
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire78e9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire78e9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iX2I3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a094e46648e7c203d266148a7c03a503>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dcbfd6bc857f18f7$var$_react = $dcbfd6bc857f18f7$var$_interopRequireDefault((parcelRequire("4tluv")));

var $dcbfd6bc857f18f7$var$_baseNew = $dcbfd6bc857f18f7$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $dcbfd6bc857f18f7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Skill".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for skill functionality. Skills are a combination of tools and a prompt to allow an agent to perform a multistep process.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dcbfd6bc857f18f7$var$SkillIcon = (props)=>/*#__PURE__*/ $dcbfd6bc857f18f7$var$_react.default.createElement($dcbfd6bc857f18f7$var$_baseNew.default, Object.assign({
        name: "SkillIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM15 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/><path fill="currentcolor" d="m11.11 4.934-5 7-1.22-.871 5-7z"/>`
    }, props));
$dcbfd6bc857f18f7$var$SkillIcon.displayName = 'SkillIcon';
var $dcbfd6bc857f18f7$var$_default = module.exports.default = $dcbfd6bc857f18f7$var$SkillIcon;

});

parcelRegister("k3H2b", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1d41a49be2d57b5fca92e1196d1fac8e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e9a5782a34f4cdd1$var$_react = $e9a5782a34f4cdd1$var$_interopRequireDefault((parcelRequire("4tluv")));

var $e9a5782a34f4cdd1$var$_baseNew = $e9a5782a34f4cdd1$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $e9a5782a34f4cdd1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBarLine".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Known uses: Bar charts with trend lines
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e9a5782a34f4cdd1$var$ChartBarLineIcon = (props)=>/*#__PURE__*/ $e9a5782a34f4cdd1$var$_react.default.createElement($e9a5782a34f4cdd1$var$_baseNew.default, Object.assign({
        name: "ChartBarLineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M14 2v1.5h-2.97L7.24 6.81a.75.75 0 0 1-.49.19H3.5V5.5h2.97l3.79-3.31.11-.08a.75.75 0 0 1 .38-.11zm-8.75 8h.08a.75.75 0 0 1 .67.75v1a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-1a.75.75 0 0 1 .75-.75zm4-2h.08a.75.75 0 0 1 .67.75v3a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-3A.75.75 0 0 1 8.25 8zm4-2a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-5a.75.75 0 0 1 .75-.75z"/>`
    }, props));
$e9a5782a34f4cdd1$var$ChartBarLineIcon.displayName = 'ChartBarLineIcon';
var $e9a5782a34f4cdd1$var$_default = module.exports.default = $e9a5782a34f4cdd1$var$ChartBarLineIcon;

});

parcelRegister("5Nq5q", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c646a99d277cd4b5b22a16e5f42dbd2f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4385c392ea704b5f$var$_react = $4385c392ea704b5f$var$_interopRequireDefault((parcelRequire("4tluv")));

var $4385c392ea704b5f$var$_baseNew = $4385c392ea704b5f$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $4385c392ea704b5f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeText".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for auto draft functionality in Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4385c392ea704b5f$var$AiGenerativeTextIcon = (props)=>/*#__PURE__*/ $4385c392ea704b5f$var$_react.default.createElement($4385c392ea704b5f$var$_baseNew.default, Object.assign({
        name: "AiGenerativeTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.617 9.011a.75.75 0 0 1 .588.483l.615 1.687 1.687.615a.75.75 0 0 1 0 1.41l-1.687.615-.615 1.686a.75.75 0 0 1-1.409 0l-.616-1.686-1.686-.616a.75.75 0 0 1 0-1.409l1.686-.615.616-1.687.048-.106A.75.75 0 0 1 12.5 9z"/><path fill="currentcolor" fill-rule="evenodd" d="M9.337.604a2 2 0 0 1 2.828 0l1.233 1.232a2 2 0 0 1 0 2.828l-8.1 8.099a2 2 0 0 1-1.022.547l-3.378.676a.75.75 0 0 1-.883-.883l.676-3.38a2 2 0 0 1 .546-1.02zm-7.04 9.159a.5.5 0 0 0-.136.256l-.456 2.275 2.278-.455a.5.5 0 0 0 .254-.137l6.078-6.078-1.94-1.94zm8.808-8.099a.5.5 0 0 0-.707 0l-.961.961 1.94 1.94.96-.961a.5.5 0 0 0 0-.707z" clip-rule="evenodd"/>`
    }, props));
$4385c392ea704b5f$var$AiGenerativeTextIcon.displayName = 'AiGenerativeTextIcon';
var $4385c392ea704b5f$var$_default = module.exports.default = $4385c392ea704b5f$var$AiGenerativeTextIcon;

});

parcelRegister("g0acl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e592cd07ebb64c538a407bba7f07723>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ba648e8d161250b6$var$_react = $ba648e8d161250b6$var$_interopRequireDefault((parcelRequire("4tluv")));

var $ba648e8d161250b6$var$_baseNew = $ba648e8d161250b6$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $ba648e8d161250b6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Plan".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing plans.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ba648e8d161250b6$var$PlanIcon = (props)=>/*#__PURE__*/ $ba648e8d161250b6$var$_react.default.createElement($ba648e8d161250b6$var$_baseNew.default, Object.assign({
        name: "PlanIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 12.75a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m1.5 0a2.75 2.75 0 0 1-5.394.75H5.625a3.125 3.125 0 1 1 0-6.25h4.75a1.625 1.625 0 1 0 0-3.25H5.394A2.749 2.749 0 0 1 0 3.25a2.75 2.75 0 0 1 5.394-.75h4.981a3.125 3.125 0 1 1 0 6.25h-4.75a1.625 1.625 0 0 0 0 3.25h4.981a2.749 2.749 0 0 1 5.394.75M1.5 3.25a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0"/>`
    }, props));
$ba648e8d161250b6$var$PlanIcon.displayName = 'PlanIcon';
var $ba648e8d161250b6$var$_default = module.exports.default = $ba648e8d161250b6$var$PlanIcon;

});

parcelRegister("lbika", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::04de3589381f9a0610e28dee990a4306>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f6b8d6e1cb625aba$var$_react = $f6b8d6e1cb625aba$var$_interopRequireDefault((parcelRequire("4tluv")));

var $f6b8d6e1cb625aba$var$_baseNew = $f6b8d6e1cb625aba$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $f6b8d6e1cb625aba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PlaylistAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Adding items to your playlist (feature).
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f6b8d6e1cb625aba$var$PlaylistAddIcon = (props)=>/*#__PURE__*/ $f6b8d6e1cb625aba$var$_react.default.createElement($f6b8d6e1cb625aba$var$_baseNew.default, Object.assign({
        name: "PlaylistAddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10.75 7v2.25H13v1.5h-2.25V13h-1.5v-2.25H7v-1.5h2.25V7z"/><path fill="currentcolor" d="M3.999 6.624A2.626 2.626 0 0 1 6.624 4h4.053l-.341-1.6a1.124 1.124 0 0 0-1.334-.866L2.399 2.937a1.124 1.124 0 0 0-.866 1.334l1.403 6.602c.11.517.558.873 1.063.889zm1.5 6.75c0 .621.504 1.125 1.125 1.125h6.75c.621 0 1.125-.503 1.125-1.125v-6.75c0-.62-.504-1.125-1.125-1.125h-6.75c-.621 0-1.125.504-1.125 1.125zm10.5 0A2.625 2.625 0 0 1 13.374 16h-6.75a2.625 2.625 0 0 1-2.625-2.625v-.112a2.624 2.624 0 0 1-2.53-2.077L.064 4.582A2.626 2.626 0 0 1 2.088 1.47L8.689.066a2.626 2.626 0 0 1 3.114 2.022L12.21 4h1.164a2.625 2.625 0 0 1 2.625 2.625z"/>`
    }, props));
$f6b8d6e1cb625aba$var$PlaylistAddIcon.displayName = 'PlaylistAddIcon';
var $f6b8d6e1cb625aba$var$_default = module.exports.default = $f6b8d6e1cb625aba$var$PlaylistAddIcon;

});

parcelRegister("hIWXs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9b025e88f545a176f0bf73d94d1b7152>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ce744793713c9b3b$var$_react = $ce744793713c9b3b$var$_interopRequireDefault((parcelRequire("4tluv")));

var $ce744793713c9b3b$var$_baseNew = $ce744793713c9b3b$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $ce744793713c9b3b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PlaylistRemove".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Represents the action for removing things from the playlist feature.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ce744793713c9b3b$var$PlaylistRemoveIcon = (props)=>/*#__PURE__*/ $ce744793713c9b3b$var$_react.default.createElement($ce744793713c9b3b$var$_baseNew.default, Object.assign({
        name: "PlaylistRemoveIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m12.78 8.28-1.72 1.719 1.72 1.72-1.06 1.06L10 11.06l-1.72 1.72-1.06-1.06L8.94 10 7.22 8.28l1.06-1.06L10 8.939l1.72-1.72z"/><path fill="currentcolor" d="M3.999 6.624A2.626 2.626 0 0 1 6.624 4h4.053l-.341-1.6a1.124 1.124 0 0 0-1.334-.866L2.399 2.937a1.124 1.124 0 0 0-.866 1.334l1.403 6.602c.11.517.558.873 1.063.889zm1.5 6.75c0 .621.504 1.125 1.125 1.125h6.75c.621 0 1.125-.503 1.125-1.125v-6.75c0-.62-.504-1.125-1.125-1.125h-6.75c-.621 0-1.125.504-1.125 1.125zm10.5 0A2.625 2.625 0 0 1 13.374 16h-6.75a2.625 2.625 0 0 1-2.625-2.625v-.112a2.624 2.624 0 0 1-2.53-2.077L.064 4.582A2.626 2.626 0 0 1 2.088 1.47L8.689.066a2.626 2.626 0 0 1 3.114 2.022L12.21 4h1.164a2.625 2.625 0 0 1 2.625 2.625z"/>`
    }, props));
$ce744793713c9b3b$var$PlaylistRemoveIcon.displayName = 'PlaylistRemoveIcon';
var $ce744793713c9b3b$var$_default = module.exports.default = $ce744793713c9b3b$var$PlaylistRemoveIcon;

});

parcelRegister("kFa5z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8eced7d4004a78c9a645ef3d6727f49b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0af766b6d6b4199$var$_react = $f0af766b6d6b4199$var$_interopRequireDefault((parcelRequire("4tluv")));

var $f0af766b6d6b4199$var$_baseNew = $f0af766b6d6b4199$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $f0af766b6d6b4199$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeChapters".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for auto chapters functionality in Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f0af766b6d6b4199$var$AiGenerativeChaptersIcon = (props)=>/*#__PURE__*/ $f0af766b6d6b4199$var$_react.default.createElement($f0af766b6d6b4199$var$_baseNew.default, Object.assign({
        name: "AiGenerativeChaptersIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 2.5v10h5.75V14H1.375C.615 14 0 13.384 0 12.625V2.375C0 1.617.613 1 1.374 1h3.5A3.87 3.87 0 0 1 8 2.583 3.87 3.87 0 0 1 11.125 1h3.5C15.387 1 16 1.62 16 2.376V8.25h-1.5V2.5h-3.375A2.375 2.375 0 0 0 8.75 4.875V10h-1.5V4.875A2.375 2.375 0 0 0 4.875 2.5zM13.25 6H10.5V4.5h2.75zM2.75 4.5H5.5V6H2.75zm0 2.5H5.5v1.5H2.75zm9.045 2.494a.75.75 0 0 1 1.41 0l.614 1.687 1.687.615a.75.75 0 0 1 0 1.41l-1.687.615-.615 1.686a.75.75 0 0 1-1.41 0l-.615-1.686-1.686-.615a.75.75 0 0 1 0-1.41l1.686-.615z" clip-rule="evenodd"/>`
    }, props));
$f0af766b6d6b4199$var$AiGenerativeChaptersIcon.displayName = 'AiGenerativeChaptersIcon';
var $f0af766b6d6b4199$var$_default = module.exports.default = $f0af766b6d6b4199$var$AiGenerativeChaptersIcon;

});

parcelRegister("5IF1e", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c29a261babb6c86cb0a5a9191efb8ed1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42a0e147e14adbdb$var$_react = $42a0e147e14adbdb$var$_interopRequireDefault((parcelRequire("4tluv")));

var $42a0e147e14adbdb$var$_baseNew = $42a0e147e14adbdb$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $42a0e147e14adbdb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Talent".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for functional representation of Talent app
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $42a0e147e14adbdb$var$TalentIcon = (props)=>/*#__PURE__*/ $42a0e147e14adbdb$var$_react.default.createElement($42a0e147e14adbdb$var$_baseNew.default, Object.assign({
        name: "TalentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M1 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m2.75 6.5a2.25 2.25 0 0 0-2.25 2.25V15H0v-2.25A3.75 3.75 0 0 1 3.75 9h2.5A3.75 3.75 0 0 1 10 12.75V15H8.5v-2.25a2.25 2.25 0 0 0-2.25-2.25z" clip-rule="evenodd"/><path fill="currentcolor" d="m13 9.444-1.526 1.047a.332.332 0 0 1-.51-.36l.48-1.788-1.315-1.097a.332.332 0 0 1 .187-.587l1.712-.131.662-1.721a.332.332 0 0 1 .62 0l.662 1.72 1.712.132a.332.332 0 0 1 .187.587l-1.315 1.097.48 1.787a.332.332 0 0 1-.51.36z"/>`
    }, props));
$42a0e147e14adbdb$var$TalentIcon.displayName = 'TalentIcon';
var $42a0e147e14adbdb$var$_default = module.exports.default = $42a0e147e14adbdb$var$TalentIcon;

});

parcelRegister("ak5on", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6a676c9b1754465cd1a0d1634f9f2e6b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $783ff468d341c147$var$_react = $783ff468d341c147$var$_interopRequireDefault((parcelRequire("4tluv")));

var $783ff468d341c147$var$_baseNew = $783ff468d341c147$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $783ff468d341c147$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Ticket".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $783ff468d341c147$var$TicketIcon = (props)=>/*#__PURE__*/ $783ff468d341c147$var$_react.default.createElement($783ff468d341c147$var$_baseNew.default, Object.assign({
        name: "TicketIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.75A.75.75 0 0 1 .75 2h14.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75H15a1 1 0 1 0 0 2h.25a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75H.75a.75.75 0 0 1-.75-.75v-3.5A.75.75 0 0 1 .75 9H1a1 1 0 0 0 0-2H.75A.75.75 0 0 1 0 6.25zm1.5.75v2.05a2.5 2.5 0 0 1 0 4.9v2.05h13v-2.05a2.5 2.5 0 0 1 0-4.9V3.5zM9 6V4.5h1.5V6zm1.5 2.75H9v-1.5h1.5zM9 11.5V10h1.5v1.5z" clip-rule="evenodd"/>`
    }, props));
$783ff468d341c147$var$TicketIcon.displayName = 'TicketIcon';
var $783ff468d341c147$var$_default = module.exports.default = $783ff468d341c147$var$TicketIcon;

});

parcelRegister("j4Hue", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::14d3508a57d0950b33e5e611a6d67b81>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $de301f8d6ea1ad34$var$_react = $de301f8d6ea1ad34$var$_interopRequireDefault((parcelRequire("4tluv")));

var $de301f8d6ea1ad34$var$_baseNew = $de301f8d6ea1ad34$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $de301f8d6ea1ad34$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextLengthen".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Lengthening text content with Atlassian Intelligence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $de301f8d6ea1ad34$var$TextLengthenIcon = (props)=>/*#__PURE__*/ $de301f8d6ea1ad34$var$_react.default.createElement($de301f8d6ea1ad34$var$_baseNew.default, Object.assign({
        name: "TextLengthenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm0 4.167H1v-1.5h14zm0 4.166H1v-1.5h14zM8 15H1v-1.5h7z" clip-rule="evenodd"/>`
    }, props));
$de301f8d6ea1ad34$var$TextLengthenIcon.displayName = 'TextLengthenIcon';
var $de301f8d6ea1ad34$var$_default = module.exports.default = $de301f8d6ea1ad34$var$TextLengthenIcon;

});

parcelRegister("5Gpv9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e145ebbd6eaf2e0b8e4930467ce4a33d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4234a8114a66a070$var$_react = $4234a8114a66a070$var$_interopRequireDefault((parcelRequire("4tluv")));

var $4234a8114a66a070$var$_baseNew = $4234a8114a66a070$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $4234a8114a66a070$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeCleanup".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for automated cleanup and tidy functionality
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4234a8114a66a070$var$AiGenerativeCleanupIcon = (props)=>/*#__PURE__*/ $4234a8114a66a070$var$_react.default.createElement($4234a8114a66a070$var$_baseNew.default, Object.assign({
        name: "AiGenerativeCleanupIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.23.44 12.22 8h1.58a2 2 0 0 1 1.91 2.59l-1.23 4a2 2 0 0 1-1.9 1.41H4.75a.75.75 0 0 1-.28-1.45h-.01l.02-.01q.03-.01.1-.06c.09-.06.23-.16.39-.32.31-.32.71-.88.93-1.84l.03-.09L7 9.3A2 2 0 0 1 8.87 8h1.8L12.78.06zM8.87 9.5a.5.5 0 0 0-.47.33l-1.06 2.89a5.7 5.7 0 0 1-.73 1.78h5.97a.5.5 0 0 0 .48-.35l1.23-4a.5.5 0 0 0-.48-.65zM4.62 1.01a.75.75 0 0 1 .54.38l.05.11.54 1.47.05.1a.5.5 0 0 0 .25.2l1.47.54.11.05a.75.75 0 0 1 0 1.31l-.11.05-1.47.54a.5.5 0 0 0-.3.3l-.54 1.47a.75.75 0 0 1-1.36.11l-.05-.1-.54-1.47a.5.5 0 0 0-.2-.25l-.1-.05-1.47-.53a.75.75 0 0 1-.48-.59L1 4.5l.01-.12a.75.75 0 0 1 .48-.59l1.47-.54.1-.05a.5.5 0 0 0 .2-.25l.54-1.47.05-.11A.75.75 0 0 1 4.5 1z"/>`
    }, props));
$4234a8114a66a070$var$AiGenerativeCleanupIcon.displayName = 'AiGenerativeCleanupIcon';
var $4234a8114a66a070$var$_default = module.exports.default = $4234a8114a66a070$var$AiGenerativeCleanupIcon;

});

parcelRegister("fwSNs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::698e254198d7222b92b3a04f2e78869b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4e459a320792f20$var$_react = $b4e459a320792f20$var$_interopRequireDefault((parcelRequire("4tluv")));

var $b4e459a320792f20$var$_baseNew = $b4e459a320792f20$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $b4e459a320792f20$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Survey".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for surveys.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b4e459a320792f20$var$SurveyIcon = (props)=>/*#__PURE__*/ $b4e459a320792f20$var$_react.default.createElement($b4e459a320792f20$var$_baseNew.default, Object.assign({
        name: "SurveyIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13 3.5a.5.5 0 0 0-.5-.5h-1v1.25a.75.75 0 0 1-.75.75h-5.5a.75.75 0 0 1-.75-.75V3h-1a.5.5 0 0 0-.5.5V14a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5zm-7 7V12H4.5v-1.5zm5.5 0V12h-4v-1.5zM6 7.5V9H4.5V7.5zm5.5 0V9h-4V7.5zm-5-6A.5.5 0 0 0 6 2v1.5h4V2a.5.5 0 0 0-.5-.5zm8 12.5a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2V3.5a2 2 0 0 1 2-2h1.065A2 2 0 0 1 6.5 0h3a2 2 0 0 1 1.935 1.5H12.5a2 2 0 0 1 2 2z"/>`
    }, props));
$b4e459a320792f20$var$SurveyIcon.displayName = 'SurveyIcon';
var $b4e459a320792f20$var$_default = module.exports.default = $b4e459a320792f20$var$SurveyIcon;

});

parcelRegister("d1yJr", function(module, exports) {
$parcel$export(module.exports, "ConfluenceIcon", () => $45794f2017c16ea4$export$68f3db7f6af48bcb);

var $3RnOG = parcelRequire("3RnOG");

var $bALiC = parcelRequire("bALiC");

var $1tUcG = parcelRequire("1tUcG");
const $45794f2017c16ea4$export$68f3db7f6af48bcb = (0, $bALiC.createFeatureFlaggedComponent)((0, $1tUcG.ConfluenceIcon), (0, $3RnOG.ConfluenceIcon));

});
parcelRegister("3RnOG", function(module, exports) {
$parcel$export(module.exports, "ConfluenceIcon", () => $77fcf0abfe5b77c5$export$68f3db7f6af48bcb);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2264fa822c5f74cedf4229a8911c73b4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $77fcf0abfe5b77c5$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M17.888 14.461c-4.039-1.953-5.219-2.245-6.92-2.245-1.997 0-3.699.831-5.219 3.165l-.25.382c-.204.314-.249.426-.249.561s.068.247.318.404l2.564 1.594c.136.09.25.135.363.135.136 0 .226-.068.363-.27l.408-.628c.635-.966 1.203-1.28 1.928-1.28.636 0 1.385.18 2.315.629l2.677 1.257c.272.134.567.067.704-.247l1.27-2.783c.136-.315.046-.517-.272-.674M6.112 9.545c4.039 1.953 5.219 2.245 6.92 2.245 1.997 0 3.699-.83 5.219-3.165l.25-.381c.204-.315.249-.427.249-.562 0-.134-.068-.247-.318-.404L15.87 5.685c-.137-.09-.25-.135-.364-.135-.136 0-.226.067-.363.27l-.408.628c-.635.965-1.203 1.28-1.928 1.28-.636 0-1.385-.18-2.315-.63L7.814 5.843c-.272-.135-.567-.068-.703.247L5.84 8.872c-.136.314-.045.516.272.673"/>
</svg>
`;
const $77fcf0abfe5b77c5$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-7.032 12.217c-1.997 0-3.699.83-5.219 3.165l-.249.38c-.204.315-.25.427-.25.562s.068.247.317.404l2.565 1.594c.136.09.249.135.362.135.136 0 .227-.068.363-.27l.409-.628c.635-.966 1.202-1.28 1.928-1.28.636 0 1.384.18 2.315.63l2.677 1.256c.273.134.568.067.704-.247l1.27-2.783c.136-.315.045-.517-.272-.674-4.039-1.953-5.219-2.244-6.92-2.244m4.538-6.667c-.136 0-.227.067-.363.27l-.409.628c-.635.965-1.202 1.28-1.928 1.28-.636 0-1.384-.18-2.315-.63L7.813 5.843c-.272-.135-.567-.067-.703.247L5.84 8.872c-.136.314-.045.517.272.674 4.039 1.953 5.219 2.244 6.92 2.244 1.997 0 3.699-.83 5.219-3.165l.249-.382c.204-.314.25-.426.25-.56s-.068-.248-.317-.405l-2.565-1.593c-.136-.09-.249-.135-.362-.135"/>
</svg>
`;
function $77fcf0abfe5b77c5$export$68f3db7f6af48bcb({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label = 'Confluence', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $77fcf0abfe5b77c5$var$svg,
        customThemeSvg: $77fcf0abfe5b77c5$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});
parcelRegister("7etaO", function(module, exports) {
$parcel$export(module.exports, "IconWrapper", () => $6a39958204a35e30$export$be58b4326e23250f);
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");

var $3X3Vo = parcelRequire("3X3Vo");

var $1r8Gx = parcelRequire("1r8Gx");
const $6a39958204a35e30$var$styles = {
    root: "_1e0c1o8l",
    TEMP_assets: "_9aea1fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $6a39958204a35e30$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $6a39958204a35e30$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $6a39958204a35e30$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $6a39958204a35e30$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
const $6a39958204a35e30$var$rovoDarkAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
const $6a39958204a35e30$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ const $6a39958204a35e30$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl",
    '12': "_4t3i1crf",
    '16': "_4t3i7vkz",
    '20': "_4t3igktf",
    '24': "_4t3i1tcg",
    '32': "_4t3izwfg"
};
function $6a39958204a35e30$export$be58b4326e23250f({ size: size = '20', label: label, svg: svg, customThemeSvg: customThemeSvg, testId: userDefinedTestId, appearance: appearance = 'brand', iconColor: customIconColor, isAssets: isAssets = false, type: type = 'tile' }) {
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && customIconColor;
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor || 'initial'
        },
        // If the label is provided an empty string, we want to remove the element from the accessibility tree.
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        // We are using dangerouslySetInnerHTML here to tell React not to track changes to the SVG elements.
        // This is because the SVG elements are static and will not change, so we get a little performance benefit by
        // bypassing React.
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $jAkMr.default)([
            $6a39958204a35e30$var$styles.root,
            $6a39958204a35e30$var$sizeMap[size],
            colorMode === 'dark' ? $6a39958204a35e30$var$dataCenterDarkAppearanceMap[appearance] : $6a39958204a35e30$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $6a39958204a35e30$var$rovoDarkAppearanceMap[appearance] : $6a39958204a35e30$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $6a39958204a35e30$var$cloudDarkAppearanceMap[appearance] : $6a39958204a35e30$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && (0, $3X3Vo.fg)('assets-platform-branding') && $6a39958204a35e30$var$styles.TEMP_assets
        ])
    });
}

});


parcelRegister("bALiC", function(module, exports) {
$parcel$export(module.exports, "createFeatureFlaggedComponent", () => $fecc373d7474f7a7$export$e30d2ddc605f6bb);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $3X3Vo = parcelRequire("3X3Vo");
const $fecc373d7474f7a7$export$e30d2ddc605f6bb = (LegacyComponent, NewComponent)=>{
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return ({ size: size, shouldUseNewLogoDesign: shouldUseNewLogoDesign, ...props })=>{
        if ((0, $3X3Vo.fg)('platform-logo-rebrand') || shouldUseNewLogoDesign) // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, $2iln5.jsx)(NewComponent, {
            size: size || 'medium',
            ...props
        });
        return /*#__PURE__*/ (0, $2iln5.jsx)(LegacyComponent, {
            size: size,
            ...props
        });
    };
};

});

parcelRegister("1tUcG", function(module, exports) {
$parcel$export(module.exports, "ConfluenceIcon", () => $0f4daa121ffcf4bb$export$68f3db7f6af48bcb);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $cA99x = parcelRequire("cA99x");
const $0f4daa121ffcf4bb$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cA99x.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098"/>
    </svg>`;
};
const $0f4daa121ffcf4bb$export$68f3db7f6af48bcb = ({ appearance: appearance, label: label = 'Confluence', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        label: label,
        svg: $0f4daa121ffcf4bb$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});
parcelRegister("81ATr", function(module, exports) {
$parcel$export(module.exports, "defaultLogoParams", () => $28e413337da5a417$export$438460117ae6b7ee);
$parcel$export(module.exports, "legacyDefaultLogoParams", () => $28e413337da5a417$export$793fba32aed8942a);
const $28e413337da5a417$export$438460117ae6b7ee = {
    iconColor: 'inherit',
    label: '',
    size: 'medium',
    textColor: 'currentColor'
};
const $28e413337da5a417$export$793fba32aed8942a = {
    iconGradientStart: 'inherit',
    iconGradientStop: 'inherit'
};

});

parcelRegister("3h3Ly", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7cc289363201b9c$export$2e2bcd8739ae039);
/* wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");
const $e7cc289363201b9c$var$CSS_VAR_COLOR = '--logo-color';
const $e7cc289363201b9c$var$CSS_VAR_FILL = '--logo-fill';
const $e7cc289363201b9c$var$styles = {
    root: "_1e0c1o8l _kqswh2mm _syaz1vry _lswu1xf6 _vwz4kb7n _uiztglyw _o5724jg8 _zbji1osq _3se11kw7",
    stop: "_vc881r31",
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ const $e7cc289363201b9c$var$Wrapper = ({ label: label, svg: svg, size: size, appearance: appearance, iconColor: iconColor, textColor: textColor, testId: userDefinedTestId, ...rest })=>{
    // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
    const shouldApplyStopColor = appearance === undefined;
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    return /*#__PURE__*/ (0, $2iln5.jsx)("span", {
        "data-testid": testId,
        style: {
            [$e7cc289363201b9c$var$CSS_VAR_COLOR]: iconColor,
            [$e7cc289363201b9c$var$CSS_VAR_FILL]: textColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        },
        ...rest,
        className: (0, $jAkMr.default)([
            $e7cc289363201b9c$var$styles.root,
            shouldApplyStopColor && $e7cc289363201b9c$var$styles.stop,
            size && $e7cc289363201b9c$var$styles[size]
        ])
    });
};
var $e7cc289363201b9c$export$2e2bcd8739ae039 = $e7cc289363201b9c$var$Wrapper;

});

parcelRegister("cA99x", function(module, exports) {
$parcel$export(module.exports, "getColorsFromAppearance", () => $7b542736b390331f$export$bbacc3980e0f3029);
const $7b542736b390331f$export$bbacc3980e0f3029 = (appearance, colorMode)=>{
    let iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#357DE8';
            textColor = '#E2E3E4';
            atlassianLogoTextColor = '#357DE8';
            break;
        case 'neutral':
            iconColor = '#96999E';
            textColor = '#BFC1C4';
            atlassianLogoTextColor = '#96999E';
            break;
        case 'inverse':
            iconColor = '#101214';
            textColor = '#101214';
            atlassianLogoTextColor = '#101214';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#1868DB';
            textColor = '#101214';
            atlassianLogoTextColor = '#1868DB';
            break;
        case 'neutral':
            iconColor = '#6C6F77';
            textColor = '#3B3D42';
            atlassianLogoTextColor = '#6C6F77';
            break;
        case 'inverse':
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};

});



parcelRegister("1SnwH", function(module, exports) {
$parcel$export(module.exports, "JiraIcon", () => (parcelRequire("7qmv7")).JiraIcon);
/**
 * __Jira icon__
 *
 * The Jira icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */ 
var $7qmv7 = parcelRequire("7qmv7");

});
parcelRegister("7qmv7", function(module, exports) {
$parcel$export(module.exports, "AdminIcon", () => $328eceb3e5970462$export$ef8e5f836dd989d3);
$parcel$export(module.exports, "AssetsIcon", () => $328eceb3e5970462$export$d89497e7f33ca6f5);
$parcel$export(module.exports, "ChatIcon", () => $328eceb3e5970462$export$52cd484a7ef4f2b9);
$parcel$export(module.exports, "CustomerServiceManagementIcon", () => $328eceb3e5970462$export$6da5aa77c402ba0f);
$parcel$export(module.exports, "FeedbackIcon", () => $328eceb3e5970462$export$34420f0520b19b1d);
$parcel$export(module.exports, "GoalsIcon", () => $328eceb3e5970462$export$9eb74917ea768ed4);
$parcel$export(module.exports, "HomeIcon", () => $328eceb3e5970462$export$92c8767b874048d);
$parcel$export(module.exports, "HubIcon", () => $328eceb3e5970462$export$80b8b269d8b5014e);
$parcel$export(module.exports, "ProjectsIcon", () => $328eceb3e5970462$export$5ed3e1bb3b04fc02);
$parcel$export(module.exports, "RovoDevIcon", () => $328eceb3e5970462$export$8b784b3227531b3e);
$parcel$export(module.exports, "SearchIcon", () => $328eceb3e5970462$export$82eafebb825fc23f);
$parcel$export(module.exports, "StudioIcon", () => $328eceb3e5970462$export$290a0f24614cde9f);
$parcel$export(module.exports, "TalentIcon", () => $328eceb3e5970462$export$4b05688514531169);
$parcel$export(module.exports, "TeamsIcon", () => $328eceb3e5970462$export$1bcbc9c337da86da);
$parcel$export(module.exports, "BambooIcon", () => $328eceb3e5970462$export$e812398311cab9a3);
$parcel$export(module.exports, "ConfluenceDataCenterIcon", () => $328eceb3e5970462$export$53305f1f2855d3be);
$parcel$export(module.exports, "JiraDataCenterIcon", () => $328eceb3e5970462$export$f8455b5667a3ee0c);
$parcel$export(module.exports, "AtlassianAnalyticsIcon", () => $328eceb3e5970462$export$c42ad8a0b925c762);
$parcel$export(module.exports, "BitbucketIcon", () => $328eceb3e5970462$export$5fc1066e677788d4);
$parcel$export(module.exports, "CompassIcon", () => $328eceb3e5970462$export$f7857fe64d7161d9);
$parcel$export(module.exports, "DxIcon", () => $328eceb3e5970462$export$9951d02c2d848122);
$parcel$export(module.exports, "ConfluenceIcon", () => $328eceb3e5970462$export$68f3db7f6af48bcb);
$parcel$export(module.exports, "ConfluenceLogo", () => $328eceb3e5970462$export$1b2e4fe6ef471556);
$parcel$export(module.exports, "AlignIcon", () => $328eceb3e5970462$export$70a0c2f5862937b6);
$parcel$export(module.exports, "JiraIcon", () => $328eceb3e5970462$export$c4b5b1f965d8b3eb);
$parcel$export(module.exports, "JiraProductDiscoveryIcon", () => $328eceb3e5970462$export$21bfbeb62fdcce8d);
$parcel$export(module.exports, "JiraServiceManagementIcon", () => $328eceb3e5970462$export$3c6158790f5e01c4);
$parcel$export(module.exports, "LoomIcon", () => $328eceb3e5970462$export$8d789f76fde3e05);
$parcel$export(module.exports, "OpsgenieIcon", () => $328eceb3e5970462$export$eeccc49dc7a12d9f);
$parcel$export(module.exports, "StatuspageIcon", () => $328eceb3e5970462$export$f3f5aa321d88adf9);
$parcel$export(module.exports, "TrelloIcon", () => $328eceb3e5970462$export$4384da9b8b140bf4);
$parcel$export(module.exports, "RovoIcon", () => $328eceb3e5970462$export$e23ae35269442b4f);
$parcel$export(module.exports, "RovoLogo", () => $328eceb3e5970462$export$a0f6cb8061290bbb);
$parcel$export(module.exports, "GuardIcon", () => $328eceb3e5970462$export$3f95fcfdc25a741d);
$parcel$export(module.exports, "FocusIcon", () => $328eceb3e5970462$export$1e02e7298035a77c);

var $6pIMI = parcelRequire("6pIMI");
var $fyHx2 = parcelRequire("fyHx2");

var $4ljOr = parcelRequire("4ljOr");
var $jUBgE = parcelRequire("jUBgE");

var $2AhdC = parcelRequire("2AhdC");
var $bTdj1 = parcelRequire("bTdj1");

var $7XOGA = parcelRequire("7XOGA");
var $9Fyp2 = parcelRequire("9Fyp2");

var $9nbck = parcelRequire("9nbck");
var $1hbQA = parcelRequire("1hbQA");

var $eGrZe = parcelRequire("eGrZe");
var $hjXCX = parcelRequire("hjXCX");

var $3lCDn = parcelRequire("3lCDn");
var $iPNb1 = parcelRequire("iPNb1");

var $3ymd9 = parcelRequire("3ymd9");
var $dEnZb = parcelRequire("dEnZb");

var $eq0XG = parcelRequire("eq0XG");
var $1AqPF = parcelRequire("1AqPF");

var $3RnOG = parcelRequire("3RnOG");
var $kh7MG = parcelRequire("kh7MG");

var $9bu2l = parcelRequire("9bu2l");
var $bBmMe = parcelRequire("bBmMe");

var $k5RCX = parcelRequire("k5RCX");
var $gO8WE = parcelRequire("gO8WE");

var $hpKZ3 = parcelRequire("hpKZ3");
var $4dd2p = parcelRequire("4dd2p");

var $6v3UH = parcelRequire("6v3UH");

var $ii4hA = parcelRequire("ii4hA");
var $n96Xi = parcelRequire("n96Xi");

var $lbsfH = parcelRequire("lbsfH");
var $lh0tZ = parcelRequire("lh0tZ");

var $gUhJt = parcelRequire("gUhJt");
var $cUsQ7 = parcelRequire("cUsQ7");

var $jkzAl = parcelRequire("jkzAl");
var $lgqiJ = parcelRequire("lgqiJ");

var $g3rmL = parcelRequire("g3rmL");
var $2IgJJ = parcelRequire("2IgJJ");

var $7r44z = parcelRequire("7r44z");
var $jkuXc = parcelRequire("jkuXc");

var $kWdjh = parcelRequire("kWdjh");
var $8j3PH = parcelRequire("8j3PH");

var $72gNH = parcelRequire("72gNH");
var $3cL5S = parcelRequire("3cL5S");

var $6x7k1 = parcelRequire("6x7k1");
var $lsS3I = parcelRequire("lsS3I");

var $krMin = parcelRequire("krMin");
var $5wzQZ = parcelRequire("5wzQZ");

var $hGd87 = parcelRequire("hGd87");
var $dlVUr = parcelRequire("dlVUr");

var $8oSGj = parcelRequire("8oSGj");
var $7ktDp = parcelRequire("7ktDp");

var $cbyZq = parcelRequire("cbyZq");

var $etntV = parcelRequire("etntV");
var $9XoBS = parcelRequire("9XoBS");

var $hzlnN = parcelRequire("hzlnN");
var $jsl2G = parcelRequire("jsl2G");

var $dkima = parcelRequire("dkima");
var $7ckOW = parcelRequire("7ckOW");

var $fA5kq = parcelRequire("fA5kq");
var $jkq81 = parcelRequire("jkq81");

var $bZCfg = parcelRequire("bZCfg");
var $kEDm8 = parcelRequire("kEDm8");

var $JcJ9s = parcelRequire("JcJ9s");
var $iMzVZ = parcelRequire("iMzVZ");

var $i8M6W = parcelRequire("i8M6W");
var $1igo3 = parcelRequire("1igo3");

var $6H7fj = parcelRequire("6H7fj");
var $fSlJW = parcelRequire("fSlJW");

var $7Kt4x = parcelRequire("7Kt4x");
var $6CcMP = parcelRequire("6CcMP");

var $4BlLF = parcelRequire("4BlLF");
var $kE2yc = parcelRequire("kE2yc");

var $5l8U4 = parcelRequire("5l8U4");
var $levgb = parcelRequire("levgb");

var $2Vvt8 = parcelRequire("2Vvt8");
var $5cWhH = parcelRequire("5cWhH");

var $HZylT = parcelRequire("HZylT");
var $6Lx0d = parcelRequire("6Lx0d");

var $bALiC = parcelRequire("bALiC");

var $fF7wm = parcelRequire("fF7wm");

var $jT0uL = parcelRequire("jT0uL");
var $d5gHq = parcelRequire("d5gHq");

var $61rOV = parcelRequire("61rOV");
var $85T2t = parcelRequire("85T2t");

var $5fq1G = parcelRequire("5fq1G");
var $lF1fo = parcelRequire("lF1fo");

var $2zbIm = parcelRequire("2zbIm");
var $3YNS7 = parcelRequire("3YNS7");

var $f3vw4 = parcelRequire("f3vw4");
var $6K9JY = parcelRequire("6K9JY");

var $1tUcG = parcelRequire("1tUcG");
var $7pfuQ = parcelRequire("7pfuQ");

var $ePtT5 = parcelRequire("ePtT5");
var $4cxnt = parcelRequire("4cxnt");

var $jMadJ = parcelRequire("jMadJ");
var $2vKx9 = parcelRequire("2vKx9");

var $b1FkN = parcelRequire("b1FkN");
var $9fpp5 = parcelRequire("9fpp5");

var $1zfwo = parcelRequire("1zfwo");
var $dJnFy = parcelRequire("dJnFy");

var $jLwoL = parcelRequire("jLwoL");
var $aahZp = parcelRequire("aahZp");

var $7txS1 = parcelRequire("7txS1");
var $4tKlw = parcelRequire("4tKlw");

var $atZlG = parcelRequire("atZlG");
var $8lXyR = parcelRequire("8lXyR");

var $1i16X = parcelRequire("1i16X");
var $oEO5t = parcelRequire("oEO5t");

var $8hS2P = parcelRequire("8hS2P");
var $23eQ8 = parcelRequire("23eQ8");

var $39U7P = parcelRequire("39U7P");
var $cGyDm = parcelRequire("cGyDm");

var $9gA1b = parcelRequire("9gA1b");
var $gUu6v = parcelRequire("gUu6v");

var $kwiP0 = parcelRequire("kwiP0");
var $gzw4h = parcelRequire("gzw4h");




var $c6wp0 = parcelRequire("c6wp0");

var $bEejo = parcelRequire("bEejo");

var $bsDCG = parcelRequire("bsDCG");

var $9RMyU = parcelRequire("9RMyU");

var $l8DVX = parcelRequire("l8DVX");
const $328eceb3e5970462$export$ef8e5f836dd989d3 = (0, $l8DVX.tempSizeWrapper)((0, $6pIMI.AdminIcon));
const $328eceb3e5970462$export$ebcd30672e67406 = (0, $l8DVX.tempSizeWrapper)((0, $fyHx2.AdminLogoCS));
const $328eceb3e5970462$export$af3460f51ce3602a = (0, $l8DVX.tempSizeWrapper)((0, $2AhdC.AnalyticsIcon));
const $328eceb3e5970462$export$c8415b6abe4a8587 = (0, $l8DVX.tempSizeWrapper)((0, $bTdj1.AnalyticsLogoCS));
const $328eceb3e5970462$export$d89497e7f33ca6f5 = (0, $l8DVX.tempSizeWrapper)((0, $7XOGA.AssetsIcon));
const $328eceb3e5970462$export$48ca930f3071e3e4 = (0, $l8DVX.tempSizeWrapper)((0, $9Fyp2.AssetsLogoCS));
const $328eceb3e5970462$export$52cd484a7ef4f2b9 = (0, $l8DVX.tempSizeWrapper)((0, $3ymd9.ChatIcon));
const $328eceb3e5970462$export$9ca9881809919df8 = (0, $l8DVX.tempSizeWrapper)((0, $dEnZb.ChatLogoCS));
const $328eceb3e5970462$export$6da5aa77c402ba0f = (0, $l8DVX.tempSizeWrapper)((0, $hpKZ3.CustomerServiceManagementIcon));
const $328eceb3e5970462$export$abc95e6180bb1d88 = (0, $l8DVX.tempSizeWrapper)((0, $4dd2p.CustomerServiceManagementLogoCS));
const $328eceb3e5970462$export$34420f0520b19b1d = (0, $l8DVX.tempSizeWrapper)((0, $ii4hA.FeedbackIcon));
const $328eceb3e5970462$export$c9696eb3c34c5a96 = (0, $l8DVX.tempSizeWrapper)((0, $n96Xi.FeedbackLogoCS));
const $328eceb3e5970462$export$9eb74917ea768ed4 = (0, $l8DVX.tempSizeWrapper)((0, $gUhJt.GoalsIcon));
const $328eceb3e5970462$export$d2577aa28451395f = (0, $l8DVX.tempSizeWrapper)((0, $cUsQ7.GoalsLogoCS));
const $328eceb3e5970462$export$92c8767b874048d = (0, $l8DVX.tempSizeWrapper)((0, $g3rmL.HomeIcon));
const $328eceb3e5970462$export$d5648119d5b68e90 = (0, $l8DVX.tempSizeWrapper)((0, $2IgJJ.HomeLogoCS));
const $328eceb3e5970462$export$80b8b269d8b5014e = (0, $l8DVX.tempSizeWrapper)((0, $7r44z.HubIcon));
const $328eceb3e5970462$export$fc9bd6687b80fe3b = (0, $l8DVX.tempSizeWrapper)((0, $jkuXc.HubLogoCS));
const $328eceb3e5970462$export$5ed3e1bb3b04fc02 = (0, $l8DVX.tempSizeWrapper)((0, $dkima.ProjectsIcon));
const $328eceb3e5970462$export$aeefab651bcf2338 = (0, $l8DVX.tempSizeWrapper)((0, $7ckOW.ProjectsLogoCS));
const $328eceb3e5970462$export$8b784b3227531b3e = (0, $l8DVX.tempSizeWrapper)((0, $bZCfg.RovoDevIcon));
const $328eceb3e5970462$export$f0750468d67c6902 = (0, $l8DVX.tempSizeWrapper)((0, $kEDm8.RovoDevLogoCS));
const $328eceb3e5970462$export$813cff80931d9dbf = (0, $l8DVX.tempSizeWrapper)((0, $JcJ9s.RovoDevAgentIcon));
const $328eceb3e5970462$export$409b7a5b7f180eba = (0, $l8DVX.tempSizeWrapper)((0, $iMzVZ.RovoDevAgentLogoCS));
const $328eceb3e5970462$export$82eafebb825fc23f = (0, $l8DVX.tempSizeWrapper)((0, $6H7fj.SearchIcon));
const $328eceb3e5970462$export$e4c5487c9a8ae3b1 = (0, $l8DVX.tempSizeWrapper)((0, $fSlJW.SearchLogoCS));
const $328eceb3e5970462$export$290a0f24614cde9f = (0, $l8DVX.tempSizeWrapper)((0, $4BlLF.StudioIcon));
const $328eceb3e5970462$export$8aceb78c659789b6 = (0, $l8DVX.tempSizeWrapper)((0, $kE2yc.StudioLogoCS));
const $328eceb3e5970462$export$4b05688514531169 = (0, $l8DVX.tempSizeWrapper)((0, $5l8U4.TalentIcon));
const $328eceb3e5970462$export$4f6453e012279f89 = (0, $l8DVX.tempSizeWrapper)((0, $levgb.TalentLogoCS));
const $328eceb3e5970462$export$1bcbc9c337da86da = (0, $l8DVX.tempSizeWrapper)((0, $2Vvt8.TeamsIcon));
const $328eceb3e5970462$export$9b1a0a0c574cec2a = (0, $l8DVX.tempSizeWrapper)((0, $5cWhH.TeamsLogoCS));
const $328eceb3e5970462$export$e812398311cab9a3 = (0, $l8DVX.tempSizeWrapper)((0, $9nbck.BambooIcon));
const $328eceb3e5970462$export$765f5afcc1a5a7e3 = (0, $l8DVX.tempSizeWrapper)((0, $1hbQA.BambooLogoCS));
const $328eceb3e5970462$export$d3ab16bbf4f954ee = (0, $l8DVX.tempSizeWrapper)((0, $3lCDn.BitbucketDataCenterIcon));
const $328eceb3e5970462$export$36044946916e84a0 = (0, $l8DVX.tempSizeWrapper)((0, $iPNb1.BitbucketDataCenterLogoCS));
const $328eceb3e5970462$export$53305f1f2855d3be = (0, $l8DVX.tempSizeWrapper)((0, $9bu2l.ConfluenceDataCenterIcon));
const $328eceb3e5970462$export$5e06396bce773a3 = (0, $l8DVX.tempSizeWrapper)((0, $bBmMe.ConfluenceDataCenterLogoCS));
const $328eceb3e5970462$export$eaf73f391f7103bd = (0, $l8DVX.tempSizeWrapper)((0, $k5RCX.CrowdIcon));
const $328eceb3e5970462$export$6128b385660fd3c6 = (0, $l8DVX.tempSizeWrapper)((0, $gO8WE.CrowdLogoCS));
const $328eceb3e5970462$export$f8455b5667a3ee0c = (0, $l8DVX.tempSizeWrapper)((0, $72gNH.JiraDataCenterIcon));
const $328eceb3e5970462$export$eb152ab3801b2ae3 = (0, $l8DVX.tempSizeWrapper)((0, $3cL5S.JiraDataCenterLogoCS));
const $328eceb3e5970462$export$65fae0eaf343f2ca = (0, $l8DVX.tempSizeWrapper)((0, $hGd87.JiraServiceManagementDataCenterIcon));
const $328eceb3e5970462$export$fffc0d480fb1ebf1 = (0, $l8DVX.tempSizeWrapper)((0, $dlVUr.JiraServiceManagementDataCenterLogoCS));
const $328eceb3e5970462$export$74517ed253186308 = (0, $bALiC.createFeatureFlaggedComponent)((0, $61rOV.AtlassianAdministrationIcon), (0, $6pIMI.AdminIcon));
const $328eceb3e5970462$export$833abe6c2ce5ebfd = (0, $bALiC.createFeatureFlaggedComponent)((0, $85T2t.AtlassianAdministrationLogo), (0, $fyHx2.AdminLogoCS));
const $328eceb3e5970462$export$84109e099492cb5f = (0, $bALiC.createFeatureFlaggedComponent)((0, $jT0uL.AtlassianAdminIcon), (0, $6pIMI.AdminIcon));
const $328eceb3e5970462$export$f845d9b9254f0541 = (0, $bALiC.createFeatureFlaggedComponent)((0, $d5gHq.AtlassianAdminLogo), (0, $fyHx2.AdminLogoCS));
const $328eceb3e5970462$export$c42ad8a0b925c762 = (0, $bALiC.createFeatureFlaggedComponent)((0, $5fq1G.AtlassianAnalyticsIcon), (0, $2AhdC.AnalyticsIcon));
const $328eceb3e5970462$export$e6470bfc39010cc4 = (0, $bALiC.createFeatureFlaggedComponent)((0, $lF1fo.AtlassianAnalyticsLogo), (0, $bTdj1.AnalyticsLogoCS));
const $328eceb3e5970462$export$5fc1066e677788d4 = (0, $bALiC.createFeatureFlaggedComponent)((0, $2zbIm.BitbucketIcon), (0, $eGrZe.BitbucketIcon));
const $328eceb3e5970462$export$bd40525f5333524b = (0, $bALiC.createFeatureFlaggedComponent)((0, $3YNS7.BitbucketLogo), (0, $hjXCX.BitbucketLogoCS));
const $328eceb3e5970462$export$f7857fe64d7161d9 = (0, $bALiC.createFeatureFlaggedComponent)((0, $f3vw4.CompassIcon), (0, $eq0XG.CompassIcon));
const $328eceb3e5970462$export$eb7d748e4f9c9676 = (0, $bALiC.createFeatureFlaggedComponent)((0, $6K9JY.CompassLogo), (0, $1AqPF.CompassLogoCS));
const $328eceb3e5970462$export$9951d02c2d848122 = (0, $l8DVX.tempSizeWrapper)((0, $6v3UH.DxIcon));
const $328eceb3e5970462$export$68f3db7f6af48bcb = (0, $bALiC.createFeatureFlaggedComponent)((0, $1tUcG.ConfluenceIcon), (0, $3RnOG.ConfluenceIcon));
const $328eceb3e5970462$export$1b2e4fe6ef471556 = (0, $bALiC.createFeatureFlaggedComponent)((0, $7pfuQ.ConfluenceLogo), (0, $kh7MG.ConfluenceLogoCS));
const $328eceb3e5970462$export$70a0c2f5862937b6 = (0, $l8DVX.tempSizeWrapper)((0, $4ljOr.AlignIcon));
const $328eceb3e5970462$export$1b8596b4b0ef673b = (0, $l8DVX.tempSizeWrapper)((0, $jUBgE.AlignLogoCS));
const $328eceb3e5970462$export$407687b2dd89cc68 = (0, $bALiC.createFeatureFlaggedComponent)((0, $1zfwo.JiraAlignIcon), (0, $4ljOr.AlignIcon));
const $328eceb3e5970462$export$ee11e928d3d045fd = (0, $bALiC.createFeatureFlaggedComponent)((0, $dJnFy.JiraAlignLogo), (0, $jUBgE.AlignLogoCS));
const $328eceb3e5970462$export$c4b5b1f965d8b3eb = (0, $bALiC.createFeatureFlaggedComponent)((0, $b1FkN.JiraIcon), (0, $kWdjh.JiraIcon));
const $328eceb3e5970462$export$17d3acb0b4379d02 = (0, $bALiC.createFeatureFlaggedComponent)((0, $9fpp5.JiraLogo), (0, $8j3PH.JiraLogoCS));
const $328eceb3e5970462$export$21bfbeb62fdcce8d = (0, $bALiC.createFeatureFlaggedComponent)((0, $jLwoL.JiraProductDiscoveryIcon), (0, $6x7k1.JiraProductDiscoveryIcon));
const $328eceb3e5970462$export$c49a2b642fe9eef4 = (0, $bALiC.createFeatureFlaggedComponent)((0, $aahZp.JiraProductDiscoveryLogo), (0, $lsS3I.JiraProductDiscoveryLogoCS));
const $328eceb3e5970462$export$3c6158790f5e01c4 = (0, $fF7wm.createFeatureFlaggedServiceCollectionComponent)((0, $7txS1.JiraServiceManagementIcon), (0, $krMin.JiraServiceManagementIcon));
const $328eceb3e5970462$export$dabef2be6cd28c20 = (0, $fF7wm.createFeatureFlaggedServiceCollectionComponent)((0, $4tKlw.JiraServiceManagementLogo), (0, $5wzQZ.JiraServiceManagementLogoCS));
const $328eceb3e5970462$export$8d789f76fde3e05 = (0, $bALiC.createFeatureFlaggedComponent)((0, $atZlG.LoomIcon), (0, $8oSGj.LoomIcon));
const $328eceb3e5970462$export$94e206806e36c2ec = (0, $bALiC.createFeatureFlaggedComponent)((0, $8lXyR.LoomLogo), (0, $7ktDp.LoomLogoCS));
const $328eceb3e5970462$export$1bf47cdade1a9fcb = (0, $bALiC.createFeatureFlaggedComponent)((0, $1i16X.LoomAttributionIcon), (0, $8oSGj.LoomIcon));
const $328eceb3e5970462$export$6e87ce8d41eda665 = (0, $bALiC.createFeatureFlaggedComponent)((0, $oEO5t.LoomAttributionLogo), (0, $cbyZq.LoomAttributionLogoCS));
const $328eceb3e5970462$export$e84e925618e0e5bc = (0, $l8DVX.tempSizeWrapper)((0, $9XoBS.LoomInternalLogoCS));
const $328eceb3e5970462$export$1940ba72c868b663 = (0, $l8DVX.tempSizeWrapper)((0, $etntV.LoomInternalIcon));
const $328eceb3e5970462$export$eeccc49dc7a12d9f = (0, $fF7wm.createFeatureFlaggedServiceCollectionComponent)((0, $8hS2P.OpsgenieIcon), (0, $hzlnN.OpsgenieIcon));
const $328eceb3e5970462$export$a1c6484cdecc2c4b = (0, $fF7wm.createFeatureFlaggedServiceCollectionComponent)((0, $23eQ8.OpsgenieLogo), (0, $jsl2G.OpsgenieLogoCS));
const $328eceb3e5970462$export$f3f5aa321d88adf9 = (0, $fF7wm.createFeatureFlaggedServiceCollectionComponent)((0, $9gA1b.StatuspageIcon), (0, $7Kt4x.StatuspageIcon));
const $328eceb3e5970462$export$bb4ae5b41b43be04 = (0, $fF7wm.createFeatureFlaggedServiceCollectionComponent)((0, $gUu6v.StatuspageLogo), (0, $6CcMP.StatuspageLogoCS));
const $328eceb3e5970462$export$4384da9b8b140bf4 = (0, $bALiC.createFeatureFlaggedComponent)((0, $kwiP0.TrelloIcon), (0, $HZylT.TrelloIcon));
const $328eceb3e5970462$export$60e26212f3b61a28 = (0, $bALiC.createFeatureFlaggedComponent)((0, $gzw4h.TrelloLogo), (0, $6Lx0d.TrelloLogoCS));
const $328eceb3e5970462$export$e23ae35269442b4f = (0, $9RMyU.createFeatureFlaggedRovoComponent)((0, $39U7P.RovoIcon), (0, $fA5kq.RovoIcon), (0, $i8M6W.RovoHexIcon));
const $328eceb3e5970462$export$a0f6cb8061290bbb = (0, $9RMyU.createFeatureFlaggedRovoComponent)((0, $cGyDm.RovoLogo), (0, $jkq81.RovoLogoCS), (0, $1igo3.RovoHexLogoCS));
const $328eceb3e5970462$export$3f95fcfdc25a741d = (0, $bALiC.createFeatureFlaggedComponent)((0, $jMadJ.GuardIcon), (0, $jkzAl.GuardIcon));
const $328eceb3e5970462$export$a4a891d202775deb = (0, $bALiC.createFeatureFlaggedComponent)((0, $2vKx9.GuardLogo), (0, $lgqiJ.GuardLogoCS));
const $328eceb3e5970462$export$1e02e7298035a77c = (0, $bALiC.createFeatureFlaggedComponent)((0, $ePtT5.FocusIcon), (0, $lbsfH.FocusIcon));
const $328eceb3e5970462$export$33908560ea1b226d = (0, $bALiC.createFeatureFlaggedComponent)((0, $4cxnt.FocusLogo), (0, $lh0tZ.FocusLogoCS));

});
parcelRegister("6pIMI", function(module, exports) {
$parcel$export(module.exports, "AdminIcon", () => $e7f4b45d4054bc12$export$ef8e5f836dd989d3);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ced2179e9e0992ccb4af61b51b4f10a3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $e7f4b45d4054bc12$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M10.444 5h3.111l.98 2.61 2.75-.457 1.555 2.694L17.07 12l1.77 2.153-1.555 2.694-2.75-.457-.979 2.61h-3.11l-.98-2.61-2.75.457-1.555-2.694L6.931 12 5.16 9.847l1.555-2.694 2.75.457zM12 14.625a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25" clip-rule="evenodd"/>
</svg>
`;
function $e7f4b45d4054bc12$export$ef8e5f836dd989d3({ size: size, appearance: appearance = 'brand', label: label = 'Admin', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $e7f4b45d4054bc12$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("fyHx2", function(module, exports) {
$parcel$export(module.exports, "AdminLogoCS", () => $7ea8b3a65fc9601f$export$61afcb38c001e19);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::58c9ee3b4e44f14aa5c8a2e33c7dac51>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $7ea8b3a65fc9601f$var$svg = `<svg height="100%" viewBox="0 0 126 32">
    <path fill="var(--text-color, #1e1f21)" d="M124.84 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-20.15-10.4c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-14.07-8.52v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.85c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-22.02-4.01c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M13.826 6.4h4.255l1.338 3.569 3.76-.626 2.128 3.684-2.422 2.945 2.421 2.943L23.18 22.6l-3.76-.626-1.338 3.57h-4.255l-1.338-3.57-3.76.625L6.6 18.915l2.421-2.943L6.6 13.028l2.127-3.685 3.76.626zm2.128 13.16a3.59 3.59 0 1 0 0-7.178 3.59 3.59 0 0 0 0 7.179" clip-rule="evenodd"/>
</svg>
`;
function $7ea8b3a65fc9601f$export$61afcb38c001e19({ size: size, appearance: appearance = 'brand', label: label = 'Admin', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $7ea8b3a65fc9601f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});
parcelRegister("0ZCvD", function(module, exports) {
$parcel$export(module.exports, "LogoWrapper", () => $51989163aa22a33e$export$f827d3c5a9c3f644);
/* logo-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");

var $3X3Vo = parcelRequire("3X3Vo");

var $1r8Gx = parcelRequire("1r8Gx");
const $51989163aa22a33e$var$styles = {
    root: "_1e0c1o8l _vwz4idpf",
    TEMP_assets: "_9aea1fkg"
};
// These styles set the `color` property so that the child SVG can inherit the correct text color using "currentColor"
const $51989163aa22a33e$var$logoTextColorMap = {
    light: "_syazqlpt",
    dark: "_syazz6c6"
};
const $51989163aa22a33e$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $51989163aa22a33e$var$textLightAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1e01",
    inverse: "_1wycu67f",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $51989163aa22a33e$var$textDarkAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1gvk",
    inverse: "_1wyc5a6q",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $51989163aa22a33e$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $51989163aa22a33e$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $51989163aa22a33e$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $51989163aa22a33e$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
const $51989163aa22a33e$var$rovoDarkAppearanceMap = {
    brand: "_1703lrxy _1evoh727 _epb51yy8 _1osdxeun",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
const $51989163aa22a33e$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
function $51989163aa22a33e$export$f827d3c5a9c3f644({ appearance: appearance = 'brand', size: size = 'small', svg: svg, customThemeSvg: customThemeSvg, label: label, testId: userDefinedTestId, iconColor: customIconColor, textColor: customTextColor, isAssets: isAssets = false, type: type = 'tile' }) {
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && (customIconColor || customTextColor);
    return /*#__PURE__*/ (0, $2iln5.jsx)("span", {
        style: {
            // Nav v3 passes in "inherit" incorrectly for iconColor, so we fall back to textColor when this happens.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor === 'inherit' ? customTextColor : customIconColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-text-color': customTextColor || 'inherit'
        },
        "data-testid": testId,
        // If the label is provided an empty string, we want to remove the element from the accessibility tree.
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        // We are using dangerouslySetInnerHTML here to tell React not to track changes to the SVG elements.
        // This is because the SVG elements are static and will not change, so we get a little performance benefit by
        // bypassing React.
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $jAkMr.default)([
            $51989163aa22a33e$var$styles.root,
            // Setting the color so that the SVG can inherit the correct text color using "currentColor"
            $51989163aa22a33e$var$logoTextColorMap[colorMode ?? 'light'],
            $51989163aa22a33e$var$sizeMap[size],
            colorMode === 'dark' ? $51989163aa22a33e$var$textDarkAppearanceMap[appearance] : $51989163aa22a33e$var$textLightAppearanceMap[appearance],
            colorMode === 'dark' ? $51989163aa22a33e$var$dataCenterDarkAppearanceMap[appearance] : $51989163aa22a33e$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $51989163aa22a33e$var$rovoDarkAppearanceMap[appearance] : $51989163aa22a33e$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $51989163aa22a33e$var$cloudDarkAppearanceMap[appearance] : $51989163aa22a33e$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && (0, $3X3Vo.fg)('assets-platform-branding') && $51989163aa22a33e$var$styles.TEMP_assets
        ])
    });
}

});


parcelRegister("4ljOr", function(module, exports) {
$parcel$export(module.exports, "AlignIcon", () => $dac5f4b7d7748584$export$70a0c2f5862937b6);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9c308d558bb8f01b0a6c887a98e5347d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $dac5f4b7d7748584$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#fb9700)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M18.545 18.545a4.49 4.49 0 0 0-4.48-4.48h-4.13v-3.78h-4.48v7.434c0 .576.25.826.826.826zM5.455 5.455a4.454 4.454 0 0 0 4.455 4.48h4.155v3.78h4.48V6.28q0-.825-.826-.826z"/>
</svg>
`;
function $dac5f4b7d7748584$export$70a0c2f5862937b6({ size: size, appearance: appearance = 'brand', label: label = 'Align', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $dac5f4b7d7748584$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jUBgE", function(module, exports) {
$parcel$export(module.exports, "AlignLogoCS", () => $1191123ce0784560$export$8b5103382c06639c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4d1c9f8765265019cd33e94ea5235515>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $1191123ce0784560$var$svg = `<svg height="100%" viewBox="0 0 106 32">
    <path fill="var(--text-color, #1e1f21)" d="M105.76 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-19.6 7.75v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52M68.73 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-2.54-.03c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM49.6 21.32c-1.53 0-3.1-.18-4.82-.52l-1.69 4.54H40l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.68 7.43 45.6 18.5c1.5.25 2.76.37 3.99.37"/>
    <path fill="var(--tile-color,#fb9700)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M23.735 23.735c0-2.928-2.396-5.295-5.295-5.295h-4.88v-4.466H8.265v8.785c0 .68.296.976.976.976zM8.265 8.265c0 2.928 2.337 5.295 5.265 5.295h4.91v4.466h5.295V9.241q0-.976-.976-.976z"/>
</svg>
`;
function $1191123ce0784560$export$8b5103382c06639c({ size: size, appearance: appearance = 'brand', label: label = 'Align', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $1191123ce0784560$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2AhdC", function(module, exports) {
$parcel$export(module.exports, "AnalyticsIcon", () => $a5b2f64b312e1605$export$af3460f51ce3602a);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5edf47443601d30b199c36fbcc7b1d7c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $a5b2f64b312e1605$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M14.63 5.88v9.19h3.06v-9.2zM5.88 18.13h11.81v-1.75H5.87zm0-3.07v-4.81h3.06v4.81zm4.37-6.56v6.56h3.06V8.5z"/>
</svg>
`;
function $a5b2f64b312e1605$export$af3460f51ce3602a({ size: size, appearance: appearance = 'brand', label: label = 'Analytics', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $a5b2f64b312e1605$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("bTdj1", function(module, exports) {
$parcel$export(module.exports, "AnalyticsLogoCS", () => $ee4b31911feca38e$export$f0bac2b7ac3e3504);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::843c7beab94f5191123277c61cbca79e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $ee4b31911feca38e$var$svg = `<svg height="100%" viewBox="0 0 161 32">
    <path fill="var(--text-color, #1e1f21)" d="M160.66 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.6 1.41v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M129.13 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-7.46-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-14.12 3.77h-1.72L100.77 10h2.82l4.91 13.13L113.41 10h2.82l-5.8 14.84c-1.72 4.39-2.7 6.66-6.59 6.66-1.32 0-2.05-.12-2.82-.43V28.8c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.81m-7.8.94c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM79.5 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM74.1 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-24.66 4.97c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M19.5 7.83v12.25h4.08V7.83zM7.83 24.17h15.75v-2.33H7.83zm0-4.09v-6.42h4.08v6.42zm5.84-8.75v8.75h4.08v-8.75z"/>
</svg>
`;
function $ee4b31911feca38e$export$f0bac2b7ac3e3504({ size: size, appearance: appearance = 'brand', label: label = 'Analytics', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $ee4b31911feca38e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("7XOGA", function(module, exports) {
$parcel$export(module.exports, "AssetsIcon", () => $b2ed5e5d2ec8930e$export$d89497e7f33ca6f5);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6ef8f48b1d072b5b8a0869540d1f52a5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $b2ed5e5d2ec8930e$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" d="M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z"/>
</svg>
`;
const $b2ed5e5d2ec8930e$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM7.432 14.704a2.273 2.273 0 1 0 .001 4.547 2.273 2.273 0 0 0-.001-4.547m9.545 0a2.274 2.274 0 1 0 .001 4.548 2.274 2.274 0 0 0 0-4.548m-6.364 1.364v1.819h3.183v-1.819zM7.887 4.25a3.637 3.637 0 0 0-1.365 7.009v2.537h1.819v-2.302a3.64 3.64 0 0 0 3.153-3.153h2.302V6.522h-2.537A3.64 3.64 0 0 0 7.887 4.25m8.181 6.363v3.183h1.819v-3.183zm.91-5.454a2.273 2.273 0 1 0 0 4.547 2.273 2.273 0 0 0 0-4.547M7.887 6.522a1.364 1.364 0 1 1-.002 2.729 1.364 1.364 0 0 1 .002-2.729"/>
</svg>
`;
function $b2ed5e5d2ec8930e$export$d89497e7f33ca6f5({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label = 'Assets', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $b2ed5e5d2ec8930e$var$svg,
        customThemeSvg: $b2ed5e5d2ec8930e$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9Fyp2", function(module, exports) {
$parcel$export(module.exports, "AssetsLogoCS", () => $425e5742aa0bc8cd$export$81c47abe19675c4c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e04e8bc884193d0eee2f110efb35733>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $425e5742aa0bc8cd$var$svg = `<svg height="100%" viewBox="0 0 126 32">
    <path fill="var(--text-color, #1e1f21)" d="M125.8 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.77-.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.5c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.13-3.56c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63-.01c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-22.22.15c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37"/>
    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M11.667 15.425a4.335 4.335 0 0 0 3.758-3.758h2.742V9.5h-3.023A4.335 4.335 0 1 0 9.5 15.144v3.023h2.167zm-.542-2.675a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" d="M24.67 10.58a2.71 2.71 0 1 1-5.42 0 2.71 2.71 0 0 1 5.42 0M10.58 24.67a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m11.38 0a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m-3.79-3.79h-3.79v2.17h3.79zm2.71-6.5v3.79h2.17v-3.79z"/>
</svg>
`;
function $425e5742aa0bc8cd$export$81c47abe19675c4c({ size: size, appearance: appearance = 'brand', label: label = 'Assets', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $425e5742aa0bc8cd$var$svg,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9nbck", function(module, exports) {
$parcel$export(module.exports, "BambooIcon", () => $bbae1812d7c883c3$export$e812398311cab9a3);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::74f0ca66b8bc3995f7a9817f08a67d6f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $bbae1812d7c883c3$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>
    <path fill="var(--icon-color, #1868db)" d="M9.215 12.652a2.75 2.75 0 0 0 2.749 2.742v4.205a6.964 6.964 0 0 1-6.849-5.727l-.049-.317zm9.26 0a.44.44 0 0 1 .436.468c-.222 3.311-2.783 5.989-6.043 6.414l-.904-4.14a2.75 2.75 0 0 0 2.723-2.37.44.44 0 0 1 .44-.372zM11.963 9.91a2.75 2.75 0 0 0-2.748 2.742H5v-.065c.033-3.495 2.668-6.374 6.059-6.816zm0-5.972a.436.436 0 0 1 .72-.33l4.824 4.138a.436.436 0 0 1 0 .662l-4.823 4.139a.436.436 0 0 1-.72-.331z"/>
</svg>
`;
function $bbae1812d7c883c3$export$e812398311cab9a3({ size: size, appearance: appearance = 'brand', label: label = 'Bamboo', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $bbae1812d7c883c3$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("1hbQA", function(module, exports) {
$parcel$export(module.exports, "BambooLogoCS", () => $89c1437375bb59dc$export$7c51958462d750e);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5436ab9ea17c11b656095d6ae713006c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $89c1437375bb59dc$var$svg = `<svg height="100%" viewBox="0 0 154 32">
    <path fill="var(--text-color, #1e1f21)" d="M146 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-16.68 13.49c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-12.07 5.52c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-21.58-8.82v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.23-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z"/>
    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>
    <path fill="var(--icon-color, #1868db)" d="M12.287 16.869a3.665 3.665 0 0 0 3.665 3.656v5.607c-4.71 0-8.602-3.52-9.196-8.06zm12.347 0a.584.584 0 0 1 .581.624c-.295 4.415-3.71 7.986-8.057 8.554l-1.206-5.521a3.67 3.67 0 0 0 3.63-3.161.59.59 0 0 1 .589-.496zm-8.683-3.656a3.664 3.664 0 0 0-3.665 3.656h-5.62v-.088c.044-4.66 3.557-8.498 8.078-9.088zm0-7.964a.58.58 0 0 1 .96-.44l6.432 5.518c.27.232.27.65 0 .883l-6.431 5.517a.581.581 0 0 1-.96-.44z"/>
</svg>
`;
function $89c1437375bb59dc$export$7c51958462d750e({ size: size, appearance: appearance = 'brand', label: label = 'Bamboo', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $89c1437375bb59dc$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("eGrZe", function(module, exports) {
$parcel$export(module.exports, "BitbucketIcon", () => $2c38b170fe82d636$export$5fc1066e677788d4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83bd991a11895fc697ec86ba4d2d82c2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $2c38b170fe82d636$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="m17.898 11.353-.994 6.064c-.065.367-.324.583-.691.583H7.787c-.367 0-.627-.216-.691-.583L5.346 6.604C5.28 6.237 5.476 6 5.82 6h12.358c.346 0 .54.237.475.604l-.475 2.85c-.065.41-.303.582-.691.582h-7.432c-.109 0-.173.065-.152.194l.584 3.583c.021.086.086.151.172.151h2.68c.086 0 .15-.065.172-.151l.41-2.59c.044-.324.26-.453.563-.453H17.4c.432 0 .562.216.497.582"/>
</svg>
`;
const $2c38b170fe82d636$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.821 6c-.345 0-.54.238-.475.604l1.75 10.813c.065.367.324.583.691.583h8.426c.367 0 .627-.216.691-.583l.994-6.065c.065-.366-.065-.582-.497-.582h-2.917c-.302 0-.518.13-.561.453l-.41 2.59c-.022.086-.087.15-.173.15h-2.68c-.086 0-.151-.064-.173-.15l-.583-3.583c-.021-.129.044-.194.152-.194h7.431c.39 0 .627-.173.692-.583l.475-2.849c.065-.366-.13-.604-.475-.604z"/>
</svg>
`;
function $2c38b170fe82d636$export$5fc1066e677788d4({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label = 'Bitbucket', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $2c38b170fe82d636$var$svg,
        customThemeSvg: $2c38b170fe82d636$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("hjXCX", function(module, exports) {
$parcel$export(module.exports, "BitbucketLogoCS", () => $8819b7ec1cc08ca7$export$f7ef5e5488e4b430);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7131ffd6f745f530e9a82fe4842b6a8c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $8819b7ec1cc08ca7$var$svg = `<svg height="100%" viewBox="0 0 166 32">
    <path fill="var(--text-color, #1e1f21)" d="M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.4-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.17-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.27 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.69 5.43z"/>
    <path fill="var(--tile-color,#94c748)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.029.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.572 0 .743.285.657.771"/>
</svg>
`;
function $8819b7ec1cc08ca7$export$f7ef5e5488e4b430({ size: size, appearance: appearance = 'brand', label: label = 'Bitbucket', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $8819b7ec1cc08ca7$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("3lCDn", function(module, exports) {
$parcel$export(module.exports, "BitbucketDataCenterIcon", () => $6f633f72c2c64132$export$d3ab16bbf4f954ee);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61dd349b817df11b196de45b8945fcdf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $6f633f72c2c64132$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>
    <path fill="var(--icon-color, #1868db)" d="m17.843 11.763-.986 6.024c-.065.365-.322.58-.686.58H7.81c-.365 0-.622-.215-.686-.58L5.387 7.047c-.064-.364.129-.6.472-.6h12.262c.343 0 .536.236.472.6l-.472 2.83c-.064.407-.3.579-.686.579h-7.374c-.107 0-.172.064-.15.193l.579 3.558c.021.086.085.15.171.15h2.658c.086 0 .15-.064.172-.15l.407-2.572c.043-.322.257-.45.558-.45h2.894c.428 0 .557.214.493.578"/>
</svg>
`;
function $6f633f72c2c64132$export$d3ab16bbf4f954ee({ size: size, appearance: appearance = 'brand', label: label = 'Bitbucket Data Center', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $6f633f72c2c64132$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("iPNb1", function(module, exports) {
$parcel$export(module.exports, "BitbucketDataCenterLogoCS", () => $8cced3bab5a94262$export$cc55e2a4c4b40552);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::68c2bbf4fd6874e93c78c51b9065dc7c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $8cced3bab5a94262$var$svg = `<svg height="100%" viewBox="0 0 166 32">
    <path fill="var(--text-color, #1e1f21)" d="M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.85-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.39-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z"/>
    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>
    <path fill="var(--icon-color, #1868db)" d="m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.028.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.571 0 .743.285.657.771"/>
</svg>
`;
function $8cced3bab5a94262$export$cc55e2a4c4b40552({ size: size, appearance: appearance = 'brand', label: label = 'Bitbucket Data Center', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $8cced3bab5a94262$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("3ymd9", function(module, exports) {
$parcel$export(module.exports, "ChatIcon", () => $8d45da3cfa978de9$export$52cd484a7ef4f2b9);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c2ff2e36e1653e53734b97e7db9892da>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $8d45da3cfa978de9$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M18.563 16.688h-8.438L5.438 19.5V5.438h13.125zm-6.83-9.375-.255.647c-.362.92-.543 1.38-.878 1.727-.334.346-.787.543-1.694.938l-.388.17v.535l.388.17c.907.394 1.36.592 1.694.938.335.346.516.807.878 1.727l.255.648h.535l.255-.648c.362-.92.543-1.38.877-1.727.335-.346.788-.544 1.694-.939l.388-.169v-.535l-.388-.17c-.906-.395-1.36-.592-1.694-.938-.334-.347-.515-.807-.877-1.727l-.255-.647z" clip-rule="evenodd"/>
</svg>
`;
function $8d45da3cfa978de9$export$52cd484a7ef4f2b9({ size: size, appearance: appearance = 'brand', label: label = 'Chat', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $8d45da3cfa978de9$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("dEnZb", function(module, exports) {
$parcel$export(module.exports, "ChatLogoCS", () => $de37fee76db3c5a2$export$a529e78951cd6709);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c1cf578ed3b2b56aa2f85ac93abd2ba>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $de37fee76db3c5a2$var$svg = `<svg height="100%" viewBox="0 0 102 32">
    <path fill="var(--text-color, #1e1f21)" d="M97.51 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.94-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.1-8.98v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.95c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.22 5.43v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M24.75 22.25H13.5L7.25 26V7.25h17.5zm-9.107-12.5-.34.864c-.482 1.226-.724 1.84-1.17 2.302s-1.05.725-2.258 1.251l-.518.226v.714l.518.226c1.209.526 1.813.79 2.259 1.251.445.462.687 1.076 1.17 2.303l.34.863h.714l.34-.864c.482-1.227.724-1.84 1.17-2.302s1.049-.725 2.258-1.251l.517-.226v-.714l-.517-.226c-1.21-.526-1.813-.79-2.259-1.251-.445-.462-.687-1.075-1.17-2.302l-.34-.864z" clip-rule="evenodd"/>
</svg>
`;
function $de37fee76db3c5a2$export$a529e78951cd6709({ size: size, appearance: appearance = 'brand', label: label = 'Chat', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $de37fee76db3c5a2$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("eq0XG", function(module, exports) {
$parcel$export(module.exports, "CompassIcon", () => $1443a612f55e12f5$export$f7857fe64d7161d9);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5ce5248a23a237688e2341559569305>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $1443a612f55e12f5$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M12.75 7.877v-3.37l6.16-.007h.007a.59.59 0 0 1 .583.598v6.147h-3.366V7.877z"/>
    <path fill="var(--icon-color, #101214)" d="M12.75 14.615v-3.37h3.368v6.165a.59.59 0 0 1-.591.59H6.583A.59.59 0 0 1 6 17.402V8.467a.59.59 0 0 1 .591-.59h6.16v3.368H9.373v3.37z"/>
</svg>
`;
function $1443a612f55e12f5$export$f7857fe64d7161d9({ size: size, appearance: appearance = 'brand', label: label = 'Compass', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $1443a612f55e12f5$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("1AqPF", function(module, exports) {
$parcel$export(module.exports, "CompassLogoCS", () => $3f2ae61cd44defbc$export$a16f50a81d183ce);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bbcc7f43e0a51fb6caa253b27359fb22>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $3f2ae61cd44defbc$var$svg = `<svg height="100%" viewBox="0 0 162 32">
    <path fill="var(--text-color, #1e1f21)" d="M161.79 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63 0c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-25.9-3.49c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01v-2.7h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97M89.5 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.53c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.83c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
    <path fill="var(--tile-color,#94c748)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M16.69 15.16v4.24h-4.25v-4.24zv-4.24H8.93a.74.74 0 0 0-.74.74v11.25a.74.74 0 0 0 .74.75h11.26a.74.74 0 0 0 .75-.74v-7.76zm0-8.48v4.24h4.26v4.24h4.24V7.42a.74.74 0 0 0-.73-.75h-.01z"/>
</svg>
`;
function $3f2ae61cd44defbc$export$a16f50a81d183ce({ size: size, appearance: appearance = 'brand', label: label = 'Compass', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $3f2ae61cd44defbc$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("kh7MG", function(module, exports) {
$parcel$export(module.exports, "ConfluenceLogoCS", () => $e5613c2670df75f3$export$a88b0b0da9ef63ce);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90f8012e577da50adfff14718da1e4b3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $e5613c2670df75f3$var$svg = `<svg height="100%" viewBox="0 0 188 32">
    <path fill="var(--text-color, #1e1f21)" d="M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.51-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.24 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.442 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.083.302.388.494l3.135 1.948c.167.11.305.165.444.165.166 0 .277-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.692.22 2.83.768l3.273 1.537c.333.165.693.083.86-.302l1.553-3.403c.167-.384.056-.63-.333-.823M8.761 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.305-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.691 8.29c-.167-.11-.306-.165-.444-.165-.167 0-.278.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.693-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302l-1.554 3.403c-.166.384-.055.63.333.823"/>
</svg>
`;
function $e5613c2670df75f3$export$a88b0b0da9ef63ce({ size: size, appearance: appearance = 'brand', label: label = 'Confluence', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $e5613c2670df75f3$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9bu2l", function(module, exports) {
$parcel$export(module.exports, "ConfluenceDataCenterIcon", () => $35af9aa36f6d0a59$export$53305f1f2855d3be);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::daf8acf7c1707ab5f837689f4e92f4a5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $35af9aa36f6d0a59$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>
    <path fill="var(--icon-color, #1868db)" d="M17.37 14.265c-3.704-1.79-4.785-2.058-6.346-2.058-1.83 0-3.391.761-4.785 2.902l-.229.35c-.187.288-.229.39-.229.514s.063.227.292.37l2.35 1.462c.125.083.23.124.333.124.125 0 .208-.062.333-.247l.375-.577c.582-.885 1.102-1.173 1.768-1.173.583 0 1.27.165 2.122.577l2.455 1.152c.25.124.52.062.645-.226l1.165-2.552c.125-.289.042-.474-.25-.618M6.572 9.757c3.703 1.791 4.785 2.059 6.346 2.059 1.83 0 3.39-.762 4.785-2.902l.229-.35c.187-.288.228-.391.228-.515 0-.123-.062-.226-.29-.37l-2.352-1.462c-.125-.082-.229-.123-.333-.123-.125 0-.208.061-.333.247l-.374.576c-.583.885-1.103 1.173-1.769 1.173-.582 0-1.269-.164-2.122-.576L8.132 6.361c-.25-.123-.52-.061-.645.227L6.322 9.14c-.125.288-.041.473.25.617"/>
</svg>
`;
function $35af9aa36f6d0a59$export$53305f1f2855d3be({ size: size, appearance: appearance = 'brand', label: label = 'Confluence Data Center', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $35af9aa36f6d0a59$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("bBmMe", function(module, exports) {
$parcel$export(module.exports, "ConfluenceDataCenterLogoCS", () => $28caef0d8f67e785$export$b3e508cb103e1f93);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c86f2cdcf615e24dd3ad3f9b48bca5bf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $28caef0d8f67e785$var$svg = `<svg height="100%" viewBox="0 0 188 32">
    <path fill="var(--text-color, #1e1f21)" d="M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.5-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.23 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.2-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>
    <path fill="var(--icon-color, #1868db)" d="M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.441 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.084.302.389.494l3.134 1.948c.167.11.306.165.444.165.167 0 .278-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.693.22 2.83.768l3.273 1.537c.333.165.694.083.86-.302l1.554-3.403c.166-.384.055-.63-.333-.823M8.762 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.306-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.69 8.29c-.167-.11-.305-.165-.444-.165-.166 0-.277.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.692-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302L8.43 12.187c-.167.384-.056.63.332.823"/>
</svg>
`;
function $28caef0d8f67e785$export$b3e508cb103e1f93({ size: size, appearance: appearance = 'brand', label: label = 'Confluence Data Center', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $28caef0d8f67e785$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("k5RCX", function(module, exports) {
$parcel$export(module.exports, "CrowdIcon", () => $cce899658bd7af06$export$eaf73f391f7103bd);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9928c9b96accda0f9234a11fc7ddaca0>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $cce899658bd7af06$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>
    <path fill="var(--icon-color, #1868db)" d="M18.71 7.463 12 4.993l-6.71 2.47a.44.44 0 0 0-.29.433l.14 3.807c.103 3.148 1.684 5.489 4.163 7.018a.446.446 0 0 0 .646-.204l1.445-3.412a.22.22 0 0 0-.14-.298 2.585 2.585 0 1 1 1.492 0 .22.22 0 0 0-.14.298l1.446 3.412a.446.446 0 0 0 .645.204c2.48-1.529 4.06-3.87 4.163-7.018L19 7.896a.44.44 0 0 0-.29-.433"/>
</svg>
`;
function $cce899658bd7af06$export$eaf73f391f7103bd({ size: size, appearance: appearance = 'brand', label: label = 'Crowd', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $cce899658bd7af06$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("gO8WE", function(module, exports) {
$parcel$export(module.exports, "CrowdLogoCS", () => $16431e75ab47754b$export$3c371bdbcdfcdce);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::206fa44ab9c6427ebeb6aaad7e53b58f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $16431e75ab47754b$var$svg = `<svg height="100%" viewBox="0 0 126 32">
    <path fill="var(--text-color, #1e1f21)" d="M113.97 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.72 0h-3.37l-2.64-7.42-1.41-4.72-1.41 4.72-2.64 7.42h-3.37L84.45 10h2.91l4.42 13 4.48-13h2.51l4.48 13 4.41-13h2.91zm-28.47.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.77 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-5.76 5.48v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>
    <path fill="var(--icon-color, #1868db)" d="M24.946 9.951 16 6.657 7.054 9.95a.59.59 0 0 0-.387.577l.187 5.076c.137 4.197 2.245 7.319 5.55 9.357.31.19.719.063.86-.272l1.928-4.55a.294.294 0 0 0-.185-.396 3.447 3.447 0 1 1 1.987 0 .294.294 0 0 0-.185.397l1.927 4.549c.142.335.55.463.86.272 3.305-2.038 5.413-5.16 5.55-9.357l.187-5.076a.59.59 0 0 0-.387-.577"/>
</svg>
`;
function $16431e75ab47754b$export$3c371bdbcdfcdce({ size: size, appearance: appearance = 'brand', label: label = 'Crowd', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $16431e75ab47754b$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("hpKZ3", function(module, exports) {
$parcel$export(module.exports, "CustomerServiceManagementIcon", () => $a655797975376923$export$6da5aa77c402ba0f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2cbaafcea60527c20df8d8395e491b95>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $a655797975376923$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z"/>
</svg>
`;
const $a655797975376923$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.238 14.751a3.25 3.25 0 0 1-1.762.516 3.25 3.25 0 0 1-1.762-.515L6.4 18.533V19H12a6.97 6.97 0 0 0 4.43-1.58zM6.58 7.571A6.97 6.97 0 0 0 5 12a6.97 6.97 0 0 0 1.58 4.43l2.669-2.668A3.25 3.25 0 0 1 8.733 12c0-.649.19-1.253.516-1.762zm8.172 2.667c.326.508.515 1.113.515 1.762s-.189 1.254-.515 1.762l2.668 2.668A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43zM12 5a6.97 6.97 0 0 0-4.43 1.58l2.668 2.668A3.25 3.25 0 0 1 12 8.733c.649 0 1.253.19 1.762.516L16.43 6.58A6.97 6.97 0 0 0 12 5"/>
</svg>
`;
function $a655797975376923$export$6da5aa77c402ba0f({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label = 'Customer Service Management', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $a655797975376923$var$svg,
        customThemeSvg: $a655797975376923$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("4dd2p", function(module, exports) {
$parcel$export(module.exports, "CustomerServiceManagementLogoCS", () => $fc1a4ae9e01ab70c$export$f597f0f7fadce0b9);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b7476897879e097648c054d2783409e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $fc1a4ae9e01ab70c$var$svg = `<svg height="100%" viewBox="0 0 456 32">
    <path fill="var(--text-color, #1e1f21)" d="M451.86 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.08-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.51-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M234.91 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.24 0h-3.53L217.69 10h2.76l4.97 13.09L230.36 10h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.65 2.45 6.65 6.07m-26.4-3.5v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H146.5c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.15-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M94.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45H94.1zm-6.7.58c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.89 2.79v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M21.91 23.23a9.3 9.3 0 0 1-5.91 2.1H8.53v-.62l5.12-5.04a4.34 4.34 0 0 0 2.35.69c.86 0 1.67-.25 2.35-.69zm1.32-1.32a9.3 9.3 0 0 0 2.1-5.91c0-2.24-.79-4.3-2.11-5.91l-3.56 3.56c.43.68.69 1.48.69 2.35s-.25 1.67-.69 2.35zM21.91 8.77l-3.56 3.56a4.34 4.34 0 0 0-2.35-.69c-.86 0-1.67.25-2.35.69l-3.56-3.56A9.3 9.3 0 0 1 16 6.67c2.24 0 4.3.79 5.91 2.11M8.77 10.09A9.3 9.3 0 0 0 6.67 16c0 2.24.79 4.3 2.11 5.91l3.56-3.56a4.34 4.34 0 0 1-.69-2.35c0-.86.25-1.67.69-2.35z"/>
</svg>
`;
function $fc1a4ae9e01ab70c$export$f597f0f7fadce0b9({ size: size, appearance: appearance = 'brand', label: label = 'Customer Service Management', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $fc1a4ae9e01ab70c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6v3UH", function(module, exports) {
$parcel$export(module.exports, "DxIcon", () => $d8741ea7cf00ec18$export$9951d02c2d848122);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe1275028f179c85adabcde30f1dc14d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $d8741ea7cf00ec18$var$svg = `<svg height="100%" viewBox="0 0 48 48">
    <path fill="var(--tile-color,#94c748)" d="M0 12C0 5.373 5.373 0 12 0h24c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H12C5.373 48 0 42.627 0 36z"/>
    <path fill="var(--icon-color, #101214)" d="m36.22 26.75 4.9 7.25h-4.78c-.52-.6-1.02-1.31-1.47-1.98-.68-1.02-.68-2.41.03-3.41zm-7.3-5.5L24.02 14h4.78c.52.6 1.02 1.31 1.47 1.98.68 1.02.68 2.41-.02 3.41zm6.98-6.02c.5-.84 1.07-1.16 1.95-1.16l3.9-.07-12.68 19.27a1.46 1.46 0 0 1-1.22.67H23.6c4.07-6.25 8.37-12.37 12.31-18.7M8 33.94h6.89c6.16 0 9.92-3.88 9.92-9.94s-3.76-9.94-9.92-9.94H8l4.28 3.9h-1.76C9.13 17.96 8 19.12 8 20.55v13.38m4.41-3.9V17.96h2.46c3.52 0 5.49 2.38 5.49 6.04 0 3.65-1.97 6.04-5.46 6.04z"/>
</svg>
`;
function $d8741ea7cf00ec18$export$9951d02c2d848122({ size: size, appearance: appearance = 'brand', label: label = 'Dx', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $d8741ea7cf00ec18$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("ii4hA", function(module, exports) {
$parcel$export(module.exports, "FeedbackIcon", () => $603c2ee6981ddbb4$export$34420f0520b19b1d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43275811237134a9433985263fbf7530>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $603c2ee6981ddbb4$var$svg = `<svg height="100%" viewBox="0 0 48 48">
    <rect width="48" height="48" fill="var(--tile-color,#c97cf4)" rx="12"/>
    <path fill="var(--icon-color, #101214)" d="M20 19h5v11h-5zm7-9h5v28h-5zm7 6h5v16h-5zm-21 0h5v16h-5zm-7 5h5v7H6z"/>
</svg>
`;
function $603c2ee6981ddbb4$export$34420f0520b19b1d({ size: size, appearance: appearance = 'brand', label: label = 'Feedback', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $603c2ee6981ddbb4$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("n96Xi", function(module, exports) {
$parcel$export(module.exports, "FeedbackLogoCS", () => $df439dc72ccedccc$export$bbccafb125ebd50c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5e0dda3588cef089e80240144a089b0a>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $df439dc72ccedccc$var$svg = `<svg height="100%" viewBox="0 0 169 32">
    <path fill="var(--text-color, #1e1f21)" d="M157.894 25.334h-2.638V3.59h2.638v13.585L164.487 10h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.177zm-5.648-2.761v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.489s1.656 5.49 5.674 5.49c1.564 0 2.545-.215 3.496-.553m-26.118-4.906c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.678 7.666v-2.76c-.981 2.024-2.821 3.067-5.182 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V10h2.638v15.333zm-16.09-7.666c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.502-4.478 4.906v1.227c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.698H107.4V3.592h2.637v9.17c.982-2.025 2.822-3.068 5.183-3.068 4.079 0 6.133 3.466 6.133 7.974 0 4.324-2.146 7.973-6.44 7.973m-22.806-7.974c0 3.68 1.472 5.52 4.2 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.508 1.963-4.508 5.52m8.678 7.666v-2.76c-.981 2.024-2.821 3.067-5.182 3.067-4.08 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.013 4.876 3.006V3.59h2.638v21.743zM80.502 12.085c-2.79 0-4.201 1.81-4.477 4.478h8.555c-.153-2.852-1.44-4.478-4.078-4.478M86.39 24.72c-1.258.675-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.625 3.282 6.625 7.943v1.196H76.055c.368 2.607 2.055 4.293 5.673 4.293 1.78 0 3.282-.337 4.662-.828zM64.42 12.085c-2.79 0-4.202 1.81-4.477 4.478h8.556c-.154-2.852-1.442-4.478-4.08-4.478m5.888 12.635c-1.258.675-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.238-7.943 4.722 0 6.623 3.282 6.623 7.943v1.196H59.974c.368 2.607 2.055 4.293 5.674 4.293 1.778 0 3.28-.337 4.66-.828zm-15.679-6.9H45.49v7.514h-2.76V5.186h12.94v2.637H45.49v7.36h9.138z"/>
    <rect width="32" height="32" fill="var(--tile-color,#c97cf4)" rx="8"/>
    <path fill="var(--icon-color, #101214)" d="M13.333 12.667h3.334V20h-3.334zm4.667-6h3.333v18.666H18zm4.667 4H26v10.666h-3.333zm-14 0H12v10.666H8.667zM4 14h3.333v4.666H4z"/>
</svg>
`;
function $df439dc72ccedccc$export$bbccafb125ebd50c({ size: size, appearance: appearance = 'brand', label: label = 'Feedback', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $df439dc72ccedccc$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("lbsfH", function(module, exports) {
$parcel$export(module.exports, "FocusIcon", () => $d09e6858a86e53f1$export$1e02e7298035a77c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c86bc4a90f7eb35fd36ae7c99f20011b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $d09e6858a86e53f1$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#fb9700)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M20.84 12.21a4.29 4.29 0 0 0-6.05 0l-1.394 1.393c-.77.769-2.02.769-2.789 0L9.45 12.445 6.424 15.47l1.158 1.158a6.25 6.25 0 0 0 8.838 0zm-17.68-.418a4.253 4.253 0 0 0 6.034.017l1.412-1.412a1.973 1.973 0 0 1 2.788 0l1.158 1.158 3.026-3.025-1.158-1.158a6.25 6.25 0 0 0-8.838 0l-4.42 4.419z"/>
</svg>
`;
function $d09e6858a86e53f1$export$1e02e7298035a77c({ size: size, appearance: appearance = 'brand', label: label = 'Focus', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $d09e6858a86e53f1$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("lh0tZ", function(module, exports) {
$parcel$export(module.exports, "FocusLogoCS", () => $585a1230e373b2ea$export$3a6e8b37e069a69d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7aca4717e5f7edbaa74141430c7d1f8d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $585a1230e373b2ea$var$svg = `<svg height="100%" viewBox="0 0 117 32">
    <path fill="var(--text-color, #1e1f21)" d="M116.03 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.71 3.58v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M64.6 25.64c-4.6 0-7.3-3.4-7.3-8S60 9.7 64.6 9.7c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.97 5.67h-9.14v7.51h-2.76V5.19h12.94v2.64H45.49v7.36h9.14z"/>
    <path fill="var(--tile-color,#fb9700)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M27.607 16.272c-2.176-2.176-5.712-2.152-7.865 0l-1.812 1.812c-1 1-2.625 1-3.625 0L12.8 16.578l-3.933 3.934 1.505 1.505a8.126 8.126 0 0 0 11.49 0zm-22.982-.541c2.176 2.175 5.668 2.196 7.844.02l1.834-1.834c1-1 2.625-1 3.625 0l1.505 1.505 3.934-3.933-1.505-1.505a8.126 8.126 0 0 0-11.49 0l-5.745 5.745z"/>
</svg>
`;
function $585a1230e373b2ea$export$3a6e8b37e069a69d({ size: size, appearance: appearance = 'brand', label: label = 'Focus', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $585a1230e373b2ea$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("gUhJt", function(module, exports) {
$parcel$export(module.exports, "GoalsIcon", () => $fb830070484ee0e7$export$9eb74917ea768ed4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::691ffc068fd79d2f7585ba74e9375893>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $fb830070484ee0e7$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0" clip-rule="evenodd"/>
</svg>
`;
function $fb830070484ee0e7$export$9eb74917ea768ed4({ size: size, appearance: appearance = 'brand', label: label = 'Goals', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $fb830070484ee0e7$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("cUsQ7", function(module, exports) {
$parcel$export(module.exports, "GoalsLogoCS", () => $0939dff37c82379b$export$c527a545aa426db3);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4fcd237a4e74e8fc6ee2ed98ecae9d02>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $0939dff37c82379b$var$svg = `<svg height="100%" viewBox="0 0 116 32">
    <path fill="var(--text-color, #1e1f21)" d="M115.55 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.12 4.13c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M58.71 24.2c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M19.36 16a3.36 3.36 0 1 1-6.72 0 3.36 3.36 0 0 1 6.72 0"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M16 25.375a9.375 9.375 0 1 0 0-18.75 9.375 9.375 0 1 0 0 18.75M21.86 16a5.86 5.86 0 1 1-11.72 0 5.86 5.86 0 0 1 11.72 0" clip-rule="evenodd"/>
</svg>
`;
function $0939dff37c82379b$export$c527a545aa426db3({ size: size, appearance: appearance = 'brand', label: label = 'Goals', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $0939dff37c82379b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jkzAl", function(module, exports) {
$parcel$export(module.exports, "GuardIcon", () => $26c53b5090dcc892$export$3f95fcfdc25a741d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9271fe2e99ed03180fc112676167f42e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $26c53b5090dcc892$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649"/>
</svg>
`;
function $26c53b5090dcc892$export$3f95fcfdc25a741d({ size: size, appearance: appearance = 'brand', label: label = 'Guard', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $26c53b5090dcc892$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("lgqiJ", function(module, exports) {
$parcel$export(module.exports, "GuardLogoCS", () => $5f18627c90cad907$export$2b896c4d595a4331);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db6984f13fa8a1f65e3a27814935822a>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $5f18627c90cad907$var$svg = `<svg height="100%" viewBox="0 0 120 32">
    <path fill="var(--text-color, #1e1f21)" d="M108.4 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.8-9.04v9.05H96.7V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.86 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-27.42-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-3.98 5.21c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M8.188 14.644h15.623c.449 0 .688-.24.688-.688V8.688c0-.449-.24-.688-.688-.688h-3.292c-.45 0-.689.24-.689.688v2.664h-1.496V8.688c0-.449-.24-.688-.688-.688h-3.293c-.448 0-.688.24-.688.688v2.664H12.17V8.688c0-.449-.24-.688-.689-.688H8.188c-.449 0-.688.24-.688.688v5.268c0 .449.24.688.688.688m.27 4.609a10.4 10.4 0 0 1-.599-2.993c-.03-.389.15-.598.569-.598H23.57c.42 0 .599.18.599.538q-.09 1.662-.629 3.053c-.18.479-.448.688-.957.688H9.415c-.508 0-.778-.21-.957-.688m13.856 2.484c-1.436 1.766-3.8 2.903-6.314 2.903s-4.939-1.137-6.345-2.903c-.36-.479-.18-.778.18-.778h12.33c.359 0 .538.3.15.778"/>
</svg>
`;
function $5f18627c90cad907$export$2b896c4d595a4331({ size: size, appearance: appearance = 'brand', label: label = 'Guard', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $5f18627c90cad907$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("g3rmL", function(module, exports) {
$parcel$export(module.exports, "HomeIcon", () => $b59b9e8572ff4d4f$export$92c8767b874048d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2dae141e789f6f860676eab772d48c16>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $b59b9e8572ff4d4f$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M5.875 10.688v7.437h4.375V13.75h3.5v4.375h4.375v-7.437L12 5z"/>
</svg>
`;
function $b59b9e8572ff4d4f$export$92c8767b874048d({ size: size, appearance: appearance = 'brand', label: label = 'Home', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $b59b9e8572ff4d4f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2IgJJ", function(module, exports) {
$parcel$export(module.exports, "HomeLogoCS", () => $d30c51da44b2955f$export$8b6b7f1b1b2367d3);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f61715fd61f2481e52a0f7c7611f421f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $d30c51da44b2955f$var$svg = `<svg height="100%" viewBox="0 0 121 32">
    <path fill="var(--text-color, #1e1f21)" d="M113.57 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM93.3 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.33 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M56.41 5.19h2.76v20.15h-2.76v-8.71H45.8v8.71h-2.76V5.19h2.76v8.8h10.61z"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M7.25 14.125V24.75h6.25V18.5h5v6.25h6.25V14.125L16 6z"/>
</svg>
`;
function $d30c51da44b2955f$export$8b6b7f1b1b2367d3({ size: size, appearance: appearance = 'brand', label: label = 'Home', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $d30c51da44b2955f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("7r44z", function(module, exports) {
$parcel$export(module.exports, "HubIcon", () => $9cc57614ef376af3$export$80b8b269d8b5014e);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::459e9cba95b1e0b094b9b0a89db30ecd>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $9cc57614ef376af3$var$svg = `<svg height="100%" viewBox="0 0 32 32">
    <g clip-path="url(#clip0_95164_16219)">
        <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
        <g clip-path="url(#clip1_95164_16219)">
            <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z" clip-rule="evenodd"/>
        </g>
    </g>
    <defs>
        <clipPath id="clip0_95164_16219">
            <path fill="var(--icon-color, white)" d="M0 0h32v32H0z"/>
        </clipPath>
        <clipPath id="clip1_95164_16219">
            <path fill="var(--icon-color, white)" d="M2 2h28v28H2z"/>
        </clipPath>
    </defs>
</svg>
`;
function $9cc57614ef376af3$export$80b8b269d8b5014e({ size: size, appearance: appearance = 'brand', label: label = 'Hub', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $9cc57614ef376af3$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jkuXc", function(module, exports) {
$parcel$export(module.exports, "HubLogoCS", () => $b3a30d16705d2aae$export$7a38180641471460);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::edd23980285704c09d78f5241a37a99c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $b3a30d16705d2aae$var$svg = `<svg height="100%" viewBox="0 0 95 32">
    <path fill="var(--text-color, #1e1f21)" d="M91.61 17.67c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-24.52-6.64V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65M56.4 5.19h2.76v20.15H56.4v-8.71H45.79v8.71h-2.76V5.19h2.76v8.8H56.4z"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z" clip-rule="evenodd"/>
</svg>
`;
function $b3a30d16705d2aae$export$7a38180641471460({ size: size, appearance: appearance = 'brand', label: label = 'Hub', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $b3a30d16705d2aae$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("kWdjh", function(module, exports) {
$parcel$export(module.exports, "JiraIcon", () => $810c191ad4f9179a$export$c4b5b1f965d8b3eb);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b225283860ba91a6c228b8f4fa0e1d39>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $810c191ad4f9179a$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M9.051 15.434H7.734c-1.988 0-3.413-1.218-3.413-3h7.085c.367 0 .605.26.605.63v7.13c-1.772 0-2.96-1.435-2.96-3.434zm3.5-3.543h-1.318c-1.987 0-3.413-1.196-3.413-2.978h7.085c.367 0 .627.239.627.608v7.13c-1.772 0-2.981-1.435-2.981-3.434zm3.52-3.522h-1.317c-1.987 0-3.413-1.217-3.413-3h7.085c.367 0 .605.262.605.61v7.129c-1.771 0-2.96-1.435-2.96-3.434z"/>
</svg>
`;
const $810c191ad4f9179a$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM4.321 12.434c0 1.782 1.425 3 3.412 3h1.319v1.326c0 2 1.188 3.433 2.959 3.433v-7.129c0-.369-.238-.63-.605-.63zm3.5-3.52c0 1.781 1.425 2.977 3.412 2.977h1.318v1.326c0 2 1.21 3.433 2.98 3.433V9.521c0-.369-.259-.608-.626-.608zm3.52-3.544c0 1.782 1.426 3 3.413 3h1.317v1.304c0 2 1.188 3.433 2.96 3.433V5.98c0-.348-.238-.609-.605-.609z"/>
</svg>
`;
function $810c191ad4f9179a$export$c4b5b1f965d8b3eb({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label = 'Jira', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $810c191ad4f9179a$var$svg,
        customThemeSvg: $810c191ad4f9179a$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8j3PH", function(module, exports) {
$parcel$export(module.exports, "JiraLogoCS", () => $a1c7c10f454c264d$export$bf4c5f97b468e8d6);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ed7d2f84cfdfe8bfef2a295bafed6da>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $a1c7c10f454c264d$var$svg = `<svg height="100%" viewBox="0 0 83 32">
    <path fill="var(--text-color, #1e1f21)" d="M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>
    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M11.965 20.698h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.423 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.503 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.7zm4.818-4.82h-1.803c-2.72 0-4.67-1.665-4.67-4.104h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z"/>
</svg>
`;
function $a1c7c10f454c264d$export$bf4c5f97b468e8d6({ size: size, appearance: appearance = 'brand', label: label = 'Jira', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $a1c7c10f454c264d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("72gNH", function(module, exports) {
$parcel$export(module.exports, "JiraDataCenterIcon", () => $51df5b0b11b04957$export$f8455b5667a3ee0c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61edfa3e375524991498620530471e0e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $51df5b0b11b04957$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>
    <path fill="var(--icon-color, #1868db)" d="M8.974 15.523H7.62c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.647v7.317c-1.817 0-3.036-1.472-3.036-3.525zm3.591-3.636h-1.352c-2.04 0-3.503-1.227-3.503-3.056h7.272c.376 0 .642.245.642.625v7.317c-1.817 0-3.059-1.473-3.059-3.525zm3.614-3.614h-1.353c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.624v7.318c-1.817 0-3.036-1.473-3.036-3.525z"/>
</svg>
`;
function $51df5b0b11b04957$export$f8455b5667a3ee0c({ size: size, appearance: appearance = 'brand', label: label = 'Jira Data Center', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $51df5b0b11b04957$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("3cL5S", function(module, exports) {
$parcel$export(module.exports, "JiraDataCenterLogoCS", () => $cdcc3adadca2bd7b$export$3224b07bc93ef23e);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::193cafbd0d66aed78a8eae06654a150d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $cdcc3adadca2bd7b$var$svg = `<svg height="100%" viewBox="0 0 83 32">
    <path fill="var(--text-color, #1e1f21)" d="M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>
    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>
    <path fill="var(--icon-color, #1868db)" d="M11.965 20.699h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.424 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.502 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.699zm4.818-4.819h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z"/>
</svg>
`;
function $cdcc3adadca2bd7b$export$3224b07bc93ef23e({ size: size, appearance: appearance = 'brand', label: label = 'Jira Data Center', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $cdcc3adadca2bd7b$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6x7k1", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryIcon", () => $fed57acdf8343a27$export$21bfbeb62fdcce8d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3b3ec3c590ed89c431e0f979daa3e25e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $fed57acdf8343a27$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#c97cf4)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z"/>
</svg>
`;
const $fed57acdf8343a27$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-5.981 5.604a6.387 6.387 0 0 0-6.394 6.394 6.373 6.373 0 0 0 6.394 6.377c3.532 0 6.41-2.854 6.41-6.377v-.563H14.19v.3c0 1.39-.97 2.412-2.171 2.413a2.154 2.154 0 0 1-2.156-2.168c0-1.197.973-2.148 2.332-2.148h.353v-4.21c-.177-.018-.353-.018-.53-.018m6.87-.722a9.47 9.47 0 0 1-5.422 0c-.141-.035-.265.07-.212.228.477 1.85.477 3.559 0 5.409-.053.14.07.264.212.211a10.1 10.1 0 0 1 5.422 0c.159.053.265-.07.23-.211-.513-1.85-.513-3.56 0-5.409.034-.158-.072-.263-.23-.228"/>
</svg>
`;
function $fed57acdf8343a27$export$21bfbeb62fdcce8d({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label = 'Jira Product Discovery', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $fed57acdf8343a27$var$svg,
        customThemeSvg: $fed57acdf8343a27$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("lsS3I", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryLogoCS", () => $50283f2ecff34470$export$602140a6a10b02bf);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8e2d27dec964efc37c6ed5782c3fe57>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $50283f2ecff34470$var$svg = `<svg height="100%" viewBox="0 0 327 32">
    <path fill="var(--text-color, #1e1f21)" d="M317.88 24.35h-1.72L310.62 10h2.82l4.91 13.13 4.9-13.13h2.82l-5.8 14.84c-1.72 4.39-2.7 6.65-6.59 6.65-1.32 0-2.06-.12-2.82-.43v-2.27c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.82m-13.25-8.05v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.72.6h-3.53L268.87 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.39 10.42v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-13.88-1.42c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.7-15.22c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zM207.68 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-13.41-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-14.99-1.32c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.78 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84h-4.02v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14h-3.71v8.28zm-27.87 1.56c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>
    <path fill="var(--tile-color,#c97cf4)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M17.448 6.967c2.544.746 5.113.746 7.656 0 .225-.05.375.1.325.323-.724 2.612-.724 5.025 0 7.637.05.199-.1.373-.325.298a14.3 14.3 0 0 0-7.656 0c-.2.075-.374-.1-.3-.298.674-2.612.674-5.025 0-7.637-.074-.223.1-.373.3-.323m1.023 9.253v.423c0 1.965-1.372 3.408-3.068 3.408a3.04 3.04 0 0 1-3.043-3.06c0-1.691 1.372-3.034 3.292-3.034h.5V8.012c-.25-.025-.5-.025-.749-.025a9.02 9.02 0 0 0-9.028 9.03c0 4.999 4.04 9.004 9.028 9.004s9.053-4.03 9.053-9.005v-.796z"/>
</svg>
`;
function $50283f2ecff34470$export$602140a6a10b02bf({ size: size, appearance: appearance = 'brand', label: label = 'Jira Product Discovery', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $50283f2ecff34470$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("krMin", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementIcon", () => $1a4200fc0de79e7f$export$3c6158790f5e01c4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cedb5d68059644a06a093aa74d8e3cc5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $1a4200fc0de79e7f$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z"/>
</svg>
`;
const $1a4200fc0de79e7f$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.256 10.156-2.481 3.12c-1.694 2.129-1.912 5.047.402 6.891l7.16-8.837c.42-.52.185-1.174-.503-1.174zm-8.619 2.348c-.419.52-.183 1.174.504 1.174h4.577l2.465-3.136c1.677-2.146 1.928-5.03-.386-6.875z"/>
</svg>
`;
function $1a4200fc0de79e7f$export$3c6158790f5e01c4({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label = 'Jira Service Management', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $1a4200fc0de79e7f$var$svg,
        customThemeSvg: $1a4200fc0de79e7f$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5wzQZ", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementLogoCS", () => $6e661aa0d8ca34bf$export$de148263c75d2bc1);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bcf1b6bc0c0712320d6fbdb868500ebb>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $6e661aa0d8ca34bf$var$svg = `<svg height="100%" viewBox="0 0 372 32">
    <path fill="var(--text-color, #1e1f21)" d="M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>
    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M18.268 13.604h5.951c.894 0 1.199.85.654 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.523-8.959zm-4.6 4.577h-5.95c-.894 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z"/>
</svg>
`;
function $6e661aa0d8ca34bf$export$de148263c75d2bc1({ size: size, appearance: appearance = 'brand', label: label = 'Jira Service Management', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $6e661aa0d8ca34bf$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("hGd87", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementDataCenterIcon", () => $c4131903caa76970$export$65fae0eaf343f2ca);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5b3684e2355c28ec62827d09d362b6cf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $c4131903caa76970$var$svg = `<svg height="100%" viewBox="0 0 25 24">
    <path fill="var(--tile-color, white)" d="M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5Z"/>
    <path fill="var(--icon-color, #1868db)" d="M14.117 10.203h4.464c.67 0 .899.637.49 1.144l-6.98 8.616c-2.257-1.798-2.044-4.643-.393-6.72zm-3.45 3.433H6.205c-.67 0-.899-.638-.49-1.144l6.981-8.617c2.256 1.799 2.011 4.61.376 6.704z"/>
</svg>
`;
function $c4131903caa76970$export$65fae0eaf343f2ca({ size: size, appearance: appearance = 'brand', label: label = 'Jira Service Management Data Center', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $c4131903caa76970$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("dlVUr", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementDataCenterLogoCS", () => $222b6c42b1fea827$export$f64bc7a7f04428d0);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d19396c378541211d8225aae490bcbcf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $222b6c42b1fea827$var$svg = `<svg height="100%" viewBox="0 0 372 32">
    <path fill="var(--text-color, #1e1f21)" d="M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.17-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>
    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>
    <path fill="var(--icon-color, #1868db)" d="M18.268 13.604h5.95c.895 0 1.2.85.655 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.524-8.959zm-4.6 4.577h-5.95c-.895 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z"/>
</svg>
`;
function $222b6c42b1fea827$export$f64bc7a7f04428d0({ size: size, appearance: appearance = 'brand', label: label = 'Jira Service Management Data Center', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $222b6c42b1fea827$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8oSGj", function(module, exports) {
$parcel$export(module.exports, "LoomIcon", () => $21e3ce7f59c04101$export$8d789f76fde3e05);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::568f663154fd35333110385dd0c22e41>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $21e3ce7f59c04101$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302"/>
</svg>
`;
function $21e3ce7f59c04101$export$8d789f76fde3e05({ size: size, appearance: appearance = 'brand', label: label = 'Loom', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $21e3ce7f59c04101$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("7ktDp", function(module, exports) {
$parcel$export(module.exports, "LoomLogoCS", () => $daf17deffdf5861b$export$78c0b4d8be34c9b2);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2d69248f39a87c063a78e83a58b63bd7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $daf17deffdf5861b$var$svg = `<svg height="100%" viewBox="0 0 103 32">
    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593"/>
    <path fill="var(--text-color, #1e1f21)" d="M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19"/>
</svg>
`;
function $daf17deffdf5861b$export$78c0b4d8be34c9b2({ size: size, appearance: appearance = 'brand', label: label = 'Loom', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $daf17deffdf5861b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("cbyZq", function(module, exports) {
$parcel$export(module.exports, "LoomAttributionLogoCS", () => $05e4114c0e5d329b$export$68d7391318cdef11);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9f5d94b0d7bf822b6ab4c2ad26c21970>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $05e4114c0e5d329b$var$svg = `<svg height="100%" viewBox="0 0 100 32">
    <path fill="var(--icon-color, #101214)" d="M66.71 5.11c0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82 0 .39-.26.62-1.08.62-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.06 0 2.85-.92 2.85-2.26m0 .03c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.5c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16m26.29-2.11v7.32h1.57V4.81l.64 1.46 2.21 4.11h1.95V3.06h-1.54v4.73l-.59-1.39-1.77-3.34zm-9.91 0h-1.7v7.32h1.7zM79.45 8.2c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.47c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16 0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82s-.26.62-1.08.62c-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.03 0 2.85-.92 2.85-2.29M53.5 3.06v7.32h3.49l.54-1.59h-2.34V3.06zm-6.91 0v1.57h1.88v5.75h1.72V4.63h2.03V3.06zm-2.49 0h-2.24l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95c-.03 0-2.57-7.32-2.57-7.32m-1.13 4.75c-.33 0-.64-.05-.93-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m20.06-4.75H60.8l-2.57 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zM61.9 7.81c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m27.32-4.75h-2.23l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zm-1.11 4.75c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19a3.7 3.7 0 0 1-.92.13"/>
    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.664-1.775-1.025-2.692 4.664V7.125h-2.048v5.385l-2.694-4.664-1.774 1.025 2.693 4.663-4.664-2.692-1.024 1.774 4.664 2.693H6.958v2.048h5.385L7.68 20.05l1.024 1.775 4.663-2.693-2.692 4.664 1.774 1.024 2.693-4.664v5.386h2.049v-5.385l2.692 4.663 1.774-1.024-2.692-4.664 4.663 2.693 1.025-1.775-4.664-2.692h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.594 2.797 2.797 0 0 1 0 5.593"/>
    <path fill="var(--text-color, #1e1f21)" d="M39.32 27.74v-13.7h2.52v13.7zm24.13-9.31h2.4v1.14c.51-.91 1.7-1.4 2.72-1.4 1.27 0 2.29.55 2.76 1.55.74-1.14 1.72-1.55 2.95-1.55 1.72 0 3.37 1.04 3.37 3.54v6.04h-2.44v-5.53c0-1-.49-1.76-1.65-1.76-1.08 0-1.72.83-1.72 1.84v5.45h-2.49v-5.53c0-1-.51-1.76-1.65-1.76-1.1 0-1.74.81-1.74 1.84v5.45h-2.52zm-15.93 9.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.05 4.93-4.89 4.93m0-7.58a2.65 2.65 0 0 0-2.65 2.65 2.65 2.65 0 0 0 2.65 2.65c1.46 0 2.65-1.19 2.65-2.65a2.65 2.65 0 0 0-2.65-2.65m10.26 7.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.06 4.93-4.89 4.93m0-7.61a2.69 2.69 0 0 0-2.68 2.68 2.69 2.69 0 0 0 2.68 2.68 2.69 2.69 0 0 0 2.68-2.68 2.69 2.69 0 0 0-2.68-2.68"/>
</svg>
`;
function $05e4114c0e5d329b$export$68d7391318cdef11({ size: size, appearance: appearance = 'brand', label: label = 'Loom Attribution', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $05e4114c0e5d329b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("etntV", function(module, exports) {
$parcel$export(module.exports, "LoomInternalIcon", () => $ee5f3afdcc2a281f$export$38c7b37a3e5e8d70);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45c3b4b2f73587dee325566fc7978684>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $ee5f3afdcc2a281f$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#625df5)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302"/>
</svg>
`;
function $ee5f3afdcc2a281f$export$38c7b37a3e5e8d70({ size: size, appearance: appearance = 'brand', label: label = 'Loom', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $ee5f3afdcc2a281f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9XoBS", function(module, exports) {
$parcel$export(module.exports, "LoomInternalLogoCS", () => $0f739c9a029f0011$export$71743a944cb62e48);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7f4fa46a3d520008396bf538a250ebef>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $0f739c9a029f0011$var$svg = `<svg height="100%" viewBox="0 0 103 32">
    <path fill="var(--tile-color,#625df5)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593"/>
    <path fill="var(--text-color, #1e1f21)" d="M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19"/>
</svg>
`;
function $0f739c9a029f0011$export$71743a944cb62e48({ size: size, appearance: appearance = 'brand', label: label = 'Loom', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $0f739c9a029f0011$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("hzlnN", function(module, exports) {
$parcel$export(module.exports, "OpsgenieIcon", () => $c8b08b89015205ec$export$eeccc49dc7a12d9f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2bf4732a418598faff0fcffc57f4a7b7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $c8b08b89015205ec$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M12.696 19.45c-.49.361-.749.336-1.24-.026-2.375-1.704-4.57-3.641-6.042-5.655-.155-.207-.078-.49.155-.62l2.685-1.678q.35-.233.62.077c1.033 1.188 2.04 2.35 3.202 3.176 1.162-.826 2.17-1.988 3.202-3.176q.272-.31.62-.078l2.686 1.679c.232.13.31.413.155.62-1.472 2.014-3.667 3.95-6.043 5.68m-.62-7.411c2.118 0 3.874-1.73 3.874-3.848s-1.756-3.9-3.874-3.9c-2.117 0-3.873 1.757-3.873 3.9s1.704 3.848 3.873 3.848"/>
</svg>
`;
function $c8b08b89015205ec$export$eeccc49dc7a12d9f({ size: size, appearance: appearance = 'brand', label: label = 'Opsgenie', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $c8b08b89015205ec$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jsl2G", function(module, exports) {
$parcel$export(module.exports, "OpsgenieLogoCS", () => $0273b51641a25914$export$a5b9122e89b32ad3);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::032f8fa95ed51413adb506dd076fd343>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $0273b51641a25914$var$svg = `<svg height="100%" viewBox="0 0 164 32">
    <path fill="var(--text-color, #1e1f21)" d="M156.69 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM143.39 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-3.68-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.47-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.06 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-4.72 3.52c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-16.29-3.49c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3.01v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-20.11.01c-6.22 0-9.72-4.29-9.72-10.43 0-6.07 3.5-10.33 9.72-10.33 6.2 0 9.69 4.26 9.69 10.34 0 6.13-3.5 10.43-9.69 10.43m0-18.12c-4.97 0-6.96 3.53-6.96 7.7 0 4.26 1.99 7.79 6.96 7.79 4.94 0 6.93-3.53 6.93-7.79 0-4.17-1.99-7.7-6.93-7.7"/>
    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M16.905 25.684c-.638.47-.974.437-1.612-.033-3.088-2.216-5.942-4.734-7.855-7.352-.202-.269-.1-.638.201-.806l3.491-2.182q.454-.302.806.1c1.343 1.545 2.652 3.056 4.163 4.13 1.51-1.074 2.82-2.585 4.163-4.13q.352-.402.805-.1l3.491 2.182c.303.168.403.537.202.806-1.914 2.618-4.767 5.136-7.855 7.385m-.806-9.635c2.753 0 5.035-2.249 5.035-5.001s-2.282-5.07-5.035-5.07-5.036 2.283-5.036 5.07c0 2.786 2.216 5.001 5.036 5.001"/>
</svg>
`;
function $0273b51641a25914$export$a5b9122e89b32ad3({ size: size, appearance: appearance = 'brand', label: label = 'Opsgenie', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $0273b51641a25914$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("dkima", function(module, exports) {
$parcel$export(module.exports, "ProjectsIcon", () => $918cd29d73f66eb0$export$5ed3e1bb3b04fc02);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bab74cd77291828d528d124967c3552>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $918cd29d73f66eb0$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m5.106 14.44 1.856-1.856-1.856-1.856L6.653 9.18h3.712l2.784-2.784h4.332v4.33l-2.785 2.785v3.712L13.15 18.77l-1.857-1.856-1.856 1.856-1.7-1.7 2.784-2.784-.928-.928-2.784 2.784zm10.209-4.331a1.094 1.094 0 1 1-1.547-1.546 1.094 1.094 0 0 1 1.547 1.546" clip-rule="evenodd"/>
</svg>
`;
function $918cd29d73f66eb0$export$5ed3e1bb3b04fc02({ size: size, appearance: appearance = 'brand', label: label = 'Projects', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $918cd29d73f66eb0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("7ckOW", function(module, exports) {
$parcel$export(module.exports, "ProjectsLogoCS", () => $4d47b5a4b66c9b38$export$e3d1678155aaab99);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::820b1edb3bac4a2b82da6f532724cb11>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $4d47b5a4b66c9b38$var$svg = `<svg height="100%" viewBox="0 0 145 32">
    <path fill="var(--text-color, #1e1f21)" d="M144.54 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.75-.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M99.43 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM83.8 31.25v-2.36c.31.03.49.03.77.03 1.13 0 2.05-.49 2.05-1.87V10h2.64v17.36c0 2.82-1.59 4.02-4.11 4.02-.67 0-1.13-.06-1.35-.12m2.3-25.3c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84M76.07 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M62.3 16.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84H45.8v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14H45.8v8.28z"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m6.152 19.486 2.651-2.652-2.651-2.651 2.21-2.21h5.303l3.977-3.977h6.187v6.187l-3.977 3.977v5.304l-2.21 2.21-2.652-2.652-2.651 2.651-2.429-2.428 3.978-3.978-1.326-1.325-3.978 3.977zM20.736 13.3a1.562 1.562 0 1 1-2.21-2.21 1.562 1.562 0 0 1 2.21 2.21" clip-rule="evenodd"/>
</svg>
`;
function $4d47b5a4b66c9b38$export$e3d1678155aaab99({ size: size, appearance: appearance = 'brand', label: label = 'Projects', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $4d47b5a4b66c9b38$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("fA5kq", function(module, exports) {
$parcel$export(module.exports, "RovoIcon", () => $d76b6c0432cec7f8$export$e23ae35269442b4f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c09aee6cc96e54887271dd42a7eae172>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $d76b6c0432cec7f8$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M11.057 5.257a1.57 1.57 0 0 1 1.539.015l4.621 2.668c.484.279.783.797.783 1.354v5.336a1.56 1.56 0 0 1-.782 1.355l-3.474 2.005a2 2 0 0 0 .12-.691v-5.337c0-.733-.39-1.409-1.026-1.774l-2.59-1.495V6.626q.001-.246.074-.473c.117-.364.366-.68.707-.877z"/>
    <path fill="var(--icon-color, white)" d="M9.881 5.94 6.408 7.945A1.56 1.56 0 0 0 5.625 9.3v5.337c0 .557.3 1.075.783 1.354l4.621 2.668c.475.274 1.06.279 1.539.015l.027-.019a1.57 1.57 0 0 0 .781-1.35v-2.067l-2.589-1.495a2.05 2.05 0 0 1-1.026-1.775V6.631a2 2 0 0 1 .12-.691"/>
</svg>
`;
function $d76b6c0432cec7f8$export$e23ae35269442b4f({ size: size, appearance: appearance = 'brand', label: label = 'Rovo', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $d76b6c0432cec7f8$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jkq81", function(module, exports) {
$parcel$export(module.exports, "RovoLogoCS", () => $1e2e754bbbef8c76$export$b0e15f0a1c9f4c55);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29265478015ee48ec34dc1fd6eae4b81>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $1e2e754bbbef8c76$var$svg = `<svg height="100%" viewBox="0 0 106 32">
    <path fill="var(--text-color, #1e1f21)" d="M98.36 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.87 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26"/>
    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896q.017-.046.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682.17-.527.529-.983 1.021-1.267h.002z"/>
    <path fill="var(--icon-color, white)" d="m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1"/>
</svg>
`;
function $1e2e754bbbef8c76$export$b0e15f0a1c9f4c55({ size: size, appearance: appearance = 'brand', label: label = 'Rovo', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $1e2e754bbbef8c76$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("bZCfg", function(module, exports) {
$parcel$export(module.exports, "RovoDevIcon", () => $0077dad4a5fd0f4a$export$8b784b3227531b3e);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0424c604e8fb1e51fac762a4e1efa562>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $0077dad4a5fd0f4a$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M11.26 4.71a1.7 1.7 0 0 1 1.666.017l5.006 2.89c.524.302.848.863.848 1.467v5.78a1.69 1.69 0 0 1-.848 1.467l-3.763 2.172.024-.07c.07-.216.107-.445.107-.679v-5.78c0-.794-.423-1.526-1.112-1.922l-2.805-1.62V6.195q.001-.267.08-.512c.126-.395.396-.737.765-.95l.002-.001z"/>
    <path fill="var(--icon-color, #101214)" d="M9.986 5.45 6.223 7.623a1.69 1.69 0 0 0-.848 1.466v5.78c0 .605.324 1.166.848 1.468l5.006 2.89a1.7 1.7 0 0 0 1.666.016l.03-.02c.37-.214.64-.556.768-.95q.078-.247.079-.513v-2.24l-2.805-1.618a2.22 2.22 0 0 1-1.112-1.922V6.2a2.2 2.2 0 0 1 .13-.75"/>
</svg>
`;
function $0077dad4a5fd0f4a$export$8b784b3227531b3e({ size: size, appearance: appearance = 'brand', label: label = 'Rovo Dev', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $0077dad4a5fd0f4a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("kEDm8", function(module, exports) {
$parcel$export(module.exports, "RovoDevLogoCS", () => $beb9a972f2c608b2$export$4145bd793c9ed1d0);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e0f280d200b0e27835aec655dfa5a41e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $beb9a972f2c608b2$var$svg = `<svg height="100%" viewBox="0 0 165 32">
    <path fill="var(--text-color, #1e1f21)" d="M158.79 25.33h-3.53L149.32 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.64-13.24c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM121.91 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.26.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.86 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26"/>
    <path fill="var(--tile-color,#94c748)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682a2.26 2.26 0 0 1 1.021-1.267h.002z"/>
    <path fill="var(--icon-color, #101214)" d="m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1"/>
</svg>
`;
function $beb9a972f2c608b2$export$4145bd793c9ed1d0({ size: size, appearance: appearance = 'brand', label: label = 'Rovo Dev', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $beb9a972f2c608b2$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("JcJ9s", function(module, exports) {
$parcel$export(module.exports, "RovoDevAgentIcon", () => $7f364f510f05b329$export$813cff80931d9dbf);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c56e9a05bb3a4c70bfd4cbcb5fa54ba2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $7f364f510f05b329$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M10.7.368a2.75 2.75 0 0 1 2.748 0l8.016 4.626a2.75 2.75 0 0 1 1.375 2.38v9.252c0 .982-.524 1.889-1.375 2.38l-8.016 4.626a2.75 2.75 0 0 1-2.749 0l-8.016-4.626a2.75 2.75 0 0 1-1.374-2.38V7.374c0-.982.524-1.889 1.374-2.38z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M10.181 6.096 6.777 8.06a1.53 1.53 0 0 0-.768 1.327v5.229c0 .547.294 1.054.768 1.327l.807.466 3.722 2.149a1.54 1.54 0 0 0 1.508.014l.027-.018a1.54 1.54 0 0 0 .766-1.323v-2.026l-1.97-1.137-.568-.327a2 2 0 0 1-1.006-1.74V6.775a2 2 0 0 1 .118-.678" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M12.842 5.441a1.54 1.54 0 0 0-1.508-.014l-.028.019a1.54 1.54 0 0 0-.765 1.323v2.025l1.91 1.102.628.362a2 2 0 0 1 1.006 1.74v5.228a2 2 0 0 1-.118.678l3.404-1.965c.476-.273.767-.778.767-1.327V9.383c0-.546-.293-1.054-.767-1.327l-.868-.501z" clip-rule="evenodd"/>
</svg>
`;
function $7f364f510f05b329$export$813cff80931d9dbf({ size: size, appearance: appearance = 'brand', label: label = 'Rovo Dev Agent', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $7f364f510f05b329$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("iMzVZ", function(module, exports) {
$parcel$export(module.exports, "RovoDevAgentLogoCS", () => $4a588beb2465d634$export$58747af448450872);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ca2d332c134816706ee434029a355d3c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $4a588beb2465d634$var$svg = `<svg height="100%" viewBox="0 0 160 32">
    <path fill="var(--text-color, #1e1f21)" d="M153.94 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zM136.3 12.42c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-25.13-16.9h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.52h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.25.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M45 8.16h-4.05v7.36H45c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26"/>
    <path fill="var(--tile-color,#94c748)" d="M12.52.49a3.67 3.67 0 0 1 3.666 0l10.688 6.17a3.66 3.66 0 0 1 1.833 3.173v12.336a3.66 3.66 0 0 1-1.833 3.173L16.186 31.51a3.67 3.67 0 0 1-3.665 0L1.833 25.341A3.66 3.66 0 0 1 0 22.168V9.832c0-1.309.7-2.519 1.833-3.173z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m11.83 8.128-4.54 2.62a2.04 2.04 0 0 0-1.022 1.77v6.972c0 .728.39 1.405 1.023 1.77l1.076.62 4.963 2.865a2.05 2.05 0 0 0 2.01.02l.037-.025c.445-.257.771-.67.925-1.146q.094-.297.095-.619v-2.7l-2.627-1.516-.757-.436a2.67 2.67 0 0 1-1.34-2.32v-6.97a2.7 2.7 0 0 1 .157-.904" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M15.377 7.255a2.05 2.05 0 0 0-2.01-.019l-.038.026c-.445.257-.77.67-.924 1.145a2 2 0 0 0-.095.618v2.7l2.545 1.47.839.483a2.67 2.67 0 0 1 1.34 2.319v6.972a2.7 2.7 0 0 1-.157.903l4.54-2.62a2.04 2.04 0 0 0 1.022-1.77v-6.971c0-.729-.39-1.405-1.023-1.77l-1.157-.668z" clip-rule="evenodd"/>
</svg>
`;
function $4a588beb2465d634$export$58747af448450872({ size: size, appearance: appearance = 'brand', label: label = 'Rovo Dev Agent', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $4a588beb2465d634$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("i8M6W", function(module, exports) {
$parcel$export(module.exports, "RovoHexIcon", () => $2aaf3409a1ea6783$export$9e62346a60cfb459);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b1fdf93317430cb701429972e6c41dc4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $2aaf3409a1ea6783$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--rovo-blue-color, #1868db)" fill-rule="evenodd" d="m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z" clip-rule="evenodd"/>
    <path fill="var(--rovo-green-color, #6a9a23)" fill-rule="evenodd" d="m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z" clip-rule="evenodd"/>
    <path fill="var(--rovo-purple-color, #af59e1)" fill-rule="evenodd" d="m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354" clip-rule="evenodd"/>
    <path fill="var(--rovo-yellow-color, #fca700)" fill-rule="evenodd" d="M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z" clip-rule="evenodd"/>
</svg>
`;
function $2aaf3409a1ea6783$export$9e62346a60cfb459({ size: size, appearance: appearance = 'brand', label: label = 'Rovo', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $2aaf3409a1ea6783$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("1igo3", function(module, exports) {
$parcel$export(module.exports, "RovoHexLogoCS", () => $1558d742548aee27$export$5e38d02efdb45577);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0e01ef8caae93929e35d346a5091c5ef>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $1558d742548aee27$var$svg = `<svg height="100%" viewBox="0 0 102 32">
    <path fill="var(--text-color, #1e1f21)" d="M93.5 25.97c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.3c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M44.99 8.16h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26"/>
    <path fill="var(--rovo-blue-color, #1868db)" fill-rule="evenodd" d="m15.892 22.385-9.538 5.559-4.538-2.613A3.63 3.63 0 0 1 0 22.19V9.821C0 8.524.69 7.33 1.816 6.682l8.058-4.649-.052.152a4.7 4.7 0 0 0-.228 1.452v12.37a4.74 4.74 0 0 0 2.38 4.113z" clip-rule="evenodd"/>
    <path fill="var(--rovo-green-color, #6a9a23)" fill-rule="evenodd" d="m13.318 20.895-9.591 5.538 8.809 5.082a3.64 3.64 0 0 0 3.568.034l.065-.043a3.63 3.63 0 0 0 1.642-2.034c.11-.35.17-.718.17-1.096v-4.792z" clip-rule="evenodd"/>
    <path fill="var(--rovo-purple-color, #af59e1)" fill-rule="evenodd" d="M26.893 6.67 21.02 3.285l-7.873 6.52 3.587 2.075a4.74 4.74 0 0 1 2.38 4.115v12.369a4.7 4.7 0 0 1-.28 1.603l8.058-4.649a3.62 3.62 0 0 0 1.816-3.139V9.81a3.63 3.63 0 0 0-1.816-3.139" clip-rule="evenodd"/>
    <path fill="var(--rovo-yellow-color, #fca700)" fill-rule="evenodd" d="m15.244 11.022-4.519-2.606V3.625c0-.378.059-.747.17-1.096a3.63 3.63 0 0 1 1.64-2.033l.002-.001.064-.044a3.64 3.64 0 0 1 3.569.034l8.665 5z" clip-rule="evenodd"/>
</svg>
`;
function $1558d742548aee27$export$5e38d02efdb45577({ size: size, appearance: appearance = 'brand', label: label = 'Rovo', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $1558d742548aee27$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6H7fj", function(module, exports) {
$parcel$export(module.exports, "SearchIcon", () => $68c736c0b63932c7$export$82eafebb825fc23f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be11b64b046e775d05a59a39754fdeaf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $68c736c0b63932c7$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6.625a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M10.76 17.176a5.791 5.791 0 1 1 5.038-2.935l3.403 3.403-2.205 2.204-3.409-3.408a5.77 5.77 0 0 1-2.827.736m-.274-9.37-.242.615c-.344.874-.516 1.312-.833 1.64-.318.33-.749.518-1.61.893l-.37.16v.51l.37.16c.861.376 1.292.563 1.61.893.317.329.49.766.833 1.64l.242.616h.51l.242-.616c.344-.874.516-1.311.834-1.64.317-.33.748-.517 1.61-.893l.368-.16v-.51l-.369-.16c-.861-.375-1.292-.563-1.61-.892-.317-.33-.489-.766-.833-1.64l-.242-.616z" clip-rule="evenodd"/>
</svg>
`;
function $68c736c0b63932c7$export$82eafebb825fc23f({ size: size, appearance: appearance = 'brand', label: label = 'Search', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $68c736c0b63932c7$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("fSlJW", function(module, exports) {
$parcel$export(module.exports, "SearchLogoCS", () => $cd40783283c7910b$export$fa08cbfe393f2a68);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::151d3b961b465b2b1ef70ce5cd1da70c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $cd40783283c7910b$var$svg = `<svg height="100%" viewBox="0 0 130 32">
    <path fill="var(--text-color, #1e1f21)" d="M128.82 16.35v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.05 6.21v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-18.23-6.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.87 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM65.08 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M14.346 22.068a7.721 7.721 0 1 1 6.718-3.913l4.537 4.536-2.94 2.94-4.545-4.545a7.7 7.7 0 0 1-3.77.982m-.364-12.494-.323.82c-.459 1.167-.688 1.75-1.112 2.188-.423.44-.997.69-2.146 1.19l-.492.214v.68l.492.213c1.149.5 1.723.75 2.146 1.19.424.439.653 1.022 1.112 2.188l.323.82h.679l.323-.82c.459-1.166.688-1.75 1.111-2.188.424-.44.998-.69 2.147-1.19l.491-.214v-.679l-.491-.214c-1.149-.5-1.723-.75-2.147-1.19-.423-.438-.652-1.021-1.111-2.187l-.323-.82z" clip-rule="evenodd"/>
</svg>
`;
function $cd40783283c7910b$export$fa08cbfe393f2a68({ size: size, appearance: appearance = 'brand', label: label = 'Search', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $cd40783283c7910b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("7Kt4x", function(module, exports) {
$parcel$export(module.exports, "StatuspageIcon", () => $bc731a1f9d8e25a4$export$f3f5aa321d88adf9);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::37c59c3ee979ff8acaf7525e576da094>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $bc731a1f9d8e25a4$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M12 9.796c-1.924 0-3.796.832-5.324 2.118q-.238.227-.475.227c-.132 0-.263-.076-.369-.202L3.908 9.771c-.105-.126-.158-.252-.158-.353 0-.151.08-.277.237-.429C6.307 7.023 9.127 5.914 12 5.914s5.693 1.109 8.013 3.075c.158.152.237.278.237.429 0 .1-.053.227-.158.353l-1.924 2.168c-.106.126-.238.202-.37.202q-.236 0-.474-.227c-1.529-1.286-3.4-2.118-5.324-2.118m0 8.118c-2.135 0-3.875-1.664-3.875-3.68 0-2.018 1.74-3.682 3.875-3.682s3.875 1.64 3.875 3.681-1.74 3.68-3.875 3.68"/>
</svg>
`;
function $bc731a1f9d8e25a4$export$f3f5aa321d88adf9({ size: size, appearance: appearance = 'brand', label: label = 'Statuspage', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $bc731a1f9d8e25a4$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6CcMP", function(module, exports) {
$parcel$export(module.exports, "StatuspageLogoCS", () => $2e7253800a69a3ff$export$2bc88a281410ffa7);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4e31a509778b74933bf91345a74560c5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $2e7253800a69a3ff$var$svg = `<svg height="100%" viewBox="0 0 192 32">
    <path fill="var(--text-color, #1e1f21)" d="M184.96 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-10.55-4.47c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.61-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19H85V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.95-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.26-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07"/>
    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M15.896 13.196c-2.464 0-4.86 1.114-6.817 2.835q-.303.304-.607.304c-.169 0-.338-.102-.473-.27l-2.463-2.902c-.135-.17-.202-.338-.202-.473 0-.202.1-.371.303-.573C8.607 9.484 12.217 8 15.896 8c3.678 0 7.29 1.484 10.259 4.117.202.202.303.37.303.573 0 .135-.067.304-.202.473l-2.463 2.902c-.135.168-.304.27-.473.27q-.303 0-.607-.304c-1.958-1.721-4.353-2.835-6.817-2.835m0 10.867c-2.733 0-4.96-2.228-4.96-4.927 0-2.7 2.227-4.927 4.96-4.927s4.96 2.193 4.96 4.927-2.227 4.927-4.96 4.927"/>
</svg>
`;
function $2e7253800a69a3ff$export$2bc88a281410ffa7({ size: size, appearance: appearance = 'brand', label: label = 'Statuspage', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $2e7253800a69a3ff$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("4BlLF", function(module, exports) {
$parcel$export(module.exports, "StudioIcon", () => $e5a3c0db17cac8a9$export$290a0f24614cde9f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ab3266b216390c79d8a1dc3be47de23d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $e5a3c0db17cac8a9$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M10.594 18.563v-7.97h7.969v7.97zm3.808-6.488-.163.429c-.235.615-.352.922-.572 1.155s-.52.368-1.12.638l-.222.1v.357l.222.099c.6.27.9.405 1.12.638s.337.54.572 1.156l.163.428h.347l.163-.429c.235-.615.352-.922.572-1.155s.52-.368 1.12-.638l.221-.1v-.357l-.22-.1c-.601-.269-.901-.404-1.121-.637s-.337-.54-.572-1.155l-.164-.429z" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" d="M14.813 7.195 10.125 4.5 5.438 7.195v5.39l3.75 2.157V9.187h5.625z"/>
</svg>
`;
function $e5a3c0db17cac8a9$export$290a0f24614cde9f({ size: size, appearance: appearance = 'brand', label: label = 'Studio', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $e5a3c0db17cac8a9$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("kE2yc", function(module, exports) {
$parcel$export(module.exports, "StudioLogoCS", () => $5ac8e4fa7e3f8112$export$273fd56580e523ae);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f3562c122e709e76d7d20dd81b620288>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $5ac8e4fa7e3f8112$var$svg = `<svg height="100%" viewBox="0 0 124 32">
    <path fill="var(--text-color, #1e1f21)" d="M116.71 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.48-6.2c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-15.3-7.66c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-27.41-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M14.125 24.75V14.125H24.75V24.75zm5.078-8.65-.218.571c-.312.82-.469 1.23-.762 1.541s-.694.49-1.494.85l-.295.133v.476l.295.133c.8.36 1.2.54 1.494.85.293.311.45.721.762 1.541l.218.572h.462l.218-.572c.313-.82.469-1.23.762-1.54s.694-.491 1.494-.851l.295-.133v-.476l-.295-.132c-.8-.36-1.2-.54-1.494-.85-.293-.312-.45-.722-.762-1.542l-.218-.571z" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" d="M19.75 9.594 13.5 6 7.25 9.594v7.187l5 2.875V12.25h7.5z"/>
</svg>
`;
function $5ac8e4fa7e3f8112$export$273fd56580e523ae({ size: size, appearance: appearance = 'brand', label: label = 'Studio', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $5ac8e4fa7e3f8112$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5l8U4", function(module, exports) {
$parcel$export(module.exports, "TalentIcon", () => $b73c1d2cfcd579f1$export$4b05688514531169);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1d8fa09e3a068fb57474a844fe5ab56>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $b73c1d2cfcd579f1$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#fb9700)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m9.297 8.753 2.277-5.073h.858l2.277 5.073 5.529.598.265.816-4.121 3.734 1.14 5.442-.695.505-4.824-2.766-4.824 2.766-.695-.505 1.14-5.442-4.121-3.733.265-.817zm.777 6.415v-.678a1.857 1.857 0 0 1 3.715 0v.613a3.6 3.6 0 0 1-1.886.548h-.053a3.6 3.6 0 0 1-1.776-.483m1.858-3.134a1.393 1.393 0 1 0 0-2.786 1.393 1.393 0 0 0 0 2.786" clip-rule="evenodd"/>
</svg>
`;
function $b73c1d2cfcd579f1$export$4b05688514531169({ size: size, appearance: appearance = 'brand', label: label = 'Talent', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $b73c1d2cfcd579f1$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("levgb", function(module, exports) {
$parcel$export(module.exports, "TalentLogoCS", () => $7cf95649e7eaf168$export$1b3979d995ebbc6e);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4af27131cfc453f0f255c3cbe65f158e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $7cf95649e7eaf168$var$svg = `<svg height="100%" viewBox="0 0 122 32">
    <path fill="var(--text-color, #1e1f21)" d="M117.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H82.4c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-14.47.57c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z"/>
    <path fill="var(--tile-color,#fb9700)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="m16.577 4.907 3.035 6.763 7.372.797.354 1.09-5.495 4.977 1.52 7.257-.927.672-6.431-3.687-6.433 3.687-.926-.672 1.52-7.257-5.495-4.978.353-1.089 7.372-.797 3.035-6.763zm-.668 11.936a2.476 2.476 0 0 0-2.476 2.477v.904a4.8 4.8 0 0 0 2.369.644h.07a4.8 4.8 0 0 0 2.514-.73v-.818a2.477 2.477 0 0 0-2.477-2.477m0-4.511a1.857 1.857 0 1 0 0 3.714 1.857 1.857 0 0 0 0-3.714"/>
</svg>
`;
function $7cf95649e7eaf168$export$1b3979d995ebbc6e({ size: size, appearance: appearance = 'brand', label: label = 'Talent', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $7cf95649e7eaf168$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2Vvt8", function(module, exports) {
$parcel$export(module.exports, "TeamsIcon", () => $0484c9b9769dece9$export$1bcbc9c337da86da);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7cfe9311dc5f8070530ce9772b12f3fc>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $0484c9b9769dece9$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M8.06 11.25a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m7.88 0a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m.17 1.31a2.89 2.89 0 0 1 2.89 2.9V18h-7.22l1.66-3.67a2.89 2.89 0 0 1 2.67-1.77M5 15.63V18h4.81l1.31-2.81a2.63 2.63 0 0 0-2.62-2.63h-.44A3.06 3.06 0 0 0 5 15.63"/>
</svg>
`;
function $0484c9b9769dece9$export$1bcbc9c337da86da({ size: size, appearance: appearance = 'brand', label: label = 'Teams', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $0484c9b9769dece9$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5cWhH", function(module, exports) {
$parcel$export(module.exports, "TeamsLogoCS", () => $9ef46795d077639f$export$bfd8d1c4da84ce71);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a9a7a0d4583e5a9f22d08a0d2f6ac1f1>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $9ef46795d077639f$var$svg = `<svg height="100%" viewBox="0 0 127 32">
    <path fill="var(--text-color, #1e1f21)" d="M126.58 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-24.66-4.36v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.33.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM61.99 12.08c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H57.55c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M10.75 14.83a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m10.5 0a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.23 1.75a3.86 3.86 0 0 1 3.86 3.86v3.72h-9.62l2.21-5.23a3.86 3.86 0 0 1 3.55-2.35M6.67 20.67v3.5h6.42l1.75-4.08a3.5 3.5 0 0 0-3.5-3.5h-.58a4.08 4.08 0 0 0-4.08 4.08"/>
</svg>
`;
function $9ef46795d077639f$export$bfd8d1c4da84ce71({ size: size, appearance: appearance = 'brand', label: label = 'Teams', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $9ef46795d077639f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("HZylT", function(module, exports) {
$parcel$export(module.exports, "TrelloIcon", () => $94c29dad612da1a7$export$4384da9b8b140bf4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2fc7b25031952cd94704eefaa85d7de4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $7etaO = parcelRequire("7etaO");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $94c29dad612da1a7$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1558bc)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M9.39 18.23a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95H5.38a.95.95 0 0 0-.95.95v11.91c0 .52.42.95.95.95zm9.23-5.46a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95h-4.01a.95.95 0 0 0-.95.95v6.44c0 .52.42.95.95.95z"/>
</svg>
`;
const $94c29dad612da1a7$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.379 4.43a.95.95 0 0 0-.948.949v11.907c0 .523.424.948.948.948H9.39a.95.95 0 0 0 .947-.948V5.38a.95.95 0 0 0-.947-.948zm9.23 0a.95.95 0 0 0-.947.949v6.44c0 .523.423.948.947.949h4.012a.95.95 0 0 0 .948-.949V5.38a.95.95 0 0 0-.948-.948z"/>
</svg>
`;
function $94c29dad612da1a7$export$4384da9b8b140bf4({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label = 'Trello', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7etaO.IconWrapper), {
        svg: $94c29dad612da1a7$var$svg,
        customThemeSvg: $94c29dad612da1a7$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6Lx0d", function(module, exports) {
$parcel$export(module.exports, "TrelloLogoCS", () => $b56af57ef1234d0f$export$1b13139dfc0336af);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b73a20da143650f747e32cb182c99798>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $0ZCvD = parcelRequire("0ZCvD");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $b56af57ef1234d0f$var$svg = `<svg height="100%" viewBox="0 0 113 32">
    <path fill="var(--text-color, #1e1f21)" d="M104.97 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M96.21 25.3c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-8 0c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM72.86 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H68.42c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.48-8.44v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z"/>
    <path fill="var(--tile-color,#1558bc)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M12.9 24c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H8.13C7.51 8 7 8.49 7 9.1v13.8c0 .61.5 1.1 1.13 1.1zm10.97-6.34c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H19.1c-.62 0-1.13.49-1.13 1.1v7.47c0 .61.5 1.1 1.13 1.1z"/>
</svg>
`;
function $b56af57ef1234d0f$export$1b13139dfc0336af({ size: size, appearance: appearance = 'brand', label: label = 'Trello', testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $0ZCvD.LogoWrapper), {
        svg: $b56af57ef1234d0f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("fF7wm", function(module, exports) {
$parcel$export(module.exports, "createFeatureFlaggedServiceCollectionComponent", () => $675f7466dd6eb8e1$export$436fcf6e31fbacea);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $3X3Vo = parcelRequire("3X3Vo");
const $675f7466dd6eb8e1$export$436fcf6e31fbacea = (LegacyComponent, NewComponent)=>{
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return ({ size: size, shouldUseNewLogoDesign: shouldUseNewLogoDesign, ...props })=>{
        if ((0, $3X3Vo.fg)('platform-logo-rebrand') || shouldUseNewLogoDesign) // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, $2iln5.jsx)(NewComponent, {
            size: size || 'medium',
            ...props
        });
        return /*#__PURE__*/ (0, $2iln5.jsx)(LegacyComponent, {
            size: size,
            ...props
        });
    };
};

});

parcelRegister("jT0uL", function(module, exports) {
$parcel$export(module.exports, "AtlassianAdminIcon", () => $a9fe8440d24ae143$export$84109e099492cb5f);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $cA99x = parcelRequire("cA99x");
const $a9fe8440d24ae143$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cA99x.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">
      <path
        d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z"
        fill="${colors.iconColor}"
      />
    </svg>`;
};
const $a9fe8440d24ae143$export$84109e099492cb5f = ({ appearance: appearance, label: label = 'Atlassian Admin', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        svg: $a9fe8440d24ae143$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("d5gHq", function(module, exports) {
$parcel$export(module.exports, "AtlassianAdminLogo", () => $74561e8d48d23b8d$export$f845d9b9254f0541);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $cA99x = parcelRequire("cA99x");
const $74561e8d48d23b8d$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cA99x.getColorsFromAppearance)(appearance, colorMode);
    return `<svg
      fill="none"
      height="32"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 295 32"
      focusable="false"
      aria-hidden="true"
    >
      <path
        d="M294.31 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369"
        fill="${colors.textColor}"
      />
      <path
        d="M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z"
        fill="${colors.iconColor}"
      />
    </svg>`;
};
const $74561e8d48d23b8d$export$f845d9b9254f0541 = ({ appearance: appearance, label: label = 'Atlassian Admin', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $74561e8d48d23b8d$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("61rOV", function(module, exports) {
$parcel$export(module.exports, "AtlassianAdministrationIcon", () => $fc055680ba2c1613$export$74517ed253186308);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $cA99x = parcelRequire("cA99x");
const $fc055680ba2c1613$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cA99x.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">
      <path
        d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z"
        fill="${colors.iconColor}"
      />
    </svg>`;
};
const $fc055680ba2c1613$export$74517ed253186308 = ({ appearance: appearance, label: label = 'Atlassian Administration', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        svg: $fc055680ba2c1613$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("85T2t", function(module, exports) {
$parcel$export(module.exports, "AtlassianAdministrationLogo", () => $01e055a930e46f92$export$833abe6c2ce5ebfd);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $cA99x = parcelRequire("cA99x");
const $01e055a930e46f92$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cA99x.getColorsFromAppearance)(appearance, colorMode);
    return `<svg
      fill="none"
      height="32"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 404 32"
      focusable="false"
      aria-hidden="true"
    >
      <path
        d="M403.77 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-23.336 9.292c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.57 0 7.237 3.343 7.237 7.943s-2.667 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.489s1.442 5.55 4.723 5.55c3.251 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49zm-13.488-6.195c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-7.461-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.078v2.453h-4.078zm-18.943-2.913c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V10h2.637v15.333zm-17.793-9.046v9.046h-2.576V10h2.576v2.699c.89-1.81 2.423-3.098 5.428-2.914v2.576c-3.373-.337-5.428.675-5.428 3.926m-10.037 4.293c0 1.35.797 2.27 2.423 2.27.613 0 1.196-.123 1.656-.215v2.545c-.46.123-.982.245-1.779.245-3.281 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.079v2.453h-4.079zm-6.696.583c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.675-2.974 1.87 0 1.074.736 1.749 3.557 2.423 3.404.828 5.121 2.086 5.121 4.754M297.497 5.952c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-3.678-8.985v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369"
        fill="${colors.textColor}"
      />
      <path
        d="M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z"
        fill="${colors.iconColor}"
      />
    </svg>`;
};
const $01e055a930e46f92$export$833abe6c2ce5ebfd = ({ appearance: appearance, label: label = 'Atlassian Administration', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $01e055a930e46f92$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("5fq1G", function(module, exports) {
$parcel$export(module.exports, "AtlassianAnalyticsIcon", () => $1f4756525dc01c85$export$c42ad8a0b925c762);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $fEY94 = parcelRequire("fEY94");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $cDSKq = parcelRequire("cDSKq");
const $1f4756525dc01c85$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode, id)=>{
    let colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cDSKq.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return `<svg height="32" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="${id}-a" x1="12.595" x2="12.595" y1="40" y2="30" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="${colors.iconGradientStart}"/>
      <stop offset="1" stop-color="${colors.iconGradientStop}"/>
    </linearGradient>
    <linearGradient id="${id}-b" x1="28.595" x2="28.595" y1="40" y2="27" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="${colors.iconGradientStart}"/>
      <stop offset="1" stop-color="${colors.iconGradientStop}"/>
    </linearGradient>
    <linearGradient xlink:href="#${id}-b" id="${id}-c" x1="20.595" x2="20.595" y2="22"/>
    <linearGradient xlink:href="#${id}-b" id="${id}-d" x1="36.595" x2="36.595" y2="20"/>
  </defs>
  <path d="M10.595 30h4v10h-4z" fill="url(#${id}-a)"/>
  <path d="M26.595 27h4v13h-4z" fill="url(#${id}-b)"/>
  <path d="M18.595 22h4v18h-4z" fill="url(#${id}-c)"/>
  <path d="M34.595 20h4v20h-4z" fill="url(#${id}-d)"/>
  <path fill="${colors.iconColor}" d="m9.009 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z" />
</svg>`;
};
const $1f4756525dc01c85$export$c42ad8a0b925c762 = ({ appearance: appearance, label: label = 'Atlassian Analytics', size: size = (0, $81ATr.defaultLogoParams).size, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor, testId: testId })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    const id = (0, $fEY94.useId)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        label: label,
        svg: $1f4756525dc01c85$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};

});
parcelRegister("fEY94", function(module, exports) {
$parcel$export(module.exports, "useId", () => $ac482933f9efee26$export$f680877a34711e37);

var $4tluv = parcelRequire("4tluv");
function $ac482933f9efee26$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).useId().replace(/[:«»]/g, '_');
}

});

parcelRegister("cDSKq", function(module, exports) {
$parcel$export(module.exports, "getColorsFromAppearanceOldLogos", () => $fc0f23589a91b57d$export$362a25f017e2bc8a);
// TODO: This is where we need to add tokens for all appearance color values
const $fc0f23589a91b57d$export$362a25f017e2bc8a = (appearance, colorMode)=>{
    let iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case 'brand':
            iconGradientStart = '#0052CC';
            iconGradientStop = '#2684FF';
            iconColor = '#2684FF';
            textColor = "var(--ds-text, #292A2E)";
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = '#0052CC';
            break;
        case 'neutral':
            iconGradientStart = '#344563';
            iconGradientStop = '#7A869A';
            iconColor = '#7A869A';
            textColor = '#505F79';
            atlassianLogoTextColor = '#505F79';
            break;
        case 'inverse':
            iconGradientStart = '#FFFFFF66';
            iconGradientStop = '#FFFFFF';
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    if (colorMode === 'dark' && appearance === 'inverse') {
        iconGradientStart = '#161A1D66';
        iconGradientStop = '#161A1D';
        iconColor = '#161A1D';
        textColor = '#161A1D';
        atlassianLogoTextColor = '#161A1D';
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};

});


parcelRegister("lF1fo", function(module, exports) {
$parcel$export(module.exports, "AtlassianAnalyticsLogo", () => $bb01761078759918$export$e6470bfc39010cc4);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $fEY94 = parcelRequire("fEY94");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $cDSKq = parcelRequire("cDSKq");
const $bb01761078759918$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode, id)=>{
    let colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        textColor: textColor,
        iconColor: iconColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $cDSKq.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return `
  <svg height="32" viewBox="0 0 477 48" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="${id}-a" x1="447.285" x2="447.285" y1="40" y2="30" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="${colors.iconGradientStart}"/>
      <stop offset="1" stop-color="${colors.iconGradientStop}"/>
    </linearGradient>
    <linearGradient xlink:href="#${id}-a" id="${id}-b" x1="463.285" x2="463.285" y2="27"/>
    <linearGradient xlink:href="#${id}-a" id="${id}-c" x1="455.285" x2="455.285" y2="22"/>
    <linearGradient xlink:href="#${id}-a" id="${id}-d" x1="471.285" x2="471.285" y2="20"/>
  </defs>
  <g fill="${colors.atlassianLogoTextColor}">
    <path d="M106.72 18.359c0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835m0 0c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445M209.1 10.346v28.455h6.063V17.103l2.556 5.76 8.575 15.938h7.623V10.346h-6.064V28.71l-2.295-5.327-6.886-13.037H209.1zM163.909 10.346h6.626v28.455h-6.626zM156.263 30.399c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445 0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835M55.243 10.346v28.455h13.62l2.145-6.15h-9.095V10.346h-6.67zM28.334 10.346v6.15h7.363v22.305h6.67V16.496h7.882v-6.15H28.334zM18.663 10.346h-8.74L0 38.801h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM92.344 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM194.414 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524Z"/>
  </g>
  <g fill="${colors.textColor}">
    <path d="m254.776 31.987-2.53 6.809H247.6l11.916-30.225h5.244l11.916 30.225h-4.646l-2.53-6.855c-2.714.552-5.061.828-7.499.828-2.3 0-4.646-.276-7.223-.782Zm13.479-3.496-6.119-16.562-6.119 16.608c2.254.368 4.141.552 5.98.552 1.933 0 3.911-.23 6.257-.598ZM298.984 38.796h-3.957V24.902c0-4.141-1.656-5.981-5.428-5.981-3.681 0-6.211 2.438-6.211 7.085v12.79h-3.957V15.794h3.957v3.772c1.472-2.715 4.187-4.232 7.269-4.232 5.291 0 8.327 3.634 8.327 9.983v13.479ZM320.097 34.656c-1.472 3.036-4.232 4.6-7.775 4.6-6.119 0-9.201-5.199-9.201-11.961 0-6.486 3.22-11.961 9.661-11.961 3.358 0 5.935 1.518 7.314 4.508v-4.048h3.957v23.002h-3.957v-4.14Zm-6.717.92c3.542 0 6.717-2.254 6.717-7.361v-1.84c0-5.106-2.898-7.361-6.256-7.361-4.463 0-6.763 2.944-6.763 8.281 0 5.521 2.208 8.281 6.303 8.281ZM336.196 38.935c-3.772 0-6.165-1.794-6.165-6.027V6.179h3.957v26.269c0 2.07 1.38 2.806 3.083 2.806.414 0 .69 0 1.15-.046v3.542c-.322.092-1.012.184-2.024.184ZM347.328 37.324l-8.327-21.53h4.232l7.361 19.69 7.361-19.69h4.232l-8.695 22.267c-2.576 6.579-4.048 9.983-9.891 9.983-1.979 0-3.083-.184-4.232-.644v-3.404c1.334.414 2.852.552 4.002.552 3.22 0 4.646-2.208 6.533-7.223h-2.576ZM374.698 35.07c.92 0 1.794-.185 2.484-.322v3.818c-.69.184-1.472.368-2.668.368-4.923 0-7.315-2.898-7.315-7.177V19.473h-3.727v-3.68h3.727v-4.877h3.864v4.877h6.119v3.68h-6.119v12.191c0 2.024 1.196 3.405 3.635 3.405ZM384.265 6.961c1.61 0 2.76 1.012 2.76 2.76s-1.15 2.76-2.76 2.76-2.76-1.012-2.76-2.76 1.15-2.76 2.76-2.76Zm-2.024 8.833h3.957v23.002h-3.957V15.794ZM408.416 38.198c-1.38.736-3.496 1.058-5.612 1.058-8.189 0-12.007-4.968-12.007-12.007 0-6.947 3.818-11.915 12.007-11.915 2.07 0 3.68.276 5.475 1.104v3.681c-1.472-.69-3.037-1.104-5.199-1.104-5.98 0-8.419 3.772-8.419 8.235s2.484 8.235 8.511 8.235c2.346 0 3.818-.322 5.244-.828v3.542ZM420.144 39.256c-3.451 0-6.257-.782-8.005-1.702v-4.187c1.978 1.15 5.291 2.254 8.188 2.254 3.037 0 4.601-1.242 4.601-3.036 0-1.749-1.334-2.761-5.705-3.818-5.106-1.242-7.269-3.221-7.269-6.993 0-4.002 3.082-6.44 8.327-6.44 2.99 0 5.705.736 7.407 1.656v4.094c-2.76-1.38-5.014-2.117-7.453-2.117-2.898 0-4.462 1.013-4.462 2.807 0 1.61 1.104 2.622 5.336 3.635 5.106 1.242 7.683 3.128 7.683 7.13 0 3.819-2.484 6.717-8.649 6.717Z"/>
  </g>
  <path fill="url(#${id}-a)" d="M445.285 30h4v10h-4z"/>
  <path fill="url(#${id}-b)" d="M461.285 27h4v13h-4z"/>
  <path fill="url(#${id}-c)" d="M453.285 22h4v18h-4z"/>
  <path fill="url(#${id}-d)" d="M469.285 20h4v20h-4z"/>
  <path fill="${colors.iconColor}" d="m443.699 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z"/>
</svg>`;
};
const $bb01761078759918$export$e6470bfc39010cc4 = ({ appearance: appearance, label: label = 'Atlassian Analytics', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    const id = (0, $fEY94.useId)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        label: label,
        size: size,
        iconColor: iconColor,
        svg: $bb01761078759918$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode, id),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("2zbIm", function(module, exports) {
$parcel$export(module.exports, "BitbucketIcon", () => $ba6b82a9d984574f$export$5fc1066e677788d4);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $cA99x = parcelRequire("cA99x");
const $ba6b82a9d984574f$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cA99x.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95"/>
    </svg>`;
};
const $ba6b82a9d984574f$export$5fc1066e677788d4 = ({ appearance: appearance, label: label = 'Bitbucket', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        label: label,
        svg: $ba6b82a9d984574f$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("3YNS7", function(module, exports) {
$parcel$export(module.exports, "BitbucketLogo", () => $17fffb1ee97deeb2$export$bd40525f5333524b);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $cA99x = parcelRequire("cA99x");
const $17fffb1ee97deeb2$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cA99x.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 158 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
        <path fill=${colors.iconColor} d="m20.46 15.152-1.619 9.885c-.105.598-.527.95-1.125.95H3.996c-.599 0-1.02-.352-1.126-.95L.02 7.412c-.105-.598.211-.985.774-.985h20.123c.563 0 .88.387.774.985l-.774 4.644c-.106.668-.493.95-1.126.95H7.69c-.176 0-.281.105-.246.316l.95 5.84c.035.141.14.247.281.247h4.363c.14 0 .246-.106.281-.247l.668-4.221c.07-.528.423-.739.915-.739h4.75c.703 0 .914.352.809.95"/>
        <path fill=${colors.textColor} d="M153.212 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-13.537-8.494c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-23.82.613h-2.638V3.799h2.638v13.585l6.593-7.176h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.176zm-5.648-2.76v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-27.843-3.588v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.982 1.81-2.79 2.821-4.846 2.821-3.526 0-5.55-2.422-5.55-6.654m-5.388-1.319c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.699h-2.637V3.798h2.637v9.17c.982-2.025 2.822-3.067 5.183-3.067 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-14.974-5.06c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zM53.328 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S56.242 8 55.168 8s-1.84-.676-1.84-1.84m.49 19.38V10.207h2.638V25.54zm-9.828-9.046h-6.194v6.287h6.256c2.637 0 3.833-.951 3.833-2.975 0-2.147-1.134-3.312-3.894-3.312m-.889-8.464h-5.305v6.01h5.305c2.607 0 3.68-1.195 3.68-3.127 0-1.963-1.165-2.883-3.68-2.883m-8.065 17.51V5.394h8.433c4.11 0 6.103 2.024 6.103 5.274 0 2.423-1.104 3.926-3.373 4.478 2.974.49 4.446 2.116 4.446 4.968 0 3.22-2.177 5.428-6.685 5.428z"/>
      </svg>`;
};
const $17fffb1ee97deeb2$export$bd40525f5333524b = ({ appearance: appearance, label: label = 'Bitbucket', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $17fffb1ee97deeb2$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("f3vw4", function(module, exports) {
$parcel$export(module.exports, "CompassIcon", () => $e70d6011a0995283$export$f7857fe64d7161d9);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $cA99x = parcelRequire("cA99x");
const $e70d6011a0995283$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cA99x.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M15.667 15.66v5.942H9.713V15.66zV9.722H4.807c-.58.004-1.047.47-1.043 1.04v15.755a1.04 1.04 0 0 0 1.028 1.054h15.771a1.04 1.04 0 0 0 1.042-1.04V15.66zm0-11.88v5.942h5.967v5.938h5.935V4.82a1.04 1.04 0 0 0-1.028-1.053h-.014z"/>
      </svg>
    `;
};
const $e70d6011a0995283$export$f7857fe64d7161d9 = ({ appearance: appearance, label: label = 'Compass', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        label: label,
        svg: $e70d6011a0995283$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("6K9JY", function(module, exports) {
$parcel$export(module.exports, "CompassLogo", () => $3281ddd2179fbd88$export$eb7d748e4f9c9676);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $cA99x = parcelRequire("cA99x");
const $3281ddd2179fbd88$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cA99x.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 155 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
    <path fill=${colors.iconColor} d="M11.903 14.993v5.942H5.95v-5.942zV9.055H1.043c-.58.004-1.047.47-1.043 1.04v15.756a1.04 1.04 0 0 0 1.028 1.054H16.8a1.04 1.04 0 0 0 1.043-1.04V14.993zm0-11.879v5.941h5.967v5.938h5.936V4.153A1.04 1.04 0 0 0 22.778 3.1h-.015z"/>
    <path fill="${colors.textColor}" d="M154.46 21.37c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.134v-2.791c1.318.767 3.526 1.503 5.458 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.889-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-13.626 0c0 2.545-1.656 4.477-5.766 4.477-2.3 0-4.17-.521-5.336-1.134v-2.791c1.319.767 3.527 1.503 5.459 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.89-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.054-4.293 5.55-4.293 1.994 0 3.803.49 4.938 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.122 2.085 5.122 4.753m-25.873-3.496c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.226c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638v15.334zm-16.09-7.667c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v8.679h-2.637V10.207h2.637v2.76c.982-2.024 2.822-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-21.583-8.832v8.526h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526H69.13V10.207h2.637v2.515c.982-1.81 2.791-2.821 4.846-2.821 2.606 0 4.385 1.318 5.152 3.741.858-2.361 2.913-3.741 5.458-3.741 3.435 0 5.336 2.33 5.336 6.654v8.986h-2.637v-8.526c0-3.158-1.104-4.722-3.619-4.722-2.453 0-4.14 1.625-4.14 4.722m-23.335 8.832c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.942 7.299-7.942c4.57 0 7.237 3.342 7.237 7.942s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49s1.441 5.55 4.723 5.55c3.25 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49m-9.233 9.629v2.668c-1.258.828-3.251 1.196-5.336 1.196-6.624 0-10.366-3.986-10.366-10.334 0-6.134 3.742-10.427 10.304-10.427 1.963 0 3.926.368 5.367 1.41v2.669c-1.441-.92-3.036-1.411-5.367-1.411-4.722 0-7.544 3.128-7.544 7.759s2.914 7.697 7.698 7.697c2.116 0 3.772-.49 5.244-1.227"/>
  </svg>`;
};
const $3281ddd2179fbd88$export$eb7d748e4f9c9676 = ({ appearance: appearance, label: label = 'Compass', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $3281ddd2179fbd88$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("7pfuQ", function(module, exports) {
$parcel$export(module.exports, "ConfluenceLogo", () => $5e8225d17b8eb36c$export$1b2e4fe6ef471556);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $cA99x = parcelRequire("cA99x");
const $5e8225d17b8eb36c$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cA99x.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 180 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M20.602 20.234c-6.584-3.183-8.507-3.66-11.281-3.66-3.255 0-6.03 1.355-8.507 5.16l-.407.622c-.333.513-.407.696-.407.915s.111.403.518.659l4.18 2.598c.221.146.406.22.591.22.222 0 .37-.11.592-.44l.666-1.024c1.035-1.574 1.96-2.086 3.144-2.086 1.035 0 2.256.293 3.772 1.025l4.365 2.049c.444.22.925.11 1.146-.403l2.072-4.537c.222-.512.074-.842-.444-1.098M1.406 12.22c6.583 3.184 8.507 3.66 11.28 3.66 3.256 0 6.03-1.354 8.508-5.16l.407-.622c.332-.512.406-.695.406-.915s-.11-.402-.518-.658L17.31 5.927c-.222-.147-.407-.22-.592-.22-.222 0-.37.11-.592.44l-.665 1.024c-1.036 1.573-1.96 2.086-3.144 2.086-1.036 0-2.257-.293-3.773-1.025L4.18 6.183c-.444-.22-.925-.11-1.147.402L.962 11.123c-.222.512-.074.841.444 1.098"/>
      <path fill="${colors.textColor}" d="M172.49 12.293c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-15.093-2.147v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-14.503-6.226v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.791-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-22.921-4.262c-2.79 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.441-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.942 7.237-7.942 4.723 0 6.624 3.281 6.624 7.942v1.196h-11.193c.368 2.607 2.054 4.294 5.673 4.294 1.778 0 3.281-.338 4.661-.828zm-29.1-5.734v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.981 1.81-2.791 2.821-4.845 2.821-3.527 0-5.551-2.422-5.551-6.654m-2.231 6.317c-.215.061-.674.122-1.35.122-2.514 0-4.108-1.196-4.108-4.017V3.798h2.637v17.51c0 1.38.92 1.871 2.055 1.871.275 0 .459 0 .766-.03zM88.157 8.582v1.625h3.956v2.454h-3.956v12.88h-2.576V12.66h-2.484v-2.454h2.484V8.521c0-2.852 1.595-4.784 4.876-4.784a6.3 6.3 0 0 1 1.779.245v2.423a8.7 8.7 0 0 0-1.656-.154c-1.626 0-2.423.95-2.423 2.33m-7.327 7.974v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-23.336 9.292c-4.6 0-7.298-3.404-7.298-8.004s2.698-7.942 7.298-7.942c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.493c-3.28 0-4.722 2.576-4.722 5.49s1.441 5.55 4.722 5.55c3.251 0 4.662-2.637 4.662-5.55s-1.41-5.49-4.662-5.49m-9.233 9.629v2.668c-1.257.828-3.25 1.196-5.336 1.196-6.624 0-10.365-3.986-10.365-10.334 0-6.134 3.741-10.427 10.304-10.427 1.963 0 3.925.368 5.367 1.41v2.669c-1.442-.92-3.036-1.411-5.367-1.411-4.723 0-7.544 3.128-7.544 7.759s2.913 7.697 7.697 7.697c2.116 0 3.772-.49 5.244-1.227"/>
    </svg>
    `;
};
const $5e8225d17b8eb36c$export$1b2e4fe6ef471556 = ({ appearance: appearance, label: label = 'Confluence', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $5e8225d17b8eb36c$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("ePtT5", function(module, exports) {
$parcel$export(module.exports, "FocusIcon", () => $f5732fbcf355e6a4$export$1e02e7298035a77c);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $cA99x = parcelRequire("cA99x");
const $f5732fbcf355e6a4$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cA99x.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 48 48" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
		<path fill="${colors.iconColor}" d="M45.4277 24.5018C41.4108 20.4849 34.8821 20.5276 30.908 24.5018L27.5636 27.8462C25.717 29.6927 22.7177 29.6927 20.8712 27.8462L18.0925 25.0675L10.8309 32.3291L13.6096 35.1078C19.4658 40.9641 28.9654 40.9641 34.8216 35.1078L45.4277 24.5018ZM3 23.5018C7.01684 27.5186 13.4637 27.5578 17.4805 23.5409L20.8676 20.1538C22.7142 18.3073 25.7135 18.3073 27.56 20.1538L30.3387 22.9325L37.6003 15.6709L34.8216 12.8922C28.9654 7.03593 19.4658 7.03593 13.6096 12.8922L3.00356 23.4982L3 23.5018Z"/>
		</svg>
		`;
};
const $f5732fbcf355e6a4$export$1e02e7298035a77c = ({ appearance: appearance, label: label = 'Focus', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        label: label,
        svg: $f5732fbcf355e6a4$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("4cxnt", function(module, exports) {
$parcel$export(module.exports, "FocusLogo", () => $df45ab52b531a304$export$33908560ea1b226d);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $cA99x = parcelRequire("cA99x");
const $df45ab52b531a304$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cA99x.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 168 48" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
		<path fill="${colors.iconColor}" d="M42.4277 24.5018C38.4108 20.4849 31.8821 20.5276 27.908 24.5018L24.5636 27.8462C22.717 29.6927 19.7177 29.6927 17.8712 27.8462L15.0925 25.0675L7.83088 32.3291L10.6096 35.1078C16.4658 40.9641 25.9654 40.9641 31.8216 35.1078L42.4277 24.5018ZM0 23.5018C4.01684 27.5186 10.4637 27.5578 14.4805 23.5409L17.8676 20.1538C19.7142 18.3073 22.7135 18.3073 24.56 20.1538L27.3387 22.9325L34.6003 15.6709L31.8216 12.8922C25.9654 7.03593 16.4658 7.03593 10.6096 12.8922L0.00355592 23.4982L0 23.5018Z"/>
		<path fill="${colors.textColor}" d="M167.405 31.746C167.405 35.564 164.921 38.462 158.757 38.462C155.307 38.462 152.501 37.68 150.753 36.76V32.574C152.731 33.724 156.043 34.828 158.941 34.828C161.977 34.828 163.541 33.586 163.541 31.792C163.541 30.044 162.207 29.032 157.837 27.974C152.731 26.732 150.569 24.754 150.569 20.982C150.569 16.98 153.651 14.542 158.895 14.542C161.885 14.542 164.599 15.278 166.301 16.198V20.292C163.541 18.912 161.287 18.176 158.849 18.176C155.951 18.176 154.387 19.188 154.387 20.982C154.387 22.592 155.491 23.604 159.723 24.616C164.829 25.858 167.405 27.744 167.405 31.746Z"/>
		<path fill="${colors.textColor}" d="M126.009 28.48V15.002H129.965V28.894C129.965 33.034 131.621 34.874 135.393 34.874C139.073 34.874 141.603 32.436 141.603 27.79V15.002H145.559V38.002H141.603V34.23C140.131 36.944 137.417 38.462 134.335 38.462C129.045 38.462 126.009 34.828 126.009 28.48Z"/>
		<path fill="${colors.textColor}" d="M121.953 33.862V37.404C120.573 38.14 118.457 38.462 116.341 38.462C108.153 38.462 104.335 33.494 104.335 26.456C104.335 19.51 108.153 14.542 116.341 14.542C118.411 14.542 120.021 14.818 121.815 15.646V19.326C120.343 18.636 118.779 18.222 116.617 18.222C110.637 18.222 108.199 21.994 108.199 26.456C108.199 30.918 110.683 34.69 116.709 34.69C119.055 34.69 120.527 34.368 121.953 33.862Z"/>
		<path fill="${colors.textColor}" d="M90.2616 38.462C83.3616 38.462 79.3136 33.356 79.3136 26.456C79.3136 19.556 83.3616 14.542 90.2616 14.542C97.1156 14.542 101.118 19.556 101.118 26.456C101.118 33.356 97.1156 38.462 90.2616 38.462ZM90.2616 18.222C85.3396 18.222 83.1776 22.086 83.1776 26.456C83.1776 30.826 85.3396 34.782 90.2616 34.782C95.1376 34.782 97.2536 30.826 97.2536 26.456C97.2536 22.086 95.1376 18.222 90.2616 18.222Z"/>
		<path fill="${colors.textColor}" d="M75.298 26.732H61.59V38.002H57.45V7.78003H76.862V11.736H61.59V22.776H75.298V26.732Z"/>
		</svg>
		`;
};
const $df45ab52b531a304$export$33908560ea1b226d = ({ appearance: appearance, label: label = 'Focus', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $df45ab52b531a304$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("jMadJ", function(module, exports) {
$parcel$export(module.exports, "GuardIcon", () => $5989fd3fcd393fe9$export$3f95fcfdc25a741d);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $cA99x = parcelRequire("cA99x");
const $5989fd3fcd393fe9$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cA99x.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">
      <path
        d="M5.584 14.4h20.83c.599 0 .918-.32.918-.918V6.459c0-.599-.319-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v7.023c0 .599.319.918.917.918zm.36 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.199-.799.758-.799h20.191c.559 0 .798.24.798.719q-.12 2.214-.838 4.07c-.24.638-.598.918-1.277.918H7.221c-.679 0-1.038-.28-1.277-.918m18.475 3.312c-1.915 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.478-.638-.239-1.038.24-1.038h16.44c.48 0 .719.4.2 1.038"
        fill="${colors.iconColor}"
      />
    </svg>`;
};
const $5989fd3fcd393fe9$export$3f95fcfdc25a741d = ({ appearance: appearance, label: label = 'Guard', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        svg: $5989fd3fcd393fe9$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("2vKx9", function(module, exports) {
$parcel$export(module.exports, "GuardLogo", () => $ac88e00cc797da6e$export$a4a891d202775deb);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $cA99x = parcelRequire("cA99x");
const $ac88e00cc797da6e$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cA99x.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 114 32" focusable="false" aria-hidden="true">
      <path
        d="M.918 13.733h20.83c.598 0 .918-.32.918-.918V5.792c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.918.32-.918.918v3.551h-1.995V5.792c0-.599-.319-.918-.918-.918H9.139c-.599 0-.918.32-.918.918v3.551H6.225V5.792c0-.599-.32-.918-.918-.918H.917c-.598 0-.917.32-.917.918v7.023c0 .599.32.918.918.918m.359 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.2-.799.758-.799h20.191c.56 0 .799.24.799.719q-.12 2.214-.838 4.07c-.24.638-.599.918-1.277.918H2.554c-.679 0-1.038-.28-1.277-.918m18.476 3.312c-1.916 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.479-.638-.24-1.038.24-1.038h16.44c.479 0 .718.4.2 1.038"
        fill="${colors.iconColor}"
      />
      <path
        d="M102.398 17.874c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.502 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52zm8.679 7.667v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.466-6.133-7.974 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005V3.798h2.637v21.743zm-17.793-9.047v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925m-17.869 1.381c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.976 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.637v15.333zM56.68 19.193v-8.985h2.637v9.261c0 2.76 1.105 3.987 3.62 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637v15.333h-2.638v-2.514c-.981 1.809-2.79 2.821-4.845 2.821-3.527 0-5.55-2.423-5.55-6.655zm-3.973 5.213c-1.595.951-4.539 1.442-6.808 1.442-6.931 0-10.672-4.232-10.672-10.335 0-6.563 4.262-10.457 11.438-10.457 1.595 0 3.466.184 5.244.797v2.76c-1.533-.613-3.342-.89-5.213-.89-5.98 0-8.71 2.975-8.71 7.729 0 4.661 2.76 7.758 8.557 7.758.95 0 2.269-.092 3.404-.429v-5.612h-5.152v-2.637h7.912z"
        fill="${colors.textColor}"
      />
    </svg>`;
};
const $ac88e00cc797da6e$export$a4a891d202775deb = ({ appearance: appearance, label: label = 'Guard', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $ac88e00cc797da6e$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("b1FkN", function(module, exports) {
$parcel$export(module.exports, "JiraIcon", () => $f571eec3d7747f31$export$c4b5b1f965d8b3eb);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $cA99x = parcelRequire("cA99x");
const $f571eec3d7747f31$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cA99x.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M11.034 21.99h-2.22c-3.346 0-5.747-2.05-5.747-5.052h11.932c.619 0 1.019.44 1.019 1.062v12.007c-2.983 0-4.984-2.416-4.984-5.784zm5.893-5.967h-2.219c-3.347 0-5.748-2.013-5.748-5.015h11.933c.618 0 1.055.402 1.055 1.025V24.04c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.219c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.018.439 1.018 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>
    </svg>`;
};
const $f571eec3d7747f31$export$c4b5b1f965d8b3eb = ({ appearance: appearance, label: label = 'Jira', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        label: label,
        svg: $f571eec3d7747f31$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("9fpp5", function(module, exports) {
$parcel$export(module.exports, "JiraLogo", () => $36f9a6895d485130$export$17d3acb0b4379d02);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $cA99x = parcelRequire("cA99x");
const $36f9a6895d485130$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cA99x.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 77 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M7.967 21.323H5.748C2.401 21.323 0 19.273 0 16.271h11.933c.618 0 1.018.44 1.018 1.062V29.34c-2.983 0-4.984-2.416-4.984-5.784zm5.894-5.967h-2.22c-3.346 0-5.747-2.013-5.747-5.015h11.932c.618 0 1.055.402 1.055 1.025v12.007c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.22c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.019.439 1.019 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>
      <path fill="${colors.textColor}" d="M65.023 17.874c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM55.91 16.493v9.047h-2.577V10.207h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M46.224 6.159c0-1.165.767-1.84 1.84-1.84s1.84.675 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.49 19.381V10.207h2.638V25.54zm-6.427-5.95V5.393h2.76v14.015c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.246-3.312-.522v-2.668c.828.338 1.84.522 2.852.522 2.33 0 3.128-1.41 3.128-3.404"/>
    </svg>`;
};
const $36f9a6895d485130$export$17d3acb0b4379d02 = ({ appearance: appearance, label: label = 'Jira', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $36f9a6895d485130$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("1zfwo", function(module, exports) {
$parcel$export(module.exports, "JiraAlignIcon", () => $4e735e39b6338153$export$407687b2dd89cc68);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $cA99x = parcelRequire("cA99x");
const $4e735e39b6338153$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cA99x.getColorsFromAppearance)(appearance, colorMode);
    return `<svg viewBox="0 0 32 32" focusable="false" aria-hidden="true" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="${colors.iconColor}"
      d="M25.52 25.727c0-3.604-2.949-6.517-6.517-6.517h-6.007v-5.497H6.48v10.813c0 .837.364 1.201 1.201 1.201zM6.48 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z"
    />
  </svg>`;
};
const $4e735e39b6338153$export$407687b2dd89cc68 = ({ appearance: appearance, label: label = 'Jira Align', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        label: label,
        svg: $4e735e39b6338153$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("dJnFy", function(module, exports) {
$parcel$export(module.exports, "JiraAlignLogo", () => $6a35069ac21a3194$export$ee11e928d3d045fd);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $cA99x = parcelRequire("cA99x");
const $6a35069ac21a3194$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cA99x.getColorsFromAppearance)(appearance, colorMode);
    return `<svg viewBox="0 0 146 32" focusable="false" aria-hidden="true" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.04 25.727c0-3.604-2.949-6.517-6.517-6.517H6.517v-5.497H0v10.813c0 .837.364 1.201 1.201 1.201zM0 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z" fill="${colors.iconColor}"/>
      <path d="M144.993 16.555v8.985h-2.638v-9.26c0-2.76-1.104-3.988-3.618-3.988-2.454 0-4.14 1.626-4.14 4.723v8.525h-2.638V10.207h2.638v2.515c.981-1.81 2.79-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-19.589 7.759V22.78c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.465-6.072-7.973 0-4.324 2.116-7.974 6.379-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.054 5.152-4.906m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.975 0-4.508 1.962-4.508 5.52M107.96 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S110.873 8 109.8 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.638Zm-2.537-.03c-.215.061-.675.122-1.349.122-2.515 0-4.11-1.196-4.11-4.017V3.798h2.638v17.51c0 1.38.92 1.871 2.054 1.871.276 0 .46 0 .767-.03v2.36ZM88.83 21.523c-1.534 0-3.098-.184-4.815-.521l-1.687 4.539h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.57c-1.81.368-3.373.552-4.999.552Zm0-2.453c1.287 0 2.606-.153 4.17-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369Zm-27.807-1.196c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925ZM42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.637Zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404" fill="${colors.textColor}"/>
    </svg>
  `;
};
const $6a35069ac21a3194$export$ee11e928d3d045fd = ({ appearance: appearance, label: label = 'Jira Align', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $6a35069ac21a3194$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("jLwoL", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryIcon", () => $f0f33f3aaa9eaf8a$export$21bfbeb62fdcce8d);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $cA99x = parcelRequire("cA99x");
const $f0f33f3aaa9eaf8a$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cA99x.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M17.655 5.884a15.3 15.3 0 0 0 8.75 0c.257-.056.428.114.37.37-.826 2.985-.826 5.742 0 8.727.058.228-.113.427-.37.342a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.342.77-2.985.77-5.742 0-8.727-.086-.256.114-.426.342-.37m1.169 10.576v.483c0 2.246-1.568 3.894-3.506 3.894a3.474 3.474 0 0 1-3.477-3.496c0-1.933 1.567-3.468 3.762-3.468h.57V7.078c-.285-.028-.57-.028-.855-.028C9.618 7.05 5 11.655 5 17.37c0 5.713 4.617 10.29 10.318 10.29s10.346-4.605 10.346-10.29v-.91z"/>
    </svg>`;
};
const $f0f33f3aaa9eaf8a$export$21bfbeb62fdcce8d = ({ appearance: appearance, label: label = 'Jira Product Discovery', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        label: label,
        svg: $f0f33f3aaa9eaf8a$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("aahZp", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryLogo", () => $9390c178f2cbd1a5$export$c49a2b642fe9eef4);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $cA99x = parcelRequire("cA99x");
const $9390c178f2cbd1a5$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cA99x.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 318 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M12.655 5.218a15.3 15.3 0 0 0 8.75 0c.257-.057.428.114.37.37-.826 2.984-.826 5.742 0 8.727.058.227-.113.426-.37.341a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.341.77-2.985.77-5.743 0-8.727-.086-.256.114-.427.342-.37m1.169 10.575v.483c0 2.246-1.568 3.895-3.506 3.895a3.474 3.474 0 0 1-3.478-3.497c0-1.933 1.568-3.468 3.763-3.468h.57V6.412c-.285-.028-.57-.028-.855-.028C4.618 6.384 0 10.989 0 16.703s4.617 10.29 10.318 10.29 10.346-4.605 10.346-10.29v-.91z" />
      <path fill="${colors.textColor}" d="M308.551 24.559h-1.718l-5.55-14.352h2.821l4.907 13.125 4.906-13.125h2.822l-5.796 14.843c-1.718 4.385-2.699 6.654-6.594 6.654-1.318 0-2.054-.122-2.821-.429v-2.27c.889.277 1.901.369 2.668.369 2.147 0 3.097-1.472 4.355-4.815m-13.247-8.065v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.422-3.097 5.428-2.913v2.576c-3.374-.338-5.428.674-5.428 3.925m-12.464-4.202c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-19.717.613h-3.527l-5.949-15.333h2.76l4.968 13.095 4.937-13.095h2.76zm-17.462.307c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.49 0 2.912 1.442 5.55 4.723 5.55 3.251 0 4.661-2.638 4.661-5.55 0-2.914-1.41-5.49-4.661-5.49M242.16 22.78v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-13.872-1.41c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.41-4.968-1.41-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.422 3.404.828 5.121 2.086 5.121 4.754M210.599 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.491 19.38V10.208h2.637v15.334zM198.344 8.03h-4.539v14.873h4.692c4.6 0 6.9-2.422 6.9-7.298 0-4.907-2.177-7.575-7.053-7.575m-7.299 17.51V5.394h7.422c6.532 0 9.69 4.078 9.69 10.12 0 6.102-3.189 10.028-9.69 10.028zm-13.411-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-6.66 1.993v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-27.843-3.588v-8.985h2.637v9.261c0 2.76 1.104 3.987 3.619 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637V25.54h-2.637v-2.514c-.982 1.809-2.791 2.821-4.846 2.821-3.526 0-5.55-2.423-5.55-6.655m-14.987-1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.667v-2.76c-.981 2.023-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005V3.798h2.637V25.54zm-20.698.306c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49 0 2.912 1.441 5.55 4.723 5.55 3.25 0 4.661-2.638 4.661-5.55 0-2.914-1.411-5.49-4.661-5.49m-13.776 4.14v9.047h-2.576V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-5.002-4.385c0 4.385-2.454 6.838-7.483 6.838h-4.017v6.594h-2.76V5.393h6.777c5.03 0 7.483 2.576 7.483 6.716m-7.79 4.2c3.558.124 4.938-1.563 4.938-4.14 0-2.452-1.38-4.14-4.938-4.14h-3.71v8.28zM61.69 17.874c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.931-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.24 0 3.957 1.012 4.877 3.006v-2.699h2.637V25.54zm-17.793-9.046v9.047H50V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.89 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.805 8 44.73 8s-1.84-.675-1.84-1.84m.491 19.38V10.208h2.638v15.334zm-6.428-5.949V5.393h2.76v14.014c0 3.71-1.625 6.256-5.428 6.256-1.441 0-2.545-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.331 0 3.128-1.41 3.128-3.404" />
    </svg>`;
};
const $9390c178f2cbd1a5$export$c49a2b642fe9eef4 = ({ appearance: appearance, label: label = 'Jira Product Discovery', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $9390c178f2cbd1a5$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("7txS1", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementIcon", () => $5c7c601d2a74ca78$export$3c6158790f5e01c4);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $cA99x = parcelRequire("cA99x");
const $5c7c601d2a74ca78$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cA99x.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="M18.79 13.257h7.325c1.1 0 1.476 1.046.805 1.878L15.464 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H5.806c-1.1 0-1.476-1.046-.805-1.878L16.457 2.874c3.702 2.951 3.3 7.566.617 11z"/>
    </svg>`;
};
const $5c7c601d2a74ca78$export$3c6158790f5e01c4 = ({ appearance: appearance, label: label = 'Jira Service Management', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        label: label,
        svg: $5c7c601d2a74ca78$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("4tKlw", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementLogo", () => $20f3546c01ca50d0$export$dabef2be6cd28c20);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $cA99x = parcelRequire("cA99x");
const $20f3546c01ca50d0$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cA99x.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 362 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="M14.124 13.257h7.325c1.1 0 1.475 1.046.804 1.878L10.798 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H1.138c-1.1 0-1.476-1.046-.805-1.878L11.79 2.874c3.703 2.951 3.3 7.566.617 11z" />
      <path fill=${colors.textColor} d="M357.074 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-7.327-4.231v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-26.152-7.912v8.525h-2.637V16.28c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.625-4.14 4.723v8.525h-2.637V10.208h2.637v2.514c.981-1.81 2.79-2.821 4.845-2.821 2.607 0 4.385 1.319 5.152 3.741.859-2.361 2.913-3.741 5.459-3.741 3.434 0 5.336 2.33 5.336 6.655v8.985h-2.638v-8.525c0-3.16-1.104-4.723-3.618-4.723-2.454 0-4.14 1.625-4.14 4.723m-22.921-4.723c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.577-7.943 7.238-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638V25.54zm-14.073-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-28.327 1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-31.445-11.009-2.76-7.482V25.54h-2.76V5.393h4.784l4.569 11.56 1.871 5.552 1.87-5.551 4.6-11.561h4.447V25.54h-2.76V7.263l-2.361 7.268-4.447 11.01h-2.668zm-21.511-2.238c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zm-15.094-2.148v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.942 8.004-7.942 1.38 0 2.453.184 3.649.736v2.453c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.515-5.612 5.49s1.656 5.489 5.673 5.489c1.564 0 2.546-.215 3.496-.552M140.124 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S143.037 8 141.964 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-8.233 0h-3.527l-5.949-15.332h2.76l4.968 13.094 4.937-13.094h2.76zm-15.455-9.046v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-12.463-4.201c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zM95.024 19.99c0 3.496-2.085 5.857-7.084 5.857-3.894 0-5.704-.766-7.268-1.564v-2.821c1.87.981 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975s-1.104-2.73-4.937-3.65c-4.539-1.103-6.563-2.667-6.563-5.98 0-3.127 2.392-5.458 7.084-5.458 2.914 0 4.784.705 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.845 3.373 4.263 1.073 6.655 2.453 6.655 6.072m-34.001-2.116c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404" />
    </svg>`;
};
const $20f3546c01ca50d0$export$dabef2be6cd28c20 = ({ appearance: appearance, label: label = 'Jira Service Management', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $20f3546c01ca50d0$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("atZlG", function(module, exports) {
$parcel$export(module.exports, "LoomIcon", () => $04c0156ea0c1e705$export$8d789f76fde3e05);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $gALux = parcelRequire("gALux");
const $04c0156ea0c1e705$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $gALux.getColorsForLoom)(appearance, colorMode);
    return `<svg
    fill="none"
    height="32"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    aria-hidden="true"
  >
    <path
      d="M27.333 15.508h-6.628l5.74-3.315-1.26-2.184-5.74 3.314 3.313-5.74-2.184-1.26-3.313 5.74V5.434h-2.522v6.628l-3.314-5.74-2.184 1.26 3.314 5.74-5.74-3.314-1.26 2.184 5.74 3.314H4.667v2.521h6.627l-5.74 3.314 1.261 2.184 5.74-3.313-3.314 5.74 2.184 1.26 3.314-5.74V28.1h2.521v-6.627l3.313 5.74 2.184-1.261-3.314-5.74 5.74 3.313 1.261-2.184-5.74-3.313h6.628zM16 20.198a3.442 3.442 0 1 1 0-6.885 3.442 3.442 0 0 1 0 6.884"
      fill="${colors.iconColor}"
    />
  </svg>`;
};
const $04c0156ea0c1e705$export$8d789f76fde3e05 = ({ appearance: appearance, label: label = 'Loom', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        label: label,
        svg: $04c0156ea0c1e705$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});
parcelRegister("gALux", function(module, exports) {
$parcel$export(module.exports, "getColorsForLoom", () => $ff88a6c94732eeee$export$7818df200941dbbf);

var $cA99x = parcelRequire("cA99x");

const $ff88a6c94732eeee$export$7818df200941dbbf = (appearance, colorMode)=>{
    let iconColor = (0, $cA99x.getColorsFromAppearance)(appearance, colorMode).iconColor;
    let textColor = (0, $cA99x.getColorsFromAppearance)(appearance, colorMode).textColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#EFF0FF';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#252434';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor
    };
};

});


parcelRegister("8lXyR", function(module, exports) {
$parcel$export(module.exports, "LoomLogo", () => $26c15cae3e54fcfc$export$94e206806e36c2ec);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $gALux = parcelRequire("gALux");
const $26c15cae3e54fcfc$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $gALux.getColorsForLoom)(appearance, colorMode);
    return `<svg
      fill="none"
      height="32"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 98 32"
      focusable="false"
      aria-hidden="true"
    >
      <path
        d="M29.657 13.659h-8.672l7.51-4.337-1.649-2.857-7.51 4.336 4.335-7.51-2.857-1.65-4.336 7.51V.479H13.18v8.672l-4.337-7.51-2.856 1.65 4.336 7.51-7.51-4.336-1.65 2.857 7.51 4.336H0v3.299h8.671l-7.51 4.336 1.65 2.858 7.51-4.336-4.336 7.51 2.857 1.65 4.336-7.511v8.672h3.3v-8.671l4.335 7.51 2.857-1.65-4.336-7.51 7.51 4.336 1.65-2.858-7.51-4.335h8.672v-3.3zM14.83 19.794a4.503 4.503 0 1 1 0-9.006 4.503 4.503 0 0 1 0 9.006"
        fill="${colors.iconColor}"
      />
      <path
        d="M37.303 26.155V4.459h3.983v21.696zm38.204-14.743h3.803v1.798c.808-1.438 2.696-2.218 4.313-2.218 2.007 0 3.624.87 4.373 2.457 1.167-1.798 2.726-2.457 4.673-2.457 2.725 0 5.33 1.648 5.33 5.604v9.559h-3.862v-8.75c0-1.588-.78-2.786-2.607-2.786-1.707 0-2.726 1.318-2.726 2.907v8.63H84.85v-8.75c0-1.59-.808-2.787-2.606-2.787-1.738 0-2.757 1.288-2.757 2.907v8.63h-3.981zm-25.219 15.17c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.251 7.798-7.737 7.798m0-11.996a4.2 4.2 0 0 0-4.197 4.199c0 2.315 1.883 4.199 4.197 4.199s4.196-1.884 4.196-4.2a4.2 4.2 0 0 0-4.196-4.198m16.245 11.996c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.253 7.798-7.737 7.798m0-12.046c-2.34 0-4.245 1.906-4.245 4.247s1.904 4.247 4.245 4.247a4.25 4.25 0 0 0 4.245-4.247 4.25 4.25 0 0 0-4.245-4.247"
        fill="${colors.textColor}"
      />
    </svg>`;
};
const $26c15cae3e54fcfc$export$94e206806e36c2ec = ({ appearance: appearance, label: label = 'Loom', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $26c15cae3e54fcfc$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("1i16X", function(module, exports) {
$parcel$export(module.exports, "LoomAttributionIcon", () => $d0f3a8670d5b5757$export$1bf47cdade1a9fcb);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $81ATr = parcelRequire("81ATr");

var $atZlG = parcelRequire("atZlG");
const $d0f3a8670d5b5757$export$1bf47cdade1a9fcb = ({ appearance: appearance, label: label = 'Loom Attribution', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor })=>{
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $atZlG.LoomIcon), {
        appearance: appearance,
        label: label,
        size: size,
        testId: testId,
        iconColor: iconColor,
        textColor: textColor
    });
};

});

parcelRegister("oEO5t", function(module, exports) {
$parcel$export(module.exports, "LoomAttributionLogo", () => $3296d8a9967cf985$export$6e87ce8d41eda665);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $gALux = parcelRequire("gALux");
const $3296d8a9967cf985$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $gALux.getColorsForLoom)(appearance, colorMode);
    return `<svg
		fill="none"
		height="32"
		xmlns="http://www.w3.org/2000/svg"
		focusable="false"
		aria-hidden="true"
		viewBox="0 0 88 32"
	>
		<path
			d="M29.488 12.765h-8.983l7.78-4.344-1.544-2.585-7.78 4.344 4.492-7.523-2.674-1.493-4.491 7.522V0H13.2v8.687L8.71 1.164 6.035 2.657l4.49 7.522-7.778-4.343L1.204 8.42l7.779 4.344H0v2.986h8.982l-7.778 4.343 1.543 2.585 7.78-4.342-4.492 7.522 2.674 1.493L13.2 19.83v8.687h3.087v-8.873l4.574 7.663 2.507-1.4-4.575-7.663 7.946 4.437 1.544-2.586-7.779-4.343h8.982v-2.986h.001Zm-14.744 5.552c-2.318 0-4.197-1.817-4.197-4.059s1.88-4.059 4.197-4.059 4.198 1.817 4.198 4.06c0 2.24-1.88 4.058-4.198 4.058"
			fill="${colors.iconColor}"
		/>
		<path
			d="M38.379 26.847V10.094h3.18v16.753zm30.503-11.79h3.036v1.438c.646-1.15 2.153-1.773 3.444-1.773 1.602 0 2.893.695 3.49 1.964.932-1.438 2.177-1.964 3.731-1.964 2.175 0 4.256 1.318 4.256 4.48v7.642h-3.084V19.85c0-1.27-.623-2.228-2.081-2.228-1.363 0-2.177 1.054-2.177 2.324v6.9h-3.155V19.85c0-1.27-.646-2.228-2.081-2.228-1.387 0-2.2 1.03-2.2 2.324v6.9h-3.18V15.057Zm-20.134 12.13c-3.582 0-6.176-2.66-6.176-6.234 0-3.517 2.585-6.242 6.176-6.242 3.609 0 6.177 2.75 6.177 6.242 0 3.547-2.596 6.234-6.177 6.234m0-9.59a3.357 3.357 0 0 0 0 6.713 3.357 3.357 0 0 0 0-6.713m12.966 9.59c-3.583 0-6.177-2.66-6.177-6.234 0-3.517 2.586-6.242 6.177-6.242 3.608 0 6.176 2.75 6.176 6.242 0 3.547-2.597 6.234-6.176 6.234m0-9.63a3.397 3.397 0 0 0-3.39 3.395 3.397 3.397 0 0 0 3.39 3.395 3.396 3.396 0 0 0 0-6.79M64.933 5.63c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473a4.46 4.46 0 0 1-2.197-.63v1.417c.483.263 1.233.473 2.197.473 1.5.052 2.197-.683 2.197-1.785Zm16.662-4.067v5.988h1.3V3.007l.542 1.23 1.841 3.368h1.626V1.563h-1.3v3.85l-.488-1.123-1.463-2.727zm-8.056 0h-1.465v6.042h1.465zm-23.981 0v6.042h2.863l.432-1.295h-1.945V1.563zm-5.671 0v1.295h1.604v4.747h1.44V2.858h1.715V1.563zm-2.177 0h-1.802l-2.066 6.042h1.59l.317-1.025a4 4 0 0 0 1.113.162q.556 0 1.113-.162l.318 1.025h1.59zm-.9 3.938a3 3 0 0 1-.743-.108l.742-2.643.742 2.643c-.265.054-.477.108-.742.108Zm16.577-3.938H55.53L53.4 7.605h1.638l.328-1.025q.573.162 1.146.162.574 0 1.147-.162l.328 1.025h1.638l-2.24-6.042Zm-.928 3.938c-.273 0-.546-.054-.765-.108l.765-2.643.764 2.643a3.3 3.3 0 0 1-.764.108m21.98-3.938h-1.857l-2.13 6.042h1.638l.328-1.025q.574.162 1.147.162c.573 0 .764-.054 1.146-.162l.328 1.025h1.638zm-.93 3.938c-.272 0-.545-.054-.763-.108l.764-2.643.765 2.643a3.3 3.3 0 0 1-.765.108Zm-6.894.129c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473-.75 0-1.608-.263-2.197-.63v1.417c.482.263 1.233.473 2.197.473 1.447.052 2.197-.683 2.197-1.785Z"
			fill="${colors.textColor}"
		/>
	</svg>`;
};
const $3296d8a9967cf985$export$6e87ce8d41eda665 = ({ appearance: appearance, label: label = 'Loom Attribution', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $3296d8a9967cf985$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("8hS2P", function(module, exports) {
$parcel$export(module.exports, "OpsgenieIcon", () => $a82ba16b31c90dca$export$eeccc49dc7a12d9f);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $cA99x = parcelRequire("cA99x");
const $a82ba16b31c90dca$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cA99x.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M17.114 28.127c-.785.578-1.199.537-1.984-.041-3.8-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.992.124c1.652 1.9 3.264 3.76 5.123 5.082 1.86-1.322 3.47-3.181 5.123-5.082q.434-.495.992-.124l4.297 2.686c.372.206.496.66.248.991-2.355 3.223-5.867 6.322-9.668 9.09m-.992-11.858c3.388 0 6.198-2.768 6.198-6.156s-2.81-6.239-6.198-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156"/>
    </svg>`;
};
const $a82ba16b31c90dca$export$eeccc49dc7a12d9f = ({ appearance: appearance, label: label = 'Opsgenie', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        svg: $a82ba16b31c90dca$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("23eQ8", function(module, exports) {
$parcel$export(module.exports, "OpsgenieLogo", () => $09a342a45a5c0a9e$export$a1c6484cdecc2c4b);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $cA99x = parcelRequire("cA99x");
const $09a342a45a5c0a9e$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cA99x.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 154 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M11.78 28.127c-.785.578-1.198.537-1.983-.041-3.801-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.991.124c1.653 1.9 3.264 3.76 5.124 5.082 1.859-1.322 3.47-3.181 5.123-5.082q.435-.495.992-.124l4.297 2.686c.371.206.495.66.247.991-2.355 3.223-5.867 6.322-9.668 9.09m-.99-11.857c3.388 0 6.197-2.768 6.197-6.156s-2.81-6.239-6.197-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156"/>
      <path fill="${colors.textColor}" d="M146.689 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zM133.385 6.16c0-1.166.767-1.84 1.841-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84c-1.074 0-1.841-.675-1.841-1.84m.491 19.38V10.208h2.638v15.334zm-3.677-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-18.639-.614v-1.533c-.981 2.024-2.821 3.067-5.182 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.378-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.834 0 5.152-2.055 5.152-4.907m-8.678-6.44c0 3.68 1.472 5.52 4.2 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m-4.703 3.497c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.17-.52-5.336-1.134v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.89-1.84-3.802-2.545-3.404-.829-4.846-2.147-4.846-4.662 0-2.668 2.055-4.293 5.55-4.293 1.994 0 3.804.49 4.938 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.121 2.085 5.121 4.753m-16.274-3.496c0-3.68-1.472-5.52-4.202-5.52-2.36 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.509-1.962 4.509-5.52m-3.803 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.637V10.207h2.637v2.76c.981-2.024 2.821-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.147 7.973-6.44 7.973m-20.121 0c-6.225 0-9.721-4.293-9.721-10.426 0-6.072 3.496-10.335 9.721-10.335 6.195 0 9.69 4.263 9.69 10.335 0 6.133-3.495 10.426-9.69 10.426m0-18.124c-4.968 0-6.961 3.527-6.961 7.698 0 4.262 1.993 7.789 6.961 7.789 4.937 0 6.93-3.527 6.93-7.79 0-4.17-1.993-7.697-6.93-7.697" />
    </svg>`;
};
const $09a342a45a5c0a9e$export$a1c6484cdecc2c4b = ({ appearance: appearance, label: label = 'Opsgenie', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $09a342a45a5c0a9e$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("39U7P", function(module, exports) {
$parcel$export(module.exports, "RovoIcon", () => $457e4827c24d60da$export$e23ae35269442b4f);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $cA99x = parcelRequire("cA99x");
const $457e4827c24d60da$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cA99x.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">
    <g fill="${colors.iconColor}" fill-rule="evenodd">
      <path d="M17.06 4.246a2.79 2.79 0 0 0-2.736-.026l-.049.033-.002.001c-.605.35-1.048.91-1.256 1.558-.085.268-.13.552-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566a2.77 2.77 0 0 0 1.392-2.407v-9.487c0-.991-.532-1.912-1.392-2.408z"/>
      <path d="m6.058 9 6.176-3.566a3.7 3.7 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155l4.604 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.851.47-1.89.461-2.735-.026L6.06 23.301a2.78 2.78 0 0 1-1.392-2.408v-9.486c0-.996.529-1.912 1.391-2.408z"/>
    </g>
  </svg>`;
};
const $457e4827c24d60da$export$e23ae35269442b4f = ({ appearance: appearance, label: label = 'Rovo', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        svg: $457e4827c24d60da$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("cGyDm", function(module, exports) {
$parcel$export(module.exports, "RovoLogo", () => $c654d40ca867d88b$export$a0f6cb8061290bbb);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $cA99x = parcelRequire("cA99x");
const $c654d40ca867d88b$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cA99x.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 100 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.393 4.246a2.79 2.79 0 0 0-2.735-.026.4.4 0 0 1-.05.033l-.001.001c-.606.35-1.048.91-1.257 1.558q-.129.404-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566A2.77 2.77 0 0 0 22 20.884v-9.487c0-.991-.532-1.912-1.392-2.408z"
        fill="${colors.iconColor}"
        fillRule="evenodd"
      />
      <path
        d="m1.391 9 6.176-3.566a3.6 3.6 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155h.001l4.603 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.85.47-1.89.461-2.734-.026l-8.216-4.743A2.78 2.78 0 0 1 0 20.893v-9.486c0-.996.529-1.912 1.391-2.408z"
        fill="${colors.iconColor}"
        fillRule="evenodd"
      />
      <path
        d="M91.688 25.848c-4.6 0-7.298-3.404-7.298-8.004S87.088 9.9 91.688 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004zm0-13.494c-3.28 0-4.722 2.576-4.722 5.49 0 2.913 1.441 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.41-5.49-4.662-5.49M77.675 25.54H74.15L68.2 10.208h2.76l4.968 13.094 4.938-13.095h2.76zm-17.462.308c-4.6 0-7.299-3.404-7.299-8.004s2.7-7.943 7.3-7.943c4.568 0 7.236 3.342 7.236 7.942s-2.668 8.004-7.237 8.004zm0-13.494c-3.281 0-4.723 2.576-4.723 5.49 0 2.913 1.442 5.55 4.723 5.55 3.25 0 4.661-2.637 4.661-5.55 0-2.914-1.41-5.49-4.66-5.49zM43.177 8.03H39.13v7.36h4.048c3.588 0 4.692-1.38 4.692-3.68 0-2.177-1.134-3.68-4.692-3.68zm7.452 3.619c0 3.036-1.288 5.09-3.956 5.949l4.938 7.943H48.36l-4.447-7.514H39.13v7.514h-2.76V5.393h7.115c4.815 0 7.145 2.392 7.145 6.256z"
        fill="${colors.textColor}"
      />
    </svg>`;
};
const $c654d40ca867d88b$export$a0f6cb8061290bbb = ({ appearance: appearance, label: label = 'Rovo', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $c654d40ca867d88b$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("9gA1b", function(module, exports) {
$parcel$export(module.exports, "StatuspageIcon", () => $0c8c0eb5ee11231a$export$f3f5aa321d88adf9);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $cA99x = parcelRequire("cA99x");
const $0c8c0eb5ee11231a$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cA99x.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M16 12.604c-3.033 0-5.981 1.37-8.39 3.489q-.375.373-.748.373c-.208 0-.415-.124-.581-.332l-3.032-3.572c-.166-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706 3.655-3.24 8.1-5.067 12.627-5.067s8.97 1.827 12.626 5.067c.249.249.374.457.374.706 0 .166-.084.374-.25.581l-3.032 3.572c-.166.208-.373.332-.581.332q-.374 0-.748-.374c-2.409-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.365 0-6.106-2.742-6.106-6.064S12.635 13.85 16 13.85s6.106 2.7 6.106 6.064-2.741 6.063-6.105 6.063"/>
    </svg>`;
};
const $0c8c0eb5ee11231a$export$f3f5aa321d88adf9 = ({ appearance: appearance, label: label = 'Statuspage', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        label: label,
        svg: $0c8c0eb5ee11231a$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("gUu6v", function(module, exports) {
$parcel$export(module.exports, "StatuspageLogo", () => $61c0e926502ab24c$export$bb4ae5b41b43be04);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $cA99x = parcelRequire("cA99x");
const $61c0e926502ab24c$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cA99x.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 188 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M13 12.604c-3.032 0-5.98 1.37-8.39 3.489q-.373.373-.747.373c-.208 0-.416-.124-.582-.332L.25 12.562c-.167-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706C4.029 8.035 8.473 6.208 13 6.208s8.971 1.827 12.626 5.067c.25.249.374.457.374.706 0 .166-.083.374-.25.581l-3.031 3.572c-.166.208-.374.332-.582.332q-.373 0-.747-.374c-2.41-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.364 0-6.105-2.742-6.105-6.064S9.635 13.85 13 13.85c3.364 0 6.105 2.7 6.105 6.064s-2.74 6.063-6.105 6.063" />
      <path fill="${colors.textColor}" d="M180.293 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.981 2.024-2.821 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.982 2.024-2.822 3.066-5.183 3.066-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-16.091-7.666c0-3.68-1.472-5.52-4.201-5.52-2.361 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.508-1.962 4.508-5.52m-3.802 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.638V10.207h2.638v2.76c.981-2.024 2.821-3.066 5.182-3.066 4.079 0 6.134 3.465 6.134 7.973 0 4.324-2.147 7.973-6.44 7.973m-10.56-4.477c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.52-5.336-1.134v-2.79c1.318.766 3.526 1.502 5.458 1.502 2.024 0 3.067-.828 3.067-2.024 0-1.165-.889-1.84-3.803-2.545-3.404-.829-4.845-2.147-4.845-4.662 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.73c-1.84-.92-3.343-1.411-4.968-1.411-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-27.598-2.177v-8.985h2.638v9.26c0 2.76 1.104 3.988 3.618 3.988 2.454 0 4.14-1.626 4.14-4.723v-8.525h2.638V25.54h-2.638v-2.515c-.981 1.81-2.79 2.821-4.845 2.821-3.527 0-5.55-2.422-5.55-6.654m-7.155 1.596c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454H85.39zm-18.943-2.914c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-17.258-4.752c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454h-4.078zm-6.894-.798c0 3.496-2.085 5.858-7.084 5.858-3.894 0-5.704-.767-7.268-1.564v-2.822c1.871.982 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975 0-1.778-1.104-2.729-4.937-3.649-4.539-1.104-6.563-2.668-6.563-5.98 0-3.128 2.392-5.459 7.084-5.459 2.914 0 4.784.706 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.846 3.373 4.262 1.074 6.654 2.454 6.654 6.072" />
    </svg>`;
};
const $61c0e926502ab24c$export$bb4ae5b41b43be04 = ({ appearance: appearance, label: label = 'Statuspage', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $61c0e926502ab24c$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("kwiP0", function(module, exports) {
$parcel$export(module.exports, "TrelloIcon", () => $a90c2ebf006c326e$export$4384da9b8b140bf4);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $cA99x = parcelRequire("cA99x");
const $a90c2ebf006c326e$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cA99x.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} clip-rule="evenodd" d="M24.286 5.337H7.714a2.585 2.585 0 0 0-2.585 2.585v16.572a2.585 2.585 0 0 0 2.585 2.584h16.572a2.585 2.585 0 0 0 2.585-2.584V7.922a2.585 2.585 0 0 0-2.585-2.585m-9.791 15.66a.86.86 0 0 1-.859.858h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86zm8.362-4.953a.86.86 0 0 1-.859.859h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86z" fill-rule="evenodd"/>
    </svg>`;
};
const $a90c2ebf006c326e$export$4384da9b8b140bf4 = ({ appearance: appearance, label: label = 'Trello', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        label: label,
        svg: $a90c2ebf006c326e$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("gzw4h", function(module, exports) {
$parcel$export(module.exports, "TrelloLogo", () => $22d91a8c01827a62$export$60e26212f3b61a28);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $cA99x = parcelRequire("cA99x");
const $22d91a8c01827a62$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cA99x.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 106 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" clip-rule="evenodd" d="M19.157 4.67H2.585A2.585 2.585 0 0 0 0 7.255v16.572a2.585 2.585 0 0 0 2.585 2.585h16.572a2.585 2.585 0 0 0 2.584-2.585V7.255a2.585 2.585 0 0 0-2.584-2.585M9.365 20.33a.86.86 0 0 1-.858.858H4.873a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86zm8.362-4.952a.86.86 0 0 1-.858.858h-3.634a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86z" fill-rule="evenodd"/>
      <path fill="${colors.textColor}" d="M97.64 25.848c-4.6 0-7.298-3.404-7.298-8.004S93.04 9.9 97.64 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.494c-3.281 0-4.722 2.576-4.722 5.49 0 2.913 1.44 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.411-5.49-4.662-5.49M88.874 25.51c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zm-7.996 0c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zM65.532 12.293c-2.79 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.44-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196H61.085c.368 2.606 2.055 4.293 5.673 4.293 1.78 0 3.282-.337 4.662-.828zm-19.48-8.434v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M32.943 5.393H48.03V8.03h-6.164v17.511h-2.76V8.031h-6.164z"/>
    </svg>`;
};
const $22d91a8c01827a62$export$60e26212f3b61a28 = ({ appearance: appearance, label: label = 'Trello', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $22d91a8c01827a62$var$svg({
            appearance: appearance,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("c6wp0", function(module, exports) {
$parcel$export(module.exports, "JiraWorkManagementIcon", () => $a634e37d2d322484$export$7330b9fc5718fd30);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $fEY94 = parcelRequire("fEY94");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $cDSKq = parcelRequire("cDSKq");
const $a634e37d2d322484$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode, id)=>{
    let colors = {
        iconGradientStart: (0, $81ATr.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $81ATr.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cDSKq.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return `
    <svg
      fill="none"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <linearGradient
        id="${id}"
        gradientUnits="userSpaceOnUse"
        x1="13.9485"
        x2="20.7792"
        y1="20.2388"
        y2="11.8277"
      >
        <stop offset="0" stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} />
        <stop offset="100%" stop-color="${colors.iconGradientStop}" />
      </linearGradient>
      <path
        d="m18.3893 7-3.4257 13.1867c4.3592 1.2052 7.8383-.3558 9.1709-5.4802l1.9988-7.6973z"
        fill="url(#${id})"
      />
      <path
      fill="${colors.iconColor}"
      d="m13.7566 24.8265 3.4257-13.1866c-4.3623-1.196-7.8383.3649-9.17087 5.4985l-2.01143 7.6881z"
      />
    </svg>`;
};
const $a634e37d2d322484$export$7330b9fc5718fd30 = ({ appearance: appearance, label: label = 'Jira Work Management', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    const id = (0, $fEY94.useId)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        label: label,
        svg: $a634e37d2d322484$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("bEejo", function(module, exports) {
$parcel$export(module.exports, "AtlassianIcon", () => $1d3cfb71a729eeee$export$8a485e2e7ed91e8f);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $cA99x = parcelRequire("cA99x");
const $1d3cfb71a729eeee$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cA99x.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251"/>
    </svg>`;
};
const $1d3cfb71a729eeee$export$8a485e2e7ed91e8f = ({ appearance: appearance, label: label = 'Atlassian', size: size = (0, $81ATr.defaultLogoParams).size, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor, testId: testId })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        label: label,
        svg: $1d3cfb71a729eeee$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};

});

parcelRegister("bsDCG", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwareIcon", () => $ba972be7fd3d8b0b$export$c3835feba2a66e67);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $fEY94 = parcelRequire("fEY94");

var $1r8Gx = parcelRequire("1r8Gx");

var $81ATr = parcelRequire("81ATr");

var $3h3Ly = parcelRequire("3h3Ly");

var $cDSKq = parcelRequire("cDSKq");
const $ba972be7fd3d8b0b$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode, id)=>{
    let colors = {
        iconGradientStart: (0, $81ATr.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $81ATr.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cDSKq.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return `
  <svg viewBox="0 0 32 32" height="32" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">
    <defs>
      <linearGradient x1="108.695%" x2="12.439%" y1="-14.936%" y2="45.215%" id="${id}-1">
        <stop stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} offset="0%"></stop>
        <stop stop-color="${colors.iconGradientStop}" offset="100%"></stop>
      </linearGradient>
      <linearGradient x1="0%" x2="91.029%" y1="118.55%" y2="63.971%" id="${id}-2">
        <stop stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} offset="0%"></stop>
        <stop stop-color="${colors.iconGradientStop}" offset="100%"></stop>
      </linearGradient>
    </defs>
    <g stroke="none" stroke-width="1" fill-rule="nonzero">
      <path fill="${colors.iconColor}" d="M15.9669691 29.3616152C17.2195568 28.1097726 17.9233158 26.4114623 17.9233158 24.6405626 17.9233158 22.8696629 17.2195568 21.1713527 15.9669691 19.91951L7.26805808 11.2489111 3.31143376 15.2055354C2.89743442 15.6200502 2.89743442 16.291565 3.31143376 16.7060799L15.9669691 29.3616152zM28.6225045 15.2055354L15.9669691 2.55 15.9280399 2.58892922C13.3485687 5.19994003 13.3612164 9.40374108 15.9563521 11.9991833L24.6623412 20.6662432 28.6225045 16.7060799C29.0365039 16.291565 29.0365039 15.6200502 28.6225045 15.2055354z" />
      <path fill="url(#${id}-1" d="M15.9669691,11.9921053 C13.3718335,9.39666304 13.3591857,5.19286199 15.938657,2.58185118 L6.91061706,11.6063521 L11.6316697,16.3274047 L15.9669691,11.9921053 Z" />
      <path fill="url(#${id}-2" d="M20.2951906,15.5912886 L15.9669691,19.91951 C17.2195568,21.1713527 17.9233158,22.8696629 17.9233158,24.6405626 C17.9233158,26.4114623 17.2195568,28.1097726 15.9669691,29.3616152 L25.0162432,20.3123412 L20.2951906,15.5912886 Z" />
    </g>
  </svg>`;
};
const $ba972be7fd3d8b0b$export$c3835feba2a66e67 = ({ appearance: appearance, label: label = 'Jira Software', size: size = (0, $81ATr.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $81ATr.defaultLogoParams).iconColor, textColor: textColor = (0, $81ATr.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $1r8Gx.default)();
    const id = (0, $fEY94.useId)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3h3Ly.default), {
        appearance: appearance,
        label: label,
        svg: $ba972be7fd3d8b0b$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("9RMyU", function(module, exports) {
$parcel$export(module.exports, "createFeatureFlaggedRovoComponent", () => $0105ff7fc5e311e1$export$2469203854060337);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $3X3Vo = parcelRequire("3X3Vo");

var $fF7wm = parcelRequire("fF7wm");

var $l8DVX = parcelRequire("l8DVX");

const $0105ff7fc5e311e1$export$2469203854060337 = (LegacyComponent, NewComponent, NewHexComponent)=>{
    const RovoHexWrapped = (0, $l8DVX.tempSizeWrapper)(NewHexComponent);
    const RovoServiceCollectionWrapped = (0, $fF7wm.createFeatureFlaggedServiceCollectionComponent)(LegacyComponent, NewComponent);
    return ({ shouldUseHexLogo: shouldUseHexLogo, ...props })=>{
        // Return hex logo if feature flag enabled. Otherwise revert to old set of components
        if ((0, $3X3Vo.fg)('platform-logo-rebrand-rovo-hex') || shouldUseHexLogo) return /*#__PURE__*/ (0, $2iln5.jsx)(RovoHexWrapped, {
            ...props
        });
        else return /*#__PURE__*/ (0, $2iln5.jsx)(RovoServiceCollectionWrapped, {
            ...props
        });
    };
};
const $0105ff7fc5e311e1$export$172fd793eb6ecac4 = [
    // Program logos
    {
        name: 'atlassian',
        type: 'legacy',
        category: 'program'
    },
    {
        name: 'atlassian-access',
        type: 'legacy',
        category: 'program'
    },
    {
        name: 'atlassian-marketplace',
        type: 'legacy',
        category: 'program'
    },
    // Home collection
    {
        name: 'home',
        type: 'new',
        category: 'app'
    },
    {
        name: 'hub',
        type: 'new',
        category: 'app'
    },
    // Teamwork collection
    {
        name: 'confluence',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'jira',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'loom',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'loom-blurple',
        type: 'new',
        category: 'app',
        skipExample: true
    },
    {
        name: 'loom-attribution',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'rovo',
        type: 'rovo-hex',
        category: 'app'
    },
    // Strategy collection
    {
        name: 'align',
        type: 'new',
        category: 'app'
    },
    {
        name: 'focus',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'talent',
        type: 'new',
        category: 'app'
    },
    // App collection
    {
        name: 'jira-product-discovery',
        type: 'migration',
        category: 'app'
    },
    // Dev collection
    {
        name: 'bitbucket',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'compass',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'dx',
        type: 'new',
        category: 'app',
        skipLogo: true
    },
    {
        name: 'rovo-dev',
        type: 'new',
        category: 'app'
    },
    {
        name: 'rovo-dev-agent',
        type: 'new',
        category: 'agent'
    },
    // Customer collection
    {
        name: 'jira-service-management',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'assets',
        type: 'new',
        category: 'app'
    },
    {
        name: 'customer-service-management',
        type: 'new',
        category: 'app'
    },
    {
        name: 'opsgenie',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'statuspage',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'trello',
        type: 'migration',
        category: 'app'
    },
    // Platform Collection
    {
        name: 'admin',
        type: 'new',
        category: 'app'
    },
    {
        name: 'analytics',
        type: 'new',
        category: 'app'
    },
    {
        name: 'chat',
        type: 'new',
        category: 'app'
    },
    {
        name: 'feedback',
        type: 'new',
        category: 'app'
    },
    {
        name: 'goals',
        type: 'new',
        category: 'app'
    },
    {
        name: 'guard',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'projects',
        type: 'new',
        category: 'app'
    },
    {
        name: 'search',
        type: 'new',
        category: 'app'
    },
    {
        name: 'studio',
        type: 'new',
        category: 'app'
    },
    {
        name: 'teams',
        type: 'new',
        category: 'app'
    },
    // Data Center
    {
        name: 'jira-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'jira-service-management-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'confluence-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'bitbucket-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'bamboo',
        type: 'new',
        category: 'app'
    },
    {
        name: 'crowd',
        type: 'new',
        category: 'app'
    },
    // Deprecated
    {
        name: 'atlassian-administration',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlassian-admin',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlassian-analytics',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlas',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-align',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-software',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-work-management',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    }
];
const $0105ff7fc5e311e1$export$62e1212796a86b1b = $0105ff7fc5e311e1$export$172fd793eb6ecac4.filter((logo)=>logo.category === 'program' && !logo.skipExample).map((logo)=>logo.name);
const $0105ff7fc5e311e1$export$e0dee4a765830f4d = $0105ff7fc5e311e1$export$172fd793eb6ecac4.filter((logo)=>logo.category === 'app' && !logo.skipExample).map((logo)=>logo.name);
const $0105ff7fc5e311e1$export$a13ce90e90d7bfc1 = $0105ff7fc5e311e1$export$172fd793eb6ecac4.filter((logo)=>logo.category === 'agent' && !logo.skipExample).map((logo)=>logo.name) || [];
const $0105ff7fc5e311e1$export$516fce44c502c1d3 = $0105ff7fc5e311e1$export$172fd793eb6ecac4.filter((logo)=>logo.type === 'legacy');
const $0105ff7fc5e311e1$export$b805fae8e798ed39 = $0105ff7fc5e311e1$export$172fd793eb6ecac4.filter((logo)=>logo.type === 'migration');
const $0105ff7fc5e311e1$export$3f9abd26214cd85f = $0105ff7fc5e311e1$export$172fd793eb6ecac4.filter((logo)=>logo.type === 'new');

});
parcelRegister("l8DVX", function(module, exports) {
$parcel$export(module.exports, "tempSizeWrapper", () => $8a573143e0c291ef$export$667425256e2e7296);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");
const $8a573143e0c291ef$export$667425256e2e7296 = (NewComponent)=>{
    return ({ size: size, ...props })=>{
        return /*#__PURE__*/ (0, $2iln5.jsx)(NewComponent, {
            size: size || 'medium',
            ...props
        });
    };
};

});




parcelRegister("e8cCK", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("eCj8S")).default);

var $eCj8S = parcelRequire("eCj8S");

var $2F3nf = parcelRequire("2F3nf");

});
parcelRegister("eCj8S", function(module, exports) {
$parcel$export(module.exports, "default", () => $b18884176f1812cd$export$2e2bcd8739ae039);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $Hyfcf = parcelRequire("Hyfcf");

var $1uL2b = parcelRequire("1uL2b");

var $ccErM = parcelRequire("ccErM");

var $1RE2F = parcelRequire("1RE2F");

var $aH1KC = parcelRequire("aH1KC");

var $3LZFN = parcelRequire("3LZFN");

var $1F7MK = parcelRequire("1F7MK");
var $ka1iJ = parcelRequire("ka1iJ");

var $kE20X = parcelRequire("kE20X");

var $gkJgm = parcelRequire("gkJgm");

var $2ocq9 = parcelRequire("2ocq9");

var $jmcPG = parcelRequire("jmcPG");

var $guEK2 = parcelRequire("guEK2");

var $8kZlM = parcelRequire("8kZlM");

var $8JvDF = parcelRequire("8JvDF");

var $6KwsR = parcelRequire("6KwsR");
const $b18884176f1812cd$var$tooltipZIndex = (0, $2ocq9.layers).tooltip();
const $b18884176f1812cd$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: undefined,
    packageVersion: undefined
};
// Inverts motion direction
const $b18884176f1812cd$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ const $b18884176f1812cd$var$getDirectionFromPlacement = (placement)=>placement.split('-')[0];
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $b18884176f1812cd$var$Tooltip({ children: children, position: position = 'bottom', mousePosition: mousePosition = 'bottom', content: content, truncate: truncate = false, // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
component: Container = (0, $6KwsR.default), tag: TargetContainer = 'div', testId: testId, delay: delay = 300, onShow: onShow = (0, $ccErM.default), onHide: onHide = (0, $ccErM.default), canAppear: canAppear, hideTooltipOnClick: hideTooltipOnClick = false, hideTooltipOnMouseDown: hideTooltipOnMouseDown = false, analyticsContext: analyticsContext, strategy: strategy = 'fixed', ignoreTooltipPointerEvents: ignoreTooltipPointerEvents = false, isScreenReaderAnnouncementDisabled: isScreenReaderAnnouncementDisabled = false, shortcut: shortcut, UNSAFE_shouldAlwaysFadeIn: shouldAlwaysFadeIn = false, UNSAFE_shouldRenderToParent: UNSAFE_shouldRenderToParent = false }) {
    // Not using a gate for this check. When the gate is disabled `mouse-y` and `mouse-x` are treated as `mouse`.
    const isMousePosition = position === 'mouse' || position === 'mouse-y' || position === 'mouse-x';
    const tooltipPosition = isMousePosition ? mousePosition : position;
    const onShowHandler = (0, $1uL2b.usePlatformLeafSyntheticEventHandler)({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext,
        ...$b18884176f1812cd$var$analyticsAttributes
    });
    const onHideHandler = (0, $1uL2b.usePlatformLeafSyntheticEventHandler)({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext,
        ...$b18884176f1812cd$var$analyticsAttributes
    });
    const apiRef = (0, $4tluv.useRef)(null);
    const [state, setState] = (0, $4tluv.useState)('hide');
    const targetRef = (0, $4tluv.useRef)(null);
    const containerRef = (0, $4tluv.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    const setImplicitRefFromChildren = (node)=>{
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    const setDirectRef = (0, $4tluv.useCallback)((node)=>{
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    const stableState = (0, $aH1KC.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    const onShowHandlerStable = (0, $aH1KC.default)(onShowHandler);
    const onHideHandlerStable = (0, $aH1KC.default)(onHideHandler);
    const delayStable = (0, $aH1KC.default)(delay);
    const canAppearStable = (0, $aH1KC.default)(canAppear);
    const hasCalledShowHandler = (0, $4tluv.useRef)(false);
    const shouldAlwaysFadeInStable = (0, $aH1KC.default)(shouldAlwaysFadeIn);
    const start = (0, $4tluv.useCallback)((api)=>{
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    const done = (0, $4tluv.useCallback)(()=>{
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    const abort = (0, $4tluv.useCallback)(()=>{
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $4tluv.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    const isDraggingRef = (0, $4tluv.useRef)(false);
    (0, $4tluv.useEffect)(()=>{
        return (0, $jmcPG.register)({
            onRegister ({ isDragging: isDragging }) {
                isDraggingRef.current = isDragging;
            },
            onDragStart () {
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ apiRef.current?.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd () {
                isDraggingRef.current = false;
            }
        });
    }, []);
    const tryShowTooltip = (0, $4tluv.useCallback)((source)=>{
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !canAppearStable.current?.()) return;
        const entry = {
            source: source,
            delay: delayStable.current,
            show: ({ isImmediate: isImmediate })=>{
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(!isImmediate ? 'fade-in' : 'show-immediate');
            },
            hide: ({ isImmediate: isImmediate })=>{
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done,
            shouldAlwaysFadeIn: shouldAlwaysFadeInStable.current
        };
        const api = (0, $8kZlM.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable,
        shouldAlwaysFadeInStable
    ]);
    const hideTooltipOnEsc = (0, $4tluv.useCallback)(()=>{
        apiRef.current?.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $1RE2F.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $4tluv.useEffect)(()=>{
        if (state === 'hide') return 0, $ccErM.default;
        if (state === 'before-fade-out') setState('fade-out');
        const unbind = (0, $Hyfcf.bind)(window, {
            type: 'scroll',
            listener: ()=>{
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    const onMouseDown = (0, $4tluv.useCallback)(()=>{
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    const onClick = (0, $4tluv.useCallback)(()=>{
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOver = (0, $4tluv.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        const source = isMousePosition ? {
            type: 'mouse',
            clientX: event.clientX,
            clientY: event.clientY
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        isMousePosition,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOut = (0, $4tluv.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onMouseMove = isMousePosition ? (event)=>{
        if (apiRef.current?.isActive()) apiRef.current.mousePos = {
            clientX: event.clientX,
            clientY: event.clientY
        };
    } : undefined;
    const onMouseOverTooltip = (0, $4tluv.useCallback)(()=>{
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    const onFocus = (0, $4tluv.useCallback)((e)=>{
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch  {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    const onBlur = (0, $4tluv.useCallback)(()=>{
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onAnimationFinished = (0, $4tluv.useCallback)((transition)=>{
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    const shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    const shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    const shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    const handleOpenLayerObserverCloseSignal = (0, $4tluv.useCallback)(()=>{
        apiRef.current?.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $3LZFN.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    const getReferenceElement = ()=>{
        if (isMousePosition && apiRef.current?.mousePos && targetRef.current) return (0, $guEK2.getVirtualElementFromMousePos)(apiRef.current.mousePos, {
            targetElement: targetRef.current,
            tooltipPosition: position
        });
        return targetRef.current || undefined;
    };
    const tooltipIdForHiddenContent = (0, $8JvDF.default)('tooltip', shouldRenderHiddenContent);
    const tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // Adding `data-testid` to the TriggerProps interface breaks Buttons, so we use type assertion
    tooltipTriggerProps['data-testid'] = `${testId}--container`;
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    const isChildrenAFunction = typeof children === 'function';
    (0, $4tluv.useEffect)(()=>{
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        const target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return ()=>target.removeAttribute('aria-describedby');
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    const hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, $2iln5.jsx)("span", {
        "data-testid": testId ? `${testId}-hidden` : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent,
        children: typeof content === 'function' ? content({}) : content
    }) : null;
    const PopperWrapper = UNSAFE_shouldRenderToParent ? (0, $4tluv.Fragment) : $b18884176f1812cd$var$TooltipPortal;
    return /*#__PURE__*/ (0, $2iln5.jsxs)((0, $2iln5.Fragment), {
        children: [
            typeof children === 'function' ? // once we deprecate the wrapped approach, we can put the aria
            // attribute back into the tooltipTriggerProps and make it required
            // instead of optional in `types`
            /*#__PURE__*/ (0, $2iln5.jsxs)((0, $2iln5.Fragment), {
                children: [
                    children({
                        ...tooltipTriggerProps,
                        'aria-describedby': tooltipIdForHiddenContent,
                        ref: setDirectRef
                    }),
                    hiddenContent
                ]
            }) : // @ts-ignore
            /*#__PURE__*/ (0, $2iln5.jsxs)(CastTargetContainer, {
                ...tooltipTriggerProps,
                ref: setImplicitRefFromChildren,
                /**
     * TODO: Why is role="presentation" added?
     * - Is it only to "remove" the `Container` from screen readers?
     * - Why is it added only to the `Container` but not to `tooltipTriggerProps`?
     * - Should `role="presentation"` only be used if `shouldRenderHiddenContent == false`?
     */ role: "presentation",
                children: [
                    children,
                    hiddenContent
                ]
            }),
            shouldRenderTooltipPopup ? /*#__PURE__*/ (0, $2iln5.jsx)(PopperWrapper, {
                children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $kE20X.Popper), {
                    placement: tooltipPosition,
                    referenceElement: getReferenceElement(),
                    strategy: strategy,
                    children: ({ ref: ref, style: style, update: update, placement: placement })=>{
                        // Invert the entrance and exit directions.
                        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
                        // This gives the effect the tooltip is appearing from the target
                        const direction = isMousePosition ? undefined : $b18884176f1812cd$var$invertedDirection[$b18884176f1812cd$var$getDirectionFromPlacement(placement)];
                        return /*#__PURE__*/ (0, $2iln5.jsx)((0, $1F7MK.default), {
                            appear: true,
                            children: shouldRenderTooltipChildren && /*#__PURE__*/ (0, $2iln5.jsx)((0, $ka1iJ.default), {
                                distance: "constant",
                                entranceDirection: direction,
                                exitDirection: direction,
                                onFinish: onAnimationFinished,
                                duration: state !== 'show-immediate' ? 'medium' : 'none',
                                children: ({ className: className })=>/*#__PURE__*/ (0, $2iln5.jsx)(Container, {
                                        ref: ref,
                                        /**
               * "Tooltip" classname is a hook used by tests to manipulate
               * and hide tooltips, including in VR snapshots
               */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                        className: `Tooltip ${className}`,
                                        style: {
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                            ...style,
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                            ...ignoreTooltipPointerEvents && {
                                                pointerEvents: 'none'
                                            }
                                        },
                                        truncate: truncate,
                                        placement: tooltipPosition,
                                        testId: getReferenceElement() ? testId : testId && `${testId}--unresolved`,
                                        onMouseOut: onMouseOut,
                                        onMouseOver: onMouseOverTooltip,
                                        shortcut: shortcut,
                                        children: typeof content === 'function' ? content({
                                            update: update
                                        }) : content
                                    })
                            })
                        });
                    }
                })
            }) : null
        ]
    });
}
var $b18884176f1812cd$export$2e2bcd8739ae039 = $b18884176f1812cd$var$Tooltip;
const $b18884176f1812cd$var$TooltipPortal = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $gkJgm.default), {
        zIndex: $b18884176f1812cd$var$tooltipZIndex,
        children: children
    });
};

});
parcelRegister("ccErM", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab6460f57f15650e$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ function $ab6460f57f15650e$export$2e2bcd8739ae039() {}

});

parcelRegister("1RE2F", function(module, exports) {
$parcel$export(module.exports, "default", () => $d69e891f05672120$export$2e2bcd8739ae039);

var $4tluv = parcelRequire("4tluv");

var $Hyfcf = parcelRequire("Hyfcf");

var $dK9uz = parcelRequire("dK9uz");
function $d69e891f05672120$export$2e2bcd8739ae039({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $4tluv.useRef)(false);
    const onKeyDown = (0, $4tluv.useCallback)((e)=>{
        if (isDisabled || escapePressed.current || e.key !== (0, $dK9uz.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    const onKeyUp = (0, $4tluv.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $4tluv.useEffect)(()=>{
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled) return;
        return (0, $Hyfcf.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}

});
parcelRegister("dK9uz", function(module, exports) {
$parcel$export(module.exports, "KEY_UP", () => $a37f7aea293a78f3$export$390330c10ff2b9a1);
$parcel$export(module.exports, "KEY_DOWN", () => $a37f7aea293a78f3$export$a80636c6f41931fe);
$parcel$export(module.exports, "KEY_LEFT", () => $a37f7aea293a78f3$export$fc4577f2a2af0ae3);
$parcel$export(module.exports, "KEY_RIGHT", () => $a37f7aea293a78f3$export$c40f9845adc73fb5);
$parcel$export(module.exports, "KEY_HOME", () => $a37f7aea293a78f3$export$4af703091671bc);
$parcel$export(module.exports, "KEY_END", () => $a37f7aea293a78f3$export$e2bc30913faa5db7);
$parcel$export(module.exports, "KEY_TAB", () => $a37f7aea293a78f3$export$10f6869ed0a7d75b);
$parcel$export(module.exports, "KEY_ENTER", () => $a37f7aea293a78f3$export$8152f929a25a0ff4);
$parcel$export(module.exports, "KEY_SPACE", () => $a37f7aea293a78f3$export$e51a3576c045c8d5);
$parcel$export(module.exports, "ESCAPE", () => $a37f7aea293a78f3$export$2bb790b9008907b4);
/**
 * Character key codes which can be used in keyboard events.
 */ const $a37f7aea293a78f3$export$390330c10ff2b9a1 = 'ArrowUp';
const $a37f7aea293a78f3$export$a80636c6f41931fe = 'ArrowDown';
const $a37f7aea293a78f3$export$fc4577f2a2af0ae3 = 'ArrowLeft';
const $a37f7aea293a78f3$export$c40f9845adc73fb5 = 'ArrowRight';
const $a37f7aea293a78f3$export$4af703091671bc = 'Home';
const $a37f7aea293a78f3$export$e2bc30913faa5db7 = 'End';
const $a37f7aea293a78f3$export$10f6869ed0a7d75b = 'Tab';
const $a37f7aea293a78f3$export$8152f929a25a0ff4 = 'Enter';
const $a37f7aea293a78f3$export$e51a3576c045c8d5 = 'Space';
const $a37f7aea293a78f3$export$2bb790b9008907b4 = 'Escape';

});


parcelRegister("aH1KC", function(module, exports) {
$parcel$export(module.exports, "default", () => $13f5f640ce4b5cd8$export$2e2bcd8739ae039);

var $4tluv = parcelRequire("4tluv");
function $13f5f640ce4b5cd8$export$2e2bcd8739ae039(value) {
    const ref = (0, $4tluv.useRef)(value);
    (0, $4tluv.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("3LZFN", function(module, exports) {
$parcel$export(module.exports, "useNotifyOpenLayerObserver", () => $175a519ec2671e47$export$469bb693f11edc7f);

var $4tluv = parcelRequire("4tluv");

var $8S8Kg = parcelRequire("8S8Kg");

var $56yYq = parcelRequire("56yYq");
function $175a519ec2671e47$export$469bb693f11edc7f({ isOpen: isOpen, type: type, onClose: onClose }) {
    const context = (0, $4tluv.useContext)((0, $8S8Kg.OpenLayerObserverContext));
    const namespace = (0, $56yYq.useOpenLayerObserverNamespace)();
    (0, $4tluv.useEffect)(()=>{
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}

});
parcelRegister("8S8Kg", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverContext", () => $f2647d92fcb0b1b8$export$5fbf4d7fae6cdc00);

var $4tluv = parcelRequire("4tluv");
const $f2647d92fcb0b1b8$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $4tluv.createContext)(null);

});

parcelRegister("56yYq", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserverNamespace", () => $2c44967d16c52c75$export$1d57e79091cc3046);

var $4tluv = parcelRequire("4tluv");

var $cHn7j = parcelRequire("cHn7j");
function $2c44967d16c52c75$export$1d57e79091cc3046() {
    const namespace = (0, $4tluv.useContext)((0, $cHn7j.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("cHn7j", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", () => $b1d50b32fb71ea71$export$644a49f3b8c50fcd);

var $4tluv = parcelRequire("4tluv");
const $b1d50b32fb71ea71$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $4tluv.createContext)(null);

});



parcelRegister("1F7MK", function(module, exports) {
$parcel$export(module.exports, "useExitingPersistence", () => $f2c699800b96e918$export$3b6f38abbdcbd000);
$parcel$export(module.exports, "default", () => $f2c699800b96e918$export$2e2bcd8739ae039);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $3X3Vo = parcelRequire("3X3Vo");
// We define empty context here so the object doesn't change.
const $f2c699800b96e918$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ const $f2c699800b96e918$var$ExitingContext = /*#__PURE__*/ (0, $4tluv.createContext)($f2c699800b96e918$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ const $f2c699800b96e918$var$wrapChildWithContextProvider = (child, value = $f2c699800b96e918$var$emptyContext)=>{
    return /*#__PURE__*/ (0, $2iln5.jsx)($f2c699800b96e918$var$ExitingContext.Provider, {
        value: value,
        children: child
    }, `${child.key}-provider`);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ const $f2c699800b96e918$var$childrenToArray = (children)=>{
    const childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $4tluv.Children).toArray(children).forEach((child)=>{
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
const $f2c699800b96e918$var$spliceNewElementsIntoPrevious = (current, previous)=>{
    const splicedChildren = previous.concat([]);
    const previousMap = $f2c699800b96e918$var$childrenToObj(previous);
    for(let i = 0; i < current.length; i++){
        const child = current[i];
        const childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
const $f2c699800b96e918$var$childrenToObj = (children)=>{
    return children.reduce((acc, child)=>{
        acc[child.key] = child;
        return acc;
    }, {});
};
const $f2c699800b96e918$var$getMissingKeys = (current, previous)=>{
    const currentMapKeys = new Set(current.map((child)=>child.key));
    const missing = new Set();
    for(let i = 0; i < previous.length; i++){
        const element = previous[i];
        const key = element.key;
        if (!currentMapKeys.has(key)) missing.add(key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ const $f2c699800b96e918$var$ExitingPersistence = /*#__PURE__*/ (0, $4tluv.memo)(({ appear: appear = false, children: children, exitThenEnter: exitThenEnter })=>{
    const [stateChildren, setChildren] = (0, $4tluv.useState)([
        null,
        children
    ]);
    const [exitingChildren, setExitingChildren] = (0, $4tluv.useState)([]);
    const [defaultContext, setDefaultContext] = (0, $4tluv.useState)(()=>({
            appear: appear,
            isExiting: false
        }));
    (0, $4tluv.useEffect)(()=>{
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    const [previousChildren, currentChildren] = stateChildren;
    const previous = $f2c699800b96e918$var$childrenToArray(previousChildren);
    const current = $f2c699800b96e918$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    const missingKeys = $f2c699800b96e918$var$getMissingKeys(current, previous);
    const isSomeChildRemoved = !!missingKeys.size;
    let visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $f2c699800b96e918$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $3X3Vo.fg)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            const nextExitingChildren = visibleChildren.filter((child)=>missingKeys.has(child.key));
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map((child)=>{
        const isExiting = missingKeys.has(child.key);
        return $f2c699800b96e918$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? ()=>{
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map((child)=>$f2c699800b96e918$var$wrapChildWithContextProvider(child, defaultContext));
    return visibleChildren;
});
const $f2c699800b96e918$export$3b6f38abbdcbd000 = ()=>{
    return (0, $4tluv.useContext)($f2c699800b96e918$var$ExitingContext);
};
$f2c699800b96e918$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $f2c699800b96e918$export$2e2bcd8739ae039 = $f2c699800b96e918$var$ExitingPersistence;

});

parcelRegister("ka1iJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $af58849f7ff9c9fe$export$2e2bcd8739ae039);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $cZhr8 = parcelRequire("cZhr8");
const $af58849f7ff9c9fe$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ const $af58849f7ff9c9fe$var$FadeIn = ({ children: children, duration: duration = 'large', entranceDirection: entranceDirection, exitDirection: exitDirection, distance: distance = 'proportional', onFinish: onFinish, isPaused: isPaused })=>{
    const invertedEntranceDirection = entranceDirection !== undefined ? $af58849f7ff9c9fe$var$invertedDirection[entranceDirection] : undefined;
    const isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? `fade-out-from-${exitDirection || invertedEntranceDirection}${distance === 'proportional' ? '' : '-constant'}` : 'fade-out';
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $cZhr8.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? `fade-in-from-${entranceDirection}${distance === 'proportional' ? '' : '-constant'}` : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused,
        children: children
    });
};
var $af58849f7ff9c9fe$export$2e2bcd8739ae039 = $af58849f7ff9c9fe$var$FadeIn;

});
parcelRegister("cZhr8", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c58c72a2b33f686$export$2e2bcd8739ae039);
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $4tluv = parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");

var $cGlqj = parcelRequire("cGlqj");

var $g7qa1 = parcelRequire("g7qa1");

var $504fE = parcelRequire("504fE");

var $1F7MK = parcelRequire("1F7MK");

var $lWeRs = parcelRequire("lWeRs");
const $9c58c72a2b33f686$var$zoomIn = null;
const $9c58c72a2b33f686$var$zoomOut = null;
const $9c58c72a2b33f686$var$fadeIn = null;
const $9c58c72a2b33f686$var$fadeOut = null;
const $9c58c72a2b33f686$var$fadeInFromTop = null;
const $9c58c72a2b33f686$var$fadeOutFromTop = null;
const $9c58c72a2b33f686$var$fadeInFromLeft = null;
const $9c58c72a2b33f686$var$fadeOutFromLeft = null;
const $9c58c72a2b33f686$var$fadeInFromBottom = null;
const $9c58c72a2b33f686$var$fadeOutFromBottom = null;
const $9c58c72a2b33f686$var$fadeInFromRight = null;
const $9c58c72a2b33f686$var$fadeOutFromRight = null;
const $9c58c72a2b33f686$var$fadeInFromTopConstant = null;
const $9c58c72a2b33f686$var$fadeOutFromTopConstant = null;
const $9c58c72a2b33f686$var$fadeInFromLeftConstant = null;
const $9c58c72a2b33f686$var$fadeOutFromLeftConstant = null;
const $9c58c72a2b33f686$var$fadeInFromBottomConstant = null;
const $9c58c72a2b33f686$var$fadeOutFromBottomConstant = null;
const $9c58c72a2b33f686$var$fadeInFromRightConstant = null;
const $9c58c72a2b33f686$var$fadeOutFromRightConstant = null;
const $9c58c72a2b33f686$var$slideInFromTop = null;
const $9c58c72a2b33f686$var$slideOutFromTop = null;
const $9c58c72a2b33f686$var$slideInFromRight = null;
const $9c58c72a2b33f686$var$slideOutFromRight = null;
const $9c58c72a2b33f686$var$slideInFromBottom = null;
const $9c58c72a2b33f686$var$slideOutFromBottom = null;
const $9c58c72a2b33f686$var$slideInFromLeft = null;
const $9c58c72a2b33f686$var$slideOutFromLeft = null;
/**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ const $9c58c72a2b33f686$var$EnteringMotion = ({ children: children, animationTimingFunction: animationTimingFunction, animationTimingFunctionExiting: animationTimingFunctionExiting = animationTimingFunction, enteringAnimation: enteringAnimation, exitingAnimation: exitingAnimation = enteringAnimation, isPaused: isPaused, onFinish: onFinishMotion, duration: duration = 'large' })=>{
    const staggered = (0, $lWeRs.useStaggeredEntrance)();
    const { isExiting: isExiting, onFinish: onExitFinished, appear: appear } = (0, $1F7MK.useExitingPersistence)();
    const setTimeout = (0, $504fE.useSetTimeout)();
    const paused = isPaused || !staggered.isReady;
    const delay = isExiting ? 0 : staggered.delay;
    const state = isExiting ? 'exiting' : 'entering';
    const [hasAnimationStyles, setHasAnimationStyles] = (0, $4tluv.useState)(appear);
    (0, $4tluv.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ const onAnimationEnd = ()=>{
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished?.();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion?.(state);
        };
        if ((0, $cGlqj.isReducedMotion)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $g7qa1.exitingDurations)[duration] : (0, $g7qa1.durations)[duration] + delay);
        return ()=>{
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $jAkMr.default)([
            (0, $jAkMr.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $jAkMr.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $jAkMr.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $jAkMr.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $jAkMr.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $jAkMr.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $jAkMr.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $jAkMr.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $jAkMr.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $jAkMr.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $jAkMr.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $jAkMr.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $jAkMr.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $jAkMr.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $jAkMr.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $jAkMr.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $jAkMr.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $jAkMr.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $jAkMr.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $jAkMr.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $jAkMr.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $jAkMr.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $jAkMr.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $jAkMr.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $jAkMr.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $jAkMr.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $jAkMr.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $jAkMr.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $jAkMr.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $jAkMr.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $jAkMr.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $jAkMr.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $jAkMr.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $jAkMr.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $jAkMr.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $jAkMr.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $jAkMr.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $jAkMr.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $jAkMr.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $jAkMr.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $jAkMr.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $jAkMr.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $jAkMr.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $jAkMr.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $jAkMr.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $jAkMr.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $jAkMr.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $jAkMr.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $jAkMr.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $jAkMr.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $jAkMr.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: `${delay}ms`
        }
    }, state);
};
var $9c58c72a2b33f686$export$2e2bcd8739ae039 = $9c58c72a2b33f686$var$EnteringMotion;

});
parcelRegister("cGlqj", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", () => $d92ff708f5961c01$export$b7baf7667a68d87c);

var $4tluv = parcelRequire("4tluv");

var $Hyfcf = parcelRequire("Hyfcf");

var $1Vuae = parcelRequire("1Vuae");
const $d92ff708f5961c01$var$isMatchMediaAvailable = ()=>typeof window !== 'undefined' && 'matchMedia' in window;
const $d92ff708f5961c01$export$b7baf7667a68d87c = ()=>{
    if (!$d92ff708f5961c01$var$isMatchMediaAvailable()) return false;
    const { matches: matches } = window.matchMedia('(prefers-reduced-motion: reduce)');
    return matches;
};
const $d92ff708f5961c01$export$c537e63161742ce3 = ()=>{
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $4tluv.useState)($d92ff708f5961c01$export$b7baf7667a68d87c);
    (0, $4tluv.useEffect)(()=>{
        if (!$d92ff708f5961c01$var$isMatchMediaAvailable()) return;
        const mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        const onChange = (event)=>setPrefersReducedMotion(event.matches);
        return (0, $Hyfcf.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
const $d92ff708f5961c01$export$ff7706047246b98b = ()=>(0, $1Vuae.reduceMotionAsPerUserPreference);

});
parcelRegister("1Vuae", function(module, exports) {
$parcel$export(module.exports, "reduceMotionAsPerUserPreference", () => $e2078267017f6e8f$export$f0f789643ba5a83c);
/**
 * Use for any CSS based motion (animation or transition).
 * Always put at the end of your declaration for correct use of the cascade.
 * Reduced motion preference is generally set through OS preferences/settings.
 *
 * @deprecated This is not fully compatible with Compiled CSS and will be removed in the future.
 * You should hardcode the `prefers-reduced-motion` media query in your file instead.
 */ const $e2078267017f6e8f$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};

});


parcelRegister("g7qa1", function(module, exports) {
$parcel$export(module.exports, "durations", () => $575b6a25f726b33e$export$38b928a7167ce124);
$parcel$export(module.exports, "exitingDurations", () => $575b6a25f726b33e$export$30fa1a2e62ae150c);
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ const $575b6a25f726b33e$export$368bacef0dacbe05 = 25;
const $575b6a25f726b33e$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ const $575b6a25f726b33e$var$EXITING_MOTION_MULTIPLIER = 0.5;
const $575b6a25f726b33e$export$30fa1a2e62ae150c = {
    none: $575b6a25f726b33e$export$38b928a7167ce124.none,
    small: $575b6a25f726b33e$export$38b928a7167ce124.small * $575b6a25f726b33e$var$EXITING_MOTION_MULTIPLIER,
    medium: $575b6a25f726b33e$export$38b928a7167ce124.medium * $575b6a25f726b33e$var$EXITING_MOTION_MULTIPLIER,
    large: $575b6a25f726b33e$export$38b928a7167ce124.large * $575b6a25f726b33e$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("504fE", function(module, exports) {
$parcel$export(module.exports, "useRequestAnimationFrame", () => $4076566d0a8b7924$export$1775f27e7c8051ca);
$parcel$export(module.exports, "useSetTimeout", () => $4076566d0a8b7924$export$4f34107a2b00f39c);

var $4tluv = parcelRequire("4tluv");
const $4076566d0a8b7924$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $4076566d0a8b7924$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $4tluv.useRef)([]);
    (0, $4tluv.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $4076566d0a8b7924$var$getHookDeps(opts));
    return (0, $4tluv.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
const $4076566d0a8b7924$export$4f34107a2b00f39c = (opts = {
    cleanup: 'unmount'
})=>{
    const timeouts = (0, $4tluv.useRef)([]);
    (0, $4tluv.useEffect)(()=>{
        return ()=>{
            if (timeouts.current.length) {
                timeouts.current.forEach((id)=>clearTimeout(id));
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $4076566d0a8b7924$var$getHookDeps(opts));
    return (0, $4tluv.useCallback)((handler, timeout, ...args)=>{
        const id = setTimeout(()=>{
            timeouts.current = timeouts.current.filter((timeoutId)=>timeoutId !== id);
            handler();
        }, timeout, ...args);
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("lWeRs", function(module, exports) {
$parcel$export(module.exports, "useStaggeredEntrance", () => $65489c8ec3f16c16$export$25c7213fc07ec080);
$parcel$export(module.exports, "default", () => $65489c8ec3f16c16$export$2e2bcd8739ae039);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $ccErM = parcelRequire("ccErM");

var $eeuEd = parcelRequire("eeuEd");

var $j8eZd = parcelRequire("j8eZd");
const $65489c8ec3f16c16$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $4tluv.createContext)(()=>({
        isReady: true,
        delay: 0,
        ref: (0, $ccErM.default)
    }));
const $65489c8ec3f16c16$export$25c7213fc07ec080 = ()=>{
    const indentifier = (0, $j8eZd.useUniqueId)();
    const context = (0, $4tluv.useContext)($65489c8ec3f16c16$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ const $65489c8ec3f16c16$var$StaggeredEntrance = ({ children: children, column: column, columns: columns = 'responsive', delayStep: delayStep = 50 })=>{
    const elementRefs = (0, $4tluv.useRef)([]);
    const indexes = [];
    const [actualColumns, setActualColumns] = (0, $4tluv.useState)(()=>{
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    });
    (0, $eeuEd.useLayoutEffect)(()=>{
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            let currentTop = 0;
            let numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(let i = 0; i < elementRefs.current.length; i++){
                const child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $2iln5.jsx)($65489c8ec3f16c16$var$StaggeredEntranceContext.Provider, {
        value: (id)=>{
            if (!indexes.includes(id)) indexes.push(id);
            const isReady = actualColumns > 0;
            const index = indexes.indexOf(id);
            const currentColumn = column || index % actualColumns;
            const currentRow = Math.floor(index / actualColumns);
            const distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            const delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: (element)=>elementRefs.current[index] = element
            };
        },
        children: children
    });
};
var $65489c8ec3f16c16$export$2e2bcd8739ae039 = $65489c8ec3f16c16$var$StaggeredEntrance;

});
parcelRegister("eeuEd", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $831d60680257e2d0$export$e5c5a5f917a5871c);

var $4tluv = parcelRequire("4tluv");
const $831d60680257e2d0$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $4tluv.useEffect) : (0, $4tluv.useLayoutEffect);

});

parcelRegister("j8eZd", function(module, exports) {
$parcel$export(module.exports, "useUniqueId", () => $9b80b21f05e1670a$export$c485849f2e393253);
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $4tluv = parcelRequire("4tluv");
function $9b80b21f05e1670a$export$c485849f2e393253() {
    const identifier = (0, $4tluv.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("kE20X", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $461477808fec77bf$export$badac9ada3a0bdf9);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $5TcPm = parcelRequire("5TcPm");

var $hMU50 = parcelRequire("hMU50");

const $461477808fec77bf$var$viewportPadding = 5;
const $461477808fec77bf$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $461477808fec77bf$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $461477808fec77bf$var$defaultChildrenFn() {
    return null;
}
const $461477808fec77bf$var$defaultOffset = [
    0,
    8
];
function $461477808fec77bf$export$badac9ada3a0bdf9({ children: children = $461477808fec77bf$var$defaultChildrenFn, offset: offset = $461477808fec77bf$var$defaultOffset, placement: placement = 'bottom-start', referenceElement: referenceElement, modifiers: modifiers, strategy: strategy = 'fixed', shouldFitViewport: shouldFitViewport = false }) {
    const [offsetX, offsetY] = offset;
    const internalModifiers = (0, $4tluv.useMemo)(()=>{
        const preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $461477808fec77bf$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        const offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        const maxSizeModifiers = shouldFitViewport ? (0, $hMU50.getMaxSizeModifiers)({
            viewportPadding: $461477808fec77bf$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [
            ...$461477808fec77bf$var$constantModifiers,
            preventOverflowModifier,
            offsetModifier,
            ...maxSizeModifiers
        ];
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    const mergedModifiers = (0, $4tluv.useMemo)(()=>{
        if (modifiers == null) return internalModifiers;
        return [
            ...internalModifiers,
            ...modifiers
        ];
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $5TcPm.Popper), {
        // @ts-expect-error - No overload matches this call
        // This error was introduced after upgrading to TypeScript 5
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement,
        children: children
    });
}

});
parcelRegister("hMU50", function(module, exports) {
$parcel$export(module.exports, "getMaxSizeModifiers", () => $07040962035b73ee$export$6d8c2b45c99d6e3f);
function $07040962035b73ee$export$6d8c2b45c99d6e3f({ viewportPadding: viewportPadding }) {
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn ({ state: state, name: name }) {
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn ({ state: state }) {
                const data = state.modifiersData.maxSizeData;
                if (typeof data?.viewport?.width !== 'number' || typeof data?.viewport?.height !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                const { viewport: viewport } = data;
                const { popperOffsets: popperOffsets = {
                    x: 0,
                    y: 0
                } } = state.modifiersData;
                const [basePlacement] = state.placement.split('-');
                const placementOffset = state.modifiersData?.offset?.[state.placement] ?? {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                let maxWidth = viewport.width - 2 * viewportPadding;
                let maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = `${maxWidth}px`;
                state.styles.popper.maxHeight = `${maxHeight}px`;
            }
        }
    ];
}

});


parcelRegister("gkJgm", function(module, exports) {
$parcel$export(module.exports, "default", () => $b077df1ffa3f0ac6$export$2e2bcd8739ae039);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $3X3Vo = parcelRequire("3X3Vo");

var $5A9AQ = parcelRequire("5A9AQ");

var $gJkep = parcelRequire("gJkep");

var $fAfK5 = parcelRequire("fAfK5");

var $iOg6u = parcelRequire("iOg6u");
function $b077df1ffa3f0ac6$export$2e2bcd8739ae039({ zIndex: zIndex = 0, children: children, mountStrategy: mountStrategy = 'effect', isClosed: isClosed = false }) {
    const isSubsequentRender = (0, $fAfK5.default)(mountStrategy);
    (0, $iOg6u.default)(zIndex);
    return !(0, $3X3Vo.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, $2iln5.jsx)((0, $5A9AQ.default), {
        zIndex: zIndex,
        isClosed: isClosed,
        children: children
    }) : null : /*#__PURE__*/ (0, $2iln5.jsx)((0, $gJkep.default), {
        zIndex: zIndex,
        isClosed: isClosed,
        children: children
    });
}

});
parcelRegister("5A9AQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1801041471511dca$export$2e2bcd8739ae039);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $lImzW = parcelRequire("lImzW");

var $9hAT9 = parcelRequire("9hAT9");
var $85lGX = parcelRequire("85lGX");

var $3X3Vo = parcelRequire("3X3Vo");

var $iN6h6 = parcelRequire("iN6h6");

var $bWMyp = parcelRequire("bWMyp");

var $6xxfy = parcelRequire("6xxfy");
function $1801041471511dca$export$2e2bcd8739ae039(props) {
    const { zIndex: zIndex, children: children, isClosed: isClosed = false } = props;
    const container = (0, $4tluv.useMemo)(()=>(0, $bWMyp.createContainer)(zIndex), [
        zIndex
    ]);
    const colorMode = (0, $85lGX.useColorMode)();
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $iN6h6.appendPortalContainerIfNotAppended)(container);
    (0, $4tluv.useEffect)(()=>{
        if ((0, $3X3Vo.fg)('import_into_jsm_in_template_gallery_killswitch')) {
            if (isClosed) (0, $6xxfy.removePortalContainer)(container);
        }
    }, [
        isClosed,
        container
    ]);
    (0, $4tluv.useEffect)(()=>{
        return ()=>{
            (0, $6xxfy.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $lImzW.createPortal)(colorMode ? /*#__PURE__*/ (0, $2iln5.jsx)((0, $9hAT9.default), {
        defaultColorMode: colorMode,
        children: children
    }) : children, container);
}

});
parcelRegister("9hAT9", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ca23de4441e491a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $jAkMr = parcelRequire("jAkMr");

var $4tluv = parcelRequire("4tluv");

var $Hyfcf = parcelRequire("Hyfcf");

var $jXZTR = parcelRequire("jXZTR");
var $1aTSX = parcelRequire("1aTSX");
var $e5lMD = parcelRequire("e5lMD");

var $1nUi7 = parcelRequire("1nUi7");

var $gqObd = parcelRequire("gqObd");

var $31P6q = parcelRequire("31P6q");

var $hOYM3 = parcelRequire("hOYM3");

var $1ihC9 = parcelRequire("1ihC9");

var $jpyIR = parcelRequire("jpyIR");

var $gIhwg = parcelRequire("gIhwg");
const $2ca23de4441e491a$var$defaultThemeSettings = {
    dark: 'dark',
    light: 'light',
    spacing: 'spacing',
    typography: 'typography'
};
const $2ca23de4441e491a$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
const $2ca23de4441e491a$var$prefersDarkModeMql = $2ca23de4441e491a$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $2ca23de4441e491a$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $2ca23de4441e491a$var$prefersDarkModeMql?.matches ? 'dark' : 'light';
    return colorMode;
}
const $2ca23de4441e491a$var$contentStyles = {
    body: "_1e0c1bgi"
};
/**
 * __Theme provider__
 *
 * Provides global theming configuration.
 */ function $2ca23de4441e491a$var$ThemeProvider({ children: children, defaultColorMode: defaultColorMode = 'auto', defaultTheme: defaultTheme }) {
    const [chosenColorMode, setChosenColorMode] = (0, $4tluv.useState)(defaultColorMode);
    const [reconciledColorMode, setReconciledColorMode] = (0, $4tluv.useState)($2ca23de4441e491a$var$getReconciledColorMode(defaultColorMode));
    const [theme, setTheme] = (0, $4tluv.useState)(()=>({
            ...$2ca23de4441e491a$var$defaultThemeSettings,
            ...defaultTheme
        }));
    const setColorMode = (0, $4tluv.useCallback)((colorMode)=>{
        setChosenColorMode(colorMode);
        setReconciledColorMode($2ca23de4441e491a$var$getReconciledColorMode(colorMode));
    }, []);
    const setPartialTheme = (0, $4tluv.useCallback)((nextTheme)=>{
        setTheme((theme)=>({
                ...theme,
                ...nextTheme
            }));
    }, []);
    const lastSetGlobalThemePromiseRef = (0, $4tluv.useRef)(null);
    const isInsideAppProvider = (0, $1nUi7.useIsInsideAppProvider)();
    const isAppProviderThemingEnabled = (0, $1nUi7.useIsAppProviderThemingEnabled)();
    const isInsideThemeProvider = (0, $jpyIR.useIsInsideThemeProvider)();
    /**
   * A top-level ThemeProvider is detected by being the first ThemeProvider inside an AppProvider.
   *
   * This will not use sub-tree theming but instead set the global theme state using the
   * `@atlaskit/tokens` APIs, as it's required for styling root `html` and `body` elements
   * for compatibility with `@atlaskit/css-reset`.
   *
   * In the future we could consider moving away from DOM mutations and require AppProvider to wrap
   * `html` in order to apply global theme state, which would allow a more consistent approach to
   * theme loading.
   */ const isRootThemeProvider = isInsideAppProvider && !isInsideThemeProvider && isAppProviderThemingEnabled;
    (0, $4tluv.useEffect)(()=>{
        if (isRootThemeProvider) {
            /**
       * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
       * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
       * `data-color-mode` attribute on the root element).
       *
       * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
       * applying the new theme.
       *
       * Without this, we can end up in the following scenario:
       * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
       * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
       * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
       * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
       */ const cleanupLastFnCall = async ()=>{
                if (lastSetGlobalThemePromiseRef.current) {
                    const unbindFn = await lastSetGlobalThemePromiseRef.current;
                    unbindFn();
                    lastSetGlobalThemePromiseRef.current = null;
                }
            };
            const safelySetGlobalTheme = async ()=>{
                await cleanupLastFnCall();
                const promise = (0, $1aTSX.default)({
                    ...theme,
                    colorMode: reconciledColorMode
                });
                lastSetGlobalThemePromiseRef.current = promise;
            };
            safelySetGlobalTheme();
            return function cleanup() {
                cleanupLastFnCall();
            };
        } else // For other theme providers (whether outside AppProvider or nested inside a ThemeProvider),
        // we treat them as sub-tree themes that do not load global theme state.
        (0, $gIhwg.loadAndMountThemes)(theme);
    }, [
        isInsideAppProvider,
        isInsideThemeProvider,
        isRootThemeProvider,
        reconciledColorMode,
        theme
    ]);
    (0, $4tluv.useEffect)(()=>{
        if (!$2ca23de4441e491a$var$prefersDarkModeMql) return;
        const unbindListener = (0, $Hyfcf.bind)($2ca23de4441e491a$var$prefersDarkModeMql, {
            type: 'change',
            listener: (event)=>{
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    const attrs = {
        ...(0, $jXZTR.default)({
            ...theme,
            colorMode: reconciledColorMode
        }),
        [(0, $e5lMD.SUBTREE_THEME_ATTRIBUTE)]: true
    };
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $31P6q.InsideThemeProviderContext).Provider, {
        value: true,
        children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $gqObd.ColorModeContext).Provider, {
            value: reconciledColorMode,
            children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $hOYM3.SetColorModeContext).Provider, {
                value: setColorMode,
                children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $1ihC9.ThemeContext).Provider, {
                    value: theme,
                    children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $1ihC9.SetThemeContext).Provider, {
                        value: setPartialTheme,
                        children: !isRootThemeProvider ? /*#__PURE__*/ (0, $2iln5.jsx)("div", {
                            ...attrs,
                            className: (0, $jAkMr.default)([
                                $2ca23de4441e491a$var$contentStyles.body
                            ]),
                            children: children
                        }) : children
                    })
                })
            })
        })
    });
}
var $2ca23de4441e491a$export$2e2bcd8739ae039 = $2ca23de4441e491a$var$ThemeProvider;

});
parcelRegister("1nUi7", function(module, exports) {
$parcel$export(module.exports, "useIsInsideAppProvider", () => $928f638b8d2d3ffd$export$26aa23367bfbab0e);
$parcel$export(module.exports, "useIsAppProviderThemingEnabled", () => $928f638b8d2d3ffd$export$a782702263f77544);

var $4tluv = parcelRequire("4tluv");

var $1f88O = parcelRequire("1f88O");

var $kXhfm = parcelRequire("kXhfm");
const $928f638b8d2d3ffd$export$26aa23367bfbab0e = ()=>{
    return (0, $4tluv.useContext)((0, $kXhfm.InsideAppProviderContext));
};
const $928f638b8d2d3ffd$export$a782702263f77544 = ()=>{
    return (0, $4tluv.useContext)((0, $1f88O.AppProviderThemingEnabledContext));
};

});
parcelRegister("1f88O", function(module, exports) {
$parcel$export(module.exports, "AppProviderThemingEnabledContext", () => $5c00b57f455d16df$export$d2def9838ca456c0);

var $4tluv = parcelRequire("4tluv");
const $5c00b57f455d16df$export$d2def9838ca456c0 = /*#__PURE__*/ (0, $4tluv.createContext)(false);

});

parcelRegister("kXhfm", function(module, exports) {
$parcel$export(module.exports, "InsideAppProviderContext", () => $3f5a6bb8ece1f6a4$export$7981b2444296e410);

var $4tluv = parcelRequire("4tluv");
const $3f5a6bb8ece1f6a4$export$7981b2444296e410 = /*#__PURE__*/ (0, $4tluv.createContext)(false);

});


parcelRegister("gqObd", function(module, exports) {
$parcel$export(module.exports, "ColorModeContext", () => $a3181447305e0f6d$export$49ddd74a6729fdb0);

var $4tluv = parcelRequire("4tluv");
const $a3181447305e0f6d$export$49ddd74a6729fdb0 = /*#__PURE__*/ (0, $4tluv.createContext)(undefined);

});

parcelRegister("31P6q", function(module, exports) {
$parcel$export(module.exports, "InsideThemeProviderContext", () => $5c5e882cfdbf7417$export$332347eeb335453c);

var $4tluv = parcelRequire("4tluv");
const $5c5e882cfdbf7417$export$332347eeb335453c = /*#__PURE__*/ (0, $4tluv.createContext)(false);

});

parcelRegister("hOYM3", function(module, exports) {
$parcel$export(module.exports, "SetColorModeContext", () => $dda1d6b6a677d4a5$export$b06130bad0bbc70f);

var $4tluv = parcelRequire("4tluv");
const $dda1d6b6a677d4a5$export$b06130bad0bbc70f = /*#__PURE__*/ (0, $4tluv.createContext)(undefined);

});

parcelRegister("1ihC9", function(module, exports) {
$parcel$export(module.exports, "ThemeContext", () => $d2e7127d9f7d28e6$export$2c657da244d00bd6);
$parcel$export(module.exports, "SetThemeContext", () => $d2e7127d9f7d28e6$export$f7a97b47760e2a13);

var $4tluv = parcelRequire("4tluv");
const $d2e7127d9f7d28e6$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $4tluv.createContext)(undefined);
const $d2e7127d9f7d28e6$export$f7a97b47760e2a13 = /*#__PURE__*/ (0, $4tluv.createContext)(undefined);

});

parcelRegister("jpyIR", function(module, exports) {
$parcel$export(module.exports, "useIsInsideThemeProvider", () => $db9123ab1fcf78f9$export$7ca11437599d653d);

var $4tluv = parcelRequire("4tluv");

var $31P6q = parcelRequire("31P6q");
const $db9123ab1fcf78f9$export$7ca11437599d653d = ()=>{
    return (0, $4tluv.useContext)((0, $31P6q.InsideThemeProviderContext)) ?? false;
};

});

parcelRegister("gIhwg", function(module, exports) {
$parcel$export(module.exports, "loadAndMountThemes", () => $f8ae8761de1977d2$export$7d4a7e812d176b24);

var $1iuUn = parcelRequire("1iuUn");

var $hXG9T = parcelRequire("hXG9T");

var $ejjYB = parcelRequire("ejjYB");
const $f8ae8761de1977d2$var$loadThemeCss = async (themeId)=>{
    // Prevent duplicate loading of themes
    if ((0, $ejjYB.isThemeMounted)(themeId)) return;
    // Gracefully handles falsy values like `null` and `undefined` when makers ignore
    // TS to avoid loading default themes.
    if (!themeId) return;
    const { default: themeCss } = await (0, $hXG9T.default)[themeId]();
    return themeCss;
};
const $f8ae8761de1977d2$var$mountThemeCss = async (css, themeId)=>{
    // SSR-safe: Only mount on client side
    const doc = (0, $1iuUn.getDocument)();
    if (!doc) return;
    const style = doc.createElement('style');
    style.textContent = css;
    style.dataset.theme = themeId;
    // Prevent duplicate mounting of themes.
    // It's possible the theme was already being loaded elsewhere.
    if ((0, $ejjYB.isThemeMounted)(themeId)) return;
    doc.head.appendChild(style);
};
const $f8ae8761de1977d2$var$loadAndMountThemeCss = async (themeId)=>{
    const themeCss = await $f8ae8761de1977d2$var$loadThemeCss(themeId);
    if (!themeCss) return;
    $f8ae8761de1977d2$var$mountThemeCss(themeCss, themeId);
};
const $f8ae8761de1977d2$export$7d4a7e812d176b24 = async (theme)=>{
    const themesToLoad = Object.values(theme).filter((themeId)=>!!themeId);
    themesToLoad.forEach($f8ae8761de1977d2$var$loadAndMountThemeCss);
};

});
parcelRegister("ejjYB", function(module, exports) {
$parcel$export(module.exports, "isThemeMounted", () => $ee997d70bb9400da$export$835a0dc855d02822);

var $1iuUn = parcelRequire("1iuUn");

var $e5lMD = parcelRequire("e5lMD");
function $ee997d70bb9400da$export$835a0dc855d02822(themeId) {
    const doc = (0, $1iuUn.getDocument)();
    if (!doc) return false;
    return doc.head.querySelector(`style[${(0, $e5lMD.THEME_DATA_ATTRIBUTE)}="${themeId}"]`);
}

});



parcelRegister("85lGX", function(module, exports) {
$parcel$export(module.exports, "useColorMode", () => $af29d2a9b2778eb7$export$20f3076712c8dfa);

var $4tluv = parcelRequire("4tluv");

var $xG0ax = parcelRequire("xG0ax");
var $75X5e = parcelRequire("75X5e");

var $gqObd = parcelRequire("gqObd");
function $af29d2a9b2778eb7$export$20f3076712c8dfa() {
    const value = (0, $4tluv.useContext)((0, $gqObd.ColorModeContext));
    // TODO: This will only return 'light' or 'dark' but never 'auto', which in some cases
    // may be desirable. We should consider returning both the reconciled color mode (e.g. 'light' or 'dark') and the selected color mode ("auto").
    const theme = (0, $xG0ax.default)();
    const [resolvedColorMode, setResolvedColorMode] = (0, $4tluv.useState)(theme?.colorMode || 'light');
    (0, $4tluv.useEffect)(()=>{
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        const observer = new (0, $75X5e.default)((theme)=>{
            setResolvedColorMode(theme?.colorMode || 'light');
        });
        observer.observe();
        return ()=>observer.disconnect();
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}

});

parcelRegister("iN6h6", function(module, exports) {
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", () => $a80ac7f4023b86e1$export$c582005add11e141);

var $byepm = parcelRequire("byepm");

var $3G34t = parcelRequire("3G34t");
const $a80ac7f4023b86e1$var$getPortalParent = ()=>{
    const parentElement = document.querySelector((0, $byepm.portalParentSelector));
    if (!parentElement) {
        const parent = document.createElement('div');
        parent.className = (0, $byepm.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (0, $3G34t.getBody)()?.appendChild(parent);
        return parent;
    }
    return parentElement;
};
const $a80ac7f4023b86e1$export$c582005add11e141 = (container)=>{
    if (!container.parentElement) $a80ac7f4023b86e1$var$getPortalParent().appendChild(container);
};

});
parcelRegister("byepm", function(module, exports) {
$parcel$export(module.exports, "portalParentClassName", () => $2fbabb8e6c2fa070$export$e4c79eb95c23a0da);
$parcel$export(module.exports, "portalParentSelector", () => $2fbabb8e6c2fa070$export$72f415121273627e);
$parcel$export(module.exports, "portalClassName", () => $2fbabb8e6c2fa070$export$13f57c02915787b3);
const $2fbabb8e6c2fa070$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $2fbabb8e6c2fa070$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $2fbabb8e6c2fa070$export$13f57c02915787b3 = 'atlaskit-portal';

});

parcelRegister("3G34t", function(module, exports) {
$parcel$export(module.exports, "getBody", () => $a0d62ece437cd5ca$export$135b49d4bc2964c6);
/**
 * Returns document body element
 * @return {number} - The document body element
 */ const $a0d62ece437cd5ca$export$135b49d4bc2964c6 = ()=>{
    return document.body;
};

});


parcelRegister("bWMyp", function(module, exports) {
$parcel$export(module.exports, "createContainer", () => $f320dd656de5a599$export$26ae5ca175b4ec5a);

var $byepm = parcelRequire("byepm");
const $f320dd656de5a599$export$26ae5ca175b4ec5a = (zIndex)=>{
    const container = document.createElement('div');
    container.className = (0, $byepm.portalClassName);
    container.style.zIndex = `${zIndex}`;
    return container;
};

});

parcelRegister("6xxfy", function(module, exports) {
$parcel$export(module.exports, "removePortalContainer", () => $b2b748007e036e13$export$da99f98bf3fe55b3);

var $byepm = parcelRequire("byepm");

var $3G34t = parcelRequire("3G34t");
const $b2b748007e036e13$var$getPortalParent = ()=>{
    const parentElement = document.querySelector((0, $byepm.portalParentSelector));
    if (!parentElement) {
        const parent = document.createElement('div');
        parent.className = (0, $byepm.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (0, $3G34t.getBody)()?.appendChild(parent);
        return parent;
    }
    return parentElement;
};
const $b2b748007e036e13$export$da99f98bf3fe55b3 = (container)=>{
    const parent = $b2b748007e036e13$var$getPortalParent();
    if (parent.contains(container)) parent.removeChild(container);
};

});


parcelRegister("gJkep", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8e09e9d4785513c$export$2e2bcd8739ae039);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $lImzW = parcelRequire("lImzW");

var $9hAT9 = parcelRequire("9hAT9");
var $85lGX = parcelRequire("85lGX");

var $3X3Vo = parcelRequire("3X3Vo");

var $6X8Dq = parcelRequire("6X8Dq");

var $kBhYt = parcelRequire("kBhYt");

var $cGMmH = parcelRequire("cGMmH");

var $f4Sih = parcelRequire("f4Sih");
function $e8e09e9d4785513c$export$2e2bcd8739ae039(props) {
    const { zIndex: zIndex, children: children, isClosed: isClosed } = props;
    const [atlaskitPortal, setAtlaskitPortal] = (0, $4tluv.useState)(null);
    const colorMode = (0, $85lGX.useColorMode)();
    (0, $6X8Dq.useIsomorphicLayoutEffect)(()=>{
        if ((0, $3X3Vo.fg)('import_into_jsm_in_template_gallery_killswitch')) {
            if (!isClosed) {
                let tempPortalContainer = (0, $kBhYt.createAtlaskitPortal)(zIndex);
                setAtlaskitPortal(tempPortalContainer);
                const portalParent = (0, $cGMmH.createPortalParent)();
                if (!tempPortalContainer || !portalParent) return;
                portalParent.appendChild(tempPortalContainer);
                return ()=>{
                    if (portalParent) {
                        portalParent.removeChild(tempPortalContainer);
                        !portalParent.hasChildNodes() && (0, $f4Sih.removePortalParent)(portalParent);
                    }
                    setAtlaskitPortal(null);
                };
            }
        } else {
            const tempPortalContainer = (0, $kBhYt.createAtlaskitPortal)(zIndex);
            setAtlaskitPortal(tempPortalContainer);
            const portalParent = (0, $cGMmH.createPortalParent)();
            if (!tempPortalContainer || !portalParent) return;
            portalParent.appendChild(tempPortalContainer);
            return ()=>{
                if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
                setAtlaskitPortal(null);
            };
        }
    }, [
        zIndex,
        isClosed,
        (0, $3X3Vo.fg)
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ const suspendedChildren = /*#__PURE__*/ (0, $2iln5.jsx)((0, $4tluv.Suspense), {
        fallback: null,
        children: colorMode ? /*#__PURE__*/ (0, $2iln5.jsx)((0, $9hAT9.default), {
            defaultColorMode: colorMode,
            children: children
        }) : children
    });
    return atlaskitPortal ? /*#__PURE__*/ (0, $lImzW.createPortal)(suspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("6X8Dq", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $81132801b7551d55$export$700979bc83e7db82);

var $4tluv = parcelRequire("4tluv");
const $81132801b7551d55$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $4tluv.useLayoutEffect) : (0, $4tluv.useEffect);

});

parcelRegister("kBhYt", function(module, exports) {
$parcel$export(module.exports, "createAtlaskitPortal", () => $5f801021696ddd99$export$fef014d7cef9e543);

var $byepm = parcelRequire("byepm");
const $5f801021696ddd99$var$isDocumentDefined = ()=>{
    return document !== undefined;
};
const $5f801021696ddd99$export$fef014d7cef9e543 = (zIndex)=>{
    //atlaskit-portal div
    if ($5f801021696ddd99$var$isDocumentDefined()) {
        const atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $byepm.portalClassName);
        atlaskitportal.style.zIndex = `${zIndex}`;
        return atlaskitportal;
    }
    return;
};

});

parcelRegister("cGMmH", function(module, exports) {
$parcel$export(module.exports, "createPortalParent", () => $65276a7521e6b828$export$95029ca7aca2989e);

var $byepm = parcelRequire("byepm");

var $3G34t = parcelRequire("3G34t");
const $65276a7521e6b828$var$isDocumentDefined = ()=>{
    return document !== undefined;
};
const $65276a7521e6b828$export$95029ca7aca2989e = ()=>{
    //atlaskit-portal-container div
    if ($65276a7521e6b828$var$isDocumentDefined()) {
        const parentElement = document.querySelector((0, $byepm.portalParentSelector));
        if (!parentElement) {
            const parent = document.createElement('div');
            parent.className = (0, $byepm.portalParentClassName);
            parent.style.display = 'flex';
            (0, $3G34t.getBody)()?.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};

});

parcelRegister("f4Sih", function(module, exports) {
$parcel$export(module.exports, "removePortalParent", () => $c8499cb964818474$export$7b20876b2769b301);

var $3G34t = parcelRequire("3G34t");
const $c8499cb964818474$var$isDocumentDefined = ()=>{
    return document !== undefined;
};
const $c8499cb964818474$export$7b20876b2769b301 = (parentElement)=>{
    if ($c8499cb964818474$var$isDocumentDefined()) {
        if (parentElement) (0, $3G34t.getBody)()?.removeChild(parentElement);
    }
};

});


parcelRegister("fAfK5", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f4aa7f082b59a11$export$2e2bcd8739ae039);

var $4tluv = parcelRequire("4tluv");

var $6X8Dq = parcelRequire("6X8Dq");
const $6f4aa7f082b59a11$var$useIsSubsequentRender = (mountStrategy)=>{
    const [isSubsequentRender, setIsSubsequentRender] = (0, $4tluv.useState)(false);
    const [useMountEffect] = (0, $4tluv.useState)(()=>mountStrategy === 'layoutEffect' ? (0, $6X8Dq.useIsomorphicLayoutEffect) : (0, $4tluv.useEffect));
    useMountEffect(()=>{
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $6f4aa7f082b59a11$export$2e2bcd8739ae039 = $6f4aa7f082b59a11$var$useIsSubsequentRender;

});

parcelRegister("iOg6u", function(module, exports) {
$parcel$export(module.exports, "default", () => $7313ede9700a5ef2$export$2e2bcd8739ae039);

var $4tluv = parcelRequire("4tluv");

var $4JUfU = parcelRequire("4JUfU");

var $bafj1 = parcelRequire("bafj1");
const $7313ede9700a5ef2$var$useFirePortalEvent = (zIndex)=>{
    const zIndexNumber = Number(zIndex);
    (0, $4tluv.useEffect)(()=>{
        (0, $bafj1.default)((0, $4JUfU.PORTAL_MOUNT_EVENT), zIndexNumber);
        return ()=>{
            (0, $bafj1.default)((0, $4JUfU.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $7313ede9700a5ef2$export$2e2bcd8739ae039 = $7313ede9700a5ef2$var$useFirePortalEvent;

});
parcelRegister("4JUfU", function(module, exports) {
$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", () => $3d031081e0a6fbd4$export$ed5835cc67e87f72);
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", () => $3d031081e0a6fbd4$export$80816bd900e5bd00);
const $3d031081e0a6fbd4$export$ed5835cc67e87f72 = 'akPortalMount';
const $3d031081e0a6fbd4$export$80816bd900e5bd00 = 'akPortalUnmount';

});

parcelRegister("bafj1", function(module, exports) {
$parcel$export(module.exports, "default", () => $7d922e0015ac4bd0$export$2e2bcd8739ae039);
const $7d922e0015ac4bd0$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ const $7d922e0015ac4bd0$var$getLayerName = (zIndex)=>{
    return $7d922e0015ac4bd0$var$zIndexToName.hasOwnProperty(zIndex) ? $7d922e0015ac4bd0$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ const $7d922e0015ac4bd0$var$getEvent = (eventName, zIndex)=>{
    const detail = {
        layer: $7d922e0015ac4bd0$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $7d922e0015ac4bd0$export$2e2bcd8739ae039(eventName, zIndex) {
    const event = $7d922e0015ac4bd0$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("jmcPG", function(module, exports) {
$parcel$export(module.exports, "register", () => $cacc695731be1069$export$6503ec6e8aabbaf);
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $Hyfcf = parcelRequire("Hyfcf");
const $cacc695731be1069$var$registrations = new Set();
let $cacc695731be1069$var$cleanupEndEventListeners = null;
function $cacc695731be1069$var$onDragStart() {
    if ($cacc695731be1069$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $cacc695731be1069$var$cleanupEndEventListeners = (0, $Hyfcf.bindAll)(window, [
        {
            type: 'dragend',
            listener: $cacc695731be1069$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $cacc695731be1069$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $cacc695731be1069$var$onDragEnd();
                };
            })()
        }
    ]);
    const clone = Array.from($cacc695731be1069$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragStart();
    });
}
function $cacc695731be1069$var$onDragEnd() {
    $cacc695731be1069$var$cleanupEndEventListeners?.();
    $cacc695731be1069$var$cleanupEndEventListeners = null;
    const clone = Array.from($cacc695731be1069$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragEnd();
    });
}
function $cacc695731be1069$var$bindStartEvents() {
    return (0, $Hyfcf.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $cacc695731be1069$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $cacc695731be1069$var$onDragStart
        }
    ]);
}
let $cacc695731be1069$var$cleanupStartEventListeners = null;
function $cacc695731be1069$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$cacc695731be1069$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $cacc695731be1069$var$cleanupStartEventListeners = $cacc695731be1069$var$bindStartEvents();
    $cacc695731be1069$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $cacc695731be1069$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $cacc695731be1069$var$registrations.delete(registration);
        if ($cacc695731be1069$var$registrations.size === 0) {
            $cacc695731be1069$var$cleanupStartEventListeners?.();
            $cacc695731be1069$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("guEK2", function(module, exports) {
$parcel$export(module.exports, "getVirtualElementFromMousePos", () => $6b6afb96f7f1cabe$export$2e68479e0a5d8746);
function $6b6afb96f7f1cabe$export$2e68479e0a5d8746(mousePos, { targetElement: targetElement, tooltipPosition: tooltipPosition }) {
    if (tooltipPosition === 'mouse') return {
        getBoundingClientRect: ()=>DOMRect.fromRect({
                x: mousePos.clientX,
                y: mousePos.clientY,
                width: 0,
                height: 0
            })
    };
    const targetRect = targetElement.getBoundingClientRect();
    if (tooltipPosition === 'mouse-x') return {
        getBoundingClientRect: ()=>DOMRect.fromRect({
                x: mousePos.clientX,
                y: targetRect.top,
                width: 0,
                height: targetRect.height
            })
    };
    if (tooltipPosition === 'mouse-y') return {
        getBoundingClientRect: ()=>DOMRect.fromRect({
                x: targetRect.left,
                y: mousePos.clientY,
                width: targetRect.width,
                height: 0
            })
    };
    throw new Error(`Invalid tooltip position for virtual element: ${tooltipPosition}`);
}

});

parcelRegister("8kZlM", function(module, exports) {
$parcel$export(module.exports, "show", () => $8d3cbe36021f3073$export$57bf213be019eeb0);
let $8d3cbe36021f3073$var$delayId = null;
function $8d3cbe36021f3073$var$clearScheduled() {
    if ($8d3cbe36021f3073$var$delayId != null) {
        window.clearTimeout($8d3cbe36021f3073$var$delayId);
        $8d3cbe36021f3073$var$delayId = null;
    }
}
function $8d3cbe36021f3073$var$scheduleTimeout(fn, delay) {
    $8d3cbe36021f3073$var$clearScheduled();
    $8d3cbe36021f3073$var$delayId = window.setTimeout(()=>{
        $8d3cbe36021f3073$var$delayId = null;
        fn();
    }, delay);
}
let $8d3cbe36021f3073$var$active = null;
function $8d3cbe36021f3073$export$57bf213be019eeb0(entry) {
    let phase = 'waiting-to-show';
    function isActive() {
        return Boolean($8d3cbe36021f3073$var$active && $8d3cbe36021f3073$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            $8d3cbe36021f3073$var$clearScheduled();
            $8d3cbe36021f3073$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            $8d3cbe36021f3073$var$clearScheduled();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            $8d3cbe36021f3073$var$clearScheduled();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide({ isImmediate: isImmediate }) {
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        $8d3cbe36021f3073$var$scheduleTimeout(()=>{
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function start() {
        const shouldAlwaysFadeIn = entry.shouldAlwaysFadeIn;
        const showImmediately = Boolean($8d3cbe36021f3073$var$active && $8d3cbe36021f3073$var$active.isVisible()) && !shouldAlwaysFadeIn;
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($8d3cbe36021f3073$var$active) {
            $8d3cbe36021f3073$var$clearScheduled();
            $8d3cbe36021f3073$var$active.entry.hide({
                isImmediate: true
            });
            $8d3cbe36021f3073$var$active.entry.done();
            $8d3cbe36021f3073$var$active = null;
        }
        // this tooltip is now the active tooltip
        $8d3cbe36021f3073$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        $8d3cbe36021f3073$var$scheduleTimeout(show, entry.delay);
    }
    // let's get started!
    start();
    const result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePos: entry.source.type === 'mouse' ? {
            clientX: entry.source.clientX,
            clientY: entry.source.clientY
        } : null
    };
    return result;
}

});

parcelRegister("8JvDF", function(module, exports) {
$parcel$export(module.exports, "default", () => $7999fc8b14b55fba$export$2e2bcd8739ae039);

var $gwxwS = parcelRequire("gwxwS");
function $7999fc8b14b55fba$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    const seed = (0, $gwxwS.useIdSeed)();
    return shouldRenderId ? `${seed(prefix)}` : undefined;
}

});
parcelRegister("gwxwS", function(module, exports) {
$parcel$export(module.exports, "useIdSeed", () => $0bb2a86057749303$export$6ee17796e3d70de2);

var $fEY94 = parcelRequire("fEY94");
function $0bb2a86057749303$export$6ee17796e3d70de2() {
    const uid = (0, $fEY94.useId)();
    return (id)=>`${uid}-${id.toString()}`;
}

});


parcelRegister("6KwsR", function(module, exports) {
$parcel$export(module.exports, "default", () => $60ab3d015e7f6ee2$export$2e2bcd8739ae039);
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");

var $2F3nf = parcelRequire("2F3nf");
const $60ab3d015e7f6ee2$var$styles = {
    base: "_2rkofajl _11c8wadc _vchhusvi _p12fp3fh _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ const $60ab3d015e7f6ee2$var$TooltipContainer = /*#__PURE__*/ (0, $4tluv.forwardRef)(function TooltipContainer({ style: style, className: className, children: children, truncate: truncate, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id, shortcut: shortcut }, ref) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $2F3nf.default), {
        ref: ref,
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $jAkMr.default)([
            $60ab3d015e7f6ee2$var$styles.base,
            truncate && $60ab3d015e7f6ee2$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut,
        children: children
    });
});
$60ab3d015e7f6ee2$var$TooltipContainer.displayName = 'TooltipContainer';
var $60ab3d015e7f6ee2$export$2e2bcd8739ae039 = $60ab3d015e7f6ee2$var$TooltipContainer;

});
parcelRegister("2F3nf", function(module, exports) {
$parcel$export(module.exports, "default", () => $5943d789899cbd67$export$2e2bcd8739ae039);
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");

var $4KtWr = parcelRequire("4KtWr");
const $5943d789899cbd67$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ const $5943d789899cbd67$var$TooltipPrimitive = /*#__PURE__*/ (0, $4tluv.forwardRef)(function TooltipPrimitive({ style: style, className: className, children: children, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id, shortcut: shortcut }, ref) {
    return /*#__PURE__*/ (0, $2iln5.jsx)("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? `${testId}--wrapper` : undefined,
        children: /*#__PURE__*/ (0, $2iln5.jsxs)("div", {
            role: "tooltip",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $jAkMr.default)([
                "_80om73ad",
                className
            ]),
            // Because the tooltip should not be focusable, there is no reason to have key events.
            /* eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events */ onMouseOut: onMouseOut,
            /* eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events */ onMouseOver: onMouseOver,
            "data-placement": placement,
            "data-testid": testId,
            id: id,
            children: [
                children,
                shortcut && /*#__PURE__*/ (0, $2iln5.jsx)((0, $4KtWr.TooltipShortcut), {
                    shortcut: shortcut
                })
            ]
        })
    });
});
$5943d789899cbd67$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $5943d789899cbd67$export$2e2bcd8739ae039 = $5943d789899cbd67$var$TooltipPrimitive;

});
parcelRegister("4KtWr", function(module, exports) {
$parcel$export(module.exports, "TooltipShortcut", () => $f521ee104651a6dc$export$5bcbc43c84236222);
/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");
const $f521ee104651a6dc$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c8wadc _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
const $f521ee104651a6dc$export$5bcbc43c84236222 = ({ shortcut: shortcut })=>{
    return /*#__PURE__*/ (0, $2iln5.jsx)("div", {
        className: (0, $jAkMr.default)([
            $f521ee104651a6dc$var$styles.shortcutSegmentsContainer
        ]),
        children: shortcut.map((segment, index)=>/*#__PURE__*/ (0, $2iln5.jsx)("kbd", {
                className: (0, $jAkMr.default)([
                    $f521ee104651a6dc$var$styles.shortcutSegment
                ]),
                children: segment
            }, `${segment}-${index}`))
    });
};

});





parcelRegister("29hEC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f5f2152e50a3b99db24df80b6d3e591d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $190a1dc51b0ce42e$var$_react = $190a1dc51b0ce42e$var$_interopRequireDefault((parcelRequire("4tluv")));

var $190a1dc51b0ce42e$var$_baseNew = $190a1dc51b0ce42e$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $190a1dc51b0ce42e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $190a1dc51b0ce42e$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $190a1dc51b0ce42e$var$_react.default.createElement($190a1dc51b0ce42e$var$_baseNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$190a1dc51b0ce42e$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $190a1dc51b0ce42e$var$_default = module.exports.default = $190a1dc51b0ce42e$var$PageLiveDocIcon;

});

parcelRegister("ewVxb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::abee860452bcaffc9cded3519ab61cd1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a940aef613eeea0c$var$_react = $a940aef613eeea0c$var$_interopRequireDefault((parcelRequire("4tluv")));

var $a940aef613eeea0c$var$_baseNew = $a940aef613eeea0c$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $a940aef613eeea0c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SuggestedEdit".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for suggestions powered by Atlassian Intelligence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a940aef613eeea0c$var$SuggestedEditIcon = (props)=>/*#__PURE__*/ $a940aef613eeea0c$var$_react.default.createElement($a940aef613eeea0c$var$_baseNew.default, Object.assign({
        name: "SuggestedEditIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.84 5.85a2 2 0 0 1 2.83 0l.73.73a2 2 0 0 1 0 2.83l-5.14 5.14a2 2 0 0 1-.86.51l-3.19.91a.75.75 0 0 1-.93-.93l.91-3.19a2 2 0 0 1 .51-.86zm1.77 1.06a.5.5 0 0 0-.71 0l-.59.59 1.44 1.44.59-.59a.5.5 0 0 0 0-.71zM12.69 10l-1.44-1.44-3.49 3.49a.5.5 0 0 0-.13.22l-.54 1.89 1.89-.54a.5.5 0 0 0 .22-.13zM4.75 0c.31 0 .59.19.7.48l1 2.57 2.57 1a.75.75 0 0 1 0 1.4l-2.57 1-1 2.57a.75.75 0 0 1-1.4 0l-1-2.57-2.57-1a.75.75 0 0 1 0-1.4l2.57-1 1-2.57a.75.75 0 0 1 .7-.48m0 2.82L4.33 3.9a.75.75 0 0 1-.43.43l-1.08.42 1.08.42a.75.75 0 0 1 .43.43l.42 1.08.42-1.08a.75.75 0 0 1 .43-.43l1.08-.42-1.08-.42a.75.75 0 0 1-.43-.43z" clip-rule="evenodd"/>`
    }, props));
$a940aef613eeea0c$var$SuggestedEditIcon.displayName = 'SuggestedEditIcon';
var $a940aef613eeea0c$var$_default = module.exports.default = $a940aef613eeea0c$var$SuggestedEditIcon;

});

parcelRegister("frEQt", function(module, exports) {
$parcel$export(module.exports, "useFlags", () => $7b4d9ea69b3be0c4$export$2879604e6aec4ab);
$parcel$export(module.exports, "FlagsProvider", () => $7b4d9ea69b3be0c4$export$a4270ab432ac8a58);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $4BsXm = parcelRequire("4BsXm");

var $1jiij = parcelRequire("1jiij");

var $kijvt = parcelRequire("kijvt");
const $7b4d9ea69b3be0c4$var$FlagContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createContext(null);
function $7b4d9ea69b3be0c4$export$2879604e6aec4ab() {
    const api = (0, $4tluv.useContext)($7b4d9ea69b3be0c4$var$FlagContext);
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
}
const $7b4d9ea69b3be0c4$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
function $7b4d9ea69b3be0c4$export$a4270ab432ac8a58({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $4tluv.useState)([]);
    const removeFlag = (0, $4tluv.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $4tluv.useMemo)(()=>({
            showFlag: function show(value) {
                const flag = {
                    ...value,
                    id: value.id || $7b4d9ea69b3be0c4$var$getUniqueId()
                };
                setFlags((current)=>{
                    const index = current.findIndex((value)=>value.id === flag.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag,
                        ...current
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current
                    ];
                    shallow[index] = flag;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag.id);
                };
            }
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $2iln5.jsxs)((0, $2iln5.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2iln5.jsx)($7b4d9ea69b3be0c4$var$FlagContext.Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $2iln5.jsx)((0, $kijvt.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag;
                    const FlagType = isAutoDismiss ? (0, $4BsXm.default) : (0, $1jiij.default);
                    return /*#__PURE__*/ (0, $4tluv.createElement)(FlagType, {
                        ...restProps,
                        key: flag.id
                    });
                })
            })
        ]
    });
}
const $7b4d9ea69b3be0c4$export$7b676815c264eaf3 = (fn)=>/*#__PURE__*/ (0, $2iln5.jsx)($7b4d9ea69b3be0c4$export$a4270ab432ac8a58, {
        children: fn()
    });

});
parcelRegister("4BsXm", function(module, exports) {
$parcel$export(module.exports, "default", () => $76ff6a727e2be727$export$2e2bcd8739ae039);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $wYkfM = parcelRequire("wYkfM");

var $ccErM = parcelRequire("ccErM");

var $1jiij = parcelRequire("1jiij");

var $egv1H = parcelRequire("egv1H");
const $76ff6a727e2be727$var$packageName = undefined;
const $76ff6a727e2be727$var$packageVersion = undefined;
const $76ff6a727e2be727$export$66c3d409977b5615 = 8;
/**
 * __Auto dismiss flag__
 *
 * An auto dismiss flag is dismissed automatically after eight seconds.
 *
 * - [Examples](https://atlassian.design/components/flag/auto-dismiss-flag/examples)
 * - [Code](https://atlassian.design/components/flag/auto-dismiss-flag/code)
 */ const $76ff6a727e2be727$var$AutoDismissFlag = (props)=>{
    const { id: id, analyticsContext: analyticsContext, onDismissed: onDismissedProp = (0, $ccErM.default), autoDismissSeconds: autoDismissSeconds = $76ff6a727e2be727$export$66c3d409977b5615 } = props;
    const autoDismissTimer = (0, $4tluv.useRef)(null);
    const { onDismissed: onDismissedFromFlagGroup, isDismissAllowed: isDismissAllowed } = (0, $egv1H.useFlagGroup)();
    const onDismissed = (0, $4tluv.useCallback)((id, analyticsEvent)=>{
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    const onDismissedAnalytics = (0, $wYkfM.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        componentName: 'flag',
        packageName: $76ff6a727e2be727$var$packageName,
        packageVersion: $76ff6a727e2be727$var$packageVersion
    });
    const isAutoDismissAllowed = isDismissAllowed && onDismissed;
    const dismissFlag = (0, $4tluv.useCallback)(()=>{
        if (isAutoDismissAllowed) onDismissedAnalytics(id);
    }, [
        id,
        onDismissedAnalytics,
        isAutoDismissAllowed
    ]);
    const stopAutoDismissTimer = (0, $4tluv.useCallback)(()=>{
        if (autoDismissTimer.current) {
            clearTimeout(autoDismissTimer.current);
            autoDismissTimer.current = null;
        }
    }, []);
    const startAutoDismissTimer = (0, $4tluv.useCallback)(()=>{
        if (!isAutoDismissAllowed) return;
        stopAutoDismissTimer();
        autoDismissTimer.current = window.setTimeout(dismissFlag, autoDismissSeconds * 1000);
    }, [
        dismissFlag,
        stopAutoDismissTimer,
        isAutoDismissAllowed,
        autoDismissSeconds
    ]);
    (0, $4tluv.useEffect)(()=>{
        startAutoDismissTimer();
        return stopAutoDismissTimer;
    }, [
        startAutoDismissTimer,
        stopAutoDismissTimer
    ]);
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $1jiij.default), {
        ...props,
        onMouseOver: stopAutoDismissTimer,
        onFocus: stopAutoDismissTimer,
        onMouseOut: startAutoDismissTimer,
        onBlur: startAutoDismissTimer
    });
};
var $76ff6a727e2be727$export$2e2bcd8739ae039 = $76ff6a727e2be727$var$AutoDismissFlag;

});
parcelRegister("1jiij", function(module, exports) {
$parcel$export(module.exports, "default", () => $6845a0adeae72f6d$export$2e2bcd8739ae039);
/* flag.tsx generated by @compiled/babel-plugin v0.36.1 */ /* flag.tsx generated by @compiled/babel-plugin v0.36.1 */ /* flag.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");

var $wYkfM = parcelRequire("wYkfM");

var $klNPa = parcelRequire("klNPa");

var $ccErM = parcelRequire("ccErM");

var $2TG1J = parcelRequire("2TG1J");

var $3X3Vo = parcelRequire("3X3Vo");

var $fYX4U = parcelRequire("fYX4U");
var $da7v4 = parcelRequire("da7v4");
var $fm1L8 = parcelRequire("fm1L8");

var $k7gbB = parcelRequire("k7gbB");

var $25sCv = parcelRequire("25sCv");

var $cLSfX = parcelRequire("cLSfX");

var $bcfqP = parcelRequire("bcfqP");

var $7xn0x = parcelRequire("7xn0x");

var $b9ly8 = parcelRequire("b9ly8");

var $4FvD5 = parcelRequire("4FvD5");

var $7bbrm = parcelRequire("7bbrm");

var $5BecW = parcelRequire("5BecW");
var $fWLYW = parcelRequire("fWLYW");

var $egv1H = parcelRequire("egv1H");
const $6845a0adeae72f6d$var$styles = {
    overflowWrap: "_1i4qfg65",
    flag: "_2rkofajl _1reo15vq _18m915vq _v564z97a _16qs130s _1pbyni7l _1bsb1osq",
    flagT26Shape: "_2rko1mok"
};
const $6845a0adeae72f6d$var$CSS_VAR_ICON_COLOR = '--flag-icon-color';
const $6845a0adeae72f6d$var$descriptionStyles = null;
const $6845a0adeae72f6d$var$iconWrapperStyles = null;
const $6845a0adeae72f6d$var$flagWrapperStyles = null;
const $6845a0adeae72f6d$var$analyticsAttributes = {
    componentName: 'flag',
    packageName: undefined,
    packageVersion: undefined
};
const $6845a0adeae72f6d$var$transitionStyles = null;
/**
 * __Flag__
 *
 * A flag is used for confirmations, alerts, and acknowledgments that require minimal user interaction,
 * often displayed using a flag group.
 *
 * - [Examples](https://atlassian.design/components/flag/examples)
 * - [Code](https://atlassian.design/components/flag/code)
 * - [Usage](https://atlassian.design/components/flag/usage)
 */ const $6845a0adeae72f6d$var$Flag = (props)=>{
    const { actions: actions = [], appearance: appearance = (0, $25sCv.DEFAULT_APPEARANCE), icon: icon, title: title, description: description, linkComponent: linkComponent, onMouseOver: onMouseOver, onFocus: onFocus = (0, $ccErM.default), onMouseOut: onMouseOut, onBlur: onBlur = (0, $ccErM.default), onDismissed: onDismissedProp = (0, $ccErM.default), testId: testId, id: id, analyticsContext: analyticsContext, delayAnnouncement: delayAnnouncement, headingLevel: headingLevel = 2 } = props;
    const [isDelayToAnnounce, setIsDelayToAnnounce] = (0, $4tluv.useState)(false);
    const { onDismissed: onDismissedFromFlagGroup, isDismissAllowed: isDismissAllowed } = (0, $egv1H.useFlagGroup)();
    const onDismissed = (0, $4tluv.useCallback)((id, analyticsEvent)=>{
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    const [isExpanded, setIsExpanded] = (0, $4tluv.useState)(false);
    const onDismissedAnalytics = (0, $wYkfM.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        ...$6845a0adeae72f6d$var$analyticsAttributes
    });
    const isBold = appearance !== (0, $25sCv.DEFAULT_APPEARANCE);
    const toggleExpand = (0, $4tluv.useCallback)(()=>{
        setIsExpanded((previous)=>!previous);
    }, []);
    const buttonActionCallback = (0, $4tluv.useCallback)(()=>{
        if (isDismissAllowed) onDismissedAnalytics(id);
    }, [
        onDismissedAnalytics,
        id,
        isDismissAllowed
    ]);
    (0, $4tluv.useEffect)(()=>{
        // If buttons are removed as a prop, update isExpanded to be false
        if (isBold && isExpanded && !description && !actions.length) setIsExpanded(false);
    }, [
        actions.length,
        description,
        isBold,
        isExpanded
    ]);
    (0, $4tluv.useEffect)(()=>{
        if (!delayAnnouncement) return;
        setTimeout(()=>{
            setIsDelayToAnnounce(true);
        }, delayAnnouncement);
    }, [
        delayAnnouncement
    ]);
    const onFocusAnalytics = (0, $wYkfM.usePlatformLeafEventHandler)({
        fn: onFocus,
        action: 'focused',
        analyticsData: analyticsContext,
        ...$6845a0adeae72f6d$var$analyticsAttributes
    });
    const onBlurAnalytics = (0, $wYkfM.usePlatformLeafEventHandler)({
        fn: onBlur,
        action: 'blurred',
        analyticsData: analyticsContext,
        ...$6845a0adeae72f6d$var$analyticsAttributes
    });
    const autoDismissProps = {
        onMouseOver: onMouseOver,
        onFocus: onFocusAnalytics,
        onMouseOut: onMouseOut,
        onBlur: onBlurAnalytics
    };
    const textColor = (0, $4FvD5.flagTextColor)[appearance];
    const iconColor = (0, $7xn0x.flagIconColor)[appearance];
    const iconGlyph = (0, $b9ly8.flagIconGlyph)[appearance];
    const isDismissable = isBold || isDismissAllowed;
    const shouldRenderGap = !isBold && (description || actions.length) || isExpanded;
    // when delayAnnouncement is available we will use a hidden content for announcement
    const delayedAnnouncement = delayAnnouncement ? /*#__PURE__*/ (0, $2iln5.jsxs)((0, $k7gbB.default), {
        children: [
            title,
            description
        ]
    }) : undefined;
    return /*#__PURE__*/ (0, $2iln5.jsx)("div", {
        role: "alert",
        "data-testid": testId,
        ...autoDismissProps,
        className: (0, $jAkMr.default)([
            "_1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $fYX4U.default), {
            padding: "space.200",
            backgroundColor: (0, $bcfqP.flagBackgroundColor)[appearance],
            xcss: (0, $klNPa.cx)($6845a0adeae72f6d$var$styles.flag, (0, $3X3Vo.fg)('platform-dst-shape-theme-default') && $6845a0adeae72f6d$var$styles.flagT26Shape),
            children: /*#__PURE__*/ (0, $2iln5.jsxs)((0, $da7v4.default), {
                alignBlock: "start",
                space: "space.200",
                children: [
                    /*#__PURE__*/ (0, $2iln5.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: {
                            [$6845a0adeae72f6d$var$CSS_VAR_ICON_COLOR]: iconColor
                        },
                        "data-testid": testId && `${testId}-icon-container`,
                        className: (0, $jAkMr.default)([
                            "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf _syaz1jn0"
                        ]),
                        children: icon || iconGlyph
                    }),
                    /*#__PURE__*/ (0, $2iln5.jsx)("span", {
                        className: (0, $jAkMr.default)([
                            "_v5641hdc _16jlkb7n"
                        ]),
                        children: /*#__PURE__*/ (0, $2iln5.jsxs)((0, $fm1L8.default), {
                            space: shouldRenderGap ? 'space.100' : 'space.0',
                            children: [
                                isDelayToAnnounce && delayedAnnouncement,
                                /*#__PURE__*/ (0, $2iln5.jsxs)((0, $da7v4.default), {
                                    alignBlock: "stretch",
                                    space: "space.100",
                                    spread: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0, $2iln5.jsx)((0, $fYX4U.default), {
                                            paddingBlockStart: "space.050",
                                            paddingBlockEnd: "space.025",
                                            xcss: $6845a0adeae72f6d$var$styles.overflowWrap,
                                            children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $2TG1J.default), {
                                                as: `h${headingLevel}`,
                                                size: "xsmall",
                                                color: textColor,
                                                children: /*#__PURE__*/ (0, $2iln5.jsx)("span", {
                                                    /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ "aria-hidden": isDelayToAnnounce,
                                                    children: title
                                                })
                                            })
                                        }),
                                        isDismissable ? !(isBold && !description && !actions.length) && /*#__PURE__*/ (0, $2iln5.jsx)((0, $5BecW.default), {
                                            testId: testId,
                                            appearance: appearance,
                                            isBold: isBold,
                                            isExpanded: isExpanded,
                                            onClick: isBold ? toggleExpand : buttonActionCallback
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0, $2iln5.jsxs)((0, $fWLYW.default), {
                                    isExpanded: !isBold || isExpanded,
                                    testId: testId,
                                    children: [
                                        description && /*#__PURE__*/ (0, $2iln5.jsx)("div", {
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                            style: {
                                                color: (0, $7bbrm.flagTextColorToken)[appearance]
                                            },
                                            "data-testid": testId && `${testId}-description`,
                                            /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ "aria-hidden": isDelayToAnnounce,
                                            className: (0, $jAkMr.default)([
                                                "_11c8fhey _1reo1wug _18m91wug _c71l53f4 _1i4qfg65"
                                            ]),
                                            children: description
                                        }),
                                        /*#__PURE__*/ (0, $2iln5.jsx)((0, $cLSfX.default), {
                                            actions: actions,
                                            appearance: appearance,
                                            linkComponent: linkComponent,
                                            testId: testId
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
var $6845a0adeae72f6d$export$2e2bcd8739ae039 = $6845a0adeae72f6d$var$Flag;

});
parcelRegister("klNPa", function(module, exports) {
$parcel$export(module.exports, "cx", () => $6f3d1667d91f0b1f$export$a274e22fb40f762e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* index.tsx generated by @compiled/babel-plugin v0.36.1 */ parcelRequire("4tluv");

var $h8GVL = parcelRequire("h8GVL");
const $6f3d1667d91f0b1f$var$strictApi = (0, $h8GVL.createStrictAPI)();
const $6f3d1667d91f0b1f$export$dbf350e5966cf602 = $6f3d1667d91f0b1f$var$strictApi.css;
const $6f3d1667d91f0b1f$export$eb1ecd84a24ee424 = $6f3d1667d91f0b1f$var$strictApi.cssMap;
$6f3d1667d91f0b1f$var$strictApi.cssMap;
const $6f3d1667d91f0b1f$export$a274e22fb40f762e = $6f3d1667d91f0b1f$var$strictApi.cx;
const $6f3d1667d91f0b1f$var$XCSSProp = $6f3d1667d91f0b1f$var$strictApi.XCSSProp;

});

parcelRegister("2TG1J", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd784add78b248c1$export$2e2bcd8739ae039);
/* heading.tsx generated by @compiled/babel-plugin v0.36.1 */ /* heading.tsx generated by @compiled/babel-plugin v0.36.1 */ /* heading.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");

var $dpQkd = parcelRequire("dpQkd");

var $71w0l = parcelRequire("71w0l");

var $g2cmx = parcelRequire("g2cmx");

var $hcSxw = parcelRequire("hcSxw");
const $cd784add78b248c1$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ const $cd784add78b248c1$var$styles = {
    reset: "_dxsyidpf _1i144jg8 _nmk4glyw"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ const $cd784add78b248c1$var$headingColorStyles = {
    'color.text': "_1w90i7uo",
    'color.text.inverse': "_1w9015cr",
    'color.text.warning.inverse': "_1w901yd3"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ const $cd784add78b248c1$var$headingSizeStyles = {
    xxlarge: "_fqox1iff",
    xlarge: "_fqox12ln",
    large: "_fqox10sd",
    medium: "_fqox1af2",
    small: "_fqox1e3o",
    xsmall: "_fqox1qyo",
    xxsmall: "_fqoxi4vh"
};
/**
 * @codegenEnd
 */ const $cd784add78b248c1$var$useColor = (colorProp)=>{
    const surface = (0, $71w0l.useSurface)();
    if (colorProp) return colorProp;
    if ((0, $dpQkd.inverseColorMap).hasOwnProperty(surface)) return (0, $dpQkd.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ const $cd784add78b248c1$var$Heading = /*#__PURE__*/ (0, $4tluv.forwardRef)((props, ref)=>{
    const { children: children, size: size, id: id, testId: testId, as: as, color: colorProp } = props;
    typeof $hcSxw;
    const [hLevel, inferredElement] = (0, $g2cmx.useHeading)($cd784add78b248c1$var$sizeTagMap[size]);
    const Component = as || inferredElement;
    const needsAriaRole = Component === 'div' && hLevel;
    const color = $cd784add78b248c1$var$useColor(colorProp);
    return /*#__PURE__*/ (0, $2iln5.jsx)(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $jAkMr.default)([
            $cd784add78b248c1$var$styles.reset,
            $cd784add78b248c1$var$headingSizeStyles[size],
            $cd784add78b248c1$var$headingColorStyles[color]
        ]),
        children: children
    });
});
var $cd784add78b248c1$export$2e2bcd8739ae039 = $cd784add78b248c1$var$Heading;

});
parcelRegister("dpQkd", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", () => $0040ab0f7666bc2e$export$6ccdbebca2ee545f);
$parcel$export(module.exports, "positiveSpaceMap", () => $0040ab0f7666bc2e$export$958d0ae7f2977ae4);
$parcel$export(module.exports, "allSpaceMap", () => $0040ab0f7666bc2e$export$632685d741f3dbbf);
$parcel$export(module.exports, "inverseColorMap", () => $0040ab0f7666bc2e$export$2185ce37f9bdd963);
$parcel$export(module.exports, "opacityMap", () => $0040ab0f7666bc2e$export$daf94a976c798b4f);
$parcel$export(module.exports, "shadowMap", () => $0040ab0f7666bc2e$export$7aff6e7ba39bb774);
$parcel$export(module.exports, "borderColorMap", () => $0040ab0f7666bc2e$export$1531ad5bb3fbedac);
$parcel$export(module.exports, "backgroundColorMap", () => $0040ab0f7666bc2e$export$d1d79bf68ac056bd);
$parcel$export(module.exports, "textColorMap", () => $0040ab0f7666bc2e$export$8473307aa00d6ea1);
$parcel$export(module.exports, "layerMap", () => $0040ab0f7666bc2e$export$b5f31a7e431d2eab);
$parcel$export(module.exports, "borderWidthMap", () => $0040ab0f7666bc2e$export$e1b83c5210c471b8);
$parcel$export(module.exports, "borderRadiusMap", () => $0040ab0f7666bc2e$export$3c0a6c3e64bb180d);
$parcel$export(module.exports, "fontMap", () => $0040ab0f7666bc2e$export$6ffa317d5e70375);
$parcel$export(module.exports, "fontWeightMap", () => $0040ab0f7666bc2e$export$303e322c6b1ed114);
$parcel$export(module.exports, "fontFamilyMap", () => $0040ab0f7666bc2e$export$3c7e9587132614b4);
$parcel$export(module.exports, "paddingStylesMap", () => $0040ab0f7666bc2e$export$e615f061ca585a6c);
$parcel$export(module.exports, "spaceStylesMap", () => $0040ab0f7666bc2e$export$bf46c3f9eeafc71f);
$parcel$export(module.exports, "backgroundColorStylesMap", () => $0040ab0f7666bc2e$export$e7af83bafe7f9e63);
$parcel$export(module.exports, "textColorStylesMap", () => $0040ab0f7666bc2e$export$3a1bcba60b23d7f0);
$parcel$export(module.exports, "textSizeStylesMap", () => $0040ab0f7666bc2e$export$219d364c0da35ae4);
$parcel$export(module.exports, "textWeightStylesMap", () => $0040ab0f7666bc2e$export$38845ca010b93505);
$parcel$export(module.exports, "surfaceColorStylesMap", () => $0040ab0f7666bc2e$export$ff257d957d48c421);
$parcel$export(module.exports, "isSurfaceColorToken", () => $0040ab0f7666bc2e$export$5e65a44e5b6ecadb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $ft5N0 = parcelRequire("ft5N0");

var $e5lMD = parcelRequire("e5lMD");
const $0040ab0f7666bc2e$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
const $0040ab0f7666bc2e$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
const $0040ab0f7666bc2e$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
const $0040ab0f7666bc2e$export$632685d741f3dbbf = {
    ...$0040ab0f7666bc2e$export$958d0ae7f2977ae4,
    ...$0040ab0f7666bc2e$export$d2dc61f58390201c
};
const $0040ab0f7666bc2e$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
const $0040ab0f7666bc2e$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
const $0040ab0f7666bc2e$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #1E1F211f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #1E1F2129)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #1E1F21, 0px 0px 1px #1E1F21)"
};
const $0040ab0f7666bc2e$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)"
};
const $0040ab0f7666bc2e$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #0B120E24)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #E2483D)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #E06C00)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #B38600)",
    'color.border.accent.green': "var(--ds-border-accent-green, #22A06B)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #2898BD)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #357DE8)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #AF59E1)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #7D818A)",
    'color.border.disabled': "var(--ds-border-disabled, #0515240F)",
    'color.border.focused': "var(--ds-border-focused, #4688EC)",
    'color.border.input': "var(--ds-border-input, #8C8F97)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #1868DB)",
    'color.border.brand': "var(--ds-border-brand, #1868DB)",
    'color.border.danger': "var(--ds-border-danger, #E2483D)",
    'color.border.warning': "var(--ds-border-warning, #E06C00)",
    'color.border.success': "var(--ds-border-success, #6A9A23)",
    'color.border.discovery': "var(--ds-border-discovery, #AF59E1)",
    'color.border.information': "var(--ds-border-information, #357DE8)",
    'color.border.bold': "var(--ds-border-bold, #7D818A)"
};
const $0040ab0f7666bc2e$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #BDE97C)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #3F5224)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #F87168)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FFB8B2)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #C9372C)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #872821)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #FCA700)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #FBD779)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #BD5B00)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #7A3B00)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #F5E989)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #EED12B)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #EFDD4E)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #946F00)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #614A05)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #BAF3DB)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #4BCE97)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #97EDC9)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #1F845A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #19573D)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #B1E4F7)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #227D9B)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #1A5265)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #669DF1)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #ADCBFB)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #1868DB)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #144794)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #EED7FC)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #C97CF4)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #E3BDFA)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #964AC0)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #673286)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FCB6E1)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #8C8F97)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #6B6E76)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    'color.background.disabled': "var(--ds-background-disabled, #17171708)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #F8F8F8)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #0515240F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #080F214A)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, #00000000)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #292A2E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #505258)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FE)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #CFE1FD)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #8FB8F6)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #1868DB)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #1558BC)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #123263)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #E9F2FE)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #CFE1FD)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #ADCBFB)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #1868DB)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #1558BC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #144794)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #1C2B42)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #123263)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #144794)",
    'color.background.danger': "var(--ds-background-danger, #FFECEB)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFD5D2)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FFB8B2)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFD5D2)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FFB8B2)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FD9891)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #C9372C)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #AE2E24)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #872821)",
    'color.background.warning': "var(--ds-background-warning, #FFF5DB)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FCE4A6)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FBD779)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FCE4A6)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FBD779)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FBC828)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FBC828)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FCA700)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #F68909)",
    'color.background.success': "var(--ds-background-success, #EFFFD6)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #D3F1A7)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #BDE97C)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #D3F1A7)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #BDE97C)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #B3DF72)",
    'color.background.success.bold': "var(--ds-background-success-bold, #5B7F24)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #4C6B1F)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #3F5224)",
    'color.background.discovery': "var(--ds-background-discovery, #F8EEFE)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #EED7FC)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #E3BDFA)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #EED7FC)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #E3BDFA)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #964AC0)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #803FA5)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #673286)",
    'color.background.information': "var(--ds-background-information, #E9F2FE)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #CFE1FD)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #ADCBFB)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #CFE1FD)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #ADCBFB)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    'color.background.information.bold': "var(--ds-background-information-bold, #1868DB)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #1558BC)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #144794)",
    'color.blanket': "var(--ds-blanket, #050C1F75)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #0515240F)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #17171708)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
const $0040ab0f7666bc2e$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #292A2E)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #AE2E24)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #5D1F1A)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #9E4C00)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #693200)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #7F5F01)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #533F04)",
    'color.text.accent.green': "var(--ds-text-accent-green, #216E4E)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #164B35)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #206A83)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #164555)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #1558BC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #123263)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #803FA5)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #48245D)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #943D73)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #50253F)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505258)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #1E1F21)",
    'color.text.disabled': "var(--ds-text-disabled, #080F214A)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #1868DB)",
    'color.text.brand': "var(--ds-text-brand, #1868DB)",
    'color.text.danger': "var(--ds-text-danger, #AE2E24)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #5D1F1A)",
    'color.text.warning': "var(--ds-text-warning, #9E4C00)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #292A2E)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #693200)",
    'color.text.success': "var(--ds-text-success, #4C6B1F)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #37471F)",
    'color.text.discovery': "var(--ds-text-discovery, #803FA5)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #48245D)",
    'color.text.information': "var(--ds-text-information, #1558BC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #123263)",
    'color.text.subtlest': "var(--ds-text-subtlest, #6B6E76)",
    'color.text.subtle': "var(--ds-text-subtle, #505258)",
    'color.link': "var(--ds-link, #1868DB)",
    'color.link.pressed': "var(--ds-link-pressed, #1558BC)",
    'color.link.visited': "var(--ds-link-visited, #803FA5)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #48245D)"
};
const $0040ab0f7666bc2e$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #292A2E)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #C9372C)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #E06C00)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #B38600)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #22A06B)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #2898BD)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #357DE8)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #AF59E1)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #7D818A)",
    'color.icon.disabled': "var(--ds-icon-disabled, #080F214A)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #1868DB)",
    'color.icon.brand': "var(--ds-icon-brand, #1868DB)",
    'color.icon.danger': "var(--ds-icon-danger, #C9372C)",
    'color.icon.warning': "var(--ds-icon-warning, #E06C00)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #292A2E)",
    'color.icon.success': "var(--ds-icon-success, #6A9A23)",
    'color.icon.discovery': "var(--ds-icon-discovery, #AF59E1)",
    'color.icon.information': "var(--ds-icon-information, #357DE8)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B6E76)",
    'color.icon.subtle': "var(--ds-icon-subtle, #505258)"
};
const $0040ab0f7666bc2e$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
const $0040ab0f7666bc2e$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
const $0040ab0f7666bc2e$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};
const $0040ab0f7666bc2e$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 653 32px/36px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $0040ab0f7666bc2e$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 653)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
const $0040ab0f7666bc2e$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $0040ab0f7666bc2e$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $0040ab0f7666bc2e$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
const $0040ab0f7666bc2e$export$b805719bc8cb376 = {
    large: "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
// Generate maps for Box props. backgroundColor, padding, etc
const $0040ab0f7666bc2e$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
const $0040ab0f7666bc2e$export$ca0f9c2de39ffed7 = (cssProperty, tokenMap)=>{
    return Object.keys(tokenMap).reduce((emotionSpacingMap, token)=>{
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $ft5N0.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            [cssProperty]: tokenMap[token]
        });
        return emotionSpacingMap;
    }, {});
};
const $0040ab0f7666bc2e$export$e615f061ca585a6c = $0040ab0f7666bc2e$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = $0040ab0f7666bc2e$export$ca0f9c2de39ffed7(spacingProperty, $0040ab0f7666bc2e$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
const $0040ab0f7666bc2e$export$bf46c3f9eeafc71f = $0040ab0f7666bc2e$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = $0040ab0f7666bc2e$export$ca0f9c2de39ffed7(spacingProperty, $0040ab0f7666bc2e$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
const $0040ab0f7666bc2e$export$e7af83bafe7f9e63 = $0040ab0f7666bc2e$export$ca0f9c2de39ffed7('backgroundColor', $0040ab0f7666bc2e$export$d1d79bf68ac056bd);
const $0040ab0f7666bc2e$export$3a1bcba60b23d7f0 = $0040ab0f7666bc2e$export$ca0f9c2de39ffed7('color', $0040ab0f7666bc2e$export$8473307aa00d6ea1);
const $0040ab0f7666bc2e$export$45f3f4fe16f9f7d5 = $0040ab0f7666bc2e$export$ca0f9c2de39ffed7('fontWeight', $0040ab0f7666bc2e$export$303e322c6b1ed114);
const $0040ab0f7666bc2e$export$68cc305da27dbaa4 = $0040ab0f7666bc2e$export$ca0f9c2de39ffed7('fontFamily', $0040ab0f7666bc2e$export$3c7e9587132614b4);
const $0040ab0f7666bc2e$export$128f10c238242f83 = $0040ab0f7666bc2e$export$ca0f9c2de39ffed7('font', $0040ab0f7666bc2e$export$6ffa317d5e70375);
const $0040ab0f7666bc2e$export$219d364c0da35ae4 = $0040ab0f7666bc2e$export$ca0f9c2de39ffed7('font', $0040ab0f7666bc2e$export$236bfe3a33ef1292);
const $0040ab0f7666bc2e$export$38845ca010b93505 = $0040ab0f7666bc2e$export$ca0f9c2de39ffed7('fontWeight', $0040ab0f7666bc2e$export$855cfd311192d666);
const $0040ab0f7666bc2e$export$ff257d957d48c421 = $0040ab0f7666bc2e$export$ca0f9c2de39ffed7((0, $e5lMD.CURRENT_SURFACE_CSS_VAR), $0040ab0f7666bc2e$export$41a358c9c2356760);
const $0040ab0f7666bc2e$export$5e65a44e5b6ecadb = (color)=>$0040ab0f7666bc2e$export$41a358c9c2356760[color] !== undefined;
const $0040ab0f7666bc2e$export$7001ce64d9ff7c7f = $0040ab0f7666bc2e$export$ca0f9c2de39ffed7('font', $0040ab0f7666bc2e$export$b805719bc8cb376);

});

parcelRegister("71w0l", function(module, exports) {
$parcel$export(module.exports, "useSurface", () => $cd232c3e8f322826$export$1aeb4f6b93c4540d);

var $4tluv = parcelRequire("4tluv");

var $ADvdq = parcelRequire("ADvdq");
const $cd232c3e8f322826$export$1aeb4f6b93c4540d = ()=>{
    return (0, $4tluv.useContext)((0, $ADvdq.SurfaceContext));
};
(0, $ADvdq.SurfaceContext).displayName = 'SurfaceProvider';

});
parcelRegister("ADvdq", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", () => $aa788c9f591da742$export$1ca2a26fecb070ae);

var $4tluv = parcelRequire("4tluv");
const $aa788c9f591da742$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $4tluv.createContext)('elevation.surface');

});


parcelRegister("g2cmx", function(module, exports) {
$parcel$export(module.exports, "useHeading", () => $c1d51d583712959f$export$97a37b1befbbf9b1);

var $jMx1w = parcelRequire("jMx1w");
const $c1d51d583712959f$export$97a37b1befbbf9b1 = (fallback)=>{
    const hLevel = (0, $jMx1w.useHeadingLevel)();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : `h${hLevel}`) || fallback
    ];
};

});
parcelRegister("jMx1w", function(module, exports) {
$parcel$export(module.exports, "useHeadingLevel", () => $3b8380d91ec0953c$export$6a64a1e2d0bbbf75);

var $4tluv = parcelRequire("4tluv");

var $db2fk = parcelRequire("db2fk");
const $3b8380d91ec0953c$export$6a64a1e2d0bbbf75 = ()=>{
    return (0, $4tluv.useContext)((0, $db2fk.HeadingLevelContext));
};

});
parcelRegister("db2fk", function(module, exports) {
$parcel$export(module.exports, "HeadingLevelContext", () => $80e551dea4ca004d$export$d1fa8a19e192bc63);

var $4tluv = parcelRequire("4tluv");
const $80e551dea4ca004d$export$d1fa8a19e192bc63 = /*#__PURE__*/ (0, $4tluv.createContext)(0);

});




parcelRegister("fYX4U", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e33fdba6d5aadff$export$2e2bcd8739ae039);
/* box.tsx generated by @compiled/babel-plugin v0.36.1 */ /* box.tsx generated by @compiled/babel-plugin v0.36.1 */ /* box.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");

var $ADvdq = parcelRequire("ADvdq");
const $7e33fdba6d5aadff$var$baseStyles = null;
const $7e33fdba6d5aadff$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhkby5v",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
const $7e33fdba6d5aadff$var$CURRENT_SURFACE_CSS_VAR = `--ds-elevation-surface-current`;
const $7e33fdba6d5aadff$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
const $7e33fdba6d5aadff$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
const $7e33fdba6d5aadff$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
const $7e33fdba6d5aadff$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
const $7e33fdba6d5aadff$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ const $7e33fdba6d5aadff$var$Box = /*#__PURE__*/ (0, $4tluv.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock = padding, paddingBlockStart: paddingBlockStart = paddingBlock, paddingBlockEnd: paddingBlockEnd = paddingBlock, paddingInline: paddingInline = padding, paddingInlineStart: paddingInlineStart = paddingInline, paddingInlineEnd: paddingInlineEnd = paddingInline, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const node = /*#__PURE__*/ (0, $2iln5.jsx)(Component, {
        style: style,
        // @ts-ignore -- Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $jAkMr.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $7e33fdba6d5aadff$var$backgroundColorMap[backgroundColor],
            backgroundColor && $7e33fdba6d5aadff$var$isSurfaceToken(backgroundColor) && $7e33fdba6d5aadff$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $7e33fdba6d5aadff$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $7e33fdba6d5aadff$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $7e33fdba6d5aadff$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $7e33fdba6d5aadff$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ]),
        ...safeHtmlAttributes,
        "data-testid": testId,
        children: children
    });
    if (backgroundColor) return /*#__PURE__*/ (0, $2iln5.jsx)((0, $ADvdq.SurfaceContext).Provider, {
        value: backgroundColor,
        children: node
    });
    return node;
});
var $7e33fdba6d5aadff$export$2e2bcd8739ae039 = $7e33fdba6d5aadff$var$Box;
function $7e33fdba6d5aadff$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $7e33fdba6d5aadff$var$setSurfaceTokenMap;
}

});

parcelRegister("da7v4", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c4172097a932afd$export$2e2bcd8739ae039);
/* inline.tsx generated by @compiled/babel-plugin v0.36.1 */ /* inline.tsx generated by @compiled/babel-plugin v0.36.1 */ /* inline.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");

var $klNPa = parcelRequire("klNPa");

var $9zxG3 = parcelRequire("9zxG3");
const $9c4172097a932afd$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazazsu _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
const $9c4172097a932afd$var$Separator = ({ children: children })=>/*#__PURE__*/ (0, $2iln5.jsx)("span", {
        className: (0, $jAkMr.default)([
            $9c4172097a932afd$var$styles.separator
        ]),
        children: children
    });
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ const $9c4172097a932afd$var$Inline = /*#__PURE__*/ (0, $4tluv.memo)(/*#__PURE__*/ (0, $4tluv.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, children: rawChildren, ...ariaAttributes }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ (0, $2iln5.jsx)($9c4172097a932afd$var$Separator, {
        children: separator
    }) : separator;
    const children = separatorComponent ? (0, $4tluv.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ (0, $2iln5.jsxs)((0, $4tluv.Fragment), {
            children: [
                separator && index > 0 ? separatorComponent : null,
                child
            ]
        }, index);
    }) : rawChildren;
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $9zxG3.default), {
        ...ariaAttributes,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $klNPa.cx)(grow === 'hug' && $9c4172097a932afd$var$styles.hug, grow === 'fill' && $9c4172097a932afd$var$styles.fill, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
}));
$9c4172097a932afd$var$Inline.displayName = 'Inline';
var $9c4172097a932afd$export$2e2bcd8739ae039 = $9c4172097a932afd$var$Inline;

});
parcelRegister("9zxG3", function(module, exports) {
$parcel$export(module.exports, "default", () => $7bb990c6ae6ffa04$export$2e2bcd8739ae039);
/* flex.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");
const $7bb990c6ae6ffa04$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $7bb990c6ae6ffa04$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $7bb990c6ae6ffa04$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $7bb990c6ae6ffa04$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
const $7bb990c6ae6ffa04$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
const $7bb990c6ae6ffa04$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $7bb990c6ae6ffa04$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ const $7bb990c6ae6ffa04$var$Flex = /*#__PURE__*/ (0, $4tluv.memo)(/*#__PURE__*/ (0, $4tluv.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss, ...ariaAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $2iln5.jsx)(Component, {
        ...ariaAttributes,
        role: role,
        className: (0, $jAkMr.default)([
            $7bb990c6ae6ffa04$var$styles.root,
            gap && $7bb990c6ae6ffa04$var$columnGapMap[gap],
            columnGap && $7bb990c6ae6ffa04$var$columnGapMap[columnGap],
            gap && $7bb990c6ae6ffa04$var$rowGapMap[gap],
            rowGap && $7bb990c6ae6ffa04$var$rowGapMap[rowGap],
            alignItems && $7bb990c6ae6ffa04$var$alignItemsMap[alignItems],
            direction && $7bb990c6ae6ffa04$var$flexDirectionMap[direction],
            justifyContent && $7bb990c6ae6ffa04$var$justifyContentMap[justifyContent],
            wrap && $7bb990c6ae6ffa04$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$7bb990c6ae6ffa04$var$Flex.displayName = 'Flex';
var $7bb990c6ae6ffa04$export$2e2bcd8739ae039 = $7bb990c6ae6ffa04$var$Flex;

});


parcelRegister("fm1L8", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc1e7264d7c528e6$export$2e2bcd8739ae039);
/* stack.tsx generated by @compiled/babel-plugin v0.36.1 */ /* stack.tsx generated by @compiled/babel-plugin v0.36.1 */ /* stack.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $klNPa = parcelRequire("klNPa");

var $9zxG3 = parcelRequire("9zxG3");
const $bc1e7264d7c528e6$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ const $bc1e7264d7c528e6$var$Stack = /*#__PURE__*/ (0, $4tluv.memo)(/*#__PURE__*/ (0, $4tluv.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role, ...ariaAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $9zxG3.default), {
        ...ariaAttributes,
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $klNPa.cx)(grow === 'hug' && $bc1e7264d7c528e6$var$styles.hug, grow === 'fill' && $bc1e7264d7c528e6$var$styles.fill, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
}));
$bc1e7264d7c528e6$var$Stack.displayName = 'Stack';
var $bc1e7264d7c528e6$export$2e2bcd8739ae039 = $bc1e7264d7c528e6$var$Stack;

});

parcelRegister("k7gbB", function(module, exports) {
$parcel$export(module.exports, "default", () => $6b1301ae8037cf3d$export$2e2bcd8739ae039);
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");
const $6b1301ae8037cf3d$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ const $6b1301ae8037cf3d$var$VisuallyHidden = ({ children: children, testId: testId, role: role, id: id })=>{
    return /*#__PURE__*/ (0, $2iln5.jsx)("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $jAkMr.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ]),
        children: children
    });
};
$6b1301ae8037cf3d$var$VisuallyHidden.displayName = 'VisuallyHidden';
var $6b1301ae8037cf3d$export$2e2bcd8739ae039 = $6b1301ae8037cf3d$var$VisuallyHidden;

});

parcelRegister("25sCv", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_APPEARANCE", () => $96e6e6c0012608cf$export$d6830277b06edd6);
const $96e6e6c0012608cf$export$d6830277b06edd6 = 'normal';

});

parcelRegister("cLSfX", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f642008c609dbdb$export$2e2bcd8739ae039);
/* flag-actions.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");

var $groaY = parcelRequire("groaY");

var $da7v4 = parcelRequire("da7v4");

var $hkYSr = parcelRequire("hkYSr");

var $25sCv = parcelRequire("25sCv");

var $3cug2 = parcelRequire("3cug2");
const $3f642008c609dbdb$var$buttonStyles = null;
const $3f642008c609dbdb$var$fontStyles = null;
const $3f642008c609dbdb$var$appearanceNormalButtonStyles = null;
const $3f642008c609dbdb$var$appearanceNormalActionsContainerStyles = null;
const $3f642008c609dbdb$var$FlagActions = (props)=>{
    const { appearance: appearance = (0, $25sCv.DEFAULT_APPEARANCE), actions: actions = [], linkComponent: linkComponent, testId: testId } = props;
    if (!actions.length) return null;
    const isBold = appearance !== (0, $25sCv.DEFAULT_APPEARANCE);
    return /*#__PURE__*/ (0, $2iln5.jsx)("span", {
        className: (0, $jAkMr.default)([
            !isBold && "_1g4l107e _y8dn107e",
            "_11c8fhey"
        ]),
        children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $da7v4.default), {
            space: "space.100",
            shouldWrap: true,
            alignBlock: "center",
            separator: isBold ? undefined : "\xb7",
            testId: testId && `${testId}-actions`,
            children: actions.map((action, index)=>/*#__PURE__*/ (0, $2iln5.jsx)((0, $groaY.default), {
                    onClick: action.onClick,
                    href: action.href,
                    target: action.target,
                    appearance: isBold ? 'default' : 'link',
                    component: linkComponent,
                    spacing: "compact",
                    testId: action.testId,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        '--color': (0, $hkYSr.actionTextColor)[appearance],
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color': (0, $3cug2.actionBackgroundColor)[appearance].default,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-hover': (0, $3cug2.actionBackgroundColor)[appearance].pressed,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-active': (0, $3cug2.actionBackgroundColor)[appearance].active
                    },
                    className: (0, $jAkMr.default)([
                        "_nup91zz4 _u4iq1zz4 _1w901pkf _qkwg1pkf _12r21wq8 _il101wq8 _1ku2grf3 _1v8mgrf3 _gbuigrf3 _1dwvgrf3 _1bk61a66 _1wy61a66 _b3g31a66 _eqps1a66 _ow071r31 _1p6b1r31 _8dbm1r31 _77mc1r31 _17rj8stv _1p6m8stv _5kwq8stv _1pd88stv _1iqunqa1 _1ejunqa1 _b6ztnqa1 _1rsgnqa1 _u1mb14jz _10fu17w4",
                        appearance === (0, $25sCv.DEFAULT_APPEARANCE) && "_1dltgrf3 _h03xgrf3 _w8sqgrf3 _1iysgrf3 _fjwrgrf3 _cwkngrf3 _1yxxgrf3 _z7cdgrf3"
                    ]),
                    children: action.content
                }, index))
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3f642008c609dbdb$export$2e2bcd8739ae039 = $3f642008c609dbdb$var$FlagActions;

});
parcelRegister("hkYSr", function(module, exports) {
$parcel$export(module.exports, "actionTextColor", () => $89ab73da63fd7ff8$export$7bcfe3cca4dd78b6);
const $89ab73da63fd7ff8$export$7bcfe3cca4dd78b6 = {
    success: "var(--ds-text-inverse, #FFFFFF)",
    info: "var(--ds-text-inverse, #FFFFFF)",
    error: "var(--ds-text-inverse, #FFFFFF)",
    warning: "var(--ds-text-warning-inverse, #292A2E)",
    normal: "var(--ds-link, #1868DB)"
};

});

parcelRegister("3cug2", function(module, exports) {
$parcel$export(module.exports, "actionBackgroundColor", () => $7a0c4e1df0a2a906$export$81ba6b63eedb299f);






const $7a0c4e1df0a2a906$export$81ba6b63eedb299f = {
    success: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    info: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    error: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    warning: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    normal: {
        default: 'none',
        active: 'none',
        pressed: 'none'
    }
};

});


parcelRegister("bcfqP", function(module, exports) {
$parcel$export(module.exports, "flagBackgroundColor", () => $95a299f4ed18b46e$export$59e42969c95d314);
const $95a299f4ed18b46e$export$59e42969c95d314 = {
    error: 'color.background.danger.bold',
    info: 'color.background.neutral.bold',
    normal: 'elevation.surface.overlay',
    success: 'color.background.success.bold',
    warning: 'color.background.warning.bold'
};

});

parcelRegister("7xn0x", function(module, exports) {
$parcel$export(module.exports, "flagIconColor", () => $e099838efbf9f5ec$export$7f70afe2167f8235);
const $e099838efbf9f5ec$export$7f70afe2167f8235 = {
    error: "var(--ds-icon-inverse, #FFFFFF)",
    info: "var(--ds-icon-inverse, #FFFFFF)",
    normal: "var(--ds-icon-subtle, #505258)",
    success: "var(--ds-icon-inverse, #FFFFFF)",
    warning: "var(--ds-icon-warning-inverse, #292A2E)"
};

});

parcelRegister("b9ly8", function(module, exports) {
$parcel$export(module.exports, "flagIconGlyph", () => $a38eb0447a9a7cdd$export$73f08aee70487cd4);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $bnlbq = parcelRequire("bnlbq");

var $6o94o = parcelRequire("6o94o");

var $fHnP4 = parcelRequire("fHnP4");

var $gm2sB = parcelRequire("gm2sB");
const $a38eb0447a9a7cdd$export$73f08aee70487cd4 = {
    error: /*#__PURE__*/ (0, $2iln5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bnlbq))), {
        label: ""
    }),
    info: /*#__PURE__*/ (0, $2iln5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6o94o))), {
        label: ""
    }),
    normal: /*#__PURE__*/ (0, $2iln5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6o94o))), {
        label: ""
    }),
    success: /*#__PURE__*/ (0, $2iln5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fHnP4))), {
        label: ""
    }),
    warning: /*#__PURE__*/ (0, $2iln5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gm2sB))), {
        label: ""
    })
};

});

parcelRegister("4FvD5", function(module, exports) {
$parcel$export(module.exports, "flagTextColor", () => $211d2adf906a8501$export$f50075b2584087f);
const $211d2adf906a8501$export$f50075b2584087f = {
    error: 'color.text.inverse',
    info: 'color.text.inverse',
    normal: 'color.text',
    success: 'color.text.inverse',
    warning: 'color.text.warning.inverse'
};

});

parcelRegister("7bbrm", function(module, exports) {
$parcel$export(module.exports, "flagTextColorToken", () => $fbb6ff6e011dabc8$export$13b42cd9d596bfe0);
const $fbb6ff6e011dabc8$export$13b42cd9d596bfe0 = {
    error: "var(--ds-text-inverse, #FFFFFF)",
    info: "var(--ds-text-inverse, #FFFFFF)",
    normal: "var(--ds-text, #292A2E)",
    success: "var(--ds-text-inverse, #FFFFFF)",
    warning: "var(--ds-text-warning-inverse, #292A2E)"
};

});

parcelRegister("5BecW", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0da6df0c897d0e8$export$2e2bcd8739ae039);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $3lyVW = parcelRequire("3lyVW");

var $l6Otc = parcelRequire("l6Otc");

var $iCx26 = parcelRequire("iCx26");

var $3PWWl = parcelRequire("3PWWl");

var $7bbrm = parcelRequire("7bbrm");
const $e0da6df0c897d0e8$var$DismissButtonComponent = ({ appearance: appearance, onClick: onClick, isBold: isBold, isExpanded: isExpanded, testId: testId })=>{
    let ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($3PWWl)));
    let buttonLabel = 'Dismiss';
    let buttonTestId = testId && `${testId}-dismiss`;
    if (isBold) {
        ButtonIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($iCx26))) : (0, (/*@__PURE__*/$parcel$interopDefault($l6Otc)));
        buttonLabel = isExpanded ? 'Collapse' : 'Expand';
        buttonTestId = testId && `${testId}-toggle`;
    }
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $3lyVW.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, $2iln5.jsx)(ButtonIcon, {
                ...iconProps,
                size: "small",
                label: "",
                color: (0, $7bbrm.flagTextColorToken)[appearance]
            }),
        appearance: "subtle",
        spacing: "compact",
        label: buttonLabel,
        onClick: onClick,
        "aria-expanded": isBold ? isExpanded : undefined,
        testId: buttonTestId
    });
};
const $e0da6df0c897d0e8$var$DismissButton = /*#__PURE__*/ (0, $4tluv.memo)($e0da6df0c897d0e8$var$DismissButtonComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e0da6df0c897d0e8$export$2e2bcd8739ae039 = $e0da6df0c897d0e8$var$DismissButton;

});

parcelRegister("fWLYW", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b4eadc3212f9d18$export$2e2bcd8739ae039);
/* expander.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $1F7MK = parcelRequire("1F7MK");
var $ka1iJ = parcelRequire("ka1iJ");

var $fYX4U = parcelRequire("fYX4U");
var $fm1L8 = parcelRequire("fm1L8");
const $3b4eadc3212f9d18$var$styles = {
    expander: "_1bsb1osq",
    container: "_v5641xzp"
};
const $3b4eadc3212f9d18$var$Expander = ({ children: children, isExpanded: isExpanded, testId: testId })=>{
    // Need to always render the ExpanderInternal otherwise the
    // reveal transition doesn't happen. We can't use CSS animation for
    // the the reveal because we don't know the height of the content.
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $fYX4U.default), {
        xcss: $3b4eadc3212f9d18$var$styles.expander,
        style: {
            maxHeight: isExpanded ? 150 : 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flex: '1 1 100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 0
        },
        "aria-hidden": !isExpanded,
        testId: testId && `${testId}-expander`,
        children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $1F7MK.default), {
            appear: true,
            children: isExpanded && /*#__PURE__*/ (0, $2iln5.jsx)((0, $ka1iJ.default), {
                children: (props)=>/*#__PURE__*/ (0, $2iln5.jsx)((0, $fYX4U.default), {
                        xcss: $3b4eadc3212f9d18$var$styles.container,
                        ...props,
                        children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $fm1L8.default), {
                            space: "space.100",
                            children: children
                        })
                    })
            })
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3b4eadc3212f9d18$export$2e2bcd8739ae039 = $3b4eadc3212f9d18$var$Expander;

});

parcelRegister("egv1H", function(module, exports) {
$parcel$export(module.exports, "useFlagGroup", () => $d9dba6ddbb24dffd$export$e91ea202abb66350);

var $4tluv = parcelRequire("4tluv");

var $9TlEu = parcelRequire("9TlEu");
function $d9dba6ddbb24dffd$export$e91ea202abb66350() {
    return (0, $4tluv.useContext)((0, $9TlEu.FlagGroupContext));
}

});
parcelRegister("9TlEu", function(module, exports) {
$parcel$export(module.exports, "FlagGroupContext", () => $7612e10073b7a916$export$c57ba665aaa722be);

var $4tluv = parcelRequire("4tluv");

var $6dnjV = parcelRequire("6dnjV");
const $7612e10073b7a916$export$c57ba665aaa722be = /*#__PURE__*/ (0, $4tluv.createContext)((0, $6dnjV.defaultFlagGroupContext));

});
parcelRegister("6dnjV", function(module, exports) {
$parcel$export(module.exports, "defaultFlagGroupContext", () => $90b74c80dd745d60$export$643760c4938da30d);

var $ccErM = parcelRequire("ccErM");
const $90b74c80dd745d60$export$643760c4938da30d = {
    onDismissed: (0, $ccErM.default),
    isDismissAllowed: false
};

});





parcelRegister("kijvt", function(module, exports) {
$parcel$export(module.exports, "default", () => $176b9089455cfd2a$export$2e2bcd8739ae039);
/* flag-group.tsx generated by @compiled/babel-plugin v0.36.1 */ /* flag-group.tsx generated by @compiled/babel-plugin v0.36.1 */ /* flag-group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");

var $Hyfcf = parcelRequire("Hyfcf");

var $8ik9q = parcelRequire("8ik9q");

var $1iuUn = parcelRequire("1iuUn");

var $klNPa = parcelRequire("klNPa");

var $ccErM = parcelRequire("ccErM");

var $1F7MK = parcelRequire("1F7MK");
var $6B5AD = parcelRequire("6B5AD");
var $5qoSr = parcelRequire("5qoSr");

var $3X3Vo = parcelRequire("3X3Vo");

var $gkJgm = parcelRequire("gkJgm");

var $fYX4U = parcelRequire("fYX4U");

var $2ocq9 = parcelRequire("2ocq9");

var $k7gbB = parcelRequire("k7gbB");

var $6dnjV = parcelRequire("6dnjV");

var $9TlEu = parcelRequire("9TlEu");
const $176b9089455cfd2a$export$1eee5ddc4f6d41c5 = 400;
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
const $176b9089455cfd2a$var$groupStyles = {
    root: "_v5641b8g _1bsb1kdj _kqswstnw _u7coidpf _1eqkauwl",
    first: "_v564glyw _t9ec1ygq _1pbyqfx8",
    second: "_1pbyegat",
    nth: "_5sag5cps _t9ec1hw2",
    hidden: "_3um015vq"
};
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
const $176b9089455cfd2a$var$groupStylesNew = {
    root: "_v564t8bh _kqswstnw _u7coidpf _1bsb1kdj _1eqkauwl",
    first: "_t9ec1ygq _1pbyqfx8",
    second: "_t9ec1pi4 _1pbyegat",
    nth: "_t9ec15wd",
    hidden: "_3um015vq"
};
// Transform needed to push up while 1st flag is leaving
// Exiting time should match the exiting time of motion so is halved
const $176b9089455cfd2a$var$dismissAllowedStyles = null;
const $176b9089455cfd2a$var$flagGroupContainerStyles = null;
/**
 * __Flag group__
 *
 * A flag group is used to group a set of related flags, with entry and exit animations.
 *
 * - [Examples](https://atlassian.design/components/flag/flag-group/examples)
 * - [Code](https://atlassian.design/components/flag/flag-group/code)
 */ const $176b9089455cfd2a$var$FlagGroup = (props)=>{
    const { id: id, label: label = 'Flag notifications', labelTag: LabelTag = 'h2', shouldRenderToParent: shouldRenderToParent = false, children: children, onDismissed: onDismissed = (0, $ccErM.default) } = props;
    const hasFlags = Array.isArray(children) ? children.length > 0 : Boolean(children);
    const dismissFlagContext = (0, $4tluv.useMemo)(()=>({
            onDismissed: onDismissed,
            isDismissAllowed: true
        }), [
        onDismissed
    ]);
    // Keep a stable reference to the latest children, dismiss handler, and
    // analytics creator so the keydown listener never reads stale closures.
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $8ik9q.useAnalyticsEvents)();
    const latestRef = (0, $4tluv.useRef)({
        children: children,
        onDismissed: onDismissed,
        createAnalyticsEvent: createAnalyticsEvent
    });
    latestRef.current = {
        children: children,
        onDismissed: onDismissed,
        createAnalyticsEvent: createAnalyticsEvent
    };
    // Accessibility (JRACLOUD-97876): allow keyboard-only and assistive
    // technology users to dismiss the topmost (and only dismissable) flag with
    // the Escape key, without having to tab through the entire page to reach
    // the dismiss button. Behaviour is gated behind a feature flag so it can
    // be rolled out and validated incrementally.
    (0, $4tluv.useEffect)(()=>{
        if (!(0, $3X3Vo.fg)('platform_dst_flag_keyboard_dismiss')) return;
        if (!hasFlags) return;
        const doc = (0, $1iuUn.getDocument)();
        if (!doc) return;
        return (0, $Hyfcf.bind)(doc, {
            type: 'keydown',
            listener: (event)=>{
                if (event.key !== 'Escape' || event.defaultPrevented) return;
                const currentChildren = latestRef.current.children;
                const firstFlag = Array.isArray(currentChildren) ? currentChildren.find(Boolean) : currentChildren;
                if (!firstFlag || typeof firstFlag !== 'object') return;
                const id = firstFlag.props?.id;
                if (id === undefined || id === null || id === '') return;
                const analyticsEvent = latestRef.current.createAnalyticsEvent({
                    action: 'dismissed',
                    actionSubject: 'flag',
                    attributes: {
                        dismissedVia: 'keyboardShortcut',
                        key: 'Escape'
                    }
                });
                event.preventDefault();
                latestRef.current.onDismissed?.(id, analyticsEvent);
            }
        });
    }, [
        hasFlags
    ]);
    const renderChildren = ()=>{
        return children && typeof children === 'object' ? (0, $4tluv.Children).map(children, (flag, index)=>{
            const isDismissAllowed = index === 0;
            return (0, $3X3Vo.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, $2iln5.jsx)((0, $fYX4U.default), {
                xcss: (0, $klNPa.cx)($176b9089455cfd2a$var$groupStylesNew.root, index === 0 && $176b9089455cfd2a$var$groupStylesNew.first, index === 1 && $176b9089455cfd2a$var$groupStylesNew.second, index >= 2 && $176b9089455cfd2a$var$groupStylesNew.nth, index >= 3 && $176b9089455cfd2a$var$groupStylesNew.hidden),
                "data-vc-oob": true,
                children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $6B5AD.default), {
                    enteringAnimation: "var(--ds-flag-enter, 250ms cubic-bezier(0, 0.4, 0, 1) SlideIn50PercentLeft, 250ms cubic-bezier(0, 0.4, 0, 1) FadeIn0to100)",
                    exitingAnimation: "var(--ds-flag-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOut15PercentLeft, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
                    children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $9TlEu.FlagGroupContext).Provider, {
                        value: // Only the first flag should be able to be dismissed.
                        isDismissAllowed ? dismissFlagContext : (0, $6dnjV.defaultFlagGroupContext),
                        children: flag
                    })
                })
            }) : /*#__PURE__*/ (0, $2iln5.jsx)((0, $5qoSr.default), {
                enterFrom: "left",
                fade: "inout",
                duration: "medium",
                animationTimingFunction: "ease-in",
                children: ({ className: className, ref: ref })=>/*#__PURE__*/ (0, $2iln5.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $jAkMr.default)([
                            $176b9089455cfd2a$var$groupStyles.root,
                            index === 0 && $176b9089455cfd2a$var$groupStyles.first,
                            index === 1 && $176b9089455cfd2a$var$groupStyles.second,
                            index >= 1 && $176b9089455cfd2a$var$groupStyles.nth,
                            index >= 2 && $176b9089455cfd2a$var$groupStyles.hidden,
                            isDismissAllowed && "_12a7luct",
                            className
                        ]),
                        ref: ref,
                        "data-vc-oob": true,
                        children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $9TlEu.FlagGroupContext).Provider, {
                            value: // Only the first flag should be able to be dismissed.
                            isDismissAllowed ? dismissFlagContext : (0, $6dnjV.defaultFlagGroupContext),
                            children: flag
                        })
                    })
            });
        }) : false;
    };
    const isKeyboardDismissEnabled = (0, $3X3Vo.fg)('platform_dst_flag_keyboard_dismiss');
    // When the keyboard dismiss shortcut is available, surface it to assistive
    // technology users via the existing visually-hidden landmark heading so they
    // know they can press Escape to dismiss the topmost flag.
    const screenReaderLabel = isKeyboardDismissEnabled ? `${label}. Press Escape to dismiss.` : label;
    const flags = /*#__PURE__*/ (0, $2iln5.jsxs)("div", {
        id: id,
        "data-vc-oob": true,
        className: (0, $jAkMr.default)([
            "_kqsw1n9t _1pbyxejw _u7cooahv _1e021epz _1iafidpf _il0widpf"
        ]),
        children: [
            hasFlags ? /*#__PURE__*/ (0, $2iln5.jsx)((0, $k7gbB.default), {
                children: /*#__PURE__*/ (0, $2iln5.jsx)(LabelTag, {
                    children: screenReaderLabel
                })
            }) : null,
            /*#__PURE__*/ (0, $2iln5.jsx)((0, $1F7MK.default), {
                appear: false,
                children: renderChildren()
            })
        ]
    });
    return shouldRenderToParent ? flags : /*#__PURE__*/ (0, $2iln5.jsx)((0, $gkJgm.default), {
        zIndex: (0, $2ocq9.layers).flag(),
        children: flags
    });
};
var $176b9089455cfd2a$export$2e2bcd8739ae039 = $176b9089455cfd2a$var$FlagGroup;

});
parcelRegister("6B5AD", function(module, exports) {
$parcel$export(module.exports, "default", () => $c2c74590cfa710e2$export$2e2bcd8739ae039);
/* motion.tsx generated by @compiled/babel-plugin v0.36.1 */ /* motion.tsx generated by @compiled/babel-plugin v0.36.1 */ /* motion.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $jAkMr = parcelRequire("jAkMr");

var $4tluv = parcelRequire("4tluv");

var $klNPa = parcelRequire("klNPa");

var $hHj16 = parcelRequire("hHj16");

var $cGlqj = parcelRequire("cGlqj");

var $f47uX = parcelRequire("f47uX");

var $eDEfX = parcelRequire("eDEfX");

var $i7PgC = parcelRequire("i7PgC");

var $1F7MK = parcelRequire("1F7MK");

var $lWeRs = parcelRequire("lWeRs");
const $c2c74590cfa710e2$var$styles = {
    base: "_1y0co91m _1bumglyw _sedtglyw",
    hidden: "_3um015vq",
    entering: "_1o51eoah",
    exiting: "_1o51q7pw"
};
var $c2c74590cfa710e2$export$569340a66b14e0dc = /*#__PURE__*/ function(Reanimate) {
    Reanimate["enter"] = "enter";
    Reanimate["exit_then_enter"] = "exit_then_enter";
    return Reanimate;
}({});
/**
 * __Motion__
 *
 * A motion primitive that can be used to animate the entry and exit of components.
 */ const $c2c74590cfa710e2$var$Motion = /*#__PURE__*/ (0, $4tluv.forwardRef)(({ children: children, enteringAnimation: enteringAnimation, enteringAnimationXcss: enteringAnimationXcss, exitingAnimation: exitingAnimation, exitingAnimationXcss: exitingAnimationXcss, onFinish: onFinishMotion, xcss: xcss, testId: testId }, ref)=>{
    const staggered = (0, $lWeRs.useStaggeredEntrance)();
    const { isExiting: isExiting, onFinish: onExitFinished, appear: appear } = (0, $1F7MK.useExitingPersistence)();
    const staggeredDelay = isExiting ? 0 : staggered.delay;
    const staggedIsReady = staggered.isReady;
    const [state, setState] = (0, $4tluv.useState)(appear ? staggedIsReady && !staggeredDelay ? 'entering' : 'init' : 'idle');
    const elementRef = (0, $4tluv.useRef)(null);
    const reanimateRef = (0, $4tluv.useRef)();
    const animationRef = (0, $4tluv.useRef)();
    const staggeredEntryRef = (0, $4tluv.useRef)();
    (0, $4tluv.useEffect)(()=>{
        if (isExiting) setState('exiting');
    }, [
        isExiting
    ]);
    // Handles staggered entry
    (0, $4tluv.useEffect)(()=>{
        if (state !== 'init') return;
        // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(()=>{
            setState('entering');
        }, staggeredDelay);
        return ()=>{
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        state,
        staggedIsReady,
        staggeredDelay
    ]);
    /**
   * Updates relevant state.
   * Called when the animation is finished, or immediately with reduced motion.
   */ const onAnimationEnd = (0, $4tluv.useCallback)((state, cancelled)=>{
        // We are done animating, so we set the state to idle
        let newState = 'idle';
        if (state === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinished?.();
            onFinishMotion?.('exiting');
        }
        if (state === 'entering') onFinishMotion?.('entering');
        if (reanimateRef.current === "exit_then_enter") {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = "enter";
            newState = 'entering';
        } else if (reanimateRef.current) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        if (!cancelled) setState(newState);
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onExitFinished
    ]);
    (0, $4tluv.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (!staggedIsReady) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        }
        // If the state is idle or init, we don't need to do anything
        if (state === 'idle' || state === 'init') return;
        // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if ((0, $cGlqj.isReducedMotion)() || !exitingAnimation && !exitingAnimationXcss) {
            onAnimationEnd(state, isCancelled);
            return;
        }
        let animationDuration = 0;
        let animationDelay = 0;
        if (state === 'entering' || state === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    const animationTimings = (0, $eDEfX.getDurationMs)((0, $i7PgC.resolveMotionToken)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDelay = animationTimings.delay;
                } else {
                    // Custom motion
                    const styles = window.getComputedStyle(elementRef.current);
                    if (styles.animationDuration) animationDuration = (0, $f47uX.convertToMs)(styles.animationDuration);
                    if (styles.animationDelay) animationDelay = (0, $f47uX.convertToMs)(styles.animationDelay);
                }
            }
        }
        // Queue `onAnimationEnd` for after the animation has finished
        if (state === 'exiting' && (exitingAnimation || exitingAnimationXcss)) animationRef.current = setTimeout(()=>onAnimationEnd(state, isCancelled), animationDuration + animationDelay);
        else if (state === 'entering' && (enteringAnimation || enteringAnimationXcss)) animationRef.current = setTimeout(()=>onAnimationEnd(state, isCancelled), animationDuration + animationDelay);
        return ()=>{
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        state,
        exitingAnimation,
        enteringAnimation,
        exitingAnimationXcss,
        enteringAnimationXcss,
        staggeredDelay,
        staggedIsReady
    ]);
    (0, $4tluv.useImperativeHandle)(ref, ()=>({
            reanimate: (value)=>{
                animationRef.current && clearTimeout(animationRef.current);
                reanimateRef.current = value;
                if (value === "exit_then_enter") setState('exiting');
                else if (value === "enter") setState('entering');
            }
        }));
    let style = {};
    let customAnimation;
    if (state === 'entering') {
        if (enteringAnimation) style.animation = `${enteringAnimation} backwards`;
        else if (enteringAnimationXcss) customAnimation = enteringAnimationXcss;
    } else if (state === 'exiting') {
        if (exitingAnimation) style.animation = `${exitingAnimation} forwards`;
        else if (exitingAnimationXcss) customAnimation = exitingAnimationXcss;
    }
    const hasAnimationStyles = state !== 'idle' && state !== 'init';
    return /*#__PURE__*/ (0, $2iln5.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $jAkMr.default)([
            hasAnimationStyles && $c2c74590cfa710e2$var$styles.base,
            state === 'init' && $c2c74590cfa710e2$var$styles.hidden,
            state === 'entering' && $c2c74590cfa710e2$var$styles.entering,
            state === 'exiting' && $c2c74590cfa710e2$var$styles.exiting,
            (0, $klNPa.cx)(xcss, customAnimation)
        ]),
        ref: (0, $hHj16.default)([
            staggered.ref,
            elementRef
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: hasAnimationStyles ? style : undefined,
        "data-testid": testId,
        children: children
    });
});
var $c2c74590cfa710e2$export$2e2bcd8739ae039 = $c2c74590cfa710e2$var$Motion;

});
parcelRegister("hHj16", function(module, exports) {
$parcel$export(module.exports, "default", () => $0afabf8591262654$export$2e2bcd8739ae039);
function $0afabf8591262654$export$2e2bcd8739ae039(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null && typeof ref === 'object') ref.current = value;
        });
    };
}

});

parcelRegister("f47uX", function(module, exports) {
$parcel$export(module.exports, "convertToMs", () => $613197f74c163472$export$75eee42ff540d8ae);
const $613197f74c163472$export$75eee42ff540d8ae = (duration)=>{
    // Use regex to separate the number and the unit
    const matches = duration.match(/^(\d+\.?\d*)(s|ms)$/);
    if (!matches) return 0; // Or return for invalid format
    const value = parseFloat(matches[1]);
    const unit = matches[2];
    if (unit === 's') return value * 1000; // Convert seconds to milliseconds
    else return value; // Already in milliseconds
};

});

parcelRegister("eDEfX", function(module, exports) {
$parcel$export(module.exports, "getDurationMs", () => $52173a0fae7d3899$export$d0038b6e47881463);
/**
 * Gets the duration in milliseconds for an animation property.
 * @param animation - The animation property to get the duration for.
 * @returns The duration in milliseconds.
 */ const $52173a0fae7d3899$export$d0038b6e47881463 = (animation)=>{
    const match = [
        ...animation.trim().matchAll(/(-?\d*\.?\d+)(ms|s)\b/g)
    ];
    if (match.length === 0) return {
        duration: 0,
        delay: 0
    };
    const durationValue = parseFloat(match[0][1]);
    const durationUnit = match[0][2];
    const duration = durationUnit === 's' ? durationValue * 1000 : durationValue;
    let delay = 0;
    if (match[1]) {
        const delayValue = parseFloat(match[1][1]);
        const delayUnit = match[1][2];
        delay = delayUnit === 's' ? delayValue * 1000 : delayValue;
    }
    return {
        duration: duration,
        delay: delay
    };
};

});

parcelRegister("i7PgC", function(module, exports) {
$parcel$export(module.exports, "resolveMotionToken", () => $f73e92d392c435a4$export$82b92541889a035d);

var $1iuUn = parcelRequire("1iuUn");
const $f73e92d392c435a4$export$82b92541889a035d = (token)=>{
    const cssVarMatch = token.match(/var\(\s*(--[^,\s)]+)/);
    const cssVar = cssVarMatch ? cssVarMatch[1] : null;
    if (cssVar) {
        const documentElement = (0, $1iuUn.getDocument)()?.documentElement;
        if (documentElement) return getComputedStyle(documentElement).getPropertyValue(cssVar);
    }
    return '';
};

});


parcelRegister("5qoSr", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3400c07b5f47d56$export$2e2bcd8739ae039);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $cZhr8 = parcelRequire("cZhr8");
/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion).
 */ const $a3400c07b5f47d56$var$SlideIn = ({ children: children, enterFrom: enterFrom, exitTo: exitTo, duration: duration = 'medium', isPaused: isPaused, onFinish: onFinish, animationTimingFunction: animationTimingFunction = 'ease-out', animationTimingFunctionExiting: animationTimingFunctionExiting = 'ease-in' })=>{
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $cZhr8.default), {
        duration: duration,
        enteringAnimation: `slide-in-from-${enterFrom}`,
        exitingAnimation: `slide-out-from-${exitTo || enterFrom}`,
        animationTimingFunction: animationTimingFunction,
        animationTimingFunctionExiting: animationTimingFunctionExiting,
        isPaused: isPaused,
        onFinish: onFinish,
        children: children
    });
};
var $a3400c07b5f47d56$export$2e2bcd8739ae039 = $a3400c07b5f47d56$var$SlideIn;

});



parcelRegister("lvn8a", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "getTheme", () => (parcelRequire("bfqIz")).default);
$parcel$export(module.exports, "default", () => (parcelRequire("bx2fV")).default);
$parcel$export(module.exports, "createTheme", () => (parcelRequire("3xU1R")).createTheme);
/*
   This file will become the new index for theme once the codemod is mature enough.
   For now we're keeping the index file to avoid having to do a major change.
   Once the codemod is done and all the AK modules have been codeshifted, we delete index.js and rename this file to index + update all the imports
*/ 
var $bfqIz = parcelRequire("bfqIz");

var $bx2fV = parcelRequire("bx2fV");

var $3xU1R = parcelRequire("3xU1R");

});
parcelRegister("bfqIz", function(module, exports) {
$parcel$export(module.exports, "default", () => $0067451083271da4$export$2e2bcd8739ae039);

var $j6jci = parcelRequire("j6jci");
function $0067451083271da4$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $j6jci.CHANNEL) in props.theme) return props.theme[0, $j6jci.CHANNEL];
        else if ('mode' in props.theme && (0, $j6jci.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $j6jci.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("j6jci", function(module, exports) {
$parcel$export(module.exports, "CHANNEL", () => $4c898485d363fe67$export$44ffba16bd48dac6);
$parcel$export(module.exports, "DEFAULT_THEME_MODE", () => $4c898485d363fe67$export$c93026a968943f95);
$parcel$export(module.exports, "THEME_MODES", () => $4c898485d363fe67$export$6ba72c8346b4c57e);
$parcel$export(module.exports, "focusRing", () => $4c898485d363fe67$export$8e24544ddba725ee);
$parcel$export(module.exports, "noFocusRing", () => $4c898485d363fe67$export$c0dd343266bc3261);
$parcel$export(module.exports, "layers", () => $4c898485d363fe67$export$7be255094ccdc533);
$parcel$export(module.exports, "visuallyHidden", () => $4c898485d363fe67$export$a1b3edb637fb4f35);
$parcel$export(module.exports, "assistive", () => $4c898485d363fe67$export$ba1d834b86d72a09);
$parcel$export(module.exports, "skeletonShimmer", () => $4c898485d363fe67$export$e497e856b4f89fcd);

var $6Yzy2 = parcelRequire("6Yzy2");
const $4c898485d363fe67$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
const $4c898485d363fe67$export$c93026a968943f95 = 'light';
const $4c898485d363fe67$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
const $4c898485d363fe67$export$8e24544ddba725ee = (color = "var(--ds-border-focused, #4688EC)", outlineWidth = 2)=>{
    (0, $6Yzy2.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return `
  &:focus {
    outline: none;
    box-shadow: 0px 0px 0px ${outlineWidth}px ${color};
  }
`;
};
const $4c898485d363fe67$export$c0dd343266bc3261 = ()=>`
  box-shadow: none;
`;
const $4c898485d363fe67$export$7be255094ccdc533 = {
    card: ()=>100,
    navigation: ()=>200,
    dialog: ()=>300,
    layer: ()=>400,
    blanket: ()=>500,
    modal: ()=>510,
    flag: ()=>600,
    spotlight: ()=>700,
    tooltip: ()=>9999
};
const $4c898485d363fe67$export$a1b3edb637fb4f35 = ()=>{
    (0, $6Yzy2.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
const $4c898485d363fe67$export$ba1d834b86d72a09 = $4c898485d363fe67$export$a1b3edb637fb4f35;
const $4c898485d363fe67$export$e497e856b4f89fcd = ()=>({
        css: {
            backgroundColor: "var(--ds-skeleton, #0515240F)",
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, #0515240F)"
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, #17171708)"
            }
        }
    });

});
parcelRegister("6Yzy2", function(module, exports) {
$parcel$export(module.exports, "default", () => $5fa01f41864c17c6$export$2e2bcd8739ae039);

var $1k1rS = parcelRequire("1k1rS");
function $5fa01f41864c17c6$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $1k1rS.default)(`[${packageName}]: The ${api} is deprecated.${additionalMessage && ` ${additionalMessage}`}`);
}

});
parcelRegister("1k1rS", function(module, exports) {
$parcel$export(module.exports, "default", () => $f4c6ba066881821e$export$2e2bcd8739ae039);
/* eslint-disable no-console */ const $f4c6ba066881821e$var$printed = {};
function $f4c6ba066881821e$export$2e2bcd8739ae039(message) {
    if ($f4c6ba066881821e$var$printed[message]) return;
    $f4c6ba066881821e$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});




parcelRegister("bx2fV", function(module, exports) {
$parcel$export(module.exports, "default", () => $906b7bf5ace4c04b$export$2e2bcd8739ae039);

var $3xU1R = parcelRequire("3xU1R");
// Create default global light theme
const $906b7bf5ace4c04b$var$dest = (0, $3xU1R.createTheme)(()=>({
        mode: 'light'
    }));
const $906b7bf5ace4c04b$var$Provider = $906b7bf5ace4c04b$var$dest.Provider;
const $906b7bf5ace4c04b$var$Consumer = $906b7bf5ace4c04b$var$dest.Consumer;
const $906b7bf5ace4c04b$export$7692396083754928 = $906b7bf5ace4c04b$var$dest.useTheme;
const $906b7bf5ace4c04b$var$Theme = {
    Provider: $906b7bf5ace4c04b$var$Provider,
    Consumer: $906b7bf5ace4c04b$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$906b7bf5ace4c04b$export$2e2bcd8739ae039 = $906b7bf5ace4c04b$var$Theme;

});
parcelRegister("3xU1R", function(module, exports) {
$parcel$export(module.exports, "createTheme", () => $90d510b62c82932a$export$25d302a5b900a763);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");
function $90d510b62c82932a$export$25d302a5b900a763(defaultGetTokens) {
    const emptyThemeFn = (getTokens, props)=>getTokens(props);
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ const ThemeContext = /*#__PURE__*/ (0, $4tluv.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        const theme = (0, $4tluv.useContext)(ThemeContext);
        const themeFn = theme || emptyThemeFn;
        const tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        const { children: children, ...themeProps } = props;
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        const tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, $2iln5.jsx)((0, $2iln5.Fragment), {
            children: children(tokens)
        });
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        const themeFn = (0, $4tluv.useContext)(ThemeContext);
        const valueFn = props.value || emptyThemeFn;
        const mixedFn = (0, $4tluv.useCallback)((themeProps)=>valueFn(themeFn, themeProps), [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, $2iln5.jsx)(ThemeContext.Provider, {
            value: mixedFn,
            children: props.children
        });
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});



parcelRegister("eL2h4", function(module, exports) {
$parcel$export(module.exports, "default", () => $092e6638f4a4603a$export$2e2bcd8739ae039);

var $4tluv = parcelRequire("4tluv");
function $092e6638f4a4603a$export$2e2bcd8739ae039(ref, autoFocus) {
    const initialMount = (0, $4tluv.useRef)(true);
    (0, $4tluv.useEffect)(()=>{
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("i83eE", function(module, exports) {
$parcel$export(module.exports, "default", () => $40fba7cd8dc80f38$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4tluv = parcelRequire("4tluv");

var $ft5N0 = parcelRequire("ft5N0");
const $40fba7cd8dc80f38$var$BORDER_WIDTH = 2;
const $40fba7cd8dc80f38$var$baseFocusOutsideStyles = (0, $ft5N0.css)({
    outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`,
    outlineOffset: $40fba7cd8dc80f38$var$BORDER_WIDTH
});
const $40fba7cd8dc80f38$var$baseInsetStyles = (0, $ft5N0.css)({
    outlineColor: "var(--ds-border-focused, #4688EC)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$40fba7cd8dc80f38$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-focused, 2px)"
});
const $40fba7cd8dc80f38$var$focusRingStyles = (0, $ft5N0.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $40fba7cd8dc80f38$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $40fba7cd8dc80f38$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: `${"var(--ds-border-width, 1px)"} solid`
        }
    }
});
const $40fba7cd8dc80f38$var$insetFocusRingStyles = (0, $ft5N0.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $40fba7cd8dc80f38$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $40fba7cd8dc80f38$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: `${"var(--ds-border-width, 1px)"} solid`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ const $40fba7cd8dc80f38$var$FocusRing = /*#__PURE__*/ (0, $4tluv.memo)(({ children: children, isInset: isInset, focus: focus })=>{
    const controlledStyles = isInset ? $40fba7cd8dc80f38$var$baseInsetStyles : $40fba7cd8dc80f38$var$baseFocusOutsideStyles;
    const uncontrolledStyles = isInset ? $40fba7cd8dc80f38$var$insetFocusRingStyles : $40fba7cd8dc80f38$var$focusRingStyles;
    const focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return /*#__PURE__*/ (0, $ft5N0.jsx)((0, $ft5N0.ClassNames), null, ({ css: css, cx: cx })=>(0, $4tluv.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, $4tluv.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children));
});
$40fba7cd8dc80f38$var$FocusRing.displayName = 'FocusRing';
var $40fba7cd8dc80f38$export$2e2bcd8739ae039 = $40fba7cd8dc80f38$var$FocusRing;

});

parcelRegister("jJcBA", function(module, exports) {
$parcel$export(module.exports, "default", () => $c2e3cc77b3b4fede$export$2e2bcd8739ae039);
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $jAkMr = parcelRequire("jAkMr");

var $4tluv = parcelRequire("4tluv");

var $cDSkE = parcelRequire("cDSkE");

var $cuTBF = parcelRequire("cuTBF");
/**
 * Returns the appropriate circle stroke color.
 */ function $c2e3cc77b3b4fede$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-inverse, #FFFFFF)";
}
const $c2e3cc77b3b4fede$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ const $c2e3cc77b3b4fede$var$loadIn = null;
const $c2e3cc77b3b4fede$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ const $c2e3cc77b3b4fede$var$useLayoutEffect = typeof window === 'undefined' ? (0, $4tluv.useEffect) : (0, $4tluv.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ const $c2e3cc77b3b4fede$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).forwardRef(function Spinner({ appearance: appearance = 'inherit', delay: delay = 0, interactionName: interactionName, label: label, size: providedSize = 'medium', testId: testId }, ref) {
    const size = typeof providedSize === 'number' ? providedSize : (0, $cuTBF.presetSizes)[providedSize];
    const animationDelay = `${delay}ms`;
    const stroke = $c2e3cc77b3b4fede$var$getStrokeColor(appearance);
    const context = (0, $4tluv.useContext)((0, $cDSkE.default));
    $c2e3cc77b3b4fede$var$useLayoutEffect(()=>{
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, $2iln5.jsx)("span", {
        /**
   * This span exists to off-load animations from the circle element,
   * which were causing performance issues (style recalculations)
   * on Safari and older versions of Chrome.
   *
   * This can be removed and styles placed back on the circle element once
   * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
   */ "data-testid": testId ? `${testId}-wrapper` : 'spinner-wrapper',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $jAkMr.default)([
            $c2e3cc77b3b4fede$var$styles.wrapperStyles,
            $c2e3cc77b3b4fede$var$styles.rotateStyles
        ]),
        children: /*#__PURE__*/ (0, $2iln5.jsx)("svg", {
            height: size,
            width: size,
            viewBox: "0 0 16 16",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": testId,
            ref: ref,
            "aria-label": label || undefined,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                animationDelay: animationDelay
            },
            role: label ? 'img' : 'none',
            className: (0, $jAkMr.default)([
                $c2e3cc77b3b4fede$var$styles.loadInStyles
            ]),
            children: /*#__PURE__*/ (0, $2iln5.jsx)("circle", {
                cx: "8",
                cy: "8",
                r: "7",
                style: {
                    stroke: stroke
                },
                className: (0, $jAkMr.default)([
                    $c2e3cc77b3b4fede$var$styles.circleStyles
                ])
            })
        })
    });
}));
var $c2e3cc77b3b4fede$export$2e2bcd8739ae039 = $c2e3cc77b3b4fede$var$Spinner;

});
parcelRegister("cuTBF", function(module, exports) {
$parcel$export(module.exports, "presetSizes", () => $04bc3384f7acf759$export$4e9f1640bbe7a1a8);
const $04bc3384f7acf759$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});


parcelRegister("1AyHF", function(module, exports) {
$parcel$export(module.exports, "createPopper", () => $1284129b128e4e9a$export$8f7491d57c8f97a9);

var $l0fyK = parcelRequire("l0fyK");

var $e9WH7 = parcelRequire("e9WH7");

var $24Spt = parcelRequire("24Spt");

var $5nwPk = parcelRequire("5nwPk");

var $fzzWx = parcelRequire("fzzWx");

var $lOTzW = parcelRequire("lOTzW");

var $5Mwp5 = parcelRequire("5Mwp5");

var $8l66N = parcelRequire("8l66N");

var $g9Uys = parcelRequire("g9Uys");

var $gWDw2 = parcelRequire("gWDw2");


var $1284129b128e4e9a$export$d34966752335dd47 = [
    (0, $e9WH7.default),
    (0, $24Spt.default),
    (0, $5nwPk.default),
    (0, $fzzWx.default),
    (0, $lOTzW.default),
    (0, $5Mwp5.default),
    (0, $8l66N.default),
    (0, $g9Uys.default),
    (0, $gWDw2.default)
];
var $1284129b128e4e9a$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $l0fyK.popperGenerator)({
    defaultModifiers: $1284129b128e4e9a$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("l0fyK", function(module, exports) {
$parcel$export(module.exports, "popperGenerator", () => $f4a5aad49efdda5b$export$ed5e13716264f202);

var $g4Ohh = parcelRequire("g4Ohh");

var $2vry6 = parcelRequire("2vry6");

var $ghpfJ = parcelRequire("ghpfJ");

var $iNRnx = parcelRequire("iNRnx");

var $5mkuN = parcelRequire("5mkuN");

var $2A8V2 = parcelRequire("2A8V2");

var $jiP1z = parcelRequire("jiP1z");


var $2hpAu = parcelRequire("2hpAu");
var $f4a5aad49efdda5b$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $f4a5aad49efdda5b$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $f4a5aad49efdda5b$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $f4a5aad49efdda5b$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $f4a5aad49efdda5b$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $2hpAu.isElement)(reference) ? (0, $ghpfJ.default)(reference) : reference.contextElement ? (0, $ghpfJ.default)(reference.contextElement) : [],
                    popper: (0, $ghpfJ.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $5mkuN.default)((0, $jiP1z.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$f4a5aad49efdda5b$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $g4Ohh.default)(reference, (0, $iNRnx.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $2vry6.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $2A8V2.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$f4a5aad49efdda5b$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $f4a5aad49efdda5b$export$8f7491d57c8f97a9 = /*#__PURE__*/ $f4a5aad49efdda5b$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("g4Ohh", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb44052f5dba03df$export$2e2bcd8739ae039);

var $7nPwk = parcelRequire("7nPwk");

var $4wiRi = parcelRequire("4wiRi");

var $jvY4f = parcelRequire("jvY4f");

var $2hpAu = parcelRequire("2hpAu");

var $cbpGQ = parcelRequire("cbpGQ");

var $6WzYt = parcelRequire("6WzYt");

var $4ikrG = parcelRequire("4ikrG");

var $hz7JJ = parcelRequire("hz7JJ");
function $bb44052f5dba03df$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $hz7JJ.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $hz7JJ.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bb44052f5dba03df$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $2hpAu.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $2hpAu.isHTMLElement)(offsetParent) && $bb44052f5dba03df$var$isElementScaled(offsetParent);
    var documentElement = (0, $6WzYt.default)(offsetParent);
    var rect = (0, $7nPwk.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $jvY4f.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $4ikrG.default)(documentElement)) scroll = (0, $4wiRi.default)(offsetParent);
        if ((0, $2hpAu.isHTMLElement)(offsetParent)) {
            offsets = (0, $7nPwk.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $cbpGQ.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("7nPwk", function(module, exports) {
$parcel$export(module.exports, "default", () => $5602a53fd14c7044$export$2e2bcd8739ae039);

var $2hpAu = parcelRequire("2hpAu");

var $hz7JJ = parcelRequire("hz7JJ");

var $doCY5 = parcelRequire("doCY5");

var $iC3kL = parcelRequire("iC3kL");
function $5602a53fd14c7044$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $2hpAu.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $hz7JJ.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $hz7JJ.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $2hpAu.isElement)(element) ? (0, $doCY5.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $iC3kL.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("2hpAu", function(module, exports) {
$parcel$export(module.exports, "isElement", () => $1a91047afae1db93$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $1a91047afae1db93$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $1a91047afae1db93$export$af51f0f06c0f328a);

var $doCY5 = parcelRequire("doCY5");
function $1a91047afae1db93$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $doCY5.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $1a91047afae1db93$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $doCY5.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $1a91047afae1db93$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $doCY5.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("doCY5", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c0bbe8968e94f63$export$2e2bcd8739ae039);
function $9c0bbe8968e94f63$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("hz7JJ", function(module, exports) {
$parcel$export(module.exports, "max", () => $cc9bb4dbe820f60c$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $cc9bb4dbe820f60c$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $cc9bb4dbe820f60c$export$2077e0241d6afd3c);
var $cc9bb4dbe820f60c$export$8960430cfd85939f = Math.max;
var $cc9bb4dbe820f60c$export$96ec731ed4dcb222 = Math.min;
var $cc9bb4dbe820f60c$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("iC3kL", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8ce5ca58c045481$export$2e2bcd8739ae039);

var $5iY8H = parcelRequire("5iY8H");
function $d8ce5ca58c045481$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $5iY8H.default)());
}

});
parcelRegister("5iY8H", function(module, exports) {
$parcel$export(module.exports, "default", () => $3dcd489d21992778$export$2e2bcd8739ae039);
function $3dcd489d21992778$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("4wiRi", function(module, exports) {
$parcel$export(module.exports, "default", () => $34a8c77ea3532a5b$export$2e2bcd8739ae039);

var $4s2O3 = parcelRequire("4s2O3");

var $doCY5 = parcelRequire("doCY5");

var $2hpAu = parcelRequire("2hpAu");

var $7qW8z = parcelRequire("7qW8z");
function $34a8c77ea3532a5b$export$2e2bcd8739ae039(node) {
    if (node === (0, $doCY5.default)(node) || !(0, $2hpAu.isHTMLElement)(node)) return (0, $4s2O3.default)(node);
    else return (0, $7qW8z.default)(node);
}

});
parcelRegister("4s2O3", function(module, exports) {
$parcel$export(module.exports, "default", () => $33dbf43bf1a4675e$export$2e2bcd8739ae039);

var $doCY5 = parcelRequire("doCY5");
function $33dbf43bf1a4675e$export$2e2bcd8739ae039(node) {
    var win = (0, $doCY5.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("7qW8z", function(module, exports) {
$parcel$export(module.exports, "default", () => $56980eee3b7be73c$export$2e2bcd8739ae039);
function $56980eee3b7be73c$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("jvY4f", function(module, exports) {
$parcel$export(module.exports, "default", () => $e34f81b51fd472a2$export$2e2bcd8739ae039);
function $e34f81b51fd472a2$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("cbpGQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $8dea70a2ed4d6527$export$2e2bcd8739ae039);

var $7nPwk = parcelRequire("7nPwk");

var $6WzYt = parcelRequire("6WzYt");

var $4s2O3 = parcelRequire("4s2O3");
function $8dea70a2ed4d6527$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $7nPwk.default)((0, $6WzYt.default)(element)).left + (0, $4s2O3.default)(element).scrollLeft;
}

});
parcelRegister("6WzYt", function(module, exports) {
$parcel$export(module.exports, "default", () => $50e410a32ab7214d$export$2e2bcd8739ae039);

var $2hpAu = parcelRequire("2hpAu");
function $50e410a32ab7214d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $2hpAu.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("4ikrG", function(module, exports) {
$parcel$export(module.exports, "default", () => $3208b3e4d69e3996$export$2e2bcd8739ae039);

var $i8G1V = parcelRequire("i8G1V");
function $3208b3e4d69e3996$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $i8G1V.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("i8G1V", function(module, exports) {
$parcel$export(module.exports, "default", () => $d34993a1dbc6efb4$export$2e2bcd8739ae039);

var $doCY5 = parcelRequire("doCY5");
function $d34993a1dbc6efb4$export$2e2bcd8739ae039(element) {
    return (0, $doCY5.default)(element).getComputedStyle(element);
}

});



parcelRegister("2vry6", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d33d8b47f12fdb4$export$2e2bcd8739ae039);

var $7nPwk = parcelRequire("7nPwk");
function $1d33d8b47f12fdb4$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $7nPwk.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("ghpfJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $bda1d285b4387dbe$export$2e2bcd8739ae039);

var $hD7MZ = parcelRequire("hD7MZ");

var $gDlNP = parcelRequire("gDlNP");

var $doCY5 = parcelRequire("doCY5");

var $4ikrG = parcelRequire("4ikrG");
function $bda1d285b4387dbe$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $hD7MZ.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $doCY5.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $4ikrG.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($bda1d285b4387dbe$export$2e2bcd8739ae039((0, $gDlNP.default)(target)));
}

});
parcelRegister("hD7MZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd5c1ef6f406241a$export$2e2bcd8739ae039);

var $gDlNP = parcelRequire("gDlNP");

var $4ikrG = parcelRequire("4ikrG");

var $jvY4f = parcelRequire("jvY4f");

var $2hpAu = parcelRequire("2hpAu");
function $cd5c1ef6f406241a$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $jvY4f.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $2hpAu.isHTMLElement)(node) && (0, $4ikrG.default)(node)) return node;
    return $cd5c1ef6f406241a$export$2e2bcd8739ae039((0, $gDlNP.default)(node));
}

});
parcelRegister("gDlNP", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1c13369d6088d6c$export$2e2bcd8739ae039);

var $jvY4f = parcelRequire("jvY4f");

var $6WzYt = parcelRequire("6WzYt");

var $2hpAu = parcelRequire("2hpAu");
function $c1c13369d6088d6c$export$2e2bcd8739ae039(element) {
    if ((0, $jvY4f.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $2hpAu.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $6WzYt.default)(element) // fallback
    );
}

});



parcelRegister("iNRnx", function(module, exports) {
$parcel$export(module.exports, "default", () => $db063575fe97832e$export$2e2bcd8739ae039);

var $doCY5 = parcelRequire("doCY5");

var $jvY4f = parcelRequire("jvY4f");

var $i8G1V = parcelRequire("i8G1V");

var $2hpAu = parcelRequire("2hpAu");

var $ca5HP = parcelRequire("ca5HP");

var $gDlNP = parcelRequire("gDlNP");

var $5iY8H = parcelRequire("5iY8H");
function $db063575fe97832e$var$getTrueOffsetParent(element) {
    if (!(0, $2hpAu.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $i8G1V.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $db063575fe97832e$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $5iY8H.default)());
    var isIE = /Trident/i.test((0, $5iY8H.default)());
    if (isIE && (0, $2hpAu.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $i8G1V.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $gDlNP.default)(element);
    if ((0, $2hpAu.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $2hpAu.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $jvY4f.default)(currentNode)) < 0){
        var css = (0, $i8G1V.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $db063575fe97832e$export$2e2bcd8739ae039(element) {
    var window = (0, $doCY5.default)(element);
    var offsetParent = $db063575fe97832e$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $ca5HP.default)(offsetParent) && (0, $i8G1V.default)(offsetParent).position === 'static')offsetParent = $db063575fe97832e$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $jvY4f.default)(offsetParent) === 'html' || (0, $jvY4f.default)(offsetParent) === 'body' && (0, $i8G1V.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $db063575fe97832e$var$getContainingBlock(element) || window;
}

});
parcelRegister("ca5HP", function(module, exports) {
$parcel$export(module.exports, "default", () => $8daad847292b8aac$export$2e2bcd8739ae039);

var $jvY4f = parcelRequire("jvY4f");
function $8daad847292b8aac$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $jvY4f.default)(element)) >= 0;
}

});


parcelRegister("5mkuN", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e6ee7d82ff597d0$export$2e2bcd8739ae039);

var $64Ldz = parcelRequire("64Ldz");
function $3e6ee7d82ff597d0$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $3e6ee7d82ff597d0$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $3e6ee7d82ff597d0$var$order(modifiers); // order based on phase
    return (0, $64Ldz.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("64Ldz", function(module, exports) {
$parcel$export(module.exports, "top", () => $46c7be45655a8f5f$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $46c7be45655a8f5f$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $46c7be45655a8f5f$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $46c7be45655a8f5f$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $46c7be45655a8f5f$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $46c7be45655a8f5f$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $46c7be45655a8f5f$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $46c7be45655a8f5f$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $46c7be45655a8f5f$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $46c7be45655a8f5f$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $46c7be45655a8f5f$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $46c7be45655a8f5f$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $46c7be45655a8f5f$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $46c7be45655a8f5f$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $46c7be45655a8f5f$export$d087d3878fdf71d5);
var $46c7be45655a8f5f$export$1e95b668f3b82d = 'top';
var $46c7be45655a8f5f$export$40e543e69a8b3fbb = 'bottom';
var $46c7be45655a8f5f$export$79ffe56a765070d2 = 'right';
var $46c7be45655a8f5f$export$eabcd2c8791e7bf4 = 'left';
var $46c7be45655a8f5f$export$dfb5619354ba860 = 'auto';
var $46c7be45655a8f5f$export$aec2ce47c367b8c3 = [
    $46c7be45655a8f5f$export$1e95b668f3b82d,
    $46c7be45655a8f5f$export$40e543e69a8b3fbb,
    $46c7be45655a8f5f$export$79ffe56a765070d2,
    $46c7be45655a8f5f$export$eabcd2c8791e7bf4
];
var $46c7be45655a8f5f$export$b3571188c770cc5a = 'start';
var $46c7be45655a8f5f$export$bd5df0f255a350f8 = 'end';
var $46c7be45655a8f5f$export$390fd549c5303b4d = 'clippingParents';
var $46c7be45655a8f5f$export$d7b7311ec04a3e8f = 'viewport';
var $46c7be45655a8f5f$export$ae5ab1c730825774 = 'popper';
var $46c7be45655a8f5f$export$ca50aac9f3ba507f = 'reference';
var $46c7be45655a8f5f$export$368f9a87e87fa4e1 = /*#__PURE__*/ $46c7be45655a8f5f$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $46c7be45655a8f5f$export$b3571188c770cc5a,
        placement + "-" + $46c7be45655a8f5f$export$bd5df0f255a350f8
    ]);
}, []);
var $46c7be45655a8f5f$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($46c7be45655a8f5f$export$aec2ce47c367b8c3, [
    $46c7be45655a8f5f$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $46c7be45655a8f5f$export$b3571188c770cc5a,
        placement + "-" + $46c7be45655a8f5f$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $46c7be45655a8f5f$export$421679a7c3d56e = 'beforeRead';
var $46c7be45655a8f5f$export$aafa59e2e03f2942 = 'read';
var $46c7be45655a8f5f$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $46c7be45655a8f5f$export$c65e99957a05207c = 'beforeMain';
var $46c7be45655a8f5f$export$f22da7240b7add18 = 'main';
var $46c7be45655a8f5f$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $46c7be45655a8f5f$export$8d4d2d70e7d46032 = 'beforeWrite';
var $46c7be45655a8f5f$export$68d8715fc104d294 = 'write';
var $46c7be45655a8f5f$export$70a6e5159acce2e6 = 'afterWrite';
var $46c7be45655a8f5f$export$d087d3878fdf71d5 = [
    $46c7be45655a8f5f$export$421679a7c3d56e,
    $46c7be45655a8f5f$export$aafa59e2e03f2942,
    $46c7be45655a8f5f$export$6964f6c886723980,
    $46c7be45655a8f5f$export$c65e99957a05207c,
    $46c7be45655a8f5f$export$f22da7240b7add18,
    $46c7be45655a8f5f$export$bab79516f2d662fe,
    $46c7be45655a8f5f$export$8d4d2d70e7d46032,
    $46c7be45655a8f5f$export$68d8715fc104d294,
    $46c7be45655a8f5f$export$70a6e5159acce2e6
];

});


parcelRegister("2A8V2", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e15dcaa38be17a6$export$2e2bcd8739ae039);
function $1e15dcaa38be17a6$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("jiP1z", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0d7471d76e17091$export$2e2bcd8739ae039);
function $e0d7471d76e17091$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("e9WH7", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4ef6f740e703a46$export$2e2bcd8739ae039);

var $doCY5 = parcelRequire("doCY5");
var $a4ef6f740e703a46$var$passive = {
    passive: true
};
function $a4ef6f740e703a46$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $doCY5.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $a4ef6f740e703a46$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $a4ef6f740e703a46$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $a4ef6f740e703a46$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $a4ef6f740e703a46$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $a4ef6f740e703a46$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $a4ef6f740e703a46$var$effect,
    data: {}
};

});

parcelRegister("24Spt", function(module, exports) {
$parcel$export(module.exports, "default", () => $1836292b5d30cf7b$export$2e2bcd8739ae039);

var $fCLb8 = parcelRequire("fCLb8");
function $1836292b5d30cf7b$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $fCLb8.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $1836292b5d30cf7b$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $1836292b5d30cf7b$var$popperOffsets,
    data: {}
};

});
parcelRegister("fCLb8", function(module, exports) {
$parcel$export(module.exports, "default", () => $b5ff0052c5c856bd$export$2e2bcd8739ae039);

var $2rLLB = parcelRequire("2rLLB");

var $a9FON = parcelRequire("a9FON");

var $fioDp = parcelRequire("fioDp");

var $64Ldz = parcelRequire("64Ldz");
function $b5ff0052c5c856bd$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $2rLLB.default)(placement) : null;
    var variation = placement ? (0, $a9FON.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $64Ldz.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $64Ldz.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $64Ldz.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $64Ldz.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $fioDp.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $64Ldz.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $64Ldz.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("2rLLB", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c8327d9fc5c77c7$export$2e2bcd8739ae039);

function $1c8327d9fc5c77c7$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("a9FON", function(module, exports) {
$parcel$export(module.exports, "default", () => $764b2ee0c8d095eb$export$2e2bcd8739ae039);
function $764b2ee0c8d095eb$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("fioDp", function(module, exports) {
$parcel$export(module.exports, "default", () => $b22ba560118ade6b$export$2e2bcd8739ae039);
function $b22ba560118ade6b$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("5nwPk", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ea89073c7e77af9$export$2e2bcd8739ae039);

var $64Ldz = parcelRequire("64Ldz");

var $iNRnx = parcelRequire("iNRnx");

var $doCY5 = parcelRequire("doCY5");

var $6WzYt = parcelRequire("6WzYt");

var $i8G1V = parcelRequire("i8G1V");

var $2rLLB = parcelRequire("2rLLB");

var $a9FON = parcelRequire("a9FON");

var $hz7JJ = parcelRequire("hz7JJ");
var $3ea89073c7e77af9$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $3ea89073c7e77af9$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $hz7JJ.round)(x * dpr) / dpr || 0,
        y: (0, $hz7JJ.round)(y * dpr) / dpr || 0
    };
}
function $3ea89073c7e77af9$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $64Ldz.left);
    var sideY = (0, $64Ldz.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $iNRnx.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $doCY5.default)(popper)) {
            offsetParent = (0, $6WzYt.default)(popper);
            if ((0, $i8G1V.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $64Ldz.top) || (placement === (0, $64Ldz.left) || placement === (0, $64Ldz.right)) && variation === (0, $64Ldz.end)) {
            sideY = (0, $64Ldz.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $64Ldz.left) || (placement === (0, $64Ldz.top) || placement === (0, $64Ldz.bottom)) && variation === (0, $64Ldz.end)) {
            sideX = (0, $64Ldz.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $3ea89073c7e77af9$var$unsetSides);
    var _ref4 = roundOffsets === true ? $3ea89073c7e77af9$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $doCY5.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $3ea89073c7e77af9$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $2rLLB.default)(state.placement),
        variation: (0, $a9FON.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $3ea89073c7e77af9$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $3ea89073c7e77af9$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $3ea89073c7e77af9$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $3ea89073c7e77af9$var$computeStyles,
    data: {}
};

});

parcelRegister("fzzWx", function(module, exports) {
$parcel$export(module.exports, "default", () => $b5660173bd05a8fa$export$2e2bcd8739ae039);

var $jvY4f = parcelRequire("jvY4f");

var $2hpAu = parcelRequire("2hpAu");
// and applies them to the HTMLElements such as popper and arrow
function $b5660173bd05a8fa$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $2hpAu.isHTMLElement)(element) || !(0, $jvY4f.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $b5660173bd05a8fa$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $2hpAu.isHTMLElement)(element) || !(0, $jvY4f.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $b5660173bd05a8fa$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $b5660173bd05a8fa$var$applyStyles,
    effect: $b5660173bd05a8fa$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("lOTzW", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe29613fcc9afbcd$export$2e2bcd8739ae039);

var $2rLLB = parcelRequire("2rLLB");

var $64Ldz = parcelRequire("64Ldz");
function $fe29613fcc9afbcd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $2rLLB.default)(placement);
    var invertDistance = [
        (0, $64Ldz.left),
        (0, $64Ldz.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $64Ldz.left),
        (0, $64Ldz.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $fe29613fcc9afbcd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $64Ldz.placements).reduce(function(acc, placement) {
        acc[placement] = $fe29613fcc9afbcd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $fe29613fcc9afbcd$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $fe29613fcc9afbcd$var$offset
};

});

parcelRegister("5Mwp5", function(module, exports) {
$parcel$export(module.exports, "default", () => $435a92212a760417$export$2e2bcd8739ae039);

var $9WPpG = parcelRequire("9WPpG");

var $2rLLB = parcelRequire("2rLLB");

var $gTGqS = parcelRequire("gTGqS");

var $4GxDV = parcelRequire("4GxDV");

var $5JhMb = parcelRequire("5JhMb");

var $64Ldz = parcelRequire("64Ldz");

var $a9FON = parcelRequire("a9FON");
function $435a92212a760417$var$getExpandedFallbackPlacements(placement) {
    if ((0, $2rLLB.default)(placement) === (0, $64Ldz.auto)) return [];
    var oppositePlacement = (0, $9WPpG.default)(placement);
    return [
        (0, $gTGqS.default)(placement),
        oppositePlacement,
        (0, $gTGqS.default)(oppositePlacement)
    ];
}
function $435a92212a760417$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $2rLLB.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $9WPpG.default)(preferredPlacement)
    ] : $435a92212a760417$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $2rLLB.default)(placement) === (0, $64Ldz.auto) ? (0, $5JhMb.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $2rLLB.default)(placement);
        var isStartVariation = (0, $a9FON.default)(placement) === (0, $64Ldz.start);
        var isVertical = [
            (0, $64Ldz.top),
            (0, $64Ldz.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $4GxDV.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $64Ldz.right) : (0, $64Ldz.left) : isStartVariation ? (0, $64Ldz.bottom) : (0, $64Ldz.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $9WPpG.default)(mainVariationSide);
        var altVariationSide = (0, $9WPpG.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $435a92212a760417$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $435a92212a760417$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("9WPpG", function(module, exports) {
$parcel$export(module.exports, "default", () => $73e16973cb998600$export$2e2bcd8739ae039);
var $73e16973cb998600$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $73e16973cb998600$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $73e16973cb998600$var$hash[matched];
    });
}

});

parcelRegister("gTGqS", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4d2b29a3ad32aed$export$2e2bcd8739ae039);
var $c4d2b29a3ad32aed$var$hash = {
    start: 'end',
    end: 'start'
};
function $c4d2b29a3ad32aed$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $c4d2b29a3ad32aed$var$hash[matched];
    });
}

});

parcelRegister("4GxDV", function(module, exports) {
$parcel$export(module.exports, "default", () => $36952e755668732e$export$2e2bcd8739ae039);

var $4bAYC = parcelRequire("4bAYC");

var $6WzYt = parcelRequire("6WzYt");

var $7nPwk = parcelRequire("7nPwk");

var $fCLb8 = parcelRequire("fCLb8");

var $3tvi0 = parcelRequire("3tvi0");

var $64Ldz = parcelRequire("64Ldz");

var $2hpAu = parcelRequire("2hpAu");

var $iQK6k = parcelRequire("iQK6k");

var $laSIN = parcelRequire("laSIN");
function $36952e755668732e$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $64Ldz.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $64Ldz.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $64Ldz.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $iQK6k.default)(typeof padding !== 'number' ? padding : (0, $laSIN.default)(padding, (0, $64Ldz.basePlacements)));
    var altContext = elementContext === (0, $64Ldz.popper) ? (0, $64Ldz.reference) : (0, $64Ldz.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $4bAYC.default)((0, $2hpAu.isElement)(element) ? element : element.contextElement || (0, $6WzYt.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $7nPwk.default)(state.elements.reference);
    var popperOffsets = (0, $fCLb8.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $3tvi0.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $64Ldz.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $64Ldz.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $64Ldz.right),
                (0, $64Ldz.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $64Ldz.top),
                (0, $64Ldz.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("4bAYC", function(module, exports) {
$parcel$export(module.exports, "default", () => $30c4df4ca7985d43$export$2e2bcd8739ae039);

var $64Ldz = parcelRequire("64Ldz");

var $2ayid = parcelRequire("2ayid");

var $gQQJ3 = parcelRequire("gQQJ3");

var $ghpfJ = parcelRequire("ghpfJ");

var $iNRnx = parcelRequire("iNRnx");

var $6WzYt = parcelRequire("6WzYt");

var $i8G1V = parcelRequire("i8G1V");

var $2hpAu = parcelRequire("2hpAu");

var $7nPwk = parcelRequire("7nPwk");

var $gDlNP = parcelRequire("gDlNP");

var $keItH = parcelRequire("keItH");

var $jvY4f = parcelRequire("jvY4f");

var $3tvi0 = parcelRequire("3tvi0");

var $hz7JJ = parcelRequire("hz7JJ");
function $30c4df4ca7985d43$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $7nPwk.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $30c4df4ca7985d43$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $64Ldz.viewport) ? (0, $3tvi0.default)((0, $2ayid.default)(element, strategy)) : (0, $2hpAu.isElement)(clippingParent) ? $30c4df4ca7985d43$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $3tvi0.default)((0, $gQQJ3.default)((0, $6WzYt.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $30c4df4ca7985d43$var$getClippingParents(element) {
    var clippingParents = (0, $ghpfJ.default)((0, $gDlNP.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $i8G1V.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $2hpAu.isHTMLElement)(element) ? (0, $iNRnx.default)(element) : element;
    if (!(0, $2hpAu.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $2hpAu.isElement)(clippingParent) && (0, $keItH.default)(clippingParent, clipperElement) && (0, $jvY4f.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $30c4df4ca7985d43$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $30c4df4ca7985d43$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $30c4df4ca7985d43$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $hz7JJ.max)(rect.top, accRect.top);
        accRect.right = (0, $hz7JJ.min)(rect.right, accRect.right);
        accRect.bottom = (0, $hz7JJ.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $hz7JJ.max)(rect.left, accRect.left);
        return accRect;
    }, $30c4df4ca7985d43$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("2ayid", function(module, exports) {
$parcel$export(module.exports, "default", () => $19471dc6c5f28f7e$export$2e2bcd8739ae039);

var $doCY5 = parcelRequire("doCY5");

var $6WzYt = parcelRequire("6WzYt");

var $cbpGQ = parcelRequire("cbpGQ");

var $iC3kL = parcelRequire("iC3kL");
function $19471dc6c5f28f7e$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $doCY5.default)(element);
    var html = (0, $6WzYt.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $iC3kL.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $cbpGQ.default)(element),
        y: y
    };
}

});

parcelRegister("gQQJ3", function(module, exports) {
$parcel$export(module.exports, "default", () => $c44a66e02c028086$export$2e2bcd8739ae039);

var $6WzYt = parcelRequire("6WzYt");

var $i8G1V = parcelRequire("i8G1V");

var $cbpGQ = parcelRequire("cbpGQ");

var $4s2O3 = parcelRequire("4s2O3");

var $hz7JJ = parcelRequire("hz7JJ");
function $c44a66e02c028086$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $6WzYt.default)(element);
    var winScroll = (0, $4s2O3.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $hz7JJ.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $hz7JJ.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $cbpGQ.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $i8G1V.default)(body || html).direction === 'rtl') x += (0, $hz7JJ.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("keItH", function(module, exports) {
$parcel$export(module.exports, "default", () => $ebb79ddec1ded5e4$export$2e2bcd8739ae039);

var $2hpAu = parcelRequire("2hpAu");
function $ebb79ddec1ded5e4$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $2hpAu.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("3tvi0", function(module, exports) {
$parcel$export(module.exports, "default", () => $287c59eea4b13213$export$2e2bcd8739ae039);
function $287c59eea4b13213$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("iQK6k", function(module, exports) {
$parcel$export(module.exports, "default", () => $db90d8064d1d8488$export$2e2bcd8739ae039);

var $lFzR3 = parcelRequire("lFzR3");
function $db90d8064d1d8488$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $lFzR3.default)(), paddingObject);
}

});
parcelRegister("lFzR3", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc693d4bc443df37$export$2e2bcd8739ae039);
function $fc693d4bc443df37$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("laSIN", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6a4fab7ac4112cb$export$2e2bcd8739ae039);
function $f6a4fab7ac4112cb$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("5JhMb", function(module, exports) {
$parcel$export(module.exports, "default", () => $42bef1b7ef5dcedf$export$2e2bcd8739ae039);

var $a9FON = parcelRequire("a9FON");

var $64Ldz = parcelRequire("64Ldz");

var $4GxDV = parcelRequire("4GxDV");

var $2rLLB = parcelRequire("2rLLB");
function $42bef1b7ef5dcedf$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $64Ldz.placements) : _options$allowedAutoP;
    var variation = (0, $a9FON.default)(placement);
    var placements = variation ? flipVariations ? (0, $64Ldz.variationPlacements) : (0, $64Ldz.variationPlacements).filter(function(placement) {
        return (0, $a9FON.default)(placement) === variation;
    }) : (0, $64Ldz.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $4GxDV.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $2rLLB.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("8l66N", function(module, exports) {
$parcel$export(module.exports, "default", () => $612505ec75c089b7$export$2e2bcd8739ae039);

var $64Ldz = parcelRequire("64Ldz");

var $2rLLB = parcelRequire("2rLLB");

var $fioDp = parcelRequire("fioDp");

var $1Vwrr = parcelRequire("1Vwrr");

var $gcdhV = parcelRequire("gcdhV");

var $2vry6 = parcelRequire("2vry6");

var $iNRnx = parcelRequire("iNRnx");

var $4GxDV = parcelRequire("4GxDV");

var $a9FON = parcelRequire("a9FON");

var $lFzR3 = parcelRequire("lFzR3");

var $hz7JJ = parcelRequire("hz7JJ");
function $612505ec75c089b7$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $4GxDV.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $2rLLB.default)(state.placement);
    var variation = (0, $a9FON.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $fioDp.default)(basePlacement);
    var altAxis = (0, $1Vwrr.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $64Ldz.top) : (0, $64Ldz.left);
        var altSide = mainAxis === 'y' ? (0, $64Ldz.bottom) : (0, $64Ldz.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $64Ldz.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $64Ldz.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $2vry6.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $lFzR3.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $gcdhV.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $iNRnx.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $gcdhV.within)(tether ? (0, $hz7JJ.min)(min, tetherMin) : min, offset, tether ? (0, $hz7JJ.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $64Ldz.top) : (0, $64Ldz.left);
        var _altSide = mainAxis === 'x' ? (0, $64Ldz.bottom) : (0, $64Ldz.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $64Ldz.top),
            (0, $64Ldz.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $gcdhV.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $gcdhV.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $612505ec75c089b7$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $612505ec75c089b7$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("1Vwrr", function(module, exports) {
$parcel$export(module.exports, "default", () => $16744789e57f6fb9$export$2e2bcd8739ae039);
function $16744789e57f6fb9$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("gcdhV", function(module, exports) {
$parcel$export(module.exports, "within", () => $bca813152379c4b0$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $bca813152379c4b0$export$86c8af6d3ef0b4a);

var $hz7JJ = parcelRequire("hz7JJ");
function $bca813152379c4b0$export$f28d906d67a997f3(min, value, max) {
    return (0, $hz7JJ.max)(min, (0, $hz7JJ.min)(value, max));
}
function $bca813152379c4b0$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $bca813152379c4b0$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("g9Uys", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc395b3158bf7039$export$2e2bcd8739ae039);

var $2rLLB = parcelRequire("2rLLB");

var $2vry6 = parcelRequire("2vry6");

var $keItH = parcelRequire("keItH");

var $iNRnx = parcelRequire("iNRnx");

var $fioDp = parcelRequire("fioDp");

var $gcdhV = parcelRequire("gcdhV");

var $iQK6k = parcelRequire("iQK6k");

var $laSIN = parcelRequire("laSIN");

var $64Ldz = parcelRequire("64Ldz");
var $bc395b3158bf7039$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $iQK6k.default)(typeof padding !== 'number' ? padding : (0, $laSIN.default)(padding, (0, $64Ldz.basePlacements)));
};
function $bc395b3158bf7039$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $2rLLB.default)(state.placement);
    var axis = (0, $fioDp.default)(basePlacement);
    var isVertical = [
        (0, $64Ldz.left),
        (0, $64Ldz.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $bc395b3158bf7039$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $2vry6.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $64Ldz.top) : (0, $64Ldz.left);
    var maxProp = axis === 'y' ? (0, $64Ldz.bottom) : (0, $64Ldz.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $iNRnx.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $gcdhV.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $bc395b3158bf7039$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $keItH.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $bc395b3158bf7039$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $bc395b3158bf7039$var$arrow,
    effect: $bc395b3158bf7039$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("gWDw2", function(module, exports) {
$parcel$export(module.exports, "default", () => $c560b721e11362a5$export$2e2bcd8739ae039);

var $64Ldz = parcelRequire("64Ldz");

var $4GxDV = parcelRequire("4GxDV");
function $c560b721e11362a5$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $c560b721e11362a5$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $64Ldz.top),
        (0, $64Ldz.right),
        (0, $64Ldz.bottom),
        (0, $64Ldz.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $c560b721e11362a5$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $4GxDV.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $4GxDV.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $c560b721e11362a5$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $c560b721e11362a5$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $c560b721e11362a5$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $c560b721e11362a5$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $c560b721e11362a5$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $c560b721e11362a5$var$hide
};

});


parcelRegister("dgwv0", function(module, exports) {
$parcel$export(module.exports, "default", () => $e83afceb593d6d10$export$2e2bcd8739ae039);
/* pressable.tsx generated by @compiled/babel-plugin v0.36.1 */ /* pressable.tsx generated by @compiled/babel-plugin v0.36.1 */ /* pressable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $3yCbE = parcelRequire("3yCbE");

var $wYkfM = parcelRequire("wYkfM");

var $dR90c = parcelRequire("dR90c");

var $ccErM = parcelRequire("ccErM");

var $cDSkE = parcelRequire("cDSkE");

var $kd9VV = parcelRequire("kd9VV");
const $e83afceb593d6d10$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ const $e83afceb593d6d10$var$Pressable = /*#__PURE__*/ (0, $4tluv.forwardRef)(({ children: children, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $ccErM.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, tabIndex: tabIndex, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $4tluv.useContext)((0, $cDSkE.default));
    const handleClick = (0, $4tluv.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $wYkfM.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $kd9VV.default), {
        // @ts-ignore -- not using expect since it causes issues with help-center local consumption - we don't allow `button` on Focusable for makers as they should use Pressable instead
        as: "button",
        // Safari does not apply focus to buttons on click like other browsers, which means click events will not be fired.
        // Adding a tabIndex of 0 to the button will allow it to be focused on click.
        // This is a known issue in Safari that is meant to be "intended", see https://bugs.webkit.org/show_bug.cgi?id=22261
        tabIndex: tabIndex ?? ((0, $dR90c.isSafari)() && !isDisabled ? 0 : undefined),
        style: style,
        ...safeHtmlAttributes,
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $3yCbE.cx)($e83afceb593d6d10$var$styles.root, isDisabled && $e83afceb593d6d10$var$styles.disabled, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
});
var $e83afceb593d6d10$export$2e2bcd8739ae039 = $e83afceb593d6d10$var$Pressable;

});
parcelRegister("dR90c", function(module, exports) {
$parcel$export(module.exports, "isSafari", () => $1252e3c42cbb1ea3$export$95df08bae54cb4df);
function $1252e3c42cbb1ea3$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        const ua = window.navigator.userAgent?.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}

});

parcelRegister("kd9VV", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa3c122c30decf5a$export$2e2bcd8739ae039);
/* focusable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");
const $fa3c122c30decf5a$var$focusRingStyles = null;
const $fa3c122c30decf5a$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ const $fa3c122c30decf5a$var$Focusable = /*#__PURE__*/ (0, $4tluv.forwardRef)(({ as: Component = 'button', children: children, isInset: isInset, testId: testId, style: style, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ (0, $2iln5.jsx)(Component, {
        ...safeHtmlAttributes,
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $jAkMr.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId,
        children: children
    });
});
var $fa3c122c30decf5a$export$2e2bcd8739ae039 = $fa3c122c30decf5a$var$Focusable;

});


parcelRegister("kbKpL", function(module, exports) {
$parcel$export(module.exports, "Box", () => $15f6dcf343327546$export$e71c4d32a2263218);
$parcel$export(module.exports, "default", () => $15f6dcf343327546$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4tluv = parcelRequire("4tluv");

var $ft5N0 = parcelRequire("ft5N0");

var $ADvdq = parcelRequire("ADvdq");

var $dpQkd = parcelRequire("dpQkd");

var $kfPot = parcelRequire("kfPot");
const $15f6dcf343327546$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $4tluv.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $kfPot.parseXcss)(xcss);
    const node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    /*#__PURE__*/ (0, $ft5N0.jsx)(Component, {
        style: style,
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        css: [
            $15f6dcf343327546$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $dpQkd.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $dpQkd.isSurfaceColorToken)(backgroundColor) && (0, $dpQkd.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $dpQkd.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $dpQkd.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $dpQkd.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $dpQkd.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $dpQkd.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $dpQkd.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $dpQkd.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }, children);
    return backgroundColor ? /*#__PURE__*/ (0, $ft5N0.jsx)((0, $ADvdq.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $15f6dcf343327546$export$2e2bcd8739ae039 = $15f6dcf343327546$export$e71c4d32a2263218;
const $15f6dcf343327546$var$baseStyles = (0, $ft5N0.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});

});
parcelRegister("kfPot", function(module, exports) {
$parcel$export(module.exports, "parseXcss", () => $b47242ccb19f27b2$export$a9c84988c8f81f2d);
$parcel$export(module.exports, "xcss", () => $b47242ccb19f27b2$export$f6c783d06584602c);
/* xcss.tsx generated by @compiled/babel-plugin v0.36.1 */ /* xcss.tsx generated by @compiled/babel-plugin v0.36.1 */ /* xcss.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
parcelRequire("4tluv");

var $ft5N0 = parcelRequire("ft5N0");

var $dpQkd = parcelRequire("dpQkd");

var $hcSxw = parcelRequire("hcSxw");
const $b47242ccb19f27b2$export$9a199fbafee0014e = {
    backgroundColor: (0, $dpQkd.backgroundColorMap),
    blockSize: (0, $dpQkd.dimensionMap),
    borderBlockColor: (0, $dpQkd.borderColorMap),
    borderBlockEndColor: (0, $dpQkd.borderColorMap),
    borderBlockEndWidth: (0, $dpQkd.borderWidthMap),
    borderBlockStartColor: (0, $dpQkd.borderColorMap),
    borderBlockStartWidth: (0, $dpQkd.borderWidthMap),
    borderBlockWidth: (0, $dpQkd.borderWidthMap),
    borderBottomColor: (0, $dpQkd.borderColorMap),
    borderBottomLeftRadius: (0, $dpQkd.borderRadiusMap),
    borderBottomRightRadius: (0, $dpQkd.borderRadiusMap),
    borderBottomWidth: (0, $dpQkd.borderWidthMap),
    borderColor: (0, $dpQkd.borderColorMap),
    borderEndEndRadius: (0, $dpQkd.borderRadiusMap),
    borderEndStartRadius: (0, $dpQkd.borderRadiusMap),
    borderInlineColor: (0, $dpQkd.borderColorMap),
    borderInlineEndColor: (0, $dpQkd.borderColorMap),
    borderInlineEndWidth: (0, $dpQkd.borderWidthMap),
    borderInlineStartColor: (0, $dpQkd.borderColorMap),
    borderInlineStartWidth: (0, $dpQkd.borderWidthMap),
    borderInlineWidth: (0, $dpQkd.borderWidthMap),
    borderLeftColor: (0, $dpQkd.borderColorMap),
    borderLeftWidth: (0, $dpQkd.borderWidthMap),
    borderRadius: (0, $dpQkd.borderRadiusMap),
    borderRightColor: (0, $dpQkd.borderColorMap),
    borderRightWidth: (0, $dpQkd.borderWidthMap),
    borderStartEndRadius: (0, $dpQkd.borderRadiusMap),
    borderStartStartRadius: (0, $dpQkd.borderRadiusMap),
    borderTopColor: (0, $dpQkd.borderColorMap),
    borderTopLeftRadius: (0, $dpQkd.borderRadiusMap),
    borderTopRightRadius: (0, $dpQkd.borderRadiusMap),
    borderTopWidth: (0, $dpQkd.borderWidthMap),
    borderWidth: (0, $dpQkd.borderWidthMap),
    bottom: (0, $dpQkd.allSpaceMap),
    boxShadow: (0, $dpQkd.shadowMap),
    color: (0, $dpQkd.textColorMap),
    columnGap: (0, $dpQkd.positiveSpaceMap),
    font: (0, $dpQkd.fontMap),
    fontFamily: (0, $dpQkd.fontFamilyMap),
    fontWeight: (0, $dpQkd.fontWeightMap),
    gap: (0, $dpQkd.positiveSpaceMap),
    height: (0, $dpQkd.dimensionMap),
    inlineSize: (0, $dpQkd.dimensionMap),
    inset: (0, $dpQkd.allSpaceMap),
    insetBlock: (0, $dpQkd.allSpaceMap),
    insetBlockEnd: (0, $dpQkd.allSpaceMap),
    insetBlockStart: (0, $dpQkd.allSpaceMap),
    insetInline: (0, $dpQkd.allSpaceMap),
    insetInlineEnd: (0, $dpQkd.allSpaceMap),
    insetInlineStart: (0, $dpQkd.allSpaceMap),
    left: (0, $dpQkd.allSpaceMap),
    margin: (0, $dpQkd.allSpaceMap),
    marginBlock: (0, $dpQkd.allSpaceMap),
    marginBlockEnd: (0, $dpQkd.allSpaceMap),
    marginBlockStart: (0, $dpQkd.allSpaceMap),
    marginBottom: (0, $dpQkd.allSpaceMap),
    marginInline: (0, $dpQkd.allSpaceMap),
    marginInlineEnd: (0, $dpQkd.allSpaceMap),
    marginInlineStart: (0, $dpQkd.allSpaceMap),
    marginLeft: (0, $dpQkd.allSpaceMap),
    marginRight: (0, $dpQkd.allSpaceMap),
    marginTop: (0, $dpQkd.allSpaceMap),
    maxBlockSize: (0, $dpQkd.dimensionMap),
    maxHeight: (0, $dpQkd.dimensionMap),
    maxInlineSize: (0, $dpQkd.dimensionMap),
    maxWidth: (0, $dpQkd.dimensionMap),
    minBlockSize: (0, $dpQkd.dimensionMap),
    minHeight: (0, $dpQkd.dimensionMap),
    minInlineSize: (0, $dpQkd.dimensionMap),
    minWidth: (0, $dpQkd.dimensionMap),
    opacity: (0, $dpQkd.opacityMap),
    outlineColor: (0, $dpQkd.borderColorMap),
    outlineOffset: (0, $dpQkd.allSpaceMap),
    outlineWidth: (0, $dpQkd.borderWidthMap),
    padding: (0, $dpQkd.positiveSpaceMap),
    paddingBlock: (0, $dpQkd.positiveSpaceMap),
    paddingBlockEnd: (0, $dpQkd.positiveSpaceMap),
    paddingBlockStart: (0, $dpQkd.positiveSpaceMap),
    paddingBottom: (0, $dpQkd.positiveSpaceMap),
    paddingInline: (0, $dpQkd.positiveSpaceMap),
    paddingInlineEnd: (0, $dpQkd.positiveSpaceMap),
    paddingInlineStart: (0, $dpQkd.positiveSpaceMap),
    paddingLeft: (0, $dpQkd.positiveSpaceMap),
    paddingRight: (0, $dpQkd.positiveSpaceMap),
    paddingTop: (0, $dpQkd.positiveSpaceMap),
    right: (0, $dpQkd.allSpaceMap),
    rowGap: (0, $dpQkd.positiveSpaceMap),
    top: (0, $dpQkd.allSpaceMap),
    width: (0, $dpQkd.dimensionMap),
    zIndex: (0, $dpQkd.layerMap)
};
const $b47242ccb19f27b2$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
const $b47242ccb19f27b2$var$isSafeEnvToThrow = ()=>typeof $hcSxw === 'object' && typeof $hcSxw.env === 'object' && false;
const $b47242ccb19f27b2$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
const $b47242ccb19f27b2$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
const $b47242ccb19f27b2$var$transformStyles = (styleObj)=>{
    if (!styleObj || typeof styleObj !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($b47242ccb19f27b2$var$transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(([key, value])=>{
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if (typeof value === 'object' && $b47242ccb19f27b2$var$safeSelectors.test(key)) {
            styleObj[key] = $b47242ccb19f27b2$var$transformStyles(value);
            return;
        }
        if ($b47242ccb19f27b2$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($b47242ccb19f27b2$var$reNestedSelectors.test(key)) throw new Error(`Styles not supported for key '${key}'.`);
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $b47242ccb19f27b2$export$9a199fbafee0014e)) return;
        const tokenValue = $b47242ccb19f27b2$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue ?? value;
    });
    return styleObj;
};
const $b47242ccb19f27b2$var$baseXcss = (style)=>{
    const transformedStyles = $b47242ccb19f27b2$var$transformStyles(style);
    return {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [$b47242ccb19f27b2$var$uniqueSymbol]: (0, $ft5N0.css)(transformedStyles)
    };
};
const $b47242ccb19f27b2$export$a9c84988c8f81f2d = (args)=>{
    if (Array.isArray(args)) {
        const emotion = [];
        const staticArr = [];
        for (const arg of args){
            const result = $b47242ccb19f27b2$export$a9c84988c8f81f2d(arg);
            if (result.emotion) emotion.push(...result.emotion);
            if (result.static) staticArr.push(result.static);
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    const objArgs = args;
    const { [$b47242ccb19f27b2$var$uniqueSymbol]: styles } = objArgs || {};
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        const stringifiedArgs = `${args}`;
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $b47242ccb19f27b2$export$f6c783d06584602c(style) {
    return $b47242ccb19f27b2$var$baseXcss(style);
}

});


parcelRegister("9KBmj", function(module, exports) {
$parcel$export(module.exports, "default", () => $766b28e16412af10$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");

var $jUD3q = parcelRequire("jUD3q");

var $1r8Gx = parcelRequire("1r8Gx");
const $766b28e16412af10$var$baseImageStyles = null;
function $766b28e16412af10$export$2e2bcd8739ae039({ src: src, srcDark: srcDark, alt: alt, testId: testId, className: className, ...props }) {
    const imgRef = (0, $4tluv.useRef)(null);
    const providedColorMode = (0, $jUD3q.UNSAFE_useColorModeForMigration)();
    const { colorMode: observedColorMode } = (0, $1r8Gx.default)();
    const colorMode = providedColorMode || observedColorMode;
    (0, $4tluv.useEffect)(()=>{
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $2iln5.jsx)("img", {
        alt: alt,
        "data-testid": testId,
        src: src,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $jAkMr.default)([
            "_p12f1osq _4t3i1wug",
            className
        ]),
        ref: imgRef,
        ...props
    });
}

});
parcelRegister("jUD3q", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useColorModeForMigration", () => $4e147da52a3c3204$export$ce91654eb9fea460);

var $4tluv = parcelRequire("4tluv");

var $gqObd = parcelRequire("gqObd");
function $4e147da52a3c3204$export$ce91654eb9fea460() {
    const value = (0, $4tluv.useContext)((0, $gqObd.ColorModeContext));
    return value;
}

});


parcelRegister("2X3dI", function(module, exports) {
$parcel$export(module.exports, "default", () => $a6fc70c5373ec21c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4tluv = parcelRequire("4tluv");

var $ft5N0 = parcelRequire("ft5N0");

var $kEkKo = parcelRequire("kEkKo");

var $wYkfM = parcelRequire("wYkfM");

var $k1Lza = parcelRequire("k1Lza");

var $ccErM = parcelRequire("ccErM");

var $fEY94 = parcelRequire("fEY94");

var $cDSkE = parcelRequire("cDSkE");

var $k7gbB = parcelRequire("k7gbB");

var $dpQkd = parcelRequire("dpQkd");

var $kfPot = parcelRequire("kfPot");
// TODO: duplicates FocusRing styles from `@atlaskit/focus-ring`.
const $a6fc70c5373ec21c$var$focusRingStyles = (0, $ft5N0.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $dpQkd.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $dpQkd.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $dpQkd.borderWidthMap)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: `${(0, $dpQkd.borderWidthMap)['border.width']} solid`
        }
    }
});
const $a6fc70c5373ec21c$var$baseStyles = (0, $ft5N0.css)({
    boxSizing: 'border-box',
    textDecoration: 'underline'
});
const $a6fc70c5373ec21c$var$positionStyles = (0, $ft5N0.css)({
    position: 'relative'
});
const $a6fc70c5373ec21c$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $a6fc70c5373ec21c$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
// Comma is added here to add a slight pause between announcing the anchor label and "opens in new window"
const $a6fc70c5373ec21c$var$OPENS_NEW_WINDOW_LABEL = '(opens new window)';
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $a6fc70c5373ec21c$var$AnchorNoRef = ({ href: href, children: children, backgroundColor: backgroundColor, newWindowLabel: newWindowLabel, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, onClick: providedOnClick = (0, $ccErM.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $4tluv.useContext)((0, $cDSkE.default));
    const handleClick = (0, $4tluv.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, $fEY94.useId)();
    const onClick = (0, $wYkfM.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $kfPot.parseXcss)(xcss);
    const RouterLink = (0, $k1Lza.default)();
    const isExternal = typeof href === 'string' && $a6fc70c5373ec21c$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $a6fc70c5373ec21c$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $kEkKo.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $ft5N0.jsx)(Component, {
        style: style,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        // @ts-expect-error
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? //`${ariaLabel} ${OPENS_NEW_WINDOW_LABEL}`
        `${ariaLabel} , ${newWindowLabel ? newWindowLabel : $a6fc70c5373ec21c$var$OPENS_NEW_WINDOW_LABEL}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        css: [
            $a6fc70c5373ec21c$var$baseStyles,
            $a6fc70c5373ec21c$var$positionStyles,
            $a6fc70c5373ec21c$var$focusRingStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $dpQkd.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $dpQkd.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $dpQkd.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $dpQkd.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $dpQkd.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $dpQkd.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $dpQkd.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $dpQkd.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }, children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $ft5N0.jsx)((0, $k7gbB.default), {
        id: opensNewWindowLabelId
    }, `, ${newWindowLabel ? newWindowLabel : $a6fc70c5373ec21c$var$OPENS_NEW_WINDOW_LABEL}`));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $a6fc70c5373ec21c$var$Anchor = /*#__PURE__*/ (0, $4tluv.forwardRef)($a6fc70c5373ec21c$var$AnchorNoRef);
var $a6fc70c5373ec21c$export$2e2bcd8739ae039 = $a6fc70c5373ec21c$var$Anchor;

});
parcelRegister("k1Lza", function(module, exports) {
$parcel$export(module.exports, "default", () => $70ed7a76ebba90be$export$2e2bcd8739ae039);

var $4tluv = parcelRequire("4tluv");

var $lo95G = parcelRequire("lo95G");
/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $70ed7a76ebba90be$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $4tluv.useContext)((0, $lo95G.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $70ed7a76ebba90be$export$2e2bcd8739ae039 = $70ed7a76ebba90be$var$useRouterLink;

});
parcelRegister("lo95G", function(module, exports) {
$parcel$export(module.exports, "RouterLinkProviderContext", () => $403c74e44903127e$export$2931e0ee690eee88);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");
const $403c74e44903127e$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $4tluv.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $403c74e44903127e$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $2iln5.jsx)($403c74e44903127e$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var $403c74e44903127e$export$2e2bcd8739ae039 = $403c74e44903127e$var$RouterLinkProvider;

});



parcelRegister("apJa9", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserver", () => $5dfa68638bcf7ae1$export$97afddda23bcd287);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $kEkKo = parcelRequire("kEkKo");

var $8S8Kg = parcelRequire("8S8Kg");
/**
 * Layers that are registered without a namespace are grouped under this fallback namespace.
 */ const $5dfa68638bcf7ae1$var$noNamespaceSymbol = Symbol('no-namespace');
/**
 * Returns the number of open layers across all namespaces.
 * It calculates the sum of the set sizes in the map, which corresponds to the number of open layers.
 */ function $5dfa68638bcf7ae1$var$getTotalOpenLayerCount(registry) {
    return Array.from(registry.values()).reduce((acc, listeners)=>acc + listeners.size, 0);
}
/**
 * Returns the number of layers in the set that match the type filter.
 */ function $5dfa68638bcf7ae1$var$getLayerCountWithFilter({ layers: layers, type: type }) {
    return Array.from(layers.values()).filter((layer)=>layer.type === type).length;
}
/**
 * Returns the layer count change listeners set for the namespace.
 * If there are no listeners registered for the namespace yet, it creates a new set
 * and adds it to the registry, then returns the new set.
 */ function $5dfa68638bcf7ae1$var$getListeners({ registry: registry, namespace: namespace }) {
    // 1. If there are existing listeners for this namespace, return the existing set.
    const existingListeners = registry.get(namespace);
    if (existingListeners) return existingListeners;
    // 2. If there are no existing listeners for this namespace, create a new set for this namespace
    // and add it to the registry, then return the new set.
    const newSet = new Set();
    registry.set(namespace, newSet);
    return newSet;
}
/**
 * Returns an instance of the open layer observer API. It internally keeps track of the number of open layers and
 * exposes methods to get the current count, increment/decrement the count, and subscribe to changes.
 */ function $5dfa68638bcf7ae1$var$createInternalAPI() {
    /**
   * The layer count change listeners for each namespace.
   */ const namespaceToChangeListenerRegistry = new Map();
    /**
   * The registered layers for each namespace.
   * Each layer registers with an `onClose` callback, and optionally with a layer type (`type`).
   * **When the layer is open**, its `onClose`
   * callback is registered in this set along with its type.
   *
   * This data structure is also used determine the number of open layers.
   */ const namespaceToLayerRegistry = new Map();
    /**
   * Calls the appropriate layer count change listeners after the number of open layers has changed.
   */ function callChangeListeners({ namespace: namespace, newCount: newCount }) {
        // 1. Call listeners registered to the specific namespace
        if (namespace) {
            const listenersForNamespace = namespaceToChangeListenerRegistry.get(namespace);
            // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
            // iterating over it.
            Array.from(listenersForNamespace ?? []).forEach((listener)=>listener({
                    count: newCount
                }));
        }
        // 2. Call listeners registered without a specific namespace
        const noNamespaceListeners = namespaceToChangeListenerRegistry.get($5dfa68638bcf7ae1$var$noNamespaceSymbol);
        // Return early if no listeners
        if (!noNamespaceListeners) return;
        // For the listeners without a specific namespace, we need to provide the sum of all namespace counts
        // as the callback `count` arg.
        const totalCount = $5dfa68638bcf7ae1$var$getTotalOpenLayerCount(namespaceToLayerRegistry);
        Array.from(noNamespaceListeners).forEach((listener)=>listener({
                count: totalCount
            }));
    }
    /**
   * Returns the current count of open layers.
   *
   * - If a namespace is provided, the count for that namespace is returned.
   * - If a type is provided, only layers of that type are counted.
   * - If both are provided, only layers matching both criteria are counted.
   * - Otherwise, the sum of all namespace counts is returned.
   */ function getCount({ namespace: namespace, type: type } = {}) {
        if (namespace) {
            // 1. A namespace was requested, so we count only layers in that namespace
            const layersForNamespace = namespaceToLayerRegistry.get(namespace);
            if (!layersForNamespace) return 0;
            if (type) // Count layers in the namespace that match the type filter
            return $5dfa68638bcf7ae1$var$getLayerCountWithFilter({
                layers: layersForNamespace,
                type: type
            });
            // No type filter - just return the size of the set
            return layersForNamespace.size;
        }
        // 2. A specific namespace was not requested, so we count across all namespaces
        if (type) // Count layers in each namespace that match the type filter
        return Array.from(namespaceToLayerRegistry.values()).reduce((acc, layers)=>acc + $5dfa68638bcf7ae1$var$getLayerCountWithFilter({
                layers: layers,
                type: type
            }), 0);
        // No type filter - count all layers across all namespaces
        return $5dfa68638bcf7ae1$var$getTotalOpenLayerCount(namespaceToLayerRegistry);
    }
    /**
   * Adds a listener that will be called when the number of open layers changes.
   *
   * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
   */ function onChange(listener, { namespace: providedNamespace } = {}) {
        /**
     * We are wrapping the passed listener in a function to ensure that each call to `onChange` creates a unique
     * function reference. This is to handle scenarios where the same function is provided to several different `onChange`
     * calls - we want to ensure that each call to `unsubscribe` only removes the specific listener registration that was added.
     */ function wrapped(...args) {
            listener(...args);
        }
        const namespace = providedNamespace ?? $5dfa68638bcf7ae1$var$noNamespaceSymbol;
        const listenersForNamespace = $5dfa68638bcf7ae1$var$getListeners({
            namespace: namespace,
            registry: namespaceToChangeListenerRegistry
        });
        listenersForNamespace.add(wrapped);
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToChangeListenerRegistry.delete(namespace);
        };
    }
    /**
   * Adds a listener to the registry that tells the observer how to close the layer component.
   * The listener should only be added if the layer is open. This is handled by `useNotifyOpenLayerObserver`.
   *
   * All close listeners will be called by the observer when `closeLayers` is called.
   *
   * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
   */ function onClose(listener, { namespace: providedNamespace, type: type }) {
        const wrapped = {
            listener: listener,
            type: type
        };
        const namespace = providedNamespace ?? $5dfa68638bcf7ae1$var$noNamespaceSymbol;
        const listenersForNamespace = $5dfa68638bcf7ae1$var$getListeners({
            namespace: namespace,
            registry: namespaceToLayerRegistry
        });
        listenersForNamespace.add(wrapped);
        callChangeListeners({
            namespace: providedNamespace,
            newCount: listenersForNamespace.size
        });
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            callChangeListeners({
                namespace: providedNamespace,
                newCount: listenersForNamespace.size
            });
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToLayerRegistry.delete(namespace);
        };
    }
    /**
   * Closes all open layers registered across all namespaces.
   */ function closeLayers() {
        // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
        // iterating over it.
        Array.from(namespaceToLayerRegistry.values()).forEach((listeners)=>{
            Array.from(listeners).forEach(({ listener: listener })=>listener());
        });
    }
    const internalAPI = {
        getCount: getCount,
        onChange: onChange,
        onClose: onClose,
        closeLayers: closeLayers
    };
    return internalAPI;
}
function $5dfa68638bcf7ae1$export$97afddda23bcd287({ children: children }) {
    // Using state to ensure a stable reference to a single instance.
    const [internalAPI] = (0, $4tluv.useState)(()=>$5dfa68638bcf7ae1$var$createInternalAPI());
    const parentContext = (0, $4tluv.useContext)((0, $8S8Kg.OpenLayerObserverContext));
    // We don't expect a parent context. If there is one, that means this component is nested within another `OpenLayerObserver`
    // - which we don't support.
    (0, $kEkKo.default)(parentContext === null, '`OpenLayerObserver` cannot be nested within another `OpenLayerObserver`.');
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $8S8Kg.OpenLayerObserverContext).Provider, {
        value: internalAPI,
        children: children
    });
}

});

parcelRegister("cYEgx", function(module, exports) {
$parcel$export(module.exports, "default", () => $72009f4eb2043b68$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4tluv = parcelRequire("4tluv");

var $ft5N0 = parcelRequire("ft5N0");

var $kEkKo = parcelRequire("kEkKo");

var $74oxG = parcelRequire("74oxG");

var $71w0l = parcelRequire("71w0l");

var $dpQkd = parcelRequire("dpQkd");
const $72009f4eb2043b68$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
const $72009f4eb2043b68$var$resetStyles = (0, $ft5N0.css)({
    margin: 0,
    overflowWrap: 'anywhere'
});
const $72009f4eb2043b68$var$strongStyles = (0, $ft5N0.css)({
    fontWeight: "var(--ds-font-weight-bold, 653)"
});
const $72009f4eb2043b68$var$emStyles = (0, $ft5N0.css)({
    fontStyle: 'italic'
});
const $72009f4eb2043b68$var$textAlignMap = {
    center: (0, $ft5N0.css)({
        textAlign: 'center'
    }),
    end: (0, $ft5N0.css)({
        textAlign: 'end'
    }),
    start: (0, $ft5N0.css)({
        textAlign: 'start'
    })
};
const $72009f4eb2043b68$var$truncationStyles = (0, $ft5N0.css)({
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical'
});
const $72009f4eb2043b68$var$wordBreakMap = {
    breakAll: (0, $ft5N0.css)({
        wordBreak: 'break-all'
    })
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ const $72009f4eb2043b68$var$useColor = (colorProp, hasTextAncestor)=>{
    const surface = (0, $71w0l.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ((0, $dpQkd.inverseColorMap).hasOwnProperty(surface)) return (0, $dpQkd.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ const $72009f4eb2043b68$var$Text = /*#__PURE__*/ (0, $4tluv.forwardRef)(({ as: Component = 'span', color: colorProp, align: align, testId: testId, id: id, size: size, weight: weight, maxLines: maxLines, children: children }, ref)=>{
    (0, $kEkKo.default)($72009f4eb2043b68$var$asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = (0, $74oxG.useHasTextAncestor)();
    const color = $72009f4eb2043b68$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    const component = /*#__PURE__*/ (0, $ft5N0.jsx)(Component, {
        ref: ref,
        css: [
            $72009f4eb2043b68$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, $dpQkd.textSizeStylesMap)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $dpQkd.textColorStylesMap)[color],
            maxLines && $72009f4eb2043b68$var$truncationStyles,
            maxLines === 1 && $72009f4eb2043b68$var$wordBreakMap.breakAll,
            align && $72009f4eb2043b68$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $dpQkd.textWeightStylesMap)[weight],
            Component === 'em' && $72009f4eb2043b68$var$emStyles,
            Component === 'strong' && $72009f4eb2043b68$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : /*#__PURE__*/ (0, $ft5N0.jsx)((0, $74oxG.HasTextAncestorProvider), {
        value: true
    }, component);
});
var $72009f4eb2043b68$export$2e2bcd8739ae039 = $72009f4eb2043b68$var$Text;

});
parcelRegister("74oxG", function(module, exports) {
$parcel$export(module.exports, "useHasTextAncestor", () => $cdf1f48f17535ecf$export$9322276ec105d055);
$parcel$export(module.exports, "HasTextAncestorProvider", () => $cdf1f48f17535ecf$export$ae933c6cbe5643ad);

var $4tluv = parcelRequire("4tluv");
const $cdf1f48f17535ecf$var$HasTextAncestorContext = /*#__PURE__*/ (0, $4tluv.createContext)(false);
const $cdf1f48f17535ecf$export$9322276ec105d055 = ()=>(0, $4tluv.useContext)($cdf1f48f17535ecf$var$HasTextAncestorContext);
const $cdf1f48f17535ecf$export$ae933c6cbe5643ad = $cdf1f48f17535ecf$var$HasTextAncestorContext.Provider;

});


parcelRegister("eb3Wn", function(module, exports) {
$parcel$export(module.exports, "default", () => $2dd40788aa567a11$export$2e2bcd8739ae039);
/* anchor.tsx generated by @compiled/babel-plugin v0.36.1 */ /* anchor.tsx generated by @compiled/babel-plugin v0.36.1 */ /* anchor.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $3yCbE = parcelRequire("3yCbE");

var $kEkKo = parcelRequire("kEkKo");

var $wYkfM = parcelRequire("wYkfM");

var $k1Lza = parcelRequire("k1Lza");

var $ccErM = parcelRequire("ccErM");

var $fEY94 = parcelRequire("fEY94");

var $cDSkE = parcelRequire("cDSkE");

var $k7gbB = parcelRequire("k7gbB");

var $kd9VV = parcelRequire("kd9VV");
const $2dd40788aa567a11$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi",
    position: "_kqswh2mm"
};
const $2dd40788aa567a11$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $2dd40788aa567a11$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $2dd40788aa567a11$var$AnchorNoRef = ({ href: href, children: children, onClick: providedOnClick = (0, $ccErM.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, newWindowLabel: newWindowLabel = '(opens new window)', ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $4tluv.useContext)((0, $cDSkE.default));
    const handleClick = (0, $4tluv.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, $fEY94.useId)();
    const onClick = (0, $wYkfM.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const RouterLink = (0, $k1Lza.default)();
    const isExternal = typeof href === 'string' && $2dd40788aa567a11$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $2dd40788aa567a11$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $kEkKo.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $2iln5.jsxs)((0, $kd9VV.default), {
        // @ts-expect-error we don't allow `a` on Focusable for makers as they should use Anchor instead
        as: Component,
        className: xcss,
        style: style,
        ref: ref,
        ...safeHtmlAttributes,
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? `${ariaLabel} , ${newWindowLabel}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        xcss: (0, $3yCbE.cx)($2dd40788aa567a11$var$styles.root, $2dd40788aa567a11$var$styles.position, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
        children: [
            children,
            target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $2iln5.jsx)((0, $k7gbB.default), {
                id: opensNewWindowLabelId,
                children: `, ${newWindowLabel}`
            })
        ]
    });
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $2dd40788aa567a11$var$Anchor = /*#__PURE__*/ (0, $4tluv.forwardRef)($2dd40788aa567a11$var$AnchorNoRef);
var $2dd40788aa567a11$export$2e2bcd8739ae039 = $2dd40788aa567a11$var$Anchor;

});

parcelRegister("1K815", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $72f93f7942f9bbfa$export$e5c5a5f917a5871c);

var $4tluv = parcelRequire("4tluv");
const $72f93f7942f9bbfa$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $4tluv.useEffect) : (0, $4tluv.useLayoutEffect);

});

parcelRegister("cJTli", function(module, exports) {
$parcel$export(module.exports, "default", () => $5300283c4979e055$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Popup", () => (parcelRequire("bvVEW")).Popup);

var $bvVEW = parcelRequire("bvVEW");
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5300283c4979e055$export$2e2bcd8739ae039 = (0, $bvVEW.Popup);

});
parcelRegister("bvVEW", function(module, exports) {
$parcel$export(module.exports, "Popup", () => $76a9ec41e2634f9b$export$129a32eedafa97c5);
/* popup.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $fEY94 = parcelRequire("fEY94");

var $dnJ1f = parcelRequire("dnJ1f");

var $3LZFN = parcelRequire("3LZFN");

var $1F7MK = parcelRequire("1F7MK");

var $3X3Vo = parcelRequire("3X3Vo");

var $2F9FU = parcelRequire("2F9FU");
var $cAIZq = parcelRequire("cAIZq");

var $gkJgm = parcelRequire("gkJgm");

var $fYX4U = parcelRequire("fYX4U");

var $1KEXw = parcelRequire("1KEXw");

var $fnITI = parcelRequire("fnITI");

var $1hPz8 = parcelRequire("1hPz8");

var $2efw1 = parcelRequire("2efw1");
const $76a9ec41e2634f9b$var$defaultLayer = 400;
const $76a9ec41e2634f9b$var$wrapperStyles = {
    root: "_kqswh2mm"
};
const $76a9ec41e2634f9b$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $4tluv.memo)(({ xcss: xcss, appearance: inAppearance = 'default', isOpen: isOpen, id: providedId, offset: offset, testId: testId, trigger: trigger, content: content, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary = 'viewport', shouldFlip: shouldFlip = true, placement: placement = 'auto', fallbackPlacements: fallbackPlacements, popupComponent: PopupContainer, autoFocus: autoFocus = true, zIndex: zIndex = $76a9ec41e2634f9b$var$defaultLayer, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick = false, shouldRenderToParent: inShouldRenderToParent = false, shouldFitContainer: shouldFitContainer = false, shouldDisableFocusLock: shouldDisableFocusLock = false, shouldReturnFocus: shouldReturnFocus = true, strategy: strategy, role: role, label: label, titleId: titleId, modifiers: modifiers, shouldFitViewport: shouldFitViewport })=>{
    const [triggerRef, setTriggerRef] = (0, $4tluv.useState)(null);
    const getMergedTriggerRef = (0, $1hPz8.useGetMemoizedMergedTriggerRef)();
    const getMergedTriggerRefNew = (0, $2efw1.useGetMemoizedMergedTriggerRefNew)();
    const generatedId = (0, $fEY94.useId)();
    const { appearance: appearance, shouldRenderToParent: shouldRenderToParent } = (0, $fnITI.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    });
    const id = providedId || generatedId;
    const handleOpenLayerObserverCloseSignal = (0, $4tluv.useCallback)(()=>{
        onClose?.(null);
    }, [
        onClose
    ]);
    (0, $3LZFN.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal,
        type: 'popup'
    });
    const renderPopperWrapper = /*#__PURE__*/ (0, $2iln5.jsx)((0, $dnJ1f.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $1KEXw.default), {
            xcss: xcss,
            appearance: appearance,
            content: content,
            isOpen: isOpen,
            placement: placement,
            fallbackPlacements: fallbackPlacements,
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: shouldFlip,
            offset: offset,
            popupComponent: PopupContainer,
            id: id,
            testId: testId,
            onClose: onClose,
            autoFocus: autoFocus,
            shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
            shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
            shouldFitContainer: shouldFitContainer,
            shouldDisableFocusLock: shouldDisableFocusLock,
            shouldReturnFocus: shouldReturnFocus,
            triggerRef: triggerRef,
            strategy: shouldFitContainer ? 'absolute' : strategy,
            role: role,
            label: label,
            titleId: titleId,
            modifiers: modifiers,
            shouldFitViewport: shouldFitViewport
        })
    });
    const popupContent = /*#__PURE__*/ (0, $2iln5.jsxs)((0, $2F9FU.Manager), {
        children: [
            /*#__PURE__*/ (0, $2iln5.jsx)((0, $cAIZq.Reference), {
                children: ({ ref: ref })=>{
                    return trigger({
                        ref: !(0, $3X3Vo.fg)('platform-design-system-popup-ref') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
                        'aria-controls': isOpen ? id : undefined,
                        'aria-expanded': isOpen,
                        'aria-haspopup': role === 'dialog' && (0, $3X3Vo.fg)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
                    });
                }
            }),
            !(0, $3X3Vo.fg)('platform-dst-motion-uplift') && isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ (0, $2iln5.jsx)((0, $gkJgm.default), {
                zIndex: zIndex,
                children: renderPopperWrapper
            })),
            (0, $3X3Vo.fg)('platform-dst-motion-uplift') && /*#__PURE__*/ (0, $2iln5.jsx)((0, $1F7MK.default), {
                children: isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ (0, $2iln5.jsx)((0, $gkJgm.default), {
                    zIndex: zIndex,
                    children: renderPopperWrapper
                }))
            })
        ]
    });
    if (shouldFitContainer) return /*#__PURE__*/ (0, $2iln5.jsx)((0, $fYX4U.default), {
        xcss: $76a9ec41e2634f9b$var$wrapperStyles.root,
        children: popupContent
    });
    return popupContent;
});

});
parcelRegister("dnJ1f", function(module, exports) {
$parcel$export(module.exports, "Layering", () => $7f0495e14f07b0bc$export$7c885f891c940977);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $7K2Oc = parcelRequire("7K2Oc");

var $gJD3O = parcelRequire("gJD3O");

var $ie1AY = parcelRequire("ie1AY");

var $jyHX4 = parcelRequire("jyHX4");
const $7f0495e14f07b0bc$var$LevelProvider = ({ children: children, currentLevel: currentLevel, node: levelNode })=>{
    (0, $4tluv.useEffect)(()=>{
        const levelNodeSafe = levelNode.current;
        const parentNode = levelNodeSafe.parent;
        parentNode?.addChild(levelNodeSafe);
        return ()=>{
            parentNode?.removeChild(levelNodeSafe);
        };
    }, [
        levelNode
    ]);
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $gJD3O.LevelContext).Provider, {
        value: currentLevel,
        children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $ie1AY.LevelNodeContext).Provider, {
            value: levelNode,
            children: children
        })
    });
};
const $7f0495e14f07b0bc$export$7c885f891c940977 = ({ children: children, isDisabled: isDisabled = true })=>{
    const currentLevel = (0, $4tluv.useContext)((0, $gJD3O.LevelContext));
    const parentNode = (0, $4tluv.useContext)((0, $ie1AY.LevelNodeContext));
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    const newNode = (0, $4tluv.useRef)(new (0, $7K2Oc.LayerNode)(Math.random().toString(36), parentNode.current));
    if (isDisabled) return /*#__PURE__*/ (0, $2iln5.jsx)((0, $2iln5.Fragment), {
        children: children
    });
    const isNested = currentLevel > 0;
    const content = /*#__PURE__*/ (0, $2iln5.jsx)($7f0495e14f07b0bc$var$LevelProvider, {
        currentLevel: currentLevel + 1,
        node: newNode,
        children: children
    });
    return isNested ? content : /*#__PURE__*/ (0, $2iln5.jsx)((0, $jyHX4.RootNodeContext).Provider, {
        value: newNode,
        children: content
    });
};

});
parcelRegister("7K2Oc", function(module, exports) {
$parcel$export(module.exports, "LayerNode", () => $5b86d23cab0699b8$export$da4f61fd78d35243);
class $5b86d23cab0699b8$export$da4f61fd78d35243 {
    constructor(id, parent){
        this.id = id;
        this.childNodes = [];
        this.parent = parent;
    }
    addChild(node) {
        this.childNodes.push(node);
    }
    removeChild(node) {
        this.childNodes = this.childNodes.filter((child)=>child.id !== node.id);
    }
    getLevel() {
        if (!this.parent) return 1;
        return this.parent.getLevel() + 1;
    }
    getHeight() {
        if (this.childNodes.length === 0) return 1;
        return Math.max(...this.childNodes.map((child)=>child.getHeight())) + 1;
    }
}

});

parcelRegister("gJD3O", function(module, exports) {
$parcel$export(module.exports, "LevelContext", () => $8dca81f061e46644$export$650d12d3c2ddb8fc);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $4tluv = parcelRequire("4tluv");
const $8dca81f061e46644$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $4tluv.createContext)(0);

});

parcelRegister("ie1AY", function(module, exports) {
$parcel$export(module.exports, "LevelNodeContext", () => $60e1c7c5eda102c1$export$18f4d8b5b3a77f59);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $4tluv = parcelRequire("4tluv");
const $60e1c7c5eda102c1$export$18f4d8b5b3a77f59 = /*#__PURE__*/ (0, $4tluv.createContext)({
    current: null
});

});

parcelRegister("jyHX4", function(module, exports) {
$parcel$export(module.exports, "RootNodeContext", () => $9715ebcf9411344d$export$fa973f110e8f6ca8);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $4tluv = parcelRequire("4tluv");
const $9715ebcf9411344d$export$fa973f110e8f6ca8 = /*#__PURE__*/ (0, $4tluv.createContext)({
    current: null
});

});


parcelRegister("1KEXw", function(module, exports) {
$parcel$export(module.exports, "default", () => $1fc040be2f10a5f6$export$2e2bcd8739ae039);
/* popper-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");

var $fXJaK = parcelRequire("fXJaK");

var $6B5AD = parcelRequire("6B5AD");

var $3X3Vo = parcelRequire("3X3Vo");

var $kE20X = parcelRequire("kE20X");

var $fkEIC = parcelRequire("fkEIC");

var $4YOWE = parcelRequire("4YOWE");

var $3lQF7 = parcelRequire("3lQF7");
const $1fc040be2f10a5f6$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $1fc040be2f10a5f6$var$fullWidthStyles = null;
const $1fc040be2f10a5f6$var$wrapperStyles = {
    root: "_2rko12b0 _1e0c1ule _vchhusvi _1pby1nn1 _bfhk1bhr _16qs130s _syazi7uo _1q1l1bhr _nt751r31 _49pcglyw _1hvw1o36",
    rootT26Shape: "_2rko1mok",
    rootLayer: "_1pby1nn1",
    fullWidth: "_1bsb1osq"
};
const $1fc040be2f10a5f6$var$scrollableStyles = null;
const $1fc040be2f10a5f6$var$blanketStyles = null;
const $1fc040be2f10a5f6$var$modalStyles = null;
const $1fc040be2f10a5f6$var$newModalStyles = null;
const $1fc040be2f10a5f6$var$focusRingStyles = {
    root: "_mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y"
};
const $1fc040be2f10a5f6$var$placementMap = {
    top: {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'top-start': {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'top-end': {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    bottom: {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'bottom-start': {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'bottom-end': {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    left: {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'left-start': {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'left-end': {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    right: {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'right-start': {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'right-end': {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    }
};
const $1fc040be2f10a5f6$var$DefaultPopupComponent = /*#__PURE__*/ (0, $4tluv.forwardRef)((props, ref)=>{
    const { shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, children: children, appearance: appearance, className: className, isReferenceHidden: _isReferenceHidden, shouldFitViewport: shouldFitViewport, ...htmlAttributes } = props;
    return /*#__PURE__*/ (0, $2iln5.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $jAkMr.default)([
            $1fc040be2f10a5f6$var$wrapperStyles.root,
            (0, $3X3Vo.fg)('platform-dst-shape-theme-default') && $1fc040be2f10a5f6$var$wrapperStyles.rootT26Shape,
            appearance === 'UNSAFE_modal-below-sm' && !(0, $3X3Vo.fg)('platform_dst_nav4_flyout_menu_slots_close_button') && "_dk5d1b66 _c71ldtre _kqsw1n9t _152t1b66",
            appearance === 'UNSAFE_modal-below-sm' && (0, $3X3Vo.fg)('platform_dst_nav4_flyout_menu_slots_close_button') && "_dk5d1b66 _c71l1ei0 _kqsw1n9t _152t1b66",
            (!shouldRenderToParent || shouldFitViewport) && "_1reo1wug _18m91wug",
            shouldFitContainer && "_1bsb1osq",
            className
        ]),
        ...htmlAttributes,
        ref: !(0, $3X3Vo.fg)('platform-dst-motion-uplift') ? ref : undefined,
        children: children
    });
});
function $1fc040be2f10a5f6$var$PopperWrapper({ xcss: xcss, isOpen: isOpen, id: id, offset: offset, testId: testId, content: content, fallbackPlacements: fallbackPlacements, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary, shouldFlip: shouldFlip, placement: placement = 'auto', // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
popupComponent: PopupContainer = $1fc040be2f10a5f6$var$DefaultPopupComponent, autoFocus: autoFocus = true, triggerRef: triggerRef, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick, shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, shouldDisableFocusLock: shouldDisableFocusLock, shouldReturnFocus: shouldReturnFocus = true, strategy: strategy, role: role, label: label, titleId: titleId, modifiers: modifiers, shouldFitViewport: shouldFitViewport, appearance: appearance = 'default' }) {
    const [popupRef, setPopupRef] = (0, $4tluv.useState)(null);
    const [initialFocusRef, setInitialFocusRef] = (0, $4tluv.useState)(null);
    // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    const shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    const shouldDisableFocusTrap = role !== 'dialog';
    (0, $3lQF7.useFocusManager)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $4YOWE.useCloseManager)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    const { currentLevel: currentLevel } = (0, $fXJaK.useLayering)();
    const mergedModifiers = (0, $4tluv.useMemo)(()=>[
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            },
            ...modifiers || []
        ], [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $kE20X.Popper), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport,
        children: ({ ref: ref, style: style, placement: placement, update: update, isReferenceHidden: isReferenceHidden })=>{
            const popupContainer = /*#__PURE__*/ (0, $2iln5.jsx)(PopupContainer, {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: (0, $jAkMr.default)([
                    xcss,
                    // @ts-expect-error: `ax` is not typed correctly
                    !initialFocusRef && (0, $3X3Vo.fg)('platform-design-system-apply-popup-wrapper-focus') && $1fc040be2f10a5f6$var$focusRingStyles.root
                ]),
                appearance: appearance,
                id: id,
                "data-ds--level": currentLevel,
                "data-placement": placement,
                "data-testid": testId,
                role: role,
                "aria-label": label,
                "aria-labelledby": titleId,
                ref: !(0, $3X3Vo.fg)('platform-dst-motion-uplift') ? (node)=>{
                    if (node) {
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                        setPopupRef(node);
                    }
                } : undefined,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: (0, $3X3Vo.fg)('platform-dst-motion-uplift') || appearance === 'UNSAFE_modal-below-sm' ? {} : style,
                // using tabIndex={-1} would cause a bug where Safari focuses
                // first on the browser address bar when using keyboard
                tabIndex: autoFocus ? 0 : undefined,
                shouldRenderToParent: shouldRenderToParent,
                shouldFitContainer: shouldFitContainer,
                shouldFitViewport: shouldFitViewport,
                isReferenceHidden: isReferenceHidden,
                children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $fkEIC.RepositionOnUpdate), {
                    update: update,
                    children: content({
                        update: update,
                        isOpen: isOpen,
                        onClose: onClose,
                        setInitialFocusRef: setInitialFocusRef
                    })
                })
            });
            const container = /*#__PURE__*/ (0, $2iln5.jsx)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                // using tabIndex={-1} would cause a bug where Safari focuses
                // first on the browser address bar when using keyboard
                ref: (node)=>{
                    if (node) {
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                        setPopupRef(node);
                    }
                },
                "data-testid": `${testId}--container`,
                className: (0, $jAkMr.default)([
                    $1fc040be2f10a5f6$var$wrapperStyles.rootLayer,
                    shouldFitContainer && $1fc040be2f10a5f6$var$wrapperStyles.fullWidth
                ]),
                children: placement === 'auto' || placement === 'auto-start' || placement === 'auto-end' ? popupContainer : /*#__PURE__*/ (0, $2iln5.jsx)((0, $6B5AD.default), {
                    enteringAnimation: $1fc040be2f10a5f6$var$placementMap[placement].enter,
                    exitingAnimation: $1fc040be2f10a5f6$var$placementMap[placement].exit,
                    children: popupContainer
                })
            });
            return /*#__PURE__*/ (0, $2iln5.jsxs)((0, $4tluv.Fragment), {
                children: [
                    (0, $3X3Vo.fg)('platform-dst-motion-uplift') ? container : popupContainer,
                    appearance === 'UNSAFE_modal-below-sm' && /*#__PURE__*/ (0, $2iln5.jsx)("div", {
                        className: (0, $jAkMr.default)([
                            "_1r04idpf _kqsw1n9t _bfhk1i5c"
                        ])
                    })
                ]
            });
        }
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1fc040be2f10a5f6$export$2e2bcd8739ae039 = $1fc040be2f10a5f6$var$PopperWrapper;

});
parcelRegister("fXJaK", function(module, exports) {
$parcel$export(module.exports, "useLayering", () => $67bc6720e010b559$export$c8b4d54e03dee6ed);

var $4tluv = parcelRequire("4tluv");

var $gJD3O = parcelRequire("gJD3O");

var $ie1AY = parcelRequire("ie1AY");

var $jyHX4 = parcelRequire("jyHX4");
function $67bc6720e010b559$export$c8b4d54e03dee6ed() {
    const currentLevel = (0, $4tluv.useContext)((0, $gJD3O.LevelContext));
    const layerNode = (0, $4tluv.useContext)((0, $ie1AY.LevelNodeContext));
    const rootNode = (0, $4tluv.useContext)((0, $jyHX4.RootNodeContext));
    const isLayerDisabled = (0, $4tluv.useCallback)(()=>{
        // This is an impossible case, added for type safety
        if (!layerNode?.current || !rootNode?.current) return false;
        return layerNode.current.getLevel() < rootNode.current.getHeight();
    }, [
        layerNode,
        rootNode
    ]);
    const getTopLevel = (0, $4tluv.useCallback)(()=>rootNode?.current ? rootNode.current.getHeight() : null, [
        rootNode
    ]);
    return {
        currentLevel: currentLevel,
        isLayerDisabled: isLayerDisabled,
        getTopLevel: getTopLevel
    };
}

});

parcelRegister("fkEIC", function(module, exports) {
$parcel$export(module.exports, "RepositionOnUpdate", () => $caa206c27c22354e$export$51eddd7655ca235a);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");
const $caa206c27c22354e$export$51eddd7655ca235a = ({ children: children, update: update })=>{
    // Ref used here to skip update on first render (when refs haven't been set)
    const isFirstRenderRef = (0, $4tluv.useRef)(true);
    (0, $4tluv.useLayoutEffect)(()=>{
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $4tluv.Fragment), {
        children: children
    });
};

});

parcelRegister("4YOWE", function(module, exports) {
$parcel$export(module.exports, "useCloseManager", () => $71607a083228200a$export$92dae2778ae88f9d);

var $4tluv = parcelRequire("4tluv");

var $Hyfcf = parcelRequire("Hyfcf");

var $ccErM = parcelRequire("ccErM");

var $fXJaK = parcelRequire("fXJaK");

var $3X3Vo = parcelRequire("3X3Vo");

var $62Jrj = parcelRequire("62Jrj");

var $6Gsnb = parcelRequire("6Gsnb");
const $71607a083228200a$export$92dae2778ae88f9d = ({ isOpen: isOpen, onClose: onClose, popupRef: popupRef, triggerRef: triggerRef, autoFocus: autoFocus, shouldDisableFocusTrap: shouldDisableFocusTrap, shouldUseCaptureOnOutsideClick: capture, shouldCloseOnTab: shouldCloseOnTab, shouldRenderToParent: shouldRenderToParent })=>{
    const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $fXJaK.useLayering)();
    const { requestFrame: requestFrame, cancelAllFrames: cancelAllFrames } = (0, $6Gsnb.useAnimationFrame)();
    const mouseDownTarget = (0, $4tluv.useRef)(null);
    (0, $4tluv.useEffect)(()=>{
        if (!isOpen || !popupRef) return 0, $ccErM.default;
        const closePopup = (event)=>{
            if (onClose) {
                let currentLevel = null;
                if (event.target instanceof HTMLElement) currentLevel = event.target.closest(`[data-ds--level]`)?.getAttribute('data-ds--level') ?? null;
                currentLevel ? onClose(event, Number(currentLevel)) : onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $3X3Vo.fg)('platform_dst_popup-disable-focuslock')) // Restoring the normal focus order for trigger.
            requestFrame(()=>{
                triggerRef?.setAttribute('tabindex', '0');
                if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        const onClick = (event)=>{
            const { target: target } = event;
            const doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist) return;
            if (isLayerDisabled()) {
                if (target instanceof HTMLElement) {
                    const layeredElement = target.closest?.(`[data-ds--level]`);
                    if (layeredElement) {
                        const closeType = layeredElement.getAttribute('[data-ds--close--type]');
                        if (closeType === 'single') // if the close type is single, we won't close other disabled layers when clicking outside
                        return;
                        const levelOfClickedLayer = layeredElement.getAttribute('data-ds--level');
                        if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // won't trigger onClick event when we click in a higher layer.
                        return;
                    }
                }
            }
            const isClickOnPopup = popupRef && popupRef.contains(target);
            const isClickOnTrigger = triggerRef && triggerRef.contains(target);
            const didClickStartInsidePopup = popupRef && mouseDownTarget.current instanceof Node && popupRef.contains(mouseDownTarget.current);
            if (!isClickOnPopup && !isClickOnTrigger && !didClickStartInsidePopup) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $62Jrj.isInteractiveElement)(document.activeElement) && (0, $3X3Vo.fg)('platform_dst_popup-disable-focuslock')) triggerRef?.focus();
            }
        };
        const onMouseDown = (event)=>{
            /**
       * Tracking the target of the mouse down event.
       * This is used to prevent the popup from closing when the user mouses down inside the popup, but then
       * moves the mouse outside the popup before releasing the mouse button.
       *
       * This is a common user interaction - users may have mistakenly clicked on something, or changed their mind,
       * so they try to cancel their click by moving their mouse away from what they had moused down on.
       *
       * Blanket uses the same technique.
       */ mouseDownTarget.current = event.target;
        };
        const onKeyDown = (event)=>{
            const key = event.key;
            if ((key === 'Escape' || key === 'Esc') && (0, $3X3Vo.fg)('platform_dst_nested_escape')) {
                const eventTarget = event.target instanceof HTMLElement ? event.target : null;
                const layeredAncestor = eventTarget?.closest?.('[data-ds--level]');
                const levelStr = layeredAncestor?.getAttribute('data-ds--level');
                if (levelStr && Number(levelStr) > currentLevel) return;
            }
            if ((0, $3X3Vo.fg)('platform_dst_popup-disable-focuslock')) {
                const { shiftKey: shiftKey } = event;
                if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(()=>{
                        const isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef?.focus();
                        }
                    });
                    return;
                }
                if (key === 'Tab') {
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && document.activeElement?.closest('[aria-modal]')) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(()=>{
                            const isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(()=>{
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc') {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc' || shouldCloseOnTab && key === 'Tab') closePopup(event);
            }
        };
        let unbind = (0, $ccErM.default);
        if ((0, $3X3Vo.fg)('popup-onclose-fix')) setTimeout(()=>{
            unbind = (0, $Hyfcf.bindAll)(window, [
                {
                    type: 'click',
                    listener: onClick,
                    options: {
                        capture: capture
                    }
                },
                {
                    type: 'keydown',
                    listener: onKeyDown
                },
                {
                    type: 'mousedown',
                    listener: onMouseDown
                }
            ]);
        }, 0);
        else unbind = (0, $Hyfcf.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'mousedown',
                listener: onMouseDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        let unbindBlur = (0, $ccErM.default);
        unbindBlur = (0, $Hyfcf.bind)(window, {
            type: 'blur',
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return ()=>{
            if ((0, $3X3Vo.fg)('popup-onclose-fix')) setTimeout(()=>{
                unbind();
            }, 0);
            else unbind();
            cancelAllFrames();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};

});
parcelRegister("62Jrj", function(module, exports) {
$parcel$export(module.exports, "isInteractiveElement", () => $0ca3e3a9039a9dd8$export$3dee5e4542c672d9);
const $0ca3e3a9039a9dd8$var$interactiveTags = [
    'button',
    'a',
    'input',
    'select',
    'textarea'
];
const $0ca3e3a9039a9dd8$export$3dee5e4542c672d9 = (element)=>{
    if ($0ca3e3a9039a9dd8$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
    return false;
};

});

parcelRegister("6Gsnb", function(module, exports) {
$parcel$export(module.exports, "useAnimationFrame", () => $c138bd0fcb2298e7$export$641fa9c94086b46e);

var $4tluv = parcelRequire("4tluv");
const $c138bd0fcb2298e7$export$641fa9c94086b46e = ()=>{
    const animationsRef = (0, $4tluv.useRef)([]);
    const requestFrame = (0, $4tluv.useCallback)((callback)=>{
        const id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    const cancelFrame = (0, $4tluv.useCallback)((id)=>{
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter((frameId)=>frameId !== id);
    }, []);
    const cancelAllFrames = (0, $4tluv.useCallback)(()=>{
        animationsRef.current.forEach((id)=>cancelAnimationFrame(id));
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};

});


parcelRegister("3lQF7", function(module, exports) {
$parcel$export(module.exports, "useFocusManager", () => $2409d7d077ca3ea2$export$10c5169755ce7bd7);

var $4tluv = parcelRequire("4tluv");

var $gH6fz = parcelRequire("gH6fz");

var $ccErM = parcelRequire("ccErM");

var $fXJaK = parcelRequire("fXJaK");

var $3X3Vo = parcelRequire("3X3Vo");

var $6Gsnb = parcelRequire("6Gsnb");
const $2409d7d077ca3ea2$export$10c5169755ce7bd7 = ({ initialFocusRef: initialFocusRef, popupRef: popupRef, triggerRef: triggerRef, autoFocus: autoFocus, shouldCloseOnTab: shouldCloseOnTab, shouldDisableFocusTrap: shouldDisableFocusTrap, shouldReturnFocus: shouldReturnFocus, shouldRenderToParent: shouldRenderToParent })=>{
    const { requestFrame: requestFrame, cancelAllFrames: cancelAllFrames } = (0, $6Gsnb.useAnimationFrame)();
    const { currentLevel: currentLevel } = (0, $fXJaK.useLayering)();
    (0, $4tluv.useEffect)(()=>{
        if (!popupRef || shouldCloseOnTab) return 0, $ccErM.default;
        if (shouldDisableFocusTrap && (0, $3X3Vo.fg)('platform_dst_popup-disable-focuslock')) {
            const isDropdown = popupRef.matches('[id^=ds--dropdown--]');
            const popups = document.querySelectorAll(`[data-ds--level="${currentLevel - 1}"]`);
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(()=>{
                    triggerRef?.setAttribute('tabindex', '-1');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $ccErM.default;
            }
        }
        const trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: (0, $3X3Vo.fg)('platform_dst_nested_escape') ? false : true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        const focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($gH6fz)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(()=>{
            focusTrap.activate();
        });
        return ()=>{
            cancelAllFrames();
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};

});


parcelRegister("fnITI", function(module, exports) {
$parcel$export(module.exports, "usePopupAppearance", () => $7b6e15f757a2b9f3$export$4065aef1d79a5730);

var $4tluv = parcelRequire("4tluv");

var $gu8yK = parcelRequire("gu8yK");
function $7b6e15f757a2b9f3$export$4065aef1d79a5730({ appearance: _appearance, shouldRenderToParent: _shouldRenderToParent }) {
    const mq = (0, $gu8yK.UNSAFE_useMediaQuery)('below.sm', (e)=>{
        setIsSmallViewport(!!e.matches);
    });
    const [isSmallViewport, setIsSmallViewport] = (0, $4tluv.useState)(!!mq?.matches);
    const appearance = _appearance === 'UNSAFE_modal-below-sm' && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
    const shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}

});
parcelRegister("gu8yK", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $6c02e9d438c946fb$export$49e55ae2c03d6045);

var $4tluv = parcelRequire("4tluv");

var $Hyfcf = parcelRequire("Hyfcf");

var $cNXkn = parcelRequire("cNXkn");
const $6c02e9d438c946fb$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $cNXkn.media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $cNXkn.media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $cNXkn.media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $cNXkn.media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $cNXkn.media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $cNXkn.media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $cNXkn.media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $cNXkn.media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $cNXkn.media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $cNXkn.media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $cNXkn.media).below.xl.replace('@media ', '').trim())
};
const $6c02e9d438c946fb$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $4tluv.useRef)(listener);
    (0, $4tluv.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ const hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ const mq = $6c02e9d438c946fb$var$queries[queryString];
    (0, $4tluv.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $Hyfcf.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});
parcelRegister("cNXkn", function(module, exports) {
$parcel$export(module.exports, "media", () => $4e665c891d20586b$export$987d49ffe1b0900f);
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ const $4e665c891d20586b$export$987d49ffe1b0900f = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

});



parcelRegister("1hPz8", function(module, exports) {
$parcel$export(module.exports, "useGetMemoizedMergedTriggerRef", () => $66f6fd4851dbf0aa$export$7cc5c058dd769dff);

var $4tluv = parcelRequire("4tluv");

var $ife0G = parcelRequire("ife0G");
const $66f6fd4851dbf0aa$export$7cc5c058dd769dff = ()=>{
    const [getMemoizedMergedTriggerRef] = (0, $4tluv.useState)(()=>(0, $ife0G.default)((ref, setTriggerRef, isOpen)=>{
            return (node)=>{
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        }));
    return getMemoizedMergedTriggerRef;
};

});

parcelRegister("2efw1", function(module, exports) {
$parcel$export(module.exports, "useGetMemoizedMergedTriggerRefNew", () => $511c0a1a83204d90$export$5d3a2de79e07b376);

var $4tluv = parcelRequire("4tluv");

var $ife0G = parcelRequire("ife0G");
const $511c0a1a83204d90$export$5d3a2de79e07b376 = ()=>{
    const [getMemoizedMergedTriggerRefNew] = (0, $4tluv.useState)(()=>(0, $ife0G.default)((ref, setTriggerRef)=>{
            return (node)=>{
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        }));
    return getMemoizedMergedTriggerRefNew;
};

});



parcelRegister("jSXMn", function(module, exports) {
$parcel$export(module.exports, "parseHex", () => $fb23cec9ccc08f08$export$103711ef09c6edec);
// valid hex color (optional alpha channel) - 3, 4, 6, or 8 digits after the #
const $fb23cec9ccc08f08$var$isValidHex = (hex)=>// Not using `([a-f0-9]{3,4}){1,2}` because that allows 7 digits which is invalid
    /^#(([a-f0-9]{3,4})|([a-f0-9][a-f0-9]){3,4})$/i.test(hex);
function $fb23cec9ccc08f08$export$103711ef09c6edec(color) {
    if (!$fb23cec9ccc08f08$var$isValidHex(color)) return null;
    let channels;
    if (color.length <= 5) // Hex code is shorthand - RGB channels are one digit
    channels = {
        r: color[1].repeat(2),
        g: color[2].repeat(2),
        b: color[3].repeat(2)
    };
    else // Hex code is longhand - RGB channels are two digits
    channels = {
        r: color.slice(1, 3),
        g: color.slice(3, 5),
        b: color.slice(5, 7)
    };
    return {
        r: parseInt(channels.r, 16),
        g: parseInt(channels.g, 16),
        b: parseInt(channels.b, 16)
    };
}

});

parcelRegister("7AQ8L", function(module, exports) {
$parcel$export(module.exports, "Profile", () => $7b0a223cd94f7fcb$export$5120f2d0b8d4cab8);

var $4tluv = parcelRequire("4tluv");

var $3LKeA = parcelRequire("3LKeA");
const $7b0a223cd94f7fcb$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, $4tluv.forwardRef)((props, ref)=>{
    const { component: component, href: href, icon: icon, id: id, isDisabled: isDisabled, isSelected: isSelected, label: labelProp, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, theme: theme, tooltip: tooltip, ...rest } = props;
    const label = labelProp || (typeof tooltip === 'string' ? tooltip : 'Your profile and settings');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement("div", {
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $3LKeA.IconButton), {
        component: component,
        href: href,
        icon: icon,
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme,
        tooltip: tooltip,
        isTooltipAnnouncementDisabled: true,
        ...rest
    }));
});
var // This exists only to extract props.
// eslint-disable-next-line import/no-anonymous-default-export
$7b0a223cd94f7fcb$export$2e2bcd8739ae039 = (_props)=>{};

});
parcelRegister("3LKeA", function(module, exports) {
$parcel$export(module.exports, "IconButton", () => $4518af09fd25d48c$export$c25acd513dcc8062);

var $4tluv = parcelRequire("4tluv");

var $groaY = parcelRequire("groaY");

var $eCj8S = parcelRequire("eCj8S");

var $2JJu8 = parcelRequire("2JJu8");

var $3HnsL = parcelRequire("3HnsL");
const $4518af09fd25d48c$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $4tluv.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, testId: testId, tooltip: tooltip, component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, theme: theme, isTooltipAnnouncementDisabled: isTooltipAnnouncementDisabled = false, ...rest } = props;
    const themeFromContext = (0, $2JJu8.useTheme)();
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $groaY.default), {
        appearance: "primary",
        "aria-label": label,
        component: component,
        href: href,
        iconBefore: icon,
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
        theme: theme || (0, $3HnsL.getIconButtonTheme)(themeFromContext),
        ...rest
    });
    if (tooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $eCj8S.default), {
        content: tooltip,
        hideTooltipOnClick: true,
        isScreenReaderAnnouncementDisabled: isTooltipAnnouncementDisabled
    }, button);
    return button;
});

});
parcelRegister("2JJu8", function(module, exports) {
$parcel$export(module.exports, "useTheme", () => $94dd9e0d329b02a5$export$93d4e7f90805808f);

var $4tluv = parcelRequire("4tluv");

var $k2jTY = parcelRequire("k2jTY");
const $94dd9e0d329b02a5$export$93d4e7f90805808f = ()=>(0, $4tluv.useContext)((0, $k2jTY.ThemeContext));

});
parcelRegister("k2jTY", function(module, exports) {
$parcel$export(module.exports, "ThemeContext", () => $e56bd55e9639b19a$export$2c657da244d00bd6);

var $4tluv = parcelRequire("4tluv");

var $l6R1I = parcelRequire("l6R1I");
const $e56bd55e9639b19a$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $4tluv.createContext)((0, $l6R1I.defaultTheme));

});
parcelRegister("l6R1I", function(module, exports) {
$parcel$export(module.exports, "defaultTheme", () => $156b48812329e2f6$export$164de7ab8df77ef0);

var $9f6TP = parcelRequire("9f6TP");
const $156b48812329e2f6$export$164de7ab8df77ef0 = (0, $9f6TP.atlassianTheme);

});
parcelRegister("9f6TP", function(module, exports) {
$parcel$export(module.exports, "atlassianTheme", () => $0fa2822fd2ed5ce8$export$eeee8619e1b91cb0);

var $k61T9 = parcelRequire("k61T9");

var $WCQeD = parcelRequire("WCQeD");
const $0fa2822fd2ed5ce8$export$eeee8619e1b91cb0 = (0, $WCQeD.generateTheme)({
    name: (0, $k61T9.DEFAULT_THEME_NAME),
    backgroundColor: '#FFFFFF',
    highlightColor: '#0052CC'
});

});
parcelRegister("k61T9", function(module, exports) {
$parcel$export(module.exports, "defaultThemeBrandRefresh", () => $c1ed310d123a0273$export$77823bc9863eaa03);
$parcel$export(module.exports, "DEFAULT_THEME_NAME", () => $c1ed310d123a0273$export$2491e13b198e597d);
const $c1ed310d123a0273$var$defaultTheme = {
    mode: {
        create: {
            active: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-pressed, #144794)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold, #1868DB)",
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-hovered, #1558BC)",
                boxShadow: ''
            },
            selected: {
                color: '',
                backgroundColor: '',
                boxShadow: ''
            }
        },
        iconButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: ''
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: ''
            }
        },
        navigation: {
            backgroundColor: "var(--ds-surface, #FFFFFF)",
            color: "var(--ds-text-subtlest, #6B6E76)"
        },
        productHome: {
            backgroundColor: "var(--ds-text-brand, #1868DB)",
            color: "var(--ds-text, #292A2E)",
            borderRight: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
            // TODO: replace with token after brand refresh
            iconColor: '#357DE8',
            textColor: "var(--ds-text, #292A2E)"
        },
        primaryButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            }
        },
        search: {
            default: {
                backgroundColor: "var(--ds-background-input, #FFFFFF)",
                color: "var(--ds-text-subtlest, #6B6E76)",
                borderColor: "var(--ds-border-input, #8C8F97)"
            },
            focus: {
                borderColor: "var(--ds-border-focused, #4688EC)"
            },
            hover: {
                backgroundColor: "var(--ds-background-input-hovered, #F8F8F8)"
            }
        },
        skeleton: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            opacity: 1
        }
    }
};
// Create deep copy of defaultTheme
const $c1ed310d123a0273$var$defaultThemeCopy = JSON.parse(JSON.stringify($c1ed310d123a0273$var$defaultTheme));
// Update iconColor and textColor in defaultThemeBrandRefresh
$c1ed310d123a0273$var$defaultThemeCopy.mode.productHome.iconColor = undefined;
$c1ed310d123a0273$var$defaultThemeCopy.mode.productHome.textColor = undefined;
const $c1ed310d123a0273$export$77823bc9863eaa03 = $c1ed310d123a0273$var$defaultThemeCopy;
const $c1ed310d123a0273$export$2491e13b198e597d = 'atlassian';
var $c1ed310d123a0273$export$2e2bcd8739ae039 = $c1ed310d123a0273$var$defaultTheme;

});

parcelRegister("WCQeD", function(module, exports) {
$parcel$export(module.exports, "generateTheme", () => $50236d580e240089$export$2e4ecffaca289a18);

var $k61T9 = parcelRequire("k61T9");

var $bbIvl = parcelRequire("bbIvl");

var $lp79L = parcelRequire("lp79L");
const $50236d580e240089$var$generateOpacityValue = (color)=>color === '#000000' ? 0.3 : 0.6;
const $50236d580e240089$var$generateButtonCSSStates = (colors, buttonType)=>{
    const { backgroundColor: backgroundColor, color: color, highlightColor: highlightColor } = colors;
    // Add less opacity for white text so it is still legible.
    const opacityValue = $50236d580e240089$var$generateOpacityValue(color);
    const isCreateButton = buttonType === 'create';
    return {
        active: {
            backgroundColor: isCreateButton ? (0, $lp79L.hexToRGBA)(backgroundColor, 0.65) : (0, $lp79L.getContrastColor)(0.3, opacityValue, backgroundColor),
            boxShadow: (0, $bbIvl.getBoxShadow)('transparent'),
            color: color
        },
        default: {
            backgroundColor: backgroundColor,
            boxShadow: (0, $bbIvl.getBoxShadow)('transparent'),
            color: color
        },
        focus: {
            boxShadow: 'none',
            color: color,
            backgroundColor: backgroundColor
        },
        hover: {
            backgroundColor: isCreateButton ? (0, $lp79L.hexToRGBA)(backgroundColor, 0.8) : (0, $lp79L.getContrastColor)(0.1, opacityValue, backgroundColor),
            boxShadow: (0, $bbIvl.getBoxShadow)('transparent'),
            color: color
        },
        selected: {
            color: color,
            backgroundColor: (0, $lp79L.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $bbIvl.getBoxShadow)('transparent')
        },
        selectedHover: {
            color: color,
            backgroundColor: (0, $lp79L.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $bbIvl.getBoxShadow)('transparent')
        }
    };
};
const $50236d580e240089$var$generateCreateButtonColors = (_themeBackground, themeHighlight)=>({
        backgroundColor: themeHighlight,
        color: (0, $lp79L.generateTextColor)(themeHighlight),
        highlightColor: themeHighlight
    });
const $50236d580e240089$export$2e4ecffaca289a18 = (themeColors)=>{
    const { backgroundColor: backgroundColor, highlightColor: highlightColor, name: name } = themeColors;
    const color = (0, $lp79L.generateTextColor)(backgroundColor);
    const colors = {
        ...themeColors,
        color: color
    };
    if (name === (0, $k61T9.DEFAULT_THEME_NAME)) return 0, $k61T9.defaultThemeBrandRefresh;
    return {
        mode: {
            create: $50236d580e240089$var$generateButtonCSSStates($50236d580e240089$var$generateCreateButtonColors(backgroundColor, highlightColor), 'create'),
            iconButton: $50236d580e240089$var$generateButtonCSSStates(colors, 'iconButton'),
            primaryButton: $50236d580e240089$var$generateButtonCSSStates(colors, 'primaryButton'),
            navigation: {
                backgroundColor: backgroundColor,
                color: color
            },
            productHome: {
                color: color,
                iconColor: color,
                textColor: color,
                backgroundColor: highlightColor,
                borderRight: `${"var(--ds-border-width, 1px)"} solid ${(0, $lp79L.hexToRGBA)(color, 0.5)}`
            },
            search: {
                default: {
                    backgroundColor: backgroundColor,
                    color: color,
                    borderColor: (0, $lp79L.hexToRGBA)(color, 0.5)
                },
                focus: {
                    borderColor: (0, $lp79L.hexToRGBA)(highlightColor, 0.8),
                    boxShadow: (0, $bbIvl.getBoxShadow)((0, $lp79L.hexToRGBA)(highlightColor, 0.5))
                },
                hover: {
                    backgroundColor: (0, $lp79L.getContrastColor)(0.1, $50236d580e240089$var$generateOpacityValue(color), backgroundColor),
                    color: color
                }
            },
            skeleton: {
                backgroundColor: color,
                opacity: 0.08
            }
        }
    };
};

});
parcelRegister("bbIvl", function(module, exports) {
$parcel$export(module.exports, "getBoxShadow", () => $be61826d3e4b4528$export$bba5a971afe05444);
const $be61826d3e4b4528$export$bba5a971afe05444 = (color)=>`0 0 0 2px ${color}`;

});

parcelRegister("lp79L", function(module, exports) {
$parcel$export(module.exports, "hexToRGBA", () => $4467f74f032db210$export$7229be6d7219ee6a);
$parcel$export(module.exports, "generateTextColor", () => $4467f74f032db210$export$10a10e7cd1193377);
$parcel$export(module.exports, "getContrastColor", () => $4467f74f032db210$export$77a1051494882576);

var $ijJ9X = parcelRequire("ijJ9X");

const $4467f74f032db210$export$7229be6d7219ee6a = (hex, opacity = 1)=>{
    const rgba = {
        ...(0, $ijJ9X.default).convert(hex).rgb,
        a: opacity
    };
    return `rgba(${Object.values(rgba).join(', ')})`;
};
const $4467f74f032db210$var$hex = '[a-z0-9]';
const $4467f74f032db210$var$shortHandHexColorPattern = new RegExp(`#(${$4467f74f032db210$var$hex})(${$4467f74f032db210$var$hex})(${$4467f74f032db210$var$hex})`, 'i');
const $4467f74f032db210$var$repeat = (str, times)=>[
        ...Array(times)
    ].map(()=>str).join('');
const $4467f74f032db210$var$isShortHexColor = (color)=>color && color.length === 4;
const $4467f74f032db210$var$completeHexColor = (colors)=>{
    const hex = colors.map((color)=>$4467f74f032db210$var$repeat(color, 2)).join('');
    return `#${hex}`;
};
const $4467f74f032db210$var$completeTriplet = (colors)=>`#${$4467f74f032db210$var$repeat(colors[1], 6)}`;
const $4467f74f032db210$var$isTriplet = (colors)=>colors[0] === colors[1] && colors[1] === colors[2];
const $4467f74f032db210$export$db8d2130677f868c = (color)=>{
    if ($4467f74f032db210$var$isShortHexColor(color)) {
        // when color = '#ccc', matches is structured as ['#ccc', 'c', 'c', 'c', ...]
        const matches = color.match($4467f74f032db210$var$shortHandHexColorPattern);
        if (matches) {
            const colors = matches.slice(1, 4);
            if ($4467f74f032db210$var$isTriplet(colors)) return $4467f74f032db210$var$completeTriplet(colors);
            else return $4467f74f032db210$var$completeHexColor(colors);
        }
    }
    // return the color as is when it's not hex color shorthand
    return color;
};
const $4467f74f032db210$export$10a10e7cd1193377 = (color)=>{
    const converted = $4467f74f032db210$export$db8d2130677f868c(color);
    return (0, $ijJ9X.default).contrastRatio(converted).hex;
};
const $4467f74f032db210$export$77a1051494882576 = (contrastValue, opacityValue, color)=>$4467f74f032db210$export$7229be6d7219ee6a((0, $ijJ9X.default).contrast(contrastValue, color).hex, opacityValue);

});






parcelRegister("3HnsL", function(module, exports) {
$parcel$export(module.exports, "getIconButtonTheme", () => $2acd3871f94fed8a$export$f32bddcb857301f3);
const $2acd3871f94fed8a$export$f32bddcb857301f3 = ({ mode: { iconButton: iconButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                borderRadius: "var(--ds-radius-full, 100%)",
                display: 'flex',
                margin: `0 ${"var(--ds-space-025, 2px)"}`,
                padding: "var(--ds-space-050, 4px)",
                height: 'auto',
                fontWeight: "var(--ds-font-weight-medium, 500)",
                ...iconButton.default,
                ':hover': iconButton.hover,
                ':focus': iconButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && iconButton.active
                },
                ...props.state === 'selected' && iconButton.selected,
                '> span': {
                    margin: 0
                }
            },
            spinnerStyles: spinnerStyles
        };
    };

});



parcelRegister("a6epy", function(module, exports) {
$parcel$export(module.exports, "default", () => $59a27a4280937e4b$export$2e2bcd8739ae039);
/* link-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $k1Lza = parcelRequire("k1Lza");

var $cDSkE = parcelRequire("cDSkE");

var $awhsN = parcelRequire("awhsN");
const $59a27a4280937e4b$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $59a27a4280937e4b$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
const $59a27a4280937e4b$var$preventEvent = (e)=>{
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $59a27a4280937e4b$var$LinkItem = /*#__PURE__*/ (0, $4tluv.memo)(/*#__PURE__*/ (0, $4tluv.forwardRef)((props, ref)=>{
    const { children: children, href: href, description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest } = props;
    const onMouseDownHandler = onMouseDown;
    const RouterLink = (0, $k1Lza.default)();
    const interactionContext = (0, $4tluv.useContext)((0, $cDSkE.default));
    const handleClick = (0, $4tluv.useCallback)((e)=>{
        interactionContext?.tracePress(interactionName, e.timeStamp);
        onClick?.(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    const isExternal = typeof href === 'string' && $59a27a4280937e4b$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $59a27a4280937e4b$var$IS_NON_HTTP_BASED.test(href);
    const isEmptyHref = href == null || href === '';
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
   * - it doesn't have an empty href (e.g. href="" or href={undefined})
   */ const isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $awhsN.default), {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: false,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        title: children,
        testId: testId && `${testId}--primitive`,
        children: ({ children: children, className: className })=>/*#__PURE__*/ (0, $2iln5.jsx)(Component, {
                "data-testid": testId,
                "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
                "data-vc": "link-item",
                ...rest,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                // @ts-expect-error
                href: isDisabled ? undefined : href,
                ...UNSAFE_isDraggable ? {} : {
                    draggable: false,
                    onDragStart: $59a27a4280937e4b$var$preventEvent
                },
                onMouseDown: isDisabled ? $59a27a4280937e4b$var$preventEvent : onMouseDownHandler,
                onClick: isDisabled ? $59a27a4280937e4b$var$preventEvent : handleClick,
                "aria-current": isSelected ? 'page' : undefined,
                "aria-disabled": isDisabled,
                ref: ref,
                children: children
            })
    });
}));
var $59a27a4280937e4b$export$2e2bcd8739ae039 = $59a27a4280937e4b$var$LinkItem;

});
parcelRegister("awhsN", function(module, exports) {
$parcel$export(module.exports, "default", () => $238206fb0a24e080$export$2e2bcd8739ae039);
/* menu-item-primitive.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");

var $da7v4 = parcelRequire("da7v4");

var $iWkWs = parcelRequire("iWkWs");

var $7xf5c = parcelRequire("7xf5c");
const $238206fb0a24e080$var$renderTitle = (Component, props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $2iln5.jsx)(Component, {
        ...props
    });
const $238206fb0a24e080$var$styles = {
    root: "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _4bfu1r31 _1hmsglyw _ajmmnqa1 _kqswh2mm _1e0c1txw _vchhusvi _1bsb1osq _1tke1ylp _1pfhze3t _12l2ze3t _6rthze3t _ahbqze3t _4cvr1h6o _uiztglyw _80omtlke _ymio1r31 _ypr0glyw _zcxs1o36 _nt751v1w _mizu1v1w _1bg41gjf _1ah31gjf _49pcnqa1 _ra3xnqa1 _1hvwdkaa _128mdkaa _9oik1r31 _1bnxglyw _jf4cnqa1 _1cvmnqa1 _4davt94y",
    beforeAfterElement: "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf",
    content: "_12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _1bah1h6o _16jlkb7n _y3gn1e5h",
    truncate: "_1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c",
    title: "_11c8fhey",
    wordBreak: "_1nmz1hna",
    description: "_11c8wadc _syaz1rpy",
    disabledDescription: "_syaz1gmx",
    unselected: "_bfhksm61 _syaz1r31 _10531r31 _irr31dpa _30l31r31 _1di61dpa _9h8h1r31",
    disabled: "_80om13gf _bfhksm61 _syaz1gmx _irr3sm61 _30l31gmx _1di6sm61 _9h8h1gmx",
    selectedBorder: "_1mp4yh40 _1cs8stnw _1rusq98m _1kt9b3bt _1fkrze3t _iajmze3t _z5wtze3t",
    selectedNotch: "_rfx3bx74 _1mp41y44 _1cs8stnw _1rusq98m _1kt9b3bt _1fkrutpp _iajmutpp _z5wtze3t",
    selected: "_bfhk15s3 _syaz6x5g _10536x5g _irr3ufnl _30l316jw _1di6nozp _9h8h6x5g",
    selectedOld: "_30l36x5g"
};
const $238206fb0a24e080$var$spacingMapStyles = {
    cozy: "_1rjcu2gc _18zrpxbi",
    compact: "_1rjc1b66 _18zrutpp _1tkezwfg"
};
const $238206fb0a24e080$var$gapMap = {
    compact: 'space.100',
    cozy: 'space.150'
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ const $238206fb0a24e080$var$MenuItemPrimitive = ({ children: children, title: title, description: description, iconAfter: iconAfter, iconBefore: iconBefore, className: UNSAFE_externalClassName, shouldTitleWrap: shouldTitleWrap = false, shouldDescriptionWrap: shouldDescriptionWrap = false, isDisabled: isDisabled = false, isSelected: isSelected = false, isTitleHeading: isTitleHeading = false, testId: testId })=>{
    const spacing = (0, $4tluv.useContext)((0, $iWkWs.SpacingContext));
    const selectionStyle = (0, $4tluv.useContext)((0, $7xf5c.SELECTION_STYLE_CONTEXT_DO_NOT_USE));
    const UNSAFE_className = UNSAFE_externalClassName;
    return (()=>{
        return children({
            className: (0, $jAkMr.default)([
                (0, $jAkMr.default)([
                    $238206fb0a24e080$var$styles.root,
                    $238206fb0a24e080$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $238206fb0a24e080$var$styles.unselected,
                    !isDisabled && isSelected && $238206fb0a24e080$var$styles.selected,
                    !isDisabled && isSelected && $238206fb0a24e080$var$styles.selectedOld,
                    !isDisabled && isSelected && selectionStyle === 'border' && $238206fb0a24e080$var$styles.selectedBorder,
                    !isDisabled && isSelected && selectionStyle === 'notch' && $238206fb0a24e080$var$styles.selectedNotch,
                    isDisabled && $238206fb0a24e080$var$styles.disabled
                ]),
                UNSAFE_className
            ]),
            children: /*#__PURE__*/ (0, $2iln5.jsxs)((0, $da7v4.default), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $238206fb0a24e080$var$gapMap[spacing],
                grow: "fill",
                testId: testId && `${testId}--container`,
                children: [
                    iconBefore && /*#__PURE__*/ (0, $2iln5.jsx)("span", {
                        "data-item-elem-before": true,
                        "data-testid": testId && `${testId}--icon-before`,
                        className: (0, $jAkMr.default)([
                            $238206fb0a24e080$var$styles.beforeAfterElement
                        ]),
                        children: iconBefore
                    }),
                    title && /*#__PURE__*/ (0, $2iln5.jsxs)("div", {
                        className: (0, $jAkMr.default)([
                            $238206fb0a24e080$var$styles.content
                        ]),
                        children: [
                            $238206fb0a24e080$var$renderTitle(isTitleHeading ? 'h2' : 'span', {
                                children: title,
                                className: (0, $jAkMr.default)([
                                    $238206fb0a24e080$var$styles.title,
                                    shouldTitleWrap ? $238206fb0a24e080$var$styles.wordBreak : $238206fb0a24e080$var$styles.truncate
                                ]),
                                'data-item-title': true
                            }),
                            description && /*#__PURE__*/ (0, $2iln5.jsx)("span", {
                                "data-item-description": true,
                                className: (0, $jAkMr.default)([
                                    $238206fb0a24e080$var$styles.description,
                                    isDisabled && $238206fb0a24e080$var$styles.disabledDescription,
                                    shouldDescriptionWrap && $238206fb0a24e080$var$styles.wordBreak,
                                    !shouldDescriptionWrap && $238206fb0a24e080$var$styles.truncate
                                ]),
                                children: description
                            })
                        ]
                    }),
                    iconAfter && /*#__PURE__*/ (0, $2iln5.jsx)("span", {
                        "data-item-elem-after": true,
                        "data-testid": testId && `${testId}--icon-after`,
                        className: (0, $jAkMr.default)([
                            $238206fb0a24e080$var$styles.beforeAfterElement
                        ]),
                        children: iconAfter
                    })
                ]
            })
        });
    })();
};
var $238206fb0a24e080$export$2e2bcd8739ae039 = $238206fb0a24e080$var$MenuItemPrimitive;

});
parcelRegister("iWkWs", function(module, exports) {
$parcel$export(module.exports, "SpacingContext", () => $a30e98a329371704$export$443076ec7ebce042);

var $4tluv = parcelRequire("4tluv");

var $7xf5c = parcelRequire("7xf5c");
const $a30e98a329371704$export$443076ec7ebce042 = /*#__PURE__*/ (0, $4tluv.createContext)('cozy');

});
parcelRegister("7xf5c", function(module, exports) {
$parcel$export(module.exports, "SELECTION_STYLE_CONTEXT_DO_NOT_USE", () => $3e08644a28c40e8f$export$9ca534b70725964d);

var $4tluv = parcelRequire("4tluv");
const $3e08644a28c40e8f$export$9ca534b70725964d = /*#__PURE__*/ (0, $4tluv.createContext)('border');

});




parcelRegister("jbQJo", function(module, exports) {
$parcel$export(module.exports, "default", () => $86a793ce3527f6a0$export$2e2bcd8739ae039);
/* menu-group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");

var $iWkWs = parcelRequire("iWkWs");

var $7xf5c = parcelRequire("7xf5c");
const $86a793ce3527f6a0$var$baseStyles = null;
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $86a793ce3527f6a0$var$MenuGroup = ({ isLoading: isLoading, maxWidth: maxWidth, minWidth: minWidth, minHeight: minHeight, maxHeight: maxHeight, testId: testId, role: role, spacing: spacing = 'cozy', menuLabel: menuLabel, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest })=>/*#__PURE__*/ (0, $2iln5.jsx)((0, $iWkWs.SpacingContext).Provider, {
        value: spacing,
        children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $7xf5c.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "border",
            children: /*#__PURE__*/ (0, $2iln5.jsx)("div", {
                "aria-busy": isLoading,
                style: {
                    minWidth: minWidth,
                    maxWidth: maxWidth,
                    minHeight: minHeight,
                    maxHeight: maxHeight
                },
                "data-testid": testId,
                role: role,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $jAkMr.default)([
                    "_1reo1wug _18m91wug _1e0c1txw _kqswpfqs _2lx21bp4",
                    UNSAFE_className
                ]),
                "aria-label": menuLabel,
                ...rest
            })
        })
    });
var $86a793ce3527f6a0$export$2e2bcd8739ae039 = $86a793ce3527f6a0$var$MenuGroup;

});

parcelRegister("jdECH", function(module, exports) {
$parcel$export(module.exports, "default", () => $49a7be339a37a0e2$export$2e2bcd8739ae039);
/* section.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");

var $Zx4NF = parcelRequire("Zx4NF");
const $49a7be339a37a0e2$var$itemHeadingTopMargin = 20;
const $49a7be339a37a0e2$var$itemHeadingBottomMargin = 6;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
const $49a7be339a37a0e2$var$itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
const $49a7be339a37a0e2$var$skeletonHeadingHeight = 8;
const $49a7be339a37a0e2$var$skeletonHeadingMarginOffset = 3;
const $49a7be339a37a0e2$var$skeletonHeadingTopMargin = $49a7be339a37a0e2$var$itemHeadingTopMargin + ($49a7be339a37a0e2$var$itemHeadingContentHeight - $49a7be339a37a0e2$var$skeletonHeadingHeight) - $49a7be339a37a0e2$var$skeletonHeadingMarginOffset;
const $49a7be339a37a0e2$var$sectionPaddingTopBottom = 6;
const $49a7be339a37a0e2$var$styles = {
    root: "_1ywu1ule _cfu11ule _1qdgi2wt _kfgti2wt _aetrb3bt _1kt9b3bt _1p3hi2wt _1l6bgktf _osbldlk8 _auo4rdoj _hp2110yn _1mfv8jkm _1bg41n1a",
    scrollable: "_1reo1wug _18m91wug _1o9zkb7n",
    unscrollable: "_1o9zidpf",
    thinSeparator: "_mqm2lllh",
    noSeparator: "_n7cnyjp0",
    sideNavSectionHeading: "_18zru2gc"
};
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $49a7be339a37a0e2$var$Section = /*#__PURE__*/ (0, $4tluv.forwardRef)(({ children: children, title: title, titleId: titleId, testId: testId, isScrollable: isScrollable, hasSeparator: hasSeparator, id: id, isList: isList = false, isSideNavSection: isSideNavSection = false, label: label, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest }, ref)=>{
    const content = isList ? /*#__PURE__*/ (0, $2iln5.jsx)("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        },
        children: (0, $4tluv.Children).map((0, $4tluv.Children).toArray(children), (child, index)=>/*#__PURE__*/ (0, $2iln5.jsx)("li", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    listStyleType: 'none',
                    margin: 0,
                    padding: 0
                },
                children: child
            }, index))
    }) : children;
    const childrenMarkup = title !== undefined ? /*#__PURE__*/ (0, $2iln5.jsxs)((0, $4tluv.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2iln5.jsx)((0, $Zx4NF.default), {
                testId: testId && `${testId}--heading`,
                "aria-hidden": true,
                // @ts-expect-error
                // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
                className: (0, $jAkMr.default)([
                    isSideNavSection && $49a7be339a37a0e2$var$styles.sideNavSectionHeading
                ]),
                children: title
            }),
            content
        ]
    }) : /*#__PURE__*/ (0, $2iln5.jsx)((0, $4tluv.Fragment), {
        children: content
    });
    return /*#__PURE__*/ (0, $2iln5.jsx)("div", {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $jAkMr.default)([
            $49a7be339a37a0e2$var$styles.root,
            isScrollable ? $49a7be339a37a0e2$var$styles.scrollable : $49a7be339a37a0e2$var$styles.unscrollable,
            hasSeparator ? $49a7be339a37a0e2$var$styles.thinSeparator : $49a7be339a37a0e2$var$styles.noSeparator,
            UNSAFE_className
        ]),
        id: id,
        // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
        // We have made a deliberate choice to leave this behaviour as is.
        "aria-label": title || label,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref,
        children: childrenMarkup
    });
});
var $49a7be339a37a0e2$export$2e2bcd8739ae039 = $49a7be339a37a0e2$var$Section;

});
parcelRegister("Zx4NF", function(module, exports) {
$parcel$export(module.exports, "default", () => $54e4dcf55c48f0e9$export$2e2bcd8739ae039);
/* heading-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");
const $54e4dcf55c48f0e9$var$headingStyles = null;
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $54e4dcf55c48f0e9$var$HeadingItem = /*#__PURE__*/ (0, $4tluv.memo)(({ children: children, testId: testId, headingLevel: headingLevel = 2, id: id, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest })=>{
    return /*#__PURE__*/ (0, $2iln5.jsx)("div", {
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $jAkMr.default)([
            "_11c8i4vh _1rjcze3t _18zrpxbi _syazazsu",
            UNSAFE_className
        ]),
        ...rest,
        children: children
    });
});
var $54e4dcf55c48f0e9$export$2e2bcd8739ae039 = $54e4dcf55c48f0e9$var$HeadingItem;

});


parcelRegister("95DsM", function(module, exports) {
$parcel$export(module.exports, "default", () => $85f690e264ddeb7c$export$2e2bcd8739ae039);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $DII3D = parcelRequire("DII3D");
var $9KeuJ = parcelRequire("9KeuJ");
var $8N0QD = parcelRequire("8N0QD");

var $8A9Bk = parcelRequire("8A9Bk");
var $fuaCP = parcelRequire("fuaCP");
var $e5Dvj = parcelRequire("e5Dvj");
var $60Q9s = parcelRequire("60Q9s");

var $kFokV = parcelRequire("kFokV");

var $eyvg7 = parcelRequire("eyvg7");

var $5x2FD = parcelRequire("5x2FD");

var $9KBmj = parcelRequire("9KBmj");

var $2ICGb = parcelRequire("2ICGb");

var $3X3Vo = parcelRequire("3X3Vo");

var $da7v4 = parcelRequire("da7v4");
var $fm1L8 = parcelRequire("fm1L8");
var $bZmu5 = parcelRequire("bZmu5");



const $85f690e264ddeb7c$var$messages = (0, $DII3D.defineMessages)({
    appDisplayMode: {
        id: 'design-system.theme-switcher.app-display-mode',
        defaultMessage: 'App display mode',
        description: 'Header for the theme switcher menu options'
    },
    themeButton: {
        id: 'design-system.theme-switcher.theme-button',
        defaultMessage: 'Theme',
        description: 'Label for button to switch to a different theme'
    },
    appearanceButton: {
        id: 'design-system.theme-switcher.appearance-button',
        defaultMessage: 'Appearance',
        description: 'Label for button to switch appearance settings'
    },
    light: {
        id: 'design-system.theme-switcher.light.option',
        defaultMessage: 'Light',
        description: 'Label for the theme switcher light option'
    },
    dark: {
        id: 'design-system.theme-switcher.dark.option',
        defaultMessage: 'Dark',
        description: 'Label for the theme switcher dark option'
    },
    matchBrowser: {
        id: 'design-system.theme-switcher.match-browser.option',
        defaultMessage: 'Match browser',
        description: 'Label for the theme switcher match browser option'
    },
    matchSystem: {
        id: 'design-system.theme-switcher.match-system.option',
        defaultMessage: 'Match system',
        description: 'Label for the theme switcher match system option'
    },
    syncedAcrossApps: {
        id: 'design-system.theme-switcher.synced-across-apps',
        defaultMessage: 'Synced across apps',
        description: 'Indicates the theme option is synced with global account settings across all apps'
    },
    personalize: {
        id: 'design-system.theme-switcher.personalize',
        defaultMessage: 'Customize display settings',
        description: 'Link to personalize settings in the theme switcher menu'
    },
    openInNewTab: {
        id: 'design-system.theme-switcher.open-in-new-tab',
        defaultMessage: ', opens in new tab',
        description: 'Accessible label for the external link icon indicating the link opens in a new browser tab'
    }
});
const $85f690e264ddeb7c$var$themeOptions = [
    {
        label: /*#__PURE__*/ (0, $2iln5.jsx)((0, $9KeuJ.default), {
            ...$85f690e264ddeb7c$var$messages.light
        }),
        value: 'light',
        thumbnail: (0, {})
    },
    {
        label: /*#__PURE__*/ (0, $2iln5.jsx)((0, $9KeuJ.default), {
            ...$85f690e264ddeb7c$var$messages.dark
        }),
        value: 'dark',
        thumbnail: (0, {})
    },
    {
        label: /*#__PURE__*/ (0, $2iln5.jsx)((0, $9KeuJ.default), {
            ...$85f690e264ddeb7c$var$messages.matchBrowser
        }),
        value: 'auto',
        thumbnail: (0, {})
    }
];
const $85f690e264ddeb7c$var$themeOptionsAutoFirst = [
    {
        label: /*#__PURE__*/ (0, $2iln5.jsx)((0, $9KeuJ.default), {
            ...$85f690e264ddeb7c$var$messages.matchSystem
        }),
        value: 'auto',
        thumbnail: (0, {})
    },
    {
        label: /*#__PURE__*/ (0, $2iln5.jsx)((0, $9KeuJ.default), {
            ...$85f690e264ddeb7c$var$messages.light
        }),
        value: 'light',
        thumbnail: (0, {})
    },
    {
        label: /*#__PURE__*/ (0, $2iln5.jsx)((0, $9KeuJ.default), {
            ...$85f690e264ddeb7c$var$messages.dark
        }),
        value: 'dark',
        thumbnail: (0, {})
    }
];
/**
 * ThemeSwitcher is a dropdown menu component for users to select between light, dark, and auto (match browser) color mode themes.
 */ const $85f690e264ddeb7c$var$ThemeSwitcher = ({ testId: testId, onThemeChange: onThemeChange, currentColorMode: currentColorMode, accountColorMode: accountColorMode, appearancePreferencesLink: appearancePreferencesLink, onOpenChange: onOpenChange, shouldInvokeOnOpenChangeOnFocusAndMouseEnter: shouldInvokeOnOpenChangeOnFocusAndMouseEnter = true })=>{
    const intl = (0, $8N0QD.default)();
    const options = (0, $3X3Vo.fg)('shared-user-preferences') ? $85f690e264ddeb7c$var$themeOptionsAutoFirst : $85f690e264ddeb7c$var$themeOptions;
    const shouldInvokeOnOpenChangeOnFocusAndMouseEnterWithCallback = shouldInvokeOnOpenChangeOnFocusAndMouseEnter && Boolean(onOpenChange);
    return /*#__PURE__*/ (0, $2iln5.jsxs)((0, $2iln5.Fragment), {
        children: [
            options.map(({ value: value, thumbnail: thumbnail })=>/*#__PURE__*/ (0, $2iln5.jsx)("link", {
                    rel: "preload",
                    href: thumbnail,
                    as: "image"
                }, value)),
            /*#__PURE__*/ (0, $2iln5.jsxs)((0, $8A9Bk.default), {
                testId: testId,
                placement: "auto-start",
                onOpenChange: onOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>{
                    const handleOpenChangeOnFocusOrMouseEnter = (event)=>{
                        if (!shouldInvokeOnOpenChangeOnFocusAndMouseEnterWithCallback) return;
                        onOpenChange?.({
                            isOpen: true,
                            event: event.nativeEvent
                        });
                    };
                    return /*#__PURE__*/ (0, $2iln5.jsx)("span", {
                        onMouseEnter: handleOpenChangeOnFocusOrMouseEnter,
                        onFocus: handleOpenChangeOnFocusOrMouseEnter,
                        children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $2ICGb.default), {
                            ref: triggerRef,
                            onClick: (event)=>event.stopPropagation(),
                            iconBefore: /*#__PURE__*/ (0, $2iln5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5x2FD))), {
                                color: "currentColor",
                                label: ""
                            }),
                            iconAfter: /*#__PURE__*/ (0, $2iln5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kFokV))), {
                                color: "currentColor",
                                label: "",
                                size: "small"
                            }),
                            ...props,
                            children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $9KeuJ.default), {
                                ...(0, $3X3Vo.fg)('shared-user-preferences') ? $85f690e264ddeb7c$var$messages.appearanceButton : $85f690e264ddeb7c$var$messages.themeButton
                            })
                        })
                    });
                },
                shouldRenderToParent: (0, $3X3Vo.fg)('set-should-render-to-parent-to-true-theme-switcher'),
                children: [
                    /*#__PURE__*/ (0, $2iln5.jsx)((0, $e5Dvj.default), {
                        title: (0, $3X3Vo.fg)('shared-user-preferences') ? intl.formatMessage($85f690e264ddeb7c$var$messages.appDisplayMode) : undefined,
                        children: options.map(({ label: label, value: value, thumbnail: thumbnail })=>{
                            const isSynced = accountColorMode !== undefined && accountColorMode === value;
                            const isSelected = currentColorMode === value;
                            return /*#__PURE__*/ (0, $2iln5.jsx)((0, $60Q9s.default), {
                                testId: `${testId}--radio-${value}`,
                                id: value,
                                onClick: ()=>onThemeChange(value),
                                isSelected: isSelected,
                                children: /*#__PURE__*/ (0, $2iln5.jsxs)((0, $da7v4.default), {
                                    space: "space.150",
                                    alignBlock: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $2iln5.jsx)((0, $9KBmj.default), {
                                            src: thumbnail,
                                            width: 64,
                                            height: 48,
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ (0, $2iln5.jsxs)((0, $fm1L8.default), {
                                            space: "space.025",
                                            children: [
                                                label,
                                                isSynced && /*#__PURE__*/ (0, $2iln5.jsx)((0, $bZmu5.default), {
                                                    size: "small",
                                                    color: "color.text.subtlest",
                                                    children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $9KeuJ.default), {
                                                        ...$85f690e264ddeb7c$var$messages.syncedAcrossApps
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, value);
                        })
                    }),
                    appearancePreferencesLink && /*#__PURE__*/ (0, $2iln5.jsx)((0, $e5Dvj.default), {
                        hasSeparator: true,
                        children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $fuaCP.default), {
                            href: appearancePreferencesLink,
                            target: "_blank",
                            rel: "noopener",
                            testId: testId && `${testId}--personalize`,
                            elemAfter: /*#__PURE__*/ (0, $2iln5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eyvg7))), {
                                color: "currentColor",
                                label: intl.formatMessage($85f690e264ddeb7c$var$messages.openInNewTab),
                                size: "small"
                            }),
                            children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $9KeuJ.default), {
                                ...$85f690e264ddeb7c$var$messages.personalize
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $85f690e264ddeb7c$export$2e2bcd8739ae039 = $85f690e264ddeb7c$var$ThemeSwitcher;

});
parcelRegister("8A9Bk", function(module, exports) {
$parcel$export(module.exports, "default", () => $42634b638ee460b2$export$2e2bcd8739ae039);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $Hyfcf = parcelRequire("Hyfcf");

var $ku0Cg = parcelRequire("ku0Cg");

var $dK9uz = parcelRequire("dK9uz");

var $hHj16 = parcelRequire("hHj16");

var $ccErM = parcelRequire("ccErM");

var $h1bE8 = parcelRequire("h1bE8");

var $g603F = parcelRequire("g603F");

var $l6Otc = parcelRequire("l6Otc");

var $fXJaK = parcelRequire("fXJaK");

var $cJTli = parcelRequire("cJTli");

var $2ocq9 = parcelRequire("2ocq9");

var $cwApa = parcelRequire("cwApa");

var $49nNx = parcelRequire("49nNx");

var $YJXSZ = parcelRequire("YJXSZ");

var $5UU2C = parcelRequire("5UU2C");

var $c3QJr = parcelRequire("c3QJr");
const $42634b638ee460b2$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $42634b638ee460b2$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $42634b638ee460b2$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$42634b638ee460b2$var$opposites[crossAxis]}`,
            `${$42634b638ee460b2$var$opposites[mainAxis]}-${crossAxis}`,
            `${$42634b638ee460b2$var$opposites[mainAxis]}`,
            `${$42634b638ee460b2$var$opposites[mainAxis]}-${$42634b638ee460b2$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$42634b638ee460b2$var$opposites[mainAxis]}`,
        `${$42634b638ee460b2$var$opposites[mainAxis]}-start`,
        `${$42634b638ee460b2$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
function $42634b638ee460b2$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $42634b638ee460b2$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $ccErM.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $2ocq9.layers).modal(), label: label, interactionName: interactionName, strategy: strategy, menuLabel: menuLabel, shouldPreventEscapePropagation: shouldPreventEscapePropagation = false })=>{
    const [isLocalOpen, setLocalIsOpen] = (0, $h1bE8.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $4tluv.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $4tluv.useState)(false);
    const id = (0, $c3QJr.default)();
    const itemRef = (0, $5UU2C.default)();
    const { currentLevel: currentLevel } = (0, $fXJaK.useLayering)();
    const fallbackPlacements = (0, $4tluv.useMemo)(()=>$42634b638ee460b2$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $4tluv.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    const handleOnClose = (0, $4tluv.useCallback)((event, currentLevel)=>{
        const isTabLeftOrEscapeKey = $42634b638ee460b2$var$isKeyboardEvent(event) && (event.key === 'Tab' || event.key === 'Escape' || event.key === (0, $dK9uz.KEY_LEFT));
        // Stop propagation on ESCAPE or Left arrow if shouldPreventEscapePropagation is true
        if (shouldPreventEscapePropagation && $42634b638ee460b2$var$isKeyboardEvent(event) && (event.key === 'Escape' || event.key === (0, $dK9uz.KEY_LEFT))) event.stopPropagation();
        if (event !== null && !isTabLeftOrEscapeKey && event.target instanceof HTMLElement && event.target.closest?.(`[id^=${(0, $c3QJr.PREFIX)}] [aria-haspopup]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if ($42634b638ee460b2$var$isKeyboardEvent(event) && (event.key === 'Tab' && event.shiftKey || event.key === 'Escape' || event.key === (0, $dK9uz.KEY_LEFT))) requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) {
            // Don't focus the trigger if the click was outside of the menu
            const isClickOutsideMenu = event?.target instanceof HTMLElement && event.target.closest?.('[role="menu"]') === null;
            const shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body; // except if clicking on the body
            if (!shouldPreventFocus) requestAnimationFrame(()=>{
                triggerRef.current?.focus();
            });
        }
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen,
        shouldPreventEscapePropagation
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $g603F.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $4tluv.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $ccErM.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $ccErM.default;
        return (0, $Hyfcf.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $c3QJr.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $dK9uz.KEY_DOWN) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $dK9uz.KEY_SPACE) || e.key === (0, $dK9uz.KEY_ENTER)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $dK9uz.KEY_TAB) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
   * The Popup component requires either:
   * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
   * or
   * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
   *
   * But not:
   * - shouldFitContainer={true} and shouldRenderToParent={false}
   *
   * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
   * types are satisfied.
   */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $YJXSZ.default), {
        children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $cJTli.default), {
            id: isLocalOpen ? id : undefined,
            shouldFlip: shouldFlip,
            isOpen: isLocalOpen,
            shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
            // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
            returnFocusRef === undefined,
            onClose: handleOnClose,
            zIndex: zIndex,
            placement: placement,
            role: shouldRenderToParent && currentLevel > 0 ? 'group' : undefined,
            fallbackPlacements: fallbackPlacements,
            testId: testId && `${testId}--content`,
            shouldUseCaptureOnOutsideClick: true,
            ...conditionalProps,
            shouldDisableFocusLock: true,
            trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
            ...rest })=>{
                if (typeof trigger === 'function') return trigger({
                    'aria-controls': ariaControls,
                    'aria-expanded': ariaExpanded,
                    'aria-haspopup': ariaHasPopup,
                    ...rest,
                    ...bindFocus,
                    triggerRef: (0, $hHj16.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    isSelected: isLocalOpen,
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`
                });
                return /*#__PURE__*/ (0, $2iln5.jsx)((0, $ku0Cg.default), {
                    ...bindFocus,
                    ref: (0, $hHj16.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    "aria-controls": ariaControls,
                    "aria-expanded": ariaExpanded,
                    "aria-haspopup": ariaHasPopup,
                    isSelected: isLocalOpen,
                    iconAfter: (iconProps)=>/*#__PURE__*/ (0, $2iln5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l6Otc))), {
                            ...iconProps,
                            size: "small"
                        }),
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`,
                    "aria-label": label,
                    interactionName: interactionName,
                    children: trigger
                });
            },
            content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, $2iln5.jsx)((0, $cwApa.default), {
                    onClose: handleOnClose,
                    children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $49nNx.default), {
                        spacing: spacing,
                        maxHeight: $42634b638ee460b2$var$MAX_HEIGHT,
                        maxWidth: shouldFitContainer ? undefined : 800,
                        onClose: handleOnClose,
                        onUpdate: update,
                        isLoading: isLoading,
                        statusLabel: statusLabel,
                        setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                        autoFocus: autoFocus,
                        testId: testId && `${testId}--menu-wrapper`,
                        menuLabel: menuLabel,
                        children: children
                    })
                })
        })
    });
};
var $42634b638ee460b2$export$2e2bcd8739ae039 = $42634b638ee460b2$var$DropdownMenu;

});
parcelRegister("h1bE8", function(module, exports) {
$parcel$export(module.exports, "default", () => $361c8f37914803a1$export$2e2bcd8739ae039);

var $4tluv = parcelRequire("4tluv");
function $361c8f37914803a1$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $4tluv.useState)(getDefaultPropValue);
    const isControlledRef = (0, $4tluv.useRef)(isControlled);
    (0, $4tluv.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $4tluv.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("g603F", function(module, exports) {
$parcel$export(module.exports, "default", () => $085f4b3800659740$export$2e2bcd8739ae039);

var $4tluv = parcelRequire("4tluv");
function $085f4b3800659740$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $4tluv.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $4tluv.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $4tluv.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("cwApa", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a40c89af1dc2448$export$2e2bcd8739ae039);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $Hyfcf = parcelRequire("Hyfcf");

var $fXJaK = parcelRequire("fXJaK");

var $fsVAr = parcelRequire("fsVAr");

var $aAAdi = parcelRequire("aAAdi");
/**
 * Focus manager logic.
 */ const $1a40c89af1dc2448$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $4tluv.useRef)([]);
    // Used to force a re-render only
    const [refresh, setRefresh] = (0, $4tluv.useState)(0);
    const registerMode = (0, $4tluv.useRef)('ordered');
    registerMode.current = 'ordered';
    const registerRef = (0, $4tluv.useCallback)((ref)=>{
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error(`Unexpected case of ${registerMode.current}`);
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $fXJaK.useLayering)();
    // Root menu (from a button) is at level 1; first submenu is at level 2. ARIA: Left only closes submenus.
    const isNestedMenu = currentLevel > 1;
    // Intentionally rebinding on each render
    (0, $4tluv.useEffect)(()=>{
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $4tluv.useEffect)(()=>(0, $Hyfcf.bind)(window, {
            type: 'keydown',
            listener: (0, $fsVAr.default)(menuItemRefs, isLayerDisabled, onClose, isNestedMenu)
        }), [
        isLayerDisabled,
        onClose,
        isNestedMenu
    ]);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $aAAdi.FocusManagerContext).Provider, {
        value: contextValue,
        children: children
    });
};
var $1a40c89af1dc2448$export$2e2bcd8739ae039 = $1a40c89af1dc2448$var$FocusManager;

});
parcelRegister("fsVAr", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae8b57ed07f73d4d$export$2e2bcd8739ae039);

var $dK9uz = parcelRequire("dK9uz");

var $3X3Vo = parcelRequire("3X3Vo");

var $c3QJr = parcelRequire("c3QJr");
const $ae8b57ed07f73d4d$var$actionMap = {
    [(0, $dK9uz.KEY_DOWN)]: 'next',
    [(0, $dK9uz.KEY_UP)]: 'prev',
    [(0, $dK9uz.KEY_HOME)]: 'first',
    [(0, $dK9uz.KEY_END)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $ae8b57ed07f73d4d$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $ae8b57ed07f73d4d$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
function $ae8b57ed07f73d4d$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose, isNestedMenu = false) {
    return (e)=>{
        const currentRefs = refs.current ?? [];
        const currentFocusedIdx = currentRefs.findIndex(({ current: el })=>el && document.activeElement?.isSameNode(el));
        if ((0, $3X3Vo.fg)('platform_dst_popup-disable-focuslock')) {
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $c3QJr.PREFIX)}]`);
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $dK9uz.KEY_TAB) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $dK9uz.KEY_TAB) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        // Left arrow: only in a submenu — close and return focus to parent. No navigation within menu.
        if (e.key === (0, $dK9uz.KEY_LEFT)) {
            e.preventDefault();
            if (isNestedMenu) onClose(e);
            return;
        }
        // Right arrow: only when item has submenu — open it. No navigation within menu.
        if (e.key === (0, $dK9uz.KEY_RIGHT)) {
            const activeElement = document.activeElement;
            if (activeElement instanceof HTMLElement && (activeElement.getAttribute('aria-haspopup') === 'true' || activeElement.getAttribute('aria-haspopup') === 'menu')) {
                e.preventDefault();
                activeElement.click();
            }
            return;
        }
        const action = $ae8b57ed07f73d4d$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const nextFocusableElement = $ae8b57ed07f73d4d$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                nextFocusableElement?.focus();
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const prevFocusableElement = $ae8b57ed07f73d4d$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                prevFocusableElement?.focus();
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const firstFocusableElement = $ae8b57ed07f73d4d$var$getNextFocusableElement(currentRefs, -1);
                firstFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const lastFocusableElement = $ae8b57ed07f73d4d$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                lastFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});
parcelRegister("c3QJr", function(module, exports) {
$parcel$export(module.exports, "PREFIX", () => $faaaf514f989ec35$export$8a682ae47622dbb9);
$parcel$export(module.exports, "default", () => $faaaf514f989ec35$export$2e2bcd8739ae039);

var $fEY94 = parcelRequire("fEY94");
const $faaaf514f989ec35$export$8a682ae47622dbb9 = 'ds--dropdown--';
function $faaaf514f989ec35$export$2e2bcd8739ae039() {
    const id = (0, $fEY94.useId)();
    return `${$faaaf514f989ec35$export$8a682ae47622dbb9}${id}`;
}

});


parcelRegister("aAAdi", function(module, exports) {
$parcel$export(module.exports, "FocusManagerContext", () => $dc2c131d2f7e1481$export$f18c1d4fc7326096);

var $4tluv = parcelRequire("4tluv");

var $ccErM = parcelRequire("ccErM");
const $dc2c131d2f7e1481$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $4tluv.createContext)({
    menuItemRefs: [],
    registerRef: (0, $ccErM.default)
});

});


parcelRegister("49nNx", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d1f05ca5ab8d58c$export$2e2bcd8739ae039);
/* menu-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $jbQJo = parcelRequire("jbQJo");

var $3X3Vo = parcelRequire("3X3Vo");

var $fYX4U = parcelRequire("fYX4U");

var $jJcBA = parcelRequire("jJcBA");

var $lkV3I = parcelRequire("lkV3I");

var $hiRuG = parcelRequire("hiRuG");

var $aAAdi = parcelRequire("aAAdi");
const $4d1f05ca5ab8d58c$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _1q51v47k _y4tiv47k _85i5v47k _bozgv47k"
};
const $4d1f05ca5ab8d58c$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $2iln5.jsx)((0, $fYX4U.default), {
        xcss: $4d1f05ca5ab8d58c$var$styles.spinnerContainer,
        role: "menuitem",
        children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $jJcBA.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        })
    });
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $4d1f05ca5ab8d58c$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus, menuLabel: menuLabel })=>{
    const { menuItemRefs: menuItemRefs } = (0, $4tluv.useContext)((0, $aAAdi.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDescendant = menuItemRefs.some((menuItemRef)=>{
            const { current: menuItem } = menuItemRef;
            if (!menuItem) return false;
            const isCheckboxOrRadio = (0, $lkV3I.default)(menuItem) || (0, $hiRuG.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $4tluv.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $4tluv.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.map(({ current: current })=>current).find((el)=>!!el && !el.hasAttribute('disabled')) ?? null;
        if (((0, $3X3Vo.fg)('platform_dst_menu_item_focus') || shouldRenderToParent) && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $jbQJo.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`,
        menuLabel: menuLabel,
        children: isLoading ? /*#__PURE__*/ (0, $2iln5.jsx)($4d1f05ca5ab8d58c$var$LoadingIndicator, {
            statusLabel: statusLabel,
            testId: testId && `${testId}--loading-indicator`
        }) : children
    });
};
var $4d1f05ca5ab8d58c$export$2e2bcd8739ae039 = $4d1f05ca5ab8d58c$var$MenuWrapper;

});
parcelRegister("lkV3I", function(module, exports) {
$parcel$export(module.exports, "default", () => $5833d80f06d798f6$export$2e2bcd8739ae039);
function $5833d80f06d798f6$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("hiRuG", function(module, exports) {
$parcel$export(module.exports, "default", () => $3777ebb31b9ea247$export$2e2bcd8739ae039);
function $3777ebb31b9ea247$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("YJXSZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $2cf4f3de6c0ef1ab$export$2e2bcd8739ae039);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $f4cOM = parcelRequire("f4cOM");
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $2cf4f3de6c0ef1ab$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $4tluv.useRef)({});
    const context = (0, $4tluv.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $f4cOM.SelectionStoreContext).Provider, {
        value: context,
        children: children
    });
};
var $2cf4f3de6c0ef1ab$export$2e2bcd8739ae039 = $2cf4f3de6c0ef1ab$var$SelectionStore;

});
parcelRegister("f4cOM", function(module, exports) {
$parcel$export(module.exports, "SelectionStoreContext", () => $ec1f3d7bf38d4c2e$export$756f795847463ebd);

var $4tluv = parcelRequire("4tluv");

var $ccErM = parcelRequire("ccErM");
const $ec1f3d7bf38d4c2e$export$756f795847463ebd = /*#__PURE__*/ (0, $4tluv.createContext)({
    setItemState: (0, $ccErM.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $ccErM.default),
    getGroupState: ()=>({})
});

});


parcelRegister("5UU2C", function(module, exports) {
$parcel$export(module.exports, "default", () => $4cefb9c953fa8405$export$2e2bcd8739ae039);
// eslint-disable-next-line sort-imports

var $4tluv = parcelRequire("4tluv");

var $3X3Vo = parcelRequire("3X3Vo");

var $aAAdi = parcelRequire("aAAdi");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $4cefb9c953fa8405$var$useRegisterItemWithFocusManager(hasPopup = false) {
    const { registerRef: registerRef } = (0, $4tluv.useContext)((0, $aAAdi.FocusManagerContext));
    const itemRef = (0, $4tluv.useRef)(null);
    (0, $4tluv.useEffect)(()=>{
        if (hasPopup && (0, $3X3Vo.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $4cefb9c953fa8405$export$2e2bcd8739ae039 = $4cefb9c953fa8405$var$useRegisterItemWithFocusManager;

});


parcelRegister("fuaCP", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b441e72e6dfcae2$export$2e2bcd8739ae039);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $hHj16 = parcelRequire("hHj16");

var $2ICGb = parcelRequire("2ICGb");

var $fl9Ti = parcelRequire("fl9Ti");

var $a6epy = parcelRequire("a6epy");

var $5UU2C = parcelRequire("5UU2C");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ const $3b441e72e6dfcae2$var$DropdownMenuItem = /*#__PURE__*/ (0, $4tluv.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, role: role, ...rest }, ref)=>{
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    const itemRef = (0, $5UU2C.default)(!!rest['aria-haspopup']);
    const handleItemClick = (0, $4tluv.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, $2iln5.jsx)((0, $fl9Ti.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $hHj16.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else if (href) return /*#__PURE__*/ (0, $2iln5.jsx)((0, $a6epy.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $hHj16.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else return /*#__PURE__*/ (0, $2iln5.jsx)((0, $2ICGb.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $hHj16.default)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        children: children
    });
});
var $3b441e72e6dfcae2$export$2e2bcd8739ae039 = $3b441e72e6dfcae2$var$DropdownMenuItem;

});
parcelRegister("2ICGb", function(module, exports) {
$parcel$export(module.exports, "default", () => $d68c094dfac6c72e$export$2e2bcd8739ae039);
/* button-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $cDSkE = parcelRequire("cDSkE");

var $awhsN = parcelRequire("awhsN");
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $d68c094dfac6c72e$var$ButtonItem = /*#__PURE__*/ (0, $4tluv.memo)(/*#__PURE__*/ (0, $4tluv.forwardRef)((props, ref)=>{
    const { children: children, description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, interactionName: interactionName, ...rest } = props;
    const onMouseDownHandler = onMouseDown;
    const interactionContext = (0, $4tluv.useContext)((0, $cDSkE.default));
    const handleClick = (0, $4tluv.useCallback)((e)=>{
        interactionContext?.tracePress(interactionName, e.timeStamp);
        onClick?.(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $awhsN.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        ...rest,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        isTitleHeading: false,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && `${testId}--primitive`,
        children: ({ children: children, className: className })=>/*#__PURE__*/ (0, $2iln5.jsx)("button", {
                "data-testid": testId,
                // This is intentionally placed before the `...rest` spread to prevent overriding existing usages of `aria-current`,
                // which are already being passed to the button element.
                "aria-current": isSelected ? 'true' : undefined,
                ...rest,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                ref: ref,
                disabled: isDisabled,
                onClick: handleClick,
                onMouseDown: onMouseDownHandler,
                type: "button",
                children: children
            })
    });
}));
var $d68c094dfac6c72e$export$2e2bcd8739ae039 = $d68c094dfac6c72e$var$ButtonItem;

});

parcelRegister("fl9Ti", function(module, exports) {
$parcel$export(module.exports, "default", () => $09e2219ce37fe414$export$2e2bcd8739ae039);
/* custom-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $cDSkE = parcelRequire("cDSkE");

var $awhsN = parcelRequire("awhsN");
const $09e2219ce37fe414$var$preventEvent = (e)=>{
    e.preventDefault();
};
/**
 * __Custom item__
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $09e2219ce37fe414$var$CustomItem = /*#__PURE__*/ (0, $4tluv.memo)(/*#__PURE__*/ (0, $4tluv.forwardRef)(({ component: Component, isDisabled: isDisabled = false, isSelected: isSelected = false, isTitleHeading: isTitleHeading = false, onClick: onClick, testId: testId, children: children, description: description, iconAfter: iconAfter, iconBefore: iconBefore, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest }, ref)=>{
    const onMouseDownHandler = onMouseDown;
    const interactionContext = (0, $4tluv.useContext)((0, $cDSkE.default));
    const handleClick = (0, $4tluv.useCallback)((e)=>{
        interactionContext?.tracePress(interactionName, e.timeStamp);
        onClick?.(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!Component) return null;
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $awhsN.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        ...rest,
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: isTitleHeading,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && `${testId}--primitive`,
        children: ({ children: children, className: className })=>/*#__PURE__*/ (0, $2iln5.jsx)(Component, {
                "data-testid": testId,
                ...rest,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                ref: ref,
                ...UNSAFE_isDraggable ? {} : {
                    draggable: false,
                    onDragStart: $09e2219ce37fe414$var$preventEvent
                },
                onMouseDown: isDisabled ? $09e2219ce37fe414$var$preventEvent : onMouseDownHandler,
                onClick: isDisabled ? $09e2219ce37fe414$var$preventEvent : handleClick,
                tabIndex: isDisabled ? -1 : undefined,
                "aria-disabled": isDisabled,
                children: children
            })
    });
}));
var $09e2219ce37fe414$export$2e2bcd8739ae039 = $09e2219ce37fe414$var$CustomItem;

});


parcelRegister("e5Dvj", function(module, exports) {
$parcel$export(module.exports, "default", () => $2487aa0f37f46a4d$export$2e2bcd8739ae039);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $fEY94 = parcelRequire("fEY94");

var $jdECH = parcelRequire("jdECH");

var $lqANn = parcelRequire("lqANn");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $2487aa0f37f46a4d$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $4tluv.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, ...rest }, ref)=>{
    const uid = (0, $fEY94.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, $2iln5.jsxs)((0, $jdECH.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        ...rest,
        children: [
            title && /*#__PURE__*/ (0, $2iln5.jsx)((0, $lqANn.default), {
                id: titleId,
                title: title
            }),
            children
        ]
    });
});
var $2487aa0f37f46a4d$export$2e2bcd8739ae039 = $2487aa0f37f46a4d$var$DropdownMenuItemGroup;

});
parcelRegister("lqANn", function(module, exports) {
$parcel$export(module.exports, "default", () => $a62d51dc95654a70$export$2e2bcd8739ae039);
/* group-title.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $fYX4U = parcelRequire("fYX4U");
const $a62d51dc95654a70$var$styles = {
    heading: "_11c8i4vh _1rjcze3t _18zrpxbi _syazazsu"
};
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ const $a62d51dc95654a70$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $2iln5.jsx)((0, $fYX4U.default), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $a62d51dc95654a70$var$styles.heading,
        children: title
    });
var $a62d51dc95654a70$export$2e2bcd8739ae039 = $a62d51dc95654a70$var$GroupTitle;

});


parcelRegister("60Q9s", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad37a6e86ded6c3c$export$2e2bcd8739ae039);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $ccErM = parcelRequire("ccErM");

var $7xf5c = parcelRequire("7xf5c");

var $2ICGb = parcelRequire("2ICGb");

var $k7gbB = parcelRequire("k7gbB");

var $8k6xG = parcelRequire("8k6xG");

var $2DDol = parcelRequire("2DDol");

var $5UU2C = parcelRequire("5UU2C");

var $hcSxw = parcelRequire("hcSxw");
/**
 * __Dropdown item radio__
 *
 * A dropdown item radio displays groups that have a single selection.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/usage)
 */ const $ad37a6e86ded6c3c$var$DropdownItemRadio = ({ children: children, defaultSelected: defaultSelected, testId: testId, id: id, title: title, description: description, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $ccErM.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, interactionName: interactionName, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $hcSxw;
    const [selected, setSelected] = (0, $2DDol.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $4tluv.useCallback)((event)=>{
        setSelected((selected)=>!selected);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $5UU2C.default)();
    return /*#__PURE__*/ (0, $2iln5.jsxs)((0, $7xf5c.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none",
        children: [
            /*#__PURE__*/ (0, $2iln5.jsx)((0, $2ICGb.default), {
                "aria-checked": selected,
                "aria-describedby": `${id}-radio`,
                description: description,
                iconBefore: /*#__PURE__*/ (0, $2iln5.jsx)((0, $8k6xG.default), {
                    checked: selected
                }),
                id: id,
                isDisabled: isDisabled,
                isSelected: selected,
                onClick: onClickHandler,
                ref: itemRef,
                role: "menuitemradio",
                shouldDescriptionWrap: shouldDescriptionWrap,
                shouldTitleWrap: shouldTitleWrap,
                testId: testId,
                // Thanks to spread props, this attribute are passed to ButtonItem, even though
                // it's not in the component's prop types.
                // @ts-expect-error
                title: title,
                interactionName: interactionName,
                ...rest,
                // Override ButtonItem's default aria-current, as aria-checked is the correct attribute for menuitemradio (A11Y-37930)
                "aria-current": undefined,
                children: children
            }),
            /*#__PURE__*/ (0, $2iln5.jsxs)((0, $k7gbB.default), {
                id: `${id}-radio`,
                children: [
                    "radio button ",
                    selected
                ]
            })
        ]
    });
};
var $ad37a6e86ded6c3c$export$2e2bcd8739ae039 = $ad37a6e86ded6c3c$var$DropdownItemRadio;

});
parcelRegister("8k6xG", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e0fcd236a82826f$export$2e2bcd8739ae039);
/* radio-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $jAkMr = parcelRequire("jAkMr");
parcelRequire("4tluv");
const $9e0fcd236a82826f$var$svgStyles = null;
/**
 * __Radio icon__
 *
 * Used to visually represent the selected state in DropdownItemRadio
 *
 * @internal
 */ const $9e0fcd236a82826f$var$RadioIcon = ({ checked: checked })=>{
    return /*#__PURE__*/ (0, $2iln5.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            color: checked ? "var(--ds-background-selected-bold, #1868DB)" : "var(--ds-background-input, #FFFFFF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            fill: checked ? "var(--ds-icon-inverse, #FFFFFF)" : 'transparent'
        },
        role: "presentation",
        className: (0, $jAkMr.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $2iln5.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $2iln5.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "7.5",
                    fill: "currentColor",
                    stroke: checked ? "var(--ds-border-selected, #1868DB)" : "var(--ds-border-input, #8C8F97)",
                    strokeWidth: "1"
                }),
                /*#__PURE__*/ (0, $2iln5.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3",
                    fill: "inherit"
                })
            ]
        })
    });
};
var $9e0fcd236a82826f$export$2e2bcd8739ae039 = $9e0fcd236a82826f$var$RadioIcon;

});

parcelRegister("2DDol", function(module, exports) {
$parcel$export(module.exports, "default", () => $511b39c7a0334863$export$2e2bcd8739ae039);

var $4tluv = parcelRequire("4tluv");

var $dyFUF = parcelRequire("dyFUF");

var $f4cOM = parcelRequire("f4cOM");
function $511b39c7a0334863$var$useRadioState({ id: id, isSelected: isSelected, defaultSelected: defaultSelected }) {
    const { setGroupState: setGroupState, getGroupState: getGroupState } = (0, $4tluv.useContext)((0, $f4cOM.SelectionStoreContext));
    const { id: group, radioGroupState: radioGroupState, selectRadioItem: selectRadioItem } = (0, $4tluv.useContext)((0, $dyFUF.RadioGroupContext));
    const persistedIsSelected = radioGroupState[id];
    const [localIsSelected, setLocalIsSelected] = (0, $4tluv.useState)(()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $4tluv.useCallback)((newValue)=>{
        if (!persistedIsSelected) {
            const nextValue = newValue(persistedIsSelected);
            selectRadioItem(id, nextValue);
            setLocalIsSelected(nextValue);
        }
    }, [
        persistedIsSelected,
        id,
        selectRadioItem
    ]);
    /**
   * - radio state changes any time a radio child is changed
   * - when it changes we want all radio buttons to update their local state
   * - it takes the value from radio group state and applies it locally if it exists which it will only exist, if it is selected
   */ (0, $4tluv.useEffect)(()=>{
        setLocalIsSelected(()=>{
            const existing = radioGroupState[id];
            return existing !== undefined ? existing : defaultSelected || false;
        });
    }, [
        radioGroupState,
        group,
        id,
        defaultSelected
    ]);
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    /**
   * Set the initial state of the context provider's store,
   * if it doesn't already have a persisted value for this id.
   */ if (persistedIsSelected === undefined) {
        const existing = getGroupState(group);
        const newGroupState = {
            ...existing,
            [id]: defaultSelected || false
        };
        setGroupState(group, newGroupState);
    }
    return [
        localIsSelected,
        setLocalState
    ];
}
var $511b39c7a0334863$export$2e2bcd8739ae039 = $511b39c7a0334863$var$useRadioState;

});
parcelRegister("dyFUF", function(module, exports) {
$parcel$export(module.exports, "RadioGroupContext", () => $20a922ce46992825$export$a79eda4ff50e30b6);

var $4tluv = parcelRequire("4tluv");

var $ccErM = parcelRequire("ccErM");
const $20a922ce46992825$export$a79eda4ff50e30b6 = /*#__PURE__*/ (0, $4tluv.createContext)({
    id: '',
    radioGroupState: {},
    selectRadioItem: (0, $ccErM.default)
});

});



parcelRegister("bZmu5", function(module, exports) {
$parcel$export(module.exports, "default", () => $24cdddd0364f3099$export$2e2bcd8739ae039);
/* text.tsx generated by @compiled/babel-plugin v0.36.1 */ /* text.tsx generated by @compiled/babel-plugin v0.36.1 */ /* text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");

var $kEkKo = parcelRequire("kEkKo");

var $74oxG = parcelRequire("74oxG");

var $71w0l = parcelRequire("71w0l");
const $24cdddd0364f3099$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ const $24cdddd0364f3099$var$useColor = (colorProp, hasTextAncestor)=>{
    const surface = (0, $71w0l.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($24cdddd0364f3099$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $24cdddd0364f3099$export$2185ce37f9bdd963[surface];
    return 'color.text';
};
const $24cdddd0364f3099$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pwu06",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
const $24cdddd0364f3099$var$fontSizeMap = {
    medium: "_11c8fhey",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
const $24cdddd0364f3099$var$fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
const $24cdddd0364f3099$var$textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
const $24cdddd0364f3099$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ const $24cdddd0364f3099$var$Text = /*#__PURE__*/ (0, $4tluv.forwardRef)(({ as: Component = 'span', color: colorProp, align: align, testId: testId, id: id, size: size, weight: weight, maxLines: maxLines, xcss: xcss, children: children }, ref)=>{
    (0, $kEkKo.default)($24cdddd0364f3099$var$asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = (0, $74oxG.useHasTextAncestor)();
    const color = $24cdddd0364f3099$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    const component = /*#__PURE__*/ (0, $2iln5.jsx)(Component, {
        id: id,
        className: (0, $jAkMr.default)([
            $24cdddd0364f3099$var$styles.root,
            size && $24cdddd0364f3099$var$fontSizeMap[size],
            color && $24cdddd0364f3099$var$textColorMap[color],
            maxLines && $24cdddd0364f3099$var$styles.truncation,
            maxLines === 1 && $24cdddd0364f3099$var$styles.breakAll,
            align && $24cdddd0364f3099$var$styles[`textAlign.${align}`],
            weight && $24cdddd0364f3099$var$fontWeightMap[weight],
            Component === 'em' && $24cdddd0364f3099$var$styles['as.em'],
            Component === 'strong' && $24cdddd0364f3099$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref,
        children: children
    });
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $74oxG.HasTextAncestorProvider), {
        value: true,
        children: component
    });
});
var $24cdddd0364f3099$export$2e2bcd8739ae039 = $24cdddd0364f3099$var$Text;

});


parcelRegister("iWyYU", function(module, exports) {
$parcel$export(module.exports, "default", () => $ddedda06d496ae64$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");
const $ddedda06d496ae64$var$shimmerKeyframes = null;
const $ddedda06d496ae64$var$skeletonStyles = null;
const $ddedda06d496ae64$var$activeShimmerStyles = null;
/**
 * __Skeleton__
 *
 * A skeleton acts as a placeholder for content, usually while the content loads.
 *
 * - [Examples](https://atlassian.design/components/skeleton/examples)
 * - [Code](https://atlassian.design/components/skeleton/code)
 */ const $ddedda06d496ae64$var$Skeleton = ({ width: width, height: height, borderRadius: borderRadius = "var(--ds-radius-small, 4px)", color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: isShimmering = false, groupName: groupName, testId: testId })=>{
    const groupDataAttribute = groupName && `data-${groupName}`;
    return /*#__PURE__*/ (0, $2iln5.jsx)("div", {
        "data-testid": testId,
        style: {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
            '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
            '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
        },
        ...groupDataAttribute && {
            [groupDataAttribute]: 'true'
        },
        className: (0, $jAkMr.default)([
            "_7hjf1yy8 _5sag12o8 _tip812c5 _1pglp3kn _bfhkizff",
            isShimmering && "",
            isShimmering && "_j7hq19vq"
        ])
    });
};
var $ddedda06d496ae64$export$2e2bcd8739ae039 = $ddedda06d496ae64$var$Skeleton;

});

parcelRegister("hT0yS", function(module, exports) {
$parcel$export(module.exports, "default", () => $12a7896178d68660$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4tluv = parcelRequire("4tluv");

var $ft5N0 = parcelRequire("ft5N0");

var $kfPot = parcelRequire("kfPot");

var $8f748 = parcelRequire("8f748");
const $12a7896178d68660$var$flexGrowMap = {
    hug: (0, $kfPot.xcss)({
        flexGrow: 0
    }),
    fill: (0, $kfPot.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
const $12a7896178d68660$var$separatorStyles = (0, $ft5N0.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: `${"var(--ds-space-negative-025, -2px)"}`,
    pointerEvents: 'none',
    userSelect: 'none'
});
const $12a7896178d68660$var$Separator = ({ children: children })=>/*#__PURE__*/ (0, $ft5N0.jsx)("span", {
        css: $12a7896178d68660$var$separatorStyles
    }, children);
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ const $12a7896178d68660$var$Inline = /*#__PURE__*/ (0, $4tluv.memo)(/*#__PURE__*/ (0, $4tluv.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, id: id, children: rawChildren }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ (0, $ft5N0.jsx)($12a7896178d68660$var$Separator, null, separator) : separator;
    const children = separatorComponent ? (0, $4tluv.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ (0, $ft5N0.jsx)((0, $4tluv.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    const justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $12a7896178d68660$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return /*#__PURE__*/ (0, $ft5N0.jsx)((0, $8f748.default), {
        id: id,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$12a7896178d68660$var$Inline.displayName = 'Inline';
var $12a7896178d68660$export$2e2bcd8739ae039 = $12a7896178d68660$var$Inline;

});
parcelRegister("8f748", function(module, exports) {
$parcel$export(module.exports, "default", () => $be2edce17d5ac61d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4tluv = parcelRequire("4tluv");

var $ft5N0 = parcelRequire("ft5N0");

var $dpQkd = parcelRequire("dpQkd");

var $kfPot = parcelRequire("kfPot");
const $be2edce17d5ac61d$var$justifyContentMap = {
    start: (0, $ft5N0.css)({
        justifyContent: 'start'
    }),
    center: (0, $ft5N0.css)({
        justifyContent: 'center'
    }),
    end: (0, $ft5N0.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $ft5N0.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $ft5N0.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $ft5N0.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $ft5N0.css)({
        justifyContent: 'stretch'
    })
};
const $be2edce17d5ac61d$var$flexDirectionMap = {
    column: (0, $ft5N0.css)({
        flexDirection: 'column'
    }),
    row: (0, $ft5N0.css)({
        flexDirection: 'row'
    })
};
const $be2edce17d5ac61d$var$flexWrapMap = {
    wrap: (0, $ft5N0.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $ft5N0.css)({
        flexWrap: 'nowrap'
    })
};
const $be2edce17d5ac61d$var$alignItemsMap = {
    start: (0, $ft5N0.css)({
        alignItems: 'start'
    }),
    center: (0, $ft5N0.css)({
        alignItems: 'center'
    }),
    baseline: (0, $ft5N0.css)({
        alignItems: 'baseline'
    }),
    end: (0, $ft5N0.css)({
        alignItems: 'end'
    }),
    stretch: (0, $ft5N0.css)({
        alignItems: 'stretch'
    })
};
const $be2edce17d5ac61d$var$baseStyles = (0, $ft5N0.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ const $be2edce17d5ac61d$var$Flex = /*#__PURE__*/ (0, $4tluv.memo)(/*#__PURE__*/ (0, $4tluv.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss, id: id }, ref)=>{
    const resolvedStyles = (0, $kfPot.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $ft5N0.jsx)(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $be2edce17d5ac61d$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $dpQkd.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $dpQkd.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $dpQkd.spaceStylesMap).rowGap[rowGap],
            alignItems && $be2edce17d5ac61d$var$alignItemsMap[alignItems],
            direction && $be2edce17d5ac61d$var$flexDirectionMap[direction],
            justifyContent && $be2edce17d5ac61d$var$justifyContentMap[justifyContent],
            wrap && $be2edce17d5ac61d$var$flexWrapMap[wrap],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$be2edce17d5ac61d$var$Flex.displayName = 'Flex';
var $be2edce17d5ac61d$export$2e2bcd8739ae039 = $be2edce17d5ac61d$var$Flex;

});


parcelRegister("eojIt", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d9ad20263b4eacd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4tluv = parcelRequire("4tluv");

var $ft5N0 = parcelRequire("ft5N0");

var $kfPot = parcelRequire("kfPot");

var $8f748 = parcelRequire("8f748");
const $4d9ad20263b4eacd$var$flexGrowMap = {
    hug: (0, $kfPot.xcss)({
        flexGrow: 0
    }),
    fill: (0, $kfPot.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ const $4d9ad20263b4eacd$var$Stack = /*#__PURE__*/ (0, $4tluv.memo)(/*#__PURE__*/ (0, $4tluv.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role, id: id }, ref)=>{
    const justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $4d9ad20263b4eacd$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return /*#__PURE__*/ (0, $ft5N0.jsx)((0, $8f748.default), {
        id: id,
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$4d9ad20263b4eacd$var$Stack.displayName = 'Stack';
var $4d9ad20263b4eacd$export$2e2bcd8739ae039 = $4d9ad20263b4eacd$var$Stack;

});

parcelRegister("caeHC", function(module, exports) {
$parcel$export(module.exports, "default", () => $37045b89715691c9$export$2e2bcd8739ae039);
/* lozenge.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");

var $3X3Vo = parcelRequire("3X3Vo");

var $6PU1e = parcelRequire("6PU1e");
/**
 * TODO: We should be using our bounded `cssMap` here, but most of
 * these styles from the visual refresh are not in the Design System.
 */ const $37045b89715691c9$var$styles = {
    container: "_2rkofajl _1reo15vq _18m915vq _1e0c116y _vchhusvi _kqswpfqs _1kz6184x _bozg1b66 _y4ti1b66",
    containerSubtle: "_1cwg1n1a",
    text: "_1reo15vq _18m915vq _ect4ttxp _1wyb1skh _zg8l4jg8 _k48pwu06 _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi",
    'bg.bold.default': "_bfhk1fkg",
    'bg.bold.inprogress': "_bfhk1ymo",
    'bg.bold.moved': "_bfhkxmjf",
    'bg.bold.new': "_bfhkshej",
    'bg.bold.removed': "_bfhk1366",
    'bg.bold.success': "_bfhk3uhp",
    'bg.subtle.default': "_bfhksm61",
    'bg.subtle.inprogress': "_bfhksm61",
    'bg.subtle.moved': "_bfhksm61",
    'bg.subtle.new': "_bfhksm61",
    'bg.subtle.removed': "_bfhksm61",
    'bg.subtle.success': "_bfhksm61",
    'outline.subtle.default': "_12ji14je _1qu2nqa1 _12y3t94y",
    'outline.subtle.inprogress': "_12jiuisw _1qu2nqa1 _12y3t94y",
    'outline.subtle.moved': "_12jih727 _1qu2nqa1 _12y3t94y",
    'outline.subtle.new': "_12ji157s _1qu2nqa1 _12y3t94y",
    'outline.subtle.removed': "_12jia2c0 _1qu2nqa1 _12y3t94y",
    'outline.subtle.success': "_12jin0nx _1qu2nqa1 _12y3t94y",
    'text.subtle': "_syazi7uo",
    'text.bold': "_syazwwip"
};
const $37045b89715691c9$var$appearanceTypes = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed'
];
const $37045b89715691c9$var$newSemanticColors = [
    'success',
    'discovery',
    'warning',
    'danger',
    'information',
    'neutral'
];
const $37045b89715691c9$var$appearanceMapping = {
    neutral: 'default',
    default: 'default',
    information: 'inprogress',
    inprogress: 'inprogress',
    warning: 'moved',
    moved: 'moved',
    removed: 'removed',
    danger: 'removed',
    success: 'success',
    discovery: 'new',
    new: 'new'
};
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ const $37045b89715691c9$var$LegacyLozenge = /*#__PURE__*/ (0, $4tluv.memo)(({ children: children, testId: testId, isBold: isBold = false, appearance: appearance = 'default', maxWidth: maxWidth = 200, style: style })=>{
    const appearanceStyle = isBold ? 'bold' : 'subtle';
    const appearanceType = (0, $4tluv.useMemo)(()=>$37045b89715691c9$var$appearanceTypes.includes(appearance) || $37045b89715691c9$var$newSemanticColors.includes(appearance) ? $37045b89715691c9$var$appearanceMapping[appearance] : 'default', [
        appearance
    ]);
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    return /*#__PURE__*/ (0, $2iln5.jsx)("span", {
        style: {
            backgroundColor: style?.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        "data-testid": testId,
        className: (0, $jAkMr.default)([
            $37045b89715691c9$var$styles.container,
            $37045b89715691c9$var$styles[`bg.${appearanceStyle}.${appearanceType}`],
            appearanceStyle === 'subtle' && $37045b89715691c9$var$styles[`outline.subtle.${appearanceType}`],
            appearanceStyle === 'subtle' && $37045b89715691c9$var$styles.containerSubtle
        ]),
        children: /*#__PURE__*/ (0, $2iln5.jsx)("span", {
            style: {
                color: style?.color,
                // to negate paddingInline specified on Box above
                maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
            },
            "data-testid": testId && `${testId}--text`,
            className: (0, $jAkMr.default)([
                $37045b89715691c9$var$styles.text,
                (0, $3X3Vo.fg)('platform-lozenge-custom-letterspacing') && $37045b89715691c9$var$styles.customLetterspacing,
                $37045b89715691c9$var$styles[`text.${appearanceStyle}`]
            ]),
            children: children
        })
    });
});
$37045b89715691c9$var$LegacyLozenge.displayName = 'Lozenge';
/**
 * Wrapper component that switches between old and new Lozenge based on feature flag
 */ const $37045b89715691c9$var$LozengeWrapper = /*#__PURE__*/ (0, $4tluv.memo)((props)=>{
    if ((0, $3X3Vo.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) return /*#__PURE__*/ (0, $2iln5.jsx)((0, $6PU1e.default), {
        ...props
    });
    return /*#__PURE__*/ (0, $2iln5.jsx)($37045b89715691c9$var$LegacyLozenge, {
        ...props
    });
});
$37045b89715691c9$var$LozengeWrapper.displayName = 'Lozenge';
var $37045b89715691c9$export$2e2bcd8739ae039 = $37045b89715691c9$var$LozengeWrapper;

});
parcelRegister("6PU1e", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc3ae34c324ca80b$export$2e2bcd8739ae039);
/* lozenge.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $eTtxG = parcelRequire("eTtxG");
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ const $dc3ae34c324ca80b$var$Lozenge = ({ appearance: appearance = 'neutral', spacing: spacing = 'default', maxWidth: maxWidth = 200, style: style, testId: testId, children: children, iconBefore: iconBefore, trailingMetric: trailingMetric, trailingMetricAppearance: trailingMetricAppearance })=>{
    const baseProps = {
        appearance: appearance,
        spacing: spacing,
        iconBefore: iconBefore,
        trailingMetric: trailingMetric,
        trailingMetricAppearance: trailingMetricAppearance,
        maxWidth: maxWidth,
        style: style,
        testId: testId,
        children: children
    };
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $eTtxG.default), {
        ...baseProps,
        children: children
    });
};
$dc3ae34c324ca80b$var$Lozenge.displayName = 'Lozenge';
var $dc3ae34c324ca80b$export$2e2bcd8739ae039 = $dc3ae34c324ca80b$var$Lozenge;

});
parcelRegister("eTtxG", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f7f23ea55911db9$export$2e2bcd8739ae039);
/* lozenge-base.tsx generated by @compiled/babel-plugin v0.36.1 */ /* lozenge-base.tsx generated by @compiled/babel-plugin v0.36.1 */ /* lozenge-base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");

var $gVju6 = parcelRequire("gVju6");

var $klNPa = parcelRequire("klNPa");

var $l6Otc = parcelRequire("l6Otc");

var $fzpPQ = parcelRequire("fzpPQ");

var $3X3Vo = parcelRequire("3X3Vo");

var $2Yh1Z = parcelRequire("2Yh1Z");

var $jJcBA = parcelRequire("jJcBA");

var $enuUm = parcelRequire("enuUm");

var $5Okr7 = parcelRequire("5Okr7");

var $ccVJ3 = parcelRequire("ccVJ3");
// Get the pressed background color for the selected lozenge dropdown trigger
const $9f7f23ea55911db9$var$pressedBackgroundMapping = {
    success: "var(--ds-background-success-subtler-pressed, #B3DF72)",
    warning: "var(--ds-background-warning-subtler-pressed, #FBC828)",
    danger: "var(--ds-background-danger-subtler-pressed, #FD9891)",
    information: "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    neutral: "var(--ds-background-neutral-pressed, #080F214A)",
    discovery: "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'accent-red': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'accent-orange': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'accent-yellow': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'accent-lime': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'accent-green': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'accent-teal': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'accent-blue': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'accent-purple': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'accent-magenta': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'accent-gray': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
};
const $9f7f23ea55911db9$var$styles = {
    container: "_2rko12b0 _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1j28 _kqswh2mm _1e0c116y _4cvr1h6o _vchhusvi _4t3i1k92 _1q51v77o _85i5v77o _bozg1b66 _y4ti1b66",
    motionContainer: "_k8m01rje _1oeci9qs _6fl41d08",
    containerSpacious: "_2rko1qi0 _1tkeviql _1q511b66 _85i51b66 _bozgutpp _y4tiutpp",
    containerBadgePadding: "_y4ti303w",
    text: "_11c8wadc _1reo15vq _18m915vq _o5721q9c",
    textEllipsis: "_1bto1l2s",
    textClip: "_1btozryt",
    textSpacious: "_11c8fhey _k48p1wq8",
    textSelected: "_syaz6x5g",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw",
    metricBadgeWrapper: "_1e0c1txw",
    'metric.semantic.success': "_1bn8d6jc _4ayg1wl5",
    'metric.semantic.warning': "_1bn8bkku _4aygzr32",
    'metric.semantic.danger': "_1bn8jkmi _4ayg1r4b",
    'metric.semantic.information': "_1bn8ar1y _4ayg1c1j",
    'metric.semantic.neutral': "_1bn814je _4ayg1fkg _iymy8hz0 _16burnys",
    'metric.semantic.discovery': "_1bn85usi _4ayg18vq",
    'metric.inverse': "_1bn8vuon _4aygvuon",
    'semantic.success': "_1b3i4pcx _3wu01mps _bfhk14j0 _syaz1p1e",
    'semantic.warning': "_1b3iervl _3wu01xiv _bfhk10f4 _syazmgs1",
    'semantic.danger': "_1b3is4qr _3wu01bqt _bfhk18wg _syaz1blx",
    'semantic.information': "_1b3iyhbg _3wu0vbh5 _bfhk8lbg _syaz1qd9",
    'semantic.neutral': "_1b3i1cv2 _3wu01ihb _bfhki8nm _syazi7uo",
    'semantic.discovery': "_1b3iqm1h _3wu0v30g _bfhke670 _syaz1g72",
    'accent.red': "_1b3inbxb _3wu016y8 _bfhk1rtt _syazhwvp",
    'accent.orange': "_1b3i1j6y _3wu01b2s _bfhk165s _syaz7i1p",
    'accent.yellow': "_1b3i1oqg _3wu0feiv _bfhk1773 _syazekll",
    'accent.lime': "_1b3i8645 _3wu0nf89 _bfhkz2ec _syaz1ik3",
    'accent.green': "_1b3i17hp _3wu01crs _bfhk1wnw _syaz1y78",
    'accent.teal': "_1b3i8uof _3wu01h3o _bfhk1a17 _syaz12v7",
    'accent.blue': "_1b3i6txe _3wu01w55 _bfhk1dy8 _syaz1kyx",
    'accent.purple': "_1b3iuq3u _3wu01hqq _bfhk1nm4 _syaz1mn1",
    'accent.magenta': "_1b3iv8hk _3wu0uwd0 _bfhkv9ra _syaz1qur",
    'accent.gray': "_1b3i1diz _3wu08yml _bfhkysee _syaz1tmo",
    'interactive.semantic.success': "_irr31r82 _1di6d6jc",
    'interactive.semantic.warning': "_irr31yx4 _1di6bkku",
    'interactive.semantic.danger': "_irr370oi _1di6jkmi",
    'interactive.semantic.information': "_irr315aw _1di6ar1y",
    'interactive.semantic.neutral': "_irr3plhp _1di61gdz",
    'interactive.semantic.discovery': "_irr3rumk _1di65usi",
    'interactive.accent.red': "_irr3affd _1di61j5a",
    'interactive.accent.orange': "_irr31ei0 _1di6dpo3",
    'interactive.accent.yellow': "_irr31uw7 _1di61r9w",
    'interactive.accent.lime': "_irr31gf0 _1di62kxc",
    'interactive.accent.green': "_irr31e2h _1di6ybhx",
    'interactive.accent.teal': "_irr3kwwr _1di61jb0",
    'interactive.accent.blue': "_irr3815t _1di6rwxf",
    'interactive.accent.purple': "_irr3attl _1di63nfk",
    'interactive.accent.magenta': "_irr31axx _1di642ri",
    'interactive.accent.gray': "_irr3wejn _1di618ut",
    iconBorderFilter: "_1h6dzs9d _4uq11yqs _1k671038 _m71tr3uz _13muu67f _168qx19p _oe6mmko7 _189qkb7n _u8p61h4e _1t75u67f _hg5mr3uz _1f28f1ug _1xe213rw _1easxmrh _1r9r1ss3",
    iconBorderInteractiveFilter: "_1iel6xdd _111i1h4e _18dicjiy _hyog26zw _fdt01r5k _46v5hwvj _ylgq1r5k _bg3q9by0 _196p1btq _18mn783i _l0666xdd _pclnn8xv _ockq1r5k _aewt1n8h _4cvx7ddx _1cp21w66 _q4zt1csi _1gqs1mvc _75gv2l9f _1lh71sfd _ui3h1ct7 _11o31cha",
    containerSelected: "_1xe213kw",
    content: "_zulp1b66 _1e0c116y _4cvr1h6o",
    contentSpacious: "_zulp12x7",
    loadingContent: "_tzy4idpf",
    containerBadge: "_1ftrbpke",
    containerBadgeInteractive: "_1axm1bqy"
};
/**
 * __New Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 * This is the updated version with the new North Star visual language.
 */ const $9f7f23ea55911db9$var$LozengeBase = /*#__PURE__*/ (0, $4tluv.memo)(/*#__PURE__*/ (0, $4tluv.forwardRef)(({ children: children, testId: testId, appearance: appearance, iconBefore: iconBefore, trailingMetric: trailingMetric, trailingMetricAppearance: trailingMetricAppearance, maxWidth: maxWidth = 200, spacing: spacing = 'default', isSelected: isSelected, isLoading: // for dropdown trigger
isLoading = false, onClick: // for dropdown trigger
onClick, style: // for dropdown trigger
style, analyticsContext: analyticsContext, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, 'aria-label': ariaLabel }, ref)=>{
    const [resizing, setResizing] = (0, $4tluv.useState)(false);
    const onFinishMotion = ()=>setResizing(false);
    const resizingWidth = (0, $fzpPQ.useResizing)({
        dimension: 'width',
        duration: "var(--ds-duration-medium, 200ms)",
        easing: "var(--ds-easing-inout-bold, cubic-bezier(0.4, 0, 0, 1))",
        onFinishMotion: onFinishMotion
    });
    const isInitialRender = (0, $4tluv.useRef)(true);
    const isInteractive = typeof onClick === 'function';
    // Determine the effective color, with fallback logic for legacy appearances
    const resolvedColor = (0, $ccVJ3.resolveLozengeColor)(appearance) || 'neutral';
    const { category: category, key: key } = (0, $enuUm.getThemeStyles)(resolvedColor);
    const colorStyleKey = `${category}.${key}`;
    const interactiveStyleKey = `interactive.${category}.${key}`;
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && maxWidth.endsWith('%');
    const resolvedTrailingMetricAppearance = trailingMetricAppearance ? trailingMetricAppearance === 'inverse' ? 'inverse' : (0, $ccVJ3.resolveLozengeColor)(trailingMetricAppearance) : resolvedColor;
    const metricBadgeAppearance = resolvedTrailingMetricAppearance === 'inverse' ? 'inverse' : resolvedTrailingMetricAppearance != null && resolvedTrailingMetricAppearance.startsWith('accent-') ? 'neutral' : resolvedTrailingMetricAppearance ?? 'neutral';
    const metricStyleKey = resolvedTrailingMetricAppearance === 'inverse' ? 'metric.inverse' : resolvedTrailingMetricAppearance != null && !resolvedTrailingMetricAppearance.startsWith('accent-') ? `metric.semantic.${(0, $enuUm.getThemeStyles)(resolvedTrailingMetricAppearance).key}` : 'metric.semantic.neutral';
    const commonStyleOverrides = {
        backgroundColor: style?.backgroundColor,
        maxWidth: maxWidthIsPc ? maxWidth : '100%'
    };
    const hasTrailingMetric = trailingMetric != null && trailingMetric !== '';
    const childrenKey = typeof children === 'string' ? children : undefined;
    (0, $4tluv.useLayoutEffect)(()=>{
        // Ignore initial render
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        setResizing(true);
    }, [
        childrenKey
    ]);
    const enableMotionFG = (0, $3X3Vo.fg)('platform-dst-motion-uplift');
    const innerContent = /*#__PURE__*/ (0, $2iln5.jsxs)("span", {
        style: {
            // When maxWidth is a percentage, constrain the content wrapper
            // so text truncation works correctly within the flex layout
            maxWidth: maxWidthIsPc ? '100%' : undefined
        },
        ...enableMotionFG ? resizingWidth : undefined,
        className: (0, $jAkMr.default)([
            $9f7f23ea55911db9$var$styles.content,
            spacing === 'spacious' && $9f7f23ea55911db9$var$styles.contentSpacious,
            isLoading && $9f7f23ea55911db9$var$styles.loadingContent
        ]),
        children: [
            iconBefore && /*#__PURE__*/ (0, $2iln5.jsx)((0, $5Okr7.default), {
                size: spacing === 'spacious' ? 'medium' : 'small',
                icon: iconBefore,
                color: resolvedColor,
                testId: testId && `${testId}--icon`
            }),
            /*#__PURE__*/ (0, $2iln5.jsx)("span", {
                style: {
                    maxWidth: maxWidthIsPc ? undefined : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`,
                    color: style?.color
                },
                "data-testid": testId && `${testId}--text`,
                className: (0, $jAkMr.default)([
                    $9f7f23ea55911db9$var$styles.text,
                    enableMotionFG && resizing ? $9f7f23ea55911db9$var$styles.textClip : $9f7f23ea55911db9$var$styles.textEllipsis,
                    spacing === 'spacious' && $9f7f23ea55911db9$var$styles.textSpacious
                ]),
                children: children
            }),
            hasTrailingMetric && !resolvedColor.startsWith('accent-') && /*#__PURE__*/ (0, $2iln5.jsx)("span", {
                "data-lozenge-metric-wrapper": true,
                "data-testid": testId && `${testId}--metric`,
                className: (0, $jAkMr.default)([
                    $9f7f23ea55911db9$var$styles.metricBadgeWrapper
                ]),
                children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $gVju6.default), {
                    appearance: metricBadgeAppearance,
                    children: trailingMetric
                })
            }),
            isInteractive && /*#__PURE__*/ (0, $2iln5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l6Otc))), {
                label: "",
                size: "small",
                color: 'currentColor',
                testId: testId && `${testId}--chevron`
            })
        ]
    });
    if (isInteractive) return /*#__PURE__*/ (0, $2iln5.jsxs)((0, $2Yh1Z.default), {
        ref: ref,
        xcss: (0, $klNPa.cx)($9f7f23ea55911db9$var$styles.container, (0, $3X3Vo.fg)('platform-dst-motion-uplift') && $9f7f23ea55911db9$var$styles.motionContainer, spacing === 'spacious' && $9f7f23ea55911db9$var$styles.containerSpacious, !isSelected && $9f7f23ea55911db9$var$styles.iconBorderFilter, !isLoading && $9f7f23ea55911db9$var$styles.iconBorderInteractiveFilter, $9f7f23ea55911db9$var$styles[colorStyleKey], !isLoading && $9f7f23ea55911db9$var$styles[interactiveStyleKey], isSelected && $9f7f23ea55911db9$var$styles.containerSelected, hasTrailingMetric && $9f7f23ea55911db9$var$styles.containerBadge, hasTrailingMetric && $9f7f23ea55911db9$var$styles.containerBadgeInteractive, hasTrailingMetric && $9f7f23ea55911db9$var$styles[metricStyleKey]),
        ...isLoading && {
            'aria-busy': true,
            'aria-disabled': true,
            isDisabled: true
        },
        "aria-label": isLoading ? 'Loading' : ariaLabel,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        onClick: isLoading ? undefined : onClick,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...commonStyleOverrides,
            // Specified because Pressable has a default border:none which overrides the border specified on the container
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            border: `solid ${"var(--ds-border-width, 1px)"} ${isSelected ? 'oklch(from var(--border-color) calc(l * var(--border-pressed-l-factor)) c h) !important' : 'transparent'}`,
            backgroundColor: isSelected ? $9f7f23ea55911db9$var$pressedBackgroundMapping[resolvedColor] : undefined,
            cursor: isLoading ? 'progress' : 'pointer'
        },
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LozengeDropdownTrigger",
        children: [
            innerContent,
            isLoading && /*#__PURE__*/ (0, $2iln5.jsx)("span", {
                className: (0, $jAkMr.default)([
                    $9f7f23ea55911db9$var$styles.loadingOverlay
                ]),
                children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $jJcBA.default), {
                    size: spacing === 'spacious' ? 'small' : 'xsmall',
                    label: ", Loading",
                    testId: testId ? `${testId}--loading-spinner` : undefined
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $2iln5.jsx)("span", {
        ref: ref,
        style: commonStyleOverrides,
        "data-testid": testId,
        className: (0, $jAkMr.default)([
            $9f7f23ea55911db9$var$styles.container,
            spacing === 'spacious' && $9f7f23ea55911db9$var$styles.containerSpacious,
            spacing !== 'spacious' && hasTrailingMetric && $9f7f23ea55911db9$var$styles.containerBadgePadding,
            $9f7f23ea55911db9$var$styles[colorStyleKey],
            hasTrailingMetric && $9f7f23ea55911db9$var$styles[metricStyleKey],
            $9f7f23ea55911db9$var$styles.iconBorderFilter,
            $9f7f23ea55911db9$var$styles.containerBadge
        ]),
        children: innerContent
    });
}));
var $9f7f23ea55911db9$export$2e2bcd8739ae039 = $9f7f23ea55911db9$var$LozengeBase;

});
parcelRegister("gVju6", function(module, exports) {
$parcel$export(module.exports, "default", () => $53d8dc0136782469$export$2e2bcd8739ae039);
/* badge.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");

var $3X3Vo = parcelRequire("3X3Vo");

var $bZmu5 = parcelRequire("bZmu5");

var $eWNbg = parcelRequire("eWNbg");

var $3tIej = parcelRequire("3tIej");

var $cIoX1 = parcelRequire("cIoX1");

var $d0n7L = parcelRequire("d0n7L");
/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they will be updated in the labelling system work and we want to avoid frequent UI changes.\
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ const $53d8dc0136782469$var$neutral300 = '#DDDEE1';
const $53d8dc0136782469$var$red300 = '#FD9891';
const $53d8dc0136782469$var$blue300 = '#8FB8F6';
const $53d8dc0136782469$var$neutral1000 = '#292A2E';
const $53d8dc0136782469$var$styles = {
    root: "_2rkolb4i _18zr1b66 _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    added: "_bfhk1y9u _syazi7uo",
    default: "_bfhk1fkg _syazwwip",
    important: "_bfhk1366 _syazwwip",
    primary: "_bfhk1ymo _syazwwip",
    primaryInverted: "_bfhkvuon _syaz1oa5",
    removed: "_bfhk1gly _syazi7uo"
};
const $53d8dc0136782469$var$badgeValueWithNegativeNumberSupported = (children, max)=>{
    return typeof children === 'number' && typeof max === 'number' ? (0, $d0n7L.formatValueWithNegativeSupport)(children, max) : children;
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ const $53d8dc0136782469$var$Badge = /*#__PURE__*/ (0, $4tluv.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    if ((0, $3X3Vo.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        // Map old appearance names to new ones
        const newAppearance = (0, $eWNbg.appearanceMapping)[appearance];
        return /*#__PURE__*/ (0, $2iln5.jsx)((0, $cIoX1.default), {
            appearance: newAppearance,
            max: max,
            style: style,
            testId: testId,
            children: children
        });
    }
    const oldAppearance = (0, $3tIej.appearanceMappingToOld)[appearance];
    return /*#__PURE__*/ (0, $2iln5.jsx)("span", {
        "data-testid": testId,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        className: (0, $jAkMr.default)([
            $53d8dc0136782469$var$styles.root,
            $53d8dc0136782469$var$styles[oldAppearance]
        ]),
        children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $bZmu5.default), {
            size: "small",
            align: "center",
            color: "inherit",
            children: $53d8dc0136782469$var$badgeValueWithNegativeNumberSupported(children, max)
        })
    });
});
var $53d8dc0136782469$export$2e2bcd8739ae039 = $53d8dc0136782469$var$Badge;

});
parcelRegister("eWNbg", function(module, exports) {
$parcel$export(module.exports, "appearanceMapping", () => $768d5f6f4d640dad$export$d21bba0569254935);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $768d5f6f4d640dad$export$d21bba0569254935 = {
    added: 'success',
    removed: 'danger',
    default: 'neutral',
    primary: 'information',
    primaryInverted: 'inverse',
    important: 'danger',
    warning: 'warning',
    discovery: 'discovery',
    danger: 'danger',
    success: 'success',
    information: 'information',
    inverse: 'inverse',
    neutral: 'neutral'
};

});

parcelRegister("3tIej", function(module, exports) {
$parcel$export(module.exports, "appearanceMappingToOld", () => $972563f12f684122$export$16f8cc7ac3541e83);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $972563f12f684122$export$16f8cc7ac3541e83 = {
    added: 'added',
    removed: 'removed',
    default: 'default',
    primary: 'primary',
    primaryInverted: 'primaryInverted',
    important: 'important',
    danger: 'removed',
    success: 'added',
    information: 'primary',
    inverse: 'primaryInverted',
    neutral: 'default',
    warning: 'default',
    discovery: 'default'
};

});

parcelRegister("cIoX1", function(module, exports) {
$parcel$export(module.exports, "default", () => $40b6a5792df1a6dd$export$2e2bcd8739ae039);
/* badge-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");

var $bZmu5 = parcelRequire("bZmu5");

var $6jUF7 = parcelRequire("6jUF7");
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ // Nested selectors with data attributes are required for theme switching
const $40b6a5792df1a6dd$var$stylesNew = {
    root: "_2rkolb4i _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    success: "_syaz1p1e _bfhk14j0",
    danger: "_syaz1blx _bfhk18wg",
    warning: "_syazmgs1 _bfhk10f4",
    information: "_syaz1qd9 _bfhk8lbg",
    discovery: "_syaz1g72 _bfhke670",
    neutral: "_syazi7uo _bfhk7qp0",
    inverse: "_bfhkvuon _syazi7uo"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ const $40b6a5792df1a6dd$var$badgeValueWithNegativeNumberSupported = (children, max)=>{
    return typeof children === 'number' && max ? (0, $6jUF7.formatValue)(children, max) : children;
};
/**
 * __BadgeNew__
 *
 * New visual refresh implementation of Badge component for the labelling system.
 * This component is used when the 'platform-dst-lozenge-tag-badge-visual-uplifts' feature flag is enabled.
 *
 * Uses new appearance naming convention:
 * - success (green)
 * - danger (red)
 * - neutral (gray)
 * - information (blue)
 * - inverse (inverted colors)
 * - warning (orange/yellow)
 * - discovery (purple)
 */ const $40b6a5792df1a6dd$var$BadgeNew = /*#__PURE__*/ (0, $4tluv.memo)(function BadgeNew({ appearance: appearance = 'neutral', children: children = 0, max: max = 99, style: style, testId: testId }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)("span", {
        "data-testid": testId,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        className: (0, $jAkMr.default)([
            $40b6a5792df1a6dd$var$stylesNew.root,
            $40b6a5792df1a6dd$var$stylesNew[appearance]
        ]),
        children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $bZmu5.default), {
            size: "small",
            align: "center",
            color: "inherit",
            children: $40b6a5792df1a6dd$var$badgeValueWithNegativeNumberSupported(children, max)
        })
    });
});
var $40b6a5792df1a6dd$export$2e2bcd8739ae039 = $40b6a5792df1a6dd$var$BadgeNew;

});
parcelRegister("6jUF7", function(module, exports) {
$parcel$export(module.exports, "formatValue", () => $1f4714657958da3d$export$7c4d25c0c3217d8c);
function $1f4714657958da3d$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $1f4714657958da3d$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $1f4714657958da3d$var$getSafeValue(value);
    const safeMax = $1f4714657958da3d$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("d0n7L", function(module, exports) {
$parcel$export(module.exports, "formatValueWithNegativeSupport", () => $cfeb546a3247d864$export$4b844743568d5983);
function $cfeb546a3247d864$var$getSafeValueWithNegativeSupport(value = 0) {
    const numericValue = +value;
    // NOTE: Changing below code as this causes custom fields -ve number to show up as zero in activity timeline.
    // This will ensure it renders correctly if it is a number otherwise renders 0
    // If the value is NaN, return it as is (assuming it's a non-numeric string)
    if (isNaN(numericValue)) return value;
    // Return the numeric value, allowing negative numbers
    return numericValue;
}
function $cfeb546a3247d864$export$4b844743568d5983(value, max) {
    const safeValue = $cfeb546a3247d864$var$getSafeValueWithNegativeSupport(value);
    const safeMax = $cfeb546a3247d864$var$getSafeValueWithNegativeSupport(max);
    let hasSafeMaxValue = false;
    if (max !== undefined) hasSafeMaxValue = true;
    if (safeMax === Infinity && safeValue === Infinity) return "\u221E";
    if (hasSafeMaxValue && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("fzpPQ", function(module, exports) {
$parcel$export(module.exports, "useResizing", () => $e0109cbdbcb536f8$export$a300664a1a230956);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $cGlqj = parcelRequire("cGlqj");

var $504fE = parcelRequire("504fE");

var $4V5j2 = parcelRequire("4V5j2");

var $eeuEd = parcelRequire("eeuEd");

var $2DgUK = parcelRequire("2DgUK");
/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $e0109cbdbcb536f8$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $e0109cbdbcb536f8$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $e0109cbdbcb536f8$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
const $e0109cbdbcb536f8$export$a300664a1a230956 = ({ dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion })=>{
    const prevDimensions = (0, $4tluv.useRef)();
    const [element, setElementRef] = (0, $4V5j2.useElementRef)();
    const setTimeout = (0, $504fE.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $504fE.useRequestAnimationFrame)();
    (0, $2DgUK.useSnapshotBeforeUpdate)(()=>{
        if ((0, $cGlqj.isReducedMotion)() || !element) return;
        const rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $eeuEd.useLayoutEffect)(()=>{
        if ((0, $cGlqj.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        const rect = element.getBoundingClientRect();
        const nextDimensions = {
            width: rect.width,
            height: rect.height
        };
        if (!$e0109cbdbcb536f8$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion?.();
            return;
        }
        const propertyList = $e0109cbdbcb536f8$var$getDimensionPropertyList(dimension);
        const newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = `${prevDimensions.current.width}px`;
        if (dimension === 'height' || dimension === 'both') newStyles.height = `${prevDimensions.current.height}px`;
        Object.assign(element.style, newStyles);
        const resolvedDuration = $e0109cbdbcb536f8$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = `${nextDimensions.width}px`;
                if (dimension === 'height' || dimension === 'both') element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion?.();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
const $e0109cbdbcb536f8$export$9942248a1ae255c2 = ({ children: children, ...props })=>{
    const resizing = $e0109cbdbcb536f8$export$a300664a1a230956(props);
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $2iln5.Fragment), {
        children: children(resizing)
    });
};

});
parcelRegister("4V5j2", function(module, exports) {
$parcel$export(module.exports, "useElementRef", () => $25bf9a03c4a3fda5$export$ff879f35a69d56b7);

var $4tluv = parcelRequire("4tluv");
const $25bf9a03c4a3fda5$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $4tluv.useRef)(null);
    const setRef = (0, $4tluv.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});

parcelRegister("2DgUK", function(module, exports) {
$parcel$export(module.exports, "useSnapshotBeforeUpdate", () => $896bc049196d6deb$export$9e95200239cd148b);

var $4tluv = parcelRequire("4tluv");

var $eeuEd = parcelRequire("eeuEd");
const $896bc049196d6deb$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $4tluv.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $eeuEd.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};

});


parcelRegister("2Yh1Z", function(module, exports) {
$parcel$export(module.exports, "default", () => $050d17160ce68b38$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4tluv = parcelRequire("4tluv");

var $ft5N0 = parcelRequire("ft5N0");

var $wYkfM = parcelRequire("wYkfM");

var $ccErM = parcelRequire("ccErM");

var $cDSkE = parcelRequire("cDSkE");

var $dpQkd = parcelRequire("dpQkd");

var $kfPot = parcelRequire("kfPot");
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
const $050d17160ce68b38$var$focusRingStyles = (0, $ft5N0.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $dpQkd.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $dpQkd.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $dpQkd.borderWidthMap)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: `${(0, $dpQkd.borderWidthMap)['border.width']} solid`
        }
    }
});
const $050d17160ce68b38$var$baseStyles = (0, $ft5N0.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});
const $050d17160ce68b38$var$enabledStyles = (0, $ft5N0.css)({
    cursor: 'pointer'
});
const $050d17160ce68b38$var$disabledStyles = (0, $ft5N0.css)({
    cursor: 'not-allowed'
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ const $050d17160ce68b38$var$Pressable = /*#__PURE__*/ (0, $4tluv.forwardRef)(({ children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $ccErM.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $4tluv.useContext)((0, $cDSkE.default));
    const handleClick = (0, $4tluv.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $wYkfM.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $kfPot.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $ft5N0.jsx)("button", {
        style: style,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $050d17160ce68b38$var$baseStyles,
            $050d17160ce68b38$var$focusRingStyles,
            isDisabled ? $050d17160ce68b38$var$disabledStyles : $050d17160ce68b38$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $dpQkd.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $dpQkd.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $dpQkd.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $dpQkd.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $dpQkd.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $dpQkd.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $dpQkd.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $dpQkd.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId
    }, children);
});
var $050d17160ce68b38$export$2e2bcd8739ae039 = $050d17160ce68b38$var$Pressable;

});

parcelRegister("enuUm", function(module, exports) {
$parcel$export(module.exports, "getThemeStyles", () => $38e9d7c06592e7ca$export$a3fc04b8551e006a);
const $38e9d7c06592e7ca$export$a3fc04b8551e006a = (resolvedColor)=>{
    const isAccent = resolvedColor.startsWith('accent-');
    const category = isAccent ? 'accent' : 'semantic';
    const key = isAccent ? resolvedColor.replace('accent-', '') : resolvedColor;
    return {
        category: category,
        key: key
    };
};

});

parcelRegister("5Okr7", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ca4e5fbef9ae4b9$export$2e2bcd8739ae039);
/* icon-renderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $3X3Vo = parcelRequire("3X3Vo");

var $fYX4U = parcelRequire("fYX4U");
// Map lozenge colors to appropriate icon colors
const $6ca4e5fbef9ae4b9$var$getIconColor = (color)=>{
    // For semantic colors, use corresponding semantic icon colors
    switch(color){
        case 'success':
            return "var(--ds-icon-success, #6A9A23)";
        case 'warning':
            return "var(--ds-icon-warning, #E06C00)";
        case 'danger':
            return "var(--ds-icon-danger, #C9372C)";
        case 'information':
            return "var(--ds-icon-information, #357DE8)";
        case 'neutral':
            return "var(--ds-icon-subtlest, #6B6E76)";
        case 'discovery':
            return "var(--ds-icon-discovery, #AF59E1)";
        // For accent colors, use corresponding accent icon colors
        case 'accent-red':
            return "var(--ds-icon-accent-red, #C9372C)";
        case 'accent-orange':
            return "var(--ds-icon-accent-orange, #E06C00)";
        case 'accent-yellow':
            return "var(--ds-icon-accent-yellow, #B38600)";
        case 'accent-lime':
            return "var(--ds-icon-accent-lime, #6A9A23)";
        case 'accent-green':
            return "var(--ds-icon-accent-green, #22A06B)";
        case 'accent-teal':
            return "var(--ds-icon-accent-teal, #2898BD)";
        case 'accent-blue':
            return "var(--ds-icon-accent-blue, #357DE8)";
        case 'accent-purple':
            return "var(--ds-icon-accent-purple, #AF59E1)";
        case 'accent-magenta':
            return "var(--ds-icon-accent-magenta, #CD519D)";
        case 'accent-gray':
            return "var(--ds-icon-accent-gray, #7D818A)";
        default:
            return "var(--ds-icon-subtlest, #6B6E76)";
    }
};
const $6ca4e5fbef9ae4b9$var$styles = {
    motion: "_k8m01ylx _1oeci9qs _6fl41d08"
};
const $6ca4e5fbef9ae4b9$export$32ff197eed95e568 = ({ icon: Icon, color: color, testId: testId, size: size })=>{
    const iconColor = $6ca4e5fbef9ae4b9$var$getIconColor(color);
    return (0, $3X3Vo.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, $2iln5.jsx)((0, $fYX4U.default), {
        xcss: $6ca4e5fbef9ae4b9$var$styles.motion,
        style: {
            color: iconColor
        },
        children: /*#__PURE__*/ (0, $2iln5.jsx)(Icon, {
            label: "",
            size: size,
            testId: testId
        })
    }) : /*#__PURE__*/ (0, $2iln5.jsx)(Icon, {
        color: iconColor,
        label: "",
        size: size,
        testId: testId
    });
};
var $6ca4e5fbef9ae4b9$export$2e2bcd8739ae039 = $6ca4e5fbef9ae4b9$export$32ff197eed95e568;

});

parcelRegister("ccVJ3", function(module, exports) {
$parcel$export(module.exports, "resolveLozengeColor", () => $5846ea328b4eef56$export$acf5d2b7dc999bda);

// Map legacy appearance to new color values
const $5846ea328b4eef56$var$legacyAppearanceMap = {
    default: 'neutral',
    removed: 'danger',
    inprogress: 'information',
    new: 'discovery',
    moved: 'warning'
};
const $5846ea328b4eef56$export$acf5d2b7dc999bda = (appearance = 'neutral')=>{
    if (appearance.startsWith('accent-')) return appearance;
    return $5846ea328b4eef56$var$legacyAppearanceMap[appearance] ?? appearance;
};

});




parcelRegister("202P8", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba70ee927b3f6f20$export$2e2bcd8739ae039);
/* field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $jAkMr = parcelRequire("jAkMr");

var $4tluv = parcelRequire("4tluv");

var $fEY94 = parcelRequire("fEY94");

var $8hnzA = parcelRequire("8hnzA");

var $kUEnn = parcelRequire("kUEnn");

var $4cGYf = parcelRequire("4cGYf");

var $eYOIg = parcelRequire("eYOIg");

var $3PrKC = parcelRequire("3PrKC");

var $2fQ8J = parcelRequire("2fQ8J");
const $ba70ee927b3f6f20$var$fieldWrapperStyles = null;
function $ba70ee927b3f6f20$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $ba70ee927b3f6f20$var$isFunction(x) {
    return typeof x === 'function';
}
function $ba70ee927b3f6f20$var$usePreviousRef(current) {
    const ref = (0, $4tluv.useRef)(current);
    // will be updated on the next render
    (0, $4tluv.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $ba70ee927b3f6f20$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $ba70ee927b3f6f20$export$2e2bcd8739ae039(props) {
    const { children: children = ()=>null, component: component } = props;
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $4tluv.useContext)((0, $kUEnn.FormContext));
    const isDisabled = (0, $4tluv.useContext)((0, $4cGYf.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $ba70ee927b3f6f20$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $ba70ee927b3f6f20$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$ba70ee927b3f6f20$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $4tluv.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explicitly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $ba70ee927b3f6f20$var$usePreviousRef(state);
    (0, $4tluv.useEffect)(()=>{
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $ba70ee927b3f6f20$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($ba70ee927b3f6f20$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                    return;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        props.isRequired,
        isDefaultValueChanged
    ]);
    const uid = (0, $fEY94.useId)();
    const fieldId = (0, $4tluv.useMemo)(()=>{
        return props.id ? props.id : `${props.name}-${uid}`;
    }, [
        props.id,
        props.name,
        uid
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-required': String(Boolean(props.isRequired)),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $2iln5.jsxs)("div", {
        "data-testid": props.testId,
        className: (0, $jAkMr.default)([
            "_1pfhu2gc"
        ]),
        children: [
            props.label && /*#__PURE__*/ (0, $2iln5.jsxs)((0, $eYOIg.Label), {
                htmlFor: fieldId,
                id: `${fieldId}-label`,
                testId: props.testId && `${props.testId}--label`,
                children: [
                    props.label,
                    props.isRequired && /*#__PURE__*/ (0, $2iln5.jsx)((0, $2fQ8J.default), {}),
                    props.elementAfterLabel
                ]
            }),
            /*#__PURE__*/ (0, $2iln5.jsx)((0, $8hnzA.FieldId).Provider, {
                value: fieldId,
                children: component ? /*#__PURE__*/ (0, $2iln5.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).Fragment, {
                    children: [
                        component({
                            fieldProps: extendedFieldProps
                        }),
                        /*#__PURE__*/ (0, $2iln5.jsxs)((0, $3PrKC.MessageWrapper), {
                            children: [
                                props.helperMessage && /*#__PURE__*/ (0, $2iln5.jsx)((0, $3PrKC.HelperMessage), {
                                    children: props.helperMessage
                                }),
                                state.error && /*#__PURE__*/ (0, $2iln5.jsx)((0, $3PrKC.ErrorMessage), {
                                    children: props.errorMessage || state.error
                                }),
                                state.meta.touched && state.valid && props.validMessage && /*#__PURE__*/ (0, $2iln5.jsx)((0, $3PrKC.ValidMessage), {
                                    children: props.validMessage
                                })
                            ]
                        })
                    ]
                }) : children({
                    fieldProps: extendedFieldProps,
                    error: state.error,
                    valid: state.valid,
                    meta: state.meta
                })
            })
        ]
    });
}

});
parcelRegister("8hnzA", function(module, exports) {
$parcel$export(module.exports, "FieldId", () => $b7b8438deaccb41b$export$3c4232819458a302);

var $4tluv = parcelRequire("4tluv");
const $b7b8438deaccb41b$export$3c4232819458a302 = /*#__PURE__*/ (0, $4tluv.createContext)(undefined);

});

parcelRegister("kUEnn", function(module, exports) {
$parcel$export(module.exports, "FormContext", () => $37628cef49c97b3a$export$c24727297075ec6a);
$parcel$export(module.exports, "default", () => $37628cef49c97b3a$export$2e2bcd8739ae039);
/* form.tsx generated by @compiled/babel-plugin v0.36.1 */ /* form.tsx generated by @compiled/babel-plugin v0.36.1 */ /* form.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $f6jDN = parcelRequire("f6jDN");

var $ifZ00 = parcelRequire("ifZ00");

var $jxVML = parcelRequire("jxVML");

var $72Jxx = parcelRequire("72Jxx");

var $hHj16 = parcelRequire("hHj16");

var $4cGYf = parcelRequire("4cGYf");

var $3oe7X = parcelRequire("3oe7X");
const $37628cef49c97b3a$export$c24727297075ec6a = /*#__PURE__*/ (0, $4tluv.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $37628cef49c97b3a$var$FormBase = (props, ref)=>{
    const { autocomplete: autocomplete, formProps: userProvidedFormProps, id: id, label: label, labelId: labelId, name: name, noValidate: noValidate, onSubmit: onSubmit, testId: testId, xcss: xcss } = props;
    const formRef = (0, $4tluv.useRef)(null);
    const onSubmitRef = (0, $4tluv.useRef)(onSubmit);
    onSubmitRef.current = onSubmit;
    const [form] = (0, $4tluv.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $f6jDN.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        (0, (/*@__PURE__*/$parcel$interopDefault($jxVML)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($jxVML)))(values, name, value);
                    }
                }
            }
        });
        (0, $ifZ00.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [], (0, $3oe7X.getFirstErrorField))(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $4tluv.useState)({
        dirty: false,
        submitting: false
    });
    (0, $4tluv.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $4tluv.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
   * This method is needed in FormContext to use it on the field level
   * to check the current value of the field in case of the component re-mounting.
   */ const getCurrentValue = (0, $4tluv.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $4tluv.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    const conditionalFormProps = {
        autocomplete: autocomplete,
        className: xcss,
        id: id,
        'aria-label': label,
        'aria-labelledby': labelId,
        name: name,
        noValidate: noValidate,
        'data-testid': testId
    };
    // Abstracting so we can use the same for both rendering patterns
    const formProps = {
        onKeyDown: handleKeyDown,
        onSubmit: handleSubmit,
        ref: ref ? (0, $hHj16.default)([
            ref,
            formRef
        ]) : formRef
    };
    // We don't want to add undefined values to the component
    Object.keys(conditionalFormProps).forEach((attr)=>{
        if (conditionalFormProps[attr] !== undefined) formProps[attr] = conditionalFormProps[attr];
    });
    const childrenContent = (()=>{
        if (typeof children === 'function') {
            const result = children.length > 0 ? children({
                formProps: formProps,
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: ()=>form.getState(),
                getValues: ()=>form.getState().values,
                setFieldValue: form.change,
                resetFieldState: form.resetFieldState
            }) : children();
            return result === undefined ? null : result;
        } else return /*#__PURE__*/ (0, $2iln5.jsx)("form", {
            ...formProps,
            ...userProvidedFormProps,
            children: children
        });
    })();
    return /*#__PURE__*/ (0, $2iln5.jsx)($37628cef49c97b3a$export$c24727297075ec6a.Provider, {
        value: FormContextValue,
        children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $4cGYf.IsDisabledContext).Provider, {
            value: isDisabled,
            children: childrenContent
        })
    });
};
/**
 * __Form__
 *
 * A form allows users to input information.
 *
 * - [Examples](https://atlassian.design/components/form/examples)
 * - [Code](https://atlassian.design/components/form/code)
 * - [Usage](https://atlassian.design/components/form/usage)
 */ const $37628cef49c97b3a$var$Form = (0, $72Jxx.default)($37628cef49c97b3a$var$FormBase);
var $37628cef49c97b3a$export$2e2bcd8739ae039 = $37628cef49c97b3a$var$Form;

});
parcelRegister("72Jxx", function(module, exports) {
$parcel$export(module.exports, "default", () => $c7cc04a45ba26168$export$2e2bcd8739ae039);

var $4tluv = parcelRequire("4tluv");
var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $c7cc04a45ba26168$export$2e2bcd8739ae039 = (0, $4tluv.forwardRef);

});

parcelRegister("4cGYf", function(module, exports) {
$parcel$export(module.exports, "IsDisabledContext", () => $519f8c41456a70c5$export$c17cf6b332a82dbc);

var $4tluv = parcelRequire("4tluv");
const $519f8c41456a70c5$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $4tluv.createContext)(false);

});

parcelRegister("3oe7X", function(module, exports) {
$parcel$export(module.exports, "getFirstErrorField", () => $6d1a0d59d94a9e00$export$fc06342dc8588d3b);

var $f6jDN = parcelRequire("f6jDN");
const $6d1a0d59d94a9e00$export$fc06342dc8588d3b = (inputs, errors)=>{
    // Guaranteed to be of type HTMLInputElement[] due to getInputs function overrided in createDecorator
    let htmlInputs = inputs;
    return htmlInputs.find(function(input) {
        // If input is hidden, do not focus
        if (input.type === 'hidden') return false;
        // If input ID matches the error, focus
        if (input.id && (0, $f6jDN.getIn)(errors, input.id)) return true;
        // Default to base behavior
        return input.name && (0, $f6jDN.getIn)(errors, input.name);
    });
};

});


parcelRegister("eYOIg", function(module, exports) {
$parcel$export(module.exports, "Label", () => $0ac03e1cd4eb3637$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $0ac03e1cd4eb3637$export$ed247974535929c7);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");
const $0ac03e1cd4eb3637$var$fieldsetLabelStyles = null;
const $0ac03e1cd4eb3637$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $2iln5.jsx)("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $jAkMr.default)([
            "_11c8wadc _1e0c1o8l _syazazsu _k48pwu06 _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
const $0ac03e1cd4eb3637$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2iln5.jsx)("legend", {
        className: (0, $jAkMr.default)([
            "_11c8wadc _1e0c1o8l _syazazsu _k48pwu06 _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
};

});

parcelRegister("3PrKC", function(module, exports) {
$parcel$export(module.exports, "HelperMessage", () => $4c3af0dc4bef4a37$export$8fbe3c7d0ed2c683);
$parcel$export(module.exports, "ErrorMessage", () => $4c3af0dc4bef4a37$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "ValidMessage", () => $4c3af0dc4bef4a37$export$5505afb209a532c8);
$parcel$export(module.exports, "MessageWrapper", () => $4c3af0dc4bef4a37$export$ec445f12f63100a5);
/* messages.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");

var $bnlbq = parcelRequire("bnlbq");

var $fHnP4 = parcelRequire("fHnP4");

var $8hnzA = parcelRequire("8hnzA");
const $4c3af0dc4bef4a37$var$messageStyles = null;
const $4c3af0dc4bef4a37$var$messageAppearanceStyles = {
    default: "_syaz1rpy",
    error: "_syaz1tmw",
    valid: "_syazgsak"
};
const $4c3af0dc4bef4a37$var$iconWrapperStyles = {
    root: "_1e0c1txw _4t3i7vkz _4cvr1h6o"
};
const $4c3af0dc4bef4a37$var$IconWrapper = ({ children: children })=>/*#__PURE__*/ (0, $2iln5.jsx)("span", {
        className: (0, $jAkMr.default)([
            $4c3af0dc4bef4a37$var$iconWrapperStyles.root
        ]),
        children: children
    });
const $4c3af0dc4bef4a37$var$messageIcons = {
    error: /*#__PURE__*/ (0, $2iln5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bnlbq))), {
        color: "currentColor",
        label: "error",
        size: "small"
    }),
    valid: /*#__PURE__*/ (0, $2iln5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fHnP4))), {
        color: "currentColor",
        label: "success",
        size: "small"
    })
};
const $4c3af0dc4bef4a37$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $4c3af0dc4bef4a37$var$messageIcons[appearance];
    const messageRef = (0, $4tluv.useRef)(null);
    const [hasMessageWrapper, setHasMessageWrapper] = (0, $4tluv.useState)(false);
    const { isWrapper: isWrapper } = (0, $4tluv.useContext)($4c3af0dc4bef4a37$var$MessageWrapperContext);
    (0, $4tluv.useEffect)(()=>{
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $2iln5.jsx)("span", {
        children: children
    });
    return /*#__PURE__*/ (0, $2iln5.jsxs)("div", {
        "data-testid": testId,
        id: fieldId,
        ref: messageRef,
        // For backwards compatability, if there is a wrapper, aria-live is not needed
        "aria-live": !hasMessageWrapper ? 'polite' : undefined,
        className: (0, $jAkMr.default)([
            "_zulp12x7 _11c8wadc _1e0c1txw _1bah1q9y _1pfh1b66",
            $4c3af0dc4bef4a37$var$messageAppearanceStyles[appearance]
        ]),
        children: [
            icon && /*#__PURE__*/ (0, $2iln5.jsx)($4c3af0dc4bef4a37$var$IconWrapper, {
                children: icon
            }),
            content
        ]
    });
};
const $4c3af0dc4bef4a37$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2iln5.jsx)((0, $8hnzA.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $2iln5.jsx)($4c3af0dc4bef4a37$var$Message, {
                fieldId: fieldId ? `${fieldId}-helper` : undefined,
                testId: testId,
                children: children
            })
    });
const $4c3af0dc4bef4a37$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2iln5.jsx)((0, $8hnzA.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $2iln5.jsx)($4c3af0dc4bef4a37$var$Message, {
                appearance: "error",
                fieldId: fieldId ? `${fieldId}-error` : undefined,
                testId: testId,
                children: children
            })
    });
const $4c3af0dc4bef4a37$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2iln5.jsx)((0, $8hnzA.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $2iln5.jsx)($4c3af0dc4bef4a37$var$Message, {
                appearance: "valid",
                fieldId: fieldId ? `${fieldId}-valid` : undefined,
                testId: testId,
                children: children
            })
    });
/**
 * __Message wrapper context__
 *
 * A message wrapper context allows the children to check
 * if it is contained within the MessageWrapper.
 */ const $4c3af0dc4bef4a37$var$MessageWrapperContext = /*#__PURE__*/ (0, $4tluv.createContext)({
    isWrapper: false
});
const $4c3af0dc4bef4a37$export$ec445f12f63100a5 = ({ children: children })=>{
    const contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ (0, $2iln5.jsx)($4c3af0dc4bef4a37$var$MessageWrapperContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2iln5.jsx)("div", {
            "aria-live": "polite",
            "data-testid": "message-wrapper",
            children: children
        })
    });
};

});

parcelRegister("2fQ8J", function(module, exports) {
$parcel$export(module.exports, "default", () => $161488d07a2e5336$export$2e2bcd8739ae039);
/* required-asterisk.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");
const $161488d07a2e5336$var$requiredIndicatorStyles = null;
function $161488d07a2e5336$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2iln5.jsx)("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $jAkMr.default)([
            "_syaz1tmw _ect4ttxp _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("bqso3", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c0f1bc8020d207f$export$2e2bcd8739ae039);
/* text-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $jAkMr = parcelRequire("jAkMr");
var $fuAjD = parcelRequire("fuAjD");

var $4tluv = parcelRequire("4tluv");

var $wYkfM = parcelRequire("wYkfM");

var $3X3Vo = parcelRequire("3X3Vo");
const $5c0f1bc8020d207f$var$packageName = undefined;
const $5c0f1bc8020d207f$var$packageVersion = undefined;
const $5c0f1bc8020d207f$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $5c0f1bc8020d207f$var$packageName,
    packageVersion: $5c0f1bc8020d207f$var$packageVersion
};
const $5c0f1bc8020d207f$var$lineHeightBase = 20;
const $5c0f1bc8020d207f$var$lineHeightCompact = 16;
const $5c0f1bc8020d207f$var$compactVerticalPadding = 2;
const $5c0f1bc8020d207f$var$verticalPadding = 6;
const $5c0f1bc8020d207f$var$transitionDuration = '0.2s';
const $5c0f1bc8020d207f$var$borderWidth = 2;
const $5c0f1bc8020d207f$var$baseStyles = null;
const $5c0f1bc8020d207f$var$baseStylesT26Shape = null;
const $5c0f1bc8020d207f$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp82rsbi _1ltx1j9a _1bqsbk0g _z1pvby5v _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _7ba01v6z _1kod1v6z _858u1v1w _jomrr01l _7ehivyy1 _186j1v1w _qu18by5v",
    subtle: "_1dqonqa1 _kp821j28 _1ltx1j28 _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _1kod1v6z _7ba01v6z _858u1v1w _jomrr01l _7ehivyy1",
    none: "_1dqoglyw _kp821j28 _1ltx1j28 _19wt1j28 _12ym1j28 _1l02v77o _daj712x7 _11zpv77o _141f12x7 _olc612x7 _1kod12x7 _14ji12x7 _7ba012x7 _858u1j28 _jomr1j28 _7ehi3sij"
};
// iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on mobile devices, the textarea uses font.body.large (16px) by default,
// then switches to the smaller font.body on screens wider than 30rem (desktop).
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $5c0f1bc8020d207f$var$fontStyles = {
    default: "_11c81d4k _1tn2fhey",
    monospace: "_11c81d4k _ect4zzfg _1tn2fhey _14md1vhz"
};
const $5c0f1bc8020d207f$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $5c0f1bc8020d207f$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $5c0f1bc8020d207f$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $5c0f1bc8020d207f$var$InnerTextArea = /*#__PURE__*/ (0, $4tluv.forwardRef)((props, ref)=>{
    const ourRef = (0, $4tluv.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $4tluv.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $4tluv.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $5c0f1bc8020d207f$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $wYkfM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$5c0f1bc8020d207f$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $wYkfM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$5c0f1bc8020d207f$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $4tluv.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $5c0f1bc8020d207f$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $2iln5.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $jAkMr.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rkofajl _11c8fhey _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazi7uo _slp31hna _153g1bqt _usy41j9a _1a2sizbr _vbqb1gmx _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra1bqt _ibjdl4ek _6zpvizbr _19k0by5v _1idr1rpy _1lep1gmx _nmhq1fiz _1n388sxn _1luh1v1w _ndzbr01l _1vj0vyy1",
            (0, $3X3Vo.fg)('platform-dst-shape-theme-default') && "_2rko1qi0",
            $5c0f1bc8020d207f$var$appearanceStyles[appearance],
            $5c0f1bc8020d207f$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $5c0f1bc8020d207f$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $fuAjD.default)($5c0f1bc8020d207f$var$lineHeightCompact * minimumRows + $5c0f1bc8020d207f$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $fuAjD.default)($5c0f1bc8020d207f$var$lineHeightBase * minimumRows + $5c0f1bc8020d207f$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
});
/**
 * __Text area__
 *
 * A text area lets users enter long form text which spans over multiple lines.
 *
 * - [Examples](https://atlassian.design/components/textarea/examples)
 * - [Code](https://atlassian.design/components/textarea/code)
 * - [Usage](https://atlassian.design/components/textarea/usage)
 */ const $5c0f1bc8020d207f$var$TextArea = /*#__PURE__*/ (0, $4tluv.memo)(/*#__PURE__*/ (0, $4tluv.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $2iln5.jsx)($5c0f1bc8020d207f$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$5c0f1bc8020d207f$var$TextArea.displayName = 'TextArea';
var $5c0f1bc8020d207f$export$2e2bcd8739ae039 = $5c0f1bc8020d207f$var$TextArea;

});

parcelRegister("f1XBl", function(module, exports) {
$parcel$export(module.exports, "default", () => $41713f597a5fedae$export$2e2bcd8739ae039);
/* fieldset.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");

var $eYOIg = parcelRequire("eYOIg");
const $41713f597a5fedae$var$fieldSetStyles = null;
/**
 * __Fieldset__
 *
 * A fieldset groups a number of fields together. For example, when multiple CheckboxFields share the same name,
 * a fieldset can be used to group them together. This makes the form more accessible.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 */ const $41713f597a5fedae$var$Fieldset = ({ children: children, legend: legend })=>{
    return /*#__PURE__*/ (0, $2iln5.jsxs)("fieldset", {
        className: (0, $jAkMr.default)([
            "_1pfhu2gc"
        ]),
        children: [
            legend && /*#__PURE__*/ (0, $2iln5.jsx)((0, $eYOIg.Legend), {
                children: legend
            }),
            children
        ]
    });
};
var $41713f597a5fedae$export$2e2bcd8739ae039 = $41713f597a5fedae$var$Fieldset;

});

parcelRegister("k14Od", function(module, exports) {
$parcel$export(module.exports, "default", () => $02018562967eeea1$export$2e2bcd8739ae039);

var $6NmUI = parcelRequire("6NmUI");
function $02018562967eeea1$export$2e2bcd8739ae039(callback) {
    const ref = (0, $6NmUI.default)(()=>callback);
    return ref.current;
}

});
parcelRegister("6NmUI", function(module, exports) {
$parcel$export(module.exports, "default", () => $765d4848e1584f6c$export$2e2bcd8739ae039);

var $4tluv = parcelRequire("4tluv");
const $765d4848e1584f6c$var$uniqueReferencedValue = {};
function $765d4848e1584f6c$export$2e2bcd8739ae039(initializer) {
    const ref = (0, $4tluv.useRef)($765d4848e1584f6c$var$uniqueReferencedValue);
    if (ref.current === $765d4848e1584f6c$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}

});


parcelRegister("bDwOM", function(module, exports) {
$parcel$export(module.exports, "default", () => $70fd3c24740a87c3$export$2e2bcd8739ae039);

var $4tluv = parcelRequire("4tluv");
function $70fd3c24740a87c3$export$2e2bcd8739ae039(value) {
    const ref = (0, $4tluv.useRef)();
    (0, $4tluv.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("i0z3a", function(module, exports) {
$parcel$export(module.exports, "default", () => $e40cd3c0e23965e8$export$2e2bcd8739ae039);

var $4tluv = parcelRequire("4tluv");
function $e40cd3c0e23965e8$export$2e2bcd8739ae039(initialState) {
    const [value, setValue] = (0, $4tluv.useState)(initialState);
    const valueRef = (0, $4tluv.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}

});

parcelRegister("iGppW", function(module, exports) {
$parcel$export(module.exports, "useCloseOnEscapePress", () => $2f0146bfed56b957$export$4a4bf067ea9e7886);

var $4tluv = parcelRequire("4tluv");

var $Hyfcf = parcelRequire("Hyfcf");

var $fXJaK = parcelRequire("fXJaK");
const $2f0146bfed56b957$var$ESCAPE = 'Escape';
function $2f0146bfed56b957$export$4a4bf067ea9e7886({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $4tluv.useRef)(false);
    const { isLayerDisabled: isLayerDisabled } = (0, $fXJaK.useLayering)();
    const onKeyDown = (0, $4tluv.useCallback)((e)=>{
        const isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $2f0146bfed56b957$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    const onKeyUp = (0, $4tluv.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $4tluv.useEffect)(()=>{
        return (0, $Hyfcf.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}

});

parcelRegister("lLJ22", function(module, exports) {
$parcel$export(module.exports, "easeInOut", () => $391400c60295bf4b$export$c07234257a03d5e9);
const $391400c60295bf4b$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $391400c60295bf4b$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $391400c60295bf4b$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
const $391400c60295bf4b$export$fc825baa2ef870d0 = 'cubic-bezier(0.4,0,0,1)';
const $391400c60295bf4b$export$816ee5d79b5bd9a5 = 'cubic-bezier(0.6,0,0,1)';
const $391400c60295bf4b$export$53ce3390a1a8f2a2 = 'cubic-bezier(0.8,0,0,1)';
const $391400c60295bf4b$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';

});

parcelRegister("8rXtL", function(module, exports) {
$parcel$export(module.exports, "isAppleDevice", () => $bcf4cbae6368b697$export$e1865c3bedcd822b);
function $bcf4cbae6368b697$var$testPlatform(re) {
    return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
}
function $bcf4cbae6368b697$var$isIPhone() {
    return $bcf4cbae6368b697$var$testPlatform(/^iPhone/i);
}
function $bcf4cbae6368b697$var$isIPad() {
    return $bcf4cbae6368b697$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $bcf4cbae6368b697$var$isMac() && navigator.maxTouchPoints > 1;
}
function $bcf4cbae6368b697$var$isMac() {
    return $bcf4cbae6368b697$var$testPlatform(/^Mac/i);
}
function $bcf4cbae6368b697$var$isIOS() {
    return $bcf4cbae6368b697$var$isIPhone() || $bcf4cbae6368b697$var$isIPad();
}
function $bcf4cbae6368b697$export$e1865c3bedcd822b() {
    return $bcf4cbae6368b697$var$isMac() || $bcf4cbae6368b697$var$isIOS();
}

});

parcelRegister("hhhOz", function(module, exports) {
$parcel$export(module.exports, "default", () => $a92d2197e9e02d7e$export$2e2bcd8739ae039);

var $cGlqj = parcelRequire("cGlqj");

var $g7qa1 = parcelRequire("g7qa1");

var $504fE = parcelRequire("504fE");

var $4V5j2 = parcelRequire("4V5j2");

var $eeuEd = parcelRequire("eeuEd");

var $1F7MK = parcelRequire("1F7MK");
/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ const $a92d2197e9e02d7e$var$ShrinkOut = ({ children: children, duration: duration = 'small', onFinish: onFinish })=>{
    const [element, setElementRef] = (0, $4V5j2.useElementRef)();
    const exiting = (0, $1F7MK.useExitingPersistence)();
    const requestAnimationFrame = (0, $504fE.useRequestAnimationFrame)();
    const setTimeout = (0, $504fE.useSetTimeout)();
    const direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $eeuEd.useLayoutEffect)(()=>{
        if (exiting.isExiting && element) {
            if ((0, $cGlqj.isReducedMotion)()) {
                exiting.onFinish && exiting.onFinish();
                onFinish && onFinish('exiting');
                return;
            }
            const newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: `${element.offsetWidth}px`,
                height: `${element.offsetHeight}px`,
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    const newStyles = {
                        width: '0px',
                        margin: '0px',
                        // We animate margin down to zero so it doesn't take any space.
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, $g7qa1.durations)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(()=>{
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, $g7qa1.durations)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $a92d2197e9e02d7e$export$2e2bcd8739ae039 = $a92d2197e9e02d7e$var$ShrinkOut;

});

parcelRegister("jx7eF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43ee578492c08869d5f395fcddb9fcf9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e386b63791204ec1$var$_react = $e386b63791204ec1$var$_interopRequireDefault((parcelRequire("4tluv")));

var $e386b63791204ec1$var$_baseNew = $e386b63791204ec1$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $e386b63791204ec1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Terminal".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e386b63791204ec1$var$TerminalIcon = (props)=>/*#__PURE__*/ $e386b63791204ec1$var$_react.default.createElement($e386b63791204ec1$var$_baseNew.default, Object.assign({
        name: "TerminalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 3a.5.5 0 0 0-.4-.49L14 2.5H2a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zM16 13a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h12l.204.01A2 2 0 0 1 16 3z"/><path fill="currentcolor" d="m4.28 4.72 2.75 2.75a.75.75 0 0 1 0 1.06l-2.75 2.75-1.06-1.06L5.44 8 3.22 5.78zM12.5 9.5V11H8V9.5z"/>`
    }, props));
$e386b63791204ec1$var$TerminalIcon.displayName = 'TerminalIcon';
var $e386b63791204ec1$var$_default = module.exports.default = $e386b63791204ec1$var$TerminalIcon;

});

parcelRegister("buxtQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df727533991c4aac2a7e523738f16a10>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $85dc778ee87f6cb2$var$_react = $85dc778ee87f6cb2$var$_interopRequireDefault((parcelRequire("4tluv")));

var $85dc778ee87f6cb2$var$_baseNew = $85dc778ee87f6cb2$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $85dc778ee87f6cb2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiSearch".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for search interactions powered by Rovo/AI.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $85dc778ee87f6cb2$var$AiSearchIcon = (props)=>/*#__PURE__*/ $85dc778ee87f6cb2$var$_react.default.createElement($85dc778ee87f6cb2$var$_baseNew.default, Object.assign({
        name: "AiSearchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6 2.612A4.501 4.501 0 0 0 7 11.5a4.48 4.48 0 0 0 3.182-1.318A4.5 4.5 0 0 0 11.387 8h1.53a6 6 0 0 1-1.179 2.678l3.292 3.292-1.06 1.06-3.292-3.292A6 6 0 1 1 6 1.084z"/><path fill="currentcolor" d="M14 3.25a.75.75 0 0 1-.493.705l-1.285.469a.5.5 0 0 0-.298.298l-.469 1.285a.75.75 0 0 1-1.41 0l-.469-1.285a.5.5 0 0 0-.298-.298l-1.285-.469a.75.75 0 0 1-.484-.589L7.5 3.25l.009-.116a.75.75 0 0 1 .484-.59l1.285-.468a.5.5 0 0 0 .298-.298l.469-1.285.049-.106A.75.75 0 0 1 10.749 0l.116.009a.75.75 0 0 1 .541.378l.05.106.468 1.285a.5.5 0 0 0 .298.298l1.285.469A.75.75 0 0 1 14 3.25"/>`
    }, props));
$85dc778ee87f6cb2$var$AiSearchIcon.displayName = 'AiSearchIcon';
var $85dc778ee87f6cb2$var$_default = module.exports.default = $85dc778ee87f6cb2$var$AiSearchIcon;

});

parcelRegister("3e67t", function(module, exports) {
$parcel$export(module.exports, "default", () => $14c2c300a6f006a7$export$2e2bcd8739ae039);
/* lozenge-dropdown-trigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $ccErM = parcelRequire("ccErM");

var $eTtxG = parcelRequire("eTtxG");
/**
 * __Lozenge Dropdown Trigger__
 *
 * An interactive lozenge component that acts as a dropdown trigger.
 * Built on LozengeBase with dropdown interaction patterns.
 *
 * - Supports all color variants from the lozenge
 * - Shows selected state with dedicated color tokens
 * - Includes a chevron icon on the right of the text
 * - Built for dropdown menu interactions
 * - Supports analytics events and UFO press interactions
 */ const $14c2c300a6f006a7$var$LozengeDropdownTrigger = /*#__PURE__*/ (0, $4tluv.memo)(/*#__PURE__*/ (0, $4tluv.forwardRef)(({ children: children, testId: testId, appearance: appearance = 'neutral', spacing: spacing = 'default', iconBefore: iconBefore, trailingMetric: trailingMetric, trailingMetricAppearance: trailingMetricAppearance, isSelected: isSelected = false, isLoading: isLoading = false, maxWidth: maxWidth = 200, onClick: onClick = (0, $ccErM.default), style: style, analyticsContext: analyticsContext, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, 'aria-label': ariaLabel }, ref)=>{
    const baseProps = {
        appearance: appearance,
        spacing: spacing,
        iconBefore: iconBefore,
        trailingMetric: trailingMetric,
        trailingMetricAppearance: trailingMetricAppearance,
        isSelected: isSelected,
        isLoading: isLoading,
        maxWidth: maxWidth,
        style: style,
        testId: testId,
        onClick: onClick,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        children: children,
        'aria-controls': ariaControls,
        'aria-expanded': ariaExpanded,
        'aria-haspopup': ariaHaspopup,
        'aria-label': ariaLabel
    };
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $eTtxG.default), {
        ref: ref,
        ...baseProps,
        children: children
    });
}));
$14c2c300a6f006a7$var$LozengeDropdownTrigger.displayName = 'LozengeDropdownTrigger';
var $14c2c300a6f006a7$export$2e2bcd8739ae039 = $14c2c300a6f006a7$var$LozengeDropdownTrigger;

});

parcelRegister("fPIcr", function(module, exports) {
$parcel$export(module.exports, "default", () => $dbe84dbd66445493$export$2e2bcd8739ae039);
/* form-section.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");

var $2TG1J = parcelRequire("2TG1J");
const $dbe84dbd66445493$var$formSectionDescriptionStyles = null;
const $dbe84dbd66445493$var$formSectionWrapperStyles = null;
const $dbe84dbd66445493$var$FormSectionWrapper = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/design-system/use-primitives
    return /*#__PURE__*/ (0, $2iln5.jsx)("div", {
        className: (0, $jAkMr.default)([
            "_1pfh1ejb"
        ]),
        children: children
    });
};
const $dbe84dbd66445493$var$FormSectionDescription = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/design-system/use-primitives
    return /*#__PURE__*/ (0, $2iln5.jsx)("div", {
        className: (0, $jAkMr.default)([
            "_1pfhu2gc"
        ]),
        children: children
    });
};
/**
 * __Form section__.
 *
 * A form section is used to define a section of a form layout. This contains a section title, content
 * and a description of the section.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout).
 */ const $dbe84dbd66445493$var$FormSection = ({ children: children, description: description, title: title })=>{
    return /*#__PURE__*/ (0, $2iln5.jsxs)($dbe84dbd66445493$var$FormSectionWrapper, {
        children: [
            title && /*#__PURE__*/ (0, $2iln5.jsx)((0, $2TG1J.default), {
                size: "medium",
                children: title
            }),
            description && /*#__PURE__*/ (0, $2iln5.jsx)($dbe84dbd66445493$var$FormSectionDescription, {
                children: description
            }),
            children
        ]
    });
};
var $dbe84dbd66445493$export$2e2bcd8739ae039 = $dbe84dbd66445493$var$FormSection;

});

parcelRegister("5JlEn", function(module, exports) {
$parcel$export(module.exports, "default", () => $0fc15ac8b16e25ca$export$2e2bcd8739ae039);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $202P8 = parcelRequire("202P8");
/**
 * __Checkbox field__
 *
 * A checkbox field is a form field that lets users select an item. Users can check or uncheck the checkbox.
 *
 * - [Examples] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Code] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Usage] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 */ const $0fc15ac8b16e25ca$var$CheckboxField = ({ children: children, defaultIsChecked: defaultIsChecked = false, isDisabled: isDisabled, isRequired: isRequired, label: label, name: name, value: value })=>{
    // Maintains a memoised list of the default values
    const defaultValue = (0, $4tluv.useCallback)((currentValue = [])=>defaultIsChecked && value !== undefined ? [
            ...currentValue,
            value
        ] : currentValue, [
        value,
        defaultIsChecked
    ]);
    return value !== undefined ? /*#__PURE__*/ (0, $2iln5.jsx)((0, $202P8.default), {
        defaultValue: defaultValue,
        isDisabled: isDisabled,
        isRequired: isRequired,
        label: label,
        name: name,
        transform: (event, currentValue)=>!Array.isArray(event) && event.currentTarget.checked && currentValue ? [
                ...currentValue,
                value
            ] : currentValue.filter((v)=>v !== value),
        children: ({ fieldProps: { value: fieldValue, onChange: onChange, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    // Setting to any because it's typed weirdly at the field level
                    onChange: (v)=>onChange(v),
                    isChecked: !!fieldValue.find((v)=>v === value),
                    value: value
                },
                ...others
            })
    }) : /*#__PURE__*/ (0, $2iln5.jsx)((0, $202P8.default), {
        defaultValue: defaultIsChecked,
        isDisabled: isDisabled,
        isRequired: isRequired,
        label: label,
        name: name,
        transform: (event)=>typeof event === 'boolean' ? event : event.currentTarget.checked,
        children: ({ fieldProps: { value: fieldValue, onChange: onChange, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    // Setting to any because it's typed weirdly at the field level
                    onChange: (v)=>onChange(v),
                    isChecked: fieldValue,
                    value: value
                },
                ...others
            })
    });
};
var $0fc15ac8b16e25ca$export$2e2bcd8739ae039 = $0fc15ac8b16e25ca$var$CheckboxField;

});

parcelRegister("560EI", function(module, exports) {
$parcel$export(module.exports, "default", () => $737333d7af6938a0$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");
const $737333d7af6938a0$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $737333d7af6938a0$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $737333d7af6938a0$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $737333d7af6938a0$var$alignContentMap = {
    start: "_ae4vv2br",
    center: "_ae4v1h6o",
    end: "_ae4vh9n0",
    'space-between': "_ae4v1yb4",
    'space-around': "_ae4v1b1v",
    'space-evenly': "_ae4vitcz",
    stretch: "_ae4v1fhb"
};
const $737333d7af6938a0$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $737333d7af6938a0$var$baseStyles = {
    root: "_1e0c11p5 _vchhusvi"
};
const $737333d7af6938a0$var$gridAutoFlowMap = {
    row: "_wij2vrvc",
    column: "_wij21bp4",
    dense: "_wij218l3",
    'row dense': "_wij2j5tq",
    'column dense': "_wij2adhi"
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $737333d7af6938a0$var$Grid = /*#__PURE__*/ (0, $4tluv.memo)(/*#__PURE__*/ (0, $4tluv.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    return /*#__PURE__*/ (0, $2iln5.jsx)(Component, {
        id: id,
        role: role,
        className: (0, $jAkMr.default)([
            $737333d7af6938a0$var$baseStyles.root,
            gap && $737333d7af6938a0$var$columnGapMap[gap],
            columnGap && $737333d7af6938a0$var$columnGapMap[columnGap],
            gap && $737333d7af6938a0$var$rowGapMap[gap],
            rowGap && $737333d7af6938a0$var$rowGapMap[rowGap],
            alignItems && $737333d7af6938a0$var$alignItemsMap[alignItems],
            alignContent && $737333d7af6938a0$var$alignContentMap[alignContent],
            justifyContent && $737333d7af6938a0$var$justifyContentMap[justifyContent],
            autoFlow && $737333d7af6938a0$var$gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$737333d7af6938a0$var$Grid.displayName = 'Grid';
var $737333d7af6938a0$export$2e2bcd8739ae039 = $737333d7af6938a0$var$Grid;

});

parcelRegister("bFCoz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f3ea5fcdbdd2a3db3d8f3f267a6778c2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87f14e8f8793d8b3$var$_react = $87f14e8f8793d8b3$var$_interopRequireDefault((parcelRequire("4tluv")));

var $87f14e8f8793d8b3$var$_baseNew = $87f14e8f8793d8b3$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $87f14e8f8793d8b3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PowerCable".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Suggested uses: Data connectivity, Connection, Plugins, Extensions, Extensibility
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $87f14e8f8793d8b3$var$PowerCableIcon = (props)=>/*#__PURE__*/ $87f14e8f8793d8b3$var$_react.default.createElement($87f14e8f8793d8b3$var$_baseNew.default, Object.assign({
        name: "PowerCableIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M4.5 3h-3v1.5A.5.5 0 0 0 2 5h2a.5.5 0 0 0 .5-.5zM6 4.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2.25a.75.75 0 0 1 .75-.75H1V0h1.5v1.5h1V0H5v1.5h.33a.75.75 0 0 1 .67.75zm8.5 8.5h-3v-1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5zm1.5-1.5a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v2.25c0 .41.34.75.75.75H11V16h1.5v-1.5h1V16H15v-1.5h.33a.75.75 0 0 0 .67-.75z"/><path fill="currentcolor" d="M12.25 6.25a1.75 1.75 0 1 0-3.5 0v3.5a3.25 3.25 0 0 1-6.5 0v-4h1.5v4a1.75 1.75 0 1 0 3.5 0v-3.5a3.25 3.25 0 1 1 6.5 0v4h-1.5z"/>`
    }, props));
$87f14e8f8793d8b3$var$PowerCableIcon.displayName = 'PowerCableIcon';
var $87f14e8f8793d8b3$var$_default = module.exports.default = $87f14e8f8793d8b3$var$PowerCableIcon;

});

parcelRegister("33iZQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f93df6ccb6a7c0b$export$2e2bcd8739ae039);
/* skeleton-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");
const $3f93df6ccb6a7c0b$var$skeletonItemElemSize = 20;
const $3f93df6ccb6a7c0b$var$styles = {
    root: "_1rjcze3t _18zrv47k _1e0c1txw _1tke1ylp _4cvr1h6o _lcxvglyw _14mj53f4 _1qdgrdoj _1hfkizff _aetrb3bt _3mxot94y",
    defaultWidth: "_sf1e1n8h _4rfy1ssb _baud1nrf _mr7o1vuk _69tq19wn _kt4d1n05",
    customWidth: "_11w8rzut",
    beforeElement: "_1mp4gktf _kfgtgktf _7bjqidpf _1rusizff _1kt9b3bt _1mbqdlk8 _1rhxv77o",
    avatar: "_rfx31rr0",
    icon: "_rfx3fajl",
    sideNavSkeleton: "_18zru2gc _kfgt1k8s _1mbqpxbi _1mp41k8s"
};
/**
 * These styles are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 * packages/design-system/menu/src/menu-item/skeleton-heading-item.tsx
 *
 * Please update both.
 */ const $3f93df6ccb6a7c0b$var$shimmerKeyframes = null;
/**
 * These styles are defined using `css` rather than `cssMap` as there is a bug when using
 * `cssMap` that causes a build failure due to the use of keyframes within this pseudo-element.
 */ const $3f93df6ccb6a7c0b$var$shimmerStyles = null;
/**
 * __Skeleton item__
 *
 * A skeleton item is used in place of an item when its contents it not ready.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $3f93df6ccb6a7c0b$var$SkeletonItem = ({ hasAvatar: hasAvatar, hasIcon: hasIcon, isShimmering: isShimmering = false, isSideNavSkeleton: isSideNavSkeleton = false, testId: testId, width: width, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $2iln5.jsx)("div", {
        className: (0, $jAkMr.default)([
            $3f93df6ccb6a7c0b$var$styles.root,
            (hasAvatar || hasIcon) && $3f93df6ccb6a7c0b$var$styles.beforeElement,
            hasAvatar && $3f93df6ccb6a7c0b$var$styles.avatar,
            hasIcon && $3f93df6ccb6a7c0b$var$styles.icon,
            width ? $3f93df6ccb6a7c0b$var$styles.customWidth : $3f93df6ccb6a7c0b$var$styles.defaultWidth,
            isSideNavSkeleton && $3f93df6ccb6a7c0b$var$styles.sideNavSkeleton,
            isShimmering && "",
            isShimmering && "_unfq1yy8 _9nev1yy8 _kwc012o8 _joxl12o8 _18f312c5 _evp612c5 _19oh1254 _10881254 _18lgp3kn _zo24p3kn _1hfkizff _1rusizff",
            xcss
        ]),
        style: {
            '--width': width
        },
        "data-testid": testId
    });
};
var $3f93df6ccb6a7c0b$export$2e2bcd8739ae039 = $3f93df6ccb6a7c0b$var$SkeletonItem;

});

parcelRegister("WGqT8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dc91bd4f7aec7121abc848a4fa856bb7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0b0655242201b1a8$var$_react = $0b0655242201b1a8$var$_interopRequireDefault((parcelRequire("4tluv")));

var $0b0655242201b1a8$var$_baseNew = $0b0655242201b1a8$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $0b0655242201b1a8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiModel".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing large language and reasoning models.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0b0655242201b1a8$var$AiModelIcon = (props)=>/*#__PURE__*/ $0b0655242201b1a8$var$_react.default.createElement($0b0655242201b1a8$var$_baseNew.default, Object.assign({
        name: "AiModelIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.75 3.19c0-.644.536-1.19 1.229-1.19.692 0 1.228.546 1.228 1.19q0 .137-.03.263a.75.75 0 0 0 .902.9.996.996 0 0 1 .59 1.897.75.75 0 0 0 .054 1.416 1.811 1.811 0 0 1-.368 3.533.75.75 0 0 0-.682.747v.593a1.462 1.462 0 0 1-2.923 0V9.362c.6.348 1.32.552 2.043.552v-1.5a2.6 2.6 0 0 1-1.481-.47c-.4-.289-.562-.61-.562-.875zm-1.5 9.35a2.961 2.961 0 0 0 5.923.016 3.31 3.31 0 0 0 1.116-5.72 2.496 2.496 0 0 0-1.604-3.98C12.517 1.518 11.359.5 9.979.5 8.486.5 7.25 1.69 7.25 3.19z"/><path fill="currentcolor" d="M7.25 3.19C7.25 2.545 6.714 2 6.021 2c-.692 0-1.228.546-1.228 1.19q0 .137.03.263a.75.75 0 0 1-.902.9.996.996 0 0 0-.59 1.897.75.75 0 0 1-.054 1.416 1.811 1.811 0 0 0 .368 3.533.75.75 0 0 1 .682.747v.593a1.462 1.462 0 0 0 2.923 0V9.362a4.13 4.13 0 0 1-2.043.552v-1.5c.542 0 1.086-.184 1.481-.47.4-.289.562-.61.562-.875zm1.5 9.35a2.961 2.961 0 0 1-5.923.016 3.31 3.31 0 0 1-1.116-5.72 2.496 2.496 0 0 1 1.604-3.98C3.483 1.518 4.641.5 6.021.5 7.514.5 8.75 1.69 8.75 3.19z"/>`
    }, props));
$0b0655242201b1a8$var$AiModelIcon.displayName = 'AiModelIcon';
var $0b0655242201b1a8$var$_default = module.exports.default = $0b0655242201b1a8$var$AiModelIcon;

});

parcelRegister("mdBGH", function(module, exports) {
$parcel$export(module.exports, "IdProvider", () => $7512db933a31247e$export$6be90bcb437e928f);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $fEY94 = parcelRequire("fEY94");
const $7512db933a31247e$export$6be90bcb437e928f = /*#__PURE__*/ (0, $4tluv.forwardRef)(({ children: children, postfix: postfix = '', prefix: prefix = '' }, ref)=>{
    const id = `${prefix}${(0, $fEY94.useId)()}${postfix}`;
    (0, $4tluv.useEffect)(()=>{
        if (!ref) return;
        switch(typeof ref){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error(`Unreachable case for unsupported type of ref "${typeof ref}"`);
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $2iln5.Fragment), {
        children: typeof children === 'function' ? children({
            id: id
        }) : children
    });
});

});

parcelRegister("9ER8A", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::32871a9e1205ad83473907533912c2d6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $708111763b80a44a$var$_react = $708111763b80a44a$var$_interopRequireDefault((parcelRequire("4tluv")));

var $708111763b80a44a$var$_baseNew = $708111763b80a44a$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $708111763b80a44a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DataFormula".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for data formulas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $708111763b80a44a$var$DataFormulaIcon = (props)=>/*#__PURE__*/ $708111763b80a44a$var$_react.default.createElement($708111763b80a44a$var$_baseNew.default, Object.assign({
        name: "DataFormulaIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M9 0a2.5 2.5 0 0 1 2.5 2.5H10a1 1 0 0 0-1-1h-.12a1.12 1.12 0 0 0-1.11.967L7.354 5.5H10V7H7.146l-.93 6.738A2.62 2.62 0 0 1 1 13.38V13h1.5v.38a1.12 1.12 0 0 0 2.23.153L5.63 7H4V5.5h1.838l.446-3.238A2.62 2.62 0 0 1 8.88 0z"/><path fill="currentcolor" d="m15.052 9.008-2.392 2.598 1.948 2.706-1.216.877-1.768-2.456-2.322 2.525-1.104-1.016 2.53-2.752-1.836-2.552 1.216-.876 1.658 2.301 2.182-2.37z"/>`
    }, props));
$708111763b80a44a$var$DataFormulaIcon.displayName = 'DataFormulaIcon';
var $708111763b80a44a$var$_default = module.exports.default = $708111763b80a44a$var$DataFormulaIcon;

});

parcelRegister("a0y24", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9bca9e4dac0d9c04fcb3620a88a92cf7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $74944d9930e6230c$var$_react = $74944d9930e6230c$var$_interopRequireDefault((parcelRequire("4tluv")));

var $74944d9930e6230c$var$_baseNew = $74944d9930e6230c$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $74944d9930e6230c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoHd".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Single purpose - Reserved for enabling high definition videos
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $74944d9930e6230c$var$VideoHdIcon = (props)=>/*#__PURE__*/ $74944d9930e6230c$var$_react.default.createElement($74944d9930e6230c$var$_baseNew.default, Object.assign({
        name: "VideoHdIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M8.75 5h2.5c.97 0 1.75.78 1.75 1.75v2.5A1.75 1.75 0 0 1 11.25 11h-2.5zm1.5 1.5v3h1a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25zm-5.5.75V5h-1.5v6h1.5V8.75H6V11h1.5V5H6v2.25z" clip-rule="evenodd"/>`
    }, props));
$74944d9930e6230c$var$VideoHdIcon.displayName = 'VideoHdIcon';
var $74944d9930e6230c$var$_default = module.exports.default = $74944d9930e6230c$var$VideoHdIcon;

});

parcelRegister("hoI2R", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e63012391fad97538340ac6a0ffbd03b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $caa6d7ff9085c641$var$_react = $caa6d7ff9085c641$var$_interopRequireDefault((parcelRequire("4tluv")));

var $caa6d7ff9085c641$var$_baseNew = $caa6d7ff9085c641$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $caa6d7ff9085c641$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoHdFilled".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Single purpose - Reserved to show that high definition is enabled for videos
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $caa6d7ff9085c641$var$VideoHdFilledIcon = (props)=>/*#__PURE__*/ $caa6d7ff9085c641$var$_react.default.createElement($caa6d7ff9085c641$var$_baseNew.default, Object.assign({
        name: "VideoHdFilledIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10.25 9.5v-3h1a.25.25 0 0 1 .25.25v2.5a.25.25 0 0 1-.25.25z"/><path fill="currentcolor" fill-rule="evenodd" d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm2.75 3v2.25H6V5h1.5v6H6V8.75H4.75V11h-1.5V5zm6.5 0h-2.5v6h2.5A1.75 1.75 0 0 0 13 9.25v-2.5A1.75 1.75 0 0 0 11.25 5" clip-rule="evenodd"/>`
    }, props));
$caa6d7ff9085c641$var$VideoHdFilledIcon.displayName = 'VideoHdFilledIcon';
var $caa6d7ff9085c641$var$_default = module.exports.default = $caa6d7ff9085c641$var$VideoHdFilledIcon;

});

parcelRegister("jbh7V", function(module, exports) {
$parcel$export(module.exports, "useResizingHeight", () => $da094b476a913171$export$da99457d6430d83);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $cGlqj = parcelRequire("cGlqj");

var $lLJ22 = parcelRequire("lLJ22");

var $g7qa1 = parcelRequire("g7qa1");

var $504fE = parcelRequire("504fE");

var $4V5j2 = parcelRequire("4V5j2");

var $eeuEd = parcelRequire("eeuEd");

var $2DgUK = parcelRequire("2DgUK");
const $da094b476a913171$export$da99457d6430d83 = ({ duration: calcDuration = ()=>(0, $g7qa1.durations).medium, timingFunction: calcTimingFunction = ()=>(0, $lLJ22.easeInOut) } = {})=>{
    const prevDimensions = (0, $4tluv.useRef)();
    const [element, setElementRef] = (0, $4V5j2.useElementRef)();
    // We cleanup on the next effect to prevent the previous timeout being called during
    // the next motion - as now the timeout has essentially been extended!
    const setTimeout = (0, $504fE.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $504fE.useRequestAnimationFrame)();
    (0, $2DgUK.useSnapshotBeforeUpdate)(()=>{
        if ((0, $cGlqj.isReducedMotion)() || !element) return;
        prevDimensions.current = element.getBoundingClientRect();
    });
    (0, $eeuEd.useLayoutEffect)(()=>{
        if ((0, $cGlqj.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination height first.
        element.setAttribute('style', '');
        const nextDimensions = element.getBoundingClientRect();
        if (nextDimensions.height === prevDimensions.current.height) return;
        const duration = calcDuration(prevDimensions.current.height, nextDimensions.height);
        const newStyles = {
            height: `${prevDimensions.current.height}px`,
            willChange: 'height',
            transitionProperty: 'height',
            transitionDuration: `${duration}ms`,
            boxSizing: 'border-box',
            transitionTimingFunction: calcTimingFunction(prevDimensions.current.height, nextDimensions.height, duration)
        };
        Object.assign(element.style, newStyles);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                }, duration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
const $da094b476a913171$export$204d7b6d1491a2d3 = ({ children: children, ...props })=>{
    const resizing = $da094b476a913171$export$da99457d6430d83(props);
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $4tluv.Fragment), {
        children: children(resizing)
    });
}; /* eslint-enable @repo/internal/deprecations/deprecation-ticket-required */ 

});

parcelRegister("12jzi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8238471175f767861134859691ed34ec>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0c15282f3fbd3f5f$var$_react = $0c15282f3fbd3f5f$var$_interopRequireDefault((parcelRequire("4tluv")));

var $0c15282f3fbd3f5f$var$_baseNew = $0c15282f3fbd3f5f$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $0c15282f3fbd3f5f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Telescope".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Known uses: Discover feature in Atlassian Home
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0c15282f3fbd3f5f$var$TelescopeIcon = (props)=>/*#__PURE__*/ $0c15282f3fbd3f5f$var$_react.default.createElement($0c15282f3fbd3f5f$var$_baseNew.default, Object.assign({
        name: "TelescopeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7.687 9.505a.75.75 0 0 1 1.183.072l3.75 5.5-1.24.846L9 12.432V16H7.5l-.001-3.567-2.38 3.49-1.239-.845 3.75-5.5z"/><path fill="currentcolor" d="m10.66 2.963 1.531 2.653L14.44 4.51l-1.698-2.94zM4.414 7.146l1.032 1.787 5.396-2.654L9.411 3.8zm11.392-3.27c.397.69.13 1.571-.584 1.922L3.118 11.75a1.687 1.687 0 0 1-2.206-.67L.289 10A1.687 1.687 0 0 1 .81 7.756L12.018.249l.126-.076a1.375 1.375 0 0 1 1.83.53zM2.21 10.33c.05.085.156.117.245.074l1.64-.808-.93-1.613-1.52 1.019a.187.187 0 0 0-.058.249z"/>`
    }, props));
$0c15282f3fbd3f5f$var$TelescopeIcon.displayName = 'TelescopeIcon';
var $0c15282f3fbd3f5f$var$_default = module.exports.default = $0c15282f3fbd3f5f$var$TelescopeIcon;

});

parcelRegister("8aUMS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9d288013ed94ec7ddbe1bb143e39a4fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5f3b4eadd469f80c$var$_react = $5f3b4eadd469f80c$var$_interopRequireDefault((parcelRequire("4tluv")));

var $5f3b4eadd469f80c$var$_baseNew = $5f3b4eadd469f80c$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $5f3b4eadd469f80c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BrowserExtension".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for chrome extensions
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5f3b4eadd469f80c$var$BrowserExtensionIcon = (props)=>/*#__PURE__*/ $5f3b4eadd469f80c$var$_react.default.createElement($5f3b4eadd469f80c$var$_baseNew.default, Object.assign({
        name: "BrowserExtensionIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.25 2v.5h2.25a2 2 0 0 1 2 2v2.25h.5a2 2 0 1 1 0 4h-.5V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2.25a.75.75 0 0 1 .75-.75h.5a1.25 1.25 0 1 0 0-2.5h-.5A.75.75 0 0 1 1 6.75V4.5a2 2 0 0 1 2-2h2.25V2a2 2 0 1 1 4 0M2.5 4.5A.5.5 0 0 1 3 4h8.5a.5.5 0 0 1 .5.5V13a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-1.511a2.75 2.75 0 0 0 0-5.478z" clip-rule="evenodd"/>`
    }, props));
$5f3b4eadd469f80c$var$BrowserExtensionIcon.displayName = 'BrowserExtensionIcon';
var $5f3b4eadd469f80c$var$_default = module.exports.default = $5f3b4eadd469f80c$var$BrowserExtensionIcon;

});

parcelRegister("9j2HF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2d6ff2113712652381db2eeef0f24380>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6c67fc3afb654453$var$_react = $6c67fc3afb654453$var$_interopRequireDefault((parcelRequire("4tluv")));

var $6c67fc3afb654453$var$_baseNew = $6c67fc3afb654453$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $6c67fc3afb654453$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sunset".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Farewell feed in hello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6c67fc3afb654453$var$SunsetIcon = (props)=>/*#__PURE__*/ $6c67fc3afb654453$var$_react.default.createElement($6c67fc3afb654453$var$_baseNew.default, Object.assign({
        name: "SunsetIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v2h-1.5V1zm3 2.845 1.414-1.415 1.06 1.061-1.413 1.414zm-8.586 1.07L1.75 3.5l1.06-1.06 1.415 1.414zM8 6a3 3 0 0 0-3 3H3.5a4.5 4.5 0 0 1 9 0H11a3 3 0 0 0-3-3M2 9H0V7.5h2zm14 0h-2V7.5h2zm-1 3H1v-1.5h14zm-4.5 1.5V15h-5v-1.5z" clip-rule="evenodd"/>`
    }, props));
$6c67fc3afb654453$var$SunsetIcon.displayName = 'SunsetIcon';
var $6c67fc3afb654453$var$_default = module.exports.default = $6c67fc3afb654453$var$SunsetIcon;

});

parcelRegister("ejQKs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f828166ff0e4b26e4ba3197fe41c41b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6cbc1c583a7d027$var$_react = $a6cbc1c583a7d027$var$_interopRequireDefault((parcelRequire("4tluv")));

var $a6cbc1c583a7d027$var$_baseNew = $a6cbc1c583a7d027$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $a6cbc1c583a7d027$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Atom".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a6cbc1c583a7d027$var$AtomIcon = (props)=>/*#__PURE__*/ $a6cbc1c583a7d027$var$_react.default.createElement($a6cbc1c583a7d027$var$_baseNew.default, Object.assign({
        name: "AtomIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M9.87 1.42c1.566-.567 3.258-.667 4.318.393 1.059 1.059.959 2.75.392 4.317A11 11 0 0 1 13.683 8c.376.635.678 1.265.897 1.87.567 1.566.667 3.258-.393 4.318-1.059 1.059-2.75.959-4.317.392A11 11 0 0 1 8 13.683a11 11 0 0 1-1.87.897c-1.566.567-3.258.667-4.317-.393-1.06-1.059-.96-2.75-.393-4.317.219-.605.52-1.235.896-1.87a11 11 0 0 1-.896-1.87c-.567-1.566-.667-3.258.393-4.317C2.872.753 4.563.853 6.13 1.42c.605.219 1.235.52 1.87.896a11 11 0 0 1 1.87-.896M3.26 9.397a9 9 0 0 0-.43.983c-.521 1.44-.362 2.342.043 2.747s1.306.564 2.747.043a9 9 0 0 0 .983-.43 17 17 0 0 1-1.785-1.558A17 17 0 0 1 3.26 9.397m9.48 0a17.4 17.4 0 0 1-3.343 3.342q.507.258.983.431c1.44.521 2.342.362 2.747-.043s.564-1.306.043-2.747a9 9 0 0 0-.43-.983M8 4.099a15.5 15.5 0 0 0-2.121 1.78A15.5 15.5 0 0 0 4.099 8a15.4 15.4 0 0 0 1.78 2.121A15.5 15.5 0 0 0 8 11.901a15.5 15.5 0 0 0 2.121-1.78A15.5 15.5 0 0 0 11.901 8a15.5 15.5 0 0 0-1.78-2.121A15.5 15.5 0 0 0 8 4.099M5.62 2.83c-1.44-.521-2.342-.362-2.747.043S2.31 4.18 2.83 5.62q.173.475.43.983c.46-.607.981-1.207 1.558-1.785A17 17 0 0 1 6.603 3.26a9 9 0 0 0-.983-.43m7.507.043c-.405-.405-1.306-.564-2.747-.043a9 9 0 0 0-.983.43c.607.46 1.207.981 1.785 1.558a17 17 0 0 1 1.557 1.785 9 9 0 0 0 .431-.983c.521-1.44.362-2.342-.043-2.747"/><path fill="currentcolor" d="M9 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$a6cbc1c583a7d027$var$AtomIcon.displayName = 'AtomIcon';
var $a6cbc1c583a7d027$var$_default = module.exports.default = $a6cbc1c583a7d027$var$AtomIcon;

});

parcelRegister("e6p74", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e990a01e1f886ae319272b03d75a687b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a4451b2c18a548dc$var$_react = $a4451b2c18a548dc$var$_interopRequireDefault((parcelRequire("4tluv")));

var $a4451b2c18a548dc$var$_baseNew = $a4451b2c18a548dc$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $a4451b2c18a548dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingFive".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H5 / Heading 5 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a4451b2c18a548dc$var$TextHeadingFiveIcon = (props)=>/*#__PURE__*/ $a4451b2c18a548dc$var$_react.default.createElement($a4451b2c18a548dc$var$_baseNew.default, Object.assign({
        name: "TextHeadingFiveIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 8.5h-3.75a.75.75 0 0 0-.75.75v3c0 .41.34.75.75.75h2.25v1.5h-3V16h3.13c.76 0 1.38-.62 1.38-1.37v-1.75c0-.76-.62-1.37-1.37-1.37H13V10h3zM2.5 6.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$a4451b2c18a548dc$var$TextHeadingFiveIcon.displayName = 'TextHeadingFiveIcon';
var $a4451b2c18a548dc$var$_default = module.exports.default = $a4451b2c18a548dc$var$TextHeadingFiveIcon;

});

parcelRegister("82lT2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a0ec299c9d9d8293148b95b4eb4ef8e6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5d9f7ce64b6bdbec$var$_react = $5d9f7ce64b6bdbec$var$_interopRequireDefault((parcelRequire("4tluv")));

var $5d9f7ce64b6bdbec$var$_baseNew = $5d9f7ce64b6bdbec$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $5d9f7ce64b6bdbec$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingFour".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H4 / Heading 4 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5d9f7ce64b6bdbec$var$TextHeadingFourIcon = (props)=>/*#__PURE__*/ $5d9f7ce64b6bdbec$var$_react.default.createElement($5d9f7ce64b6bdbec$var$_baseNew.default, Object.assign({
        name: "TextHeadingFourIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.5 12V8.5H11v3.63c0 .76.62 1.38 1.38 1.38h2.12V16H16V8.5h-1.5V12zm-10-5.75V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$5d9f7ce64b6bdbec$var$TextHeadingFourIcon.displayName = 'TextHeadingFourIcon';
var $5d9f7ce64b6bdbec$var$_default = module.exports.default = $5d9f7ce64b6bdbec$var$TextHeadingFourIcon;

});

parcelRegister("a322m", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6e4d3b8c2282199229e89fad097e5cbf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $750bc3b93ed050f8$var$_react = $750bc3b93ed050f8$var$_interopRequireDefault((parcelRequire("4tluv")));

var $750bc3b93ed050f8$var$_baseNew = $750bc3b93ed050f8$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $750bc3b93ed050f8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingOne".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H1 / Heading 1 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $750bc3b93ed050f8$var$TextHeadingOneIcon = (props)=>/*#__PURE__*/ $750bc3b93ed050f8$var$_react.default.createElement($750bc3b93ed050f8$var$_baseNew.default, Object.assign({
        name: "TextHeadingOneIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 6.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25zM12 8.5h1.75a.75.75 0 0 1 .75.75V16H13v-6h-1z" clip-rule="evenodd"/>`
    }, props));
$750bc3b93ed050f8$var$TextHeadingOneIcon.displayName = 'TextHeadingOneIcon';
var $750bc3b93ed050f8$var$_default = module.exports.default = $750bc3b93ed050f8$var$TextHeadingOneIcon;

});

parcelRegister("1P9nU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7ea50078a5999a2c3fbe51c1b3e78d4a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1541d57a1c8e063e$var$_react = $1541d57a1c8e063e$var$_interopRequireDefault((parcelRequire("4tluv")));

var $1541d57a1c8e063e$var$_baseNew = $1541d57a1c8e063e$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $1541d57a1c8e063e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingSix".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H6 / Heading 6 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1541d57a1c8e063e$var$TextHeadingSixIcon = (props)=>/*#__PURE__*/ $1541d57a1c8e063e$var$_react.default.createElement($1541d57a1c8e063e$var$_baseNew.default, Object.assign({
        name: "TextHeadingSixIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15.5 8.5h-2.62c-.76 0-1.37.62-1.37 1.38v4.75c0 .76.62 1.38 1.38 1.38h1.75c.76 0 1.38-.62 1.38-1.37v-1.75c0-.76-.62-1.37-1.37-1.37H13V10h2.5zM13 13h1.5v1.5H13zM2.5 6.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$1541d57a1c8e063e$var$TextHeadingSixIcon.displayName = 'TextHeadingSixIcon';
var $1541d57a1c8e063e$var$_default = module.exports.default = $1541d57a1c8e063e$var$TextHeadingSixIcon;

});

parcelRegister("dJUs7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eb8ba74bc7f968e3347d9c83c15417ee>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a00b449b4a4f0c8a$var$_react = $a00b449b4a4f0c8a$var$_interopRequireDefault((parcelRequire("4tluv")));

var $a00b449b4a4f0c8a$var$_baseNew = $a00b449b4a4f0c8a$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $a00b449b4a4f0c8a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingThree".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H3 / Heading 3 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a00b449b4a4f0c8a$var$TextHeadingThreeIcon = (props)=>/*#__PURE__*/ $a00b449b4a4f0c8a$var$_react.default.createElement($a00b449b4a4f0c8a$var$_baseNew.default, Object.assign({
        name: "TextHeadingThreeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.5 8.5h3.13c.76 0 1.38.62 1.38 1.38v4.75c0 .76-.62 1.38-1.37 1.38H11.5v-1.5h3V13h-3v-1.5h3V10h-3zm-9-2.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$a00b449b4a4f0c8a$var$TextHeadingThreeIcon.displayName = 'TextHeadingThreeIcon';
var $a00b449b4a4f0c8a$var$_default = module.exports.default = $a00b449b4a4f0c8a$var$TextHeadingThreeIcon;

});

parcelRegister("3n9uM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4280f54cb1f2416c8d1b430fc38ff118>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $274ae2b1645c8721$var$_react = $274ae2b1645c8721$var$_interopRequireDefault((parcelRequire("4tluv")));

var $274ae2b1645c8721$var$_baseNew = $274ae2b1645c8721$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $274ae2b1645c8721$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingTwo".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H2 / Heading 2 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $274ae2b1645c8721$var$TextHeadingTwoIcon = (props)=>/*#__PURE__*/ $274ae2b1645c8721$var$_react.default.createElement($274ae2b1645c8721$var$_baseNew.default, Object.assign({
        name: "TextHeadingTwoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.5 8.5h3.13c.76 0 1.38.62 1.38 1.38v1.75c0 .76-.62 1.38-1.37 1.38H13v1.5h3V16h-3.75a.75.75 0 0 1-.75-.75v-2.37c0-.76.62-1.37 1.38-1.37h1.62V10h-3zm-9-2.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$274ae2b1645c8721$var$TextHeadingTwoIcon.displayName = 'TextHeadingTwoIcon';
var $274ae2b1645c8721$var$_default = module.exports.default = $274ae2b1645c8721$var$TextHeadingTwoIcon;

});

parcelRegister("2Sy7t", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a6d0daa86571e434771830ab21d189b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $218b175d39349d7f$var$_react = $218b175d39349d7f$var$_interopRequireDefault((parcelRequire("4tluv")));

var $218b175d39349d7f$var$_baseNew = $218b175d39349d7f$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $218b175d39349d7f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextNormal".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing Paragraph text style / Normal text style.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $218b175d39349d7f$var$TextNormalIcon = (props)=>/*#__PURE__*/ $218b175d39349d7f$var$_react.default.createElement($218b175d39349d7f$var$_baseNew.default, Object.assign({
        name: "TextNormalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 1v1.5H8.751V15h-1.5V2.5H2.5V1z"/>`
    }, props));
$218b175d39349d7f$var$TextNormalIcon.displayName = 'TextNormalIcon';
var $218b175d39349d7f$var$_default = module.exports.default = $218b175d39349d7f$var$TextNormalIcon;

});

parcelRegister("6w0mT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f550c803053c031f05bc533bcabb23b5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4be60456a8d55dbf$var$_react = $4be60456a8d55dbf$var$_interopRequireDefault((parcelRequire("4tluv")));

var $4be60456a8d55dbf$var$_baseNew = $4be60456a8d55dbf$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $4be60456a8d55dbf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextSmall".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing small text style in text editor experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4be60456a8d55dbf$var$TextSmallIcon = (props)=>/*#__PURE__*/ $4be60456a8d55dbf$var$_react.default.createElement($4be60456a8d55dbf$var$_baseNew.default, Object.assign({
        name: "TextSmallIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11 1v1.5H6.251V15h-1.5V2.5H0V1zm3.5 11.375v-.5c0-.621-.504-1.125-1.125-1.125h-1.75A2.625 2.625 0 0 1 9 8.125v-.5A2.625 2.625 0 0 1 11.625 5H13.5A2.5 2.5 0 0 1 16 7.5h-1.5a1 1 0 0 0-1-1h-1.875c-.621 0-1.125.504-1.125 1.125v.5c0 .621.504 1.125 1.125 1.125h1.75A2.625 2.625 0 0 1 16 11.875v.5A2.625 2.625 0 0 1 13.375 15H11.5A2.5 2.5 0 0 1 9 12.5h1.5a1 1 0 0 0 1 1h1.875c.621 0 1.125-.504 1.125-1.125"/>`
    }, props));
$4be60456a8d55dbf$var$TextSmallIcon.displayName = 'TextSmallIcon';
var $4be60456a8d55dbf$var$_default = module.exports.default = $4be60456a8d55dbf$var$TextSmallIcon;

});

parcelRegister("4bN2M", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::74ca1dacf8943b30998c1339b14fef77>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $30ce3b96ae793b60$var$_react = $30ce3b96ae793b60$var$_interopRequireDefault((parcelRequire("4tluv")));

var $30ce3b96ae793b60$var$_baseNew = $30ce3b96ae793b60$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $30ce3b96ae793b60$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextParagraph".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Confluence Editor AI action for reformatting paragraphs into multiple shorter paragraphs
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $30ce3b96ae793b60$var$TextParagraphIcon = (props)=>/*#__PURE__*/ $30ce3b96ae793b60$var$_react.default.createElement($30ce3b96ae793b60$var$_baseNew.default, Object.assign({
        name: "TextParagraphIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.25 2.5a2.75 2.75 0 0 0 0 5.5H8V2.5zm3.25 0V15H8V9.5H6.25a4.25 4.25 0 0 1 0-8.5h5.5a.75.75 0 0 1 .75.75V15H11V2.5z" clip-rule="evenodd"/>`
    }, props));
$30ce3b96ae793b60$var$TextParagraphIcon.displayName = 'TextParagraphIcon';
var $30ce3b96ae793b60$var$_default = module.exports.default = $30ce3b96ae793b60$var$TextParagraphIcon;

});

parcelRegister("5f2B0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f5b21011f48bf458b340a61b5c22f75f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3d105df041a75499$var$_react = $3d105df041a75499$var$_interopRequireDefault((parcelRequire("4tluv")));

var $3d105df041a75499$var$_baseNew = $3d105df041a75499$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $3d105df041a75499$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextSubscript".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for subscript text formatting.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3d105df041a75499$var$TextSubscriptIcon = (props)=>/*#__PURE__*/ $3d105df041a75499$var$_react.default.createElement($3d105df041a75499$var$_baseNew.default, Object.assign({
        name: "TextSubscriptIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m6.26 8 3.69 6H8.19L5.4 9.47 2.78 14H1.05l3.46-6-3.46-6h1.73L5.4 6.53 8.19 2h1.76zm7.49.5h.08a.75.75 0 0 1 .67.75V16H13v-6h-1V8.5z"/>`
    }, props));
$3d105df041a75499$var$TextSubscriptIcon.displayName = 'TextSubscriptIcon';
var $3d105df041a75499$var$_default = module.exports.default = $3d105df041a75499$var$TextSubscriptIcon;

});

parcelRegister("b3uq3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4915c62246fa16053f30e48aed5989a6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0213bc29e2a68d6d$var$_react = $0213bc29e2a68d6d$var$_interopRequireDefault((parcelRequire("4tluv")));

var $0213bc29e2a68d6d$var$_baseNew = $0213bc29e2a68d6d$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $0213bc29e2a68d6d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextSuperscript".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for superscript text formatting.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0213bc29e2a68d6d$var$TextSuperscriptIcon = (props)=>/*#__PURE__*/ $0213bc29e2a68d6d$var$_react.default.createElement($0213bc29e2a68d6d$var$_baseNew.default, Object.assign({
        name: "TextSuperscriptIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m6.26 8 3.69 6H8.19L5.4 9.47 2.78 14H1.05l3.46-6-3.46-6h1.73L5.4 6.53 8.19 2h1.76zm7.49-8h.08a.75.75 0 0 1 .67.75V7.5H13v-6h-1V0z"/>`
    }, props));
$0213bc29e2a68d6d$var$TextSuperscriptIcon.displayName = 'TextSuperscriptIcon';
var $0213bc29e2a68d6d$var$_default = module.exports.default = $0213bc29e2a68d6d$var$TextSuperscriptIcon;

});

parcelRegister("8Ki0n", function(module, exports) {
$parcel$export(module.exports, "default", () => $f8753113b63350cb$export$2e2bcd8739ae039);
/* form-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");
const $f8753113b63350cb$var$formFooterWrapperStyles = null;
const $f8753113b63350cb$var$justifyContentStyles = null;
function $f8753113b63350cb$export$2e2bcd8739ae039({ align: align = 'end', children: children }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)("footer", {
        className: (0, $jAkMr.default)([
            "_1e0c1txw _1bahesu3 _1pfh1ejb",
            align === 'start' && "_1bah1y6m"
        ]),
        children: children
    });
}

});

parcelRegister("dICSU", function(module, exports) {
$parcel$export(module.exports, "default", () => $38f3f38e5a663cd2$export$2e2bcd8739ae039);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $ccErM = parcelRequire("ccErM");

var $7xf5c = parcelRequire("7xf5c");

var $2ICGb = parcelRequire("2ICGb");

var $jCUk1 = parcelRequire("jCUk1");

var $1FIyg = parcelRequire("1FIyg");

var $5UU2C = parcelRequire("5UU2C");

var $hcSxw = parcelRequire("hcSxw");
/**
 * __Dropdown item checkbox__
 *
 * A dropdown item checkbox creates groups that have multiple selections.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/usage)
 */ const $38f3f38e5a663cd2$var$DropdownItemCheckbox = ({ children: children, defaultSelected: defaultSelected, description: description, id: id, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $ccErM.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, testId: testId, interactionName: interactionName, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $hcSxw;
    const [selected, setSelected] = (0, $1FIyg.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $4tluv.useCallback)((event)=>{
        setSelected((selected)=>!selected);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $5UU2C.default)();
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $7xf5c.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none",
        children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $2ICGb.default), {
            "aria-checked": selected,
            description: description,
            iconBefore: /*#__PURE__*/ (0, $2iln5.jsx)((0, $jCUk1.default), {
                checked: selected
            }),
            id: id,
            isDisabled: isDisabled,
            isSelected: selected,
            onClick: onClickHandler,
            ref: itemRef,
            role: "menuitemcheckbox",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            interactionName: interactionName,
            ...rest,
            children: children
        })
    });
};
var $38f3f38e5a663cd2$export$2e2bcd8739ae039 = $38f3f38e5a663cd2$var$DropdownItemCheckbox;

});
parcelRegister("jCUk1", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ed4eb3a0eaa6b64$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $jAkMr = parcelRequire("jAkMr");
parcelRequire("4tluv");
const $3ed4eb3a0eaa6b64$var$svgStyles = null;
/**
 * __Checkbox icon__
 *
 * Used to visually represent the selected state in DropdownItemCheckbox
 *
 * @internal
 */ const $3ed4eb3a0eaa6b64$var$CheckboxIcon = ({ checked: checked })=>{
    return /*#__PURE__*/ (0, $2iln5.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            color: checked ? "var(--ds-background-selected-bold, #1868DB)" : "var(--ds-background-input, #FFFFFF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            fill: checked ? "var(--ds-icon-inverse, #FFFFFF)" : 'transparent'
        },
        role: "presentation",
        className: (0, $jAkMr.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $2iln5.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $2iln5.jsx)("rect", {
                    stroke: checked ? "var(--ds-border-selected, #1868DB)" : "var(--ds-border-input, #8C8F97)",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $2iln5.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                    fill: "inherit"
                })
            ]
        })
    });
};
var $3ed4eb3a0eaa6b64$export$2e2bcd8739ae039 = $3ed4eb3a0eaa6b64$var$CheckboxIcon;

});

parcelRegister("1FIyg", function(module, exports) {
$parcel$export(module.exports, "default", () => $4216fd58ba92be6c$export$2e2bcd8739ae039);

var $4tluv = parcelRequire("4tluv");

var $j92Ai = parcelRequire("j92Ai");

var $f4cOM = parcelRequire("f4cOM");
/**
 * Custom hook to handle checkbox state for dropdown menu.
 * It works in tandem with the selection store context when the
 * component is uncontrolled.
 */ const $4216fd58ba92be6c$var$useCheckboxState = ({ isSelected: isSelected, id: id, defaultSelected: defaultSelected })=>{
    const { setItemState: setItemState, getItemState: getItemState } = (0, $4tluv.useContext)((0, $f4cOM.SelectionStoreContext));
    const groupId = (0, $4tluv.useContext)((0, $j92Ai.CheckboxGroupContext));
    const persistedIsSelected = getItemState(groupId, id);
    const [localIsSelected, setLocalIsSelected] = (0, $4tluv.useState)(// Initial state is set depending on value being defined or not.
    // This state is only utilised if the checkbox is uncontrolled.
    ()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $4tluv.useCallback)((newValue)=>{
        const nextValue = newValue(persistedIsSelected);
        setLocalIsSelected(nextValue);
        setItemState(groupId, id, nextValue);
    }, [
        setItemState,
        persistedIsSelected,
        groupId,
        id
    ]);
    // Checkbox is controlled - do nothing!
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    // Checkbox is going through its first render pass!
    if (persistedIsSelected === undefined) // Set the item so we have this state to access next time the checkbox renders (either by mounting or re-rendering!)
    setItemState(groupId, id, defaultSelected || false);
    // Return the value and setter!
    // Remember this flow is only returned if the checkbox is uncontrolled.
    return [
        localIsSelected,
        setLocalState
    ];
};
var $4216fd58ba92be6c$export$2e2bcd8739ae039 = $4216fd58ba92be6c$var$useCheckboxState;

});
parcelRegister("j92Ai", function(module, exports) {
$parcel$export(module.exports, "CheckboxGroupContext", () => $dca135130b55d709$export$baf37c4be89255b8);

var $4tluv = parcelRequire("4tluv");
const $dca135130b55d709$export$baf37c4be89255b8 = /*#__PURE__*/ (0, $4tluv.createContext)('');

});



parcelRegister("3CeMN", function(module, exports) {
$parcel$export(module.exports, "default", () => $be363c7ba240430f$export$2e2bcd8739ae039);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $fEY94 = parcelRequire("fEY94");

var $jdECH = parcelRequire("jdECH");

var $lqANn = parcelRequire("lqANn");

var $j92Ai = parcelRequire("j92Ai");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu checkbox items.
 *
 */ const $be363c7ba240430f$var$DropdownItemCheckboxGroup = ({ children: children, hasSeparator: hasSeparator, id: id, isList: isList, isScrollable: isScrollable, testId: testId, title: title, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    const uid = (0, $fEY94.useId)();
    const titleId = `dropdown-menu-item-checkbox-group-title-${uid}`;
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $j92Ai.CheckboxGroupContext).Provider, {
        value: id,
        children: /*#__PURE__*/ (0, $2iln5.jsxs)((0, $jdECH.default), {
            hasSeparator: hasSeparator,
            id: id,
            isList: isList,
            isScrollable: isScrollable,
            testId: testId,
            titleId: title ? titleId : undefined,
            ...rest,
            children: [
                title && /*#__PURE__*/ (0, $2iln5.jsx)((0, $lqANn.default), {
                    id: titleId,
                    title: title
                }),
                children
            ]
        })
    });
};
var $be363c7ba240430f$export$2e2bcd8739ae039 = $be363c7ba240430f$var$DropdownItemCheckboxGroup;

});

parcelRegister("5rODF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c07c4c04f9f99a3868a6c26b78654ed8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3f76c1315242ca34$var$_react = $3f76c1315242ca34$var$_interopRequireDefault((parcelRequire("4tluv")));

var $3f76c1315242ca34$var$_baseNew = $3f76c1315242ca34$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $3f76c1315242ca34$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Known uses: None
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3f76c1315242ca34$var$BookOpenIcon = (props)=>/*#__PURE__*/ $3f76c1315242ca34$var$_react.default.createElement($3f76c1315242ca34$var$_baseNew.default, Object.assign({
        name: "BookOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.5 2.25v10H8.75V4.625a2.375 2.375 0 0 1 2.375-2.375zM8 2.333A3.87 3.87 0 0 1 11.125.75h3.501C15.387.75 16 1.367 16 2.125v10.25c0 .76-.616 1.375-1.375 1.375H8.75v1.5h-1.5v-1.5H1.375C.615 13.75 0 13.134 0 12.375V2.125C0 1.366.615.75 1.375.75h3.5A3.87 3.87 0 0 1 8 2.333m-.75 9.917V4.625A2.375 2.375 0 0 0 4.875 2.25H1.5v10zm6-8H10.5v1.5h2.75zm0 2.5H10.5v1.5h2.75z" clip-rule="evenodd"/>`
    }, props));
$3f76c1315242ca34$var$BookOpenIcon.displayName = 'BookOpenIcon';
var $3f76c1315242ca34$var$_default = module.exports.default = $3f76c1315242ca34$var$BookOpenIcon;

});

parcelRegister("7lAM7", function(module, exports) {
$parcel$export(module.exports, "default", () => $d25fd5227eb22c7f$export$2e2bcd8739ae039);
/* bleed.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $jAkMr = parcelRequire("jAkMr");

var $4tluv = parcelRequire("4tluv");
// NOTE: This maintains a full map of 10 styles as Bleed is a bit of a semantic outlier
const $d25fd5227eb22c7f$var$styles = {
    root: "_vchhusvi",
    'inline.space.025': "_195g1i6y",
    'inline.space.050': "_195gr5cr",
    'inline.space.100': "_195gx0bf",
    'inline.space.150': "_195gxmi2",
    'inline.space.200': "_195gmgjw",
    'block.space.025': "_1mou1i6y",
    'block.space.050': "_1mour5cr",
    'block.space.100': "_1moux0bf",
    'block.space.150': "_1mouxmi2",
    'block.space.200': "_1moumgjw"
};
/**
 * __Bleed__
 *
 * `Bleed` is a primitive layout component that controls negative whitespace.
 *
 * - [Examples](https://atlassian.design/components/primitives/bleed/examples)
 * - [Code](https://atlassian.design/components/primitives/bleed/code)
 */ const $d25fd5227eb22c7f$var$Bleed = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).memo(({ children: children, testId: testId, inline: inline, block: block, all: all, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $2iln5.jsx)("div", {
        className: (0, $jAkMr.default)([
            $d25fd5227eb22c7f$var$styles.root,
            all && $d25fd5227eb22c7f$var$styles[`inline.${all}`],
            inline && $d25fd5227eb22c7f$var$styles[`inline.${inline}`],
            all && $d25fd5227eb22c7f$var$styles[`block.${all}`],
            block && $d25fd5227eb22c7f$var$styles[`block.${block}`],
            xcss
        ]),
        "data-testid": testId,
        children: children
    });
});
$d25fd5227eb22c7f$var$Bleed.displayName = 'Bleed';
var $d25fd5227eb22c7f$export$2e2bcd8739ae039 = $d25fd5227eb22c7f$var$Bleed;

});

parcelRegister("5DhZA", function(module, exports) {
$parcel$export(module.exports, "useFormState", () => $1f1f109ee34aa23e$export$606f11b2eb45ecc6);

var $4tluv = parcelRequire("4tluv");

var $kUEnn = parcelRequire("kUEnn");
// Constantized to avoid a new object reference built every call
const $1f1f109ee34aa23e$var$defaultSubscriptionConfig = {
    values: true
};
/**
 * Build a simple hash for a given subscription object for use in a `useMemo` dependencies array.
 * This is because `{ values: true } !== { values: true }`, but `'values:true|' === 'values:true|'`
 *
 * @example { values: true, dirty: false } => 'values:true|dirty:false|'
 */ const $1f1f109ee34aa23e$var$getSubscriptionHash = (subscriptionConfig)=>{
    let hash = '';
    for(const key in subscriptionConfig)if (subscriptionConfig.hasOwnProperty(key)) hash += `${key}:${subscriptionConfig[key]}|`;
    return hash;
};
const $1f1f109ee34aa23e$export$606f11b2eb45ecc6 = (subscriptionConfig = $1f1f109ee34aa23e$var$defaultSubscriptionConfig)=>{
    const { subscribe: subscribe } = (0, $4tluv.useContext)((0, $kUEnn.FormContext));
    const [state, setState] = (0, $4tluv.useState)();
    /**
   * A hash for us to shallow compare the subscriptionConfig object to react to shallow changes, but avoid referential changes.
   * We avoid computing the hash if the subscription config has referential equality altogether.
   */ const subscriptionConfigHash = (0, $4tluv.useMemo)(()=>$1f1f109ee34aa23e$var$getSubscriptionHash(subscriptionConfig), [
        subscriptionConfig
    ]);
    /**
   * Return a memoized version of the subscription config to only react to shallow changes, not referential changes.
   * Eg. calling `useFormState({ values: true })` twice will result in two different objects by reference, but not by shallow comparison.
   * This will ensure we don't re-subscribe to the form state when the subscription config is the same.
   */ const config = (0, $4tluv.useMemo)(()=>subscriptionConfig, // eslint-disable-next-line react-hooks/exhaustive-deps -- intentionally controlled with a hash to have an explicit shallow comparison
    [
        subscriptionConfigHash
    ]);
    (0, $4tluv.useEffect)(()=>{
        const unsubscribe = subscribe((formState)=>{
            setState(formState);
        }, config);
        return ()=>unsubscribe();
    }, [
        subscribe,
        config
    ]);
    return state;
};

});

parcelRegister("9H6lE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0c82000dc806c2316f0968120fc4d10f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $70ed0dd9c9ff5c25$var$_react = $70ed0dd9c9ff5c25$var$_interopRequireDefault((parcelRequire("4tluv")));

var $70ed0dd9c9ff5c25$var$_baseNew = $70ed0dd9c9ff5c25$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $70ed0dd9c9ff5c25$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Lozenge".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for inserting status lozenges in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $70ed0dd9c9ff5c25$var$LozengeIcon = (props)=>/*#__PURE__*/ $70ed0dd9c9ff5c25$var$_react.default.createElement($70ed0dd9c9ff5c25$var$_baseNew.default, Object.assign({
        name: "LozengeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V6a.5.5 0 0 0-.5-.5zm11 3.25H3v-1.5h10z" clip-rule="evenodd"/>`
    }, props));
$70ed0dd9c9ff5c25$var$LozengeIcon.displayName = 'LozengeIcon';
var $70ed0dd9c9ff5c25$var$_default = module.exports.default = $70ed0dd9c9ff5c25$var$LozengeIcon;

});

parcelRegister("ffpNO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a0b019b9a1703ba836e9431143f4089a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b19c458a0384c0e4$var$_react = $b19c458a0384c0e4$var$_interopRequireDefault((parcelRequire("4tluv")));

var $b19c458a0384c0e4$var$_baseNew = $b19c458a0384c0e4$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $b19c458a0384c0e4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Repeat".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for setting objects to recur (eg Work items, Forms)
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b19c458a0384c0e4$var$RepeatIcon = (props)=>/*#__PURE__*/ $b19c458a0384c0e4$var$_react.default.createElement($b19c458a0384c0e4$var$_baseNew.default, Object.assign({
        name: "RepeatIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m8.78 3.72-3-3-1.06 1.06L6.44 3.5H4.5a4.5 4.5 0 0 0 0 9h1V11h-1a3 3 0 0 1 0-6h1.94L4.72 6.72l1.06 1.06 3-3a.75.75 0 0 0 0-1.06M11.5 5a3 3 0 1 1 0 6H9.56l1.72-1.72-1.06-1.06-3 3a.75.75 0 0 0 0 1.06l3 3 1.06-1.06-1.72-1.72h1.94a4.5 4.5 0 1 0 0-9h-1V5z" clip-rule="evenodd"/>`
    }, props));
$b19c458a0384c0e4$var$RepeatIcon.displayName = 'RepeatIcon';
var $b19c458a0384c0e4$var$_default = module.exports.default = $b19c458a0384c0e4$var$RepeatIcon;

});

parcelRegister("dLeph", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::81ff0ece5a5fcc077ae0770ac0c0ffcf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0295da2d7690a7db$var$_react = $0295da2d7690a7db$var$_interopRequireDefault((parcelRequire("4tluv")));

var $0295da2d7690a7db$var$_baseNew = $0295da2d7690a7db$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $0295da2d7690a7db$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ReplyRight".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Known uses: replying to a message thread
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0295da2d7690a7db$var$ReplyRightIcon = (props)=>/*#__PURE__*/ $0295da2d7690a7db$var$_react.default.createElement($0295da2d7690a7db$var$_baseNew.default, Object.assign({
        name: "ReplyRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m10.22 2.28 3.22 3.219H8.5a8.5 8.5 0 0 0-8.5 8.5h1.5a7 7 0 0 1 7-7h4.94l-3.22 3.22 1.06 1.06 4.5-4.5a.75.75 0 0 0 0-1.06l-4.5-4.5z"/>`
    }, props));
$0295da2d7690a7db$var$ReplyRightIcon.displayName = 'ReplyRightIcon';
var $0295da2d7690a7db$var$_default = module.exports.default = $0295da2d7690a7db$var$ReplyRightIcon;

});

parcelRegister("5eM2q", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9ae989161e32c463035303e756b6dca8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3d0385e7f4f22ce2$var$_react = $3d0385e7f4f22ce2$var$_interopRequireDefault((parcelRequire("4tluv")));

var $3d0385e7f4f22ce2$var$_baseNew = $3d0385e7f4f22ce2$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $3d0385e7f4f22ce2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Return".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for submitting text fields without dedicated button, mainly AI prompts
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3d0385e7f4f22ce2$var$ReturnIcon = (props)=>/*#__PURE__*/ $3d0385e7f4f22ce2$var$_react.default.createElement($3d0385e7f4f22ce2$var$_baseNew.default, Object.assign({
        name: "ReturnIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.5 8V3H14v5.438c0 .586-.476 1.062-1.062 1.062H4.56l2.72 2.72-1.061 1.06-4-4a.75.75 0 0 1 0-1.06l4-4 1.06 1.06L4.56 8z" clip-rule="evenodd"/>`
    }, props));
$3d0385e7f4f22ce2$var$ReturnIcon.displayName = 'ReturnIcon';
var $3d0385e7f4f22ce2$var$_default = module.exports.default = $3d0385e7f4f22ce2$var$ReturnIcon;

});

parcelRegister("4KZHG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3aa391a3d57e28f300b24cee0bba3c43>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $376b5254f173c519$var$_react = $376b5254f173c519$var$_interopRequireDefault((parcelRequire("4tluv")));

var $376b5254f173c519$var$_baseNew = $376b5254f173c519$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $376b5254f173c519$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Spaces".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for use for Jira Projects for now. This will replace the Jira rocket. 

More context: Later, it will eventually replace the Confluence Spaces icon later when Jira Projects -> Jira Spaces. This is a planned phased rollout.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $376b5254f173c519$var$SpacesIcon = (props)=>/*#__PURE__*/ $376b5254f173c519$var$_react.default.createElement($376b5254f173c519$var$_baseNew.default, Object.assign({
        name: "SpacesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.809 9.496a5.98 5.98 0 0 1-2.809 3.7 5.98 5.98 0 0 1-4.608.583 29.4 29.4 0 0 0 3.858-1.881 29.4 29.4 0 0 0 3.559-2.402"/><path fill="currentcolor" fill-rule="evenodd" d="M5 2.804a6 6 0 0 1 6.515.333c.859-.264 1.65-.425 2.308-.447.377-.013.751.017 1.083.126.338.11.678.32.888.684.354.613.152 1.297-.107 1.8-.276.538-.736 1.113-1.306 1.688q-.197.196-.413.397a20 20 0 0 1-1.517 1.263 29 29 0 0 1-2.951 1.95 29 29 0 0 1-3.165 1.58c-.65.275-1.272.506-1.85.683h-.003q-.28.087-.548.159c-.783.206-1.511.317-2.116.288-.505-.025-1.114-.162-1.49-.63l-.052-.069-.07-.109-.07-.139a1.6 1.6 0 0 1-.078-.972c.071-.342.231-.681.431-1.001.35-.559.883-1.164 1.541-1.776A6 6 0 0 1 5 2.804m-2.541 7.499c-.302.324-.536.62-.698.879-.147.235-.213.407-.236.515l-.004.046c.048.022.155.056.37.067.329.016.78-.036 1.343-.165a6 6 0 0 1-.775-1.342m8.429-5.756A4.502 4.502 0 0 0 3.52 8.435l.045.34c.089.504.265 1.004.538 1.475.198.344.435.652.702.921 1.181-.43 2.542-1.062 3.945-1.872s2.63-1.672 3.593-2.48a4.5 4.5 0 0 0-1.31-2.146zm2.987-.36a6 6 0 0 0-1.111.166q.233.306.432.647.196.341.342.695c.394-.423.665-.788.816-1.08.098-.192.121-.303.127-.355q-.016-.009-.041-.019a1.7 1.7 0 0 0-.565-.053" clip-rule="evenodd"/>`
    }, props));
$376b5254f173c519$var$SpacesIcon.displayName = 'SpacesIcon';
var $376b5254f173c519$var$_default = module.exports.default = $376b5254f173c519$var$SpacesIcon;

});

parcelRegister("h4ZuH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8306b821ef694f38a906a83337269c35>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6f282d5a7f638f7$var$_react = $c6f282d5a7f638f7$var$_interopRequireDefault((parcelRequire("4tluv")));

var $c6f282d5a7f638f7$var$_baseNew = $c6f282d5a7f638f7$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $c6f282d5a7f638f7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeSlides".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Confluence Slides
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c6f282d5a7f638f7$var$AiGenerativeSlidesIcon = (props)=>/*#__PURE__*/ $c6f282d5a7f638f7$var$_react.default.createElement($c6f282d5a7f638f7$var$_baseNew.default, Object.assign({
        name: "AiGenerativeSlidesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 10V3.5H0V2h8v1.5H2.5V10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5H15V10a2 2 0 0 1-2 2h-1.376l1.822 2.139-1.142.972L9.654 12H8.75v3h-1.5v-3h-.903l-2.65 3.111-1.143-.972L4.376 12H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M13.115.009a.75.75 0 0 1 .541.378l.05.106.4 1.102c.051.138.16.248.3.299l1.1.4a.75.75 0 0 1 0 1.411l-1.1.401a.5.5 0 0 0-.3.3l-.4 1.1a.75.75 0 0 1-1.411 0l-.401-1.1a.5.5 0 0 0-.3-.3l-1.1-.4a.75.75 0 0 1-.485-.59L10 3l.009-.116a.75.75 0 0 1 .484-.59l1.102-.4a.5.5 0 0 0 .299-.3l.4-1.1.05-.107A.75.75 0 0 1 12.999 0z"/>`
    }, props));
$c6f282d5a7f638f7$var$AiGenerativeSlidesIcon.displayName = 'AiGenerativeSlidesIcon';
var $c6f282d5a7f638f7$var$_default = module.exports.default = $c6f282d5a7f638f7$var$AiGenerativeSlidesIcon;

});

parcelRegister("692PR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79393cf52935af5d2ce7204817b33e1d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4795c864c8979184$var$_react = $4795c864c8979184$var$_interopRequireDefault((parcelRequire("4tluv")));

var $4795c864c8979184$var$_baseNew = $4795c864c8979184$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $4795c864c8979184$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Randomize".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for randomizing or shuffling functionality.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4795c864c8979184$var$RandomizeIcon = (props)=>/*#__PURE__*/ $4795c864c8979184$var$_react.default.createElement($4795c864c8979184$var$_baseNew.default, Object.assign({
        name: "RandomizeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M15.78 11.22a.75.75 0 0 1 .052 1.004l-.052.056-2.5 2.5-1.06-1.06 1.22-1.22h-2.845a2 2 0 0 1-1.552-.74l-1.124-1.382.967-1.189 1.321 1.626a.5.5 0 0 0 .388.185h2.845l-1.22-1.22 1.06-1.06z"/><path fill="currentcolor" d="m15.78 3.72.05.06a.75.75 0 0 1-.05 1l-2.5 2.5-1.06-1.06L13.44 5H10.6a.5.5 0 0 0-.39.19l-5.75 7.08a2 2 0 0 1-1.55.73H0v-1.5h2.91a.5.5 0 0 0 .39-.18l5.75-7.08a2 2 0 0 1 1.55-.74h2.85l-1.22-1.22 1.06-1.06zM2.91 3a2 2 0 0 1 1.55.74l1.53 1.88-.97 1.19-1.73-2.13a.5.5 0 0 0-.39-.18H0V3z"/>`
    }, props));
$4795c864c8979184$var$RandomizeIcon.displayName = 'RandomizeIcon';
var $4795c864c8979184$var$_default = module.exports.default = $4795c864c8979184$var$RandomizeIcon;

});

parcelRegister("iqWLC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::619fb4ad6cec2107e8d1f4fc5bb05b5a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d6b83d987bb8ff66$var$_react = $d6b83d987bb8ff66$var$_interopRequireDefault((parcelRequire("4tluv")));

var $d6b83d987bb8ff66$var$_baseNew = $d6b83d987bb8ff66$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $d6b83d987bb8ff66$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "History".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for history and recent
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d6b83d987bb8ff66$var$HistoryIcon = (props)=>/*#__PURE__*/ $d6b83d987bb8ff66$var$_react.default.createElement($d6b83d987bb8ff66$var$_baseNew.default, Object.assign({
        name: "HistoryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1.5 8A6.5 6.5 0 1 0 8 1.5a6.36 6.36 0 0 0-4.651 2.005l1.298.26a.75.75 0 0 1-.09 1.483l-3.25.25A.75.75 0 0 1 .5 4.75V1.5l.013-.137a.75.75 0 0 1 1.456-.079l.34 1.138A7.86 7.86 0 0 1 8 0a8 8 0 1 1-8 8zm7.25-4.25v4.389l2.219 1.775-.938 1.172-2.5-2A.75.75 0 0 1 7.25 8.5V3.75z"/>`
    }, props));
$d6b83d987bb8ff66$var$HistoryIcon.displayName = 'HistoryIcon';
var $d6b83d987bb8ff66$var$_default = module.exports.default = $d6b83d987bb8ff66$var$HistoryIcon;

});

parcelRegister("aFjPS", function(module, exports) {
$parcel$export(module.exports, "PanelSplitter", () => $45d34c621bc97e36$export$db67e3f8d3d6da0f);
/* panel-splitter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");

var $Hyfcf = parcelRequire("Hyfcf");

var $lImzW = parcelRequire("lImzW");

var $kEkKo = parcelRequire("kEkKo");

var $fEY94 = parcelRequire("fEY94");

var $aH1KC = parcelRequire("aH1KC");

var $6ZwWP = parcelRequire("6ZwWP");

var $9Zu6O = parcelRequire("9Zu6O");

var $4LjiE = parcelRequire("4LjiE");

var $kR6CH = parcelRequire("kR6CH");

var $5sUv1 = parcelRequire("5sUv1");

var $kNrNf = parcelRequire("kNrNf");

var $eCj8S = parcelRequire("eCj8S");

var $6KwsR = parcelRequire("6KwsR");

var $k7gbB = parcelRequire("k7gbB");

var $ltmxR = parcelRequire("ltmxR");

var $3CMDc = parcelRequire("3CMDc");

var $8kPj9 = parcelRequire("8kPj9");

var $dFIQa = parcelRequire("dFIQa");

var $2ExWa = parcelRequire("2ExWa");

var $dtkkI = parcelRequire("dtkkI");

var $2u2R1 = parcelRequire("2u2R1");

var $agKqx = parcelRequire("agKqx");

var $aS84f = parcelRequire("aS84f");

var $fBEso = parcelRequire("fBEso");

var $6m2Lr = parcelRequire("6m2Lr");
function $45d34c621bc97e36$var$signPanelSplitterDragData(data) {
    return {
        ...data,
        [(0, $6m2Lr.panelSplitterDragDataSymbol)]: true
    };
}
const $45d34c621bc97e36$var$containerStyles = {
    root: "_12ji1r31 _1qu2glyw _12y31o36 _1e0cglyw _kqswstnw _u7coidpf _152tidpf _1pbykb7n _181n1ule",
    positionEnd: "_rjxpftgi",
    positionStart: "_1e02zeo2"
};
const $45d34c621bc97e36$var$grabAreaStyles = {
    root: "_1bsbl52n _4t3i1osq _kqswstnw _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _syaz1j28 _bfhk1j28 _1oec6ebc _1lww188d _6fl41ytf _k8m01ylx _d0aluf7j _vp7g6x5g _30l36x5g _1gglglyw _9h8h12zz",
    fullHeightSidebar: "_d0al11mm"
};
const $45d34c621bc97e36$var$lineStyles = {
    root: "_kqswstnw _1e0c1ule _1bsb1l7b _4t3i1osq _syaz1kw7 _bfhk1r31 _1e021v6z"
};
const $45d34c621bc97e36$var$tooltipStyles = {
    root: "_ahbq196n _1bsb1ris"
};
const $45d34c621bc97e36$var$PanelSplitterTooltip = /*#__PURE__*/ (0, $4tluv.forwardRef)(({ children: children, className: className, ...props }, ref)=>{
    const style = (0, $4tluv.useMemo)(()=>{
        if (!props.style || !props.style.transform) return props.style;
        // We cannot just match against integers safely, as browsers may introduce non-integer values due to scaling
        // In the future we can probably use `CSSStyleValue.parse()` to get the browser to handle parsing for us,
        // but there's no Firefox support yet.
        const [translateX, translateY] = props.style.transform.matchAll(/(?:-|\+)?\d*\.?\d+px/g);
        if (!translateY) // If we can't extract the translateY value we bail out and return the original style
        return props.style;
        /**
     * Adjusts the translate Y to keep the tooltip within the main content area,
     * so that it does not appear over the banner or top navigation.
     */ const newTranslateY = `max(calc(${(0, $3CMDc.contentInsetBlockStart)} + ${"var(--ds-space-100, 8px)"}), ${translateY})`;
        const newTransform = `translate3d(${translateX}, ${newTranslateY}, 0)`;
        return {
            ...props.style,
            transform: newTransform
        };
    }, [
        props.style
    ]);
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $6KwsR.default), {
        ...props,
        ref: ref,
        // Must be statically passed
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $jAkMr.default)([
            $45d34c621bc97e36$var$tooltipStyles.root,
            className
        ]),
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        children: children
    });
});
/**
 * A wrapper component that renders a tooltip if the tooltipContent or shortcut is provided.
 */ const $45d34c621bc97e36$var$MaybeTooltip = ({ tooltipContent: tooltipContent, shortcut: shortcut, children: children, testId: testId })=>{
    const isFhsEnabled = (0, $ltmxR.useIsFhsEnabled)();
    if (tooltipContent && isFhsEnabled) return /*#__PURE__*/ (0, $2iln5.jsx)((0, $eCj8S.default), {
        testId: testId,
        content: tooltipContent,
        shortcut: shortcut,
        position: "mouse-y",
        mousePosition: "right",
        isScreenReaderAnnouncementDisabled: true,
        component: $45d34c621bc97e36$var$PanelSplitterTooltip,
        UNSAFE_shouldAlwaysFadeIn: true,
        UNSAFE_shouldRenderToParent: true,
        children: children
    });
    return children;
};
function $45d34c621bc97e36$var$getTextDirection(element) {
    const { direction: direction } = window.getComputedStyle(element);
    return direction === 'rtl' ? 'rtl' : 'ltr';
}
const $45d34c621bc97e36$var$PortaledPanelSplitter = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId, panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, getResizeBounds: getResizeBounds, panel: panel, portal: portal, resizingCssVar: resizingCssVar, position: position, tooltipContent: tooltipContent, shortcut: shortcut })=>{
    const isFhsEnabled = (0, $ltmxR.useIsFhsEnabled)();
    const splitterRef = (0, $4tluv.useRef)(null);
    const labelId = (0, $fEY94.useId)();
    // Separate state used for the input range width to remove the UI's dependency on the "persisted" layout state value being updated
    const [rangeInputValue, setRangeInputValue] = (0, $4tluv.useState)(panelWidth);
    /**
   * We are using state to store the resize bounds _converted into pixel units_, so that we can update them when the window is resized.
   * Otherwise they can become out of sync with the actual viewport size, and cause a broken experience (inaccurate width percentage)
   * when the user tries to resize using the keyboard.
   */ const [rangeInputBounds, setRangeInputBounds] = (0, $4tluv.useState)({
        // Using placeholder values here for the initial render. These will be calculated and updated when the range input is focused.
        min: 200,
        max: 500
    });
    const openLayerObserver = (0, $6ZwWP.useOpenLayerObserver)();
    /**
   * This is a temporary workaround to enable the `SideNavPanelSplitter` component
   * to collapse the side nav on double click, without exposing the `onDoubleClick` prop on `PanelSplitter`.
   * Once `PanelSplitter` supports an `onDoubleClick` prop directly, this context can be removed.
   */ const onDoubleClick = (0, $4tluv.useContext)((0, $aS84f.OnDoubleClickContext));
    // Storing the initial `clientX` on `mousedown` events, to workaround a bug caused by some browser extensions
    // where the `dragstart` event incorrectly returns `0` for the `clientX` location.
    const initialClientXRef = (0, $4tluv.useRef)(null);
    (0, $4tluv.useEffect)(()=>{
        const splitter = splitterRef.current;
        (0, $kEkKo.default)(splitter, 'Splitter ref must be set');
        return (0, $9Zu6O.combine)((0, $kR6CH.blockDraggingToIFrames)({
            element: splitter
        }), /**
     * Capturing the initial `clientX` from the mousedown, before the drag starts.
     *
     * ⚠️ Note: We are not using pragmatic-drag-and-drop's `onDragStart` for this as some browser
     * extensions can cause the client location (e.g. clientX) to incorrectly return 0 during the `dragstart` event.
     *
     * We are also not using pragmatic-drag-and-drop's `onDrag` here as it is throttled, which means
     * fast mouse movements can cause the real first drag event to be missed, causing a different clientX
     * to be captured.
     *
     * I also tried only binding an event listener inside pragmatic-drag-and-drop's `onDragStart`, which seemd to work
     * but did not feel as robust, and might have timing issues as it happens slightly later.
     */ (0, $Hyfcf.bind)(splitter, {
            type: 'mousedown',
            listener: (event)=>{
                initialClientXRef.current = event.clientX;
            }
        }), (0, $4LjiE.draggable)({
            element: splitter,
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                // We will be moving the line to indicate a drag. We can disable the native drag preview
                (0, $5sUv1.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                });
                // We don't want any native drop animation for when the user does not drop on a drop target. We want the drag to finish immediately
                (0, $kNrNf.preventUnhandled).start();
            },
            getInitialData () {
                const initialWidth = (0, $2ExWa.getPixelWidth)(panel);
                /**
         * The drag calculations require the actual computed width of the element
         * For example, if the panel has loaded with a width of 2000px, but the max bound is 1000px and is visually 1000px (due to the CSS `clamp()`),
         * the drag calculations should use the actual width of 1000px, not the width in state of 2000px.
         */ return $45d34c621bc97e36$var$signPanelSplitterDragData({
                    panelId: panelId,
                    initialWidth: initialWidth,
                    resizingWidth: `${initialWidth}px`,
                    resizeBounds: getResizeBounds(),
                    // Only computing text direction when we need it, just as the drag is starting.
                    // Recomputing text direction on each new drag in case the text direction
                    // has changed. This is unlikely, but being safe.
                    direction: $45d34c621bc97e36$var$getTextDirection(panel)
                });
            },
            onDragStart ({ source: source }) {
                /**
         * ⚠️ Note: We are not using the client locations (e.g. clientX) during `onDragStart`
         * because some browser extensions can cause the event properties to incorrectly return 0.
         */ (0, $kEkKo.default)((0, $2u2R1.isPanelSplitterDragData)(source.data));
                onResizeStart?.({
                    initialWidth: source.data.initialWidth
                });
                // Close any open layers when the user starts resizing
                openLayerObserver?.closeLayers();
            },
            onDrag ({ location: location, source: source }) {
                /**
         * ⚠️ Note: We are not using the location.initial.input client locations because some browser extensions
         * can cause the client locations (e.g. clientX) in the `dragstart` event to incorrectly return 0.
         */ (0, $kEkKo.default)((0, $2u2R1.isPanelSplitterDragData)(source.data));
                const { initialWidth: initialWidth, resizeBounds: resizeBounds, direction: direction } = source.data;
                (0, $kEkKo.default)(initialClientXRef.current !== null, 'initialClientX must be set');
                /**
         * How wide the element would be if there were no width constraints,
         * based on the pointer's position.
         */ const targetWidth = (0, $dtkkI.getWidthFromDragLocation)({
                    initialWidth: initialWidth,
                    location: location,
                    // The fallback of 0 won't be used due to the invariant, however we require one to satisfy the type.
                    initialClientX: initialClientXRef.current ?? 0,
                    direction: direction,
                    position: position
                });
                const resizingWidth = `clamp(${resizeBounds.min}, ${targetWidth}px, ${resizeBounds.max})`;
                panel.style.setProperty(resizingCssVar, resizingWidth);
                source.data.resizingWidth = resizingWidth;
            },
            onDrop ({ source: source }) {
                (0, $kEkKo.default)((0, $2u2R1.isPanelSplitterDragData)(source.data));
                (0, $kNrNf.preventUnhandled).stop();
                const finalWidth = (0, $2ExWa.getPixelWidth)(panel);
                onCompleteResize(finalWidth);
                onResizeEnd?.({
                    initialWidth: source.data.initialWidth,
                    finalWidth: finalWidth
                });
                panel.style.removeProperty(resizingCssVar);
            }
        }));
    }, [
        onCompleteResize,
        onResizeStart,
        onResizeEnd,
        panel,
        resizingCssVar,
        panelWidth,
        position,
        openLayerObserver,
        panelId,
        getResizeBounds
    ]);
    const onResizeStartStableRef = (0, $aH1KC.default)(onResizeStart);
    const onResizeEndStableRef = (0, $aH1KC.default)(onResizeEnd);
    const [keyboardResizeManager] = (0, $4tluv.useState)(()=>(0, $agKqx.createKeyboardResizeManager)({
            onResizeStart: (...args)=>{
                // Close any open layers when the user starts resizing with keyboard
                openLayerObserver?.closeLayers();
                onResizeStartStableRef.current?.(...args);
            },
            onResizeEnd: (...args)=>onResizeEndStableRef.current?.(...args)
        }));
    const handleSliderInputChange = (0, $4tluv.useCallback)((event)=>{
        const value = parseInt(event.target.value);
        setRangeInputValue(value);
        /**
     * We are intentionally _not_ debouncing `onCompleteResize` as we want it to be called anytime the user changes the range input value.
     * It is an internal-only callback - it's provided by `PanelSplitterProvider`, and used by layout slots to update their layout width state.
     */ onCompleteResize(value);
        keyboardResizeManager.onResize({
            initialWidth: panelWidth,
            finalWidth: value
        });
    }, [
        onCompleteResize,
        panelWidth,
        keyboardResizeManager
    ]);
    const resizeEventListenerCleanupFn = (0, $4tluv.useRef)(null);
    const handleSliderFocus = (0, $4tluv.useCallback)(()=>{
        /**
     * We are only updating the range input's properties when the element is focused, as a performance optimisation.
     * It isn't necessary to recalculate these values until the element is going to be used.
     */ // Clean up any left over listeners in case `focus` was triggered again without `blur`.
        resizeEventListenerCleanupFn.current?.();
        // Update the range input value to match the current panel width.
        setRangeInputValue(panelWidth);
        const resizeBounds = getResizeBounds();
        // Update the range input bounds to ensure they are accurate (in case the viewport was previously resized)
        setRangeInputBounds({
            min: (0, $8kPj9.convertResizeBoundToPixels)(resizeBounds.min),
            max: (0, $8kPj9.convertResizeBoundToPixels)(resizeBounds.max)
        });
        /**
     * _While the slider element is focused_, add a window resize event listener to update the range input bounds
     * when the window is resized. This is needed to ensure the min and max widths accurately reflect the viewport
     * size - in case they are provided in vw units.
     *
     * This listener is cleaned up when the element is blurred.
     */ resizeEventListenerCleanupFn.current = (0, $Hyfcf.bind)(window, {
            type: 'resize',
            listener: function updateState() {
                const resizeBounds = getResizeBounds();
                setRangeInputBounds({
                    min: (0, $8kPj9.convertResizeBoundToPixels)(resizeBounds.min),
                    max: (0, $8kPj9.convertResizeBoundToPixels)(resizeBounds.max)
                });
            }
        });
    }, [
        panelWidth,
        getResizeBounds
    ]);
    const handleSliderBlur = (0, $4tluv.useCallback)(()=>{
        // Remove the resize event listener when the range input is blurred.
        resizeEventListenerCleanupFn.current?.();
    }, []);
    (0, $4tluv.useEffect)(()=>{
        return function cleanup() {
            // Cleanup the resize event listener when the component is unmounted.
            resizeEventListenerCleanupFn.current?.();
        };
    }, []);
    const ariaValueText = (0, $4tluv.useMemo)(()=>`${(0, $dFIQa.getPercentageWithinPixelBounds)({
            currentWidth: rangeInputValue,
            resizeBounds: rangeInputBounds
        })}% width`, [
        rangeInputValue,
        rangeInputBounds
    ]);
    return /*#__PURE__*/ (0, $lImzW.createPortal)(/*#__PURE__*/ (0, $2iln5.jsx)("div", {
        "data-testid": testId ? `${testId}-container` : undefined,
        className: (0, $jAkMr.default)([
            $45d34c621bc97e36$var$containerStyles.root,
            position === 'start' && $45d34c621bc97e36$var$containerStyles.positionStart,
            position === 'end' && $45d34c621bc97e36$var$containerStyles.positionEnd
        ]),
        children: /*#__PURE__*/ (0, $2iln5.jsx)($45d34c621bc97e36$var$MaybeTooltip, {
            tooltipContent: tooltipContent,
            shortcut: shortcut,
            testId: testId ? `${testId}-tooltip` : undefined,
            children: /*#__PURE__*/ (0, $2iln5.jsxs)("div", {
                ref: splitterRef,
                "data-testid": testId,
                onDoubleClick: onDoubleClick,
                className: (0, $jAkMr.default)([
                    $45d34c621bc97e36$var$grabAreaStyles.root,
                    isFhsEnabled && $45d34c621bc97e36$var$grabAreaStyles.fullHeightSidebar
                ]),
                children: [
                    /*#__PURE__*/ (0, $2iln5.jsxs)((0, $k7gbB.default), {
                        children: [
                            /*#__PURE__*/ (0, $2iln5.jsx)("input", {
                                type: "range",
                                value: rangeInputValue,
                                step: 20,
                                min: rangeInputBounds.min,
                                max: rangeInputBounds.max,
                                "aria-valuetext": ariaValueText,
                                "aria-labelledby": labelId,
                                onChange: handleSliderInputChange,
                                onFocus: handleSliderFocus,
                                onBlur: handleSliderBlur
                            }),
                            /*#__PURE__*/ (0, $2iln5.jsx)("span", {
                                id: labelId,
                                children: label
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2iln5.jsx)("span", {
                        className: (0, $jAkMr.default)([
                            $45d34c621bc97e36$var$lineStyles.root
                        ])
                    })
                ]
            })
        })
    }), portal);
};
const $45d34c621bc97e36$export$db67e3f8d3d6da0f = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId, tooltipContent: tooltipContent })=>{
    const [panel, setPanel] = (0, $4tluv.useState)(null);
    const [portal, setPortal] = (0, $4tluv.useState)(null);
    const context = (0, $4tluv.useContext)((0, $fBEso.PanelSplitterContext));
    (0, $kEkKo.default)(context, 'Panel splitter context not set');
    const { panelRef: panelRef, portalRef: portalRef, isEnabled: isEnabled, panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, getResizeBounds: getResizeBounds, resizingCssVar: resizingCssVar, position: position, shortcut: shortcut } = context;
    /**
   * **Explanation**
   *
   * _How React Suspense works_
   *
   * When a component is suspended:
   *
   * - it is _not_ "unmounted" and effects are _not_ cleaned up
   * - refs to react managed elements are cleared
   * - react adds `display:none !important` as an inline style to hide the element
   * - state is preserved
   *
   * When a suspended component is resumed:
   * - `display:none !important` inline style is removed
   * - it will re-render (without the refs set)
   * - refs will be set
   * - `useEffect` will _not_ re-run
   *
   * [More details](https://x.com/alexandereardon/status/1944617494569992440)
   *
   * _What does this mean for the panel splitter?_
   *
   * - The panel splitter renders into content into a react managed element (eg managed by Aside)
   * - When UI is suspended the portal ref is cleared
   * - After a suspense, we will get a render with cleared refs
   * - 🔥 This is problematic if we want to portal into that ref during the render
   *
   * _Approach: initial render_
   *
   * - We cannot portal the panel splitter until after the refs are initially set
   * - Effects run after refs being set. In an effect we set the ref values (which are populated),
   *   trigger a re-render and then portal into the refs.
   *
   * _Approach: suspense_
   *
   * - We put the refs into react `state` after every render
   * - The refs in `state` will not be cleared by suspending as effects are not run, or cleaned up,
   *   when components are suspended / resumed.
   * - After the post suspense render, we can use the `portalRef` (which was captured in an effect)
   *   to continue to portal into.
   *
   * _Why not store `portalRef` in `state` in `<PanelSplitterProvider>`?_
   *
   * - The `portalRef` is set high in the tree, so a re-render will cause a
   *   large amount of components to re-render (eg the whole sidebar)
   * - After a suspense, we would need to do _another_ large re-render to propagate the new refs
   * - With our current approach, any changes to `portalRef` will cause a re-render low in the tree
   *   (just in the `<PanelSplitter>`)
   */ // We want this effect to run after each render (see above)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $4tluv.useEffect)(()=>{
        // Don't need to do anything
        if (!isEnabled) return;
        // It is safe to access refs in useEffect, even with Suspense
        const panelEl = panelRef.current;
        const portalEl = portalRef.current;
        (0, $kEkKo.default)(panelEl, 'panelRef not set');
        (0, $kEkKo.default)(portalEl, 'portal element not set');
        // Doing our own check, as this results in fewer re-renders than react
        // (which also does it's own checks to see if a re-render should occur)
        if (panelEl === panel && portalEl === portal) return;
        // If refs don't change, react won't cause infinite loops
        setPanel(panelEl);
        setPortal(portalEl);
    });
    if (!isEnabled) return null;
    if (!portal || !panel) return null;
    return /*#__PURE__*/ (0, $2iln5.jsx)($45d34c621bc97e36$var$PortaledPanelSplitter, {
        label: label,
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd,
        testId: testId,
        panelId: panelId,
        panel: panel,
        portal: portal,
        panelWidth: panelWidth,
        onCompleteResize: onCompleteResize,
        getResizeBounds: getResizeBounds,
        resizingCssVar: resizingCssVar,
        position: position,
        tooltipContent: tooltipContent,
        shortcut: shortcut
    });
};

});
parcelRegister("6ZwWP", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserver", () => $9fd5fb1d168b38e5$export$750f5b0d6c51617e);

var $4tluv = parcelRequire("4tluv");

var $8S8Kg = parcelRequire("8S8Kg");
function $9fd5fb1d168b38e5$export$750f5b0d6c51617e() {
    const context = (0, $4tluv.useContext)((0, $8S8Kg.OpenLayerObserverContext));
    const publicAPI = (0, $4tluv.useMemo)(()=>{
        if (context === null) return null;
        return {
            getCount: context.getCount,
            onChange: context.onChange,
            closeLayers: context.closeLayers
        };
    }, [
        context
    ]);
    return publicAPI;
}

});

parcelRegister("ltmxR", function(module, exports) {
$parcel$export(module.exports, "useIsFhsEnabled", () => $ea611391889d1721$export$8b40a725a91166de);

var $4tluv = parcelRequire("4tluv");

var $98anh = parcelRequire("98anh");
const $ea611391889d1721$export$8b40a725a91166de = ()=>{
    const isFhsEnabled = (0, $4tluv.useContext)((0, $98anh.IsFhsEnabledContext));
    return typeof isFhsEnabled === 'boolean' ? isFhsEnabled : isFhsEnabled();
};

});
parcelRegister("98anh", function(module, exports) {
$parcel$export(module.exports, "IsFhsEnabledContext", () => $c3495f132e8afcdc$export$1e91b29ada71c32a);

var $4tluv = parcelRequire("4tluv");

var $3X3Vo = parcelRequire("3X3Vo");
const $c3495f132e8afcdc$export$1e91b29ada71c32a = /*#__PURE__*/ (0, $4tluv.createContext)(()=>(0, $3X3Vo.fg)('navx-full-height-sidebar'));

});


parcelRegister("3CMDc", function(module, exports) {
$parcel$export(module.exports, "sideNavVar", () => $aadea5ec9e63cf3b$export$951bf5156e86d974);
$parcel$export(module.exports, "sideNavLiveWidthVar", () => $aadea5ec9e63cf3b$export$1216dacffd1e9e65);
$parcel$export(module.exports, "sideNavPanelSplitterId", () => $aadea5ec9e63cf3b$export$5db28b16b6e686bc);
$parcel$export(module.exports, "contentInsetBlockStart", () => $aadea5ec9e63cf3b$export$bfabd8c2c572ad29);
$parcel$export(module.exports, "UNSAFE_sideNavLayoutVar", () => $aadea5ec9e63cf3b$export$6bfc931a04ec5741);
$parcel$export(module.exports, "openLayerObserverSideNavNamespace", () => $aadea5ec9e63cf3b$export$876effa8b02edc2f);
$parcel$export(module.exports, "openLayerObserverTopNavStartNamespace", () => $aadea5ec9e63cf3b$export$a6be839a92c90df7);
$parcel$export(module.exports, "openLayerObserverTopNavMiddleNamespace", () => $aadea5ec9e63cf3b$export$762ad20d97870b35);
$parcel$export(module.exports, "openLayerObserverTopNavEndNamespace", () => $aadea5ec9e63cf3b$export$8dd71e8a7db48024);
/**
 * These variables are shared across the different page layout slots.
 * This violates the [UI styling standard](https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-imported-style-values/usage).
 * We have chosen to ignore this rule to prevent duplicating them across the different slots, and to provide a high level view of them and how they relate.
 */ // These are "compressed" to discourage usage.
const $aadea5ec9e63cf3b$export$951bf5156e86d974 = '--n_sNvw';
const $aadea5ec9e63cf3b$export$594e6a30db7c057e = '--n_asDw';
const $aadea5ec9e63cf3b$export$db0c2e1d744fb281 = '--n_pnlW';
const $aadea5ec9e63cf3b$export$515a0b1baafe906c = '--n_bnrM';
const $aadea5ec9e63cf3b$export$60ef3a7b1ed42328 = '--n_tNvM';
const $aadea5ec9e63cf3b$export$a16bbd599f6269e7 = '--n_rbnW';
const $aadea5ec9e63cf3b$export$1216dacffd1e9e65 = '--n_sNvlw';
const $aadea5ec9e63cf3b$export$5db28b16b6e686bc = Symbol('SideNav PanelSplitter');
const $aadea5ec9e63cf3b$export$de580d653bac8ad9 = Symbol('Aside PanelSplitter');
const $aadea5ec9e63cf3b$export$3452dcb65711af44 = Symbol('Panel PanelSplitter');
const $aadea5ec9e63cf3b$export$2874e68531ce3163 = `calc(100vh - var(--n_bnrM, 0px) - var(--n_tNvM, 0px))`;
const $aadea5ec9e63cf3b$export$bfabd8c2c572ad29 = `calc(var(--n_bnrM, 0px) + var(--n_tNvM, 0px))`;
const $aadea5ec9e63cf3b$export$855f5a09f5c99ac = '--topNavigationHeight';
const $aadea5ec9e63cf3b$export$26354f9814213292 = '--bannerHeight';
const $aadea5ec9e63cf3b$export$6bfc931a04ec5741 = '--leftSidebarWidth';
const $aadea5ec9e63cf3b$export$58de0a46980ca7f4 = '--leftPanelWidth';
const $aadea5ec9e63cf3b$export$bbbace2ff0c7ae1b = '--rightSidebarWidth';
const $aadea5ec9e63cf3b$export$753bf7651b25db91 = '--rightPanelWidth';
const $aadea5ec9e63cf3b$export$6460bd6a2446260 = `calc(var(${$aadea5ec9e63cf3b$export$26354f9814213292}, 0px) + var(${$aadea5ec9e63cf3b$export$855f5a09f5c99ac}, 0px))`;
const $aadea5ec9e63cf3b$export$3055529fab2b4edf = `calc(var(${$aadea5ec9e63cf3b$export$58de0a46980ca7f4}, 0px) + var(${$aadea5ec9e63cf3b$export$6bfc931a04ec5741}, 0px))`;
const $aadea5ec9e63cf3b$export$166d8fd766c3eb92 = `calc(var(${$aadea5ec9e63cf3b$export$bbbace2ff0c7ae1b}, 0px) + var(${$aadea5ec9e63cf3b$export$753bf7651b25db91}, 0px))`;
const $aadea5ec9e63cf3b$export$61156ceb1a99f6a0 = {
    ribbon: 4,
    // The side nav panel splitter is layered above the top nav when FHS is enabled.
    // It has the same z-index value, but is rendered after the top nav in the DOM so is stacked above.
    sideNavPanelSplitterFHS: 4,
    topBar: 4,
    banner: 4,
    // When FHS is enabled, the side nav is layered below the top nav,
    // but above the panel
    bannerFHS: 3,
    topNavFHS: 3,
    sideNav: 2,
    panelSmallViewports: 1
};
const $aadea5ec9e63cf3b$export$876effa8b02edc2f = 'side-nav';
const $aadea5ec9e63cf3b$export$a6be839a92c90df7 = 'top-nav-start';
const $aadea5ec9e63cf3b$export$762ad20d97870b35 = 'top-nav-middle';
const $aadea5ec9e63cf3b$export$8dd71e8a7db48024 = 'top-nav-end';

});

parcelRegister("8kPj9", function(module, exports) {
$parcel$export(module.exports, "convertResizeBoundToPixels", () => $de436f93336272ca$export$3d412b3011b66f82);
function $de436f93336272ca$export$3d412b3011b66f82(resizeBound) {
    if (resizeBound.endsWith('vw')) {
        // Max width was provided in `vw` units, so is relative to the viewport width.
        // e.g. 50vw = 50% of the viewport width.
        // `parseInt` will remove the `vw` suffix.
        const maxWidthFraction = parseInt(resizeBound) / 100;
        return Math.floor(window.innerWidth * maxWidthFraction);
    }
    // Max width was provided in `px` units, so we can parse it directly.
    // `parseInt` will remove the `px` suffix.
    return Math.floor(parseInt(resizeBound));
}

});

parcelRegister("dFIQa", function(module, exports) {
$parcel$export(module.exports, "getPercentageWithinPixelBounds", () => $53b1b728124f4bd9$export$b5423678cdf09f5);
function $53b1b728124f4bd9$export$b5423678cdf09f5({ currentWidth: currentWidth, resizeBounds: resizeBounds }) {
    const resizeRange = resizeBounds.max - resizeBounds.min;
    const widthAsPercentage = (currentWidth - resizeBounds.min) / resizeRange * 100;
    if (widthAsPercentage < 0) return 0;
    if (widthAsPercentage > 100) return 100;
    return Math.floor(widthAsPercentage);
}

});

parcelRegister("2ExWa", function(module, exports) {
$parcel$export(module.exports, "getPixelWidth", () => $55d1f4b7cf1438e7$export$d942790ad00c41f9);
/**
 * Returns the computed width of an element in pixels.
 */ const $55d1f4b7cf1438e7$export$d942790ad00c41f9 = (element)=>{
    // Always returns an integer. Returns 0 if element is hidden / removed.
    return element.offsetWidth;
};

});

parcelRegister("dtkkI", function(module, exports) {
$parcel$export(module.exports, "getWidthFromDragLocation", () => $725f88637b35d6ba$export$e360234971cb95b8);
const $725f88637b35d6ba$export$e360234971cb95b8 = ({ initialWidth: initialWidth, location: location, initialClientX: initialClientX, direction: direction, position: position })=>{
    const diffX = location.current.input.clientX - initialClientX;
    // Resize line is positioned at the inline-end (right) of the element.
    // If the direction is left-to-right, the width will increase when the mouse is moved to the right, and vice versa.
    if (position === 'end') return direction === 'ltr' ? initialWidth + diffX : initialWidth - diffX;
    // Resize line is positioned at the inline-start (left) of the element.
    // If the direction is left-to-right, the width will decrease when the mouse is moved to the right, and vice versa.
    return direction === 'ltr' ? initialWidth - diffX : initialWidth + diffX;
};

});

parcelRegister("2u2R1", function(module, exports) {
$parcel$export(module.exports, "isPanelSplitterDragData", () => $429ad2174091c3b6$export$e239b3966b677000);

var $6m2Lr = parcelRequire("6m2Lr");
function $429ad2174091c3b6$export$e239b3966b677000(data) {
    return data[0, $6m2Lr.panelSplitterDragDataSymbol] === true;
}

});
parcelRegister("6m2Lr", function(module, exports) {
$parcel$export(module.exports, "panelSplitterDragDataSymbol", () => $bbfccad99139d9b8$export$64f49ceb7f6e9a23);
const $bbfccad99139d9b8$export$64f49ceb7f6e9a23 = Symbol('panel-splitter-drag-data');

});


parcelRegister("agKqx", function(module, exports) {
$parcel$export(module.exports, "createKeyboardResizeManager", () => $e0230302d166b42e$export$f7d3d5dae65f74aa);
/**
 * The debounce time for the PanelSplitter resize callback functions.
 *
 * - For `onResizeStart`, it will call the callback immediately, but not
 * again until the user stops resizing and this wait time has passed.
 * - For `onResizeEnd`, it will call the callback only after this time has
 * passed since the last resize event.
 */ const $e0230302d166b42e$var$resizeCallbackDebounceTimeMs = 500;
function $e0230302d166b42e$export$f7d3d5dae65f74aa({ onResizeStart: onResizeStart, onResizeEnd: onResizeEnd }) {
    let resizingState = {
        type: 'idle'
    };
    /**
   * Starts a timer to reset the state to idle and call `onResizeEnd` after a wait time.
   */ function startResizeEndTimer({ initialWidth: initialWidth, finalWidth: finalWidth }) {
        const markResizeAsEndedTimeout = setTimeout(()=>{
            onResizeEnd({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            resizingState = {
                type: 'idle'
            };
        }, $e0230302d166b42e$var$resizeCallbackDebounceTimeMs);
        resizingState = {
            type: 'resizing',
            initialWidth: initialWidth,
            abort () {
                clearTimeout(markResizeAsEndedTimeout);
            }
        };
    }
    function onResize({ initialWidth: initialWidth, finalWidth: finalWidth }) {
        if (resizingState.type === 'idle') {
            // If the state was idle, this counts as a resize start event.
            onResizeStart({
                initialWidth: initialWidth
            });
            startResizeEndTimer({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
        if (resizingState.type === 'resizing') {
            // If the state was already resizing, clear the existing timeout and start a new one.
            resizingState.abort();
            startResizeEndTimer({
                initialWidth: resizingState.initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
    }
    return {
        onResize: onResize
    };
}

});

parcelRegister("aS84f", function(module, exports) {
$parcel$export(module.exports, "OnDoubleClickContext", () => $e96f29713ffaf7d8$export$e253efba824eceb);

var $4tluv = parcelRequire("4tluv");
const $e96f29713ffaf7d8$export$e253efba824eceb = /*#__PURE__*/ (0, $4tluv.createContext)(undefined);

});

parcelRegister("fBEso", function(module, exports) {
$parcel$export(module.exports, "PanelSplitterContext", () => $8d28e5c40aba8e7e$export$7a4054f2c546f2cd);

var $4tluv = parcelRequire("4tluv");
const $8d28e5c40aba8e7e$export$7a4054f2c546f2cd = /*#__PURE__*/ (0, $4tluv.createContext)(null);

});


parcelRegister("iha90", function(module, exports) {
$parcel$export(module.exports, "SideNav", () => $5fbce3fa1124ca81$export$1a35787d6353cf6a);
/* side-nav.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $jAkMr = parcelRequire("jAkMr");

var $4tluv = parcelRequire("4tluv");

var $Hyfcf = parcelRequire("Hyfcf");

var $lImzW = parcelRequire("lImzW");

var $8ik9q = parcelRequire("8ik9q");

var $hHj16 = parcelRequire("hHj16");

var $aH1KC = parcelRequire("aH1KC");

var $c7USH = parcelRequire("c7USH");
var $6ZwWP = parcelRequire("6ZwWP");

var $3X3Vo = parcelRequire("3X3Vo");

var $4LjiE = parcelRequire("4LjiE");
parcelRequire("2njLb");
var $6bZZN = parcelRequire("6bZZN");

var $8DgQK = parcelRequire("8DgQK");

var $gFfv2 = parcelRequire("gFfv2");

var $ltmxR = parcelRequire("ltmxR");

var $3CMDc = parcelRequire("3CMDc");

var $lsCRl = parcelRequire("lsCRl");

var $dmhFx = parcelRequire("dmhFx");

var $kKhAx = parcelRequire("kKhAx");

var $it82a = parcelRequire("it82a");

var $k649C = parcelRequire("k649C");

var $8iE39 = parcelRequire("8iE39");

var $lPYIa = parcelRequire("lPYIa");

var $80OBc = parcelRequire("80OBc");

var $jyKIs = parcelRequire("jyKIs");

var $dE5R1 = parcelRequire("dE5R1");

var $76gw6 = parcelRequire("76gw6");

var $43xg0 = parcelRequire("43xg0");

var $iEJEn = parcelRequire("iEJEn");

var $9kOZe = parcelRequire("9kOZe");

var $avMNZ = parcelRequire("avMNZ");

var $expak = parcelRequire("expak");

var $4dO7T = parcelRequire("4dO7T");

var $26fBJ = parcelRequire("26fBJ");
const $5fbce3fa1124ca81$var$panelSplitterResizingVar = '--n_snvRsz';
// Used to share the side nav width with the panel splitter, which is rendered outside the side nav element
// but positioned to stay at its right edge.
const $5fbce3fa1124ca81$var$sideNavClampedWidthVar = '--n_snvW';
const $5fbce3fa1124ca81$var$widthResizeBounds = {
    min: '240px',
    max: '50vw'
};
function $5fbce3fa1124ca81$var$getResizeBounds() {
    return $5fbce3fa1124ca81$var$widthResizeBounds;
}
/**
 * We are using JS to detect Firefox and disable animations, instead of using CSS, as Compiled currently does not merge duplicate
 * CSS at-rules when at-rules are nested: https://github.com/atlassian-labs/compiled/blob/e04a325915e1d13010205089e4915de0e53bc2d4/packages/css/src/plugins/merge-duplicate-at-rules.ts#L5
 * Avoiding nesting the `@supports` at-rule inside of `@media` means Compiled can remove duplicate styles from the generated CSS.
 */ const $5fbce3fa1124ca81$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
const $5fbce3fa1124ca81$var$panelSplitterPortalTargetStyles = {
    root: "_kqsw1n9t _1pbyegat _u7coidpf _t9ectl5p _4t3ieqxy _165t56xv _p0az1elq"
};
const $5fbce3fa1124ca81$var$styles = {
    root: "_nd5l1b6c _191wglyw _t51zglyw _bfhk1bhr _16qs130s _vchhusvi _4t3ieqxy _152timx3 _kqsw1if8 _1bsb1ego _1pbycs5v _14b5hc79 _qilnk0mc _p5clia51 _4ap3vuon _scbpglyw",
    flyoutOpen: "_qiln1gzg _p5clglyw _4ap31bhr _scbp130s _139f8iot _1tpvfnf5 _sylc1a5r _oyeijq3t",
    flyoutAnimateClosed: "_1e0cglyw _qiln1gzg _139f8iot _1tpvfnf5 _sylc1a5r _1uwsjq3t",
    animationRTLSupport: "_15yekb7n _65m41mrw",
    flyoutBaseStylesFullHeightSidebar: "_qiln1gzg _p5clglyw _4ap31bhr _scbp130s _17ly8iot _177m1a5r",
    flyoutOpenFullHeightSidebar: "_hjoifnf5 _vgub1ku9 _s2eg1p9u",
    flyoutAnimateClosedFullHeightSidebar: "_dm25glyw _hjoifnf5 _vgub1mm8 _hh1u1p9u",
    flexContainer: "_4t3i1osq _1e0c1txw _2lx21bp4 _1bah1yb4",
    hiddenMobileAndDesktop: "_1e0cglyw",
    hiddenMobileOnly: "_1e0cglyw _dm2518uv",
    hiddenDesktopOnly: "_dm25glyw",
    animationBaseStyles: "_10t88iot _1vrh1a5r _xrrpfnf5",
    expandAnimationMobile: "_1xq51ku9 _1nu51p9u",
    collapseAnimationMobile: "_1lh81gzg _1xq51mm8 _aadi1p9u",
    expandAnimationDesktop: "_1sg8k0mc _vgub1ku9 _s2eg1p9u",
    collapseAnimationDesktop: "_1sg81gzg _vgub1mm8 _hh1u1p9u"
};
const $5fbce3fa1124ca81$var$fallbackDefaultWidth = 320;
const $5fbce3fa1124ca81$export$c735dc1c21910e21 = 500;
/**
 * We need an additional component layer so we can wrap the side nav in a `OpenLayerObserver` and have access to the
 * context value.
 */ function $5fbce3fa1124ca81$var$SideNavInternal({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidthProp = $5fbce3fa1124ca81$var$fallbackDefaultWidth, testId: testId, label: label = 'Sidebar', skipLinkLabel: skipLinkLabel = label, onExpand: onExpand, onCollapse: onCollapse, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, id: providedId, canToggleWithShortcut: canToggleWithShortcut }) {
    const isFhsEnabled = (0, $ltmxR.useIsFhsEnabled)();
    const id = (0, $it82a.useLayoutId)({
        providedId: providedId
    });
    const expandSideNav = (0, $43xg0.useExpandSideNav)({
        trigger: 'skip-link'
    });
    /**
   * Called after clicking on the side nav skip link, and ensures the side nav is expanded so that it is focusable.
   *
   * We need to update the DOM synchronously because `.focus()` is called synchronously after this state update.
   */ const synchronouslyExpandSideNav = (0, $4tluv.useCallback)(()=>{
        (0, $lImzW.flushSync)(()=>{
            /**
       * Calling this unconditionally and relying on it to avoid no-op renders.
       *
       * We _could_ call it conditionally, but we'd be duplicating the screen size checks `expandSideNav` makes.
       */ expandSideNav();
        });
    }, [
        expandSideNav
    ]);
    (0, $8DgQK.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        onBeforeNavigate: synchronouslyExpandSideNav
    });
    const sideNavState = (0, $4tluv.useContext)((0, $76gw6.SideNavVisibilityState));
    const setSideNavState = (0, $4tluv.useContext)((0, $80OBc.SetSideNavVisibilityState));
    const { isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile } = (0, $expak.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    });
    // We are placing `defaultCollapsed` into a state container so we can have a stable reference to the initial value.
    // This is so we can use it in an effect _that only runs once_, after the initial render on the client,
    // to sync the side nav context (provided in `<Root>`) with the `defaultCollapsed` prop provided to `<SideNav>`.
    const [initialDefaultCollapsed] = (0, $4tluv.useState)(defaultCollapsed);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $8ik9q.useAnalyticsEvents)();
    const [initialIsExpandedOnDesktop] = (0, $4tluv.useState)(isExpandedOnDesktop);
    /**
   * Captures the initial collapsed/expanded state of the side nav.
   *
   * Only firing on desktop because the nav is never open by default on mobile.
   */ (0, $4tluv.useEffect)(()=>{
        if (initialIsExpandedOnDesktop) {
            const isDesktop = window.matchMedia('(min-width: 64rem)').matches;
            if (isDesktop) {
                const navigationAnalyticsEvent = createAnalyticsEvent({
                    source: 'topNav',
                    actionSubject: 'sideNav',
                    action: 'viewedOnLoad',
                    actionSubjectId: 'sideNavMenu',
                    attributes: {
                        screen: 'desktop'
                    }
                });
                navigationAnalyticsEvent.fire('navigation');
            }
        }
    }, [
        createAnalyticsEvent,
        initialIsExpandedOnDesktop
    ]);
    const defaultWidth = (0, $8iE39.useSafeDefaultWidth)({
        defaultWidthProp: defaultWidthProp,
        fallbackDefaultWidth: $5fbce3fa1124ca81$var$fallbackDefaultWidth,
        slotName: 'SideNav'
    });
    const [width, setWidth] = (0, $4tluv.useState)(defaultWidth);
    const clampedWidth = `clamp(${$5fbce3fa1124ca81$var$widthResizeBounds.min}, ${width}px, ${$5fbce3fa1124ca81$var$widthResizeBounds.max})`;
    const dangerouslyHoistSlotSizes = (0, $4tluv.useContext)((0, $dmhFx.DangerouslyHoistSlotSizes));
    const navRef = (0, $4tluv.useRef)(null);
    const panelSplitterPortalTargetRef = (0, $4tluv.useRef)(null);
    /**
   * Used to share the side nav element with the `Panel`,
   * which observes the side nav to determine its maximum width.
   */ const sharedRef = (0, $9kOZe.useSideNavRef)();
    const mergedRef = (0, $hHj16.default)([
        navRef,
        sharedRef
    ]);
    const toggleButtonElement = (0, $4tluv.useContext)((0, $jyKIs.SideNavToggleButtonElement));
    const topNavStartElement = (0, $4tluv.useContext)((0, $gFfv2.TopNavStartElement));
    const devTimeOnlyAttributes = {};
    const openLayerObserver = (0, $6ZwWP.useOpenLayerObserver)();
    const flyoutStateRef = (0, $4tluv.useRef)({
        type: 'not-active'
    });
    const isFlyoutVisible = sideNavState?.flyout === 'open';
    const isExpandedOnDesktopRef = (0, $aH1KC.default)(isExpandedOnDesktop);
    const hasPeekStartedRef = (0, $4tluv.useRef)(false);
    const onPeekStartRef = (0, $aH1KC.default)(onPeekStart);
    const onPeekEndRef = (0, $aH1KC.default)(onPeekEnd);
    const onPeekStartTimeoutIdRef = (0, $4tluv.useRef)(undefined);
    (0, $4tluv.useEffect)(()=>{
        return ()=>{
            clearTimeout(onPeekStartTimeoutIdRef.current);
        };
    }, []);
    const updateFlyoutState = (0, $4tluv.useMemo)(()=>{
        function tryAbortPendingClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        }
        function open() {
            // Prevent the flyout from being opened if there are any open layers in the top nav start
            if (openLayerObserver && openLayerObserver.getCount({
                namespace: (0, $3CMDc.openLayerObserverTopNavStartNamespace),
                type: 'popup'
            }) > 0) return;
            const prevFlyoutState = flyoutStateRef.current;
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'open'
            };
            setSideNavState((currentState)=>{
                if (currentState?.desktop === 'collapsed' && currentState?.flyout !== 'open') return {
                    ...currentState,
                    flyout: 'open'
                };
                return currentState;
            });
            // Avoid redundant calls to `onPeekStart()`
            if (prevFlyoutState.type === 'not-active') {
                clearTimeout(onPeekStartTimeoutIdRef.current);
                onPeekStartTimeoutIdRef.current = setTimeout(()=>{
                    // If the flyout isn't still open after ~500ms then we won't count the peek
                    // As we want to track user intention rather than all hovers
                    if (isExpandedOnDesktopRef.current || flyoutStateRef.current.type !== 'open') return;
                    hasPeekStartedRef.current = true;
                    onPeekStartRef.current?.();
                }, $5fbce3fa1124ca81$export$c735dc1c21910e21);
            }
        }
        function close() {
            const prevFlyoutState = flyoutStateRef.current;
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'not-active'
            };
            setSideNavState((currentState)=>{
                if (currentState?.desktop === 'collapsed' && currentState?.flyout === 'open') return {
                    ...currentState,
                    flyout: 'triggered-animate-close'
                };
                return currentState;
            });
            // Avoid redundant calls to `onPeekEnd()`
            if (prevFlyoutState.type !== 'not-active' && hasPeekStartedRef.current) {
                hasPeekStartedRef.current = false;
                onPeekEndRef.current?.({
                    trigger: isExpandedOnDesktopRef.current ? 'side-nav-expand' : 'mouse-leave'
                });
            }
        }
        return function onAction(action) {
            if (action === 'drag-from-flyout-started') {
                open();
                flyoutStateRef.current = {
                    type: 'is-dragging-from-flyout'
                };
                return;
            }
            if (action === 'drag-from-flyout-finished') {
                open();
                return;
            }
            // ignoring all actions until the drag is finished
            if (flyoutStateRef.current.type === 'is-dragging-from-flyout') return;
            if (action === 'open') {
                open();
                return;
            }
            if (action === 'waiting-for-close') {
                if (flyoutStateRef.current.type === 'waiting-for-close') return;
                // A timeout is used to close the flyout after a delay when the user mouses out of the flyout area, and to allow
                // us to cancel the close if the user mouses back in.
                const timeout = setTimeout(()=>{
                    updateFlyoutState('ready-to-close');
                }, (0, $lPYIa.sideNavFlyoutCloseDelayMs));
                flyoutStateRef.current = {
                    type: 'waiting-for-close',
                    abort () {
                        clearTimeout(timeout);
                    }
                };
                return;
            }
            if (action === 'ready-to-close') {
                // If there are no open layers, we can close the flyout.
                if (openLayerObserver?.getCount({
                    namespace: (0, $3CMDc.openLayerObserverSideNavNamespace)
                }) === 0) {
                    close();
                    return;
                }
                flyoutStateRef.current = {
                    type: 'ready-to-close'
                };
                return;
            }
            if (action === 'force-close') {
                close();
                return;
            }
        };
    }, [
        isExpandedOnDesktopRef,
        onPeekEndRef,
        onPeekStartRef,
        openLayerObserver,
        setSideNavState
    ]);
    const toggleVisibilityByScreenResize = (0, $26fBJ.useToggleSideNav)({
        trigger: 'screen-resize'
    });
    const toggleVisibilityByClickOutsideOnMobile = (0, $26fBJ.useToggleSideNav)({
        trigger: 'click-outside-on-mobile'
    });
    // Using `useLayoutEffect` so that there's no visual shift in non-SSR environments when using legacy API
    // For SSR the new API is still necessary
    (0, $4tluv.useLayoutEffect)(()=>{
        if (sideNavState !== null) // Only need to do an initial sync if it hasn't been initialized from Root
        return;
        // Sync the visibility in context (provided in `<Root>`) with the local `defaultCollapsed` prop provided to `SideNav`
        // after SSR hydration. This should only run once, after the initial render on the client.
        if ((0, $3X3Vo.fg)('navx-4418-fix-effect-state-updates-in-gsn')) (0, $4tluv.startTransition)(()=>{
            setSideNavState({
                desktop: initialDefaultCollapsed ? 'collapsed' : 'expanded',
                mobile: 'collapsed',
                flyout: 'closed',
                lastTrigger: null
            });
        });
        else setSideNavState({
            desktop: initialDefaultCollapsed ? 'collapsed' : 'expanded',
            mobile: 'collapsed',
            flyout: 'closed',
            lastTrigger: null
        });
    }, [
        initialDefaultCollapsed,
        setSideNavState,
        sideNavState
    ]);
    const handleExpand = (0, $4tluv.useCallback)(({ screen: screen, trigger: trigger })=>{
        onExpand?.({
            screen: screen,
            trigger: trigger
        });
        const navigationAnalyticsEvent = createAnalyticsEvent({
            source: 'topNav',
            actionSubject: 'sideNav',
            action: 'expanded',
            actionSubjectId: 'sideNavMenu',
            attributes: {
                trigger: trigger
            }
        });
        navigationAnalyticsEvent.fire('navigation');
        // When the side nav gets expanded, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to expand.
        updateFlyoutState('force-close');
    }, [
        onExpand,
        updateFlyoutState,
        createAnalyticsEvent
    ]);
    const handleCollapse = (0, $4tluv.useCallback)(({ screen: screen, trigger: trigger })=>{
        onCollapse?.({
            screen: screen,
            trigger: trigger
        });
        const navigationAnalyticsEvent = createAnalyticsEvent({
            source: 'topNav',
            actionSubject: 'sideNav',
            action: 'collapsed',
            actionSubjectId: 'sideNavMenu',
            attributes: {
                trigger: trigger
            }
        });
        navigationAnalyticsEvent.fire('navigation');
        // When the side nav gets collapsed, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to collapse.
        updateFlyoutState('force-close');
    }, [
        onCollapse,
        updateFlyoutState,
        createAnalyticsEvent
    ]);
    (0, $4dO7T.useSideNavVisibilityCallbacks)({
        onExpand: handleExpand,
        onCollapse: handleCollapse,
        isExpandedOnDesktop: isExpandedOnDesktop,
        isExpandedOnMobile: isExpandedOnMobile,
        lastTrigger: sideNavState?.lastTrigger ?? null
    });
    (0, $4tluv.useEffect)(()=>{
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $Hyfcf.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                if (mediaQueryList.matches) // We're transitioning from tablet to desktop viewport size.
                // We forcibly show the side nav if it was shown on mobile.
                {
                    if (isExpandedOnMobile && !isExpandedOnDesktop) toggleVisibilityByScreenResize();
                }
            }
        });
    }, [
        toggleVisibilityByScreenResize,
        isExpandedOnDesktop,
        isExpandedOnMobile
    ]);
    /**
   * Close the mobile side nav if there is a click outside.
   *
   * Binding/unbinding on changes to `isExpandedOnMobile` instead of window size changes for simplicity.
   * If we listened to window size changes we'd need nested `bind()` calls.
   */ (0, $4tluv.useEffect)(()=>{
        if (!isExpandedOnMobile) return;
        /**
     * The expected URL fragment used by the side nav skip link.
     */ const skipLinkUrlFragment = `#${id}`;
        return (0, $Hyfcf.bind)(window, {
            type: 'click',
            listener (event) {
                if (window.matchMedia('(min-width: 64rem)').matches) // Clicks on desktop should do nothing
                return;
                const sideNav = navRef.current;
                if (!sideNav || !(event.target instanceof Node)) // Ignore if our element references are invalid
                return;
                if (!event.target.isConnected) /**
           * If the element that was clicked is no longer in the document, we should not collapse the side nav.
           * This can happen when the user clicks on a dropdown menu item (such as one used in a `...` More menu),
           * as the dropdown menu will close after being clicked. By the time this event listener runs, the clicked
           * element will no longer be in the document, so the check below for `sideNav.contains(event.target)` will fail.
           */ return;
                if (sideNav.contains(event.target)) // Clicks inside the side nav should not close it
                return;
                if (toggleButtonElement?.contains(event.target)) // Clicks on the toggle button will already toggle the side nav,
                // so we need to ignore it or we end up doing a double toggle
                return;
                if (event.target instanceof HTMLAnchorElement && /**
         * Intentionally using `.getAttribute()` for simplicity to match exactly what we expect
         * for skip links.
         *
         * Alternatives considered:
         *
         * - Using `.href` returns a full URL, which would then require extra parsing.
         * - Using `.hash` could incorrectly capture `<a href="/another-page#skip-link-id>` so we'd need extra checks.
         *
         * This approach has an edge case of `<a href="/same-page#skip-link-id>` not being captured,
         * but we are okay with that trade-off.
         */ event.target.getAttribute('href') === skipLinkUrlFragment) // This was a click on a link to the side nav, so we shouldn't try to collapse the SideNav.
                // It was most likely the skip link, although anyone can render a link with the ID.
                // In either case keeping the SideNav expanded makes sense.
                return;
                toggleVisibilityByClickOutsideOnMobile();
            }
        });
    }, [
        id,
        isExpandedOnMobile,
        toggleButtonElement,
        toggleVisibilityByClickOutsideOnMobile
    ]);
    (0, $4tluv.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $Hyfcf.bind)(toggleButtonElement, {
            type: 'mouseenter',
            listener () {
                // Only flyout the side nav if the user hovered while the side nav was collapsed
                if (isExpandedOnDesktop) return;
                // Only flyout the side nav on desktop viewports
                const { matches: matches } = window.matchMedia('(min-width: 64rem)');
                if (matches) updateFlyoutState('open');
            }
        });
    }, [
        updateFlyoutState,
        toggleButtonElement,
        isExpandedOnDesktop
    ]);
    (0, $4tluv.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $Hyfcf.bind)(toggleButtonElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        toggleButtonElement,
        updateFlyoutState
    ]);
    (0, $4tluv.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $Hyfcf.bind)(navRef.current, {
            type: 'mouseenter',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                // The user mouses has moused back over the side nav
                updateFlyoutState('open');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState,
        isExpandedOnDesktop
    ]);
    (0, $4tluv.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $Hyfcf.bind)(navRef.current, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $4tluv.useEffect)(()=>{
        const nav = navRef.current;
        if (!nav) return;
        if (!isFlyoutVisible) return;
        // Using a monitor rather than a drop target. Rationale:
        // - We are not creating a drop target for the users to drop on,
        //   we are just interested in listening to events within an element
        // - We do not want to impact `location.{*}.dropTargets` in events
        return (0, $4LjiE.monitorForElements)({
            canMonitor ({ source: source }) {
                return nav.contains(source.element);
            },
            onGenerateDragPreview () {
                updateFlyoutState('drag-from-flyout-started');
            },
            onDrop ({ location: location }) {
                // Always marking the drag and done
                updateFlyoutState('drag-from-flyout-finished');
                // If the user dropped outside of the flyout, we will close the flyout
                const underUsersPointer = document.elementFromPoint(location.current.input.clientX, location.current.input.clientY);
                if (!nav.contains(underUsersPointer)) updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $4tluv.useEffect)(()=>{
        if (!topNavStartElement || !toggleButtonElement) return;
        return (0, $Hyfcf.bind)(topNavStartElement, {
            type: 'mouseover',
            listener (event) {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                if (event.target === topNavStartElement) {
                    // The mouse is directly over the TopNavStart element, so cancel any pending flyout closes.
                    updateFlyoutState('open');
                    return;
                }
                if (event.target instanceof Element && toggleButtonElement.contains(event.target)) // The mouse is over the toggle button or any of its children, so we don't want to close the flyout.
                // We also don't need to cancel any pending closes, as we have separate event listeners for the toggle button mouse events.
                return;
                // The user has moused over a child element of the TopNavStart element that isn't the toggle button, e.g. the app switcher or nav logo,
                // so we should close the flyout (with a delay).
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        topNavStartElement,
        isFlyoutVisible,
        toggleButtonElement,
        isExpandedOnDesktop,
        updateFlyoutState
    ]);
    (0, $4tluv.useEffect)(()=>{
        if (!topNavStartElement) return;
        return (0, $Hyfcf.bind)(topNavStartElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                // The mouse has left the TopNavStart element, so we should close the flyout with a delay.
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        topNavStartElement,
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $4tluv.useEffect)(()=>{
        // Close the flyout if there are no more layers open and the user is not mousing over the
        // flyout areas (side nav, TopNavStart element)
        return openLayerObserver?.onChange(({ count: count })=>{
            if (flyoutStateRef.current.type === 'ready-to-close' && count === 0) updateFlyoutState('force-close');
        }, {
            namespace: (0, $3CMDc.openLayerObserverSideNavNamespace)
        });
    }, [
        openLayerObserver,
        updateFlyoutState
    ]);
    (0, $4tluv.useEffect)(()=>{
        // Clear flyout close timer if being unmounted
        return function cleanupPendingFlyoutClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        };
    }, []);
    (0, $avMNZ.useSideNavToggleKeyboardShortcut)({
        canToggleWithShortcut: canToggleWithShortcut
    });
    // Used to conditionally display the keyboard shortcut in the SideNavPanelSplitter tooltip.
    const isShortcutEnabled = (0, $iEJEn.useIsSideNavShortcutEnabled)();
    (0, $k649C.useResizingWidthCssVarOnRootElement)({
        isEnabled: true,
        cssVar: $5fbce3fa1124ca81$var$panelSplitterResizingVar,
        panelId: (0, $3CMDc.sideNavPanelSplitterId)
    });
    const isExpandedStateDifferentFromInitial = isExpandedOnMobile || isExpandedOnDesktop !== initialIsExpandedOnDesktop;
    /**
   * Used to track (between renders) if the expanded state of the side nav has ever changed since mount.
   *
   * Cannot rely solely on `isExpandedStateDifferentFromInitial` because the expanded state can go back to the initial state.
   */ const hasExpandedStateChangedRef = (0, $4tluv.useRef)(false);
    (0, $4tluv.useEffect)(()=>{
        if (hasExpandedStateChangedRef.current) return;
        if (isExpandedStateDifferentFromInitial) hasExpandedStateChangedRef.current = true;
    }, [
        isExpandedStateDifferentFromInitial
    ]);
    /**
   * If the expanded state of the side nav has ever changed since mount.
   *
   * Used to prevent sidebar expand animations from running on the initial load.
   * Otherwise, the `@starting-style` rule will cause the sidebar to slide in initially.
   */ const hasExpandedStateChanged = isExpandedStateDifferentFromInitial || hasExpandedStateChangedRef.current;
    // This is only used for the regular expand and collapse animations, not the flyout animations.
    const shouldShowSidebarToggleAnimation = isFhsEnabled && // We do not apply the animation styles on the initial render, as the `@starting-style` rule will cause the sidebar to
    // slide in initially.
    hasExpandedStateChanged && // We also do not apply the animation styles if the side nav is in flyout mode to make sure we don't override flyout styles.
    // If we instead try to unset the `transform` property in the flyout styles using `transform: initial`, it results in the entire
    // flyout animation being disabled.
    !isFlyoutVisible && /**
   * Disabling animations for Firefox, as it doesn't support animating the `display` property:
   * https://caniuse.com/mdn-css_properties_display_is_transitionable
   *
   * As of October 2025, Firefox supports the expand animation, but not the collapse animation (it instantly changes to `display: none`).
   * Because of this, we are disabling all sidebar animations for Firefox so it doesn't look like a bug.
   *
   * Unfortunately we cannot use `@supports` to target the support of `transition-behavior: allow-discrete` specifically
   * for the `display` property. And `@supports at-rule(@starting-style)` is also not ready for browser use yet.
   *
   * We are using JS to detect Firefox and disable animations, instead of using CSS, as Compiled currently does not merge duplicate
   * CSS at-rules when at-rules are nested: https://github.com/atlassian-labs/compiled/blob/e04a325915e1d13010205089e4915de0e53bc2d4/packages/css/src/plugins/merge-duplicate-at-rules.ts#L5
   * Avoiding nesting the `@supports` at-rule inside of `@media` means Compiled can remove duplicate styles from the generated CSS.
   */ !$5fbce3fa1124ca81$var$isFirefox;
    return /*#__PURE__*/ (0, $2iln5.jsxs)((0, $2iln5.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2iln5.jsxs)("nav", {
                id: id,
                ...devTimeOnlyAttributes,
                "data-layout-slot": true,
                "aria-label": label,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop
                    [(0, $3CMDc.sideNavVar)]: clampedWidth
                },
                ref: mergedRef,
                "data-testid": testId,
                className: (0, $jAkMr.default)([
                    $5fbce3fa1124ca81$var$styles.root,
                    isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $5fbce3fa1124ca81$var$styles.hiddenMobileOnly,
                    !isExpandedOnDesktop && isExpandedOnMobile && !isFlyoutVisible && $5fbce3fa1124ca81$var$styles.hiddenDesktopOnly,
                    !isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $5fbce3fa1124ca81$var$styles.hiddenMobileAndDesktop,
                    isFhsEnabled && $5fbce3fa1124ca81$var$styles.animationRTLSupport,
                    shouldShowSidebarToggleAnimation && $5fbce3fa1124ca81$var$styles.animationBaseStyles,
                    isExpandedOnMobile && shouldShowSidebarToggleAnimation && $5fbce3fa1124ca81$var$styles.expandAnimationMobile,
                    !isExpandedOnMobile && shouldShowSidebarToggleAnimation && $5fbce3fa1124ca81$var$styles.collapseAnimationMobile,
                    isExpandedOnDesktop && shouldShowSidebarToggleAnimation && $5fbce3fa1124ca81$var$styles.expandAnimationDesktop,
                    !isExpandedOnDesktop && shouldShowSidebarToggleAnimation && $5fbce3fa1124ca81$var$styles.collapseAnimationDesktop,
                    sideNavState?.flyout === 'open' && !isFhsEnabled && $5fbce3fa1124ca81$var$styles.flyoutOpen,
                    sideNavState?.flyout === 'triggered-animate-close' && !isFhsEnabled && $5fbce3fa1124ca81$var$styles.flyoutAnimateClosed,
                    (sideNavState?.flyout === 'open' || sideNavState?.flyout === 'triggered-animate-close') && !$5fbce3fa1124ca81$var$isFirefox && isFhsEnabled && $5fbce3fa1124ca81$var$styles.flyoutBaseStylesFullHeightSidebar,
                    sideNavState?.flyout === 'triggered-animate-close' && !$5fbce3fa1124ca81$var$isFirefox && isFhsEnabled && $5fbce3fa1124ca81$var$styles.flyoutAnimateClosedFullHeightSidebar,
                    sideNavState?.flyout === 'open' && !$5fbce3fa1124ca81$var$isFirefox && isFhsEnabled && $5fbce3fa1124ca81$var$styles.flyoutOpenFullHeightSidebar,
                    sideNavState?.flyout === 'triggered-animate-close' && !$5fbce3fa1124ca81$var$isFirefox && isFhsEnabled && $5fbce3fa1124ca81$var$styles.flyoutAnimateClosedFullHeightSidebar
                ]),
                children: [
                    /*#__PURE__*/ (0, $2iln5.jsx)((0, $lsCRl.DangerouslyHoistCssVarToDocumentRoot), {
                        variableName: (0, $3CMDc.sideNavLiveWidthVar),
                        value: "0px",
                        mediaQuery: (0, $6bZZN.media).above.md,
                        responsiveValue: isExpandedOnDesktop ? `var(${$5fbce3fa1124ca81$var$panelSplitterResizingVar}, ${clampedWidth})` : 0
                    }),
                    dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
                    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
                    // When they aren't needed anymore we can delete them wholesale.
                    /*#__PURE__*/ (0, $2iln5.jsx)((0, $lsCRl.DangerouslyHoistCssVarToDocumentRoot), {
                        variableName: (0, $3CMDc.UNSAFE_sideNavLayoutVar),
                        value: `var(${(0, $3CMDc.sideNavLiveWidthVar)})`
                    }),
                    /*#__PURE__*/ (0, $2iln5.jsx)((0, $kKhAx.PanelSplitterProvider), {
                        panelId: (0, $3CMDc.sideNavPanelSplitterId),
                        panelRef: navRef,
                        portalRef: isFhsEnabled ? panelSplitterPortalTargetRef : undefined,
                        panelWidth: width,
                        onCompleteResize: setWidth,
                        getResizeBounds: $5fbce3fa1124ca81$var$getResizeBounds,
                        resizingCssVar: $5fbce3fa1124ca81$var$panelSplitterResizingVar,
                        // Not resizable when in peek (flyout) mode.
                        isEnabled: !isFlyoutVisible,
                        shortcut: isShortcutEnabled ? (0, $dE5R1.sideNavToggleTooltipKeyboardShortcut) : undefined,
                        children: /*#__PURE__*/ (0, $2iln5.jsx)("div", {
                            className: (0, $jAkMr.default)([
                                $5fbce3fa1124ca81$var$styles.flexContainer
                            ]),
                            children: children
                        })
                    })
                ]
            }),
            isFhsEnabled && /*#__PURE__*/ (0, $2iln5.jsx)("div", {
                ref: panelSplitterPortalTargetRef,
                "data-layout-slot": true,
                style: {
                    // We need to use an inline style here to share the side nav width to position the panel splitter.
                    // We can't use the existing --n_sNvlw variable (sideNavLiveWidthVar) because it is set to 0 when the side nav is collapsed on desktop,
                    // however the panel splitter is still visible and usable on small viewports until 48rem.
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    [$5fbce3fa1124ca81$var$sideNavClampedWidthVar]: clampedWidth
                },
                className: (0, $jAkMr.default)([
                    $5fbce3fa1124ca81$var$panelSplitterPortalTargetStyles.root,
                    isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $5fbce3fa1124ca81$var$styles.hiddenMobileOnly,
                    !isExpandedOnDesktop && isExpandedOnMobile && !isFlyoutVisible && $5fbce3fa1124ca81$var$styles.hiddenDesktopOnly,
                    !isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $5fbce3fa1124ca81$var$styles.hiddenMobileAndDesktop
                ])
            })
        ]
    });
}
function $5fbce3fa1124ca81$export$1a35787d6353cf6a({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label, skipLinkLabel: // Default value is defined in `SideNavInternal`
skipLinkLabel = label, onExpand: // Default value is defined in `SideNavInternal`
onExpand, onCollapse: onCollapse, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, canToggleWithShortcut: canToggleWithShortcut, id: id }) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $c7USH.OpenLayerObserverNamespaceProvider), {
        namespace: (0, $3CMDc.openLayerObserverSideNavNamespace),
        children: /*#__PURE__*/ (0, $2iln5.jsx)($5fbce3fa1124ca81$var$SideNavInternal, {
            defaultCollapsed: defaultCollapsed,
            defaultWidth: defaultWidth,
            testId: testId,
            label: label,
            skipLinkLabel: skipLinkLabel,
            onExpand: onExpand,
            onCollapse: onCollapse,
            onPeekStart: onPeekStart,
            onPeekEnd: onPeekEnd,
            id: id,
            canToggleWithShortcut: canToggleWithShortcut,
            children: children
        })
    });
}

});
parcelRegister("c7USH", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceProvider", () => $0bc908e0e8030827$export$327d0d2a7ae6f7cc);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $kEkKo = parcelRequire("kEkKo");

var $cHn7j = parcelRequire("cHn7j");

var $56yYq = parcelRequire("56yYq");
function $0bc908e0e8030827$export$327d0d2a7ae6f7cc({ children: children, namespace: namespace }) {
    // If there is an existing namespace context being provided, throw an invariant.
    // This use case is not supported at this time.
    const parentContext = (0, $56yYq.useOpenLayerObserverNamespace)();
    (0, $4tluv.useEffect)(()=>{
        (0, $kEkKo.default)(parentContext === null, `An OpenLayerObserver namespace already exists in this component tree: ${parentContext}. Nesting OpenLayerObserverNamespaceProvider is not supported.`);
    }, [
        parentContext
    ]);
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $cHn7j.OpenLayerObserverNamespaceContext).Provider, {
        value: namespace,
        children: children
    });
}

});

parcelRegister("2njLb", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_media", () => $df20b070a92ab374$export$c881183ca713c214);
$parcel$export(module.exports, "media", () => (parcelRequire("6bZZN")).media);

var $6bZZN = parcelRequire("6bZZN");
const $df20b070a92ab374$export$c881183ca713c214 = (0, $6bZZN.media);

});
parcelRegister("6bZZN", function(module, exports) {
$parcel$export(module.exports, "media", () => $28084cea9958d2a0$export$987d49ffe1b0900f);
const $28084cea9958d2a0$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

});


parcelRegister("8DgQK", function(module, exports) {
$parcel$export(module.exports, "useSkipLinkInternal", () => $09cb69df853d4339$export$707b94c26b8b75aa);

var $4tluv = parcelRequire("4tluv");

var $evtNP = parcelRequire("evtNP");
const $09cb69df853d4339$export$707b94c26b8b75aa = ({ id: id, label: label, listIndex: listIndex, onBeforeNavigate: onBeforeNavigate, isHidden: isHidden })=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = (0, $4tluv.useContext)((0, $evtNP.SkipLinksContext));
    (0, $4tluv.useEffect)(()=>{
        if (isHidden) /**
       * Skip links are hidden for slots with 0 height or width.
       * They should not be registered.
       */ return;
        registerSkipLink({
            id: id,
            label: label,
            listIndex: listIndex,
            onBeforeNavigate: onBeforeNavigate,
            isHidden: isHidden
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        isHidden,
        label,
        listIndex,
        onBeforeNavigate,
        registerSkipLink,
        unregisterSkipLink
    ]);
};

});
parcelRegister("evtNP", function(module, exports) {
$parcel$export(module.exports, "SkipLinksContext", () => $c6fe9f81fa888ae3$export$4c5cc3b14c7678a);

var $4tluv = parcelRequire("4tluv");

var $ccErM = parcelRequire("ccErM");
const $c6fe9f81fa888ae3$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $4tluv.createContext)({
    registerSkipLink: (0, $ccErM.default),
    unregisterSkipLink: (0, $ccErM.default)
});

});


parcelRegister("gFfv2", function(module, exports) {
$parcel$export(module.exports, "TopNavStartElement", () => $e04ac18eeb2cb725$export$e9e5087bd319cc8c);

var $4tluv = parcelRequire("4tluv");
const $e04ac18eeb2cb725$export$e9e5087bd319cc8c = /*#__PURE__*/ (0, $4tluv.createContext)(null);

});

parcelRegister("lsCRl", function(module, exports) {
$parcel$export(module.exports, "DangerouslyHoistCssVarToDocumentRoot", () => $22d9174dd3799806$export$9f45a1325e3cdfb8);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");
const $22d9174dd3799806$var$getCssStringValue = (value)=>typeof value === 'number' ? `${value}px` : value;
const $22d9174dd3799806$export$9f45a1325e3cdfb8 = ({ variableName: variableName, value: value, mediaQuery: mediaQuery, responsiveValue: responsiveValue })=>{
    /**
   * Note don't put multiple variables in multiple lines. eg
   * <style>
   *   {css1}
   *   {css2}
   * </style>
   *
   * React will insert an empty HTML comment in between the text in SSR.
   * This is not a valid tag and will break the page.
   * <style>foo<!-- -->bar</style>
   */ let style = `:root { ${variableName}: ${$22d9174dd3799806$var$getCssStringValue(value)} }`;
    if (mediaQuery && responsiveValue) style += ` ${mediaQuery} { :root { ${variableName}: ${$22d9174dd3799806$var$getCssStringValue(responsiveValue)} } }`;
    return(// Using a global style is required for SSR, as we can't use React hooks
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
    /*#__PURE__*/ (0, $2iln5.jsx)("style", {
        children: style
    }));
};

});

parcelRegister("dmhFx", function(module, exports) {
$parcel$export(module.exports, "DangerouslyHoistSlotSizes", () => $9324d53a231e5391$export$66e2c1a0115af861);

var $4tluv = parcelRequire("4tluv");
const $9324d53a231e5391$export$66e2c1a0115af861 = /*#__PURE__*/ (0, $4tluv.createContext)(false);

});

parcelRegister("kKhAx", function(module, exports) {
$parcel$export(module.exports, "PanelSplitterProvider", () => $baf3ee830b10dede$export$f662bfb764348932);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $fBEso = parcelRequire("fBEso");
const $baf3ee830b10dede$export$f662bfb764348932 = ({ panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, getResizeBounds: getResizeBounds, resizingCssVar: resizingCssVar, panelRef: panelRef, portalRef: providedPortalRef, position: position = 'end', isEnabled: isEnabled = true, shortcut: shortcut, children: children })=>{
    const portalRef = (0, $4tluv.useRef)(null);
    const context = (0, $4tluv.useMemo)(()=>({
            panelId: panelId,
            panelWidth: panelWidth,
            onCompleteResize: onCompleteResize,
            getResizeBounds: getResizeBounds,
            resizingCssVar: resizingCssVar,
            position: position,
            panelRef: panelRef,
            isEnabled: isEnabled,
            portalRef: typeof providedPortalRef !== 'undefined' ? providedPortalRef : portalRef,
            shortcut: shortcut
        }), [
        panelId,
        panelWidth,
        onCompleteResize,
        getResizeBounds,
        resizingCssVar,
        position,
        panelRef,
        isEnabled,
        providedPortalRef,
        shortcut
    ]);
    return /*#__PURE__*/ (0, $2iln5.jsxs)((0, $4tluv.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2iln5.jsx)((0, $fBEso.PanelSplitterContext).Provider, {
                value: context,
                children: children
            }),
            typeof providedPortalRef !== 'undefined' ? null : /*#__PURE__*/ (0, $2iln5.jsx)("div", {
                ref: portalRef
            })
        ]
    });
};

});

parcelRegister("it82a", function(module, exports) {
$parcel$export(module.exports, "useLayoutId", () => $7c9c714aa4a98c97$export$110c3550c7c1c9aa);

var $4bYOS = parcelRequire("4bYOS");
function $7c9c714aa4a98c97$export$110c3550c7c1c9aa({ providedId: providedId } = {}) {
    const uniqueId = (0, $4bYOS.useSkipLinkId)();
    const id = providedId ? providedId : uniqueId;
    return id;
}

});
parcelRegister("4bYOS", function(module, exports) {
$parcel$export(module.exports, "useSkipLinkId", () => $52cd4cbc20160922$export$fa3cfac0c8e29c5c);

var $fEY94 = parcelRequire("fEY94");
function $52cd4cbc20160922$export$fa3cfac0c8e29c5c() {
    const uniqueId = (0, $fEY94.useId)();
    return uniqueId;
}

});


parcelRegister("k649C", function(module, exports) {
$parcel$export(module.exports, "useResizingWidthCssVarOnRootElement", () => $358cd73405c72b5f$export$d4931ecf0fbcc8fc);

var $4tluv = parcelRequire("4tluv");

var $9Zu6O = parcelRequire("9Zu6O");

var $4LjiE = parcelRequire("4LjiE");

var $2u2R1 = parcelRequire("2u2R1");
function $358cd73405c72b5f$export$d4931ecf0fbcc8fc({ isEnabled: isEnabled = true, cssVar: cssVar, panelId: panelId }) {
    (0, $4tluv.useEffect)(()=>{
        if (!isEnabled) return;
        return (0, $9Zu6O.combine)((0, $4LjiE.monitorForElements)({
            canMonitor ({ source: source }) {
                return source.data.panelId === panelId;
            },
            onDrag ({ source: source }) {
                if (!(0, $2u2R1.isPanelSplitterDragData)(source.data)) return;
                /**
         * Copies the resizing width value to the `<html>` element.
         *
         * Required to reflect the live width of the side navigation.
         *
         * Used by:
         *   - Legacy `--leftSidebarWidth` variable
         *   - Panel slot max-width constraint
         *
         * When the legacy `--leftSidebarWidth` variable is no longer needed,
         * we could consider writing to the `Panel` element instead.
         */ document.documentElement.style.setProperty(cssVar, source.data.resizingWidth);
            },
            onDrop () {
                document.documentElement.style.removeProperty(cssVar);
            }
        }));
    }, [
        cssVar,
        isEnabled,
        panelId
    ]);
    (0, $4tluv.useEffect)(()=>{
        if (!isEnabled) return;
        /**
     * Ensures that the resizing CSS var on the `<html>` element is cleaned up properly
     * if the component unmounts during a drag.
     */ return function cleanupGlobalResizingCssVar() {
            document.documentElement.style.removeProperty(cssVar);
        };
    }, [
        cssVar,
        isEnabled
    ]);
}

});

parcelRegister("8iE39", function(module, exports) {
$parcel$export(module.exports, "useSafeDefaultWidth", () => $9d90eb237a27b5ec$export$cff429d7d83ba1f0);
/**
 * Returns the `fallbackWidth` if the provided `defaultWidthProp` is not an integer value.
 */ function $9d90eb237a27b5ec$export$cff429d7d83ba1f0({ defaultWidthProp: defaultWidthProp, fallbackDefaultWidth: fallbackDefaultWidth, slotName: slotName }) {
    // If the provided `defaultWidth` is invalid then we use our fallback.
    // We are using a runtime check because some invalid numbers like `NaN` are not caught by types,
    // and we saw some issues in products where our experience broke due to this.
    if (!Number.isInteger(defaultWidthProp)) return fallbackDefaultWidth;
    return defaultWidthProp;
}

});

parcelRegister("lPYIa", function(module, exports) {
$parcel$export(module.exports, "sideNavFlyoutCloseDelayMs", () => $99e837b2c44a52db$export$a7801e29f563faad);
// Note: this value has been pulled into a separate file to better
// support testing with Playwright. Playwright did not like importing
// an exported value from `sidenav.tsx` which has `@jsxRuntime classic`.
//
// Error:
// > importSource cannot be set when runtime is classic.
/**
 * How long the flyout should remain open after the users
 * pointer has left the side nav flyout
 */ const $99e837b2c44a52db$export$a7801e29f563faad = 400;

});

parcelRegister("80OBc", function(module, exports) {
$parcel$export(module.exports, "SetSideNavVisibilityState", () => $4081a5d4c0407b8e$export$f6b496b07d1ea493);

var $4tluv = parcelRequire("4tluv");

var $ccErM = parcelRequire("ccErM");
const $4081a5d4c0407b8e$export$f6b496b07d1ea493 = /*#__PURE__*/ (0, $4tluv.createContext)((0, $ccErM.default));

});

parcelRegister("jyKIs", function(module, exports) {
$parcel$export(module.exports, "SideNavToggleButtonElement", () => $01533d853e72dd43$export$9c1768094bef896);

var $4tluv = parcelRequire("4tluv");
const $01533d853e72dd43$export$9c1768094bef896 = /*#__PURE__*/ (0, $4tluv.createContext)(null);

});

parcelRegister("dE5R1", function(module, exports) {
$parcel$export(module.exports, "sideNavToggleTooltipKeyboardShortcut", () => $05f4d6b7094a60b0$export$bcd616a79072c3e4);
/**
 * The keyboard shortcut used in tooltips for indicating how to toggle the side nav.
 *
 * Used in `SideNavToggleButton` and `SideNavPanelSplitter` tooltips.
 */ const $05f4d6b7094a60b0$export$bcd616a79072c3e4 = [
    'Ctrl',
    '['
];

});

parcelRegister("76gw6", function(module, exports) {
$parcel$export(module.exports, "SideNavVisibilityState", () => $ca8379c184a57ff8$export$eb04201bb6dd1e4e);

var $4tluv = parcelRequire("4tluv");
const $ca8379c184a57ff8$export$eb04201bb6dd1e4e = /*#__PURE__*/ (0, $4tluv.createContext)(null);

});

parcelRegister("43xg0", function(module, exports) {
$parcel$export(module.exports, "useExpandSideNav", () => $d20e948d46003c26$export$e44b4744d8ff971a);

var $4tluv = parcelRequire("4tluv");

var $80OBc = parcelRequire("80OBc");
function $d20e948d46003c26$export$e44b4744d8ff971a({ trigger: trigger = 'programmatic' } = {}) {
    const setSideNavState = (0, $4tluv.useContext)((0, $80OBc.SetSideNavVisibilityState));
    const expandSideNav = (0, $4tluv.useCallback)(()=>{
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        if (matches) setSideNavState((currentState)=>{
            // No-op if the side nav state has not been initialised yet
            // e.g. if the SideNav has not been mounted yet
            if (!currentState) return null;
            // Skip the re-render if it's a no-op change
            if (currentState.desktop === 'expanded' && currentState.flyout === 'closed') return currentState;
            return {
                mobile: currentState.mobile,
                desktop: 'expanded',
                flyout: 'closed',
                lastTrigger: trigger
            };
        });
        else setSideNavState((currentState)=>{
            // No-op if the side nav state has not been initialised yet
            // e.g. if the SideNav has not been mounted yet
            if (!currentState) return null;
            // Skip the re-render if it's a no-op change
            if (currentState.mobile === 'expanded' && currentState.flyout === 'closed') return currentState;
            return {
                desktop: currentState.desktop,
                mobile: 'expanded',
                flyout: 'closed',
                lastTrigger: trigger
            };
        });
    }, [
        setSideNavState,
        trigger
    ]);
    return expandSideNav;
}

});

parcelRegister("iEJEn", function(module, exports) {
$parcel$export(module.exports, "useIsSideNavShortcutEnabled", () => $3c511ac83594c920$export$be30cdcd17f95ec7);

var $4tluv = parcelRequire("4tluv");

var $3HmjP = parcelRequire("3HmjP");
function $3c511ac83594c920$export$be30cdcd17f95ec7() {
    return (0, $4tluv.useContext)((0, $3HmjP.IsSideNavShortcutEnabledContext));
}

});
parcelRegister("3HmjP", function(module, exports) {
$parcel$export(module.exports, "IsSideNavShortcutEnabledContext", () => $bb1b0fe2d827c0d8$export$c41e1ac5602bc8d5);

var $4tluv = parcelRequire("4tluv");
const $bb1b0fe2d827c0d8$export$c41e1ac5602bc8d5 = /*#__PURE__*/ (0, $4tluv.createContext)(false);

});


parcelRegister("9kOZe", function(module, exports) {
$parcel$export(module.exports, "useSideNavRef", () => $a3b580b34bbd4753$export$fa4d0cff03b1ea4f);

var $4tluv = parcelRequire("4tluv");

var $1eI22 = parcelRequire("1eI22");
function $a3b580b34bbd4753$export$fa4d0cff03b1ea4f() {
    return (0, $4tluv.useContext)((0, $1eI22.SideNavRefContext));
}

});
parcelRegister("1eI22", function(module, exports) {
$parcel$export(module.exports, "SideNavRefContext", () => $d3202cd6c75b0237$export$1cd490805a3a9874);

var $4tluv = parcelRequire("4tluv");
const $d3202cd6c75b0237$export$1cd490805a3a9874 = /*#__PURE__*/ (0, $4tluv.createContext)({
    current: null
});

});


parcelRegister("avMNZ", function(module, exports) {
$parcel$export(module.exports, "useSideNavToggleKeyboardShortcut", () => $bd534c08fe96c825$export$f762e7ac9d86adb0);

var $4tluv = parcelRequire("4tluv");

var $Hyfcf = parcelRequire("Hyfcf");

var $aH1KC = parcelRequire("aH1KC");

var $6ZwWP = parcelRequire("6ZwWP");

var $ltmxR = parcelRequire("ltmxR");

var $iEJEn = parcelRequire("iEJEn");

var $26fBJ = parcelRequire("26fBJ");
function $bd534c08fe96c825$export$f762e7ac9d86adb0({ canToggleWithShortcut: canToggleWithShortcut }) {
    const isFhsEnabled = (0, $ltmxR.useIsFhsEnabled)();
    const openLayerObserver = (0, $6ZwWP.useOpenLayerObserver)();
    const toggleVisibilityByShortcut = (0, $26fBJ.useToggleSideNav)({
        trigger: 'keyboard'
    });
    const canToggleWithShortcutStableRef = (0, $aH1KC.default)(canToggleWithShortcut);
    const isSideNavShortcutEnabled = (0, $iEJEn.useIsSideNavShortcutEnabled)();
    (0, $4tluv.useEffect)(()=>{
        if (!isFhsEnabled) return;
        if (!isSideNavShortcutEnabled) return;
        return (0, $Hyfcf.bind)(window, {
            type: 'keydown',
            listener (event) {
                if (event.ctrlKey && event.key === '[') {
                    if (canToggleWithShortcutStableRef.current && !canToggleWithShortcutStableRef.current()) // Return early if the callback returns false.
                    // If the callback is not provided, we assume the shortcut is enabled.
                    return;
                    if (event.repeat) // Ignore repeated keydown events from holding down the keys
                    return;
                    if (openLayerObserver && openLayerObserver.getCount({
                        type: 'modal'
                    }) > 0) // Return early if there are any open modals
                    return;
                    openLayerObserver?.closeLayers();
                    toggleVisibilityByShortcut();
                }
            }
        });
    }, [
        canToggleWithShortcutStableRef,
        isFhsEnabled,
        isSideNavShortcutEnabled,
        openLayerObserver,
        toggleVisibilityByShortcut
    ]);
}

});
parcelRegister("26fBJ", function(module, exports) {
$parcel$export(module.exports, "useToggleSideNav", () => $52f0b0345f56ef53$export$477ee35601a0a8ce);

var $4tluv = parcelRequire("4tluv");

var $80OBc = parcelRequire("80OBc");
function $52f0b0345f56ef53$export$477ee35601a0a8ce({ trigger: trigger = 'programmatic' } = {}) {
    const setSideNavState = (0, $4tluv.useContext)((0, $80OBc.SetSideNavVisibilityState));
    const toggleSideNav = (0, $4tluv.useCallback)(()=>{
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        if (matches) setSideNavState((currentState)=>{
            // No-op if the side nav state has not been initialised yet
            // e.g. if the SideNav has not been mounted yet
            if (!currentState) return null;
            return {
                mobile: currentState.mobile,
                desktop: currentState.desktop === 'expanded' ? 'collapsed' : 'expanded',
                flyout: 'closed',
                lastTrigger: trigger
            };
        });
        else setSideNavState((currentState)=>{
            // No-op if the side nav state has not been initialised yet
            // e.g. if the SideNav has not been mounted yet
            if (!currentState) return null;
            return {
                desktop: currentState.desktop,
                mobile: currentState.mobile === 'expanded' ? 'collapsed' : 'expanded',
                flyout: 'closed',
                lastTrigger: trigger
            };
        });
    }, [
        setSideNavState,
        trigger
    ]);
    return toggleSideNav;
}

});


parcelRegister("expak", function(module, exports) {
$parcel$export(module.exports, "useSideNavVisibility", () => $cf9d468a3a580832$export$4a602ad7e09bdb2c);

var $4tluv = parcelRequire("4tluv");

var $76gw6 = parcelRequire("76gw6");
const $cf9d468a3a580832$export$4a602ad7e09bdb2c = ({ defaultCollapsed: defaultCollapsed = false } = {})=>{
    const sideNavState = (0, $4tluv.useContext)((0, $76gw6.SideNavVisibilityState));
    // If the context value is `null`, it means we are still in SSR, and should use the default values.
    // For desktop, it comes from the `defaultCollapsed` prop, and for mobile, it is always `false`.
    if (sideNavState === null) return {
        isExpandedOnDesktop: !defaultCollapsed,
        isExpandedOnMobile: false
    };
    return {
        isExpandedOnDesktop: sideNavState.desktop === 'expanded',
        isExpandedOnMobile: sideNavState.mobile === 'expanded'
    };
};

});

parcelRegister("4dO7T", function(module, exports) {
$parcel$export(module.exports, "useSideNavVisibilityCallbacks", () => $2a0c250e4b89b4f8$export$1904b8f2577aba9a);

var $4tluv = parcelRequire("4tluv");

var $bDwOM = parcelRequire("bDwOM");
function $2a0c250e4b89b4f8$export$1904b8f2577aba9a({ onExpand: onExpand, onCollapse: onCollapse, isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile, lastTrigger: lastTrigger }) {
    // Wrapping in refs so we can call them in `useEffect` without changes to them triggering the `useEffect`
    const onExpandRef = (0, $4tluv.useRef)(onExpand);
    const onCollapseRef = (0, $4tluv.useRef)(onCollapse);
    (0, $4tluv.useEffect)(()=>{
        onExpandRef.current = onExpand;
        onCollapseRef.current = onCollapse;
    }, [
        onExpand,
        onCollapse
    ]);
    const previousIsExpandedOnDesktop = (0, $bDwOM.default)(isExpandedOnDesktop);
    (0, $4tluv.useEffect)(()=>{
        if (previousIsExpandedOnDesktop === undefined || previousIsExpandedOnDesktop === isExpandedOnDesktop) /**
       * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
       *
       * The previous value can be equal to the current one if the component re-renders due to something else changing.
       *
       * In both cases the value hasn't changed and we don't want to notify consumers.
       */ return;
        if (isExpandedOnDesktop) onExpandRef.current?.({
            screen: 'desktop',
            trigger: lastTrigger
        });
        else onCollapseRef.current?.({
            screen: 'desktop',
            trigger: lastTrigger
        });
    }, [
        previousIsExpandedOnDesktop,
        isExpandedOnDesktop,
        lastTrigger
    ]);
    const previousIsExpandedOnMobile = (0, $bDwOM.default)(isExpandedOnMobile);
    (0, $4tluv.useEffect)(()=>{
        if (previousIsExpandedOnMobile === undefined || previousIsExpandedOnMobile === isExpandedOnMobile) /**
       * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
       *
       * The previous value can be equal to the current one if the component re-renders due to something else changing.
       *
       * In both cases the value hasn't changed and we don't want to notify consumers.
       */ return;
        if (isExpandedOnMobile) onExpandRef.current?.({
            screen: 'mobile',
            trigger: lastTrigger
        });
        else onCollapseRef.current?.({
            screen: 'mobile',
            trigger: lastTrigger
        });
    }, [
        previousIsExpandedOnMobile,
        isExpandedOnMobile,
        lastTrigger
    ]);
}

});


parcelRegister("em3CX", function(module, exports) {
$parcel$export(module.exports, "SideNavBody", () => $c4c397b10c6915c1$export$28f21f3651df4fa1);
/* side-nav-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $jAkMr = parcelRequire("jAkMr");

var $4tluv = parcelRequire("4tluv");

var $hHj16 = parcelRequire("hHj16");

var $ltmxR = parcelRequire("ltmxR");
const $c4c397b10c6915c1$export$28f21f3651df4fa1 = /*#__PURE__*/ (0, $4tluv.forwardRef)($c4c397b10c6915c1$var$_SideNavContent);
// Placing this const below the function breaks Compiled!
const $c4c397b10c6915c1$var$styles = {
    scrollContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo1wug _18m91wug",
    paddingContainer: "_1q51utpp _y4tiutpp _85i5utpp _bozgutpp"
};
function $c4c397b10c6915c1$var$_SideNavContent({ children: children, testId: testId }, forwardedRef) {
    const isFhsEnabled = (0, $ltmxR.useIsFhsEnabled)();
    const internalRef = (0, $4tluv.useRef)(null);
    const mergedRef = (0, $4tluv.useMemo)(()=>(0, $hHj16.default)([
            internalRef,
            forwardedRef
        ]), [
        forwardedRef
    ]);
    return /*#__PURE__*/ (0, $2iln5.jsx)("div", {
        ref: isFhsEnabled ? mergedRef : forwardedRef,
        "data-testid": testId,
        className: (0, $jAkMr.default)([
            $c4c397b10c6915c1$var$styles.scrollContainer
        ]),
        children: /*#__PURE__*/ (0, $2iln5.jsx)("div", {
            className: (0, $jAkMr.default)([
                $c4c397b10c6915c1$var$styles.paddingContainer
            ]),
            children: children
        })
    });
}

});

parcelRegister("f9iF7", function(module, exports) {
$parcel$export(module.exports, "SideNavFooter", () => $fbca3ae2ff8aa473$export$b773c4c9cf740fbe);
/* side-nav-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ /* side-nav-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ /* side-nav-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");
const $fbca3ae2ff8aa473$var$styles = {
    root: "_1q51utpp _y4tiutpp _85i5utpp _bozgutpp _7myae4h9 _1sw7nqa1 _qgnu1l7x"
};
const $fbca3ae2ff8aa473$export$b773c4c9cf740fbe = ({ children: /**
   * The content of the layout area.
   */ children, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $2iln5.jsx)("div", {
        className: (0, $jAkMr.default)([
            $fbca3ae2ff8aa473$var$styles.root,
            xcss
        ]),
        children: children
    });
};

});

parcelRegister("7FPlQ", function(module, exports) {
$parcel$export(module.exports, "SideNavHeader", () => $af9731c2e1f94ea3$export$9d28ff3a0d89869c);
/* side-nav-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");
const $af9731c2e1f94ea3$var$styles = {
    root: "_18zrutpp _1q51utpp _85i51b66"
};
const $af9731c2e1f94ea3$export$9d28ff3a0d89869c = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2iln5.jsx)("div", {
        className: (0, $jAkMr.default)([
            $af9731c2e1f94ea3$var$styles.root
        ]),
        children: children
    });
};

});

parcelRegister("309oB", function(module, exports) {
$parcel$export(module.exports, "SideNav", () => (parcelRequire("iha90")).SideNav);
$parcel$export(module.exports, "SideNavHeader", () => (parcelRequire("7FPlQ")).SideNavHeader);
$parcel$export(module.exports, "SideNavBody", () => (parcelRequire("em3CX")).SideNavBody);
$parcel$export(module.exports, "SideNavFooter", () => (parcelRequire("f9iF7")).SideNavFooter);
$parcel$export(module.exports, "SideNavToggleButton", () => (parcelRequire("14XEF")).SideNavToggleButton);
$parcel$export(module.exports, "useToggleSideNav", () => (parcelRequire("26fBJ")).useToggleSideNav);
$parcel$export(module.exports, "useExpandSideNav", () => (parcelRequire("43xg0")).useExpandSideNav);
$parcel$export(module.exports, "SideNavPanelSplitter", () => (parcelRequire("5YUwp")).SideNavPanelSplitter);

var $iha90 = parcelRequire("iha90");

var $7FPlQ = parcelRequire("7FPlQ");

var $em3CX = parcelRequire("em3CX");

var $f9iF7 = parcelRequire("f9iF7");

var $14XEF = parcelRequire("14XEF");

var $26fBJ = parcelRequire("26fBJ");

var $43xg0 = parcelRequire("43xg0");

var $5YUwp = parcelRequire("5YUwp");

});
parcelRegister("14XEF", function(module, exports) {
$parcel$export(module.exports, "SideNavToggleButton", () => $6f8540c326ccd070$export$8bd77667631fec25);
/* toggle-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $jAkMr = parcelRequire("jAkMr");

var $4tluv = parcelRequire("4tluv");

var $Hyfcf = parcelRequire("Hyfcf");

var $8ik9q = parcelRequire("8ik9q");

var $gkEme = parcelRequire("gkEme");

var $QUsft = parcelRequire("QUsft");

var $6ZwWP = parcelRequire("6ZwWP");

var $ltmxR = parcelRequire("ltmxR");

var $97Piv = parcelRequire("97Piv");

var $eW3UU = parcelRequire("eW3UU");

var $dE5R1 = parcelRequire("dE5R1");

var $76gw6 = parcelRequire("76gw6");

var $iEJEn = parcelRequire("iEJEn");

var $expak = parcelRequire("expak");

var $26fBJ = parcelRequire("26fBJ");
const $6f8540c326ccd070$var$toggleButtonTooltipOptions = {
    // We're disabling pointer events on the tooltip to prevent it from blocking mouse events, so that the side nav flyout stays open
    // when moving the mouse from the top bar to the side nav.
    ignoreTooltipPointerEvents: true
};
// For duplicate "mouseenter" issue when changing icons (see below)
const $6f8540c326ccd070$var$silentIconStyles = null;
const $6f8540c326ccd070$export$8bd77667631fec25 = ({ defaultCollapsed: defaultCollapsed = false, expandLabel: expandLabel, collapseLabel: collapseLabel, testId: testId, interactionName: interactionName, onClick: onClick })=>{
    const isFhsEnabled = (0, $ltmxR.useIsFhsEnabled)();
    const { isExpandedOnDesktop: isSideNavExpandedOnDesktop, isExpandedOnMobile: isSideNavExpandedOnMobile } = (0, $expak.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    });
    const sideNavState = (0, $4tluv.useContext)((0, $76gw6.SideNavVisibilityState));
    // When default state is provided to `Root` the state in context will already be
    // initialized in SSR
    const [isSideNavExpanded, setIsSideNavExpanded] = (0, $4tluv.useState)(sideNavState === null ? !defaultCollapsed : isSideNavExpandedOnDesktop);
    const ref = (0, $4tluv.useContext)((0, $eW3UU.SideNavToggleButtonAttachRef));
    /**
   * Addresses HOT-121458 by ensuring that the toggle button element in context is always up to date.
   *
   * My theory is that something to do with SSR, hydration and suspense was causing the
   * underlying HTML element to change but without causing the toggle button to remount.
   *
   * This meant the effect calling `ref()` did not re-run, and the value in context became stale.
   */ const [element, setElement] = (0, $4tluv.useState)(null);
    (0, $4tluv.useEffect)(()=>{
        ref(element);
    }, [
        element,
        ref
    ]);
    (0, $4tluv.useEffect)(()=>{
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        setIsSideNavExpanded(matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
    }, [
        isSideNavExpandedOnDesktop,
        isSideNavExpandedOnMobile
    ]);
    (0, $4tluv.useEffect)(()=>{
        // When screen size changes, ensure we use the correct visibility state
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $Hyfcf.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                setIsSideNavExpanded(mediaQueryList.matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
            }
        });
    }, [
        isSideNavExpandedOnDesktop,
        isSideNavExpandedOnMobile
    ]);
    const toggleVisibility = (0, $26fBJ.useToggleSideNav)({
        trigger: 'toggle-button'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $8ik9q.useAnalyticsEvents)();
    const openLayerObserver = (0, $6ZwWP.useOpenLayerObserver)();
    const handleClick = (0, $4tluv.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent, {
            isSideNavVisible: isSideNavExpanded
        });
        toggleVisibility();
        if (isFhsEnabled) openLayerObserver?.closeLayers();
    }, [
        isFhsEnabled,
        isSideNavExpanded,
        onClick,
        openLayerObserver,
        toggleVisibility
    ]);
    const handlePointerEnter = (0, $4tluv.useCallback)(()=>{
        // Hovers don't do anything on mobile, so not capturing
        const isDesktop = window.matchMedia('(min-width: 64rem)').matches;
        if (!isDesktop) return;
        const navigationAnalyticsEvent = createAnalyticsEvent({
            source: 'topNav',
            actionSubject: 'sideNav',
            action: 'hovered',
            actionSubjectId: 'sideNavButton',
            attributes: {
                itemState: isSideNavExpanded ? 'expanded' : 'collapsed',
                screen: 'desktop'
            }
        });
        navigationAnalyticsEvent.fire('navigation');
    }, [
        createAnalyticsEvent,
        isSideNavExpanded
    ]);
    /**
   * ## Behaviour
   * It is intentional that collapse icon will be used while the flyout is open.
   * The icon is tied to the expanded / collapse state, and not the flyout state.
   *
   * ## Why a function?
   * Unfortunately, changing the icon inside an <IconButton> when the user is over
   * the button will cause the svg element to be replaced, which can trigger a
   * "mouseenter" event. This is problematic when the user is already over the button,
   * as it can result in a "mouseenter" event after the user manually entered the button.
   *
   * `icon` accepts a function for the `icon` prop (ie a render prop), so we don't need to
   * memoize it, or pull it out into a new function
   */ const icon = (props)=>/*#__PURE__*/ (0, $2iln5.jsx)("span", {
            className: (0, $jAkMr.default)([
                "_1e0c1bgi _lcxvglyw"
            ]),
            children: isSideNavExpanded ? /*#__PURE__*/ (0, $2iln5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gkEme))), {
                ...props
            }) : /*#__PURE__*/ (0, $2iln5.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($QUsft))), {
                ...props
            })
        });
    const isShortcutEnabled = (0, $iEJEn.useIsSideNavShortcutEnabled)();
    const tooltipProps = (0, $4tluv.useMemo)(()=>{
        if (isFhsEnabled) return {
            ...$6f8540c326ccd070$var$toggleButtonTooltipOptions,
            shortcut: isShortcutEnabled ? (0, $dE5R1.sideNavToggleTooltipKeyboardShortcut) : undefined
        };
        return $6f8540c326ccd070$var$toggleButtonTooltipOptions;
    }, [
        isFhsEnabled,
        isShortcutEnabled
    ]);
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $97Piv.IconButton), {
        appearance: "subtle",
        label: isSideNavExpanded ? collapseLabel : expandLabel,
        icon: icon,
        onClick: handleClick,
        onPointerEnter: handlePointerEnter,
        testId: testId,
        isTooltipDisabled: false,
        interactionName: interactionName,
        ref: setElement,
        tooltip: tooltipProps
    });
};

});
parcelRegister("97Piv", function(module, exports) {
$parcel$export(module.exports, "IconButton", () => $0946589badf76f41$export$c25acd513dcc8062);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $3lyVW = parcelRequire("3lyVW");

var $6UQyv = parcelRequire("6UQyv");

var $iNBxj = parcelRequire("iNBxj");
const $0946589badf76f41$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $4tluv.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $6UQyv.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $iNBxj.ThemedIconButton) : (0, $3lyVW.default);
    return /*#__PURE__*/ (0, $2iln5.jsx)(Component, {
        ref: ref,
        ...props
    });
});

});
parcelRegister("6UQyv", function(module, exports) {
$parcel$export(module.exports, "useHasCustomTheme", () => $290c3fb3054af109$export$abfcaeeca4ae7a55);

var $4tluv = parcelRequire("4tluv");
const $290c3fb3054af109$export$d158fa15757a1890 = /*#__PURE__*/ (0, $4tluv.createContext)(false);
function $290c3fb3054af109$export$abfcaeeca4ae7a55() {
    return (0, $4tluv.useContext)($290c3fb3054af109$export$d158fa15757a1890);
}

});

parcelRegister("iNBxj", function(module, exports) {
$parcel$export(module.exports, "ThemedIconButton", () => $3eaadca36d393cc4$export$d9c2d067feb61447);
/* themed-icon-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $hHj16 = parcelRequire("hHj16");

var $3X3Vo = parcelRequire("3X3Vo");

var $eCj8S = parcelRequire("eCj8S");

var $k7gbB = parcelRequire("k7gbB");

var $yb1Rb = parcelRequire("yb1Rb");

var $iPeNt = parcelRequire("iPeNt");
const $3eaadca36d393cc4$export$d9c2d067feb61447 = /*#__PURE__*/ (0, $4tluv.forwardRef)(function ThemedIconButton({ icon: Icon, label: label, tooltip: tooltip, ...props }, ref) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $eCj8S.default), {
        ...tooltip,
        content: tooltip?.content ?? label,
        children: (triggerProps)=>/**
     * The `aria-describedby` from `triggerProps` is intentionally not passed down,
     * because it would cause double announcements with the `VisuallyHidden` label.
     *
     * The `@atlaskit/button` IconButton uses the same approach.
     */ /*#__PURE__*/ (0, $2iln5.jsxs)((0, $iPeNt.ThemedPressable), {
                ...props,
                shape: "square",
                ref: (0, $hHj16.default)([
                    ref,
                    triggerProps.ref
                ]),
                onClick: (event, analyticsEvent)=>{
                    props.onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    props.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    props.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    props.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    props.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    props.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    props.onBlur?.(e);
                },
                children: [
                    (0, $3X3Vo.fg)('platform_themed_button_use_icon_renderer') ? /*#__PURE__*/ (0, $2iln5.jsx)((0, $yb1Rb.default), {
                        icon: Icon
                    }) : /*#__PURE__*/ (0, $2iln5.jsx)(Icon, {
                        label: "",
                        color: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $2iln5.jsx)((0, $k7gbB.default), {
                        children: label
                    })
                ]
            })
    });
});

});
parcelRegister("yb1Rb", function(module, exports) {
$parcel$export(module.exports, "default", () => $02716ad8330cc352$export$2e2bcd8739ae039);

var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $3X3Vo = parcelRequire("3X3Vo");
function $02716ad8330cc352$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 * This is copied from @atlaskit/button to render IconButtons. Some IconButton's DOM element
 * will be re-created during SSR -> SPA hydration without using this, which delays TTVC. As
 * IconRenderer is already used in @atlaskit/button to mitigate this issue, add it here to
 * mitigate the same issue for IconButtons in navigation-system, especially for ThemedIconButton.
 *
 */ const $02716ad8330cc352$var$IconRenderer = ({ icon: Icon })=>{
    const isRenderProp = $02716ad8330cc352$var$isIconRenderProp(Icon);
    let iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $3X3Vo.fg)('platform_dst_button_chevron_sizing') ? (iconName)=>iconName.startsWith('Chevron') ? 'small' : 'medium' : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $2iln5.Fragment), {
        children: isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, $2iln5.jsx)(Icon, {
            ...iconProps
        })
    });
};
var $02716ad8330cc352$export$2e2bcd8739ae039 = $02716ad8330cc352$var$IconRenderer;

});

parcelRegister("iPeNt", function(module, exports) {
$parcel$export(module.exports, "ThemedPressable", () => $31f3aed8cd613002$export$66240319f1f78d74);
/* themed-pressable.tsx generated by @compiled/babel-plugin v0.36.1 */ /* themed-pressable.tsx generated by @compiled/babel-plugin v0.36.1 */ /* themed-pressable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $3yCbE = parcelRequire("3yCbE");

var $3X3Vo = parcelRequire("3X3Vo");

var $dgwv0 = parcelRequire("dgwv0");

var $5S8Q0 = parcelRequire("5S8Q0");
const $31f3aed8cd613002$var$styles = {
    root: "_zulp12x7 _11c8fhey _2rkofajl _v5649dqc _4bfu1r31 _1hmsglyw _ajmmnqa1 _1rjcze3t _1e0c1txw _4cvr1h6o _1bah1h6o _4t3i5r7u _kqswh2mm _1nrm1r31 _1a3b1r31 _9oik1r31 _c2waglyw _4fprglyw _1bnxglyw _1iohnqa1 _5goinqa1 _jf4cnqa1",
    rootT26Shape: "_2rko1qi0",
    border: "_14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _aetrb3bt _18postnw",
    selected: "_11q71qds _syazw5ct _8l3m15jn _f8pjw5ct _1053w5ct _19lcjrv1 _30l3w5ct _j6xtnh62 _9h8hw5ct",
    disabled: "_11q71c9b _syaz1i3i _8l3m1j28 _f8pj1i3i _10531i3i _19lc1c9b _30l31i3i _j6xt1c9b _9h8h1i3i"
};
const $31f3aed8cd613002$var$shapeStyles = {
    default: "_18zrutpp",
    square: "_18zrze3t _1bsb5r7u _vwz4idpf"
};
const $31f3aed8cd613002$var$appearanceStyles = {
    default: "_11q7pkxg _syaz1r31 _8l3maykr _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    subtle: "_11q7pkxg _syaz1r31 _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    primary: "_11q7esko _syaz15o7 _f8pj15o7 _105315o7 _19lcp6hf _30l315o7 _j6xt5sko _9h8h15o7"
};
const $31f3aed8cd613002$export$66240319f1f78d74 = /*#__PURE__*/ (0, $4tluv.forwardRef)(function ThemedPressable({ appearance: appearance = 'default', shape: shape = 'default', isSelected: isSelected, isDisabled: isDisabled, ...props }, ref) {
    const hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $dgwv0.default), {
        ...(0, $5S8Q0.getPrimitiveSpreadProps)(props),
        ref: ref,
        type: "button",
        /**
   * We are using some style values that are outside of the strict
   * `@atlaskit/css` types.
   */ // @ts-expect-error
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $3yCbE.cx)($31f3aed8cd613002$var$styles.root, (0, $3X3Vo.fg)('platform-dst-shape-theme-default') && $31f3aed8cd613002$var$styles.rootT26Shape, $31f3aed8cd613002$var$shapeStyles[shape], hasBorder && $31f3aed8cd613002$var$styles.border, $31f3aed8cd613002$var$appearanceStyles[appearance], isSelected && $31f3aed8cd613002$var$styles.selected, isDisabled && $31f3aed8cd613002$var$styles.disabled),
        isDisabled: isDisabled
    });
});

});
parcelRegister("5S8Q0", function(module, exports) {
$parcel$export(module.exports, "getPrimitiveSpreadProps", () => $23e996f0cc2956f8$export$e4c95325a21f9785);
/**
 * Props from primitives that we explicitly ignore and remove from spread props,
 * because they apply styles.
 *
 * `css` / `className` are not here because primitives don't support them.
 *
 * See `packages/design-system/primitives/src/components/anchor.tsx` and `packages/design-system/primitives/src/components/pressable.tsx`
 * for where these are defined. These shouldn't change very often as the direction is `xcss` over individual props.
 */ function $23e996f0cc2956f8$export$e4c95325a21f9785({ style: style, xcss: xcss, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, ...props }) {
    return props;
}

});




parcelRegister("eW3UU", function(module, exports) {
$parcel$export(module.exports, "SideNavToggleButtonAttachRef", () => $62e1a3a948f88d31$export$fb8fa9a80240785e);

var $4tluv = parcelRequire("4tluv");

var $ccErM = parcelRequire("ccErM");
const $62e1a3a948f88d31$export$fb8fa9a80240785e = /*#__PURE__*/ (0, $4tluv.createContext)((0, $ccErM.default));

});


parcelRegister("5YUwp", function(module, exports) {
$parcel$export(module.exports, "SideNavPanelSplitter", () => $9096d9c15d529481$export$5f595addf4e50d58);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $kEkKo = parcelRequire("kEkKo");

var $6ZwWP = parcelRequire("6ZwWP");

var $ltmxR = parcelRequire("ltmxR");

var $3CMDc = parcelRequire("3CMDc");

var $26fBJ = parcelRequire("26fBJ");

var $aS84f = parcelRequire("aS84f");

var $aFjPS = parcelRequire("aFjPS");

var $fBEso = parcelRequire("fBEso");
/**
 * Namespaces to check for open layers that would interfere with the panel splitter.
 *
 * Placed outside the component for stability, as the list is used as an effect dependency.
 */ const $9096d9c15d529481$var$openLayerNamespacesToCheck = [
    // The side nav panel splitter is layered above the side nav, so needs to be disabled when there are open popups in the side nav.
    (0, $3CMDc.openLayerObserverSideNavNamespace),
    // The side nav panel splitter is layered above the top nav, so needs to be disabled when there are open popups in the top nav.
    (0, $3CMDc.openLayerObserverTopNavStartNamespace),
    (0, $3CMDc.openLayerObserverTopNavMiddleNamespace),
    (0, $3CMDc.openLayerObserverTopNavEndNamespace)
];
/**
 * Returns whether there are any open popups in the side nav or top nav
 */ function $9096d9c15d529481$var$useHasOpenPopupsInSideNavOrTopNav() {
    const isFhsEnabled = (0, $ltmxR.useIsFhsEnabled)();
    const openLayerObserver = (0, $6ZwWP.useOpenLayerObserver)();
    // Setting the initial state to false, as it is unlikely that there would be any open popups when the app starts.
    const [hasOpenPopups, setHasOpenPopups] = (0, $4tluv.useState)(false);
    (0, $4tluv.useEffect)(()=>{
        if (!openLayerObserver || !isFhsEnabled) return;
        function updateState() {
            if (!openLayerObserver) return;
            const hasAnyOpenLayers = $9096d9c15d529481$var$openLayerNamespacesToCheck.some((namespace)=>openLayerObserver.getCount({
                    namespace: namespace,
                    type: 'popup'
                }) > 0);
            setHasOpenPopups(hasAnyOpenLayers);
        }
        // Initial check. We do this _in case_ a popup is already open when the component mounts.
        updateState();
        // Subscribe to each namespace
        const cleanups = $9096d9c15d529481$var$openLayerNamespacesToCheck.map((namespace)=>openLayerObserver.onChange(updateState, {
                namespace: namespace
            }));
        return function cleanupHook() {
            cleanups.forEach((cleanup)=>cleanup());
        };
    }, [
        isFhsEnabled,
        openLayerObserver
    ]);
    return hasOpenPopups;
}
const $9096d9c15d529481$export$5f595addf4e50d58 = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId, shouldCollapseOnDoubleClick: shouldCollapseOnDoubleClick = true, tooltipContent: tooltipContent })=>{
    const context = (0, $4tluv.useContext)((0, $fBEso.PanelSplitterContext));
    (0, $kEkKo.default)(context?.panelId === (0, $3CMDc.sideNavPanelSplitterId), 'SideNavPanelSplitter must be rendered as a child of <SideNav />.');
    const toggleSideNav = (0, $26fBJ.useToggleSideNav)({
        trigger: 'double-click'
    });
    const isFhsEnabled = (0, $ltmxR.useIsFhsEnabled)();
    // The logic and state for disabling the panel splitter when there are open popups
    // in the side nav or top nav is being placed here, instead of in `SideNav`, to prevent
    // re-rendering the side nav anytime the number of open popups changes.
    const hasOpenLayersInSideNavOrTopNav = $9096d9c15d529481$var$useHasOpenPopupsInSideNavOrTopNav();
    if (hasOpenLayersInSideNavOrTopNav && isFhsEnabled) return null;
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $aS84f.OnDoubleClickContext).Provider, {
        value: shouldCollapseOnDoubleClick ? toggleSideNav : undefined,
        children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $aFjPS.PanelSplitter), {
            label: label,
            onResizeStart: onResizeStart,
            onResizeEnd: onResizeEnd,
            testId: testId,
            tooltipContent: // Only displaying the tooltip if double click to collapse is enabled.
            // Otherwise, we would be displaying a tooltip with "Double click to collapse", when it actually won't.
            shouldCollapseOnDoubleClick ? tooltipContent : undefined
        })
    });
};

});


parcelRegister("aoOYT", function(module, exports) {
$parcel$export(module.exports, "Popup", () => $1a95f148029f42f8$export$129a32eedafa97c5);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $fEY94 = parcelRequire("fEY94");

var $2F9FU = parcelRequire("2F9FU");

var $javfE = parcelRequire("javfE");

var $cj4TX = parcelRequire("cj4TX");

var $2nHqC = parcelRequire("2nHqC");

var $lW4yp = parcelRequire("lW4yp");

var $7Dvv6 = parcelRequire("7Dvv6");

var $2uAKV = parcelRequire("2uAKV");
const $1a95f148029f42f8$export$129a32eedafa97c5 = ({ children: children, id: providedId, isOpen: isOpen = false, role: role })=>{
    const [triggerRef, setTriggerRef] = (0, $4tluv.useState)(null);
    const generatedId = (0, $fEY94.useId)();
    const id = providedId || generatedId;
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $lW4yp.RoleContext).Provider, {
        value: role,
        children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $cj4TX.EnsureIsInsidePopupContext).Provider, {
            value: true,
            children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $javfE.IdContext).Provider, {
                value: id,
                children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $2uAKV.TriggerRefContext).Provider, {
                    value: triggerRef,
                    children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $7Dvv6.SetTriggerRefContext).Provider, {
                        value: setTriggerRef,
                        children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $2nHqC.IsOpenContext).Provider, {
                            value: isOpen,
                            children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $2F9FU.Manager), {
                                children: children
                            })
                        })
                    })
                })
            })
        })
    });
};

});
parcelRegister("javfE", function(module, exports) {
$parcel$export(module.exports, "IdContext", () => $71c96afe1bff70f9$export$26537912ea160acd);

var $4tluv = parcelRequire("4tluv");
const $71c96afe1bff70f9$export$26537912ea160acd = /*#__PURE__*/ (0, $4tluv.createContext)(undefined);

});

parcelRegister("cj4TX", function(module, exports) {
$parcel$export(module.exports, "EnsureIsInsidePopupContext", () => $a1941d9138535c2c$export$2d7d3979eeceb992);

var $4tluv = parcelRequire("4tluv");
const $a1941d9138535c2c$export$2d7d3979eeceb992 = /*#__PURE__*/ (0, $4tluv.createContext)(false);

});

parcelRegister("2nHqC", function(module, exports) {
$parcel$export(module.exports, "IsOpenContext", () => $1ff2b6b35e0838ca$export$efa4d9670e96ac31);

var $4tluv = parcelRequire("4tluv");
const $1ff2b6b35e0838ca$export$efa4d9670e96ac31 = /*#__PURE__*/ (0, $4tluv.createContext)(false);

});

parcelRegister("lW4yp", function(module, exports) {
$parcel$export(module.exports, "RoleContext", () => $72d72934e5ce1cbf$export$a8c52551eddf6b9);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $4tluv = parcelRequire("4tluv");
const $72d72934e5ce1cbf$export$a8c52551eddf6b9 = /*#__PURE__*/ (0, $4tluv.createContext)(undefined);

});

parcelRegister("7Dvv6", function(module, exports) {
$parcel$export(module.exports, "SetTriggerRefContext", () => $eeca86ea9ba3cc7e$export$85b81def7d2cbc37);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $4tluv = parcelRequire("4tluv");

var $ccErM = parcelRequire("ccErM");
const $eeca86ea9ba3cc7e$export$85b81def7d2cbc37 = /*#__PURE__*/ (0, $4tluv.createContext)((0, $ccErM.default));

});

parcelRegister("2uAKV", function(module, exports) {
$parcel$export(module.exports, "TriggerRefContext", () => $76cba9c926733578$export$53ee23205ed2541e);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $4tluv = parcelRequire("4tluv");
const $76cba9c926733578$export$53ee23205ed2541e = /*#__PURE__*/ (0, $4tluv.createContext)(null);

});


parcelRegister("lrP4l", function(module, exports) {
$parcel$export(module.exports, "PopupContent", () => $306dab2c49b143b8$export$2a2c7ba12d3231e3);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $dnJ1f = parcelRequire("dnJ1f");

var $3LZFN = parcelRequire("3LZFN");

var $gkJgm = parcelRequire("gkJgm");

var $1KEXw = parcelRequire("1KEXw");

var $fnITI = parcelRequire("fnITI");

var $javfE = parcelRequire("javfE");

var $2nHqC = parcelRequire("2nHqC");

var $2uAKV = parcelRequire("2uAKV");

var $7Kc4c = parcelRequire("7Kc4c");
const $306dab2c49b143b8$var$defaultLayer = 400;
const $306dab2c49b143b8$var$shouldDisableGpuAccelerationModifiers = [
    {
        name: 'computeStyles',
        options: {
            gpuAcceleration: false
        }
    }
];
const $306dab2c49b143b8$export$2a2c7ba12d3231e3 = ({ xcss: xcss, appearance: inAppearance = 'default', children: children, boundary: boundary, offset: offset, strategy: strategy, onClose: onClose, testId: testId, rootBoundary: rootBoundary = 'viewport', shouldFlip: shouldFlip = true, placement: placement = 'auto', fallbackPlacements: fallbackPlacements, popupComponent: popupComponent, autoFocus: autoFocus = true, zIndex: zIndex = $306dab2c49b143b8$var$defaultLayer, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick = false, shouldRenderToParent: inShouldRenderToParent, shouldDisableFocusLock: shouldDisableFocusLock = false, shouldFitContainer: shouldFitContainer, shouldFitViewport: shouldFitViewport, shouldDisableGpuAcceleration: shouldDisableGpuAcceleration = false, role: role, titleId: titleId })=>{
    (0, $7Kc4c.useEnsureIsInsidePopup)();
    const isOpen = (0, $4tluv.useContext)((0, $2nHqC.IsOpenContext));
    const id = (0, $4tluv.useContext)((0, $javfE.IdContext));
    const triggerRef = (0, $4tluv.useContext)((0, $2uAKV.TriggerRefContext));
    const { appearance: appearance, shouldRenderToParent: shouldRenderToParent } = (0, $fnITI.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    });
    const handleOpenLayerObserverCloseSignal = (0, $4tluv.useCallback)(()=>{
        onClose?.(null);
    }, [
        onClose
    ]);
    (0, $3LZFN.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal,
        type: 'popup'
    });
    if (!isOpen) return null;
    const popperWrapper = /*#__PURE__*/ (0, $2iln5.jsx)((0, $dnJ1f.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $1KEXw.default), {
            xcss: xcss,
            appearance: appearance,
            content: children,
            isOpen: isOpen,
            placement: placement,
            fallbackPlacements: fallbackPlacements,
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: shouldFlip,
            offset: offset,
            popupComponent: popupComponent,
            id: id,
            testId: testId,
            onClose: onClose,
            autoFocus: autoFocus,
            shouldFitContainer: shouldFitContainer,
            shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
            shouldRenderToParent: shouldRenderToParent,
            shouldDisableFocusLock: shouldDisableFocusLock,
            triggerRef: triggerRef,
            strategy: strategy,
            shouldFitViewport: shouldFitViewport,
            modifiers: shouldDisableGpuAcceleration ? $306dab2c49b143b8$var$shouldDisableGpuAccelerationModifiers : undefined,
            role: role,
            titleId: titleId
        })
    });
    if (shouldRenderToParent) return popperWrapper;
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $gkJgm.default), {
        zIndex: zIndex,
        children: popperWrapper
    });
};

});
parcelRegister("7Kc4c", function(module, exports) {
$parcel$export(module.exports, "useEnsureIsInsidePopup", () => $ddde9c2a344042c7$export$421fc1dbb5b2c905);

var $4tluv = parcelRequire("4tluv");

var $kEkKo = parcelRequire("kEkKo");

var $cj4TX = parcelRequire("cj4TX");
function $ddde9c2a344042c7$export$421fc1dbb5b2c905() {
    const context = (0, $4tluv.useContext)((0, $cj4TX.EnsureIsInsidePopupContext));
    (0, $kEkKo.default)(context, 'PopupTrigger and PopupContent components must be used within a Popup');
}

});


parcelRegister("8g2ng", function(module, exports) {
$parcel$export(module.exports, "PopupTrigger", () => $ce2f63ba01bb4fed$export$95d4acdbab2fc6ef);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $3X3Vo = parcelRequire("3X3Vo");

var $cAIZq = parcelRequire("cAIZq");

var $2efw1 = parcelRequire("2efw1");

var $javfE = parcelRequire("javfE");

var $2nHqC = parcelRequire("2nHqC");

var $lW4yp = parcelRequire("lW4yp");

var $7Dvv6 = parcelRequire("7Dvv6");

var $7Kc4c = parcelRequire("7Kc4c");
const $ce2f63ba01bb4fed$export$95d4acdbab2fc6ef = ({ children: children })=>{
    (0, $7Kc4c.useEnsureIsInsidePopup)();
    const id = (0, $4tluv.useContext)((0, $javfE.IdContext));
    const setTriggerRef = (0, $4tluv.useContext)((0, $7Dvv6.SetTriggerRefContext));
    const isOpen = (0, $4tluv.useContext)((0, $2nHqC.IsOpenContext));
    const getMergedTriggerRef = (0, $2efw1.useGetMemoizedMergedTriggerRefNew)();
    const role = (0, $4tluv.useContext)((0, $lW4yp.RoleContext));
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $cAIZq.Reference), {
        children: ({ ref: ref })=>children({
                ref: getMergedTriggerRef(ref, setTriggerRef),
                'aria-controls': id,
                'aria-expanded': isOpen,
                'aria-haspopup': role === 'dialog' && (0, $3X3Vo.fg)('platform_dst_nav4_flyout_menu_slots_close_button') ? 'dialog' : true
            })
    });
};

});

parcelRegister("lJGXe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0cdccba3d7742a12d1dd259bf333308d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fd2f1ecd1b6637ba$var$_react = $fd2f1ecd1b6637ba$var$_interopRequireDefault((parcelRequire("4tluv")));

var $fd2f1ecd1b6637ba$var$_baseNew = $fd2f1ecd1b6637ba$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $fd2f1ecd1b6637ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Template".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved fore templates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fd2f1ecd1b6637ba$var$TemplateIcon = (props)=>/*#__PURE__*/ $fd2f1ecd1b6637ba$var$_react.default.createElement($fd2f1ecd1b6637ba$var$_baseNew.default, Object.assign({
        name: "TemplateIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 6h-7v7.5H13a.5.5 0 0 0 .5-.5zm-11 7a.5.5 0 0 0 .5.5h2V6H2.5zm11-10a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v1.5h11zM15 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>`
    }, props));
$fd2f1ecd1b6637ba$var$TemplateIcon.displayName = 'TemplateIcon';
var $fd2f1ecd1b6637ba$var$_default = module.exports.default = $fd2f1ecd1b6637ba$var$TemplateIcon;

});

parcelRegister("jJG1t", function(module, exports) {
$parcel$export(module.exports, "default", () => $44ef3e34de8dcb01$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4tluv = parcelRequire("4tluv");

var $ft5N0 = parcelRequire("ft5N0");

var $dpQkd = parcelRequire("dpQkd");

var $kfPot = parcelRequire("kfPot");
const $44ef3e34de8dcb01$var$gridTemplateAreasVar = '--ds-grid--grid-template-areas';
const $44ef3e34de8dcb01$var$gridTemplateColumnsVar = '--ds-grid--grid-template-columns';
const $44ef3e34de8dcb01$var$gridTemplateRowsVar = '--ds-grid--grid-template-rows';
const $44ef3e34de8dcb01$var$justifyContentMap = {
    start: (0, $ft5N0.css)({
        justifyContent: 'start'
    }),
    center: (0, $ft5N0.css)({
        justifyContent: 'center'
    }),
    end: (0, $ft5N0.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $ft5N0.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $ft5N0.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $ft5N0.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $ft5N0.css)({
        justifyContent: 'stretch'
    })
};
const $44ef3e34de8dcb01$var$justifyItemsMap = {
    start: (0, $ft5N0.css)({
        justifyItems: 'start'
    }),
    center: (0, $ft5N0.css)({
        justifyItems: 'center'
    }),
    end: (0, $ft5N0.css)({
        justifyItems: 'end'
    }),
    stretch: (0, $ft5N0.css)({
        justifyItems: 'stretch'
    })
};
const $44ef3e34de8dcb01$var$alignContentMap = {
    start: (0, $ft5N0.css)({
        alignContent: 'start'
    }),
    center: (0, $ft5N0.css)({
        alignContent: 'center'
    }),
    end: (0, $ft5N0.css)({
        alignContent: 'end'
    }),
    'space-between': (0, $ft5N0.css)({
        alignContent: 'space-between'
    }),
    'space-around': (0, $ft5N0.css)({
        alignContent: 'space-around'
    }),
    'space-evenly': (0, $ft5N0.css)({
        alignContent: 'space-evenly'
    }),
    stretch: (0, $ft5N0.css)({
        alignContent: 'stretch'
    })
};
const $44ef3e34de8dcb01$var$alignItemsMap = {
    start: (0, $ft5N0.css)({
        alignItems: 'start'
    }),
    center: (0, $ft5N0.css)({
        alignItems: 'center'
    }),
    baseline: (0, $ft5N0.css)({
        alignItems: 'baseline'
    }),
    end: (0, $ft5N0.css)({
        alignItems: 'end'
    })
};
const $44ef3e34de8dcb01$var$baseStyles = (0, $ft5N0.css)({
    display: 'grid',
    boxSizing: 'border-box',
    gridTemplateAreas: `var(${$44ef3e34de8dcb01$var$gridTemplateAreasVar})`,
    gridTemplateColumns: `var(${$44ef3e34de8dcb01$var$gridTemplateColumnsVar})`,
    gridTemplateRows: `var(${$44ef3e34de8dcb01$var$gridTemplateRowsVar})`
});
const $44ef3e34de8dcb01$var$gridAutoFlowMap = {
    row: (0, $ft5N0.css)({
        gridAutoFlow: 'row'
    }),
    column: (0, $ft5N0.css)({
        gridAutoFlow: 'column'
    }),
    dense: (0, $ft5N0.css)({
        gridAutoFlow: 'dense'
    }),
    'row dense': (0, $ft5N0.css)({
        gridAutoFlow: 'row dense'
    }),
    'column dense': (0, $ft5N0.css)({
        gridAutoFlow: 'column dense'
    })
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $44ef3e34de8dcb01$var$Grid = /*#__PURE__*/ (0, $4tluv.memo)(/*#__PURE__*/ (0, $4tluv.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, templateAreas: gridTemplateAreas, templateRows: gridTemplateRows, templateColumns: gridTemplateColumns, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    const resolvedStyles = (0, $kfPot.parseXcss)(xcss);
    /**
   * We use CSS variables to allow for dynamic grid templates instead of dynamically setting to `props.style`
   * This allows `props.xcss` to override them as `style={{ gridTemplateAreas }}` would have higher specificity.
   *
   * This must be reset to `initial` if `gridTemplateAreas` is not set, otherwise nested grids will break!
   *
   * NOTE: If we disallow `grid-template-areas` (etc) to be set via `props.xcss`, we can remove this.
   */ const style = (0, $4tluv.useMemo)(()=>({
            [$44ef3e34de8dcb01$var$gridTemplateAreasVar]: gridTemplateAreas ? gridTemplateAreas.map((str)=>`"${str}"`).join('\n') || 'initial' : 'initial',
            [$44ef3e34de8dcb01$var$gridTemplateColumnsVar]: gridTemplateColumns || 'initial',
            [$44ef3e34de8dcb01$var$gridTemplateRowsVar]: gridTemplateRows || 'initial'
        }), [
        gridTemplateAreas,
        gridTemplateColumns,
        gridTemplateRows
    ]);
    return /*#__PURE__*/ (0, $ft5N0.jsx)(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $44ef3e34de8dcb01$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $dpQkd.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $dpQkd.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $dpQkd.spaceStylesMap).rowGap[rowGap],
            alignItems && $44ef3e34de8dcb01$var$alignItemsMap[alignItems],
            alignContent && $44ef3e34de8dcb01$var$alignContentMap[alignContent],
            justifyContent && $44ef3e34de8dcb01$var$justifyContentMap[justifyContent],
            autoFlow && $44ef3e34de8dcb01$var$gridAutoFlowMap[autoFlow],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$44ef3e34de8dcb01$var$Grid.displayName = 'Grid';
var $44ef3e34de8dcb01$export$2e2bcd8739ae039 = $44ef3e34de8dcb01$var$Grid;

});

parcelRegister("23Kd4", function(module, exports) {
$parcel$export(module.exports, "PrimaryDropdownButton", () => $6064dd8d1daa49a4$export$bb3af89fb196520d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4tluv = parcelRequire("4tluv");

var $ft5N0 = parcelRequire("ft5N0");

var $l6Otc = parcelRequire("l6Otc");

var $9BHJD = parcelRequire("9BHJD");
const $6064dd8d1daa49a4$var$buttonNoOpStyle = (0, $ft5N0.css)({
    '--noop': 1
});
const $6064dd8d1daa49a4$export$bb3af89fb196520d = /*#__PURE__*/ (0, $4tluv.forwardRef)((props, ref)=>{
    const { component: component, isHighlighted: isHighlighted, isLoading: isLoading, onClick: onClick, testId: testId, theme: theme, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, $ft5N0.jsx)((0, $9BHJD.PrimaryButton), {
        component: component,
        iconAfter: /*#__PURE__*/ (0, $ft5N0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l6Otc))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        isHighlighted: isHighlighted,
        isLoading: isLoading,
        onClick: onClick,
        ref: ref,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme,
        tooltip: tooltip,
        css: [
            $6064dd8d1daa49a4$var$buttonNoOpStyle
        ],
        ...rest
    });
});

});
parcelRegister("9BHJD", function(module, exports) {
$parcel$export(module.exports, "PrimaryButton", () => $509d5a1912d5c4e1$export$ac16a6a04d9b7c84);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4tluv = parcelRequire("4tluv");

var $ft5N0 = parcelRequire("ft5N0");

var $groaY = parcelRequire("groaY");

var $eCj8S = parcelRequire("eCj8S");

var $2JJu8 = parcelRequire("2JJu8");

var $4BR9K = parcelRequire("4BR9K");
const $509d5a1912d5c4e1$var$VAR_BUTTON_SELECTED_COLOR = '--button-selected-color';
const $509d5a1912d5c4e1$var$VAR_BUTTON_SELECTED_BORDER_COLOR = '--button-selected-border-color';
const $509d5a1912d5c4e1$var$buttonBaseStyles = (0, $ft5N0.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
});
const $509d5a1912d5c4e1$var$buttonNoOpStyle = (0, $ft5N0.css)({
    '--noop': 1
});
const $509d5a1912d5c4e1$var$buttonHighlightedStyles = (0, $ft5N0.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& > *': {
        color: `var(${$509d5a1912d5c4e1$var$VAR_BUTTON_SELECTED_COLOR})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        height: 3,
        position: 'absolute',
        backgroundColor: `var(${$509d5a1912d5c4e1$var$VAR_BUTTON_SELECTED_BORDER_COLOR})`,
        borderStartEndRadius: "var(--ds-radius-xsmall, 1px)",
        borderStartStartRadius: "var(--ds-radius-xsmall, 1px)",
        content: '""',
        insetBlockEnd: 0,
        insetInlineEnd: "var(--ds-space-050, 4px)",
        insetInlineStart: "var(--ds-space-050, 4px)"
    }
});
const $509d5a1912d5c4e1$export$ac16a6a04d9b7c84 = /*#__PURE__*/ (0, $4tluv.forwardRef)((props, ref)=>{
    const { children: children, component: component, isHighlighted: isHighlighted, isLoading: isLoading, isSelected: isSelected, onClick: onClick, testId: testId, theme: theme, tooltip: tooltip, shortcut: shortcut, ...rest } = props;
    const themeFromContext = (0, $2JJu8.useTheme)();
    const button = /*#__PURE__*/ (0, $ft5N0.jsx)("div", {
        style: {
            [$509d5a1912d5c4e1$var$VAR_BUTTON_SELECTED_COLOR]: themeFromContext.mode.primaryButton.selected.color,
            [$509d5a1912d5c4e1$var$VAR_BUTTON_SELECTED_BORDER_COLOR]: themeFromContext.mode.primaryButton.selected.borderColor
        },
        css: [
            $509d5a1912d5c4e1$var$buttonBaseStyles,
            isHighlighted && $509d5a1912d5c4e1$var$buttonHighlightedStyles
        ],
        role: "listitem",
        "data-vc": "primary-button"
    }, /*#__PURE__*/ (0, $ft5N0.jsx)((0, $groaY.default), {
        appearance: "primary",
        component: component,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        ref: ref,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
        theme: theme || (0, $4BR9K.getPrimaryButtonTheme)(themeFromContext),
        css: [
            $509d5a1912d5c4e1$var$buttonNoOpStyle
        ],
        ...rest
    }, children));
    if (tooltip) return /*#__PURE__*/ (0, $ft5N0.jsx)((0, $eCj8S.default), {
        content: tooltip,
        hideTooltipOnClick: true,
        shortcut: shortcut
    }, button);
    return button;
});

});
parcelRegister("4BR9K", function(module, exports) {
$parcel$export(module.exports, "getPrimaryButtonTheme", () => $ae5c8d1e93c28a3c$export$14dd6915caf431fe);
const $ae5c8d1e93c28a3c$export$14dd6915caf431fe = ({ mode: { primaryButton: primaryButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...primaryButton.default,
                ...props.isSelected && primaryButton.selected,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                padding: `0 ${"var(--ds-space-050, 4px)"}`,
                marginLeft: 0,
                marginRight: 0,
                ':hover': props.isSelected ? primaryButton.selectedHover : primaryButton.hover,
                ':focus': primaryButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && primaryButton.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };

});



parcelRegister("j2uLl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::edc088c8e1dff28f4540e843bee097cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ddc6110c3f6e75e0$var$_react = $ddc6110c3f6e75e0$var$_interopRequireDefault((parcelRequire("4tluv")));

var $ddc6110c3f6e75e0$var$_baseNew = $ddc6110c3f6e75e0$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $ddc6110c3f6e75e0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsObject".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing objects in Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ddc6110c3f6e75e0$var$AssetsObjectIcon = (props)=>/*#__PURE__*/ $ddc6110c3f6e75e0$var$_react.default.createElement($ddc6110c3f6e75e0$var$_baseNew.default, Object.assign({
        name: "AssetsObjectIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3a.5.5 0 0 0-.5-.5h-2.5v3.75a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75V2.5H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM7 5.5h2v-3H7zm8 7.5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>`
    }, props));
$ddc6110c3f6e75e0$var$AssetsObjectIcon.displayName = 'AssetsObjectIcon';
var $ddc6110c3f6e75e0$var$_default = module.exports.default = $ddc6110c3f6e75e0$var$AssetsObjectIcon;

});

parcelRegister("a6AoA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0aca1d30928709a7afbf0b04d0a092a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75b6b253aefdfba1$var$_react = $75b6b253aefdfba1$var$_interopRequireDefault((parcelRequire("4tluv")));

var $75b6b253aefdfba1$var$_baseNew = $75b6b253aefdfba1$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $75b6b253aefdfba1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsObjectType".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing object types in Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75b6b253aefdfba1$var$AssetsObjectTypeIcon = (props)=>/*#__PURE__*/ $75b6b253aefdfba1$var$_react.default.createElement($75b6b253aefdfba1$var$_baseNew.default, Object.assign({
        name: "AssetsObjectTypeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11 14.5h3.5V11H11zm-5.5-11a2 2 0 1 0-4 0 2 2 0 0 0 4 0M16 14.625c0 .76-.616 1.375-1.375 1.375h-3.75c-.76 0-1.375-.616-1.375-1.375v-3.75c0-.76.616-1.375 1.375-1.375h3.75c.76 0 1.375.616 1.375 1.375zM7 3.5a3.5 3.5 0 0 1-2.75 3.418V11.5a.5.5 0 0 0 .5.5H8v1.5H4.75a2 2 0 0 1-2-2V6.918A3.5 3.5 0 1 1 7 3.5"/>`
    }, props));
$75b6b253aefdfba1$var$AssetsObjectTypeIcon.displayName = 'AssetsObjectTypeIcon';
var $75b6b253aefdfba1$var$_default = module.exports.default = $75b6b253aefdfba1$var$AssetsObjectTypeIcon;

});

parcelRegister("kSPeV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::46a94e1addf026bfebe08b8e272a8c2a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f34098eda8bbf3f4$var$_react = $f34098eda8bbf3f4$var$_interopRequireDefault((parcelRequire("4tluv")));

var $f34098eda8bbf3f4$var$_baseNew = $f34098eda8bbf3f4$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $f34098eda8bbf3f4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsSchema".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing schema in Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f34098eda8bbf3f4$var$AssetsSchemaIcon = (props)=>/*#__PURE__*/ $f34098eda8bbf3f4$var$_react.default.createElement($f34098eda8bbf3f4$var$_baseNew.default, Object.assign({
        name: "AssetsSchemaIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.75 11a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5m0-8a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5M3 13.5a2 2 0 0 1-2-2V0h1.5v4H8v1.5H2.5v6a.5.5 0 0 0 .5.5h5v1.5zm9.75-4a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5m0-8a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5"/>`
    }, props));
$f34098eda8bbf3f4$var$AssetsSchemaIcon.displayName = 'AssetsSchemaIcon';
var $f34098eda8bbf3f4$var$_default = module.exports.default = $f34098eda8bbf3f4$var$AssetsSchemaIcon;

});

parcelRegister("fbSIE", function(module, exports) {
$parcel$export(module.exports, "Show", () => $7b88e200279edd95$export$f6a3d19be20f5819);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $ft5N0 = parcelRequire("ft5N0");

var $kfPot = parcelRequire("kfPot");

var $3CMQh = parcelRequire("3CMQh");

var $5lHkS = parcelRequire("5lHkS");
const $7b88e200279edd95$var$showAboveQueries = (0, $3CMQh.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'revert'
});
const $7b88e200279edd95$var$showBelowQueries = (0, $5lHkS.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'revert'
});
const $7b88e200279edd95$var$defaultHiddenStyles = (0, $ft5N0.css)({
    display: 'none'
});
const $7b88e200279edd95$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $kfPot.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $ft5N0.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $7b88e200279edd95$var$defaultHiddenStyles,
            above && $7b88e200279edd95$var$showAboveQueries[above],
            below && $7b88e200279edd95$var$showBelowQueries[below],
            ...resolvedStyles.emotion || []
        ]
    }, children);
};

});
parcelRegister("3CMQh", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_buildAboveMediaQueryCSS", () => $ecf6ebe6aec0303a$export$918f8818cfbbeb2c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $ft5N0 = parcelRequire("ft5N0");

var $cRokI = parcelRequire("cRokI");

var $6bZZN = parcelRequire("6bZZN");
const $ecf6ebe6aec0303a$export$918f8818cfbbeb2c = (input)=>{
    return (0, $cRokI.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
            ...acc,
            [breakpoint]: (0, $ft5N0.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $6bZZN.media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        }), {});
};

});
parcelRegister("cRokI", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_BREAKPOINTS_ORDERED_LIST", () => $c81f93a2d149b6ce$export$2d293d9871c38e91);
const $c81f93a2d149b6ce$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '110.49rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110.5rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
const $c81f93a2d149b6ce$export$2d293d9871c38e91 = Object.keys($c81f93a2d149b6ce$export$e5ee4fe8b989fd09);
const $c81f93a2d149b6ce$export$b7ed752a57b4177b = $c81f93a2d149b6ce$export$2d293d9871c38e91[0];

});


parcelRegister("5lHkS", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_buildBelowMediaQueryCSS", () => $a0ec272559c06ca9$export$b2a4e2b0c6417297);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $ft5N0 = parcelRequire("ft5N0");

var $cRokI = parcelRequire("cRokI");

var $2njLb = parcelRequire("2njLb");
const $a0ec272559c06ca9$export$b2a4e2b0c6417297 = (input)=>{
    return (0, $cRokI.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
        if (breakpoint === 'xxs') return acc;
        return {
            ...acc,
            [breakpoint]: (0, $ft5N0.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $2njLb.UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        };
    }, {});
};

});


parcelRegister("kCthB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cd6c6061ead1c7bf826f9b8997aa8670>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f02e123f906e95a7$var$_react = $f02e123f906e95a7$var$_interopRequireDefault((parcelRequire("4tluv")));

var $f02e123f906e95a7$var$_baseNew = $f02e123f906e95a7$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $f02e123f906e95a7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Signature".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Toggle author visibility on sticky notes in Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f02e123f906e95a7$var$SignatureIcon = (props)=>/*#__PURE__*/ $f02e123f906e95a7$var$_react.default.createElement($f02e123f906e95a7$var$_baseNew.default, Object.assign({
        name: "SignatureIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 14H0v-1.5h16zM2.83 2.27c.62-.41 1.4-.47 2.24-.24.58.15 1.03.48 1.32.95.28.45.39.98.38 1.49-.02 1.01-.47 2.14-1.16 3.1-.33.46-.74.93-1.18 1.38q.03.03.05.06c.32.33.62.48.88.5.24.02.57-.05.99-.44.44-.4.94-1.09 1.47-2.23a.75.75 0 0 1 1.42.46v.02l-.01.08c-.01.07-.02.18-.04.31-.02.26-.03.59.01.9.05.32.14.56.25.7.09.11.23.21.55.21.83 0 1.35-.56 1.53-1.21a.75.75 0 0 1 1.47.15v-.01.02a1.1 1.1 0 0 0 .22.46c.19.23.65.6 1.78.6V11c-1.35 0-2.23-.41-2.77-.96.36-.4.61-.87.74-1.33l-.72-.21.75-.05-.75.05c-.75.05-.75.06-.75.06v.02a1 1 0 0 0 .02.13q.02.12.08.3a2.6 2.6 0 0 0 .63 1.03c-.51.56-1.25.96-2.23.96-.74 0-1.32-.28-1.71-.76a2.4 2.4 0 0 1-.38-.66c.44-.55.87-1.25 1.27-2.13l-.68-.31-.73-.15V7l-.01.03-.02.12a6 6 0 0 0-.05.4 5.6 5.6 0 0 0 .02 1.25c.04.25.1.52.2.78q-.27.33-.55.58c-.65.6-1.38.89-2.13.82-.73-.06-1.34-.45-1.82-.94l-.06-.06q-.17.15-.32.29a35 35 0 0 1-1.54 1.29l-.02.02-.01.01L1 11l-.46-.59h.01l.02-.02a24 24 0 0 0 .41-.32 34 34 0 0 0 1.51-1.33 7 7 0 0 1-.24-.51c-.57-1.33-.84-2.99-.52-4.28.16-.65.49-1.29 1.1-1.69m.79 5.35c.29-.32.56-.63.77-.93.56-.79.86-1.63.88-2.26.01-.31-.06-.52-.14-.66-.08-.12-.2-.23-.44-.3-.56-.15-.87-.06-1.04.05-.18.12-.36.36-.46.79-.21.87-.05 2.17.44 3.31" clip-rule="evenodd"/><path fill="currentcolor" d="M7.91 9.58c.44-.55.87-1.25 1.27-2.13l-.68-.31-.73-.15V7l-.01.03-.02.12a6 6 0 0 0-.05.4 5.6 5.6 0 0 0 .02 1.25c.04.25.1.52.2.78m4.32.46c.36-.4.61-.87.74-1.33l-.72-.21c-.75.05-.75.06-.75.06v.02a1 1 0 0 0 .02.13q.02.12.08.3a2.6 2.6 0 0 0 .63 1.03"/>`
    }, props));
$f02e123f906e95a7$var$SignatureIcon.displayName = 'SignatureIcon';
var $f02e123f906e95a7$var$_default = module.exports.default = $f02e123f906e95a7$var$SignatureIcon;

});

parcelRegister("6s4cz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::432ea26d62f26515b4626718ca47f05c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b289dffb6fb51a3$var$_react = $4b289dffb6fb51a3$var$_interopRequireDefault((parcelRequire("4tluv")));

var $4b289dffb6fb51a3$var$_baseNew = $4b289dffb6fb51a3$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $4b289dffb6fb51a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cursor".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Selecting the cursor in Whiteboards
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4b289dffb6fb51a3$var$CursorIcon = (props)=>/*#__PURE__*/ $4b289dffb6fb51a3$var$_react.default.createElement($4b289dffb6fb51a3$var$_baseNew.default, Object.assign({
        name: "CursorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.827 2.827 6.914 13.23l1.272-4.134c.134-.436.474-.776.91-.91l4.134-1.272zm-1.5.282C.886 1.99 1.99.887 3.108 1.326L14.11 5.648c1.21.476 1.145 2.212-.099 2.594L9.6 9.6l-1.358 4.412c-.382 1.244-2.118 1.31-2.594.099z" clip-rule="evenodd"/>`
    }, props));
$4b289dffb6fb51a3$var$CursorIcon.displayName = 'CursorIcon';
var $4b289dffb6fb51a3$var$_default = module.exports.default = $4b289dffb6fb51a3$var$CursorIcon;

});

parcelRegister("7YrnT", function(module, exports) {
$parcel$export(module.exports, "Show", () => $b12586e82b76ab7a$export$f6a3d19be20f5819);
/* show.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");
const $b12586e82b76ab7a$var$styles = {
    default: "_1e0cglyw",
    'above.xs': "_114b19ly",
    'above.sm': "_181n19ly",
    'above.md': "_dm2519ly",
    'above.lg': "_je3o19ly",
    'above.xl': "_1uxv19ly",
    'below.xs': "_1m0a19ly",
    'below.sm': "_suga19ly",
    'below.md': "_1mjb19ly",
    'below.lg': "_liwc19ly",
    'below.xl': "_14wz19ly"
};
const $b12586e82b76ab7a$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    return /*#__PURE__*/ (0, $2iln5.jsx)(AsElement, {
        className: (0, $jAkMr.default)([
            $b12586e82b76ab7a$var$styles.default,
            above && $b12586e82b76ab7a$var$styles[`above.${above}`],
            below && $b12586e82b76ab7a$var$styles[`below.${below}`],
            xcss
        ]),
        children: children
    });
};

});

parcelRegister("7m5YQ", function(module, exports) {
$parcel$export(module.exports, "Button", () => $64f4c0b07db5d5a8$export$353f5b6fc5456de1);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $ku0Cg = parcelRequire("ku0Cg");

var $6UQyv = parcelRequire("6UQyv");

var $hiYtG = parcelRequire("hiYtG");
const $64f4c0b07db5d5a8$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $4tluv.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $6UQyv.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $hiYtG.ThemedButton) : (0, $ku0Cg.default);
    return /*#__PURE__*/ (0, $2iln5.jsx)(Component, {
        ref: ref,
        ...props
    });
});

});
parcelRegister("hiYtG", function(module, exports) {
$parcel$export(module.exports, "ThemedButton", () => $ae694b12b6e6d8a7$export$f67fb575035cc7d0);
/* themed-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $jAkMr = parcelRequire("jAkMr");

var $4tluv = parcelRequire("4tluv");

var $3X3Vo = parcelRequire("3X3Vo");

var $yb1Rb = parcelRequire("yb1Rb");

var $iPeNt = parcelRequire("iPeNt");
const $ae694b12b6e6d8a7$var$textButtonStyles = {
    iconBefore: "_vwz4idpf",
    text: "_k48p1wq8"
};
const $ae694b12b6e6d8a7$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $4tluv.forwardRef)(function ThemedButton({ iconBefore: IconBefore, children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, $2iln5.jsxs)((0, $iPeNt.ThemedPressable), {
        ...props,
        ref: ref,
        children: [
            IconBefore && /*#__PURE__*/ (0, $2iln5.jsx)("span", {
                className: (0, $jAkMr.default)([
                    $ae694b12b6e6d8a7$var$textButtonStyles.iconBefore
                ]),
                children: (0, $3X3Vo.fg)('platform_themed_button_use_icon_renderer') ? /*#__PURE__*/ (0, $2iln5.jsx)((0, $yb1Rb.default), {
                    icon: IconBefore
                }) : /*#__PURE__*/ (0, $2iln5.jsx)(IconBefore, {
                    label: "",
                    color: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $2iln5.jsx)("span", {
                className: (0, $jAkMr.default)([
                    $ae694b12b6e6d8a7$var$textButtonStyles.text
                ]),
                children: children
            })
        ]
    });
});

});


parcelRegister("etPVj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::37f6936d803063c7a3f55cf0b9660261>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a8ac0d02d8f295cf$var$_react = $a8ac0d02d8f295cf$var$_interopRequireDefault((parcelRequire("4tluv")));

var $a8ac0d02d8f295cf$var$_baseNew = $a8ac0d02d8f295cf$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $a8ac0d02d8f295cf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Blur".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for blurring an element in Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a8ac0d02d8f295cf$var$BlurIcon = (props)=>/*#__PURE__*/ $a8ac0d02d8f295cf$var$_react.default.createElement($a8ac0d02d8f295cf$var$_baseNew.default, Object.assign({
        name: "BlurIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6.67 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1 2a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5m0 4.5a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5m4.5-4.5a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5m0 4.5a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5M5.67 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2M3 5.75a1 1 0 1 1-2 0 1 1 0 0 1 2 0m11 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-11 3.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m11 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2M11.17 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/>`
    }, props));
$a8ac0d02d8f295cf$var$BlurIcon.displayName = 'BlurIcon';
var $a8ac0d02d8f295cf$var$_default = module.exports.default = $a8ac0d02d8f295cf$var$BlurIcon;

});

parcelRegister("6G1Xu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63d9932361b81d6cef1fdc11a53c1ac8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4dc82f3c9a7ab4ef$var$_react = $4dc82f3c9a7ab4ef$var$_interopRequireDefault((parcelRequire("4tluv")));

var $4dc82f3c9a7ab4ef$var$_baseNew = $4dc82f3c9a7ab4ef$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $4dc82f3c9a7ab4ef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoRewindOverlay".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for rewinding media and representing rewind diagram symbol.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4dc82f3c9a7ab4ef$var$VideoRewindOverlayIcon = (props)=>/*#__PURE__*/ $4dc82f3c9a7ab4ef$var$_react.default.createElement($4dc82f3c9a7ab4ef$var$_baseNew.default, Object.assign({
        name: "VideoRewindOverlayIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.138 3.84A1.375 1.375 0 0 1 16 5.127v5.75a1.376 1.376 0 0 1-2.036 1.205l-5.25-2.876a1.36 1.36 0 0 1-.713-1.175v2.846a1.376 1.376 0 0 1-2.036 1.205L.714 9.205a1.373 1.373 0 0 1 0-2.408L5.965 3.92l.173-.08A1.376 1.376 0 0 1 8 5.126v2.842c.01-.46.248-.917.713-1.171l5.25-2.876z"/>`
    }, props));
$4dc82f3c9a7ab4ef$var$VideoRewindOverlayIcon.displayName = 'VideoRewindOverlayIcon';
var $4dc82f3c9a7ab4ef$var$_default = module.exports.default = $4dc82f3c9a7ab4ef$var$VideoRewindOverlayIcon;

});

parcelRegister("fr76f", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aad4b9387252563dd29f57d4d8dc9f59>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b3cee27ee4362fdc$var$_react = $b3cee27ee4362fdc$var$_interopRequireDefault((parcelRequire("4tluv")));

var $b3cee27ee4362fdc$var$_baseNew = $b3cee27ee4362fdc$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $b3cee27ee4362fdc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoRecord".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for when a video is recording
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b3cee27ee4362fdc$var$VideoRecordIcon = (props)=>/*#__PURE__*/ $b3cee27ee4362fdc$var$_react.default.createElement($b3cee27ee4362fdc$var$_baseNew.default, Object.assign({
        name: "VideoRecordIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.084 8.068a7 7 0 1 1 14 0 7 7 0 0 1-14 0" clip-rule="evenodd"/>`
    }, props));
$b3cee27ee4362fdc$var$VideoRecordIcon.displayName = 'VideoRecordIcon';
var $b3cee27ee4362fdc$var$_default = module.exports.default = $b3cee27ee4362fdc$var$VideoRecordIcon;

});

parcelRegister("3u8PU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::197921048e92db6f31070962e79acfb7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $289b071effab74c2$var$_react = $289b071effab74c2$var$_interopRequireDefault((parcelRequire("4tluv")));

var $289b071effab74c2$var$_baseNew = $289b071effab74c2$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $289b071effab74c2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPlayCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Known uses: play video in Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $289b071effab74c2$var$VideoPlayCircleIcon = (props)=>/*#__PURE__*/ $289b071effab74c2$var$_react.default.createElement($289b071effab74c2$var$_baseNew.default, Object.assign({
        name: "VideoPlayCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m5-2.694c0-.808.866-1.32 1.574-.931l4.958 2.722a1.062 1.062 0 0 1 0 1.862l-4.958 2.722A1.063 1.063 0 0 1 5 10.75zm1.5.74v3.965l3.611-1.983z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.5 10.01V6.046l3.611 1.983z"/>`
    }, props));
$289b071effab74c2$var$VideoPlayCircleIcon.displayName = 'VideoPlayCircleIcon';
var $289b071effab74c2$var$_default = module.exports.default = $289b071effab74c2$var$VideoPlayCircleIcon;

});

parcelRegister("5UvAZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::34370ab3dde16589138f03d8588b48b8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $44dab0ec8f69def8$var$_react = $44dab0ec8f69def8$var$_interopRequireDefault((parcelRequire("4tluv")));

var $44dab0ec8f69def8$var$_baseNew = $44dab0ec8f69def8$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $44dab0ec8f69def8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoStrikethrough".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for no video input
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $44dab0ec8f69def8$var$VideoStrikethroughIcon = (props)=>/*#__PURE__*/ $44dab0ec8f69def8$var$_react.default.createElement($44dab0ec8f69def8$var$_baseNew.default, Object.assign({
        name: "VideoStrikethroughIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m.47 1.53 14 14 1.06-1.06-14-14zM8.82 12l1.48 1.48a2 2 0 0 1-.3.02H2a2 2 0 0 1-2-2v-7c0-.38.11-.73.29-1.03L1.5 4.68v6.82a.5.5 0 0 0 .5.5zM10 2.5H5.68L7.18 4H10a.5.5 0 0 1 .5.5v2.82l1.5 1.5V6.44l2.5-1.41v6.29l1.17 1.17c.2-.22.33-.51.33-.84V4.61a1.25 1.25 0 0 0-1.86-1.09L12 4.72V4.5a2 2 0 0 0-2-2"/>`
    }, props));
$44dab0ec8f69def8$var$VideoStrikethroughIcon.displayName = 'VideoStrikethroughIcon';
var $44dab0ec8f69def8$var$_default = module.exports.default = $44dab0ec8f69def8$var$VideoStrikethroughIcon;

});

parcelRegister("6rirf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9a0095371d279b0b7977407d9c03c610>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b039134ba950582$var$_react = $4b039134ba950582$var$_interopRequireDefault((parcelRequire("4tluv")));

var $4b039134ba950582$var$_baseNew = $4b039134ba950582$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $4b039134ba950582$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "MicrophoneStrikethrough".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for no microphone input
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4b039134ba950582$var$MicrophoneStrikethroughIcon = (props)=>/*#__PURE__*/ $4b039134ba950582$var$_react.default.createElement($4b039134ba950582$var$_baseNew.default, Object.assign({
        name: "MicrophoneStrikethroughIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m8.31 11.49 1.29 1.29q-.41.11-.85.17v1.55h2.57l.68.68V16H4v-1.5h3.25v-1.55A6 6 0 0 1 2 7h1.5a4.5 4.5 0 0 0 4.81 4.49M12.5 7c0 .68-.15 1.32-.42 1.9l1.11 1.11A6 6 0 0 0 14 7zm-3-.68 1.41 1.41Q11 7.38 11 7V3a3 3 0 0 0-5.83-1.01L6.5 3.32V3a1.5 1.5 0 0 1 3 0zM6.27 9.45l-.72-.72q.3.42.72.72M.1 1.16l14.75 14.75 1.06-1.06L1.16.1z"/>`
    }, props));
$4b039134ba950582$var$MicrophoneStrikethroughIcon.displayName = 'MicrophoneStrikethroughIcon';
var $4b039134ba950582$var$_default = module.exports.default = $4b039134ba950582$var$MicrophoneStrikethroughIcon;

});

parcelRegister("c9jl9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a9109095f0a9b69c0b01202dc3ed5e4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8d8553d5b001faac$var$_react = $8d8553d5b001faac$var$_interopRequireDefault((parcelRequire("4tluv")));

var $8d8553d5b001faac$var$_baseNew = $8d8553d5b001faac$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $8d8553d5b001faac$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Editions".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing premium features in upsell experiences. The Editions gem icon has officially replaced the sparkle icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8d8553d5b001faac$var$EditionsIcon = (props)=>/*#__PURE__*/ $8d8553d5b001faac$var$_react.default.createElement($8d8553d5b001faac$var$_baseNew.default, Object.assign({
        name: "EditionsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m12.75 1 .096.006a.75.75 0 0 1 .54.347l2.5 4a.75.75 0 0 1-.066.883l-7.25 8.5a.75.75 0 0 1-1.14 0l-7.25-8.5a.75.75 0 0 1-.066-.883l2.5-4 .056-.079A.75.75 0 0 1 3.25 1zM8 11.813 9.719 6.5H6.28zm-1.873-.914L4.704 6.5H2.375zm3.745 0L13.625 6.5h-2.33zM11.302 5h2.596l-1.563-2.5H10.52zM6.27 5h3.46l-.782-2.5H7.052zM2.103 5h2.595l.781-2.5H3.665z"/>`
    }, props));
$8d8553d5b001faac$var$EditionsIcon.displayName = 'EditionsIcon';
var $8d8553d5b001faac$var$_default = module.exports.default = $8d8553d5b001faac$var$EditionsIcon;

});

parcelRegister("52xKM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b27c4fffdceed1a1307cfef5a2c834bc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3ab752665fb9f7d4$var$_react = $3ab752665fb9f7d4$var$_interopRequireDefault((parcelRequire("4tluv")));

var $3ab752665fb9f7d4$var$_baseNew = $3ab752665fb9f7d4$var$_interopRequireDefault((parcelRequire("7KZ3Q")));
function $3ab752665fb9f7d4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pencil".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Known uses: compose video title in Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3ab752665fb9f7d4$var$PencilIcon = (props)=>/*#__PURE__*/ $3ab752665fb9f7d4$var$_react.default.createElement($3ab752665fb9f7d4$var$_baseNew.default, Object.assign({
        name: "PencilIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.336 1.604a2 2 0 0 1 2.828 0l1.233 1.232a2 2 0 0 1 0 2.828l-8.099 8.099a2 2 0 0 1-1.022.547l-3.379.675a.75.75 0 0 1-.882-.882l.675-3.379a2 2 0 0 1 .547-1.022zm1.768 1.06a.5.5 0 0 0-.707 0l-.961.961 1.939 1.94.96-.961a.5.5 0 0 0 0-.707zm-.79 3.961-1.939-1.94-6.077 6.078a.5.5 0 0 0-.137.255l-.455 2.276 2.276-.455a.5.5 0 0 0 .255-.137zM16 15H8v-1.5h8z" clip-rule="evenodd"/>`
    }, props));
$3ab752665fb9f7d4$var$PencilIcon.displayName = 'PencilIcon';
var $3ab752665fb9f7d4$var$_default = module.exports.default = $3ab752665fb9f7d4$var$PencilIcon;

});

parcelRegister("jSKID", function(module, exports) {
$parcel$export(module.exports, "Hide", () => $1e88c92e8a6ddab8$export$bed28288a051538);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $ft5N0 = parcelRequire("ft5N0");

var $kfPot = parcelRequire("kfPot");

var $3CMQh = parcelRequire("3CMQh");

var $5lHkS = parcelRequire("5lHkS");
const $1e88c92e8a6ddab8$var$hideAboveQueries = (0, $3CMQh.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'none'
});
const $1e88c92e8a6ddab8$var$hideBelowQueries = (0, $5lHkS.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'none'
});
const $1e88c92e8a6ddab8$export$bed28288a051538 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $kfPot.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $ft5N0.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            above && $1e88c92e8a6ddab8$var$hideAboveQueries[above],
            below && $1e88c92e8a6ddab8$var$hideBelowQueries[below],
            ...resolvedStyles.emotion || []
        ]
    }, children);
};

});

parcelRegister("j66QP", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $552c76faf0f15429$export$49e55ae2c03d6045);

var $4tluv = parcelRequire("4tluv");

var $Hyfcf = parcelRequire("Hyfcf");

var $1K815 = parcelRequire("1K815");

var $2njLb = parcelRequire("2njLb");
const $552c76faf0f15429$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $2njLb.UNSAFE_media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $2njLb.UNSAFE_media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $2njLb.UNSAFE_media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $2njLb.UNSAFE_media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $2njLb.UNSAFE_media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $2njLb.UNSAFE_media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $2njLb.UNSAFE_media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $2njLb.UNSAFE_media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $2njLb.UNSAFE_media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $2njLb.UNSAFE_media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $2njLb.UNSAFE_media).below.xl.replace('@media ', '').trim())
};
const $552c76faf0f15429$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $4tluv.useRef)(listener);
    (0, $4tluv.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ const hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ const mq = $552c76faf0f15429$var$queries[queryString];
    (0, $1K815.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $Hyfcf.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});

parcelRegister("dW37p", function(module, exports) {
$parcel$export(module.exports, "Notifications", () => $a29d5d701eca305d$export$36ba2f559d49a8f6);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $kWdnL = parcelRequire("kWdnL");

var $bfjng = parcelRequire("bfjng");

var $cwrqS = parcelRequire("cwrqS");
const $a29d5d701eca305d$var$NOTIFICATIONS_BADGE_ID = 'atlassian-navigation-notification-count';
const $a29d5d701eca305d$export$36ba2f559d49a8f6 = /*#__PURE__*/ (0, $4tluv.forwardRef)(function Notifications({ label: label, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, isListItem: isListItem, badge: badge, shortcut: shortcut }, ref) {
    return /*#__PURE__*/ (0, $2iln5.jsx)((0, $bfjng.BadgeContainer), {
        id: $a29d5d701eca305d$var$NOTIFICATIONS_BADGE_ID,
        badge: badge,
        // We only need to set the list item role on the top level element (BadgeContainer)
        isListItem: isListItem,
        children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $cwrqS.EndItem), {
            label: label,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            isSelected: isSelected,
            testId: testId,
            interactionName: interactionName,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHasPopup,
            ref: ref,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kWdnL))),
            // We explicitly set the EndItem to not be a list item,
            // because the BadgeContainer already has a list item role (if `isListItem` is true)
            isListItem: false,
            shortcut: shortcut
        })
    });
});

});
parcelRegister("bfjng", function(module, exports) {
$parcel$export(module.exports, "BadgeContainer", () => $6c8afa1464f3e919$export$f710265eb5a003da);
/* badge-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");
parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");
const $6c8afa1464f3e919$var$styles = {
    root: "_kqswh2mm _1e0c1txw",
    badgeContainer: "_kqswstnw _o5721q9c _152tr5cr _1e02utpp _lcxvglyw"
};
const $6c8afa1464f3e919$export$f710265eb5a003da = ({ children: children, id: badgeId, badge: Badge, isListItem: isListItem = true })=>/*#__PURE__*/ (0, $2iln5.jsxs)("div", {
        role: isListItem ? 'listitem' : undefined,
        className: (0, $jAkMr.default)([
            $6c8afa1464f3e919$var$styles.root
        ]),
        children: [
            children,
            /*#__PURE__*/ (0, $2iln5.jsx)("div", {
                id: badgeId,
                "aria-hidden": true,
                className: (0, $jAkMr.default)([
                    $6c8afa1464f3e919$var$styles.badgeContainer
                ]),
                children: /*#__PURE__*/ (0, $2iln5.jsx)(Badge, {})
            })
        ]
    });

});

parcelRegister("cwrqS", function(module, exports) {
$parcel$export(module.exports, "EndItem", () => $867f0c6a4b1b9471$export$b3477e90773be2d0);

var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");

var $B5Fo9 = parcelRequire("B5Fo9");

var $97Piv = parcelRequire("97Piv");
const $867f0c6a4b1b9471$export$b3477e90773be2d0 = /*#__PURE__*/ (0, $4tluv.forwardRef)(({ label: label, icon: icon, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, isListItem: isListItem = true, shortcut: shortcut }, forwardedRef)=>{
    const Wrapper = isListItem ? (0, $B5Fo9.ListItem) : (0, $4tluv.Fragment);
    return /*#__PURE__*/ (0, $2iln5.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0, $2iln5.jsx)((0, $97Piv.IconButton), {
            ref: forwardedRef,
            icon: icon,
            label: label,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            appearance: "subtle",
            isSelected: isSelected,
            isTooltipDisabled: false,
            testId: testId,
            interactionName: interactionName,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHasPopup,
            // Only creating object when shortcut is provided
            tooltip: shortcut ? {
                shortcut: shortcut
            } : undefined
        })
    });
});

});
parcelRegister("B5Fo9", function(module, exports) {
$parcel$export(module.exports, "ListItem", () => $d57957b06d32f081$export$a7b06bfba60a8a78);
/* list-item.tsx generated by @compiled/babel-plugin v0.36.1 */ /* list-item.tsx generated by @compiled/babel-plugin v0.36.1 */ /* list-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2iln5 = parcelRequire("2iln5");

var $4tluv = parcelRequire("4tluv");
function $d57957b06d32f081$var$_ListItem({ children: children, testId: testId, xcss: xcss }, ref) {
    return /*#__PURE__*/ (0, $2iln5.jsx)("div", {
        role: "listitem",
        ref: ref,
        className: xcss,
        "data-testid": testId,
        children: children
    });
}
const $d57957b06d32f081$export$a7b06bfba60a8a78 = /*#__PURE__*/ (0, $4tluv.forwardRef)($d57957b06d32f081$var$_ListItem);

});




//# sourceMappingURL=feedback-collector.a4d4e1c9.js.map
